/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 85);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(20),
	__webpack_require__(2),
	__webpack_require__(86),
	__webpack_require__(27),
	__webpack_require__(45),
	__webpack_require__(46),
	__webpack_require__(28),
	__webpack_require__(26),
	__webpack_require__(87),
	__webpack_require__(29),
	__webpack_require__(47),
	__webpack_require__(88),
	__webpack_require__(10),
	__webpack_require__(48)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( arr, document, getProto, slice, concat, push, indexOf,
	class2type, toString, hasOwn, fnToString, ObjectFunctionString,
	support, DOMEval ) {

"use strict";

var
	version = "3.2.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&

			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 13
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}

return jQuery;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(3),
	__webpack_require__(16),
	__webpack_require__(35),
	__webpack_require__(15),
	__webpack_require__(94),
	__webpack_require__(58),
	__webpack_require__(95),
	__webpack_require__(37),
	__webpack_require__(96),
	__webpack_require__(100),
	__webpack_require__(17),
	__webpack_require__(104),
	__webpack_require__(105),
	__webpack_require__(22),
	__webpack_require__(107),
	__webpack_require__(110),
	__webpack_require__(19),
	__webpack_require__(111),
	__webpack_require__(72),
	__webpack_require__(18),
	__webpack_require__(112),
	__webpack_require__(113),
	__webpack_require__(114),
	__webpack_require__(115),
	__webpack_require__(118),
	__webpack_require__(38),
	__webpack_require__(119),
	__webpack_require__(120),
	__webpack_require__(121),
	__webpack_require__(122),
	__webpack_require__(123),
	__webpack_require__(124)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {

"use strict";

return jQuery;

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	"use strict";

	return window.document;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(89) ], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	"use strict";
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Initialize a jQuery object
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(2),
	__webpack_require__(55),

	__webpack_require__(56)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, rsingleTag ) {

"use strict";

// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );

return init;

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(59)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( Data ) {
	"use strict";

	return new Data();
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	"use strict";

	// Only count HTML whitespace
	// Other whitespace should count in values
	// https://html.spec.whatwg.org/multipage/infrastructure.html#space-character
	return ( /[^\x20\t\r\n\f]+/g );
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {

"use strict";

function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};

return nodeName;

}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transitionend = exports.GetYoDigits = exports.rtl = undefined;

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Core Foundation Utilities, utilized in a number of places.

/**
 * Returns a boolean for RTL support
 */
function rtl() {
  return (0, _jquery2.default)('html').attr('dir') === 'rtl';
}

/**
 * returns a random base-36 uid with namespacing
 * @function
 * @param {Number} length - number of random base-36 digits desired. Increase for more random strings.
 * @param {String} namespace - name of plugin to be incorporated in uid, optional.
 * @default {String} '' - if no plugin name is provided, nothing is appended to the uid.
 * @returns {String} - unique id
 */
function GetYoDigits(length, namespace) {
  length = length || 6;
  return Math.round(Math.pow(36, length + 1) - Math.random() * Math.pow(36, length)).toString(36).slice(1) + (namespace ? '-' + namespace : '');
}

function transitionend($elem) {
  var transitions = {
    'transition': 'transitionend',
    'WebkitTransition': 'webkitTransitionEnd',
    'MozTransition': 'transitionend',
    'OTransition': 'otransitionend'
  };
  var elem = document.createElement('div'),
      end;

  for (var t in transitions) {
    if (typeof elem.style[t] !== 'undefined') {
      end = transitions[t];
    }
  }
  if (end) {
    return end;
  } else {
    end = setTimeout(function () {
      $elem.triggerHandler('transitionend', [$elem]);
    }, 1);
    return 'transitionend';
  }
}

exports.rtl = rtl;
exports.GetYoDigits = GetYoDigits;
exports.transitionend = transitionend;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Fizzy UI utils v2.0.5
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(151)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( matchesSelector ) {
      return factory( window, matchesSelector );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('desandro-matches-selector')
    );
  } else {
    // browser global
    window.fizzyUIUtils = factory(
      window,
      window.matchesSelector
    );
  }

}( window, function factory( window, matchesSelector ) {

'use strict';

var utils = {};

// ----- extend ----- //

// extends objects
utils.extend = function( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
};

// ----- modulo ----- //

utils.modulo = function( num, div ) {
  return ( ( num % div ) + div ) % div;
};

// ----- makeArray ----- //

// turn element or nodeList into an array
utils.makeArray = function( obj ) {
  var ary = [];
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    ary = obj;
  } else if ( obj && typeof obj == 'object' &&
    typeof obj.length == 'number' ) {
    // convert nodeList to array
    for ( var i=0; i < obj.length; i++ ) {
      ary.push( obj[i] );
    }
  } else {
    // array of single index
    ary.push( obj );
  }
  return ary;
};

// ----- removeFrom ----- //

utils.removeFrom = function( ary, obj ) {
  var index = ary.indexOf( obj );
  if ( index != -1 ) {
    ary.splice( index, 1 );
  }
};

// ----- getParent ----- //

utils.getParent = function( elem, selector ) {
  while ( elem.parentNode && elem != document.body ) {
    elem = elem.parentNode;
    if ( matchesSelector( elem, selector ) ) {
      return elem;
    }
  }
};

// ----- getQueryElement ----- //

// use element as selector string
utils.getQueryElement = function( elem ) {
  if ( typeof elem == 'string' ) {
    return document.querySelector( elem );
  }
  return elem;
};

// ----- handleEvent ----- //

// enable .ontype to trigger from .addEventListener( elem, 'type' )
utils.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// ----- filterFindElements ----- //

utils.filterFindElements = function( elems, selector ) {
  // make array of elems
  elems = utils.makeArray( elems );
  var ffElems = [];

  elems.forEach( function( elem ) {
    // check that elem is an actual element
    if ( !( elem instanceof HTMLElement ) ) {
      return;
    }
    // add elem if no selector
    if ( !selector ) {
      ffElems.push( elem );
      return;
    }
    // filter & find items if we have a selector
    // filter
    if ( matchesSelector( elem, selector ) ) {
      ffElems.push( elem );
    }
    // find children
    var childElems = elem.querySelectorAll( selector );
    // concat childElems to filterFound array
    for ( var i=0; i < childElems.length; i++ ) {
      ffElems.push( childElems[i] );
    }
  });

  return ffElems;
};

// ----- debounceMethod ----- //

utils.debounceMethod = function( _class, methodName, threshold ) {
  // original method
  var method = _class.prototype[ methodName ];
  var timeoutName = methodName + 'Timeout';

  _class.prototype[ methodName ] = function() {
    var timeout = this[ timeoutName ];
    if ( timeout ) {
      clearTimeout( timeout );
    }
    var args = arguments;

    var _this = this;
    this[ timeoutName ] = setTimeout( function() {
      method.apply( _this, args );
      delete _this[ timeoutName ];
    }, threshold || 100 );
  };
};

// ----- docReady ----- //

utils.docReady = function( callback ) {
  var readyState = document.readyState;
  if ( readyState == 'complete' || readyState == 'interactive' ) {
    // do async to allow for other scripts to run. metafizzy/flickity#441
    setTimeout( callback );
  } else {
    document.addEventListener( 'DOMContentLoaded', callback );
  }
};

// ----- htmlInit ----- //

// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
utils.toDashed = function( str ) {
  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
    return $1 + '-' + $2;
  }).toLowerCase();
};

var console = window.console;
/**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */
utils.htmlInit = function( WidgetClass, namespace ) {
  utils.docReady( function() {
    var dashedNamespace = utils.toDashed( namespace );
    var dataAttr = 'data-' + dashedNamespace;
    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
    var elems = utils.makeArray( dataAttrElems )
      .concat( utils.makeArray( jsDashElems ) );
    var dataOptionsAttr = dataAttr + '-options';
    var jQuery = window.jQuery;

    elems.forEach( function( elem ) {
      var attr = elem.getAttribute( dataAttr ) ||
        elem.getAttribute( dataOptionsAttr );
      var options;
      try {
        options = attr && JSON.parse( attr );
      } catch ( error ) {
        // log error, do not initialize
        if ( console ) {
          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
          ': ' + error );
        }
        return;
      }
      // initialize
      var instance = new WidgetClass( elem, options );
      // make available via $().data('namespace')
      if ( jQuery ) {
        jQuery.data( elem, namespace, instance );
      }
    });

  });
};

// -----  ----- //

return utils;

}));


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	"use strict";

	// All support tests are defined in their respective modules.
	return {};
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {

"use strict";

// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};

return access;

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Flickity main
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(43),
      __webpack_require__(79),
      __webpack_require__(9),
      __webpack_require__(152),
      __webpack_require__(153),
      __webpack_require__(154)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter, getSize, utils, Cell, Slide, animatePrototype ) {
      return factory( window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('ev-emitter'),
      require('get-size'),
      require('fizzy-ui-utils'),
      require('./cell'),
      require('./slide'),
      require('./animate')
    );
  } else {
    // browser global
    var _Flickity = window.Flickity;

    window.Flickity = factory(
      window,
      window.EvEmitter,
      window.getSize,
      window.fizzyUIUtils,
      _Flickity.Cell,
      _Flickity.Slide,
      _Flickity.animatePrototype
    );
  }

}( window, function factory( window, EvEmitter, getSize,
  utils, Cell, Slide, animatePrototype ) {

'use strict';

// vars
var jQuery = window.jQuery;
var getComputedStyle = window.getComputedStyle;
var console = window.console;

function moveElements( elems, toElem ) {
  elems = utils.makeArray( elems );
  while ( elems.length ) {
    toElem.appendChild( elems.shift() );
  }
}

// -------------------------- Flickity -------------------------- //

// globally unique identifiers
var GUID = 0;
// internal store of all Flickity intances
var instances = {};

function Flickity( element, options ) {
  var queryElement = utils.getQueryElement( element );
  if ( !queryElement ) {
    if ( console ) {
      console.error( 'Bad element for Flickity: ' + ( queryElement || element ) );
    }
    return;
  }
  this.element = queryElement;
  // do not initialize twice on same element
  if ( this.element.flickityGUID ) {
    var instance = instances[ this.element.flickityGUID ];
    instance.option( options );
    return instance;
  }

  // add jQuery
  if ( jQuery ) {
    this.$element = jQuery( this.element );
  }
  // options
  this.options = utils.extend( {}, this.constructor.defaults );
  this.option( options );

  // kick things off
  this._create();
}

Flickity.defaults = {
  accessibility: true,
  // adaptiveHeight: false,
  cellAlign: 'center',
  // cellSelector: undefined,
  // contain: false,
  freeScrollFriction: 0.075, // friction when free-scrolling
  friction: 0.28, // friction when selecting
  namespaceJQueryEvents: true,
  // initialIndex: 0,
  percentPosition: true,
  resize: true,
  selectedAttraction: 0.025,
  setGallerySize: true
  // watchCSS: false,
  // wrapAround: false
};

// hash of methods triggered on _create()
Flickity.createMethods = [];

var proto = Flickity.prototype;
// inherit EventEmitter
utils.extend( proto, EvEmitter.prototype );

proto._create = function() {
  // add id for Flickity.data
  var id = this.guid = ++GUID;
  this.element.flickityGUID = id; // expando
  instances[ id ] = this; // associate via id
  // initial properties
  this.selectedIndex = 0;
  // how many frames slider has been in same position
  this.restingFrames = 0;
  // initial physics properties
  this.x = 0;
  this.velocity = 0;
  this.originSide = this.options.rightToLeft ? 'right' : 'left';
  // create viewport & slider
  this.viewport = document.createElement('div');
  this.viewport.className = 'flickity-viewport';
  this._createSlider();

  if ( this.options.resize || this.options.watchCSS ) {
    window.addEventListener( 'resize', this );
  }

  Flickity.createMethods.forEach( function( method ) {
    this[ method ]();
  }, this );

  if ( this.options.watchCSS ) {
    this.watchCSS();
  } else {
    this.activate();
  }

};

/**
 * set options
 * @param {Object} opts
 */
proto.option = function( opts ) {
  utils.extend( this.options, opts );
};

proto.activate = function() {
  if ( this.isActive ) {
    return;
  }
  this.isActive = true;
  this.element.classList.add('flickity-enabled');
  if ( this.options.rightToLeft ) {
    this.element.classList.add('flickity-rtl');
  }

  this.getSize();
  // move initial cell elements so they can be loaded as cells
  var cellElems = this._filterFindCellElements( this.element.children );
  moveElements( cellElems, this.slider );
  this.viewport.appendChild( this.slider );
  this.element.appendChild( this.viewport );
  // get cells from children
  this.reloadCells();

  if ( this.options.accessibility ) {
    // allow element to focusable
    this.element.tabIndex = 0;
    // listen for key presses
    this.element.addEventListener( 'keydown', this );
  }

  this.emitEvent('activate');

  var index;
  var initialIndex = this.options.initialIndex;
  if ( this.isInitActivated ) {
    index = this.selectedIndex;
  } else if ( initialIndex !== undefined ) {
    index = this.cells[ initialIndex ] ? initialIndex : 0;
  } else {
    index = 0;
  }
  // select instantly
  this.select( index, false, true );
  // flag for initial activation, for using initialIndex
  this.isInitActivated = true;
};

// slider positions the cells
proto._createSlider = function() {
  // slider element does all the positioning
  var slider = document.createElement('div');
  slider.className = 'flickity-slider';
  slider.style[ this.originSide ] = 0;
  this.slider = slider;
};

proto._filterFindCellElements = function( elems ) {
  return utils.filterFindElements( elems, this.options.cellSelector );
};

// goes through all children
proto.reloadCells = function() {
  // collection of item elements
  this.cells = this._makeCells( this.slider.children );
  this.positionCells();
  this._getWrapShiftCells();
  this.setGallerySize();
};

/**
 * turn elements into Flickity.Cells
 * @param {Array or NodeList or HTMLElement} elems
 * @returns {Array} items - collection of new Flickity Cells
 */
proto._makeCells = function( elems ) {
  var cellElems = this._filterFindCellElements( elems );

  // create new Flickity for collection
  var cells = cellElems.map( function( cellElem ) {
    return new Cell( cellElem, this );
  }, this );

  return cells;
};

proto.getLastCell = function() {
  return this.cells[ this.cells.length - 1 ];
};

proto.getLastSlide = function() {
  return this.slides[ this.slides.length - 1 ];
};

// positions all cells
proto.positionCells = function() {
  // size all cells
  this._sizeCells( this.cells );
  // position all cells
  this._positionCells( 0 );
};

/**
 * position certain cells
 * @param {Integer} index - which cell to start with
 */
proto._positionCells = function( index ) {
  index = index || 0;
  // also measure maxCellHeight
  // start 0 if positioning all cells
  this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
  var cellX = 0;
  // get cellX
  if ( index > 0 ) {
    var startCell = this.cells[ index - 1 ];
    cellX = startCell.x + startCell.size.outerWidth;
  }
  var len = this.cells.length;
  for ( var i=index; i < len; i++ ) {
    var cell = this.cells[i];
    cell.setPosition( cellX );
    cellX += cell.size.outerWidth;
    this.maxCellHeight = Math.max( cell.size.outerHeight, this.maxCellHeight );
  }
  // keep track of cellX for wrap-around
  this.slideableWidth = cellX;
  // slides
  this.updateSlides();
  // contain slides target
  this._containSlides();
  // update slidesWidth
  this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
};

/**
 * cell.getSize() on multiple cells
 * @param {Array} cells
 */
proto._sizeCells = function( cells ) {
  cells.forEach( function( cell ) {
    cell.getSize();
  });
};

// --------------------------  -------------------------- //

proto.updateSlides = function() {
  this.slides = [];
  if ( !this.cells.length ) {
    return;
  }

  var slide = new Slide( this );
  this.slides.push( slide );
  var isOriginLeft = this.originSide == 'left';
  var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';

  var canCellFit = this._getCanCellFit();

  this.cells.forEach( function( cell, i ) {
    // just add cell if first cell in slide
    if ( !slide.cells.length ) {
      slide.addCell( cell );
      return;
    }

    var slideWidth = ( slide.outerWidth - slide.firstMargin ) +
      ( cell.size.outerWidth - cell.size[ nextMargin ] );

    if ( canCellFit.call( this, i, slideWidth ) ) {
      slide.addCell( cell );
    } else {
      // doesn't fit, new slide
      slide.updateTarget();

      slide = new Slide( this );
      this.slides.push( slide );
      slide.addCell( cell );
    }
  }, this );
  // last slide
  slide.updateTarget();
  // update .selectedSlide
  this.updateSelectedSlide();
};

proto._getCanCellFit = function() {
  var groupCells = this.options.groupCells;
  if ( !groupCells ) {
    return function() {
      return false;
    };
  } else if ( typeof groupCells == 'number' ) {
    // group by number. 3 -> [0,1,2], [3,4,5], ...
    var number = parseInt( groupCells, 10 );
    return function( i ) {
      return ( i % number ) !== 0;
    };
  }
  // default, group by width of slide
  // parse '75%
  var percentMatch = typeof groupCells == 'string' &&
    groupCells.match(/^(\d+)%$/);
  var percent = percentMatch ? parseInt( percentMatch[1], 10 ) / 100 : 1;
  return function( i, slideWidth ) {
    return slideWidth <= ( this.size.innerWidth + 1 ) * percent;
  };
};

// alias _init for jQuery plugin .flickity()
proto._init =
proto.reposition = function() {
  this.positionCells();
  this.positionSliderAtSelected();
};

proto.getSize = function() {
  this.size = getSize( this.element );
  this.setCellAlign();
  this.cursorPosition = this.size.innerWidth * this.cellAlign;
};

var cellAlignShorthands = {
  // cell align, then based on origin side
  center: {
    left: 0.5,
    right: 0.5
  },
  left: {
    left: 0,
    right: 1
  },
  right: {
    right: 0,
    left: 1
  }
};

proto.setCellAlign = function() {
  var shorthand = cellAlignShorthands[ this.options.cellAlign ];
  this.cellAlign = shorthand ? shorthand[ this.originSide ] : this.options.cellAlign;
};

proto.setGallerySize = function() {
  if ( this.options.setGallerySize ) {
    var height = this.options.adaptiveHeight && this.selectedSlide ?
      this.selectedSlide.height : this.maxCellHeight;
    this.viewport.style.height = height + 'px';
  }
};

proto._getWrapShiftCells = function() {
  // only for wrap-around
  if ( !this.options.wrapAround ) {
    return;
  }
  // unshift previous cells
  this._unshiftCells( this.beforeShiftCells );
  this._unshiftCells( this.afterShiftCells );
  // get before cells
  // initial gap
  var gapX = this.cursorPosition;
  var cellIndex = this.cells.length - 1;
  this.beforeShiftCells = this._getGapCells( gapX, cellIndex, -1 );
  // get after cells
  // ending gap between last cell and end of gallery viewport
  gapX = this.size.innerWidth - this.cursorPosition;
  // start cloning at first cell, working forwards
  this.afterShiftCells = this._getGapCells( gapX, 0, 1 );
};

proto._getGapCells = function( gapX, cellIndex, increment ) {
  // keep adding cells until the cover the initial gap
  var cells = [];
  while ( gapX > 0 ) {
    var cell = this.cells[ cellIndex ];
    if ( !cell ) {
      break;
    }
    cells.push( cell );
    cellIndex += increment;
    gapX -= cell.size.outerWidth;
  }
  return cells;
};

// ----- contain ----- //

// contain cell targets so no excess sliding
proto._containSlides = function() {
  if ( !this.options.contain || this.options.wrapAround || !this.cells.length ) {
    return;
  }
  var isRightToLeft = this.options.rightToLeft;
  var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
  var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
  var contentWidth = this.slideableWidth - this.getLastCell().size[ endMargin ];
  // content is less than gallery size
  var isContentSmaller = contentWidth < this.size.innerWidth;
  // bounds
  var beginBound = this.cursorPosition + this.cells[0].size[ beginMargin ];
  var endBound = contentWidth - this.size.innerWidth * ( 1 - this.cellAlign );
  // contain each cell target
  this.slides.forEach( function( slide ) {
    if ( isContentSmaller ) {
      // all cells fit inside gallery
      slide.target = contentWidth * this.cellAlign;
    } else {
      // contain to bounds
      slide.target = Math.max( slide.target, beginBound );
      slide.target = Math.min( slide.target, endBound );
    }
  }, this );
};

// -----  ----- //

/**
 * emits events via eventEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */
proto.dispatchEvent = function( type, event, args ) {
  var emitArgs = event ? [ event ].concat( args ) : args;
  this.emitEvent( type, emitArgs );

  if ( jQuery && this.$element ) {
    // default trigger with type if no event
    type += this.options.namespaceJQueryEvents ? '.flickity' : '';
    var $event = type;
    if ( event ) {
      // create jQuery event
      var jQEvent = jQuery.Event( event );
      jQEvent.type = type;
      $event = jQEvent;
    }
    this.$element.trigger( $event, args );
  }
};

// -------------------------- select -------------------------- //

/**
 * @param {Integer} index - index of the slide
 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
 * @param {Boolean} isInstant - will immediately set position at selected cell
 */
proto.select = function( index, isWrap, isInstant ) {
  if ( !this.isActive ) {
    return;
  }
  index = parseInt( index, 10 );
  this._wrapSelect( index );

  if ( this.options.wrapAround || isWrap ) {
    index = utils.modulo( index, this.slides.length );
  }
  // bail if invalid index
  if ( !this.slides[ index ] ) {
    return;
  }
  this.selectedIndex = index;
  this.updateSelectedSlide();
  if ( isInstant ) {
    this.positionSliderAtSelected();
  } else {
    this.startAnimation();
  }
  if ( this.options.adaptiveHeight ) {
    this.setGallerySize();
  }

  this.dispatchEvent('select');
  // old v1 event name, remove in v3
  this.dispatchEvent('cellSelect');
};

// wraps position for wrapAround, to move to closest slide. #113
proto._wrapSelect = function( index ) {
  var len = this.slides.length;
  var isWrapping = this.options.wrapAround && len > 1;
  if ( !isWrapping ) {
    return index;
  }
  var wrapIndex = utils.modulo( index, len );
  // go to shortest
  var delta = Math.abs( wrapIndex - this.selectedIndex );
  var backWrapDelta = Math.abs( ( wrapIndex + len ) - this.selectedIndex );
  var forewardWrapDelta = Math.abs( ( wrapIndex - len ) - this.selectedIndex );
  if ( !this.isDragSelect && backWrapDelta < delta ) {
    index += len;
  } else if ( !this.isDragSelect && forewardWrapDelta < delta ) {
    index -= len;
  }
  // wrap position so slider is within normal area
  if ( index < 0 ) {
    this.x -= this.slideableWidth;
  } else if ( index >= len ) {
    this.x += this.slideableWidth;
  }
};

proto.previous = function( isWrap, isInstant ) {
  this.select( this.selectedIndex - 1, isWrap, isInstant );
};

proto.next = function( isWrap, isInstant ) {
  this.select( this.selectedIndex + 1, isWrap, isInstant );
};

proto.updateSelectedSlide = function() {
  var slide = this.slides[ this.selectedIndex ];
  // selectedIndex could be outside of slides, if triggered before resize()
  if ( !slide ) {
    return;
  }
  // unselect previous selected slide
  this.unselectSelectedSlide();
  // update new selected slide
  this.selectedSlide = slide;
  slide.select();
  this.selectedCells = slide.cells;
  this.selectedElements = slide.getCellElements();
  // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
  // Remove in v3?
  this.selectedCell = slide.cells[0];
  this.selectedElement = this.selectedElements[0];
};

proto.unselectSelectedSlide = function() {
  if ( this.selectedSlide ) {
    this.selectedSlide.unselect();
  }
};

/**
 * select slide from number or cell element
 * @param {Element or Number} elem
 */
proto.selectCell = function( value, isWrap, isInstant ) {
  // get cell
  var cell;
  if ( typeof value == 'number' ) {
    cell = this.cells[ value ];
  } else {
    // use string as selector
    if ( typeof value == 'string' ) {
      value = this.element.querySelector( value );
    }
    // get cell from element
    cell = this.getCell( value );
  }
  // select slide that has cell
  for ( var i=0; cell && i < this.slides.length; i++ ) {
    var slide = this.slides[i];
    var index = slide.cells.indexOf( cell );
    if ( index != -1 ) {
      this.select( i, isWrap, isInstant );
      return;
    }
  }
};

// -------------------------- get cells -------------------------- //

/**
 * get Flickity.Cell, given an Element
 * @param {Element} elem
 * @returns {Flickity.Cell} item
 */
proto.getCell = function( elem ) {
  // loop through cells to get the one that matches
  for ( var i=0; i < this.cells.length; i++ ) {
    var cell = this.cells[i];
    if ( cell.element == elem ) {
      return cell;
    }
  }
};

/**
 * get collection of Flickity.Cells, given Elements
 * @param {Element, Array, NodeList} elems
 * @returns {Array} cells - Flickity.Cells
 */
proto.getCells = function( elems ) {
  elems = utils.makeArray( elems );
  var cells = [];
  elems.forEach( function( elem ) {
    var cell = this.getCell( elem );
    if ( cell ) {
      cells.push( cell );
    }
  }, this );
  return cells;
};

/**
 * get cell elements
 * @returns {Array} cellElems
 */
proto.getCellElements = function() {
  return this.cells.map( function( cell ) {
    return cell.element;
  });
};

/**
 * get parent cell from an element
 * @param {Element} elem
 * @returns {Flickit.Cell} cell
 */
proto.getParentCell = function( elem ) {
  // first check if elem is cell
  var cell = this.getCell( elem );
  if ( cell ) {
    return cell;
  }
  // try to get parent cell elem
  elem = utils.getParent( elem, '.flickity-slider > *' );
  return this.getCell( elem );
};

/**
 * get cells adjacent to a slide
 * @param {Integer} adjCount - number of adjacent slides
 * @param {Integer} index - index of slide to start
 * @returns {Array} cells - array of Flickity.Cells
 */
proto.getAdjacentCellElements = function( adjCount, index ) {
  if ( !adjCount ) {
    return this.selectedSlide.getCellElements();
  }
  index = index === undefined ? this.selectedIndex : index;

  var len = this.slides.length;
  if ( 1 + ( adjCount * 2 ) >= len ) {
    return this.getCellElements();
  }

  var cellElems = [];
  for ( var i = index - adjCount; i <= index + adjCount ; i++ ) {
    var slideIndex = this.options.wrapAround ? utils.modulo( i, len ) : i;
    var slide = this.slides[ slideIndex ];
    if ( slide ) {
      cellElems = cellElems.concat( slide.getCellElements() );
    }
  }
  return cellElems;
};

// -------------------------- events -------------------------- //

proto.uiChange = function() {
  this.emitEvent('uiChange');
};

proto.childUIPointerDown = function( event ) {
  this.emitEvent( 'childUIPointerDown', [ event ] );
};

// ----- resize ----- //

proto.onresize = function() {
  this.watchCSS();
  this.resize();
};

utils.debounceMethod( Flickity, 'onresize', 150 );

proto.resize = function() {
  if ( !this.isActive ) {
    return;
  }
  this.getSize();
  // wrap values
  if ( this.options.wrapAround ) {
    this.x = utils.modulo( this.x, this.slideableWidth );
  }
  this.positionCells();
  this._getWrapShiftCells();
  this.setGallerySize();
  this.emitEvent('resize');
  // update selected index for group slides, instant
  // TODO: position can be lost between groups of various numbers
  var selectedElement = this.selectedElements && this.selectedElements[0];
  this.selectCell( selectedElement, false, true );
};

// watches the :after property, activates/deactivates
proto.watchCSS = function() {
  var watchOption = this.options.watchCSS;
  if ( !watchOption ) {
    return;
  }

  var afterContent = getComputedStyle( this.element, ':after' ).content;
  // activate if :after { content: 'flickity' }
  if ( afterContent.indexOf('flickity') != -1 ) {
    this.activate();
  } else {
    this.deactivate();
  }
};

// ----- keydown ----- //

// go previous/next if left/right keys pressed
proto.onkeydown = function( event ) {
  // only work if element is in focus
  if ( !this.options.accessibility ||
    ( document.activeElement && document.activeElement != this.element ) ) {
    return;
  }

  if ( event.keyCode == 37 ) {
    // go left
    var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
    this.uiChange();
    this[ leftMethod ]();
  } else if ( event.keyCode == 39 ) {
    // go right
    var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
    this.uiChange();
    this[ rightMethod ]();
  }
};

// -------------------------- destroy -------------------------- //

// deactivate all Flickity functionality, but keep stuff available
proto.deactivate = function() {
  if ( !this.isActive ) {
    return;
  }
  this.element.classList.remove('flickity-enabled');
  this.element.classList.remove('flickity-rtl');
  // destroy cells
  this.cells.forEach( function( cell ) {
    cell.destroy();
  });
  this.unselectSelectedSlide();
  this.element.removeChild( this.viewport );
  // move child elements back into element
  moveElements( this.slider.children, this.element );
  if ( this.options.accessibility ) {
    this.element.removeAttribute('tabIndex');
    this.element.removeEventListener( 'keydown', this );
  }
  // set flags
  this.isActive = false;
  this.emitEvent('deactivate');
};

proto.destroy = function() {
  this.deactivate();
  window.removeEventListener( 'resize', this );
  this.emitEvent('destroy');
  if ( jQuery && this.$element ) {
    jQuery.removeData( this.element, 'flickity' );
  }
  delete this.element.flickityGUID;
  delete instances[ this.guid ];
};

// -------------------------- prototype -------------------------- //

utils.extend( proto, animatePrototype );

// -------------------------- extras -------------------------- //

/**
 * get Flickity instance from element
 * @param {Element} elem
 * @returns {Flickity}
 */
Flickity.data = function( elem ) {
  elem = utils.getQueryElement( elem );
  var id = elem && elem.flickityGUID;
  return id && instances[ id ];
};

utils.htmlInit( Flickity, 'flickity' );

if ( jQuery && jQuery.bridget ) {
  jQuery.bridget( 'flickity', Flickity );
}

// set internal jQuery, for Webpack + jQuery v3, #478
Flickity.setJQuery = function( jq ) {
  jQuery = jq;
};

Flickity.Cell = Cell;

return Flickity;

}));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * media query module
 * @module twt.media-query
 */

var queries = {
  xs: 'only screen',
  s: 'only screen and (min-width: 48em)',
  m: 'only screen and (min-width: 64em)',
  l: 'only screen and (min-width: 73.125em)'
};

var current = null;

/**
 * @return {void}
 */
function getCurrentSize() {
  var size = null;

  for (var i = 0; i < Object.keys(queries).length; i += 1) {
    if (window.matchMedia(queries[Object.keys(queries)[i]]).matches) {
      size = Object.keys(queries)[i];
    }
  }

  return size;
}

/**
 * @return {void}
 */
function registerEventListener() {
  window.addEventListener('resize', function () {
    var newSize = getCurrentSize();
    var currentSize = current;

    if (currentSize !== null && newSize !== currentSize) {
      // Change the current media query
      current = newSize;

      var event = new CustomEvent('changed.twt.mediaQuery', {
        detail: {
          newSize: newSize,
          oldSize: currentSize
        }
      });

      window.dispatchEvent(event);
    }
  });
}

/**
 * @return {void}
 */
function init() {
  registerEventListener();
}

exports.init = init;
exports.getCurrentSize = getCurrentSize;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Pub/Sub module.
 * @module pubSub
 */

var messages = {};

var pubSub = {
  publish: function publish(message, data) {
    // check if there are even messages
    if (Object.keys(messages).length === 0 && messages.constructor === Object) return false;

    // check if message exists
    if (messages[message] === undefined) return false;

    // check if message has subscribers
    if (Object.keys(messages[message]).length === 0) return false;

    // call message handler
    var handlers = Object.keys(messages[message]).map(function (handler) {
      return messages[message][handler];
    });

    handlers.forEach(function (handler) {
      handler(data);
    });

    return true;
  },

  subscribe: function subscribe(message, handler) {
    var token = "uid_" + String(Math.floor(Math.random() * 9999) + 1);

    // message is not registered yet
    if (!(message in messages)) {
      messages[message] = {};
    }

    // assign handler to message and token
    messages[message][token] = handler;

    // return token for unsubscribing
    return token;
  },

  unsubscribe: function unsubscribe(token) {
    Object.keys(messages).forEach(function (message) {
      Object.keys(messages[message]).forEach(function (key) {
        if (key === token) {
          delete messages[message][token];
        }
      });
    });
  },

  clearAllSubscriptions: function clearAllSubscriptions() {
    messages = {};
  }
};

exports.default = pubSub;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(27),
	__webpack_require__(35)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, slice ) {

"use strict";

function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( jQuery.isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );

return jQuery;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(28),
	__webpack_require__(92),
	__webpack_require__(93),
	__webpack_require__(57),
	__webpack_require__(7),

	__webpack_require__(4),
	__webpack_require__(56),
	__webpack_require__(3)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, indexOf, dir, siblings, rneedsContext, nodeName ) {

"use strict";

var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );

return jQuery;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(2),
	__webpack_require__(34),
	__webpack_require__(6),
	__webpack_require__(27),
	__webpack_require__(5),
	__webpack_require__(7),

	__webpack_require__(4),
	__webpack_require__(3)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, documentElement, rnothtmlwhite, slice, dataPriv, nodeName ) {

"use strict";

var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: jQuery.isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );

return jQuery;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(2),
	__webpack_require__(6),
	__webpack_require__(108),
	__webpack_require__(70),
	__webpack_require__(71),

	__webpack_require__(4),
	__webpack_require__(109),
	__webpack_require__(41),
	__webpack_require__(15),
	__webpack_require__(72) // jQuery.param
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, rnothtmlwhite, location, nonce, rquery ) {

"use strict";

var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 13
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

return jQuery;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(31),
	__webpack_require__(11),
	__webpack_require__(49),
	__webpack_require__(2),
	__webpack_require__(30),
	__webpack_require__(32),
	__webpack_require__(50),
	__webpack_require__(51),
	__webpack_require__(44),
	__webpack_require__(52),
	__webpack_require__(53),
	__webpack_require__(54),
	__webpack_require__(33),

	__webpack_require__(4),
	__webpack_require__(58),
	__webpack_require__(3) // contains
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, pnum, access, rmargin, document, rcssNum, rnumnonpx, cssExpand,
	getStyles, swap, curCSS, adjustCSS, addGetHookIf, support ) {

"use strict";

var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i,
		val = 0;

	// If we already have the right measurement, avoid augmentation
	if ( extra === ( isBorderBox ? "border" : "content" ) ) {
		i = 4;

	// Otherwise initialize for horizontal or vertical properties
	} else {
		i = name === "width" ? 1 : 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with computed style
	var valueIsBorderBox,
		styles = getStyles( elem ),
		val = curCSS( elem, name, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Computed unit is not pixels. Stop here and return.
	if ( rnumnonpx.test( val ) ) {
		return val;
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = isBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ name ] );

	// Fall back to offsetWidth/Height when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	if ( val === "auto" ) {
		val = elem[ "offset" + name[ 0 ].toUpperCase() + name.slice( 1 ) ];
	}

	// Normalize "", auto, and prepare for extra
	val = parseFloat( val ) || 0;

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );

return jQuery;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	"use strict";

	return [];
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var spinnerUtils = {
  /**
   * @param  {HTMLElement} container to container in which the spinner shall be displayed
   * @return {String} token
   */
  create: function create() {
    var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;

    var overlay = document.createElement('div');
    var spinnerNode = document.createElement('div');
    var token = 'spinner-' + String(Math.floor(Math.random() * 9999) + 1);
    var target = container;

    // overlay
    overlay.id = token;
    overlay.classList.add('spinner--overlay');

    // wrapper
    spinnerNode.classList.add('spinner');
    spinnerNode.dataset.spinner = '';

    // add elements to spinner
    for (var i = 1; i <= 8; i += 1) {
      var element = document.createElement('div');

      // set id and classes
      element.id = 'frotateG_0' + i;
      element.classList.add('spinner--element');

      // add element to spinner
      spinnerNode.appendChild(element);
    }

    // assamble
    overlay.appendChild(spinnerNode);
    target.appendChild(overlay);

    return token;
  },

  /**
   * @param  {String} token token to identify the spinner
   * @return {void}
   */
  destroy: function destroy(token) {
    var spinner = document.getElementById(token);

    // remove spinner
    if (spinner !== null) spinner.parentNode.removeChild(spinner);
  }
};

exports.default = spinnerUtils;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(45),
	__webpack_require__(46),
	__webpack_require__(11),
	__webpack_require__(62),
	__webpack_require__(63),
	__webpack_require__(64),
	__webpack_require__(65),
	__webpack_require__(66),
	__webpack_require__(67),
	__webpack_require__(68),
	__webpack_require__(98),

	__webpack_require__(5),
	__webpack_require__(60),
	__webpack_require__(36),
	__webpack_require__(48),
	__webpack_require__(7),

	__webpack_require__(4),
	__webpack_require__(16),
	__webpack_require__(3),
	__webpack_require__(17)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, concat, push, access,
	rcheckableType, rtagName, rscriptType,
	wrapMap, getAll, setGlobalEval, buildFragment, support,
	dataPriv, dataUser, acceptData, DOMEval, nodeName ) {

"use strict";

var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( ">tbody", elem )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );

return jQuery;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initPagination;

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _pubSub = __webpack_require__(14);

var _pubSub2 = _interopRequireDefault(_pubSub);

var _filter = __webpack_require__(24);

var _articleListOrder = __webpack_require__(25);

var _articleListOrder2 = _interopRequireDefault(_articleListOrder);

var _spinner = __webpack_require__(21);

var _spinner2 = _interopRequireDefault(_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param  {Node} scope the scope in which to search for articles to reload
 * @return {void}
 */
function initPagination() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  (0, _jquery2.default)(scope).find('.pagination .btn').on('click', function (event) {
    event.preventDefault();
    var element = (0, _jquery2.default)(event.currentTarget);
    var url = (0, _jquery2.default)(element).attr('href');
    var token = _spinner2.default.create();

    // send with 'partial' param to get the content for ajax injection into the DOM
    _jquery2.default.get(url, { partial: '1' }, function (data) {
      if (data.length > 0) {
        var container = (0, _jquery2.default)(element).closest('.load-more-content');
        var oldArticles = (0, _jquery2.default)(container).find('.load-more-teaser').first().html();

        (0, _jquery2.default)(container).html(data);

        var newArticles = (0, _jquery2.default)(container).find('.load-more-teaser').first().html();

        (0, _jquery2.default)(container).find('.load-more-teaser').first().html(oldArticles + newArticles);

        (0, _filter.initFilterTags)(document.querySelector('.delete-option'));
        initPagination(container);
        (0, _articleListOrder2.default)(container);

        _pubSub2.default.publish('reloaded.content', {
          scope: container[0]
        });
      }

      // destroy spinner
      _spinner2.default.destroy(token);
    });

    return false;
  });

  (0, _jquery2.default)(scope).find('.listLocator').on('click', function (event) {
    var element = event.currentTarget;
    var url = (0, _jquery2.default)(element).attr('href');
    var token = _spinner2.default.create();

    // send with 'partial' param to get the content for ajax injection into the DOM
    _jquery2.default.get(url, { partial: '1' }, function (data) {
      if (data.length > 0) {
        var container = (0, _jquery2.default)(element).closest('.load-more-content');
        (0, _jquery2.default)(container).html(data);

        (0, _filter.initFilterTags)(document.querySelector('.delete-option'));
        initPagination(container);
        (0, _articleListOrder2.default)(container);

        _pubSub2.default.publish('reloaded.content', {
          scope: container[0]
        });
      }

      // destroy spinner
      _spinner2.default.destroy(token);
    });

    return false;
  });
}

initPagination();

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterDropdown = filterDropdown;
exports.initFilterTags = initFilterTags;
exports.registerFilterResetEventlistener = registerFilterResetEventlistener;
exports.initFilterForm = initFilterForm;

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _pubSub = __webpack_require__(14);

var _pubSub2 = _interopRequireDefault(_pubSub);

var _articleListOrder = __webpack_require__(25);

var _articleListOrder2 = _interopRequireDefault(_articleListOrder);

var _pagination = __webpack_require__(23);

var _pagination2 = _interopRequireDefault(_pagination);

var _spinner = __webpack_require__(21);

var _spinner2 = _interopRequireDefault(_spinner);

var _searchresultCategories = __webpack_require__(82);

var _searchresultCategories2 = _interopRequireDefault(_searchresultCategories);

var _range = __webpack_require__(78);

var _range2 = _interopRequireDefault(_range);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param  {Node} scope The scope in which to search for filter dropdowns
 * @return {void}
 */
function filterDropdown() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  (0, _jquery2.default)(scope).find('.js-dropdown').on('click', function (event) {
    var element = (0, _jquery2.default)(event.currentTarget);
    element.toggleClass('active', 500);
    element.siblings('.category-filter__dropdown, .category-content-navigation, .productdetailstext').toggleClass('active', 500);

    // check for data attribute text and replace if text is available
    if (element.data('text') !== undefined) {
      var currentText = element.text();
      var newText = element.data('text');

      element.text(newText);
      element.data('text', currentText);
    }
  });

  (0, _jquery2.default)(scope).find('.js-dropdown-item__label').on('click', function (event) {
    (0, _jquery2.default)('.js-dropdown-item__label').not(event.currentTarget).siblings('.dropdown-item__option.active').removeClass('active');
    (0, _jquery2.default)('.js-dropdown-item__label.active').not(event.currentTarget).removeClass('active');
    (0, _jquery2.default)(event.currentTarget).toggleClass('active', 500);
    (0, _jquery2.default)(event.currentTarget).siblings('.dropdown-item__option').toggleClass('active', 500);
  });
}

/**
 * @param  {Node} scope The scope in which to search for filter tags
 * @return {void}
 */
function initFilterTags(scope) {
  if (scope === null) return false;

  (0, _jquery2.default)(scope).find('.tag').on('click', function (event) {
    var element = (0, _jquery2.default)(event.currentTarget);
    var form = (0, _jquery2.default)('form[name=filterlist]');
    var filterItemId = element.data('filteritemid');
    var filterItem = form.find('#' + filterItemId);

    var filterType = filterItem.parents('.dropdown-item').data('filtertype');

    switch (filterType) {
      case 'checkbox':
        {
          // uncheck the respective filter param and resend the form
          filterItem.attr('checked', false);
          form.submit();
          break;
        }
      case 'price':
      // falls through
      case 'range':
        {
          // set the slider range to min and max and resend the form
          var rangeGroup = form.find('#' + filterItemId);
          var inputMin = (0, _jquery2.default)('input.js-amount_min', rangeGroup);
          var inputMax = (0, _jquery2.default)('input.js-amount_max', rangeGroup);
          var inputActiveFlag = rangeGroup.siblings('input.js-amount_active');
          inputMin.val(inputMin.attr('min'));
          inputMax.val(inputMax.attr('max'));
          inputActiveFlag.val(0);
          form.submit();
          break;
        }
      default:
        break;
    }

    return false;
  });

  return true;
}

/**
 * @param  {Event} event The trigger
 * @param  {String} filterURL The url to call to get the new content
 * @return {void}
 */
function reloadContentWithFilterURL(event, filterURL) {
  return new Promise(function (resolve) {
    var xhr = new XMLHttpRequest();
    var token = _spinner2.default.create();

    // AJAX
    xhr.open('GET', filterURL);
    xhr.send();
    xhr.onload = function () {
      if (xhr.status === 200) {
        var container = event.target.closest('.load-more-content');

        // set content
        container.innerHTML = xhr.responseText;

        // reinit scripts
        initFilterTags(document.querySelector('.delete-option'));
        (0, _pagination2.default)(container);
        (0, _articleListOrder2.default)(container);
        (0, _jquery2.default)('.accordion').Accordion();
        filterDropdown(container);
        (0, _searchresultCategories2.default)();
        (0, _range2.default)(container);
        registerFilterResetEventlistener(container); // eslint-disable-line no-use-before-define

        // publish message
        _pubSub2.default.publish('reloaded.content', {
          scope: container[0]
        });
      }

      // destroy spinner
      _spinner2.default.destroy(token);
    };

    resolve();
  });
}

/**
 * @param  {Node} scope The scope in which to search for the filter form
 * @return {void}
 */
function registerFilterResetEventlistener() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  var backToAllProductsButtons = [].slice.call(scope.querySelectorAll('[data-reset-filter-page-url]'));
  var resetFilterButtons = [].slice.call(scope.querySelectorAll('[data-reset-filter-partial-url]'));

  // back to all products
  if (backToAllProductsButtons.length > 0) {
    backToAllProductsButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.stopImmediatePropagation();
        reloadContentWithFilterURL(event, button.dataset.resetFilterPageUrl);
      });
    });
  }

  // remove all filters
  if (resetFilterButtons.length > 0) {
    resetFilterButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.stopImmediatePropagation();
        reloadContentWithFilterURL(event, button.dataset.resetFilterPartialUrl);
      });
    });
  }
}

/**
 * @param  {Node} scope The scope in which to search for the filter form
 * @return {void}
 */
function initFilterForm() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  // bind delegated event to filterform that will be loaded asynchronously in tab content
  (0, _jquery2.default)(scope).find('.tabs').on('submit', 'form[name=filterlist]', function (event) {
    var form = (0, _jquery2.default)(event.currentTarget);
    // send the form via ajax?
    if (form.data('method') === 'ajax') {
      event.preventDefault();

      var url = form.attr('action');
      var params = form.serializeArray();
      var token = _spinner2.default.create();

      // we only load the products partial (searchtype=2)
      params.push({ name: 'searchtype', value: '2' });
      _jquery2.default.get(url, params, function (data) {
        if (data.length > 0) {
          var container = (0, _jquery2.default)(form).closest('.load-more-content');

          container.html(data);

          initFilterTags(document.querySelector('.delete-option'));
          (0, _pagination2.default)(container);
          (0, _articleListOrder2.default)(container);
          registerFilterResetEventlistener();

          _pubSub2.default.publish('reloaded.content', {
            scope: container[0]
          });
        }

        // destroy spinner
        _spinner2.default.destroy(token);
      });
    }
  });

  // bind delegated event to category filter items
  (0, _jquery2.default)(scope).find('.tabs').on('click', '.js-categoryfilter', function (event) {
    var element = (0, _jquery2.default)(event.currentTarget);

    if (element.data('store') === 'category') {
      var categoryId = element.data('value');
      var form = element.closest('.load-more-content').find('form[name=filterlist]');
      var categoryFilterInput = form.find('input[name=filtercategory]');

      categoryFilterInput.val(categoryId);
      form.submit();
      window.scrollTo(0, 0);
    }
  });

  registerFilterResetEventlistener(scope);
}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initArticleListOrder;

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _filter = __webpack_require__(24);

var _pubSub = __webpack_require__(14);

var _pubSub2 = _interopRequireDefault(_pubSub);

var _pagination = __webpack_require__(23);

var _pagination2 = _interopRequireDefault(_pagination);

var _spinner = __webpack_require__(21);

var _spinner2 = _interopRequireDefault(_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param  {HTMLElement} scope = document
 * @return {void}
 */
function initArticleListOrder() {
  (0, _jquery2.default)('.category-quantity select').on('change', function (event) {
    var element = (0, _jquery2.default)(event.currentTarget);
    var url = (0, _jquery2.default)(element).val();
    var token = _spinner2.default.create();

    // send with 'partial' param to get the content for ajax injection into the DOM
    _jquery2.default.get(url, { partial: '1' }, function (data) {
      if (data.length > 0) {
        var container = (0, _jquery2.default)(element).closest('.load-more-content');
        (0, _jquery2.default)(container).html(data);

        (0, _filter.initFilterTags)(document.querySelector('.delete-option'));
        (0, _pagination2.default)(container);
        initArticleListOrder(container);

        _pubSub2.default.publish('reloaded.content', {
          scope: container[0]
        });
      }

      // destroy spinner
      _spinner2.default.destroy(token);
    });

    return false;
  });
}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	"use strict";

	// [[Class]] -> type pairs
	return {};
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(20)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( arr ) {
	"use strict";

	return arr.slice;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(20)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( arr ) {
	"use strict";

	return arr.indexOf;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(26)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( class2type ) {
	"use strict";

	return class2type.hasOwnProperty;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(31)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( pnum ) {

"use strict";

return new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	"use strict";

	return ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(31)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( pnum ) {
	"use strict";

	return new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(2),
	__webpack_require__(34),
	__webpack_require__(10)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, documentElement, support ) {

"use strict";

( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		div.style.cssText =
			"box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	jQuery.extend( support, {
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {
			computeStyleTests();
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		}
	} );
} )();

return support;

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(2)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( document ) {
	"use strict";

	return document.documentElement;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(6)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, rnothtmlwhite ) {

"use strict";

// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};

return jQuery;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {

"use strict";

/**
 * Determines whether an object can have data
 */
return function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};

}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(5),
	__webpack_require__(15),
	__webpack_require__(35)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, dataPriv ) {

"use strict";

jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );

return jQuery;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(2),
	__webpack_require__(30),
	__webpack_require__(6),
	__webpack_require__(50),
	__webpack_require__(61),
	__webpack_require__(44),
	__webpack_require__(53),
	__webpack_require__(5),
	__webpack_require__(97),

	__webpack_require__(4),
	__webpack_require__(37),
	__webpack_require__(15),
	__webpack_require__(16),
	__webpack_require__(22),
	__webpack_require__(19),
	__webpack_require__(99)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, rcssNum, rnothtmlwhite, cssExpand, isHiddenWithinTree, swap,
	adjustCSS, dataPriv, showHide ) {

"use strict";

var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 13
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};

return jQuery;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(2),
	__webpack_require__(10)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( document, support ) {

"use strict";

( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();

return support;

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(6)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( rnothtmlwhite ) {
	"use strict";

	// Strip and collapse whitespace according to HTML spec
	// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}

	return stripAndCollapse;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(2),
	__webpack_require__(5),
	__webpack_require__(36),
	__webpack_require__(29),

	__webpack_require__(17)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, dataPriv, acceptData, hasOwn ) {

"use strict";

var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );

return jQuery;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Triggers = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _foundationUtil = __webpack_require__(131);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MutationObserver = function () {
  var prefixes = ['WebKit', 'Moz', 'O', 'Ms', ''];
  for (var i = 0; i < prefixes.length; i++) {
    if (prefixes[i] + 'MutationObserver' in window) {
      return window[prefixes[i] + 'MutationObserver'];
    }
  }
  return false;
}();

var triggers = function triggers(el, type) {
  el.data(type).split(' ').forEach(function (id) {
    (0, _jquery2.default)('#' + id)[type === 'close' ? 'trigger' : 'triggerHandler'](type + '.zf.trigger', [el]);
  });
};

var Triggers = {
  Listeners: {
    Basic: {},
    Global: {}
  },
  Initializers: {}
};

Triggers.Listeners.Basic = {
  openListener: function openListener() {
    triggers((0, _jquery2.default)(this), 'open');
  },
  closeListener: function closeListener() {
    var id = (0, _jquery2.default)(this).data('close');
    if (id) {
      triggers((0, _jquery2.default)(this), 'close');
    } else {
      (0, _jquery2.default)(this).trigger('close.zf.trigger');
    }
  },
  toggleListener: function toggleListener() {
    var id = (0, _jquery2.default)(this).data('toggle');
    if (id) {
      triggers((0, _jquery2.default)(this), 'toggle');
    } else {
      (0, _jquery2.default)(this).trigger('toggle.zf.trigger');
    }
  },
  closeableListener: function closeableListener(e) {
    e.stopPropagation();
    var animation = (0, _jquery2.default)(this).data('closable');

    if (animation !== '') {
      _foundationUtil.Motion.animateOut((0, _jquery2.default)(this), animation, function () {
        (0, _jquery2.default)(this).trigger('closed.zf');
      });
    } else {
      (0, _jquery2.default)(this).fadeOut().trigger('closed.zf');
    }
  },
  toggleFocusListener: function toggleFocusListener() {
    var id = (0, _jquery2.default)(this).data('toggle-focus');
    (0, _jquery2.default)('#' + id).triggerHandler('toggle.zf.trigger', [(0, _jquery2.default)(this)]);
  }
};

// Elements with [data-open] will reveal a plugin that supports it when clicked.
Triggers.Initializers.addOpenListener = function ($elem) {
  $elem.off('click.zf.trigger', Triggers.Listeners.Basic.openListener);
  $elem.on('click.zf.trigger', '[data-open]', Triggers.Listeners.Basic.openListener);
};

// Elements with [data-close] will close a plugin that supports it when clicked.
// If used without a value on [data-close], the event will bubble, allowing it to close a parent component.
Triggers.Initializers.addCloseListener = function ($elem) {
  $elem.off('click.zf.trigger', Triggers.Listeners.Basic.closeListener);
  $elem.on('click.zf.trigger', '[data-close]', Triggers.Listeners.Basic.closeListener);
};

// Elements with [data-toggle] will toggle a plugin that supports it when clicked.
Triggers.Initializers.addToggleListener = function ($elem) {
  $elem.off('click.zf.trigger', Triggers.Listeners.Basic.toggleListener);
  $elem.on('click.zf.trigger', '[data-toggle]', Triggers.Listeners.Basic.toggleListener);
};

// Elements with [data-closable] will respond to close.zf.trigger events.
Triggers.Initializers.addCloseableListener = function ($elem) {
  $elem.off('close.zf.trigger', Triggers.Listeners.Basic.closeableListener);
  $elem.on('close.zf.trigger', '[data-closeable], [data-closable]', Triggers.Listeners.Basic.closeableListener);
};

// Elements with [data-toggle-focus] will respond to coming in and out of focus
Triggers.Initializers.addToggleFocusListener = function ($elem) {
  $elem.off('focus.zf.trigger blur.zf.trigger', Triggers.Listeners.Basic.toggleFocusListener);
  $elem.on('focus.zf.trigger blur.zf.trigger', '[data-toggle-focus]', Triggers.Listeners.Basic.toggleFocusListener);
};

// More Global/complex listeners and triggers
Triggers.Listeners.Global = {
  resizeListener: function resizeListener($nodes) {
    if (!MutationObserver) {
      //fallback for IE 9
      $nodes.each(function () {
        (0, _jquery2.default)(this).triggerHandler('resizeme.zf.trigger');
      });
    }
    //trigger all listening elements and signal a resize event
    $nodes.attr('data-events', "resize");
  },
  scrollListener: function scrollListener($nodes) {
    if (!MutationObserver) {
      //fallback for IE 9
      $nodes.each(function () {
        (0, _jquery2.default)(this).triggerHandler('scrollme.zf.trigger');
      });
    }
    //trigger all listening elements and signal a scroll event
    $nodes.attr('data-events', "scroll");
  },
  closeMeListener: function closeMeListener(e, pluginId) {
    var plugin = e.namespace.split('.')[0];
    var plugins = (0, _jquery2.default)('[data-' + plugin + ']').not('[data-yeti-box="' + pluginId + '"]');

    plugins.each(function () {
      var _this = (0, _jquery2.default)(this);
      _this.triggerHandler('close.zf.trigger', [_this]);
    });
  }

  // Global, parses whole document.
};Triggers.Initializers.addClosemeListener = function (pluginName) {
  var yetiBoxes = (0, _jquery2.default)('[data-yeti-box]'),
      plugNames = ['dropdown', 'tooltip', 'reveal'];

  if (pluginName) {
    if (typeof pluginName === 'string') {
      plugNames.push(pluginName);
    } else if ((typeof pluginName === 'undefined' ? 'undefined' : _typeof(pluginName)) === 'object' && typeof pluginName[0] === 'string') {
      plugNames.concat(pluginName);
    } else {
      console.error('Plugin names must be strings');
    }
  }
  if (yetiBoxes.length) {
    var listeners = plugNames.map(function (name) {
      return 'closeme.zf.' + name;
    }).join(' ');

    (0, _jquery2.default)(window).off(listeners).on(listeners, Triggers.Listeners.Global.closeMeListener);
  }
};

function debounceGlobalListener(debounce, trigger, listener) {
  var timer = void 0,
      args = Array.prototype.slice.call(arguments, 3);
  (0, _jquery2.default)(window).off(trigger).on(trigger, function (e) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      listener.apply(null, args);
    }, debounce || 10); //default time to emit scroll event
  });
}

Triggers.Initializers.addResizeListener = function (debounce) {
  var $nodes = (0, _jquery2.default)('[data-resize]');
  if ($nodes.length) {
    debounceGlobalListener(debounce, 'resize.zf.trigger', Triggers.Listeners.Global.resizeListener, $nodes);
  }
};

Triggers.Initializers.addScrollListener = function (debounce) {
  var $nodes = (0, _jquery2.default)('[data-scroll]');
  if ($nodes.length) {
    debounceGlobalListener(debounce, 'scroll.zf.trigger', Triggers.Listeners.Global.scrollListener, $nodes);
  }
};

Triggers.Initializers.addMutationEventsListener = function ($elem) {
  if (!MutationObserver) {
    return false;
  }
  var $nodes = $elem.find('[data-resize], [data-scroll], [data-mutate]');

  //element callback
  var listeningElementsMutation = function listeningElementsMutation(mutationRecordsList) {
    var $target = (0, _jquery2.default)(mutationRecordsList[0].target);

    //trigger the event handler for the element depending on type
    switch (mutationRecordsList[0].type) {
      case "attributes":
        if ($target.attr("data-events") === "scroll" && mutationRecordsList[0].attributeName === "data-events") {
          $target.triggerHandler('scrollme.zf.trigger', [$target, window.pageYOffset]);
        }
        if ($target.attr("data-events") === "resize" && mutationRecordsList[0].attributeName === "data-events") {
          $target.triggerHandler('resizeme.zf.trigger', [$target]);
        }
        if (mutationRecordsList[0].attributeName === "style") {
          $target.closest("[data-mutate]").attr("data-events", "mutate");
          $target.closest("[data-mutate]").triggerHandler('mutateme.zf.trigger', [$target.closest("[data-mutate]")]);
        }
        break;

      case "childList":
        $target.closest("[data-mutate]").attr("data-events", "mutate");
        $target.closest("[data-mutate]").triggerHandler('mutateme.zf.trigger', [$target.closest("[data-mutate]")]);
        break;

      default:
        return false;
      //nothing
    }
  };

  if ($nodes.length) {
    //for each element that needs to listen for resizing, scrolling, or mutation add a single observer
    for (var i = 0; i <= $nodes.length - 1; i++) {
      var elementObserver = new MutationObserver(listeningElementsMutation);
      elementObserver.observe($nodes[i], { attributes: true, childList: true, characterData: false, subtree: true, attributeFilter: ["data-events", "style"] });
    }
  }
};

Triggers.Initializers.addSimpleListeners = function () {
  var $document = (0, _jquery2.default)(document);

  Triggers.Initializers.addOpenListener($document);
  Triggers.Initializers.addCloseListener($document);
  Triggers.Initializers.addToggleListener($document);
  Triggers.Initializers.addCloseableListener($document);
  Triggers.Initializers.addToggleFocusListener($document);
};

Triggers.Initializers.addGlobalListeners = function () {
  var $document = (0, _jquery2.default)(document);
  Triggers.Initializers.addMutationEventsListener($document);
  Triggers.Initializers.addResizeListener();
  Triggers.Initializers.addScrollListener();
  Triggers.Initializers.addClosemeListener();
};

Triggers.init = function ($, Foundation) {
  if (typeof $.triggersInitialized === 'undefined') {
    var $document = $(document);

    if (document.readyState === "complete") {
      Triggers.Initializers.addSimpleListeners();
      Triggers.Initializers.addGlobalListeners();
    } else {
      $(window).on('load', function () {
        Triggers.Initializers.addSimpleListeners();
        Triggers.Initializers.addGlobalListeners();
      });
    }

    $.triggersInitialized = true;
  }

  if (Foundation) {
    Foundation.Triggers = Triggers;
    // Legacy included to be backwards compatible for now.
    Foundation.IHearYou = Triggers.Initializers.addGlobalListeners;
  }
};

exports.Triggers = Triggers;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if ( true ) {
    // AMD - RequireJS
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }

}( typeof window != 'undefined' ? window : this, function() {

"use strict";

function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var i = 0;
  var listener = listeners[i];
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  while ( listener ) {
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
    // get next listener
    i += isOnce ? 0 : 1;
    listener = listeners[i];
  }

  return this;
};

proto.allOff =
proto.removeAllListeners = function() {
  delete this._events;
  delete this._onceEvents;
};

return EvEmitter;

}));


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {

"use strict";

// A method for quickly swapping in/out CSS properties to get correct calculations.
return function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};

}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(20)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( arr ) {
	"use strict";

	return arr.concat;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(20)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( arr ) {
	"use strict";

	return arr.push;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(29)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( hasOwn ) {
	"use strict";

	return hasOwn.toString;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(2)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( document ) {
	"use strict";

	function DOMEval( code, doc ) {
		doc = doc || document;

		var script = doc.createElement( "script" );

		script.text = code;
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}

	return DOMEval;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	"use strict";

	return ( /^margin/ );
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	"use strict";

	return [ "Top", "Right", "Bottom", "Left" ];
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	"use strict";

	return function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(32),
	__webpack_require__(49),
	__webpack_require__(51),
	__webpack_require__(33),
	__webpack_require__(3) // Get jQuery.contains
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, rnumnonpx, rmargin, getStyles, support ) {

"use strict";

function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}

return curCSS;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(30)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, rcssNum ) {

"use strict";

function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}

return adjustCSS;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {

"use strict";

function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}

return addGetHookIf;

}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	"use strict";

	// Match a standalone tag
	return ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(28),
	__webpack_require__(57),
	__webpack_require__(3)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, indexOf, rneedsContext ) {

"use strict";

var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Simple selector that can be filtered directly, removing non-Elements
	if ( risSimple.test( qualifier ) ) {
		return jQuery.filter( qualifier, elements, not );
	}

	// Complex selector, compare the two sets, removing non-Elements
	qualifier = jQuery.filter( qualifier, elements );
	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(3)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	"use strict";

	return jQuery.expr.match.needsContext;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(2),
	__webpack_require__(91),
	__webpack_require__(15)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document ) {

"use strict";

// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(6),
	__webpack_require__(36)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, rnothtmlwhite, acceptData ) {

"use strict";

function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ jQuery.camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ jQuery.camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( jQuery.camelCase );
			} else {
				key = jQuery.camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};

return Data;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(59)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( Data ) {
	"use strict";

	return new Data();
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(3)

	// css is assumed
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	"use strict";

	// isHiddenWithinTree reports if an element has a non-"none" display style (inline and/or
	// through the CSS cascade), which is useful in deciding whether or not to make it visible.
	// It differs from the :hidden selector (jQuery.expr.pseudos.hidden) in two important ways:
	// * A hidden ancestor does not force an element to be classified as hidden.
	// * Being disconnected from the document does not force an element to be classified as hidden.
	// These differences improve the behavior of .toggle() et al. when applied to elements that are
	// detached or contained within hidden ancestors (gh-2404, gh-2863).
	return function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	"use strict";

	return ( /^(?:checkbox|radio)$/i );
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	"use strict";

	return ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	"use strict";

	return ( /^$|\/(?:java|ecma)script/i );
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {

"use strict";

// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

return wrapMap;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(7)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, nodeName ) {

"use strict";

function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}

return getAll;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(5)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( dataPriv ) {

"use strict";

// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}

return setGlobalEval;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(63),
	__webpack_require__(64),
	__webpack_require__(65),
	__webpack_require__(66),
	__webpack_require__(67)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, rtagName, rscriptType, wrapMap, getAll, setGlobalEval ) {

"use strict";

var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}

return buildFragment;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(11),
	__webpack_require__(39),
	__webpack_require__(3)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, access, support ) {

"use strict";

var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	"use strict";

	return jQuery.now();
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	"use strict";

	return ( /\?/ );
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(62),
	__webpack_require__(4),
	__webpack_require__(16), // filter
	__webpack_require__(69)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, rcheckableType ) {

"use strict";

var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = jQuery.isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );

return jQuery;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = undefined;

var _foundationUtil = __webpack_require__(8);

var Box = {
  ImNotTouchingYou: ImNotTouchingYou,
  OverlapArea: OverlapArea,
  GetDimensions: GetDimensions,
  GetOffsets: GetOffsets,
  GetExplicitOffsets: GetExplicitOffsets

  /**
   * Compares the dimensions of an element to a container and determines collision events with container.
   * @function
   * @param {jQuery} element - jQuery object to test for collisions.
   * @param {jQuery} parent - jQuery object to use as bounding container.
   * @param {Boolean} lrOnly - set to true to check left and right values only.
   * @param {Boolean} tbOnly - set to true to check top and bottom values only.
   * @default if no parent object passed, detects collisions with `window`.
   * @returns {Boolean} - true if collision free, false if a collision in any direction.
   */
};function ImNotTouchingYou(element, parent, lrOnly, tbOnly, ignoreBottom) {
  return OverlapArea(element, parent, lrOnly, tbOnly, ignoreBottom) === 0;
};

function OverlapArea(element, parent, lrOnly, tbOnly, ignoreBottom) {
  var eleDims = GetDimensions(element),
      topOver,
      bottomOver,
      leftOver,
      rightOver;
  if (parent) {
    var parDims = GetDimensions(parent);

    bottomOver = parDims.height + parDims.offset.top - (eleDims.offset.top + eleDims.height);
    topOver = eleDims.offset.top - parDims.offset.top;
    leftOver = eleDims.offset.left - parDims.offset.left;
    rightOver = parDims.width + parDims.offset.left - (eleDims.offset.left + eleDims.width);
  } else {
    bottomOver = eleDims.windowDims.height + eleDims.windowDims.offset.top - (eleDims.offset.top + eleDims.height);
    topOver = eleDims.offset.top - eleDims.windowDims.offset.top;
    leftOver = eleDims.offset.left - eleDims.windowDims.offset.left;
    rightOver = eleDims.windowDims.width - (eleDims.offset.left + eleDims.width);
  }

  bottomOver = ignoreBottom ? 0 : Math.min(bottomOver, 0);
  topOver = Math.min(topOver, 0);
  leftOver = Math.min(leftOver, 0);
  rightOver = Math.min(rightOver, 0);

  if (lrOnly) {
    return leftOver + rightOver;
  }
  if (tbOnly) {
    return topOver + bottomOver;
  }

  // use sum of squares b/c we care about overlap area.
  return Math.sqrt(topOver * topOver + bottomOver * bottomOver + leftOver * leftOver + rightOver * rightOver);
}

/**
 * Uses native methods to return an object of dimension values.
 * @function
 * @param {jQuery || HTML} element - jQuery object or DOM element for which to get the dimensions. Can be any element other that document or window.
 * @returns {Object} - nested object of integer pixel values
 * TODO - if element is window, return only those values.
 */
function GetDimensions(elem, test) {
  elem = elem.length ? elem[0] : elem;

  if (elem === window || elem === document) {
    throw new Error("I'm sorry, Dave. I'm afraid I can't do that.");
  }

  var rect = elem.getBoundingClientRect(),
      parRect = elem.parentNode.getBoundingClientRect(),
      winRect = document.body.getBoundingClientRect(),
      winY = window.pageYOffset,
      winX = window.pageXOffset;

  return {
    width: rect.width,
    height: rect.height,
    offset: {
      top: rect.top + winY,
      left: rect.left + winX
    },
    parentDims: {
      width: parRect.width,
      height: parRect.height,
      offset: {
        top: parRect.top + winY,
        left: parRect.left + winX
      }
    },
    windowDims: {
      width: winRect.width,
      height: winRect.height,
      offset: {
        top: winY,
        left: winX
      }
    }
  };
}

/**
 * Returns an object of top and left integer pixel values for dynamically rendered elements,
 * such as: Tooltip, Reveal, and Dropdown. Maintained for backwards compatibility, and where
 * you don't know alignment, but generally from
 * 6.4 forward you should use GetExplicitOffsets, as GetOffsets conflates position and alignment.
 * @function
 * @param {jQuery} element - jQuery object for the element being positioned.
 * @param {jQuery} anchor - jQuery object for the element's anchor point.
 * @param {String} position - a string relating to the desired position of the element, relative to it's anchor
 * @param {Number} vOffset - integer pixel value of desired vertical separation between anchor and element.
 * @param {Number} hOffset - integer pixel value of desired horizontal separation between anchor and element.
 * @param {Boolean} isOverflow - if a collision event is detected, sets to true to default the element to full width - any desired offset.
 * TODO alter/rewrite to work with `em` values as well/instead of pixels
 */
function GetOffsets(element, anchor, position, vOffset, hOffset, isOverflow) {
  console.log("NOTE: GetOffsets is deprecated in favor of GetExplicitOffsets and will be removed in 6.5");
  switch (position) {
    case 'top':
      return (0, _foundationUtil.rtl)() ? GetExplicitOffsets(element, anchor, 'top', 'left', vOffset, hOffset, isOverflow) : GetExplicitOffsets(element, anchor, 'top', 'right', vOffset, hOffset, isOverflow);
    case 'bottom':
      return (0, _foundationUtil.rtl)() ? GetExplicitOffsets(element, anchor, 'bottom', 'left', vOffset, hOffset, isOverflow) : GetExplicitOffsets(element, anchor, 'bottom', 'right', vOffset, hOffset, isOverflow);
    case 'center top':
      return GetExplicitOffsets(element, anchor, 'top', 'center', vOffset, hOffset, isOverflow);
    case 'center bottom':
      return GetExplicitOffsets(element, anchor, 'bottom', 'center', vOffset, hOffset, isOverflow);
    case 'center left':
      return GetExplicitOffsets(element, anchor, 'left', 'center', vOffset, hOffset, isOverflow);
    case 'center right':
      return GetExplicitOffsets(element, anchor, 'right', 'center', vOffset, hOffset, isOverflow);
    case 'left bottom':
      return GetExplicitOffsets(element, anchor, 'bottom', 'left', vOffset, hOffset, isOverflow);
    case 'right bottom':
      return GetExplicitOffsets(element, anchor, 'bottom', 'right', vOffset, hOffset, isOverflow);
    // Backwards compatibility... this along with the reveal and reveal full
    // classes are the only ones that didn't reference anchor
    case 'center':
      return {
        left: $eleDims.windowDims.offset.left + $eleDims.windowDims.width / 2 - $eleDims.width / 2 + hOffset,
        top: $eleDims.windowDims.offset.top + $eleDims.windowDims.height / 2 - ($eleDims.height / 2 + vOffset)
      };
    case 'reveal':
      return {
        left: ($eleDims.windowDims.width - $eleDims.width) / 2 + hOffset,
        top: $eleDims.windowDims.offset.top + vOffset
      };
    case 'reveal full':
      return {
        left: $eleDims.windowDims.offset.left,
        top: $eleDims.windowDims.offset.top
      };
      break;
    default:
      return {
        left: (0, _foundationUtil.rtl)() ? $anchorDims.offset.left - $eleDims.width + $anchorDims.width - hOffset : $anchorDims.offset.left + hOffset,
        top: $anchorDims.offset.top + $anchorDims.height + vOffset
      };

  }
}

function GetExplicitOffsets(element, anchor, position, alignment, vOffset, hOffset, isOverflow) {
  var $eleDims = GetDimensions(element),
      $anchorDims = anchor ? GetDimensions(anchor) : null;

  var topVal, leftVal;

  // set position related attribute

  switch (position) {
    case 'top':
      topVal = $anchorDims.offset.top - ($eleDims.height + vOffset);
      break;
    case 'bottom':
      topVal = $anchorDims.offset.top + $anchorDims.height + vOffset;
      break;
    case 'left':
      leftVal = $anchorDims.offset.left - ($eleDims.width + hOffset);
      break;
    case 'right':
      leftVal = $anchorDims.offset.left + $anchorDims.width + hOffset;
      break;
  }

  // set alignment related attribute
  switch (position) {
    case 'top':
    case 'bottom':
      switch (alignment) {
        case 'left':
          leftVal = $anchorDims.offset.left + hOffset;
          break;
        case 'right':
          leftVal = $anchorDims.offset.left - $eleDims.width + $anchorDims.width - hOffset;
          break;
        case 'center':
          leftVal = isOverflow ? hOffset : $anchorDims.offset.left + $anchorDims.width / 2 - $eleDims.width / 2 + hOffset;
          break;
      }
      break;
    case 'right':
    case 'left':
      switch (alignment) {
        case 'bottom':
          topVal = $anchorDims.offset.top - vOffset + $anchorDims.height - $eleDims.height;
          break;
        case 'top':
          topVal = $anchorDims.offset.top + vOffset;
          break;
        case 'center':
          topVal = $anchorDims.offset.top + vOffset + $anchorDims.height / 2 - $eleDims.height / 2;
          break;
      }
      break;
  }
  return { top: topVal, left: leftVal };
}

exports.Box = Box;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Default set of media queries
var defaultQueries = {
  'default': 'only screen',
  landscape: 'only screen and (orientation: landscape)',
  portrait: 'only screen and (orientation: portrait)',
  retina: 'only screen and (-webkit-min-device-pixel-ratio: 2),' + 'only screen and (min--moz-device-pixel-ratio: 2),' + 'only screen and (-o-min-device-pixel-ratio: 2/1),' + 'only screen and (min-device-pixel-ratio: 2),' + 'only screen and (min-resolution: 192dpi),' + 'only screen and (min-resolution: 2dppx)'
};

// matchMedia() polyfill - Test a CSS media type/query in JS.
// Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. Dual MIT/BSD license
var matchMedia = window.matchMedia || function () {
  'use strict';

  // For browsers that support matchMedium api such as IE 9 and webkit

  var styleMedia = window.styleMedia || window.media;

  // For those that don't support matchMedium
  if (!styleMedia) {
    var style = document.createElement('style'),
        script = document.getElementsByTagName('script')[0],
        info = null;

    style.type = 'text/css';
    style.id = 'matchmediajs-test';

    script && script.parentNode && script.parentNode.insertBefore(style, script);

    // 'style.currentStyle' is used by IE <= 8 and 'window.getComputedStyle' for all other browsers
    info = 'getComputedStyle' in window && window.getComputedStyle(style, null) || style.currentStyle;

    styleMedia = {
      matchMedium: function matchMedium(media) {
        var text = '@media ' + media + '{ #matchmediajs-test { width: 1px; } }';

        // 'style.styleSheet' is used by IE <= 8 and 'style.textContent' for all other browsers
        if (style.styleSheet) {
          style.styleSheet.cssText = text;
        } else {
          style.textContent = text;
        }

        // Test if media query is true or false
        return info.width === '1px';
      }
    };
  }

  return function (media) {
    return {
      matches: styleMedia.matchMedium(media || 'all'),
      media: media || 'all'
    };
  };
}();

var MediaQuery = {
  queries: [],

  current: '',

  /**
   * Initializes the media query helper, by extracting the breakpoint list from the CSS and activating the breakpoint watcher.
   * @function
   * @private
   */
  _init: function _init() {
    var self = this;
    var $meta = (0, _jquery2.default)('meta.foundation-mq');
    if (!$meta.length) {
      (0, _jquery2.default)('<meta class="foundation-mq">').appendTo(document.head);
    }

    var extractedStyles = (0, _jquery2.default)('.foundation-mq').css('font-family');
    var namedQueries;

    namedQueries = parseStyleToObject(extractedStyles);

    for (var key in namedQueries) {
      if (namedQueries.hasOwnProperty(key)) {
        self.queries.push({
          name: key,
          value: 'only screen and (min-width: ' + namedQueries[key] + ')'
        });
      }
    }

    this.current = this._getCurrentSize();

    this._watcher();
  },


  /**
   * Checks if the screen is at least as wide as a breakpoint.
   * @function
   * @param {String} size - Name of the breakpoint to check.
   * @returns {Boolean} `true` if the breakpoint matches, `false` if it's smaller.
   */
  atLeast: function atLeast(size) {
    var query = this.get(size);

    if (query) {
      return matchMedia(query).matches;
    }

    return false;
  },


  /**
   * Checks if the screen matches to a breakpoint.
   * @function
   * @param {String} size - Name of the breakpoint to check, either 'small only' or 'small'. Omitting 'only' falls back to using atLeast() method.
   * @returns {Boolean} `true` if the breakpoint matches, `false` if it does not.
   */
  is: function is(size) {
    size = size.trim().split(' ');
    if (size.length > 1 && size[1] === 'only') {
      if (size[0] === this._getCurrentSize()) return true;
    } else {
      return this.atLeast(size[0]);
    }
    return false;
  },


  /**
   * Gets the media query of a breakpoint.
   * @function
   * @param {String} size - Name of the breakpoint to get.
   * @returns {String|null} - The media query of the breakpoint, or `null` if the breakpoint doesn't exist.
   */
  get: function get(size) {
    for (var i in this.queries) {
      if (this.queries.hasOwnProperty(i)) {
        var query = this.queries[i];
        if (size === query.name) return query.value;
      }
    }

    return null;
  },


  /**
   * Gets the current breakpoint name by testing every breakpoint and returning the last one to match (the biggest one).
   * @function
   * @private
   * @returns {String} Name of the current breakpoint.
   */
  _getCurrentSize: function _getCurrentSize() {
    var matched;

    for (var i = 0; i < this.queries.length; i++) {
      var query = this.queries[i];

      if (matchMedia(query.value).matches) {
        matched = query;
      }
    }

    if ((typeof matched === 'undefined' ? 'undefined' : _typeof(matched)) === 'object') {
      return matched.name;
    } else {
      return matched;
    }
  },


  /**
   * Activates the breakpoint watcher, which fires an event on the window whenever the breakpoint changes.
   * @function
   * @private
   */
  _watcher: function _watcher() {
    var _this = this;

    (0, _jquery2.default)(window).off('resize.zf.mediaquery').on('resize.zf.mediaquery', function () {
      var newSize = _this._getCurrentSize(),
          currentSize = _this.current;

      if (newSize !== currentSize) {
        // Change the current media query
        _this.current = newSize;

        // Broadcast the media query change on the window
        (0, _jquery2.default)(window).trigger('changed.zf.mediaquery', [newSize, currentSize]);
      }
    });
  }
};

// Thank you: https://github.com/sindresorhus/query-string
function parseStyleToObject(str) {
  var styleObject = {};

  if (typeof str !== 'string') {
    return styleObject;
  }

  str = str.trim().slice(1, -1); // browsers re-quote string style values

  if (!str) {
    return styleObject;
  }

  styleObject = str.split('&').reduce(function (ret, param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = parts[0];
    var val = parts[1];
    key = decodeURIComponent(key);

    // missing `=` should be `null`:
    // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
    val = val === undefined ? null : decodeURIComponent(val);

    if (!ret.hasOwnProperty(key)) {
      ret[key] = val;
    } else if (Array.isArray(ret[key])) {
      ret[key].push(val);
    } else {
      ret[key] = [ret[key], val];
    }
    return ret;
  }, {});

  return styleObject;
}

exports.MediaQuery = MediaQuery;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*******************************************
 *                                         *
 * This util was created by Marius Olbertz *
 * Please thank Marius on GitHub /owlbertz *
 * or the web http://www.mariusolbertz.de/ *
 *                                         *
 ******************************************/



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Keyboard = undefined;

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _foundationUtil = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var keyCodes = {
  9: 'TAB',
  13: 'ENTER',
  27: 'ESCAPE',
  32: 'SPACE',
  35: 'END',
  36: 'HOME',
  37: 'ARROW_LEFT',
  38: 'ARROW_UP',
  39: 'ARROW_RIGHT',
  40: 'ARROW_DOWN'
};

var commands = {};

// Functions pulled out to be referenceable from internals
function findFocusable($element) {
  if (!$element) {
    return false;
  }
  return $element.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]').filter(function () {
    if (!(0, _jquery2.default)(this).is(':visible') || (0, _jquery2.default)(this).attr('tabindex') < 0) {
      return false;
    } //only have visible elements and those that have a tabindex greater or equal 0
    return true;
  });
}

function parseKey(event) {
  var key = keyCodes[event.which || event.keyCode] || String.fromCharCode(event.which).toUpperCase();

  // Remove un-printable characters, e.g. for `fromCharCode` calls for CTRL only events
  key = key.replace(/\W+/, '');

  if (event.shiftKey) key = 'SHIFT_' + key;
  if (event.ctrlKey) key = 'CTRL_' + key;
  if (event.altKey) key = 'ALT_' + key;

  // Remove trailing underscore, in case only modifiers were used (e.g. only `CTRL_ALT`)
  key = key.replace(/_$/, '');

  return key;
}

var Keyboard = {
  keys: getKeyCodes(keyCodes),

  /**
   * Parses the (keyboard) event and returns a String that represents its key
   * Can be used like Foundation.parseKey(event) === Foundation.keys.SPACE
   * @param {Event} event - the event generated by the event handler
   * @return String key - String that represents the key pressed
   */
  parseKey: parseKey,

  /**
   * Handles the given (keyboard) event
   * @param {Event} event - the event generated by the event handler
   * @param {String} component - Foundation component's name, e.g. Slider or Reveal
   * @param {Objects} functions - collection of functions that are to be executed
   */
  handleKey: function handleKey(event, component, functions) {
    var commandList = commands[component],
        keyCode = this.parseKey(event),
        cmds,
        command,
        fn;

    if (!commandList) return console.warn('Component not defined!');

    if (typeof commandList.ltr === 'undefined') {
      // this component does not differentiate between ltr and rtl
      cmds = commandList; // use plain list
    } else {
      // merge ltr and rtl: if document is rtl, rtl overwrites ltr and vice versa
      if ((0, _foundationUtil.rtl)()) cmds = _jquery2.default.extend({}, commandList.ltr, commandList.rtl);else cmds = _jquery2.default.extend({}, commandList.rtl, commandList.ltr);
    }
    command = cmds[keyCode];

    fn = functions[command];
    if (fn && typeof fn === 'function') {
      // execute function  if exists
      var returnValue = fn.apply();
      if (functions.handled || typeof functions.handled === 'function') {
        // execute function when event was handled
        functions.handled(returnValue);
      }
    } else {
      if (functions.unhandled || typeof functions.unhandled === 'function') {
        // execute function when event was not handled
        functions.unhandled();
      }
    }
  },


  /**
   * Finds all focusable elements within the given `$element`
   * @param {jQuery} $element - jQuery object to search within
   * @return {jQuery} $focusable - all focusable elements within `$element`
   */

  findFocusable: findFocusable,

  /**
   * Returns the component name name
   * @param {Object} component - Foundation component, e.g. Slider or Reveal
   * @return String componentName
   */

  register: function register(componentName, cmds) {
    commands[componentName] = cmds;
  },


  // TODO9438: These references to Keyboard need to not require global. Will 'this' work in this context?
  //
  /**
   * Traps the focus in the given element.
   * @param  {jQuery} $element  jQuery object to trap the foucs into.
   */
  trapFocus: function trapFocus($element) {
    var $focusable = findFocusable($element),
        $firstFocusable = $focusable.eq(0),
        $lastFocusable = $focusable.eq(-1);

    $element.on('keydown.zf.trapfocus', function (event) {
      if (event.target === $lastFocusable[0] && parseKey(event) === 'TAB') {
        event.preventDefault();
        $firstFocusable.focus();
      } else if (event.target === $firstFocusable[0] && parseKey(event) === 'SHIFT_TAB') {
        event.preventDefault();
        $lastFocusable.focus();
      }
    });
  },

  /**
   * Releases the trapped focus from the given element.
   * @param  {jQuery} $element  jQuery object to release the focus for.
   */
  releaseFocus: function releaseFocus($element) {
    $element.off('keydown.zf.trapfocus');
  }
};

/*
 * Constants for easier comparing.
 * Can be used like Foundation.parseKey(event) === Foundation.keys.SPACE
 */
function getKeyCodes(kcs) {
  var k = {};
  for (var kc in kcs) {
    k[kcs[kc]] = kcs[kc];
  }return k;
}

exports.Keyboard = Keyboard;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Positionable = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _foundationUtil = __webpack_require__(73);

var _foundation = __webpack_require__(133);

var _foundationUtil2 = __webpack_require__(8);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var POSITIONS = ['left', 'right', 'top', 'bottom'];
var VERTICAL_ALIGNMENTS = ['top', 'bottom', 'center'];
var HORIZONTAL_ALIGNMENTS = ['left', 'right', 'center'];

var ALIGNMENTS = {
  'left': VERTICAL_ALIGNMENTS,
  'right': VERTICAL_ALIGNMENTS,
  'top': HORIZONTAL_ALIGNMENTS,
  'bottom': HORIZONTAL_ALIGNMENTS
};

function nextItem(item, array) {
  var currentIdx = array.indexOf(item);
  if (currentIdx === array.length - 1) {
    return array[0];
  } else {
    return array[currentIdx + 1];
  }
}

var Positionable = function (_Plugin) {
  _inherits(Positionable, _Plugin);

  function Positionable() {
    _classCallCheck(this, Positionable);

    return _possibleConstructorReturn(this, (Positionable.__proto__ || Object.getPrototypeOf(Positionable)).apply(this, arguments));
  }

  _createClass(Positionable, [{
    key: '_init',

    /**
     * Abstract class encapsulating the tether-like explicit positioning logic
     * including repositioning based on overlap.
     * Expects classes to define defaults for vOffset, hOffset, position,
     * alignment, allowOverlap, and allowBottomOverlap. They can do this by
     * extending the defaults, or (for now recommended due to the way docs are
     * generated) by explicitly declaring them.
     *
     **/

    value: function _init() {
      this.triedPositions = {};
      this.position = this.options.position === 'auto' ? this._getDefaultPosition() : this.options.position;
      this.alignment = this.options.alignment === 'auto' ? this._getDefaultAlignment() : this.options.alignment;
    }
  }, {
    key: '_getDefaultPosition',
    value: function _getDefaultPosition() {
      return 'bottom';
    }
  }, {
    key: '_getDefaultAlignment',
    value: function _getDefaultAlignment() {
      switch (this.position) {
        case 'bottom':
        case 'top':
          return (0, _foundationUtil2.rtl)() ? 'right' : 'left';
        case 'left':
        case 'right':
          return 'bottom';
      }
    }

    /**
     * Adjusts the positionable possible positions by iterating through alignments
     * and positions.
     * @function
     * @private
     */

  }, {
    key: '_reposition',
    value: function _reposition() {
      if (this._alignmentsExhausted(this.position)) {
        this.position = nextItem(this.position, POSITIONS);
        this.alignment = ALIGNMENTS[this.position][0];
      } else {
        this._realign();
      }
    }

    /**
     * Adjusts the dropdown pane possible positions by iterating through alignments
     * on the current position.
     * @function
     * @private
     */

  }, {
    key: '_realign',
    value: function _realign() {
      this._addTriedPosition(this.position, this.alignment);
      this.alignment = nextItem(this.alignment, ALIGNMENTS[this.position]);
    }
  }, {
    key: '_addTriedPosition',
    value: function _addTriedPosition(position, alignment) {
      this.triedPositions[position] = this.triedPositions[position] || [];
      this.triedPositions[position].push(alignment);
    }
  }, {
    key: '_positionsExhausted',
    value: function _positionsExhausted() {
      var isExhausted = true;
      for (var i = 0; i < POSITIONS.length; i++) {
        isExhausted = isExhausted && this._alignmentsExhausted(POSITIONS[i]);
      }
      return isExhausted;
    }
  }, {
    key: '_alignmentsExhausted',
    value: function _alignmentsExhausted(position) {
      return this.triedPositions[position] && this.triedPositions[position].length == ALIGNMENTS[position].length;
    }

    // When we're trying to center, we don't want to apply offset that's going to
    // take us just off center, so wrap around to return 0 for the appropriate
    // offset in those alignments.  TODO: Figure out if we want to make this
    // configurable behavior... it feels more intuitive, especially for tooltips, but
    // it's possible someone might actually want to start from center and then nudge
    // slightly off.

  }, {
    key: '_getVOffset',
    value: function _getVOffset() {
      return this.options.vOffset;
    }
  }, {
    key: '_getHOffset',
    value: function _getHOffset() {
      return this.options.hOffset;
    }
  }, {
    key: '_setPosition',
    value: function _setPosition($anchor, $element, $parent) {
      if ($anchor.attr('aria-expanded') === 'false') {
        return false;
      }
      var $eleDims = _foundationUtil.Box.GetDimensions($element),
          $anchorDims = _foundationUtil.Box.GetDimensions($anchor);

      $element.offset(_foundationUtil.Box.GetExplicitOffsets($element, $anchor, this.position, this.alignment, this._getVOffset(), this._getHOffset()));

      if (!this.options.allowOverlap) {
        var overlaps = {};
        var minOverlap = 100000000;
        // default coordinates to how we start, in case we can't figure out better
        var minCoordinates = { position: this.position, alignment: this.alignment };
        while (!this._positionsExhausted()) {
          var overlap = _foundationUtil.Box.OverlapArea($element, $parent, false, false, this.options.allowBottomOverlap);
          if (overlap === 0) {
            return;
          }

          if (overlap < minOverlap) {
            minOverlap = overlap;
            minCoordinates = { position: this.position, alignment: this.alignment };
          }

          this._reposition();

          $element.offset(_foundationUtil.Box.GetExplicitOffsets($element, $anchor, this.position, this.alignment, this._getVOffset(), this._getHOffset()));
        }
        // If we get through the entire loop, there was no non-overlapping
        // position available. Pick the version with least overlap.
        this.position = minCoordinates.position;
        this.alignment = minCoordinates.alignment;
        $element.offset(_foundationUtil.Box.GetExplicitOffsets($element, $anchor, this.position, this.alignment, this._getVOffset(), this._getHOffset()));
      }
    }
  }]);

  return Positionable;
}(_foundation.Plugin);

Positionable.defaults = {
  /**
   * Position of positionable relative to anchor. Can be left, right, bottom, top, or auto.
   * @option
   * @type {string}
   * @default 'auto'
   */
  position: 'auto',
  /**
   * Alignment of positionable relative to anchor. Can be left, right, bottom, top, center, or auto.
   * @option
   * @type {string}
   * @default 'auto'
   */
  alignment: 'auto',
  /**
   * Allow overlap of container/window. If false, dropdown positionable first
   * try to position as defined by data-position and data-alignment, but
   * reposition if it would cause an overflow.
   * @option
   * @type {boolean}
   * @default false
   */
  allowOverlap: false,
  /**
   * Allow overlap of only the bottom of the container. This is the most common
   * behavior for dropdowns, allowing the dropdown to extend the bottom of the
   * screen but not otherwise influence or break out of the container.
   * @option
   * @type {boolean}
   * @default true
   */
  allowBottomOverlap: true,
  /**
   * Number of pixels the positionable should be separated vertically from anchor
   * @option
   * @type {number}
   * @default 0
   */
  vOffset: 0,
  /**
   * Number of pixels the positionable should be separated horizontally from anchor
   * @option
   * @type {number}
   * @default 0
   */
  hOffset: 0
};

exports.Positionable = Positionable;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = readCookie;
/**
 * @param  {String} name Name of the cookie to read
 * @return {Any} value
 */
function readCookie(name) {
  var cookies = document.cookie.split(/;\s*/);
  var value = false;

  cookies.forEach(function (cookie) {
    if (!cookie.indexOf(name + '=')) {
      value = cookie.replace(name + '=', '');
    }
  });

  return value;
}

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initRangeSliders;

var _nouislider = __webpack_require__(146);

var _nouislider2 = _interopRequireDefault(_nouislider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param  {HTMLElement} slider e slider to manipulate
 * @param  {Number} i index
 * @param  {Number} value slider value to set
 * @return {void}
 */
function setSliderHandle(slider, i, value) {
  var r = [null, null];
  r[i] = value;
  slider.noUiSlider.set(r);
}

/**
 * @param  {HTMLElement} slider slider element
 * @return {Boolean} true
 */
function createRangeSlider(slider) {
  var parent = slider.parentElement;
  var inputMin = parent.querySelector('[data-min-input]');
  var inputMax = parent.querySelector('[data-max-input]');
  var inputs = [inputMin, inputMax];

  if (inputMin === null || inputMax === null) return false;

  _nouislider2.default.create(slider, {
    start: [parseInt(inputMin.value, 10), parseInt(inputMax.value, 10)],
    step: parseInt(inputMin.step, 10),
    margin: parseInt(inputMin.step, 10),
    range: {
      min: parseInt(inputMin.min, 10),
      max: parseInt(inputMin.max, 10)
    }
  });

  slider.noUiSlider.on('update', function (values, handle) {
    var input = inputs[handle];

    // Make sure the updated value is an integer
    input.value = values[handle].split('.')[0];

    var inputNameTokens = input.name.split('_');

    // Is this is a filter range slider?
    if (inputNameTokens.length === 3 && inputNameTokens[0] === 'f' && (inputNameTokens[2] === 'min' || inputNameTokens[2] === 'max')) {
      // Is there a matching filter-active flag input field?
      var filterActiveName = 'f_' + inputNameTokens[1] + '_active';
      var filterActiveFlag = document.querySelector('[name="' + filterActiveName + '"]');

      // We only need to check min/max to adjust the active flag
      // if we really have one and if it was not set to "1" in the first place
      if (filterActiveFlag != null && filterActiveFlag.dataset.initialValue === '0') {
        // Check if the integer value of the min and/or max input field was changed
        // compared to the initial value of the input field.
        // We need both input fields. We assume we're currently on "min" first
        var otherInputName = 'f_' + inputNameTokens[1] + '_max';
        if (inputNameTokens[2] === 'max') {
          // No, we're on max
          otherInputName = 'f_' + inputNameTokens[1] + '_min';
        }
        var otherInput = document.querySelector('[name="' + otherInputName + '"]');

        if (otherInput != null) {
          // Check if at least one of the range filter values were changed by the user
          if (input.value !== input.dataset.initialValue || otherInput.value !== otherInput.dataset.initialValue) {
            filterActiveFlag.value = 1;
          } else {
            filterActiveFlag.value = 0;
          }
        }
      }
    }
  });

  // Listen to keydown events on the input field.
  inputs.forEach(function (input, handle) {
    input.addEventListener('change', function (event) {
      setSliderHandle(slider, handle, event.target.value);
    });
  });

  return true;
}

/**
 * @param  {HTMLElement} scope = document
 * @return {void}
 */
function initRangeSliders() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  var rangeSlider = [].slice.call(scope.querySelectorAll('[data-range-slider]'));

  if (rangeSlider !== null) {
    rangeSlider.forEach(function (slider) {
      createRangeSlider(slider);
    });
  }
}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * getSize v2.0.2
 * measure size of elements
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */
/*global define: false, module: false, console: false */

( function( window, factory ) {
  'use strict';

  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return factory();
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.getSize = factory();
  }

})( window, function factory() {
'use strict';

// -------------------------- helpers -------------------------- //

// get a number from a string, not a percentage
function getStyleSize( value ) {
  var num = parseFloat( value );
  // not a percent like '100%', and a number
  var isValid = value.indexOf('%') == -1 && !isNaN( num );
  return isValid && num;
}

function noop() {}

var logError = typeof console == 'undefined' ? noop :
  function( message ) {
    console.error( message );
  };

// -------------------------- measurements -------------------------- //

var measurements = [
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
  'borderLeftWidth',
  'borderRightWidth',
  'borderTopWidth',
  'borderBottomWidth'
];

var measurementsLength = measurements.length;

function getZeroSize() {
  var size = {
    width: 0,
    height: 0,
    innerWidth: 0,
    innerHeight: 0,
    outerWidth: 0,
    outerHeight: 0
  };
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    size[ measurement ] = 0;
  }
  return size;
}

// -------------------------- getStyle -------------------------- //

/**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */
function getStyle( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    logError( 'Style returned ' + style +
      '. Are you running this code in a hidden iframe on Firefox? ' +
      'See http://bit.ly/getsizebug1' );
  }
  return style;
}

// -------------------------- setup -------------------------- //

var isSetup = false;

var isBoxSizeOuter;

/**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */
function setup() {
  // setup once
  if ( isSetup ) {
    return;
  }
  isSetup = true;

  // -------------------------- box sizing -------------------------- //

  /**
   * WebKit measures the outer-width on style.width on border-box elems
   * IE & Firefox<29 measures the inner-width
   */
  var div = document.createElement('div');
  div.style.width = '200px';
  div.style.padding = '1px 2px 3px 4px';
  div.style.borderStyle = 'solid';
  div.style.borderWidth = '1px 2px 3px 4px';
  div.style.boxSizing = 'border-box';

  var body = document.body || document.documentElement;
  body.appendChild( div );
  var style = getStyle( div );

  getSize.isBoxSizeOuter = isBoxSizeOuter = getStyleSize( style.width ) == 200;
  body.removeChild( div );

}

// -------------------------- getSize -------------------------- //

function getSize( elem ) {
  setup();

  // use querySeletor if elem is string
  if ( typeof elem == 'string' ) {
    elem = document.querySelector( elem );
  }

  // do not proceed on non-objects
  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
    return;
  }

  var style = getStyle( elem );

  // if hidden, everything is 0
  if ( style.display == 'none' ) {
    return getZeroSize();
  }

  var size = {};
  size.width = elem.offsetWidth;
  size.height = elem.offsetHeight;

  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

  // get all measurements
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    var value = style[ measurement ];
    var num = parseFloat( value );
    // any 'auto', 'medium' value will be 0
    size[ measurement ] = !isNaN( num ) ? num : 0;
  }

  var paddingWidth = size.paddingLeft + size.paddingRight;
  var paddingHeight = size.paddingTop + size.paddingBottom;
  var marginWidth = size.marginLeft + size.marginRight;
  var marginHeight = size.marginTop + size.marginBottom;
  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
  var borderHeight = size.borderTopWidth + size.borderBottomWidth;

  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

  // overwrite width and height if we can get it from style
  var styleWidth = getStyleSize( style.width );
  if ( styleWidth !== false ) {
    size.width = styleWidth +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
  }

  var styleHeight = getStyleSize( style.height );
  if ( styleHeight !== false ) {
    size.height = styleHeight +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
  }

  size.innerWidth = size.width - ( paddingWidth + borderWidth );
  size.innerHeight = size.height - ( paddingHeight + borderHeight );

  size.outerWidth = size.width + marginWidth;
  size.outerHeight = size.height + marginHeight;

  return size;
}

return getSize;

});


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Unipointer v2.2.0
 * base class for doing one thing with pointer event
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*global define, module, require */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(43)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter ) {
      return factory( window, EvEmitter );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('ev-emitter')
    );
  } else {
    // browser global
    window.Unipointer = factory(
      window,
      window.EvEmitter
    );
  }

}( window, function factory( window, EvEmitter ) {

'use strict';

function noop() {}

function Unipointer() {}

// inherit EvEmitter
var proto = Unipointer.prototype = Object.create( EvEmitter.prototype );

proto.bindStartEvent = function( elem ) {
  this._bindStartEvent( elem, true );
};

proto.unbindStartEvent = function( elem ) {
  this._bindStartEvent( elem, false );
};

/**
 * works as unbinder, as you can ._bindStart( false ) to unbind
 * @param {Boolean} isBind - will unbind if falsey
 */
proto._bindStartEvent = function( elem, isBind ) {
  // munge isBind, default to true
  isBind = isBind === undefined ? true : !!isBind;
  var bindMethod = isBind ? 'addEventListener' : 'removeEventListener';

  if ( window.PointerEvent ) {
    // Pointer Events. Chrome 55, IE11, Edge 14
    elem[ bindMethod ]( 'pointerdown', this );
  } else {
    // listen for both, for devices like Chrome Pixel
    elem[ bindMethod ]( 'mousedown', this );
    elem[ bindMethod ]( 'touchstart', this );
  }
};

// trigger handler methods for events
proto.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// returns the touch that we're keeping track of
proto.getTouch = function( touches ) {
  for ( var i=0; i < touches.length; i++ ) {
    var touch = touches[i];
    if ( touch.identifier == this.pointerIdentifier ) {
      return touch;
    }
  }
};

// ----- start event ----- //

proto.onmousedown = function( event ) {
  // dismiss clicks from right or middle buttons
  var button = event.button;
  if ( button && ( button !== 0 && button !== 1 ) ) {
    return;
  }
  this._pointerDown( event, event );
};

proto.ontouchstart = function( event ) {
  this._pointerDown( event, event.changedTouches[0] );
};

proto.onpointerdown = function( event ) {
  this._pointerDown( event, event );
};

/**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto._pointerDown = function( event, pointer ) {
  // dismiss other pointers
  if ( this.isPointerDown ) {
    return;
  }

  this.isPointerDown = true;
  // save pointer identifier to match up touch events
  this.pointerIdentifier = pointer.pointerId !== undefined ?
    // pointerId for pointer events, touch.indentifier for touch events
    pointer.pointerId : pointer.identifier;

  this.pointerDown( event, pointer );
};

proto.pointerDown = function( event, pointer ) {
  this._bindPostStartEvents( event );
  this.emitEvent( 'pointerDown', [ event, pointer ] );
};

// hash of events to be bound after start event
var postStartEvents = {
  mousedown: [ 'mousemove', 'mouseup' ],
  touchstart: [ 'touchmove', 'touchend', 'touchcancel' ],
  pointerdown: [ 'pointermove', 'pointerup', 'pointercancel' ],
};

proto._bindPostStartEvents = function( event ) {
  if ( !event ) {
    return;
  }
  // get proper events to match start event
  var events = postStartEvents[ event.type ];
  // bind events to node
  events.forEach( function( eventName ) {
    window.addEventListener( eventName, this );
  }, this );
  // save these arguments
  this._boundPointerEvents = events;
};

proto._unbindPostStartEvents = function() {
  // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
  if ( !this._boundPointerEvents ) {
    return;
  }
  this._boundPointerEvents.forEach( function( eventName ) {
    window.removeEventListener( eventName, this );
  }, this );

  delete this._boundPointerEvents;
};

// ----- move event ----- //

proto.onmousemove = function( event ) {
  this._pointerMove( event, event );
};

proto.onpointermove = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerMove( event, event );
  }
};

proto.ontouchmove = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerMove( event, touch );
  }
};

/**
 * pointer move
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerMove = function( event, pointer ) {
  this.pointerMove( event, pointer );
};

// public
proto.pointerMove = function( event, pointer ) {
  this.emitEvent( 'pointerMove', [ event, pointer ] );
};

// ----- end event ----- //


proto.onmouseup = function( event ) {
  this._pointerUp( event, event );
};

proto.onpointerup = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerUp( event, event );
  }
};

proto.ontouchend = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerUp( event, touch );
  }
};

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerUp = function( event, pointer ) {
  this._pointerDone();
  this.pointerUp( event, pointer );
};

// public
proto.pointerUp = function( event, pointer ) {
  this.emitEvent( 'pointerUp', [ event, pointer ] );
};

// ----- pointer done ----- //

// triggered on pointer up & pointer cancel
proto._pointerDone = function() {
  // reset properties
  this.isPointerDown = false;
  delete this.pointerIdentifier;
  // remove events
  this._unbindPostStartEvents();
  this.pointerDone();
};

proto.pointerDone = noop;

// ----- pointer cancel ----- //

proto.onpointercancel = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerCancel( event, event );
  }
};

proto.ontouchcancel = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerCancel( event, touch );
  }
};

/**
 * pointer cancel
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerCancel = function( event, pointer ) {
  this._pointerDone();
  this.pointerCancel( event, pointer );
};

// public
proto.pointerCancel = function( event, pointer ) {
  this.emitEvent( 'pointerCancel', [ event, pointer ] );
};

// -----  ----- //

// utility function for getting x/y coords from event
Unipointer.getPointerPoint = function( pointer ) {
  return {
    x: pointer.pageX,
    y: pointer.pageY
  };
};

// -----  ----- //

return Unipointer;

}));


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Tap listener v2.0.0
 * listens to taps
 * MIT license
 */

/*jshint browser: true, unused: true, undef: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false*/ /*globals define, module, require */

  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(80)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Unipointer ) {
      return factory( window, Unipointer );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('unipointer')
    );
  } else {
    // browser global
    window.TapListener = factory(
      window,
      window.Unipointer
    );
  }

}( window, function factory( window, Unipointer ) {

'use strict';

// --------------------------  TapListener -------------------------- //

function TapListener( elem ) {
  this.bindTap( elem );
}

// inherit Unipointer & EventEmitter
var proto = TapListener.prototype = Object.create( Unipointer.prototype );

/**
 * bind tap event to element
 * @param {Element} elem
 */
proto.bindTap = function( elem ) {
  if ( !elem ) {
    return;
  }
  this.unbindTap();
  this.tapElement = elem;
  this._bindStartEvent( elem, true );
};

proto.unbindTap = function() {
  if ( !this.tapElement ) {
    return;
  }
  this._bindStartEvent( this.tapElement, true );
  delete this.tapElement;
};

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerUp = function( event, pointer ) {
  // ignore emulated mouse up clicks
  if ( this.isIgnoringMouseUp && event.type == 'mouseup' ) {
    return;
  }

  var pointerPoint = Unipointer.getPointerPoint( pointer );
  var boundingRect = this.tapElement.getBoundingClientRect();
  var scrollX = window.pageXOffset;
  var scrollY = window.pageYOffset;
  // calculate if pointer is inside tapElement
  var isInside = pointerPoint.x >= boundingRect.left + scrollX &&
    pointerPoint.x <= boundingRect.right + scrollX &&
    pointerPoint.y >= boundingRect.top + scrollY &&
    pointerPoint.y <= boundingRect.bottom + scrollY;
  // trigger callback if pointer is inside element
  if ( isInside ) {
    this.emitEvent( 'tap', [ event, pointer ] );
  }

  // set flag for emulated clicks 300ms after touchend
  if ( event.type != 'mouseup' ) {
    this.isIgnoringMouseUp = true;
    // reset flag after 300ms
    var _this = this;
    setTimeout( function() {
      delete _this.isIgnoringMouseUp;
    }, 400 );
  }
};

proto.destroy = function() {
  this.pointerDone();
  this.unbindTap();
};

// -----  ----- //

return TapListener;

}));


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = manageSearchResultCategories;

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _twt = __webpack_require__(13);

var TWTmediaQuery = _interopRequireWildcard(_twt);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// scroll page to container top
/* eslint-disable */
function scrollNavCategories(container) {
  // scroll to element position
  (0, _jquery2.default)('html, body').animate({
    scrollTop: (0, _jquery2.default)(container).offset().top
  }, 400);
}

// collapse container
function collapseContainer(target) {
  var $this = (0, _jquery2.default)(target);
  var objData = $this.data();
  var $elPreviousContainer = $this.prev();

  if (!objData.hasOwnProperty('state') || objData.state === 'opened') {
    $elPreviousContainer.animate({ 'height': objData.intMinHeight }, 400);
    $this.find('.btn__text').text(objData.buttonTextClose);
    $this.data('state', 'closed');
  } else {
    $elPreviousContainer.animate({ 'height': objData.intMaxHeight }, 400);
    $this.find('.btn__text').text(objData.buttonTextOpen);
    $this.data('state', 'opened');
  }

  $this.addClass('js-collapse');

  $this.toggleClass('less');
}

function manageSearchResultCategories() {
  var _this = this;

  var $elNavCategories = (0, _jquery2.default)('.nav--categories'); // sidebar nav

  // set category filter in filter form
  $elNavCategories.find('[data-store]').on('click', function () {
    // individual categories
    var $this = (0, _jquery2.default)(this);
    var mixedValue = $this.data('value');
    var strStore = $this.data('store');
    (0, _jquery2.default)('input[data-receive="' + strStore + '"]').val(mixedValue).trigger('update');
  });

  // submit from after category was updated
  (0, _jquery2.default)('[data-receive]').on('update', function () {
    (0, _jquery2.default)(_this).closest('form').submit();
  });

  $elNavCategories.find('[data-collapse]').each(function (index, button) {
    collapseContainer(button);
  });

  // collapse on click (weniger anzeigen button)
  $elNavCategories.find('[data-collapse]').on('click', function (event) {
    collapseContainer(event.currentTarget);
  });

  // after class js collpase was set on click scroll to container top
  $elNavCategories.find('.js-collapse').on('click', function (event) {
    var $this = (0, _jquery2.default)(this);
    var objData = $this.data();
    var $elPreviousContainer = $this.prev();

    if ($this.data().state !== 'opened') {
      scrollNavCategories($elPreviousContainer);
    }
  });

  //
  (0, _jquery2.default)(window).on('resize', function () {
    // set CSS
    $elNavCategories.css('transition', 'none');

    // weniger anzeigen buttons
    $elNavCategories.find('[data-collapse]').each(function () {
      var $this = (0, _jquery2.default)(this);
      var objData = $this.data();
      var $elPreviousContainer = $this.prev();
      var $elItems = $elPreviousContainer.children();
      var $elLastVisibleItem = $elItems.eq(objData.itemsLimit).prev();
      var intMinHeight = $elLastVisibleItem.position().top + $elLastVisibleItem.outerHeight(true);
      var intMaxHeight = $elPreviousContainer.css('height', 'auto').height();

      $this.data('intMinHeight', intMinHeight);
      $this.data('intMaxHeight', intMaxHeight);

      if (objData.hasOwnProperty('state') && objData.state === 'closed') $elPreviousContainer.css('height', intMinHeight);
    });

    // remove styles
    setTimeout(function () {
      $elNavCategories.removeAttr('style');
    });
  }).trigger('resize');

  // mobile nav
  (0, _jquery2.default)('[data-toggle="nav--categories"]').on('click', function () {
    var currentSize = TWTmediaQuery.getCurrentSize();
    if (currentSize === ('xs' || 's' || 'm')) {
      var $this = (0, _jquery2.default)(this);
      var objData = $elNavCategories.data();

      if (objData.hasOwnProperty('scrollTop')) {
        var intScrollTop = objData.scrollTop;
        document.body.scrollTop = intScrollTop;
        document.documentElement.scrollTop = intScrollTop;
        $elNavCategories.removeData('scrollTop');
      } else {
        $elNavCategories.data('scrollTop', document.body.scrollTop || document.documentElement.scrollTop);
      }

      (0, _jquery2.default)('body').toggleClass('has--open-categories');
    }
  });
}

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.noticeManager = noticeManager;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * @param  {Notice} notice the Notice
 * @param  {Function} method function to invoke on Notice
 * @param  {Any} args arguments binded to function call
 * @return {void}
 */
function noticeManager(notice, method, args) {
  if (args === undefined) {
    notice[method]();
  } else if (args.length > 1) {
    notice[method].apply(notice, _toConsumableArray(args));
  } else {
    notice[method](args[0]);
  }
}

/**
 * @class Notice
 * @export
 */

var Notice = exports.Notice = function () {
  /**
   * Creates a new instance of a menu.
   * @param  {String} type e. g. error, success
   * @param  {String} message message
   * @param  {Number} x x coordinate
   * @param  {Number} y y coordinate
   * @return {void}
  */
  function Notice(type, message, x, y) {
    var _this = this;

    _classCallCheck(this, Notice);

    var noticeTemplate = document.getElementById('notice');

    if (noticeTemplate !== null) {
      this.notice = noticeTemplate.cloneNode(true);
      var closeButton = this.notice.querySelector('[data-close]');

      // remove ID
      this.notice.id = undefined;

      // set type
      if (type !== undefined) this.setType(type);

      // set message
      if (type !== undefined) this.setMessage(message);

      // set position
      if (x !== undefined && y !== undefined) {
        this.setPosition(x, y);
      }

      // add event listener
      closeButton.addEventListener('click', function () {
        _this.close(_this.notice);
      });
    }
  }

  /**
   * @return {void}
   */


  _createClass(Notice, [{
    key: 'handleTimeout',
    value: function handleTimeout() {
      var _this2 = this;

      if (!this.timeout) {
        // init
        this.timeout = window.setTimeout(function () {
          _this2.close();
        }, 4000);
      } else {
        // clear
        window.clearTimeout(this.timeout);

        // reinit
        this.timeout = window.setTimeout(function () {
          _this2.close();
        }, 4000);
      }
    }

    /**
     * @param  {String} type e. g. error, success
     * @return {void}
     */

  }, {
    key: 'setType',
    value: function setType(type) {
      this.notice.dataset.type = type;

      this.handleTimeout();
    }

    /**
     * @param  {String} message message
     * @return {void}
     */

  }, {
    key: 'setMessage',
    value: function setMessage(message) {
      var messageNode = this.notice.querySelector('[data-notification-message]');

      messageNode.innerHTML = message;

      this.handleTimeout();
    }

    /**
     * @param  {String} context Selector for placement of notice
     * @return {void}
     */

  }, {
    key: 'render',
    value: function render() {
      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'body';

      this.rendered = true;
      document.querySelector(context).appendChild(this.notice);

      this.handleTimeout();
    }

    /**
     * @return {void}
     */

  }, {
    key: 'close',
    value: function close() {
      if (this.rendered && this.notice !== null) {
        this.notice.parentNode.removeChild(this.notice);
      }

      this.rendered = false;
    }

    /**
     * @param  {Number} x x coordinate
     * @param  {Number} y y coordinate
     * @return {void}
     */

  }, {
    key: 'setPosition',
    value: function setPosition(x, y) {
      this.notice.style.left = x + 'px';
      this.notice.style.top = y + 'px';

      this.handleTimeout();
    }

    /**
     * @param  {HTMLElement} element element to position notice
     * @param  {String} context Selector for placement of notice
     * @return {void}
     */

  }, {
    key: 'displayNoticeAtElementPosition',
    value: function displayNoticeAtElementPosition(element, context) {
      var elementDimensions = element.getBoundingClientRect();
      var contentWrapperDimensions = document.querySelector('.main-content').getBoundingClientRect();
      var arrow = this.notice.querySelector('[data-arrow-position]');
      var top = context ? document.querySelector(context).scrollTop : window.pageYOffset;
      var offset = 20;
      var arrowPosition = 32;
      var elementPositionLeftRelative = elementDimensions.left - contentWrapperDimensions.left;
      var noticeWidth = this.notice.getBoundingClientRect().width;
      var noticePositionLeft = elementDimensions.left + elementDimensions.width / 2 - arrowPosition;
      var noticePositionRight = elementDimensions.left + elementDimensions.width / 2 + arrowPosition - noticeWidth;
      var noticePositionTop = elementDimensions.top + top - this.notice.getBoundingClientRect().height - offset;

      if (elementPositionLeftRelative < noticeWidth / 2) {
        // set notice position
        this.setPosition(noticePositionLeft, noticePositionTop);
        arrow.dataset.arrowPosition = 'left';
      } else if (contentWrapperDimensions.width - elementPositionLeftRelative < noticeWidth / 2) {
        // set notice position
        this.setPosition(noticePositionRight, noticePositionTop);
        arrow.dataset.arrowPosition = 'right';
      } else {
        this.setPosition(elementDimensions.left + elementDimensions.width / 2 - noticeWidth / 2, noticePositionTop);
        arrow.dataset.arrowPosition = 'center';
      }

      this.handleTimeout();
    }
  }]);

  return Notice;
}();

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNumberOfItemsOnWishlist = exports.updateWishlistBadge = undefined;

var _cookie = __webpack_require__(77);

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasBadgeClass = 'has--badge';
var dataBadgeWishlistSelector = '[data-badge-wishlist]';
var wishlistCounterCookieName = 'obo_noticelist_counter';

/**
 * @return {Number} Number of wishlist items
 */
function getNumberOfItemsOnWishlist() {
  return (0, _cookie2.default)(wishlistCounterCookieName);
}

/**
 * @return {void}
 */
function showWishlistBadge() {
  var wishlistBadge = document.querySelector(dataBadgeWishlistSelector);

  wishlistBadge.classList.add(hasBadgeClass);
}

/**
 * @return {void}
 */
function hideWishlistBadge() {
  document.querySelector(dataBadgeWishlistSelector).classList.remove(hasBadgeClass);
}

/**
 * @param  {Number} quantity number of items on wishlist
 * @return {void}
 */
function updateWishlistBadge(quantity) {
  var wishlistBadge = document.querySelector(dataBadgeWishlistSelector);
  var count = quantity !== undefined ? quantity : getNumberOfItemsOnWishlist();

  // check if badge exists
  if (wishlistBadge === null) return;

  if (count <= 0) {
    hideWishlistBadge();

    // reset
    document.querySelector(dataBadgeWishlistSelector).setAttribute('data-badge-wishlist', '');
  } else {
    wishlistBadge.setAttribute('data-badge-wishlist', count);
    showWishlistBadge();
  }
}

exports.updateWishlistBadge = updateWishlistBadge;
exports.getNumberOfItemsOnWishlist = getNumberOfItemsOnWishlist;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(125);

__webpack_require__(126);

var _svg4everybody = __webpack_require__(127);

var _svg4everybody2 = _interopRequireDefault(_svg4everybody);

var _objectFitImages = __webpack_require__(128);

var _objectFitImages2 = _interopRequireDefault(_objectFitImages);

__webpack_require__(129);

var _foundation = __webpack_require__(130);

var _foundationUtil = __webpack_require__(73);

var _foundationUtil2 = __webpack_require__(74);

var _foundationUtil3 = __webpack_require__(42);

var _foundationUtil4 = __webpack_require__(75);

var _foundation2 = __webpack_require__(132);

var _foundation3 = __webpack_require__(134);

__webpack_require__(77);

__webpack_require__(135);

__webpack_require__(136);

__webpack_require__(137);

__webpack_require__(138);

__webpack_require__(139);

__webpack_require__(140);

__webpack_require__(141);

var _toggler = __webpack_require__(142);

var _toggler2 = _interopRequireDefault(_toggler);

var _toggleButton = __webpack_require__(143);

var _toggleButton2 = _interopRequireDefault(_toggleButton);

var _clickRelay = __webpack_require__(144);

var _clickRelay2 = _interopRequireDefault(_clickRelay);

__webpack_require__(145);

var _range = __webpack_require__(78);

var _range2 = _interopRequireDefault(_range);

__webpack_require__(147);

__webpack_require__(148);

__webpack_require__(149);

__webpack_require__(162);

__webpack_require__(163);

__webpack_require__(164);

__webpack_require__(165);

__webpack_require__(166);

__webpack_require__(167);

__webpack_require__(168);

__webpack_require__(169);

__webpack_require__(170);

__webpack_require__(171);

__webpack_require__(172);

__webpack_require__(173);

__webpack_require__(23);

var _filter = __webpack_require__(24);

__webpack_require__(174);

__webpack_require__(175);

__webpack_require__(176);

__webpack_require__(177);

__webpack_require__(178);

var _twt = __webpack_require__(179);

var _twt2 = _interopRequireDefault(_twt);

var _twt3 = __webpack_require__(180);

var _twt4 = _interopRequireDefault(_twt3);

var _twt5 = __webpack_require__(181);

var _twt6 = _interopRequireDefault(_twt5);

var _tabs = __webpack_require__(182);

var _tabs2 = _interopRequireDefault(_tabs);

var _twt7 = __webpack_require__(13);

var TWTmediaQuery = _interopRequireWildcard(_twt7);

var _pubSub = __webpack_require__(14);

var _pubSub2 = _interopRequireDefault(_pubSub);

var _overlay = __webpack_require__(183);

var _overlay2 = _interopRequireDefault(_overlay);

__webpack_require__(21);

__webpack_require__(184);

var _wishlistActions = __webpack_require__(84);

__webpack_require__(185);

__webpack_require__(186);

var _articleListOrder = __webpack_require__(25);

var _articleListOrder2 = _interopRequireDefault(_articleListOrder);

var _searchresultCategories = __webpack_require__(82);

var _searchresultCategories2 = _interopRequireDefault(_searchresultCategories);

var _truncateText = __webpack_require__(188);

var _truncateText2 = _interopRequireDefault(_truncateText);

var _matchHeight = __webpack_require__(189);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// svg4everybody


// components


// vendor
// libraries
(0, _svg4everybody2.default)();

// images


// polyfills
(0, _objectFitImages2.default)();

// instanciate classes
var drilldownNodes = document.querySelectorAll('[data-drilldown]');
var drilldownInstances = [];
var menuNodes = document.querySelectorAll('[data-menu]');
var menuInstances = [];
var offCanvasNodes = document.querySelectorAll('[data-off-canvas]');
var OffCanvasInstances = [];
var tabsNodes = document.querySelectorAll('[data-tabs]');
var tabsInstances = [];

var blnIsTouchDevice = !!('ontouchstart' in window) || !!navigator.msMaxTouchPoints;

document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

if (blnIsTouchDevice) {
  document.documentElement.classList.remove('no-touch');
  document.documentElement.classList.add('touch');
}

// Media Query
TWTmediaQuery.init();

// Drilldown
for (var i = 0; i < drilldownNodes.length; i += 1) {
  drilldownInstances.push(new _twt4.default(drilldownNodes[i]));
}

// Menu
for (var _i = 0; _i < menuNodes.length; _i += 1) {
  menuInstances.push(new _twt6.default(menuNodes[_i]));
}

// OffCanvas
for (var _i2 = 0; _i2 < offCanvasNodes.length; _i2 += 1) {
  OffCanvasInstances.push(new _twt2.default(offCanvasNodes[_i2]));
}

// Tabs
for (var _i3 = 0; _i3 < tabsNodes.length; _i3 += 1) {
  tabsInstances.push(new _tabs2.default(tabsNodes[_i3]));
}

/**
 * Utils
 */
var deleteOptionsContainer = document.querySelector('.delete-option');
if (deleteOptionsContainer !== null) (0, _filter.initFilterTags)(deleteOptionsContainer);

(0, _filter.initFilterForm)();
(0, _toggler2.default)();
(0, _toggleButton2.default)();
(0, _clickRelay2.default)();
(0, _filter.filterDropdown)();
(0, _articleListOrder2.default)();
(0, _range2.default)();
(0, _truncateText2.default)();
(0, _matchHeight.matchTeaserHeights)();
(0, _matchHeight.matchSliderHeights)();
(0, _wishlistActions.updateWishlistBadge)();
(0, _jquery2.default)('.service-contact__name').matchHeight();

/**
 * Subscriptions
 */

// Off-canvas
_pubSub2.default.subscribe('opened.offCanvas', function () {
  return _overlay2.default.show();
});
_pubSub2.default.subscribe('closed.offCanvas', function () {
  return _overlay2.default.hide();
});

// Content reload
_pubSub2.default.subscribe('reloaded.content', function (data) {
  if (data.scope !== undefined) {
    var scope = data.scope;

    (0, _toggler2.default)(scope);
    (0, _toggleButton2.default)(scope);
    (0, _clickRelay2.default)(scope);
    (0, _filter.filterDropdown)(scope);
    (0, _jquery2.default)('.accordion').Accordion();
    (0, _range2.default)(scope);

    if (scope.parentNode.id === 'searchresult-1') (0, _searchresultCategories2.default)();
  }

  // match height
  (0, _matchHeight.matchTeaserHeights)();
});

// wenn die Suche geöffnet wird, soll der Focus auf dem Input gesetzt werden
var metaSearchButton = document.querySelector('.meta-search button');

if (metaSearchButton !== null) {
  metaSearchButton.addEventListener('click', function () {
    var search = document.getElementById('js-search');

    search.querySelector('input').focus();
  });
}

(0, _jquery2.default)(document).ready(function () {
  /**
   * Foundation
   * https://github.com/zurb/foundation-sites/blob/develop/js/entries/foundation.js
   */

  // add to jQuery
  _foundation.Foundation.addToJquery(_jquery2.default);

  // add to Foundation
  _foundation.Foundation.Box = _foundationUtil.Box;
  _foundation.Foundation.MediaQuery = _foundationUtil2.MediaQuery;
  _foundation.Foundation.Keyboard = _foundationUtil4.Keyboard;

  // init utils
  _foundationUtil3.Triggers.init(_jquery2.default, _foundation.Foundation);

  // Plugins
  _foundation.Foundation.plugin(_foundation2.Tooltip, 'Tooltip');
  _foundation.Foundation.plugin(_foundation3.Dropdown, 'Dropdown');

  (0, _jquery2.default)(document).foundation();

  /**
   * Magnific Popup
   * http://dimsemenov.com/plugins/magnific-popup/
   */
  (0, _jquery2.default)('.news-gallery').magnificPopup({
    type: 'image',
    delegate: 'a',
    gallery: {
      enabled: true,
      titleSrc: 'title'
    },
    verticalFit: true
  });

  // Menu active state generation
  // ----------------------------
  var currentUid = (0, _jquery2.default)('body').data('uidCurrent');
  var $sidebar = (0, _jquery2.default)('.sidebar > .nav.nav--sidebar');
  var $breadcrumb = (0, _jquery2.default)('.nav.nav--breadcrumb');

  // eslint-disable-next-line func-names
  var generateMenuActiveStates = function generateMenuActiveStates() {
    var links = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var removeFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    // If list array is not empty
    if (links.length > 0) {
      // Remove first item
      if (removeFirst) links.shift();

      // Find the first mainNavigation item that matches the first item within
      // the links array
      var $selector = (0, _jquery2.default)('#mainNavigation').find('a[href="' + links[0] + '"]').first().parent();

      // Add is--current class to the list item
      $selector.addClass('is--current');

      // Recursively find current child pages
      for (var index = 1; index < links.length; index = index + 1) {
        $selector = $selector.find('a[href="' + links[index] + '"]').first().parent();
        $selector.addClass('is--current');
      }
    }
  };

  // If body has data-uid-current attribute (CMS)
  if (typeof currentUid !== 'undefined') {
    // Add is--current class to current page and all parent pages
    (0, _jquery2.default)('[data-uid=' + currentUid + ']').addClass('is--current').parentsUntil('#mainNavigation', 'li').each(function () {
      // eslint-disable-line func-names
      (0, _jquery2.default)(this).addClass('is--current');
    });
  } else if ($sidebar.length > 0) {
    // Else if sidebar exists
    var $currentSidebarActiveLink = $sidebar.find('.nav__item.is--active');
    var links = [];

    // Add active menu item to the links array
    //
    // If mainNavigation is changed to absolute links, remove the replace
    // function or adjust the regular expression
    links.push($currentSidebarActiveLink.find('> a').attr('href').replace(/(https?):\/\/.+?\//, '/'));

    // Traverse tree upwards to find all parent list items of the active menu item
    (0, _jquery2.default)($currentSidebarActiveLink.parentsUntil('.sidebar > .nav.nav--sidebar', 'li').find('> a').get().reverse()).each(function () {
      // eslint-disable-line func-names
      // Add all parent pages of the active link at the beginning of the links array
      links.unshift(
      // Remove protocol and domain name to get relative URLs, because the
      // mainNavigation contains only relative links
      //
      // If mainNavigation is changed to absolute links, remove the replace
      // function or adjust the regular expression
      (0, _jquery2.default)(this).attr('href').replace(/(https?):\/\/.+?\//, '/'));
    });

    generateMenuActiveStates(links, false);
  } else if ($breadcrumb.length > 0) {
    // Else if breadcrumb exists
    var _links = [];
    $breadcrumb.find('li.nav__item > a').each(function () {
      // eslint-disable-line func-names
      _links.push((0, _jquery2.default)(this).attr('href').replace(/(https?):\/\/.+?\//, '/'));
    });

    // Remove first item from links array because it's the home link "/"
    generateMenuActiveStates(_links, true);
  }
});

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	"use strict";

	return Object.getPrototypeOf;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(26)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( class2type ) {
	"use strict";

	return class2type.toString;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(47)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( fnToString ) {
	"use strict";

	return fnToString.call( Object );
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(90)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, Sizzle ) {

"use strict";

jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

// EXPOSE
var _sizzle = window.Sizzle;

Sizzle.noConflict = function() {
	if ( window.Sizzle === Sizzle ) {
		window.Sizzle = _sizzle;
	}

	return Sizzle;
};

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return Sizzle; }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
// Sizzle requires that there be a global window in Common-JS like environments
} else if ( typeof module !== "undefined" && module.exports ) {
	module.exports = Sizzle;
} else {
	window.Sizzle = Sizzle;
}
// EXPOSE

})( window );


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {

"use strict";

jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {

"use strict";

return function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {

"use strict";

return function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};

}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(15)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {

"use strict";

// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(11),
	__webpack_require__(5),
	__webpack_require__(60)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, access, dataPriv, dataUser ) {

"use strict";

//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );

return jQuery;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(37),
	__webpack_require__(38) // Delay is optional because of this dependency
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {

"use strict";

// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};

return jQuery.fn.delay;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(5),
	__webpack_require__(61)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, dataPriv, isHiddenWithinTree ) {

"use strict";

var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );

return showHide;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(2),
	__webpack_require__(10)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( document, support ) {

"use strict";

( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();

return support;

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(19)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {

"use strict";

function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(101),
	__webpack_require__(69),
	__webpack_require__(102),
	__webpack_require__(103)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {

"use strict";

// Return jQuery for attributes-only inclusion
return jQuery;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(11),
	__webpack_require__(7),
	__webpack_require__(39),
	__webpack_require__(6),
	__webpack_require__(3)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, access, nodeName, support, rnothtmlwhite ) {

"use strict";

var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(40),
	__webpack_require__(6),
	__webpack_require__(5),
	__webpack_require__(4)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, stripAndCollapse, rnothtmlwhite, dataPriv ) {

"use strict";

function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnothtmlwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(40),
	__webpack_require__(39),
	__webpack_require__(7),

	__webpack_require__(4)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, stripAndCollapse, support, nodeName ) {

"use strict";

var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),

	__webpack_require__(17),
	__webpack_require__(41)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {

"use strict";

jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(5),
	__webpack_require__(106),

	__webpack_require__(17),
	__webpack_require__(41)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, dataPriv, support ) {

"use strict";

// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}

return jQuery;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(10)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( support ) {

"use strict";

support.focusin = "onfocusin" in window;

return support;

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(18)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {

"use strict";

jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};

return jQuery._evalUrl;

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	"use strict";

	return window.location;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {

"use strict";

// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};

return jQuery.parseXML;

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(4),
	__webpack_require__(22), // clone
	__webpack_require__(16) // parent, contents
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {

"use strict";

jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( jQuery.isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );

return jQuery;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(3)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {

"use strict";

jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(10),
	__webpack_require__(18)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, support ) {

"use strict";

jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(2),
	__webpack_require__(18)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document ) {

"use strict";

// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(70),
	__webpack_require__(71),
	__webpack_require__(18)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, nonce, rquery ) {

"use strict";

var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(40),
	__webpack_require__(116),
	__webpack_require__(18),
	__webpack_require__(16),
	__webpack_require__(22),
	__webpack_require__(3)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, stripAndCollapse ) {

"use strict";

/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(2),
	__webpack_require__(55),
	__webpack_require__(68),

	// This is the only module that needs core/support
	__webpack_require__(117)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, rsingleTag, buildFragment, support ) {

"use strict";

// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};

return jQuery.parseHTML;

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(2),
	__webpack_require__(10)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( document, support ) {

"use strict";

// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();

return support;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(17)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {

"use strict";

// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(3),
	__webpack_require__(38)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {

"use strict";

jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(11),
	__webpack_require__(2),
	__webpack_require__(34),
	__webpack_require__(32),
	__webpack_require__(52),
	__webpack_require__(54),
	__webpack_require__(33),
	__webpack_require__(7),

	__webpack_require__(4),
	__webpack_require__(19),
	__webpack_require__(3) // contains
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, access, document, documentElement, rnumnonpx,
             curCSS, addGetHookIf, support, nodeName ) {

"use strict";

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var doc, docElem, rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		rect = elem.getBoundingClientRect();

		doc = elem.ownerDocument;
		docElem = doc.documentElement;
		win = doc.defaultView;

		return {
			top: rect.top + win.pageYOffset - docElem.clientTop,
			left: rect.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset = {
				top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
				left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
			};
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( jQuery.isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );

return jQuery;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(11),
	__webpack_require__(19)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, access ) {

"use strict";

// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );

return jQuery;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0),
	__webpack_require__(7)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, nodeName ) {

"use strict";

jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {

"use strict";

// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(0)
], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, noGlobal ) {

"use strict";

var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
* jquery-match-height 0.7.2 by @liabru
* http://brm.io/jquery-match-height/
* License: MIT
*/

;(function(factory) { // eslint-disable-line no-extra-semi
    'use strict';
    if (true) {
        // AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module !== 'undefined' && module.exports) {
        // CommonJS
        module.exports = factory(require('jquery'));
    } else {
        // Global
        factory(jQuery);
    }
})(function($) {
    /*
    *  internal
    */

    var _previousResizeWidth = -1,
        _updateTimeout = -1;

    /*
    *  _parse
    *  value parse utility function
    */

    var _parse = function(value) {
        // parse value and convert NaN to 0
        return parseFloat(value) || 0;
    };

    /*
    *  _rows
    *  utility function returns array of jQuery selections representing each row
    *  (as displayed after float wrapping applied by browser)
    */

    var _rows = function(elements) {
        var tolerance = 1,
            $elements = $(elements),
            lastTop = null,
            rows = [];

        // group elements by their top position
        $elements.each(function(){
            var $that = $(this),
                top = $that.offset().top - _parse($that.css('margin-top')),
                lastRow = rows.length > 0 ? rows[rows.length - 1] : null;

            if (lastRow === null) {
                // first item on the row, so just push it
                rows.push($that);
            } else {
                // if the row top is the same, add to the row group
                if (Math.floor(Math.abs(lastTop - top)) <= tolerance) {
                    rows[rows.length - 1] = lastRow.add($that);
                } else {
                    // otherwise start a new row group
                    rows.push($that);
                }
            }

            // keep track of the last row top
            lastTop = top;
        });

        return rows;
    };

    /*
    *  _parseOptions
    *  handle plugin options
    */

    var _parseOptions = function(options) {
        var opts = {
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        };

        if (typeof options === 'object') {
            return $.extend(opts, options);
        }

        if (typeof options === 'boolean') {
            opts.byRow = options;
        } else if (options === 'remove') {
            opts.remove = true;
        }

        return opts;
    };

    /*
    *  matchHeight
    *  plugin definition
    */

    var matchHeight = $.fn.matchHeight = function(options) {
        var opts = _parseOptions(options);

        // handle remove
        if (opts.remove) {
            var that = this;

            // remove fixed height from all selected elements
            this.css(opts.property, '');

            // remove selected elements from all groups
            $.each(matchHeight._groups, function(key, group) {
                group.elements = group.elements.not(that);
            });

            // TODO: cleanup empty groups

            return this;
        }

        if (this.length <= 1 && !opts.target) {
            return this;
        }

        // keep track of this group so we can re-apply later on load and resize events
        matchHeight._groups.push({
            elements: this,
            options: opts
        });

        // match each element's height to the tallest element in the selection
        matchHeight._apply(this, opts);

        return this;
    };

    /*
    *  plugin global options
    */

    matchHeight.version = '0.7.2';
    matchHeight._groups = [];
    matchHeight._throttle = 80;
    matchHeight._maintainScroll = false;
    matchHeight._beforeUpdate = null;
    matchHeight._afterUpdate = null;
    matchHeight._rows = _rows;
    matchHeight._parse = _parse;
    matchHeight._parseOptions = _parseOptions;

    /*
    *  matchHeight._apply
    *  apply matchHeight to given elements
    */

    matchHeight._apply = function(elements, options) {
        var opts = _parseOptions(options),
            $elements = $(elements),
            rows = [$elements];

        // take note of scroll position
        var scrollTop = $(window).scrollTop(),
            htmlHeight = $('html').outerHeight(true);

        // get hidden parents
        var $hiddenParents = $elements.parents().filter(':hidden');

        // cache the original inline style
        $hiddenParents.each(function() {
            var $that = $(this);
            $that.data('style-cache', $that.attr('style'));
        });

        // temporarily must force hidden parents visible
        $hiddenParents.css('display', 'block');

        // get rows if using byRow, otherwise assume one row
        if (opts.byRow && !opts.target) {

            // must first force an arbitrary equal height so floating elements break evenly
            $elements.each(function() {
                var $that = $(this),
                    display = $that.css('display');

                // temporarily force a usable display value
                if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') {
                    display = 'block';
                }

                // cache the original inline style
                $that.data('style-cache', $that.attr('style'));

                $that.css({
                    'display': display,
                    'padding-top': '0',
                    'padding-bottom': '0',
                    'margin-top': '0',
                    'margin-bottom': '0',
                    'border-top-width': '0',
                    'border-bottom-width': '0',
                    'height': '100px',
                    'overflow': 'hidden'
                });
            });

            // get the array of rows (based on element top position)
            rows = _rows($elements);

            // revert original inline styles
            $elements.each(function() {
                var $that = $(this);
                $that.attr('style', $that.data('style-cache') || '');
            });
        }

        $.each(rows, function(key, row) {
            var $row = $(row),
                targetHeight = 0;

            if (!opts.target) {
                // skip apply to rows with only one item
                if (opts.byRow && $row.length <= 1) {
                    $row.css(opts.property, '');
                    return;
                }

                // iterate the row and find the max height
                $row.each(function(){
                    var $that = $(this),
                        style = $that.attr('style'),
                        display = $that.css('display');

                    // temporarily force a usable display value
                    if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') {
                        display = 'block';
                    }

                    // ensure we get the correct actual height (and not a previously set height value)
                    var css = { 'display': display };
                    css[opts.property] = '';
                    $that.css(css);

                    // find the max height (including padding, but not margin)
                    if ($that.outerHeight(false) > targetHeight) {
                        targetHeight = $that.outerHeight(false);
                    }

                    // revert styles
                    if (style) {
                        $that.attr('style', style);
                    } else {
                        $that.css('display', '');
                    }
                });
            } else {
                // if target set, use the height of the target element
                targetHeight = opts.target.outerHeight(false);
            }

            // iterate the row and apply the height to all elements
            $row.each(function(){
                var $that = $(this),
                    verticalPadding = 0;

                // don't apply to a target
                if (opts.target && $that.is(opts.target)) {
                    return;
                }

                // handle padding and border correctly (required when not using border-box)
                if ($that.css('box-sizing') !== 'border-box') {
                    verticalPadding += _parse($that.css('border-top-width')) + _parse($that.css('border-bottom-width'));
                    verticalPadding += _parse($that.css('padding-top')) + _parse($that.css('padding-bottom'));
                }

                // set the height (accounting for padding and border)
                $that.css(opts.property, (targetHeight - verticalPadding) + 'px');
            });
        });

        // revert hidden parents
        $hiddenParents.each(function() {
            var $that = $(this);
            $that.attr('style', $that.data('style-cache') || null);
        });

        // restore scroll position if enabled
        if (matchHeight._maintainScroll) {
            $(window).scrollTop((scrollTop / htmlHeight) * $('html').outerHeight(true));
        }

        return this;
    };

    /*
    *  matchHeight._applyDataApi
    *  applies matchHeight to all elements with a data-match-height attribute
    */

    matchHeight._applyDataApi = function() {
        var groups = {};

        // generate groups by their groupId set by elements using data-match-height
        $('[data-match-height], [data-mh]').each(function() {
            var $this = $(this),
                groupId = $this.attr('data-mh') || $this.attr('data-match-height');

            if (groupId in groups) {
                groups[groupId] = groups[groupId].add($this);
            } else {
                groups[groupId] = $this;
            }
        });

        // apply matchHeight to each group
        $.each(groups, function() {
            this.matchHeight(true);
        });
    };

    /*
    *  matchHeight._update
    *  updates matchHeight on all current groups with their correct options
    */

    var _update = function(event) {
        if (matchHeight._beforeUpdate) {
            matchHeight._beforeUpdate(event, matchHeight._groups);
        }

        $.each(matchHeight._groups, function() {
            matchHeight._apply(this.elements, this.options);
        });

        if (matchHeight._afterUpdate) {
            matchHeight._afterUpdate(event, matchHeight._groups);
        }
    };

    matchHeight._update = function(throttle, event) {
        // prevent update if fired from a resize event
        // where the viewport width hasn't actually changed
        // fixes an event looping bug in IE8
        if (event && event.type === 'resize') {
            var windowWidth = $(window).width();
            if (windowWidth === _previousResizeWidth) {
                return;
            }
            _previousResizeWidth = windowWidth;
        }

        // throttle updates
        if (!throttle) {
            _update(event);
        } else if (_updateTimeout === -1) {
            _updateTimeout = setTimeout(function() {
                _update(event);
                _updateTimeout = -1;
            }, matchHeight._throttle);
        }
    };

    /*
    *  bind events
    */

    // apply on DOM ready event
    $(matchHeight._applyDataApi);

    // use on or bind where supported
    var on = $.fn.on ? 'on' : 'bind';

    // update heights on load and resize events
    $(window)[on]('load', function(event) {
        matchHeight._update(false, event);
    });

    // throttled update heights on resize events
    $(window)[on]('resize orientationchange', function(event) {
        matchHeight._update(true, event);
    });

});


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! picturefill - v3.0.2 - 2016-02-12
 * https://scottjehl.github.io/picturefill/
 * Copyright (c) 2016 https://github.com/scottjehl/picturefill/blob/master/Authors.txt; Licensed MIT
 */
/*! Gecko-Picture - v1.0
 * https://github.com/scottjehl/picturefill/tree/3.0/src/plugins/gecko-picture
 * Firefox's early picture implementation (prior to FF41) is static and does
 * not react to viewport changes. This tiny module fixes this.
 */
(function(window) {
	/*jshint eqnull:true */
	var ua = navigator.userAgent;

	if ( window.HTMLPictureElement && ((/ecko/).test(ua) && ua.match(/rv\:(\d+)/) && RegExp.$1 < 45) ) {
		addEventListener("resize", (function() {
			var timer;

			var dummySrc = document.createElement("source");

			var fixRespimg = function(img) {
				var source, sizes;
				var picture = img.parentNode;

				if (picture.nodeName.toUpperCase() === "PICTURE") {
					source = dummySrc.cloneNode();

					picture.insertBefore(source, picture.firstElementChild);
					setTimeout(function() {
						picture.removeChild(source);
					});
				} else if (!img._pfLastSize || img.offsetWidth > img._pfLastSize) {
					img._pfLastSize = img.offsetWidth;
					sizes = img.sizes;
					img.sizes += ",100vw";
					setTimeout(function() {
						img.sizes = sizes;
					});
				}
			};

			var findPictureImgs = function() {
				var i;
				var imgs = document.querySelectorAll("picture > img, img[srcset][sizes]");
				for (i = 0; i < imgs.length; i++) {
					fixRespimg(imgs[i]);
				}
			};
			var onResize = function() {
				clearTimeout(timer);
				timer = setTimeout(findPictureImgs, 99);
			};
			var mq = window.matchMedia && matchMedia("(orientation: landscape)");
			var init = function() {
				onResize();

				if (mq && mq.addListener) {
					mq.addListener(onResize);
				}
			};

			dummySrc.srcset = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

			if (/^[c|i]|d$/.test(document.readyState || "")) {
				init();
			} else {
				document.addEventListener("DOMContentLoaded", init);
			}

			return onResize;
		})());
	}
})(window);

/*! Picturefill - v3.0.2
 * http://scottjehl.github.io/picturefill
 * Copyright (c) 2015 https://github.com/scottjehl/picturefill/blob/master/Authors.txt;
 *  License: MIT
 */

(function( window, document, undefined ) {
	// Enable strict mode
	"use strict";

	// HTML shim|v it for old IE (IE9 will still need the HTML video tag workaround)
	document.createElement( "picture" );

	var warn, eminpx, alwaysCheckWDescriptor, evalId;
	// local object for method references and testing exposure
	var pf = {};
	var isSupportTestReady = false;
	var noop = function() {};
	var image = document.createElement( "img" );
	var getImgAttr = image.getAttribute;
	var setImgAttr = image.setAttribute;
	var removeImgAttr = image.removeAttribute;
	var docElem = document.documentElement;
	var types = {};
	var cfg = {
		//resource selection:
		algorithm: ""
	};
	var srcAttr = "data-pfsrc";
	var srcsetAttr = srcAttr + "set";
	// ua sniffing is done for undetectable img loading features,
	// to do some non crucial perf optimizations
	var ua = navigator.userAgent;
	var supportAbort = (/rident/).test(ua) || ((/ecko/).test(ua) && ua.match(/rv\:(\d+)/) && RegExp.$1 > 35 );
	var curSrcProp = "currentSrc";
	var regWDesc = /\s+\+?\d+(e\d+)?w/;
	var regSize = /(\([^)]+\))?\s*(.+)/;
	var setOptions = window.picturefillCFG;
	/**
	 * Shortcut property for https://w3c.github.io/webappsec/specs/mixedcontent/#restricts-mixed-content ( for easy overriding in tests )
	 */
	// baseStyle also used by getEmValue (i.e.: width: 1em is important)
	var baseStyle = "position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)";
	var fsCss = "font-size:100%!important;";
	var isVwDirty = true;

	var cssCache = {};
	var sizeLengthCache = {};
	var DPR = window.devicePixelRatio;
	var units = {
		px: 1,
		"in": 96
	};
	var anchor = document.createElement( "a" );
	/**
	 * alreadyRun flag used for setOptions. is it true setOptions will reevaluate
	 * @type {boolean}
	 */
	var alreadyRun = false;

	// Reusable, non-"g" Regexes

	// (Don't use \s, to avoid matching non-breaking space.)
	var regexLeadingSpaces = /^[ \t\n\r\u000c]+/,
	    regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/,
	    regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/,
	    regexTrailingCommas = /[,]+$/,
	    regexNonNegativeInteger = /^\d+$/,

	    // ( Positive or negative or unsigned integers or decimals, without or without exponents.
	    // Must include at least one digit.
	    // According to spec tests any decimal point must be followed by a digit.
	    // No leading plus sign is allowed.)
	    // https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
	    regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/;

	var on = function(obj, evt, fn, capture) {
		if ( obj.addEventListener ) {
			obj.addEventListener(evt, fn, capture || false);
		} else if ( obj.attachEvent ) {
			obj.attachEvent( "on" + evt, fn);
		}
	};

	/**
	 * simple memoize function:
	 */

	var memoize = function(fn) {
		var cache = {};
		return function(input) {
			if ( !(input in cache) ) {
				cache[ input ] = fn(input);
			}
			return cache[ input ];
		};
	};

	// UTILITY FUNCTIONS

	// Manual is faster than RegEx
	// http://jsperf.com/whitespace-character/5
	function isSpace(c) {
		return (c === "\u0020" || // space
		        c === "\u0009" || // horizontal tab
		        c === "\u000A" || // new line
		        c === "\u000C" || // form feed
		        c === "\u000D");  // carriage return
	}

	/**
	 * gets a mediaquery and returns a boolean or gets a css length and returns a number
	 * @param css mediaqueries or css length
	 * @returns {boolean|number}
	 *
	 * based on: https://gist.github.com/jonathantneal/db4f77009b155f083738
	 */
	var evalCSS = (function() {

		var regLength = /^([\d\.]+)(em|vw|px)$/;
		var replace = function() {
			var args = arguments, index = 0, string = args[0];
			while (++index in args) {
				string = string.replace(args[index], args[++index]);
			}
			return string;
		};

		var buildStr = memoize(function(css) {

			return "return " + replace((css || "").toLowerCase(),
				// interpret `and`
				/\band\b/g, "&&",

				// interpret `,`
				/,/g, "||",

				// interpret `min-` as >=
				/min-([a-z-\s]+):/g, "e.$1>=",

				// interpret `max-` as <=
				/max-([a-z-\s]+):/g, "e.$1<=",

				//calc value
				/calc([^)]+)/g, "($1)",

				// interpret css values
				/(\d+[\.]*[\d]*)([a-z]+)/g, "($1 * e.$2)",
				//make eval less evil
				/^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/ig, ""
			) + ";";
		});

		return function(css, length) {
			var parsedLength;
			if (!(css in cssCache)) {
				cssCache[css] = false;
				if (length && (parsedLength = css.match( regLength ))) {
					cssCache[css] = parsedLength[ 1 ] * units[parsedLength[ 2 ]];
				} else {
					/*jshint evil:true */
					try{
						cssCache[css] = new Function("e", buildStr(css))(units);
					} catch(e) {}
					/*jshint evil:false */
				}
			}
			return cssCache[css];
		};
	})();

	var setResolution = function( candidate, sizesattr ) {
		if ( candidate.w ) { // h = means height: || descriptor.type === 'h' do not handle yet...
			candidate.cWidth = pf.calcListLength( sizesattr || "100vw" );
			candidate.res = candidate.w / candidate.cWidth ;
		} else {
			candidate.res = candidate.d;
		}
		return candidate;
	};

	/**
	 *
	 * @param opt
	 */
	var picturefill = function( opt ) {

		if (!isSupportTestReady) {return;}

		var elements, i, plen;

		var options = opt || {};

		if ( options.elements && options.elements.nodeType === 1 ) {
			if ( options.elements.nodeName.toUpperCase() === "IMG" ) {
				options.elements =  [ options.elements ];
			} else {
				options.context = options.elements;
				options.elements =  null;
			}
		}

		elements = options.elements || pf.qsa( (options.context || document), ( options.reevaluate || options.reselect ) ? pf.sel : pf.selShort );

		if ( (plen = elements.length) ) {

			pf.setupRun( options );
			alreadyRun = true;

			// Loop through all elements
			for ( i = 0; i < plen; i++ ) {
				pf.fillImg(elements[ i ], options);
			}

			pf.teardownRun( options );
		}
	};

	/**
	 * outputs a warning for the developer
	 * @param {message}
	 * @type {Function}
	 */
	warn = ( window.console && console.warn ) ?
		function( message ) {
			console.warn( message );
		} :
		noop
	;

	if ( !(curSrcProp in image) ) {
		curSrcProp = "src";
	}

	// Add support for standard mime types.
	types[ "image/jpeg" ] = true;
	types[ "image/gif" ] = true;
	types[ "image/png" ] = true;

	function detectTypeSupport( type, typeUri ) {
		// based on Modernizr's lossless img-webp test
		// note: asynchronous
		var image = new window.Image();
		image.onerror = function() {
			types[ type ] = false;
			picturefill();
		};
		image.onload = function() {
			types[ type ] = image.width === 1;
			picturefill();
		};
		image.src = typeUri;
		return "pending";
	}

	// test svg support
	types[ "image/svg+xml" ] = document.implementation.hasFeature( "http://www.w3.org/TR/SVG11/feature#Image", "1.1" );

	/**
	 * updates the internal vW property with the current viewport width in px
	 */
	function updateMetrics() {

		isVwDirty = false;
		DPR = window.devicePixelRatio;
		cssCache = {};
		sizeLengthCache = {};

		pf.DPR = DPR || 1;

		units.width = Math.max(window.innerWidth || 0, docElem.clientWidth);
		units.height = Math.max(window.innerHeight || 0, docElem.clientHeight);

		units.vw = units.width / 100;
		units.vh = units.height / 100;

		evalId = [ units.height, units.width, DPR ].join("-");

		units.em = pf.getEmValue();
		units.rem = units.em;
	}

	function chooseLowRes( lowerValue, higherValue, dprValue, isCached ) {
		var bonusFactor, tooMuch, bonus, meanDensity;

		//experimental
		if (cfg.algorithm === "saveData" ){
			if ( lowerValue > 2.7 ) {
				meanDensity = dprValue + 1;
			} else {
				tooMuch = higherValue - dprValue;
				bonusFactor = Math.pow(lowerValue - 0.6, 1.5);

				bonus = tooMuch * bonusFactor;

				if (isCached) {
					bonus += 0.1 * bonusFactor;
				}

				meanDensity = lowerValue + bonus;
			}
		} else {
			meanDensity = (dprValue > 1) ?
				Math.sqrt(lowerValue * higherValue) :
				lowerValue;
		}

		return meanDensity > dprValue;
	}

	function applyBestCandidate( img ) {
		var srcSetCandidates;
		var matchingSet = pf.getSet( img );
		var evaluated = false;
		if ( matchingSet !== "pending" ) {
			evaluated = evalId;
			if ( matchingSet ) {
				srcSetCandidates = pf.setRes( matchingSet );
				pf.applySetCandidate( srcSetCandidates, img );
			}
		}
		img[ pf.ns ].evaled = evaluated;
	}

	function ascendingSort( a, b ) {
		return a.res - b.res;
	}

	function setSrcToCur( img, src, set ) {
		var candidate;
		if ( !set && src ) {
			set = img[ pf.ns ].sets;
			set = set && set[set.length - 1];
		}

		candidate = getCandidateForSrc(src, set);

		if ( candidate ) {
			src = pf.makeUrl(src);
			img[ pf.ns ].curSrc = src;
			img[ pf.ns ].curCan = candidate;

			if ( !candidate.res ) {
				setResolution( candidate, candidate.set.sizes );
			}
		}
		return candidate;
	}

	function getCandidateForSrc( src, set ) {
		var i, candidate, candidates;
		if ( src && set ) {
			candidates = pf.parseSet( set );
			src = pf.makeUrl(src);
			for ( i = 0; i < candidates.length; i++ ) {
				if ( src === pf.makeUrl(candidates[ i ].url) ) {
					candidate = candidates[ i ];
					break;
				}
			}
		}
		return candidate;
	}

	function getAllSourceElements( picture, candidates ) {
		var i, len, source, srcset;

		// SPEC mismatch intended for size and perf:
		// actually only source elements preceding the img should be used
		// also note: don't use qsa here, because IE8 sometimes doesn't like source as the key part in a selector
		var sources = picture.getElementsByTagName( "source" );

		for ( i = 0, len = sources.length; i < len; i++ ) {
			source = sources[ i ];
			source[ pf.ns ] = true;
			srcset = source.getAttribute( "srcset" );

			// if source does not have a srcset attribute, skip
			if ( srcset ) {
				candidates.push( {
					srcset: srcset,
					media: source.getAttribute( "media" ),
					type: source.getAttribute( "type" ),
					sizes: source.getAttribute( "sizes" )
				} );
			}
		}
	}

	/**
	 * Srcset Parser
	 * By Alex Bell |  MIT License
	 *
	 * @returns Array [{url: _, d: _, w: _, h:_, set:_(????)}, ...]
	 *
	 * Based super duper closely on the reference algorithm at:
	 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
	 */

	// 1. Let input be the value passed to this algorithm.
	// (TO-DO : Explain what "set" argument is here. Maybe choose a more
	// descriptive & more searchable name.  Since passing the "set" in really has
	// nothing to do with parsing proper, I would prefer this assignment eventually
	// go in an external fn.)
	function parseSrcset(input, set) {

		function collectCharacters(regEx) {
			var chars,
			    match = regEx.exec(input.substring(pos));
			if (match) {
				chars = match[ 0 ];
				pos += chars.length;
				return chars;
			}
		}

		var inputLength = input.length,
		    url,
		    descriptors,
		    currentDescriptor,
		    state,
		    c,

		    // 2. Let position be a pointer into input, initially pointing at the start
		    //    of the string.
		    pos = 0,

		    // 3. Let candidates be an initially empty source set.
		    candidates = [];

		/**
		* Adds descriptor properties to a candidate, pushes to the candidates array
		* @return undefined
		*/
		// (Declared outside of the while loop so that it's only created once.
		// (This fn is defined before it is used, in order to pass JSHINT.
		// Unfortunately this breaks the sequencing of the spec comments. :/ )
		function parseDescriptors() {

			// 9. Descriptor parser: Let error be no.
			var pError = false,

			// 10. Let width be absent.
			// 11. Let density be absent.
			// 12. Let future-compat-h be absent. (We're implementing it now as h)
			    w, d, h, i,
			    candidate = {},
			    desc, lastChar, value, intVal, floatVal;

			// 13. For each descriptor in descriptors, run the appropriate set of steps
			// from the following list:
			for (i = 0 ; i < descriptors.length; i++) {
				desc = descriptors[ i ];

				lastChar = desc[ desc.length - 1 ];
				value = desc.substring(0, desc.length - 1);
				intVal = parseInt(value, 10);
				floatVal = parseFloat(value);

				// If the descriptor consists of a valid non-negative integer followed by
				// a U+0077 LATIN SMALL LETTER W character
				if (regexNonNegativeInteger.test(value) && (lastChar === "w")) {

					// If width and density are not both absent, then let error be yes.
					if (w || d) {pError = true;}

					// Apply the rules for parsing non-negative integers to the descriptor.
					// If the result is zero, let error be yes.
					// Otherwise, let width be the result.
					if (intVal === 0) {pError = true;} else {w = intVal;}

				// If the descriptor consists of a valid floating-point number followed by
				// a U+0078 LATIN SMALL LETTER X character
				} else if (regexFloatingPoint.test(value) && (lastChar === "x")) {

					// If width, density and future-compat-h are not all absent, then let error
					// be yes.
					if (w || d || h) {pError = true;}

					// Apply the rules for parsing floating-point number values to the descriptor.
					// If the result is less than zero, let error be yes. Otherwise, let density
					// be the result.
					if (floatVal < 0) {pError = true;} else {d = floatVal;}

				// If the descriptor consists of a valid non-negative integer followed by
				// a U+0068 LATIN SMALL LETTER H character
				} else if (regexNonNegativeInteger.test(value) && (lastChar === "h")) {

					// If height and density are not both absent, then let error be yes.
					if (h || d) {pError = true;}

					// Apply the rules for parsing non-negative integers to the descriptor.
					// If the result is zero, let error be yes. Otherwise, let future-compat-h
					// be the result.
					if (intVal === 0) {pError = true;} else {h = intVal;}

				// Anything else, Let error be yes.
				} else {pError = true;}
			} // (close step 13 for loop)

			// 15. If error is still no, then append a new image source to candidates whose
			// URL is url, associated with a width width if not absent and a pixel
			// density density if not absent. Otherwise, there is a parse error.
			if (!pError) {
				candidate.url = url;

				if (w) { candidate.w = w;}
				if (d) { candidate.d = d;}
				if (h) { candidate.h = h;}
				if (!h && !d && !w) {candidate.d = 1;}
				if (candidate.d === 1) {set.has1x = true;}
				candidate.set = set;

				candidates.push(candidate);
			}
		} // (close parseDescriptors fn)

		/**
		* Tokenizes descriptor properties prior to parsing
		* Returns undefined.
		* (Again, this fn is defined before it is used, in order to pass JSHINT.
		* Unfortunately this breaks the logical sequencing of the spec comments. :/ )
		*/
		function tokenize() {

			// 8.1. Descriptor tokeniser: Skip whitespace
			collectCharacters(regexLeadingSpaces);

			// 8.2. Let current descriptor be the empty string.
			currentDescriptor = "";

			// 8.3. Let state be in descriptor.
			state = "in descriptor";

			while (true) {

				// 8.4. Let c be the character at position.
				c = input.charAt(pos);

				//  Do the following depending on the value of state.
				//  For the purpose of this step, "EOF" is a special character representing
				//  that position is past the end of input.

				// In descriptor
				if (state === "in descriptor") {
					// Do the following, depending on the value of c:

				  // Space character
				  // If current descriptor is not empty, append current descriptor to
				  // descriptors and let current descriptor be the empty string.
				  // Set state to after descriptor.
					if (isSpace(c)) {
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
							currentDescriptor = "";
							state = "after descriptor";
						}

					// U+002C COMMA (,)
					// Advance position to the next character in input. If current descriptor
					// is not empty, append current descriptor to descriptors. Jump to the step
					// labeled descriptor parser.
					} else if (c === ",") {
						pos += 1;
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
						}
						parseDescriptors();
						return;

					// U+0028 LEFT PARENTHESIS (()
					// Append c to current descriptor. Set state to in parens.
					} else if (c === "\u0028") {
						currentDescriptor = currentDescriptor + c;
						state = "in parens";

					// EOF
					// If current descriptor is not empty, append current descriptor to
					// descriptors. Jump to the step labeled descriptor parser.
					} else if (c === "") {
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
						}
						parseDescriptors();
						return;

					// Anything else
					// Append c to current descriptor.
					} else {
						currentDescriptor = currentDescriptor + c;
					}
				// (end "in descriptor"

				// In parens
				} else if (state === "in parens") {

					// U+0029 RIGHT PARENTHESIS ())
					// Append c to current descriptor. Set state to in descriptor.
					if (c === ")") {
						currentDescriptor = currentDescriptor + c;
						state = "in descriptor";

					// EOF
					// Append current descriptor to descriptors. Jump to the step labeled
					// descriptor parser.
					} else if (c === "") {
						descriptors.push(currentDescriptor);
						parseDescriptors();
						return;

					// Anything else
					// Append c to current descriptor.
					} else {
						currentDescriptor = currentDescriptor + c;
					}

				// After descriptor
				} else if (state === "after descriptor") {

					// Do the following, depending on the value of c:
					// Space character: Stay in this state.
					if (isSpace(c)) {

					// EOF: Jump to the step labeled descriptor parser.
					} else if (c === "") {
						parseDescriptors();
						return;

					// Anything else
					// Set state to in descriptor. Set position to the previous character in input.
					} else {
						state = "in descriptor";
						pos -= 1;

					}
				}

				// Advance position to the next character in input.
				pos += 1;

			// Repeat this step.
			} // (close while true loop)
		}

		// 4. Splitting loop: Collect a sequence of characters that are space
		//    characters or U+002C COMMA characters. If any U+002C COMMA characters
		//    were collected, that is a parse error.
		while (true) {
			collectCharacters(regexLeadingCommasOrSpaces);

			// 5. If position is past the end of input, return candidates and abort these steps.
			if (pos >= inputLength) {
				return candidates; // (we're done, this is the sole return path)
			}

			// 6. Collect a sequence of characters that are not space characters,
			//    and let that be url.
			url = collectCharacters(regexLeadingNotSpaces);

			// 7. Let descriptors be a new empty list.
			descriptors = [];

			// 8. If url ends with a U+002C COMMA character (,), follow these substeps:
			//		(1). Remove all trailing U+002C COMMA characters from url. If this removed
			//         more than one character, that is a parse error.
			if (url.slice(-1) === ",") {
				url = url.replace(regexTrailingCommas, "");
				// (Jump ahead to step 9 to skip tokenization and just push the candidate).
				parseDescriptors();

			//	Otherwise, follow these substeps:
			} else {
				tokenize();
			} // (close else of step 8)

		// 16. Return to the step labeled splitting loop.
		} // (Close of big while loop.)
	}

	/*
	 * Sizes Parser
	 *
	 * By Alex Bell |  MIT License
	 *
	 * Non-strict but accurate and lightweight JS Parser for the string value <img sizes="here">
	 *
	 * Reference algorithm at:
	 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-sizes-attribute
	 *
	 * Most comments are copied in directly from the spec
	 * (except for comments in parens).
	 *
	 * Grammar is:
	 * <source-size-list> = <source-size># [ , <source-size-value> ]? | <source-size-value>
	 * <source-size> = <media-condition> <source-size-value>
	 * <source-size-value> = <length>
	 * http://www.w3.org/html/wg/drafts/html/master/embedded-content.html#attr-img-sizes
	 *
	 * E.g. "(max-width: 30em) 100vw, (max-width: 50em) 70vw, 100vw"
	 * or "(min-width: 30em), calc(30vw - 15px)" or just "30vw"
	 *
	 * Returns the first valid <css-length> with a media condition that evaluates to true,
	 * or "100vw" if all valid media conditions evaluate to false.
	 *
	 */

	function parseSizes(strValue) {

		// (Percentage CSS lengths are not allowed in this case, to avoid confusion:
		// https://html.spec.whatwg.org/multipage/embedded-content.html#valid-source-size-list
		// CSS allows a single optional plus or minus sign:
		// http://www.w3.org/TR/CSS2/syndata.html#numbers
		// CSS is ASCII case-insensitive:
		// http://www.w3.org/TR/CSS2/syndata.html#characters )
		// Spec allows exponential notation for <number> type:
		// http://dev.w3.org/csswg/css-values/#numbers
		var regexCssLengthWithUnits = /^(?:[+-]?[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?(?:ch|cm|em|ex|in|mm|pc|pt|px|rem|vh|vmin|vmax|vw)$/i;

		// (This is a quick and lenient test. Because of optional unlimited-depth internal
		// grouping parens and strict spacing rules, this could get very complicated.)
		var regexCssCalc = /^calc\((?:[0-9a-z \.\+\-\*\/\(\)]+)\)$/i;

		var i;
		var unparsedSizesList;
		var unparsedSizesListLength;
		var unparsedSize;
		var lastComponentValue;
		var size;

		// UTILITY FUNCTIONS

		//  (Toy CSS parser. The goals here are:
		//  1) expansive test coverage without the weight of a full CSS parser.
		//  2) Avoiding regex wherever convenient.
		//  Quick tests: http://jsfiddle.net/gtntL4gr/3/
		//  Returns an array of arrays.)
		function parseComponentValues(str) {
			var chrctr;
			var component = "";
			var componentArray = [];
			var listArray = [];
			var parenDepth = 0;
			var pos = 0;
			var inComment = false;

			function pushComponent() {
				if (component) {
					componentArray.push(component);
					component = "";
				}
			}

			function pushComponentArray() {
				if (componentArray[0]) {
					listArray.push(componentArray);
					componentArray = [];
				}
			}

			// (Loop forwards from the beginning of the string.)
			while (true) {
				chrctr = str.charAt(pos);

				if (chrctr === "") { // ( End of string reached.)
					pushComponent();
					pushComponentArray();
					return listArray;
				} else if (inComment) {
					if ((chrctr === "*") && (str[pos + 1] === "/")) { // (At end of a comment.)
						inComment = false;
						pos += 2;
						pushComponent();
						continue;
					} else {
						pos += 1; // (Skip all characters inside comments.)
						continue;
					}
				} else if (isSpace(chrctr)) {
					// (If previous character in loop was also a space, or if
					// at the beginning of the string, do not add space char to
					// component.)
					if ( (str.charAt(pos - 1) && isSpace( str.charAt(pos - 1) ) ) || !component ) {
						pos += 1;
						continue;
					} else if (parenDepth === 0) {
						pushComponent();
						pos +=1;
						continue;
					} else {
						// (Replace any space character with a plain space for legibility.)
						chrctr = " ";
					}
				} else if (chrctr === "(") {
					parenDepth += 1;
				} else if (chrctr === ")") {
					parenDepth -= 1;
				} else if (chrctr === ",") {
					pushComponent();
					pushComponentArray();
					pos += 1;
					continue;
				} else if ( (chrctr === "/") && (str.charAt(pos + 1) === "*") ) {
					inComment = true;
					pos += 2;
					continue;
				}

				component = component + chrctr;
				pos += 1;
			}
		}

		function isValidNonNegativeSourceSizeValue(s) {
			if (regexCssLengthWithUnits.test(s) && (parseFloat(s) >= 0)) {return true;}
			if (regexCssCalc.test(s)) {return true;}
			// ( http://www.w3.org/TR/CSS2/syndata.html#numbers says:
			// "-0 is equivalent to 0 and is not a negative number." which means that
			// unitless zero and unitless negative zero must be accepted as special cases.)
			if ((s === "0") || (s === "-0") || (s === "+0")) {return true;}
			return false;
		}

		// When asked to parse a sizes attribute from an element, parse a
		// comma-separated list of component values from the value of the element's
		// sizes attribute (or the empty string, if the attribute is absent), and let
		// unparsed sizes list be the result.
		// http://dev.w3.org/csswg/css-syntax/#parse-comma-separated-list-of-component-values

		unparsedSizesList = parseComponentValues(strValue);
		unparsedSizesListLength = unparsedSizesList.length;

		// For each unparsed size in unparsed sizes list:
		for (i = 0; i < unparsedSizesListLength; i++) {
			unparsedSize = unparsedSizesList[i];

			// 1. Remove all consecutive <whitespace-token>s from the end of unparsed size.
			// ( parseComponentValues() already omits spaces outside of parens. )

			// If unparsed size is now empty, that is a parse error; continue to the next
			// iteration of this algorithm.
			// ( parseComponentValues() won't push an empty array. )

			// 2. If the last component value in unparsed size is a valid non-negative
			// <source-size-value>, let size be its value and remove the component value
			// from unparsed size. Any CSS function other than the calc() function is
			// invalid. Otherwise, there is a parse error; continue to the next iteration
			// of this algorithm.
			// http://dev.w3.org/csswg/css-syntax/#parse-component-value
			lastComponentValue = unparsedSize[unparsedSize.length - 1];

			if (isValidNonNegativeSourceSizeValue(lastComponentValue)) {
				size = lastComponentValue;
				unparsedSize.pop();
			} else {
				continue;
			}

			// 3. Remove all consecutive <whitespace-token>s from the end of unparsed
			// size. If unparsed size is now empty, return size and exit this algorithm.
			// If this was not the last item in unparsed sizes list, that is a parse error.
			if (unparsedSize.length === 0) {
				return size;
			}

			// 4. Parse the remaining component values in unparsed size as a
			// <media-condition>. If it does not parse correctly, or it does parse
			// correctly but the <media-condition> evaluates to false, continue to the
			// next iteration of this algorithm.
			// (Parsing all possible compound media conditions in JS is heavy, complicated,
			// and the payoff is unclear. Is there ever an situation where the
			// media condition parses incorrectly but still somehow evaluates to true?
			// Can we just rely on the browser/polyfill to do it?)
			unparsedSize = unparsedSize.join(" ");
			if (!(pf.matchesMedia( unparsedSize ) ) ) {
				continue;
			}

			// 5. Return size and exit this algorithm.
			return size;
		}

		// If the above algorithm exhausts unparsed sizes list without returning a
		// size value, return 100vw.
		return "100vw";
	}

	// namespace
	pf.ns = ("pf" + new Date().getTime()).substr(0, 9);

	// srcset support test
	pf.supSrcset = "srcset" in image;
	pf.supSizes = "sizes" in image;
	pf.supPicture = !!window.HTMLPictureElement;

	// UC browser does claim to support srcset and picture, but not sizes,
	// this extended test reveals the browser does support nothing
	if (pf.supSrcset && pf.supPicture && !pf.supSizes) {
		(function(image2) {
			image.srcset = "data:,a";
			image2.src = "data:,a";
			pf.supSrcset = image.complete === image2.complete;
			pf.supPicture = pf.supSrcset && pf.supPicture;
		})(document.createElement("img"));
	}

	// Safari9 has basic support for sizes, but does't expose the `sizes` idl attribute
	if (pf.supSrcset && !pf.supSizes) {

		(function() {
			var width2 = "data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw==";
			var width1 = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
			var img = document.createElement("img");
			var test = function() {
				var width = img.width;

				if (width === 2) {
					pf.supSizes = true;
				}

				alwaysCheckWDescriptor = pf.supSrcset && !pf.supSizes;

				isSupportTestReady = true;
				// force async
				setTimeout(picturefill);
			};

			img.onload = test;
			img.onerror = test;
			img.setAttribute("sizes", "9px");

			img.srcset = width1 + " 1w," + width2 + " 9w";
			img.src = width1;
		})();

	} else {
		isSupportTestReady = true;
	}

	// using pf.qsa instead of dom traversing does scale much better,
	// especially on sites mixing responsive and non-responsive images
	pf.selShort = "picture>img,img[srcset]";
	pf.sel = pf.selShort;
	pf.cfg = cfg;

	/**
	 * Shortcut property for `devicePixelRatio` ( for easy overriding in tests )
	 */
	pf.DPR = (DPR  || 1 );
	pf.u = units;

	// container of supported mime types that one might need to qualify before using
	pf.types =  types;

	pf.setSize = noop;

	/**
	 * Gets a string and returns the absolute URL
	 * @param src
	 * @returns {String} absolute URL
	 */

	pf.makeUrl = memoize(function(src) {
		anchor.href = src;
		return anchor.href;
	});

	/**
	 * Gets a DOM element or document and a selctor and returns the found matches
	 * Can be extended with jQuery/Sizzle for IE7 support
	 * @param context
	 * @param sel
	 * @returns {NodeList|Array}
	 */
	pf.qsa = function(context, sel) {
		return ( "querySelector" in context ) ? context.querySelectorAll(sel) : [];
	};

	/**
	 * Shortcut method for matchMedia ( for easy overriding in tests )
	 * wether native or pf.mMQ is used will be decided lazy on first call
	 * @returns {boolean}
	 */
	pf.matchesMedia = function() {
		if ( window.matchMedia && (matchMedia( "(min-width: 0.1em)" ) || {}).matches ) {
			pf.matchesMedia = function( media ) {
				return !media || ( matchMedia( media ).matches );
			};
		} else {
			pf.matchesMedia = pf.mMQ;
		}

		return pf.matchesMedia.apply( this, arguments );
	};

	/**
	 * A simplified matchMedia implementation for IE8 and IE9
	 * handles only min-width/max-width with px or em values
	 * @param media
	 * @returns {boolean}
	 */
	pf.mMQ = function( media ) {
		return media ? evalCSS(media) : true;
	};

	/**
	 * Returns the calculated length in css pixel from the given sourceSizeValue
	 * http://dev.w3.org/csswg/css-values-3/#length-value
	 * intended Spec mismatches:
	 * * Does not check for invalid use of CSS functions
	 * * Does handle a computed length of 0 the same as a negative and therefore invalid value
	 * @param sourceSizeValue
	 * @returns {Number}
	 */
	pf.calcLength = function( sourceSizeValue ) {

		var value = evalCSS(sourceSizeValue, true) || false;
		if (value < 0) {
			value = false;
		}

		return value;
	};

	/**
	 * Takes a type string and checks if its supported
	 */

	pf.supportsType = function( type ) {
		return ( type ) ? types[ type ] : true;
	};

	/**
	 * Parses a sourceSize into mediaCondition (media) and sourceSizeValue (length)
	 * @param sourceSizeStr
	 * @returns {*}
	 */
	pf.parseSize = memoize(function( sourceSizeStr ) {
		var match = ( sourceSizeStr || "" ).match(regSize);
		return {
			media: match && match[1],
			length: match && match[2]
		};
	});

	pf.parseSet = function( set ) {
		if ( !set.cands ) {
			set.cands = parseSrcset(set.srcset, set);
		}
		return set.cands;
	};

	/**
	 * returns 1em in css px for html/body default size
	 * function taken from respondjs
	 * @returns {*|number}
	 */
	pf.getEmValue = function() {
		var body;
		if ( !eminpx && (body = document.body) ) {
			var div = document.createElement( "div" ),
				originalHTMLCSS = docElem.style.cssText,
				originalBodyCSS = body.style.cssText;

			div.style.cssText = baseStyle;

			// 1em in a media query is the value of the default font size of the browser
			// reset docElem and body to ensure the correct value is returned
			docElem.style.cssText = fsCss;
			body.style.cssText = fsCss;

			body.appendChild( div );
			eminpx = div.offsetWidth;
			body.removeChild( div );

			//also update eminpx before returning
			eminpx = parseFloat( eminpx, 10 );

			// restore the original values
			docElem.style.cssText = originalHTMLCSS;
			body.style.cssText = originalBodyCSS;

		}
		return eminpx || 16;
	};

	/**
	 * Takes a string of sizes and returns the width in pixels as a number
	 */
	pf.calcListLength = function( sourceSizeListStr ) {
		// Split up source size list, ie ( max-width: 30em ) 100%, ( max-width: 50em ) 50%, 33%
		//
		//                           or (min-width:30em) calc(30% - 15px)
		if ( !(sourceSizeListStr in sizeLengthCache) || cfg.uT ) {
			var winningLength = pf.calcLength( parseSizes( sourceSizeListStr ) );

			sizeLengthCache[ sourceSizeListStr ] = !winningLength ? units.width : winningLength;
		}

		return sizeLengthCache[ sourceSizeListStr ];
	};

	/**
	 * Takes a candidate object with a srcset property in the form of url/
	 * ex. "images/pic-medium.png 1x, images/pic-medium-2x.png 2x" or
	 *     "images/pic-medium.png 400w, images/pic-medium-2x.png 800w" or
	 *     "images/pic-small.png"
	 * Get an array of image candidates in the form of
	 *      {url: "/foo/bar.png", resolution: 1}
	 * where resolution is http://dev.w3.org/csswg/css-values-3/#resolution-value
	 * If sizes is specified, res is calculated
	 */
	pf.setRes = function( set ) {
		var candidates;
		if ( set ) {

			candidates = pf.parseSet( set );

			for ( var i = 0, len = candidates.length; i < len; i++ ) {
				setResolution( candidates[ i ], set.sizes );
			}
		}
		return candidates;
	};

	pf.setRes.res = setResolution;

	pf.applySetCandidate = function( candidates, img ) {
		if ( !candidates.length ) {return;}
		var candidate,
			i,
			j,
			length,
			bestCandidate,
			curSrc,
			curCan,
			candidateSrc,
			abortCurSrc;

		var imageData = img[ pf.ns ];
		var dpr = pf.DPR;

		curSrc = imageData.curSrc || img[curSrcProp];

		curCan = imageData.curCan || setSrcToCur(img, curSrc, candidates[0].set);

		// if we have a current source, we might either become lazy or give this source some advantage
		if ( curCan && curCan.set === candidates[ 0 ].set ) {

			// if browser can abort image request and the image has a higher pixel density than needed
			// and this image isn't downloaded yet, we skip next part and try to save bandwidth
			abortCurSrc = (supportAbort && !img.complete && curCan.res - 0.1 > dpr);

			if ( !abortCurSrc ) {
				curCan.cached = true;

				// if current candidate is "best", "better" or "okay",
				// set it to bestCandidate
				if ( curCan.res >= dpr ) {
					bestCandidate = curCan;
				}
			}
		}

		if ( !bestCandidate ) {

			candidates.sort( ascendingSort );

			length = candidates.length;
			bestCandidate = candidates[ length - 1 ];

			for ( i = 0; i < length; i++ ) {
				candidate = candidates[ i ];
				if ( candidate.res >= dpr ) {
					j = i - 1;

					// we have found the perfect candidate,
					// but let's improve this a little bit with some assumptions ;-)
					if (candidates[ j ] &&
						(abortCurSrc || curSrc !== pf.makeUrl( candidate.url )) &&
						chooseLowRes(candidates[ j ].res, candidate.res, dpr, candidates[ j ].cached)) {

						bestCandidate = candidates[ j ];

					} else {
						bestCandidate = candidate;
					}
					break;
				}
			}
		}

		if ( bestCandidate ) {

			candidateSrc = pf.makeUrl( bestCandidate.url );

			imageData.curSrc = candidateSrc;
			imageData.curCan = bestCandidate;

			if ( candidateSrc !== curSrc ) {
				pf.setSrc( img, bestCandidate );
			}
			pf.setSize( img );
		}
	};

	pf.setSrc = function( img, bestCandidate ) {
		var origWidth;
		img.src = bestCandidate.url;

		// although this is a specific Safari issue, we don't want to take too much different code paths
		if ( bestCandidate.set.type === "image/svg+xml" ) {
			origWidth = img.style.width;
			img.style.width = (img.offsetWidth + 1) + "px";

			// next line only should trigger a repaint
			// if... is only done to trick dead code removal
			if ( img.offsetWidth + 1 ) {
				img.style.width = origWidth;
			}
		}
	};

	pf.getSet = function( img ) {
		var i, set, supportsType;
		var match = false;
		var sets = img [ pf.ns ].sets;

		for ( i = 0; i < sets.length && !match; i++ ) {
			set = sets[i];

			if ( !set.srcset || !pf.matchesMedia( set.media ) || !(supportsType = pf.supportsType( set.type )) ) {
				continue;
			}

			if ( supportsType === "pending" ) {
				set = supportsType;
			}

			match = set;
			break;
		}

		return match;
	};

	pf.parseSets = function( element, parent, options ) {
		var srcsetAttribute, imageSet, isWDescripor, srcsetParsed;

		var hasPicture = parent && parent.nodeName.toUpperCase() === "PICTURE";
		var imageData = element[ pf.ns ];

		if ( imageData.src === undefined || options.src ) {
			imageData.src = getImgAttr.call( element, "src" );
			if ( imageData.src ) {
				setImgAttr.call( element, srcAttr, imageData.src );
			} else {
				removeImgAttr.call( element, srcAttr );
			}
		}

		if ( imageData.srcset === undefined || options.srcset || !pf.supSrcset || element.srcset ) {
			srcsetAttribute = getImgAttr.call( element, "srcset" );
			imageData.srcset = srcsetAttribute;
			srcsetParsed = true;
		}

		imageData.sets = [];

		if ( hasPicture ) {
			imageData.pic = true;
			getAllSourceElements( parent, imageData.sets );
		}

		if ( imageData.srcset ) {
			imageSet = {
				srcset: imageData.srcset,
				sizes: getImgAttr.call( element, "sizes" )
			};

			imageData.sets.push( imageSet );

			isWDescripor = (alwaysCheckWDescriptor || imageData.src) && regWDesc.test(imageData.srcset || "");

			// add normal src as candidate, if source has no w descriptor
			if ( !isWDescripor && imageData.src && !getCandidateForSrc(imageData.src, imageSet) && !imageSet.has1x ) {
				imageSet.srcset += ", " + imageData.src;
				imageSet.cands.push({
					url: imageData.src,
					d: 1,
					set: imageSet
				});
			}

		} else if ( imageData.src ) {
			imageData.sets.push( {
				srcset: imageData.src,
				sizes: null
			} );
		}

		imageData.curCan = null;
		imageData.curSrc = undefined;

		// if img has picture or the srcset was removed or has a srcset and does not support srcset at all
		// or has a w descriptor (and does not support sizes) set support to false to evaluate
		imageData.supported = !( hasPicture || ( imageSet && !pf.supSrcset ) || (isWDescripor && !pf.supSizes) );

		if ( srcsetParsed && pf.supSrcset && !imageData.supported ) {
			if ( srcsetAttribute ) {
				setImgAttr.call( element, srcsetAttr, srcsetAttribute );
				element.srcset = "";
			} else {
				removeImgAttr.call( element, srcsetAttr );
			}
		}

		if (imageData.supported && !imageData.srcset && ((!imageData.src && element.src) ||  element.src !== pf.makeUrl(imageData.src))) {
			if (imageData.src === null) {
				element.removeAttribute("src");
			} else {
				element.src = imageData.src;
			}
		}

		imageData.parsed = true;
	};

	pf.fillImg = function(element, options) {
		var imageData;
		var extreme = options.reselect || options.reevaluate;

		// expando for caching data on the img
		if ( !element[ pf.ns ] ) {
			element[ pf.ns ] = {};
		}

		imageData = element[ pf.ns ];

		// if the element has already been evaluated, skip it
		// unless `options.reevaluate` is set to true ( this, for example,
		// is set to true when running `picturefill` on `resize` ).
		if ( !extreme && imageData.evaled === evalId ) {
			return;
		}

		if ( !imageData.parsed || options.reevaluate ) {
			pf.parseSets( element, element.parentNode, options );
		}

		if ( !imageData.supported ) {
			applyBestCandidate( element );
		} else {
			imageData.evaled = evalId;
		}
	};

	pf.setupRun = function() {
		if ( !alreadyRun || isVwDirty || (DPR !== window.devicePixelRatio) ) {
			updateMetrics();
		}
	};

	// If picture is supported, well, that's awesome.
	if ( pf.supPicture ) {
		picturefill = noop;
		pf.fillImg = noop;
	} else {

		 // Set up picture polyfill by polling the document
		(function() {
			var isDomReady;
			var regReady = window.attachEvent ? /d$|^c/ : /d$|^c|^i/;

			var run = function() {
				var readyState = document.readyState || "";

				timerId = setTimeout(run, readyState === "loading" ? 200 :  999);
				if ( document.body ) {
					pf.fillImgs();
					isDomReady = isDomReady || regReady.test(readyState);
					if ( isDomReady ) {
						clearTimeout( timerId );
					}

				}
			};

			var timerId = setTimeout(run, document.body ? 9 : 99);

			// Also attach picturefill on resize and readystatechange
			// http://modernjavascript.blogspot.com/2013/08/building-better-debounce.html
			var debounce = function(func, wait) {
				var timeout, timestamp;
				var later = function() {
					var last = (new Date()) - timestamp;

					if (last < wait) {
						timeout = setTimeout(later, wait - last);
					} else {
						timeout = null;
						func();
					}
				};

				return function() {
					timestamp = new Date();

					if (!timeout) {
						timeout = setTimeout(later, wait);
					}
				};
			};
			var lastClientWidth = docElem.clientHeight;
			var onResize = function() {
				isVwDirty = Math.max(window.innerWidth || 0, docElem.clientWidth) !== units.width || docElem.clientHeight !== lastClientWidth;
				lastClientWidth = docElem.clientHeight;
				if ( isVwDirty ) {
					pf.fillImgs();
				}
			};

			on( window, "resize", debounce(onResize, 99 ) );
			on( document, "readystatechange", run );
		})();
	}

	pf.picturefill = picturefill;
	//use this internally for easy monkey patching/performance testing
	pf.fillImgs = picturefill;
	pf.teardownRun = noop;

	/* expose methods for testing */
	picturefill._ = pf;

	window.picturefillCFG = {
		pf: pf,
		push: function(args) {
			var name = args.shift();
			if (typeof pf[name] === "function") {
				pf[name].apply(pf, args);
			} else {
				cfg[name] = args[0];
				if (alreadyRun) {
					pf.fillImgs( { reselect: true } );
				}
			}
		}
	};

	while (setOptions && setOptions.length) {
		window.picturefillCFG.push(setOptions.shift());
	}

	/* expose picturefill */
	window.picturefill = picturefill;

	/* expose picturefill */
	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// CommonJS, just export
		module.exports = picturefill;
	} else if ( true ) {
		// AMD support
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return picturefill; }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}

	// IE8 evals this sync, so it must be the last thing we do
	if ( !pf.supPicture ) {
		types[ "image/webp" ] = detectTypeSupport("image/webp", "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==" );
	}

} )( window, document );


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(root, factory) {
     true ? // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
        return root.svg4everybody = factory();
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == typeof module && module.exports ? // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory() : root.svg4everybody = factory();
}(this, function() {
    /*! svg4everybody v2.1.9 | github.com/jonathantneal/svg4everybody */
    function embed(parent, svg, target) {
        // if the target exists
        if (target) {
            // create a document fragment to hold the contents of the target
            var fragment = document.createDocumentFragment(), viewBox = !svg.hasAttribute("viewBox") && target.getAttribute("viewBox");
            // conditionally set the viewBox on the svg
            viewBox && svg.setAttribute("viewBox", viewBox);
            // copy the contents of the clone into the fragment
            for (// clone the target
            var clone = target.cloneNode(!0); clone.childNodes.length; ) {
                fragment.appendChild(clone.firstChild);
            }
            // append the fragment into the svg
            parent.appendChild(fragment);
        }
    }
    function loadreadystatechange(xhr) {
        // listen to changes in the request
        xhr.onreadystatechange = function() {
            // if the request is ready
            if (4 === xhr.readyState) {
                // get the cached html document
                var cachedDocument = xhr._cachedDocument;
                // ensure the cached html document based on the xhr response
                cachedDocument || (cachedDocument = xhr._cachedDocument = document.implementation.createHTMLDocument(""), 
                cachedDocument.body.innerHTML = xhr.responseText, xhr._cachedTarget = {}), // clear the xhr embeds list and embed each item
                xhr._embeds.splice(0).map(function(item) {
                    // get the cached target
                    var target = xhr._cachedTarget[item.id];
                    // ensure the cached target
                    target || (target = xhr._cachedTarget[item.id] = cachedDocument.getElementById(item.id)), 
                    // embed the target into the svg
                    embed(item.parent, item.svg, target);
                });
            }
        }, // test the ready state change immediately
        xhr.onreadystatechange();
    }
    function svg4everybody(rawopts) {
        function oninterval() {
            // while the index exists in the live <use> collection
            for (// get the cached <use> index
            var index = 0; index < uses.length; ) {
                // get the current <use>
                var use = uses[index], parent = use.parentNode, svg = getSVGAncestor(parent), src = use.getAttribute("xlink:href") || use.getAttribute("href");
                if (!src && opts.attributeName && (src = use.getAttribute(opts.attributeName)), 
                svg && src) {
                    if (polyfill) {
                        if (!opts.validate || opts.validate(src, svg, use)) {
                            // remove the <use> element
                            parent.removeChild(use);
                            // parse the src and get the url and id
                            var srcSplit = src.split("#"), url = srcSplit.shift(), id = srcSplit.join("#");
                            // if the link is external
                            if (url.length) {
                                // get the cached xhr request
                                var xhr = requests[url];
                                // ensure the xhr request exists
                                xhr || (xhr = requests[url] = new XMLHttpRequest(), xhr.open("GET", url), xhr.send(), 
                                xhr._embeds = []), // add the svg and id as an item to the xhr embeds list
                                xhr._embeds.push({
                                    parent: parent,
                                    svg: svg,
                                    id: id
                                }), // prepare the xhr ready state change event
                                loadreadystatechange(xhr);
                            } else {
                                // embed the local id into the svg
                                embed(parent, svg, document.getElementById(id));
                            }
                        } else {
                            // increase the index when the previous value was not "valid"
                            ++index, ++numberOfSvgUseElementsToBypass;
                        }
                    }
                } else {
                    // increase the index when the previous value was not "valid"
                    ++index;
                }
            }
            // continue the interval
            (!uses.length || uses.length - numberOfSvgUseElementsToBypass > 0) && requestAnimationFrame(oninterval, 67);
        }
        var polyfill, opts = Object(rawopts), newerIEUA = /\bTrident\/[567]\b|\bMSIE (?:9|10)\.0\b/, webkitUA = /\bAppleWebKit\/(\d+)\b/, olderEdgeUA = /\bEdge\/12\.(\d+)\b/, edgeUA = /\bEdge\/.(\d+)\b/, inIframe = window.top !== window.self;
        polyfill = "polyfill" in opts ? opts.polyfill : newerIEUA.test(navigator.userAgent) || (navigator.userAgent.match(olderEdgeUA) || [])[1] < 10547 || (navigator.userAgent.match(webkitUA) || [])[1] < 537 || edgeUA.test(navigator.userAgent) && inIframe;
        // create xhr requests object
        var requests = {}, requestAnimationFrame = window.requestAnimationFrame || setTimeout, uses = document.getElementsByTagName("use"), numberOfSvgUseElementsToBypass = 0;
        // conditionally start the interval if the polyfill is active
        polyfill && oninterval();
    }
    function getSVGAncestor(node) {
        for (var svg = node; "svg" !== svg.nodeName.toLowerCase() && (svg = svg.parentNode); ) {}
        return svg;
    }
    return svg4everybody;
});

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! npm.im/object-fit-images 3.2.3 */


var OFI = 'bfred-it:object-fit-images';
var propRegex = /(object-fit|object-position)\s*:\s*([-\w\s%]+)/g;
var testImg = typeof Image === 'undefined' ? {style: {'object-position': 1}} : new Image();
var supportsObjectFit = 'object-fit' in testImg.style;
var supportsObjectPosition = 'object-position' in testImg.style;
var supportsOFI = 'background-size' in testImg.style;
var supportsCurrentSrc = typeof testImg.currentSrc === 'string';
var nativeGetAttribute = testImg.getAttribute;
var nativeSetAttribute = testImg.setAttribute;
var autoModeEnabled = false;

function createPlaceholder(w, h) {
	return ("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E");
}

function polyfillCurrentSrc(el) {
	if (el.srcset && !supportsCurrentSrc && window.picturefill) {
		var pf = window.picturefill._;
		// parse srcset with picturefill where currentSrc isn't available
		if (!el[pf.ns] || !el[pf.ns].evaled) {
			// force synchronous srcset parsing
			pf.fillImg(el, {reselect: true});
		}

		if (!el[pf.ns].curSrc) {
			// force picturefill to parse srcset
			el[pf.ns].supported = false;
			pf.fillImg(el, {reselect: true});
		}

		// retrieve parsed currentSrc, if any
		el.currentSrc = el[pf.ns].curSrc || el.src;
	}
}

function getStyle(el) {
	var style = getComputedStyle(el).fontFamily;
	var parsed;
	var props = {};
	while ((parsed = propRegex.exec(style)) !== null) {
		props[parsed[1]] = parsed[2];
	}
	return props;
}

function setPlaceholder(img, width, height) {
	// Default: fill width, no height
	var placeholder = createPlaceholder(width || 1, height || 0);

	// Only set placeholder if it's different
	if (nativeGetAttribute.call(img, 'src') !== placeholder) {
		nativeSetAttribute.call(img, 'src', placeholder);
	}
}

function onImageReady(img, callback) {
	// naturalWidth is only available when the image headers are loaded,
	// this loop will poll it every 100ms.
	if (img.naturalWidth) {
		callback(img);
	} else {
		setTimeout(onImageReady, 100, img, callback);
	}
}

function fixOne(el) {
	var style = getStyle(el);
	var ofi = el[OFI];
	style['object-fit'] = style['object-fit'] || 'fill'; // default value

	// Avoid running where unnecessary, unless OFI had already done its deed
	if (!ofi.img) {
		// fill is the default behavior so no action is necessary
		if (style['object-fit'] === 'fill') {
			return;
		}

		// Where object-fit is supported and object-position isn't (Safari < 10)
		if (
			!ofi.skipTest && // unless user wants to apply regardless of browser support
			supportsObjectFit && // if browser already supports object-fit
			!style['object-position'] // unless object-position is used
		) {
			return;
		}
	}

	// keep a clone in memory while resetting the original to a blank
	if (!ofi.img) {
		ofi.img = new Image(el.width, el.height);
		ofi.img.srcset = nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
		ofi.img.src = nativeGetAttribute.call(el, "data-ofi-src") || el.src;

		// preserve for any future cloneNode calls
		// https://github.com/bfred-it/object-fit-images/issues/53
		nativeSetAttribute.call(el, "data-ofi-src", el.src);
		if (el.srcset) {
			nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
		}

		setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);

		// remove srcset because it overrides src
		if (el.srcset) {
			el.srcset = '';
		}
		try {
			keepSrcUsable(el);
		} catch (err) {
			if (window.console) {
				console.warn('https://bit.ly/ofi-old-browser');
			}
		}
	}

	polyfillCurrentSrc(ofi.img);

	el.style.backgroundImage = "url(\"" + ((ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"')) + "\")";
	el.style.backgroundPosition = style['object-position'] || 'center';
	el.style.backgroundRepeat = 'no-repeat';
	el.style.backgroundOrigin = 'content-box';

	if (/scale-down/.test(style['object-fit'])) {
		onImageReady(ofi.img, function () {
			if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) {
				el.style.backgroundSize = 'contain';
			} else {
				el.style.backgroundSize = 'auto';
			}
		});
	} else {
		el.style.backgroundSize = style['object-fit'].replace('none', 'auto').replace('fill', '100% 100%');
	}

	onImageReady(ofi.img, function (img) {
		setPlaceholder(el, img.naturalWidth, img.naturalHeight);
	});
}

function keepSrcUsable(el) {
	var descriptors = {
		get: function get(prop) {
			return el[OFI].img[prop ? prop : 'src'];
		},
		set: function set(value, prop) {
			el[OFI].img[prop ? prop : 'src'] = value;
			nativeSetAttribute.call(el, ("data-ofi-" + prop), value); // preserve for any future cloneNode
			fixOne(el);
			return value;
		}
	};
	Object.defineProperty(el, 'src', descriptors);
	Object.defineProperty(el, 'currentSrc', {
		get: function () { return descriptors.get('currentSrc'); }
	});
	Object.defineProperty(el, 'srcset', {
		get: function () { return descriptors.get('srcset'); },
		set: function (ss) { return descriptors.set(ss, 'srcset'); }
	});
}

function hijackAttributes() {
	function getOfiImageMaybe(el, name) {
		return el[OFI] && el[OFI].img && (name === 'src' || name === 'srcset') ? el[OFI].img : el;
	}
	if (!supportsObjectPosition) {
		HTMLImageElement.prototype.getAttribute = function (name) {
			return nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
		};

		HTMLImageElement.prototype.setAttribute = function (name, value) {
			return nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
		};
	}
}

function fix(imgs, opts) {
	var startAutoMode = !autoModeEnabled && !imgs;
	opts = opts || {};
	imgs = imgs || 'img';

	if ((supportsObjectPosition && !opts.skipTest) || !supportsOFI) {
		return false;
	}

	// use imgs as a selector or just select all images
	if (imgs === 'img') {
		imgs = document.getElementsByTagName('img');
	} else if (typeof imgs === 'string') {
		imgs = document.querySelectorAll(imgs);
	} else if (!('length' in imgs)) {
		imgs = [imgs];
	}

	// apply fix to all
	for (var i = 0; i < imgs.length; i++) {
		imgs[i][OFI] = imgs[i][OFI] || {
			skipTest: opts.skipTest
		};
		fixOne(imgs[i]);
	}

	if (startAutoMode) {
		document.body.addEventListener('load', function (e) {
			if (e.target.tagName === 'IMG') {
				fix(e.target, {
					skipTest: opts.skipTest
				});
			}
		}, true);
		autoModeEnabled = true;
		imgs = 'img'; // reset to a generic selector for watchMQ
	}

	// if requested, watch media queries for object-fit change
	if (opts.watchMQ) {
		window.addEventListener('resize', fix.bind(null, imgs, {
			skipTest: opts.skipTest
		}));
	}
}

fix.supportsObjectFit = supportsObjectFit;
fix.supportsObjectPosition = supportsObjectPosition;

hijackAttributes();

module.exports = fix;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Magnific Popup - v1.1.0 - 2016-02-20
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2016 Dmitry Semenov; */
;(function (factory) { 
if (true) { 
 // AMD. Register as an anonymous module. 
 !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); 
 } else if (typeof exports === 'object') { 
 // Node/CommonJS 
 factory(require('jquery')); 
 } else { 
 // Browser globals 
 factory(window.jQuery || window.Zepto); 
 } 
 }(function($) { 

/*>>core*/
/**
 * 
 * Magnific Popup Core JS file
 * 
 */


/**
 * Private static constants
 */
var CLOSE_EVENT = 'Close',
	BEFORE_CLOSE_EVENT = 'BeforeClose',
	AFTER_CLOSE_EVENT = 'AfterClose',
	BEFORE_APPEND_EVENT = 'BeforeAppend',
	MARKUP_PARSE_EVENT = 'MarkupParse',
	OPEN_EVENT = 'Open',
	CHANGE_EVENT = 'Change',
	NS = 'mfp',
	EVENT_NS = '.' + NS,
	READY_CLASS = 'mfp-ready',
	REMOVING_CLASS = 'mfp-removing',
	PREVENT_CLOSE_CLASS = 'mfp-prevent-close';


/**
 * Private vars 
 */
/*jshint -W079 */
var mfp, // As we have only one instance of MagnificPopup object, we define it locally to not to use 'this'
	MagnificPopup = function(){},
	_isJQ = !!(window.jQuery),
	_prevStatus,
	_window = $(window),
	_document,
	_prevContentType,
	_wrapClasses,
	_currPopupType;


/**
 * Private functions
 */
var _mfpOn = function(name, f) {
		mfp.ev.on(NS + name + EVENT_NS, f);
	},
	_getEl = function(className, appendTo, html, raw) {
		var el = document.createElement('div');
		el.className = 'mfp-'+className;
		if(html) {
			el.innerHTML = html;
		}
		if(!raw) {
			el = $(el);
			if(appendTo) {
				el.appendTo(appendTo);
			}
		} else if(appendTo) {
			appendTo.appendChild(el);
		}
		return el;
	},
	_mfpTrigger = function(e, data) {
		mfp.ev.triggerHandler(NS + e, data);

		if(mfp.st.callbacks) {
			// converts "mfpEventName" to "eventName" callback and triggers it if it's present
			e = e.charAt(0).toLowerCase() + e.slice(1);
			if(mfp.st.callbacks[e]) {
				mfp.st.callbacks[e].apply(mfp, $.isArray(data) ? data : [data]);
			}
		}
	},
	_getCloseBtn = function(type) {
		if(type !== _currPopupType || !mfp.currTemplate.closeBtn) {
			mfp.currTemplate.closeBtn = $( mfp.st.closeMarkup.replace('%title%', mfp.st.tClose ) );
			_currPopupType = type;
		}
		return mfp.currTemplate.closeBtn;
	},
	// Initialize Magnific Popup only when called at least once
	_checkInstance = function() {
		if(!$.magnificPopup.instance) {
			/*jshint -W020 */
			mfp = new MagnificPopup();
			mfp.init();
			$.magnificPopup.instance = mfp;
		}
	},
	// CSS transition detection, http://stackoverflow.com/questions/7264899/detect-css-transitions-using-javascript-and-without-modernizr
	supportsTransitions = function() {
		var s = document.createElement('p').style, // 's' for style. better to create an element if body yet to exist
			v = ['ms','O','Moz','Webkit']; // 'v' for vendor

		if( s['transition'] !== undefined ) {
			return true; 
		}
			
		while( v.length ) {
			if( v.pop() + 'Transition' in s ) {
				return true;
			}
		}
				
		return false;
	};



/**
 * Public functions
 */
MagnificPopup.prototype = {

	constructor: MagnificPopup,

	/**
	 * Initializes Magnific Popup plugin. 
	 * This function is triggered only once when $.fn.magnificPopup or $.magnificPopup is executed
	 */
	init: function() {
		var appVersion = navigator.appVersion;
		mfp.isLowIE = mfp.isIE8 = document.all && !document.addEventListener;
		mfp.isAndroid = (/android/gi).test(appVersion);
		mfp.isIOS = (/iphone|ipad|ipod/gi).test(appVersion);
		mfp.supportsTransition = supportsTransitions();

		// We disable fixed positioned lightbox on devices that don't handle it nicely.
		// If you know a better way of detecting this - let me know.
		mfp.probablyMobile = (mfp.isAndroid || mfp.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent) );
		_document = $(document);

		mfp.popupsCache = {};
	},

	/**
	 * Opens popup
	 * @param  data [description]
	 */
	open: function(data) {

		var i;

		if(data.isObj === false) { 
			// convert jQuery collection to array to avoid conflicts later
			mfp.items = data.items.toArray();

			mfp.index = 0;
			var items = data.items,
				item;
			for(i = 0; i < items.length; i++) {
				item = items[i];
				if(item.parsed) {
					item = item.el[0];
				}
				if(item === data.el[0]) {
					mfp.index = i;
					break;
				}
			}
		} else {
			mfp.items = $.isArray(data.items) ? data.items : [data.items];
			mfp.index = data.index || 0;
		}

		// if popup is already opened - we just update the content
		if(mfp.isOpen) {
			mfp.updateItemHTML();
			return;
		}
		
		mfp.types = []; 
		_wrapClasses = '';
		if(data.mainEl && data.mainEl.length) {
			mfp.ev = data.mainEl.eq(0);
		} else {
			mfp.ev = _document;
		}

		if(data.key) {
			if(!mfp.popupsCache[data.key]) {
				mfp.popupsCache[data.key] = {};
			}
			mfp.currTemplate = mfp.popupsCache[data.key];
		} else {
			mfp.currTemplate = {};
		}



		mfp.st = $.extend(true, {}, $.magnificPopup.defaults, data ); 
		mfp.fixedContentPos = mfp.st.fixedContentPos === 'auto' ? !mfp.probablyMobile : mfp.st.fixedContentPos;

		if(mfp.st.modal) {
			mfp.st.closeOnContentClick = false;
			mfp.st.closeOnBgClick = false;
			mfp.st.showCloseBtn = false;
			mfp.st.enableEscapeKey = false;
		}
		

		// Building markup
		// main containers are created only once
		if(!mfp.bgOverlay) {

			// Dark overlay
			mfp.bgOverlay = _getEl('bg').on('click'+EVENT_NS, function() {
				mfp.close();
			});

			mfp.wrap = _getEl('wrap').attr('tabindex', -1).on('click'+EVENT_NS, function(e) {
				if(mfp._checkIfClose(e.target)) {
					mfp.close();
				}
			});

			mfp.container = _getEl('container', mfp.wrap);
		}

		mfp.contentContainer = _getEl('content');
		if(mfp.st.preloader) {
			mfp.preloader = _getEl('preloader', mfp.container, mfp.st.tLoading);
		}


		// Initializing modules
		var modules = $.magnificPopup.modules;
		for(i = 0; i < modules.length; i++) {
			var n = modules[i];
			n = n.charAt(0).toUpperCase() + n.slice(1);
			mfp['init'+n].call(mfp);
		}
		_mfpTrigger('BeforeOpen');


		if(mfp.st.showCloseBtn) {
			// Close button
			if(!mfp.st.closeBtnInside) {
				mfp.wrap.append( _getCloseBtn() );
			} else {
				_mfpOn(MARKUP_PARSE_EVENT, function(e, template, values, item) {
					values.close_replaceWith = _getCloseBtn(item.type);
				});
				_wrapClasses += ' mfp-close-btn-in';
			}
		}

		if(mfp.st.alignTop) {
			_wrapClasses += ' mfp-align-top';
		}

	

		if(mfp.fixedContentPos) {
			mfp.wrap.css({
				overflow: mfp.st.overflowY,
				overflowX: 'hidden',
				overflowY: mfp.st.overflowY
			});
		} else {
			mfp.wrap.css({ 
				top: _window.scrollTop(),
				position: 'absolute'
			});
		}
		if( mfp.st.fixedBgPos === false || (mfp.st.fixedBgPos === 'auto' && !mfp.fixedContentPos) ) {
			mfp.bgOverlay.css({
				height: _document.height(),
				position: 'absolute'
			});
		}

		

		if(mfp.st.enableEscapeKey) {
			// Close on ESC key
			_document.on('keyup' + EVENT_NS, function(e) {
				if(e.keyCode === 27) {
					mfp.close();
				}
			});
		}

		_window.on('resize' + EVENT_NS, function() {
			mfp.updateSize();
		});


		if(!mfp.st.closeOnContentClick) {
			_wrapClasses += ' mfp-auto-cursor';
		}
		
		if(_wrapClasses)
			mfp.wrap.addClass(_wrapClasses);


		// this triggers recalculation of layout, so we get it once to not to trigger twice
		var windowHeight = mfp.wH = _window.height();

		
		var windowStyles = {};

		if( mfp.fixedContentPos ) {
            if(mfp._hasScrollBar(windowHeight)){
                var s = mfp._getScrollbarSize();
                if(s) {
                    windowStyles.marginRight = s;
                }
            }
        }

		if(mfp.fixedContentPos) {
			if(!mfp.isIE7) {
				windowStyles.overflow = 'hidden';
			} else {
				// ie7 double-scroll bug
				$('body, html').css('overflow', 'hidden');
			}
		}

		
		
		var classesToadd = mfp.st.mainClass;
		if(mfp.isIE7) {
			classesToadd += ' mfp-ie7';
		}
		if(classesToadd) {
			mfp._addClassToMFP( classesToadd );
		}

		// add content
		mfp.updateItemHTML();

		_mfpTrigger('BuildControls');

		// remove scrollbar, add margin e.t.c
		$('html').css(windowStyles);
		
		// add everything to DOM
		mfp.bgOverlay.add(mfp.wrap).prependTo( mfp.st.prependTo || $(document.body) );

		// Save last focused element
		mfp._lastFocusedEl = document.activeElement;
		
		// Wait for next cycle to allow CSS transition
		setTimeout(function() {
			
			if(mfp.content) {
				mfp._addClassToMFP(READY_CLASS);
				mfp._setFocus();
			} else {
				// if content is not defined (not loaded e.t.c) we add class only for BG
				mfp.bgOverlay.addClass(READY_CLASS);
			}
			
			// Trap the focus in popup
			_document.on('focusin' + EVENT_NS, mfp._onFocusIn);

		}, 16);

		mfp.isOpen = true;
		mfp.updateSize(windowHeight);
		_mfpTrigger(OPEN_EVENT);

		return data;
	},

	/**
	 * Closes the popup
	 */
	close: function() {
		if(!mfp.isOpen) return;
		_mfpTrigger(BEFORE_CLOSE_EVENT);

		mfp.isOpen = false;
		// for CSS3 animation
		if(mfp.st.removalDelay && !mfp.isLowIE && mfp.supportsTransition )  {
			mfp._addClassToMFP(REMOVING_CLASS);
			setTimeout(function() {
				mfp._close();
			}, mfp.st.removalDelay);
		} else {
			mfp._close();
		}
	},

	/**
	 * Helper for close() function
	 */
	_close: function() {
		_mfpTrigger(CLOSE_EVENT);

		var classesToRemove = REMOVING_CLASS + ' ' + READY_CLASS + ' ';

		mfp.bgOverlay.detach();
		mfp.wrap.detach();
		mfp.container.empty();

		if(mfp.st.mainClass) {
			classesToRemove += mfp.st.mainClass + ' ';
		}

		mfp._removeClassFromMFP(classesToRemove);

		if(mfp.fixedContentPos) {
			var windowStyles = {marginRight: ''};
			if(mfp.isIE7) {
				$('body, html').css('overflow', '');
			} else {
				windowStyles.overflow = '';
			}
			$('html').css(windowStyles);
		}
		
		_document.off('keyup' + EVENT_NS + ' focusin' + EVENT_NS);
		mfp.ev.off(EVENT_NS);

		// clean up DOM elements that aren't removed
		mfp.wrap.attr('class', 'mfp-wrap').removeAttr('style');
		mfp.bgOverlay.attr('class', 'mfp-bg');
		mfp.container.attr('class', 'mfp-container');

		// remove close button from target element
		if(mfp.st.showCloseBtn &&
		(!mfp.st.closeBtnInside || mfp.currTemplate[mfp.currItem.type] === true)) {
			if(mfp.currTemplate.closeBtn)
				mfp.currTemplate.closeBtn.detach();
		}


		if(mfp.st.autoFocusLast && mfp._lastFocusedEl) {
			$(mfp._lastFocusedEl).focus(); // put tab focus back
		}
		mfp.currItem = null;	
		mfp.content = null;
		mfp.currTemplate = null;
		mfp.prevHeight = 0;

		_mfpTrigger(AFTER_CLOSE_EVENT);
	},
	
	updateSize: function(winHeight) {

		if(mfp.isIOS) {
			// fixes iOS nav bars https://github.com/dimsemenov/Magnific-Popup/issues/2
			var zoomLevel = document.documentElement.clientWidth / window.innerWidth;
			var height = window.innerHeight * zoomLevel;
			mfp.wrap.css('height', height);
			mfp.wH = height;
		} else {
			mfp.wH = winHeight || _window.height();
		}
		// Fixes #84: popup incorrectly positioned with position:relative on body
		if(!mfp.fixedContentPos) {
			mfp.wrap.css('height', mfp.wH);
		}

		_mfpTrigger('Resize');

	},

	/**
	 * Set content of popup based on current index
	 */
	updateItemHTML: function() {
		var item = mfp.items[mfp.index];

		// Detach and perform modifications
		mfp.contentContainer.detach();

		if(mfp.content)
			mfp.content.detach();

		if(!item.parsed) {
			item = mfp.parseEl( mfp.index );
		}

		var type = item.type;

		_mfpTrigger('BeforeChange', [mfp.currItem ? mfp.currItem.type : '', type]);
		// BeforeChange event works like so:
		// _mfpOn('BeforeChange', function(e, prevType, newType) { });

		mfp.currItem = item;

		if(!mfp.currTemplate[type]) {
			var markup = mfp.st[type] ? mfp.st[type].markup : false;

			// allows to modify markup
			_mfpTrigger('FirstMarkupParse', markup);

			if(markup) {
				mfp.currTemplate[type] = $(markup);
			} else {
				// if there is no markup found we just define that template is parsed
				mfp.currTemplate[type] = true;
			}
		}

		if(_prevContentType && _prevContentType !== item.type) {
			mfp.container.removeClass('mfp-'+_prevContentType+'-holder');
		}

		var newContent = mfp['get' + type.charAt(0).toUpperCase() + type.slice(1)](item, mfp.currTemplate[type]);
		mfp.appendContent(newContent, type);

		item.preloaded = true;

		_mfpTrigger(CHANGE_EVENT, item);
		_prevContentType = item.type;

		// Append container back after its content changed
		mfp.container.prepend(mfp.contentContainer);

		_mfpTrigger('AfterChange');
	},


	/**
	 * Set HTML content of popup
	 */
	appendContent: function(newContent, type) {
		mfp.content = newContent;

		if(newContent) {
			if(mfp.st.showCloseBtn && mfp.st.closeBtnInside &&
				mfp.currTemplate[type] === true) {
				// if there is no markup, we just append close button element inside
				if(!mfp.content.find('.mfp-close').length) {
					mfp.content.append(_getCloseBtn());
				}
			} else {
				mfp.content = newContent;
			}
		} else {
			mfp.content = '';
		}

		_mfpTrigger(BEFORE_APPEND_EVENT);
		mfp.container.addClass('mfp-'+type+'-holder');

		mfp.contentContainer.append(mfp.content);
	},


	/**
	 * Creates Magnific Popup data object based on given data
	 * @param  {int} index Index of item to parse
	 */
	parseEl: function(index) {
		var item = mfp.items[index],
			type;

		if(item.tagName) {
			item = { el: $(item) };
		} else {
			type = item.type;
			item = { data: item, src: item.src };
		}

		if(item.el) {
			var types = mfp.types;

			// check for 'mfp-TYPE' class
			for(var i = 0; i < types.length; i++) {
				if( item.el.hasClass('mfp-'+types[i]) ) {
					type = types[i];
					break;
				}
			}

			item.src = item.el.attr('data-mfp-src');
			if(!item.src) {
				item.src = item.el.attr('href');
			}
		}

		item.type = type || mfp.st.type || 'inline';
		item.index = index;
		item.parsed = true;
		mfp.items[index] = item;
		_mfpTrigger('ElementParse', item);

		return mfp.items[index];
	},


	/**
	 * Initializes single popup or a group of popups
	 */
	addGroup: function(el, options) {
		var eHandler = function(e) {
			e.mfpEl = this;
			mfp._openClick(e, el, options);
		};

		if(!options) {
			options = {};
		}

		var eName = 'click.magnificPopup';
		options.mainEl = el;

		if(options.items) {
			options.isObj = true;
			el.off(eName).on(eName, eHandler);
		} else {
			options.isObj = false;
			if(options.delegate) {
				el.off(eName).on(eName, options.delegate , eHandler);
			} else {
				options.items = el;
				el.off(eName).on(eName, eHandler);
			}
		}
	},
	_openClick: function(e, el, options) {
		var midClick = options.midClick !== undefined ? options.midClick : $.magnificPopup.defaults.midClick;


		if(!midClick && ( e.which === 2 || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey ) ) {
			return;
		}

		var disableOn = options.disableOn !== undefined ? options.disableOn : $.magnificPopup.defaults.disableOn;

		if(disableOn) {
			if($.isFunction(disableOn)) {
				if( !disableOn.call(mfp) ) {
					return true;
				}
			} else { // else it's number
				if( _window.width() < disableOn ) {
					return true;
				}
			}
		}

		if(e.type) {
			e.preventDefault();

			// This will prevent popup from closing if element is inside and popup is already opened
			if(mfp.isOpen) {
				e.stopPropagation();
			}
		}

		options.el = $(e.mfpEl);
		if(options.delegate) {
			options.items = el.find(options.delegate);
		}
		mfp.open(options);
	},


	/**
	 * Updates text on preloader
	 */
	updateStatus: function(status, text) {

		if(mfp.preloader) {
			if(_prevStatus !== status) {
				mfp.container.removeClass('mfp-s-'+_prevStatus);
			}

			if(!text && status === 'loading') {
				text = mfp.st.tLoading;
			}

			var data = {
				status: status,
				text: text
			};
			// allows to modify status
			_mfpTrigger('UpdateStatus', data);

			status = data.status;
			text = data.text;

			mfp.preloader.html(text);

			mfp.preloader.find('a').on('click', function(e) {
				e.stopImmediatePropagation();
			});

			mfp.container.addClass('mfp-s-'+status);
			_prevStatus = status;
		}
	},


	/*
		"Private" helpers that aren't private at all
	 */
	// Check to close popup or not
	// "target" is an element that was clicked
	_checkIfClose: function(target) {

		if($(target).hasClass(PREVENT_CLOSE_CLASS)) {
			return;
		}

		var closeOnContent = mfp.st.closeOnContentClick;
		var closeOnBg = mfp.st.closeOnBgClick;

		if(closeOnContent && closeOnBg) {
			return true;
		} else {

			// We close the popup if click is on close button or on preloader. Or if there is no content.
			if(!mfp.content || $(target).hasClass('mfp-close') || (mfp.preloader && target === mfp.preloader[0]) ) {
				return true;
			}

			// if click is outside the content
			if(  (target !== mfp.content[0] && !$.contains(mfp.content[0], target))  ) {
				if(closeOnBg) {
					// last check, if the clicked element is in DOM, (in case it's removed onclick)
					if( $.contains(document, target) ) {
						return true;
					}
				}
			} else if(closeOnContent) {
				return true;
			}

		}
		return false;
	},
	_addClassToMFP: function(cName) {
		mfp.bgOverlay.addClass(cName);
		mfp.wrap.addClass(cName);
	},
	_removeClassFromMFP: function(cName) {
		this.bgOverlay.removeClass(cName);
		mfp.wrap.removeClass(cName);
	},
	_hasScrollBar: function(winHeight) {
		return (  (mfp.isIE7 ? _document.height() : document.body.scrollHeight) > (winHeight || _window.height()) );
	},
	_setFocus: function() {
		(mfp.st.focus ? mfp.content.find(mfp.st.focus).eq(0) : mfp.wrap).focus();
	},
	_onFocusIn: function(e) {
		if( e.target !== mfp.wrap[0] && !$.contains(mfp.wrap[0], e.target) ) {
			mfp._setFocus();
			return false;
		}
	},
	_parseMarkup: function(template, values, item) {
		var arr;
		if(item.data) {
			values = $.extend(item.data, values);
		}
		_mfpTrigger(MARKUP_PARSE_EVENT, [template, values, item] );

		$.each(values, function(key, value) {
			if(value === undefined || value === false) {
				return true;
			}
			arr = key.split('_');
			if(arr.length > 1) {
				var el = template.find(EVENT_NS + '-'+arr[0]);

				if(el.length > 0) {
					var attr = arr[1];
					if(attr === 'replaceWith') {
						if(el[0] !== value[0]) {
							el.replaceWith(value);
						}
					} else if(attr === 'img') {
						if(el.is('img')) {
							el.attr('src', value);
						} else {
							el.replaceWith( $('<img>').attr('src', value).attr('class', el.attr('class')) );
						}
					} else {
						el.attr(arr[1], value);
					}
				}

			} else {
				template.find(EVENT_NS + '-'+key).html(value);
			}
		});
	},

	_getScrollbarSize: function() {
		// thx David
		if(mfp.scrollbarSize === undefined) {
			var scrollDiv = document.createElement("div");
			scrollDiv.style.cssText = 'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
			document.body.appendChild(scrollDiv);
			mfp.scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
			document.body.removeChild(scrollDiv);
		}
		return mfp.scrollbarSize;
	}

}; /* MagnificPopup core prototype end */




/**
 * Public static functions
 */
$.magnificPopup = {
	instance: null,
	proto: MagnificPopup.prototype,
	modules: [],

	open: function(options, index) {
		_checkInstance();

		if(!options) {
			options = {};
		} else {
			options = $.extend(true, {}, options);
		}

		options.isObj = true;
		options.index = index || 0;
		return this.instance.open(options);
	},

	close: function() {
		return $.magnificPopup.instance && $.magnificPopup.instance.close();
	},

	registerModule: function(name, module) {
		if(module.options) {
			$.magnificPopup.defaults[name] = module.options;
		}
		$.extend(this.proto, module.proto);
		this.modules.push(name);
	},

	defaults: {

		// Info about options is in docs:
		// http://dimsemenov.com/plugins/magnific-popup/documentation.html#options

		disableOn: 0,

		key: null,

		midClick: false,

		mainClass: '',

		preloader: true,

		focus: '', // CSS selector of input to focus after popup is opened

		closeOnContentClick: false,

		closeOnBgClick: true,

		closeBtnInside: true,

		showCloseBtn: true,

		enableEscapeKey: true,

		modal: false,

		alignTop: false,

		removalDelay: 0,

		prependTo: null,

		fixedContentPos: 'auto',

		fixedBgPos: 'auto',

		overflowY: 'auto',

		closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>',

		tClose: 'Close (Esc)',

		tLoading: 'Loading...',

		autoFocusLast: true

	}
};



$.fn.magnificPopup = function(options) {
	_checkInstance();

	var jqEl = $(this);

	// We call some API method of first param is a string
	if (typeof options === "string" ) {

		if(options === 'open') {
			var items,
				itemOpts = _isJQ ? jqEl.data('magnificPopup') : jqEl[0].magnificPopup,
				index = parseInt(arguments[1], 10) || 0;

			if(itemOpts.items) {
				items = itemOpts.items[index];
			} else {
				items = jqEl;
				if(itemOpts.delegate) {
					items = items.find(itemOpts.delegate);
				}
				items = items.eq( index );
			}
			mfp._openClick({mfpEl:items}, jqEl, itemOpts);
		} else {
			if(mfp.isOpen)
				mfp[options].apply(mfp, Array.prototype.slice.call(arguments, 1));
		}

	} else {
		// clone options obj
		options = $.extend(true, {}, options);

		/*
		 * As Zepto doesn't support .data() method for objects
		 * and it works only in normal browsers
		 * we assign "options" object directly to the DOM element. FTW!
		 */
		if(_isJQ) {
			jqEl.data('magnificPopup', options);
		} else {
			jqEl[0].magnificPopup = options;
		}

		mfp.addGroup(jqEl, options);

	}
	return jqEl;
};

/*>>core*/

/*>>inline*/

var INLINE_NS = 'inline',
	_hiddenClass,
	_inlinePlaceholder,
	_lastInlineElement,
	_putInlineElementsBack = function() {
		if(_lastInlineElement) {
			_inlinePlaceholder.after( _lastInlineElement.addClass(_hiddenClass) ).detach();
			_lastInlineElement = null;
		}
	};

$.magnificPopup.registerModule(INLINE_NS, {
	options: {
		hiddenClass: 'hide', // will be appended with `mfp-` prefix
		markup: '',
		tNotFound: 'Content not found'
	},
	proto: {

		initInline: function() {
			mfp.types.push(INLINE_NS);

			_mfpOn(CLOSE_EVENT+'.'+INLINE_NS, function() {
				_putInlineElementsBack();
			});
		},

		getInline: function(item, template) {

			_putInlineElementsBack();

			if(item.src) {
				var inlineSt = mfp.st.inline,
					el = $(item.src);

				if(el.length) {

					// If target element has parent - we replace it with placeholder and put it back after popup is closed
					var parent = el[0].parentNode;
					if(parent && parent.tagName) {
						if(!_inlinePlaceholder) {
							_hiddenClass = inlineSt.hiddenClass;
							_inlinePlaceholder = _getEl(_hiddenClass);
							_hiddenClass = 'mfp-'+_hiddenClass;
						}
						// replace target inline element with placeholder
						_lastInlineElement = el.after(_inlinePlaceholder).detach().removeClass(_hiddenClass);
					}

					mfp.updateStatus('ready');
				} else {
					mfp.updateStatus('error', inlineSt.tNotFound);
					el = $('<div>');
				}

				item.inlineElement = el;
				return el;
			}

			mfp.updateStatus('ready');
			mfp._parseMarkup(template, {}, item);
			return template;
		}
	}
});

/*>>inline*/

/*>>ajax*/
var AJAX_NS = 'ajax',
	_ajaxCur,
	_removeAjaxCursor = function() {
		if(_ajaxCur) {
			$(document.body).removeClass(_ajaxCur);
		}
	},
	_destroyAjaxRequest = function() {
		_removeAjaxCursor();
		if(mfp.req) {
			mfp.req.abort();
		}
	};

$.magnificPopup.registerModule(AJAX_NS, {

	options: {
		settings: null,
		cursor: 'mfp-ajax-cur',
		tError: '<a href="%url%">The content</a> could not be loaded.'
	},

	proto: {
		initAjax: function() {
			mfp.types.push(AJAX_NS);
			_ajaxCur = mfp.st.ajax.cursor;

			_mfpOn(CLOSE_EVENT+'.'+AJAX_NS, _destroyAjaxRequest);
			_mfpOn('BeforeChange.' + AJAX_NS, _destroyAjaxRequest);
		},
		getAjax: function(item) {

			if(_ajaxCur) {
				$(document.body).addClass(_ajaxCur);
			}

			mfp.updateStatus('loading');

			var opts = $.extend({
				url: item.src,
				success: function(data, textStatus, jqXHR) {
					var temp = {
						data:data,
						xhr:jqXHR
					};

					_mfpTrigger('ParseAjax', temp);

					mfp.appendContent( $(temp.data), AJAX_NS );

					item.finished = true;

					_removeAjaxCursor();

					mfp._setFocus();

					setTimeout(function() {
						mfp.wrap.addClass(READY_CLASS);
					}, 16);

					mfp.updateStatus('ready');

					_mfpTrigger('AjaxContentAdded');
				},
				error: function() {
					_removeAjaxCursor();
					item.finished = item.loadError = true;
					mfp.updateStatus('error', mfp.st.ajax.tError.replace('%url%', item.src));
				}
			}, mfp.st.ajax.settings);

			mfp.req = $.ajax(opts);

			return '';
		}
	}
});

/*>>ajax*/

/*>>image*/
var _imgInterval,
	_getTitle = function(item) {
		if(item.data && item.data.title !== undefined)
			return item.data.title;

		var src = mfp.st.image.titleSrc;

		if(src) {
			if($.isFunction(src)) {
				return src.call(mfp, item);
			} else if(item.el) {
				return item.el.attr(src) || '';
			}
		}
		return '';
	};

$.magnificPopup.registerModule('image', {

	options: {
		markup: '<div class="mfp-figure">'+
					'<div class="mfp-close"></div>'+
					'<figure>'+
						'<div class="mfp-img"></div>'+
						'<figcaption>'+
							'<div class="mfp-bottom-bar">'+
								'<div class="mfp-title"></div>'+
								'<div class="mfp-counter"></div>'+
							'</div>'+
						'</figcaption>'+
					'</figure>'+
				'</div>',
		cursor: 'mfp-zoom-out-cur',
		titleSrc: 'title',
		verticalFit: true,
		tError: '<a href="%url%">The image</a> could not be loaded.'
	},

	proto: {
		initImage: function() {
			var imgSt = mfp.st.image,
				ns = '.image';

			mfp.types.push('image');

			_mfpOn(OPEN_EVENT+ns, function() {
				if(mfp.currItem.type === 'image' && imgSt.cursor) {
					$(document.body).addClass(imgSt.cursor);
				}
			});

			_mfpOn(CLOSE_EVENT+ns, function() {
				if(imgSt.cursor) {
					$(document.body).removeClass(imgSt.cursor);
				}
				_window.off('resize' + EVENT_NS);
			});

			_mfpOn('Resize'+ns, mfp.resizeImage);
			if(mfp.isLowIE) {
				_mfpOn('AfterChange', mfp.resizeImage);
			}
		},
		resizeImage: function() {
			var item = mfp.currItem;
			if(!item || !item.img) return;

			if(mfp.st.image.verticalFit) {
				var decr = 0;
				// fix box-sizing in ie7/8
				if(mfp.isLowIE) {
					decr = parseInt(item.img.css('padding-top'), 10) + parseInt(item.img.css('padding-bottom'),10);
				}
				item.img.css('max-height', mfp.wH-decr);
			}
		},
		_onImageHasSize: function(item) {
			if(item.img) {

				item.hasSize = true;

				if(_imgInterval) {
					clearInterval(_imgInterval);
				}

				item.isCheckingImgSize = false;

				_mfpTrigger('ImageHasSize', item);

				if(item.imgHidden) {
					if(mfp.content)
						mfp.content.removeClass('mfp-loading');

					item.imgHidden = false;
				}

			}
		},

		/**
		 * Function that loops until the image has size to display elements that rely on it asap
		 */
		findImageSize: function(item) {

			var counter = 0,
				img = item.img[0],
				mfpSetInterval = function(delay) {

					if(_imgInterval) {
						clearInterval(_imgInterval);
					}
					// decelerating interval that checks for size of an image
					_imgInterval = setInterval(function() {
						if(img.naturalWidth > 0) {
							mfp._onImageHasSize(item);
							return;
						}

						if(counter > 200) {
							clearInterval(_imgInterval);
						}

						counter++;
						if(counter === 3) {
							mfpSetInterval(10);
						} else if(counter === 40) {
							mfpSetInterval(50);
						} else if(counter === 100) {
							mfpSetInterval(500);
						}
					}, delay);
				};

			mfpSetInterval(1);
		},

		getImage: function(item, template) {

			var guard = 0,

				// image load complete handler
				onLoadComplete = function() {
					if(item) {
						if (item.img[0].complete) {
							item.img.off('.mfploader');

							if(item === mfp.currItem){
								mfp._onImageHasSize(item);

								mfp.updateStatus('ready');
							}

							item.hasSize = true;
							item.loaded = true;

							_mfpTrigger('ImageLoadComplete');

						}
						else {
							// if image complete check fails 200 times (20 sec), we assume that there was an error.
							guard++;
							if(guard < 200) {
								setTimeout(onLoadComplete,100);
							} else {
								onLoadError();
							}
						}
					}
				},

				// image error handler
				onLoadError = function() {
					if(item) {
						item.img.off('.mfploader');
						if(item === mfp.currItem){
							mfp._onImageHasSize(item);
							mfp.updateStatus('error', imgSt.tError.replace('%url%', item.src) );
						}

						item.hasSize = true;
						item.loaded = true;
						item.loadError = true;
					}
				},
				imgSt = mfp.st.image;


			var el = template.find('.mfp-img');
			if(el.length) {
				var img = document.createElement('img');
				img.className = 'mfp-img';
				if(item.el && item.el.find('img').length) {
					img.alt = item.el.find('img').attr('alt');
				}
				item.img = $(img).on('load.mfploader', onLoadComplete).on('error.mfploader', onLoadError);
				img.src = item.src;

				// without clone() "error" event is not firing when IMG is replaced by new IMG
				// TODO: find a way to avoid such cloning
				if(el.is('img')) {
					item.img = item.img.clone();
				}

				img = item.img[0];
				if(img.naturalWidth > 0) {
					item.hasSize = true;
				} else if(!img.width) {
					item.hasSize = false;
				}
			}

			mfp._parseMarkup(template, {
				title: _getTitle(item),
				img_replaceWith: item.img
			}, item);

			mfp.resizeImage();

			if(item.hasSize) {
				if(_imgInterval) clearInterval(_imgInterval);

				if(item.loadError) {
					template.addClass('mfp-loading');
					mfp.updateStatus('error', imgSt.tError.replace('%url%', item.src) );
				} else {
					template.removeClass('mfp-loading');
					mfp.updateStatus('ready');
				}
				return template;
			}

			mfp.updateStatus('loading');
			item.loading = true;

			if(!item.hasSize) {
				item.imgHidden = true;
				template.addClass('mfp-loading');
				mfp.findImageSize(item);
			}

			return template;
		}
	}
});

/*>>image*/

/*>>zoom*/
var hasMozTransform,
	getHasMozTransform = function() {
		if(hasMozTransform === undefined) {
			hasMozTransform = document.createElement('p').style.MozTransform !== undefined;
		}
		return hasMozTransform;
	};

$.magnificPopup.registerModule('zoom', {

	options: {
		enabled: false,
		easing: 'ease-in-out',
		duration: 300,
		opener: function(element) {
			return element.is('img') ? element : element.find('img');
		}
	},

	proto: {

		initZoom: function() {
			var zoomSt = mfp.st.zoom,
				ns = '.zoom',
				image;

			if(!zoomSt.enabled || !mfp.supportsTransition) {
				return;
			}

			var duration = zoomSt.duration,
				getElToAnimate = function(image) {
					var newImg = image.clone().removeAttr('style').removeAttr('class').addClass('mfp-animated-image'),
						transition = 'all '+(zoomSt.duration/1000)+'s ' + zoomSt.easing,
						cssObj = {
							position: 'fixed',
							zIndex: 9999,
							left: 0,
							top: 0,
							'-webkit-backface-visibility': 'hidden'
						},
						t = 'transition';

					cssObj['-webkit-'+t] = cssObj['-moz-'+t] = cssObj['-o-'+t] = cssObj[t] = transition;

					newImg.css(cssObj);
					return newImg;
				},
				showMainContent = function() {
					mfp.content.css('visibility', 'visible');
				},
				openTimeout,
				animatedImg;

			_mfpOn('BuildControls'+ns, function() {
				if(mfp._allowZoom()) {

					clearTimeout(openTimeout);
					mfp.content.css('visibility', 'hidden');

					// Basically, all code below does is clones existing image, puts in on top of the current one and animated it

					image = mfp._getItemToZoom();

					if(!image) {
						showMainContent();
						return;
					}

					animatedImg = getElToAnimate(image);

					animatedImg.css( mfp._getOffset() );

					mfp.wrap.append(animatedImg);

					openTimeout = setTimeout(function() {
						animatedImg.css( mfp._getOffset( true ) );
						openTimeout = setTimeout(function() {

							showMainContent();

							setTimeout(function() {
								animatedImg.remove();
								image = animatedImg = null;
								_mfpTrigger('ZoomAnimationEnded');
							}, 16); // avoid blink when switching images

						}, duration); // this timeout equals animation duration

					}, 16); // by adding this timeout we avoid short glitch at the beginning of animation


					// Lots of timeouts...
				}
			});
			_mfpOn(BEFORE_CLOSE_EVENT+ns, function() {
				if(mfp._allowZoom()) {

					clearTimeout(openTimeout);

					mfp.st.removalDelay = duration;

					if(!image) {
						image = mfp._getItemToZoom();
						if(!image) {
							return;
						}
						animatedImg = getElToAnimate(image);
					}

					animatedImg.css( mfp._getOffset(true) );
					mfp.wrap.append(animatedImg);
					mfp.content.css('visibility', 'hidden');

					setTimeout(function() {
						animatedImg.css( mfp._getOffset() );
					}, 16);
				}

			});

			_mfpOn(CLOSE_EVENT+ns, function() {
				if(mfp._allowZoom()) {
					showMainContent();
					if(animatedImg) {
						animatedImg.remove();
					}
					image = null;
				}
			});
		},

		_allowZoom: function() {
			return mfp.currItem.type === 'image';
		},

		_getItemToZoom: function() {
			if(mfp.currItem.hasSize) {
				return mfp.currItem.img;
			} else {
				return false;
			}
		},

		// Get element postion relative to viewport
		_getOffset: function(isLarge) {
			var el;
			if(isLarge) {
				el = mfp.currItem.img;
			} else {
				el = mfp.st.zoom.opener(mfp.currItem.el || mfp.currItem);
			}

			var offset = el.offset();
			var paddingTop = parseInt(el.css('padding-top'),10);
			var paddingBottom = parseInt(el.css('padding-bottom'),10);
			offset.top -= ( $(window).scrollTop() - paddingTop );


			/*

			Animating left + top + width/height looks glitchy in Firefox, but perfect in Chrome. And vice-versa.

			 */
			var obj = {
				width: el.width(),
				// fix Zepto height+padding issue
				height: (_isJQ ? el.innerHeight() : el[0].offsetHeight) - paddingBottom - paddingTop
			};

			// I hate to do this, but there is no another option
			if( getHasMozTransform() ) {
				obj['-moz-transform'] = obj['transform'] = 'translate(' + offset.left + 'px,' + offset.top + 'px)';
			} else {
				obj.left = offset.left;
				obj.top = offset.top;
			}
			return obj;
		}

	}
});



/*>>zoom*/

/*>>iframe*/

var IFRAME_NS = 'iframe',
	_emptyPage = '//about:blank',

	_fixIframeBugs = function(isShowing) {
		if(mfp.currTemplate[IFRAME_NS]) {
			var el = mfp.currTemplate[IFRAME_NS].find('iframe');
			if(el.length) {
				// reset src after the popup is closed to avoid "video keeps playing after popup is closed" bug
				if(!isShowing) {
					el[0].src = _emptyPage;
				}

				// IE8 black screen bug fix
				if(mfp.isIE8) {
					el.css('display', isShowing ? 'block' : 'none');
				}
			}
		}
	};

$.magnificPopup.registerModule(IFRAME_NS, {

	options: {
		markup: '<div class="mfp-iframe-scaler">'+
					'<div class="mfp-close"></div>'+
					'<iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe>'+
				'</div>',

		srcAction: 'iframe_src',

		// we don't care and support only one default type of URL by default
		patterns: {
			youtube: {
				index: 'youtube.com',
				id: 'v=',
				src: '//www.youtube.com/embed/%id%?autoplay=1'
			},
			vimeo: {
				index: 'vimeo.com/',
				id: '/',
				src: '//player.vimeo.com/video/%id%?autoplay=1'
			},
			gmaps: {
				index: '//maps.google.',
				src: '%id%&output=embed'
			}
		}
	},

	proto: {
		initIframe: function() {
			mfp.types.push(IFRAME_NS);

			_mfpOn('BeforeChange', function(e, prevType, newType) {
				if(prevType !== newType) {
					if(prevType === IFRAME_NS) {
						_fixIframeBugs(); // iframe if removed
					} else if(newType === IFRAME_NS) {
						_fixIframeBugs(true); // iframe is showing
					}
				}// else {
					// iframe source is switched, don't do anything
				//}
			});

			_mfpOn(CLOSE_EVENT + '.' + IFRAME_NS, function() {
				_fixIframeBugs();
			});
		},

		getIframe: function(item, template) {
			var embedSrc = item.src;
			var iframeSt = mfp.st.iframe;

			$.each(iframeSt.patterns, function() {
				if(embedSrc.indexOf( this.index ) > -1) {
					if(this.id) {
						if(typeof this.id === 'string') {
							embedSrc = embedSrc.substr(embedSrc.lastIndexOf(this.id)+this.id.length, embedSrc.length);
						} else {
							embedSrc = this.id.call( this, embedSrc );
						}
					}
					embedSrc = this.src.replace('%id%', embedSrc );
					return false; // break;
				}
			});

			var dataObj = {};
			if(iframeSt.srcAction) {
				dataObj[iframeSt.srcAction] = embedSrc;
			}
			mfp._parseMarkup(template, dataObj, item);

			mfp.updateStatus('ready');

			return template;
		}
	}
});



/*>>iframe*/

/*>>gallery*/
/**
 * Get looped index depending on number of slides
 */
var _getLoopedId = function(index) {
		var numSlides = mfp.items.length;
		if(index > numSlides - 1) {
			return index - numSlides;
		} else  if(index < 0) {
			return numSlides + index;
		}
		return index;
	},
	_replaceCurrTotal = function(text, curr, total) {
		return text.replace(/%curr%/gi, curr + 1).replace(/%total%/gi, total);
	};

$.magnificPopup.registerModule('gallery', {

	options: {
		enabled: false,
		arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
		preload: [0,2],
		navigateByImgClick: true,
		arrows: true,

		tPrev: 'Previous (Left arrow key)',
		tNext: 'Next (Right arrow key)',
		tCounter: '%curr% of %total%'
	},

	proto: {
		initGallery: function() {

			var gSt = mfp.st.gallery,
				ns = '.mfp-gallery';

			mfp.direction = true; // true - next, false - prev

			if(!gSt || !gSt.enabled ) return false;

			_wrapClasses += ' mfp-gallery';

			_mfpOn(OPEN_EVENT+ns, function() {

				if(gSt.navigateByImgClick) {
					mfp.wrap.on('click'+ns, '.mfp-img', function() {
						if(mfp.items.length > 1) {
							mfp.next();
							return false;
						}
					});
				}

				_document.on('keydown'+ns, function(e) {
					if (e.keyCode === 37) {
						mfp.prev();
					} else if (e.keyCode === 39) {
						mfp.next();
					}
				});
			});

			_mfpOn('UpdateStatus'+ns, function(e, data) {
				if(data.text) {
					data.text = _replaceCurrTotal(data.text, mfp.currItem.index, mfp.items.length);
				}
			});

			_mfpOn(MARKUP_PARSE_EVENT+ns, function(e, element, values, item) {
				var l = mfp.items.length;
				values.counter = l > 1 ? _replaceCurrTotal(gSt.tCounter, item.index, l) : '';
			});

			_mfpOn('BuildControls' + ns, function() {
				if(mfp.items.length > 1 && gSt.arrows && !mfp.arrowLeft) {
					var markup = gSt.arrowMarkup,
						arrowLeft = mfp.arrowLeft = $( markup.replace(/%title%/gi, gSt.tPrev).replace(/%dir%/gi, 'left') ).addClass(PREVENT_CLOSE_CLASS),
						arrowRight = mfp.arrowRight = $( markup.replace(/%title%/gi, gSt.tNext).replace(/%dir%/gi, 'right') ).addClass(PREVENT_CLOSE_CLASS);

					arrowLeft.click(function() {
						mfp.prev();
					});
					arrowRight.click(function() {
						mfp.next();
					});

					mfp.container.append(arrowLeft.add(arrowRight));
				}
			});

			_mfpOn(CHANGE_EVENT+ns, function() {
				if(mfp._preloadTimeout) clearTimeout(mfp._preloadTimeout);

				mfp._preloadTimeout = setTimeout(function() {
					mfp.preloadNearbyImages();
					mfp._preloadTimeout = null;
				}, 16);
			});


			_mfpOn(CLOSE_EVENT+ns, function() {
				_document.off(ns);
				mfp.wrap.off('click'+ns);
				mfp.arrowRight = mfp.arrowLeft = null;
			});

		},
		next: function() {
			mfp.direction = true;
			mfp.index = _getLoopedId(mfp.index + 1);
			mfp.updateItemHTML();
		},
		prev: function() {
			mfp.direction = false;
			mfp.index = _getLoopedId(mfp.index - 1);
			mfp.updateItemHTML();
		},
		goTo: function(newIndex) {
			mfp.direction = (newIndex >= mfp.index);
			mfp.index = newIndex;
			mfp.updateItemHTML();
		},
		preloadNearbyImages: function() {
			var p = mfp.st.gallery.preload,
				preloadBefore = Math.min(p[0], mfp.items.length),
				preloadAfter = Math.min(p[1], mfp.items.length),
				i;

			for(i = 1; i <= (mfp.direction ? preloadAfter : preloadBefore); i++) {
				mfp._preloadItem(mfp.index+i);
			}
			for(i = 1; i <= (mfp.direction ? preloadBefore : preloadAfter); i++) {
				mfp._preloadItem(mfp.index-i);
			}
		},
		_preloadItem: function(index) {
			index = _getLoopedId(index);

			if(mfp.items[index].preloaded) {
				return;
			}

			var item = mfp.items[index];
			if(!item.parsed) {
				item = mfp.parseEl( index );
			}

			_mfpTrigger('LazyLoad', item);

			if(item.type === 'image') {
				item.img = $('<img class="mfp-img" />').on('load.mfploader', function() {
					item.hasSize = true;
				}).on('error.mfploader', function() {
					item.hasSize = true;
					item.loadError = true;
					_mfpTrigger('LazyLoadError', item);
				}).attr('src', item.src);
			}


			item.preloaded = true;
		}
	}
});

/*>>gallery*/

/*>>retina*/

var RETINA_NS = 'retina';

$.magnificPopup.registerModule(RETINA_NS, {
	options: {
		replaceSrc: function(item) {
			return item.src.replace(/\.\w+$/, function(m) { return '@2x' + m; });
		},
		ratio: 1 // Function or number.  Set to 1 to disable.
	},
	proto: {
		initRetina: function() {
			if(window.devicePixelRatio > 1) {

				var st = mfp.st.retina,
					ratio = st.ratio;

				ratio = !isNaN(ratio) ? ratio : ratio();

				if(ratio > 1) {
					_mfpOn('ImageHasSize' + '.' + RETINA_NS, function(e, item) {
						item.img.css({
							'max-width': item.img[0].naturalWidth / ratio,
							'width': '100%'
						});
					});
					_mfpOn('ElementParse' + '.' + RETINA_NS, function(e, item) {
						item.src = st.replaceSrc(item, ratio);
					});
				}
			}

		}
	}
});

/*>>retina*/
 _checkInstance(); }));

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Foundation = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _foundationUtil = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FOUNDATION_VERSION = '6.4.0';

// Global Foundation object
// This is attached to the window, or used as a module for AMD/Browserify
var Foundation = {
  version: FOUNDATION_VERSION,

  /**
   * Stores initialized plugins.
   */
  _plugins: {},

  /**
   * Stores generated unique ids for plugin instances
   */
  _uuids: [],

  /**
   * Defines a Foundation plugin, adding it to the `Foundation` namespace and the list of plugins to initialize when reflowing.
   * @param {Object} plugin - The constructor of the plugin.
   */
  plugin: function plugin(_plugin, name) {
    // Object key to use when adding to global Foundation object
    // Examples: Foundation.Reveal, Foundation.OffCanvas
    var className = name || functionName(_plugin);
    // Object key to use when storing the plugin, also used to create the identifying data attribute for the plugin
    // Examples: data-reveal, data-off-canvas
    var attrName = hyphenate(className);

    // Add to the Foundation object and the plugins list (for reflowing)
    this._plugins[attrName] = this[className] = _plugin;
  },
  /**
   * @function
   * Populates the _uuids array with pointers to each individual plugin instance.
   * Adds the `zfPlugin` data-attribute to programmatically created plugins to allow use of $(selector).foundation(method) calls.
   * Also fires the initialization event for each plugin, consolidating repetitive code.
   * @param {Object} plugin - an instance of a plugin, usually `this` in context.
   * @param {String} name - the name of the plugin, passed as a camelCased string.
   * @fires Plugin#init
   */
  registerPlugin: function registerPlugin(plugin, name) {
    var pluginName = name ? hyphenate(name) : functionName(plugin.constructor).toLowerCase();
    plugin.uuid = (0, _foundationUtil.GetYoDigits)(6, pluginName);

    if (!plugin.$element.attr('data-' + pluginName)) {
      plugin.$element.attr('data-' + pluginName, plugin.uuid);
    }
    if (!plugin.$element.data('zfPlugin')) {
      plugin.$element.data('zfPlugin', plugin);
    }
    /**
     * Fires when the plugin has initialized.
     * @event Plugin#init
     */
    plugin.$element.trigger('init.zf.' + pluginName);

    this._uuids.push(plugin.uuid);

    return;
  },
  /**
   * @function
   * Removes the plugins uuid from the _uuids array.
   * Removes the zfPlugin data attribute, as well as the data-plugin-name attribute.
   * Also fires the destroyed event for the plugin, consolidating repetitive code.
   * @param {Object} plugin - an instance of a plugin, usually `this` in context.
   * @fires Plugin#destroyed
   */
  unregisterPlugin: function unregisterPlugin(plugin) {
    var pluginName = hyphenate(functionName(plugin.$element.data('zfPlugin').constructor));

    this._uuids.splice(this._uuids.indexOf(plugin.uuid), 1);
    plugin.$element.removeAttr('data-' + pluginName).removeData('zfPlugin')
    /**
     * Fires when the plugin has been destroyed.
     * @event Plugin#destroyed
     */
    .trigger('destroyed.zf.' + pluginName);
    for (var prop in plugin) {
      plugin[prop] = null; //clean up script to prep for garbage collection.
    }
    return;
  },

  /**
   * @function
   * Causes one or more active plugins to re-initialize, resetting event listeners, recalculating positions, etc.
   * @param {String} plugins - optional string of an individual plugin key, attained by calling `$(element).data('pluginName')`, or string of a plugin class i.e. `'dropdown'`
   * @default If no argument is passed, reflow all currently active plugins.
   */
  reInit: function reInit(plugins) {
    var isJQ = plugins instanceof _jquery2.default;
    try {
      if (isJQ) {
        plugins.each(function () {
          (0, _jquery2.default)(this).data('zfPlugin')._init();
        });
      } else {
        var type = typeof plugins === 'undefined' ? 'undefined' : _typeof(plugins),
            _this = this,
            fns = {
          'object': function object(plgs) {
            plgs.forEach(function (p) {
              p = hyphenate(p);
              (0, _jquery2.default)('[data-' + p + ']').foundation('_init');
            });
          },
          'string': function string() {
            plugins = hyphenate(plugins);
            (0, _jquery2.default)('[data-' + plugins + ']').foundation('_init');
          },
          'undefined': function undefined() {
            this['object'](Object.keys(_this._plugins));
          }
        };
        fns[type](plugins);
      }
    } catch (err) {
      console.error(err);
    } finally {
      return plugins;
    }
  },

  /**
   * Initialize plugins on any elements within `elem` (and `elem` itself) that aren't already initialized.
   * @param {Object} elem - jQuery object containing the element to check inside. Also checks the element itself, unless it's the `document` object.
   * @param {String|Array} plugins - A list of plugins to initialize. Leave this out to initialize everything.
   */
  reflow: function reflow(elem, plugins) {

    // If plugins is undefined, just grab everything
    if (typeof plugins === 'undefined') {
      plugins = Object.keys(this._plugins);
    }
    // If plugins is a string, convert it to an array with one item
    else if (typeof plugins === 'string') {
        plugins = [plugins];
      }

    var _this = this;

    // Iterate through each plugin
    _jquery2.default.each(plugins, function (i, name) {
      // Get the current plugin
      var plugin = _this._plugins[name];

      // Localize the search to all elements inside elem, as well as elem itself, unless elem === document
      var $elem = (0, _jquery2.default)(elem).find('[data-' + name + ']').addBack('[data-' + name + ']');

      // For each plugin found, initialize it
      $elem.each(function () {
        var $el = (0, _jquery2.default)(this),
            opts = {};
        // Don't double-dip on plugins
        if ($el.data('zfPlugin')) {
          console.warn("Tried to initialize " + name + " on an element that already has a Foundation plugin.");
          return;
        }

        if ($el.attr('data-options')) {
          var thing = $el.attr('data-options').split(';').forEach(function (e, i) {
            var opt = e.split(':').map(function (el) {
              return el.trim();
            });
            if (opt[0]) opts[opt[0]] = parseValue(opt[1]);
          });
        }
        try {
          $el.data('zfPlugin', new plugin((0, _jquery2.default)(this), opts));
        } catch (er) {
          console.error(er);
        } finally {
          return;
        }
      });
    });
  },
  getFnName: functionName,

  addToJquery: function addToJquery($) {
    // TODO: consider not making this a jQuery function
    // TODO: need way to reflow vs. re-initialize
    /**
     * The Foundation jQuery method.
     * @param {String|Array} method - An action to perform on the current jQuery object.
     */
    var foundation = function foundation(method) {
      var type = typeof method === 'undefined' ? 'undefined' : _typeof(method),
          $noJS = $('.no-js');

      if ($noJS.length) {
        $noJS.removeClass('no-js');
      }

      if (type === 'undefined') {
        //needs to initialize the Foundation object, or an individual plugin.
        Foundation.MediaQuery._init();
        Foundation.reflow(this);
      } else if (type === 'string') {
        //an individual method to invoke on a plugin or group of plugins
        var args = Array.prototype.slice.call(arguments, 1); //collect all the arguments, if necessary
        var plugClass = this.data('zfPlugin'); //determine the class of plugin

        if (plugClass !== undefined && plugClass[method] !== undefined) {
          //make sure both the class and method exist
          if (this.length === 1) {
            //if there's only one, call it directly.
            plugClass[method].apply(plugClass, args);
          } else {
            this.each(function (i, el) {
              //otherwise loop through the jQuery collection and invoke the method on each
              plugClass[method].apply($(el).data('zfPlugin'), args);
            });
          }
        } else {
          //error for no class or no method
          throw new ReferenceError("We're sorry, '" + method + "' is not an available method for " + (plugClass ? functionName(plugClass) : 'this element') + '.');
        }
      } else {
        //error for invalid argument type
        throw new TypeError('We\'re sorry, ' + type + ' is not a valid parameter. You must use a string representing the method you wish to invoke.');
      }
      return this;
    };
    $.fn.foundation = foundation;
    return $;
  }
};

Foundation.util = {
  /**
   * Function for applying a debounce effect to a function call.
   * @function
   * @param {Function} func - Function to be called at end of timeout.
   * @param {Number} delay - Time in ms to delay the call of `func`.
   * @returns function
   */
  throttle: function throttle(func, delay) {
    var timer = null;

    return function () {
      var context = this,
          args = arguments;

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(context, args);
          timer = null;
        }, delay);
      }
    };
  }
};

window.Foundation = Foundation;

// Polyfill for requestAnimationFrame
(function () {
  if (!Date.now || !window.Date.now) window.Date.now = Date.now = function () {
    return new Date().getTime();
  };

  var vendors = ['webkit', 'moz'];
  for (var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
    var vp = vendors[i];
    window.requestAnimationFrame = window[vp + 'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vp + 'CancelAnimationFrame'] || window[vp + 'CancelRequestAnimationFrame'];
  }
  if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
    var lastTime = 0;
    window.requestAnimationFrame = function (callback) {
      var now = Date.now();
      var nextTime = Math.max(lastTime + 16, now);
      return setTimeout(function () {
        callback(lastTime = nextTime);
      }, nextTime - now);
    };
    window.cancelAnimationFrame = clearTimeout;
  }
  /**
   * Polyfill for performance.now, required by rAF
   */
  if (!window.performance || !window.performance.now) {
    window.performance = {
      start: Date.now(),
      now: function now() {
        return Date.now() - this.start;
      }
    };
  }
})();
if (!Function.prototype.bind) {
  Function.prototype.bind = function (oThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP = function fNOP() {},
        fBound = function fBound() {
      return fToBind.apply(this instanceof fNOP ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
    };

    if (this.prototype) {
      // native functions don't have a prototype
      fNOP.prototype = this.prototype;
    }
    fBound.prototype = new fNOP();

    return fBound;
  };
}
// Polyfill to get the name of a function in IE9
function functionName(fn) {
  if (Function.prototype.name === undefined) {
    var funcNameRegex = /function\s([^(]{1,})\(/;
    var results = funcNameRegex.exec(fn.toString());
    return results && results.length > 1 ? results[1].trim() : "";
  } else if (fn.prototype === undefined) {
    return fn.constructor.name;
  } else {
    return fn.prototype.constructor.name;
  }
}
function parseValue(str) {
  if ('true' === str) return true;else if ('false' === str) return false;else if (!isNaN(str * 1)) return parseFloat(str);
  return str;
}
// Convert PascalCase to kebab-case
// Thank you: http://stackoverflow.com/a/8955580
function hyphenate(str) {
  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

exports.Foundation = Foundation;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Motion = exports.Move = undefined;

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _foundationUtil = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Motion module.
 * @module foundation.motion
 */

var initClasses = ['mui-enter', 'mui-leave'];
var activeClasses = ['mui-enter-active', 'mui-leave-active'];

var Motion = {
  animateIn: function animateIn(element, animation, cb) {
    animate(true, element, animation, cb);
  },

  animateOut: function animateOut(element, animation, cb) {
    animate(false, element, animation, cb);
  }
};

function Move(duration, elem, fn) {
  var anim,
      prog,
      start = null;
  // console.log('called');

  if (duration === 0) {
    fn.apply(elem);
    elem.trigger('finished.zf.animate', [elem]).triggerHandler('finished.zf.animate', [elem]);
    return;
  }

  function move(ts) {
    if (!start) start = ts;
    // console.log(start, ts);
    prog = ts - start;
    fn.apply(elem);

    if (prog < duration) {
      anim = window.requestAnimationFrame(move, elem);
    } else {
      window.cancelAnimationFrame(anim);
      elem.trigger('finished.zf.animate', [elem]).triggerHandler('finished.zf.animate', [elem]);
    }
  }
  anim = window.requestAnimationFrame(move);
}

/**
 * Animates an element in or out using a CSS transition class.
 * @function
 * @private
 * @param {Boolean} isIn - Defines if the animation is in or out.
 * @param {Object} element - jQuery or HTML object to animate.
 * @param {String} animation - CSS class to use.
 * @param {Function} cb - Callback to run when animation is finished.
 */
function animate(isIn, element, animation, cb) {
  element = (0, _jquery2.default)(element).eq(0);

  if (!element.length) return;

  var initClass = isIn ? initClasses[0] : initClasses[1];
  var activeClass = isIn ? activeClasses[0] : activeClasses[1];

  // Set up the animation
  reset();

  element.addClass(animation).css('transition', 'none');

  requestAnimationFrame(function () {
    element.addClass(initClass);
    if (isIn) element.show();
  });

  // Start the animation
  requestAnimationFrame(function () {
    element[0].offsetWidth;
    element.css('transition', '').addClass(activeClass);
  });

  // Clean up the animation when it finishes
  element.one((0, _foundationUtil.transitionend)(element), finish);

  // Hides the element (for out animations), resets the element, and runs a callback
  function finish() {
    if (!isIn) element.hide();
    reset();
    if (cb) cb.apply(element);
  }

  // Resets transitions and removes motion-specific classes
  function reset() {
    element[0].style.transitionDuration = 0;
    element.removeClass(initClass + ' ' + activeClass + ' ' + animation);
  }
}

exports.Move = Move;
exports.Motion = Motion;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _foundationUtil = __webpack_require__(8);

var _foundationUtil2 = __webpack_require__(74);

var _foundationUtil3 = __webpack_require__(42);

var _foundation = __webpack_require__(76);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Tooltip module.
 * @module foundation.tooltip
 * @requires foundation.util.box
 * @requires foundation.util.mediaQuery
 * @requires foundation.util.triggers
 */

var Tooltip = function (_Positionable) {
  _inherits(Tooltip, _Positionable);

  function Tooltip() {
    _classCallCheck(this, Tooltip);

    return _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).apply(this, arguments));
  }

  _createClass(Tooltip, [{
    key: '_setup',

    /**
     * Creates a new instance of a Tooltip.
     * @class
     * @fires Tooltip#init
     * @param {jQuery} element - jQuery object to attach a tooltip to.
     * @param {Object} options - object to extend the default configuration.
     */
    value: function _setup(element, options) {
      this.$element = element;
      this.options = _jquery2.default.extend({}, Tooltip.defaults, this.$element.data(), options);
      this.className = 'Tooltip'; // ie9 back compat

      this.isActive = false;
      this.isClick = false;

      // Triggers init is idempotent, just need to make sure it is initialized
      _foundationUtil3.Triggers.init(_jquery2.default);

      this._init();
    }

    /**
     * Initializes the tooltip by setting the creating the tip element, adding it's text, setting private variables and setting attributes on the anchor.
     * @private
     */

  }, {
    key: '_init',
    value: function _init() {
      _foundationUtil2.MediaQuery._init();
      var elemId = this.$element.attr('aria-describedby') || (0, _foundationUtil.GetYoDigits)(6, 'tooltip');

      this.options.tipText = this.options.tipText || this.$element.attr('title');
      this.template = this.options.template ? (0, _jquery2.default)(this.options.template) : this._buildTemplate(elemId);

      if (this.options.allowHtml) {
        this.template.appendTo(document.body).html(this.options.tipText).hide();
      } else {
        this.template.appendTo(document.body).text(this.options.tipText).hide();
      }

      this.$element.attr({
        'title': '',
        'aria-describedby': elemId,
        'data-yeti-box': elemId,
        'data-toggle': elemId,
        'data-resize': elemId
      }).addClass(this.options.triggerClass);

      _get(Tooltip.prototype.__proto__ || Object.getPrototypeOf(Tooltip.prototype), '_init', this).call(this);
      this._events();
    }
  }, {
    key: '_getDefaultPosition',
    value: function _getDefaultPosition() {
      // handle legacy classnames
      var position = this.$element[0].className.match(/\b(top|left|right|bottom)\b/g);
      return position ? position[0] : 'top';
    }
  }, {
    key: '_getDefaultAlignment',
    value: function _getDefaultAlignment() {
      return 'center';
    }
  }, {
    key: '_getHOffset',
    value: function _getHOffset() {
      if (this.position === 'left' || this.position === 'right') {
        return this.options.hOffset + this.options.tooltipWidth;
      } else {
        return this.options.hOffset;
      }
    }
  }, {
    key: '_getVOffset',
    value: function _getVOffset() {
      if (this.position === 'top' || this.position === 'bottom') {
        return this.options.vOffset + this.options.tooltipHeight;
      } else {
        return this.options.vOffset;
      }
    }

    /**
     * builds the tooltip element, adds attributes, and returns the template.
     * @private
     */

  }, {
    key: '_buildTemplate',
    value: function _buildTemplate(id) {
      var templateClasses = (this.options.tooltipClass + ' ' + this.options.positionClass + ' ' + this.options.templateClasses).trim();
      var $template = (0, _jquery2.default)('<div></div>').addClass(templateClasses).attr({
        'role': 'tooltip',
        'aria-hidden': true,
        'data-is-active': false,
        'data-is-focus': false,
        'id': id
      });
      return $template;
    }

    /**
     * sets the position class of an element and recursively calls itself until there are no more possible positions to attempt, or the tooltip element is no longer colliding.
     * if the tooltip is larger than the screen width, default to full width - any user selected margin
     * @private
     */

  }, {
    key: '_setPosition',
    value: function _setPosition() {
      _get(Tooltip.prototype.__proto__ || Object.getPrototypeOf(Tooltip.prototype), '_setPosition', this).call(this, this.$element, this.template);
    }

    /**
     * reveals the tooltip, and fires an event to close any other open tooltips on the page
     * @fires Tooltip#closeme
     * @fires Tooltip#show
     * @function
     */

  }, {
    key: 'show',
    value: function show() {
      if (this.options.showOn !== 'all' && !_foundationUtil2.MediaQuery.is(this.options.showOn)) {
        // console.error('The screen is too small to display this tooltip');
        return false;
      }

      var _this = this;
      this.template.css('visibility', 'hidden').show();
      this._setPosition();
      this.template.removeClass('top bottom left right').addClass(this.position);
      this.template.removeClass('align-top align-bottom align-left align-right align-center').addClass('align-' + this.alignment);

      /**
       * Fires to close all other open tooltips on the page
       * @event Closeme#tooltip
       */
      this.$element.trigger('closeme.zf.tooltip', this.template.attr('id'));

      this.template.attr({
        'data-is-active': true,
        'aria-hidden': false
      });
      _this.isActive = true;
      // console.log(this.template);
      this.template.stop().hide().css('visibility', '').fadeIn(this.options.fadeInDuration, function () {
        //maybe do stuff?
      });
      /**
       * Fires when the tooltip is shown
       * @event Tooltip#show
       */
      this.$element.trigger('show.zf.tooltip');
    }

    /**
     * Hides the current tooltip, and resets the positioning class if it was changed due to collision
     * @fires Tooltip#hide
     * @function
     */

  }, {
    key: 'hide',
    value: function hide() {
      // console.log('hiding', this.$element.data('yeti-box'));
      var _this = this;
      this.template.stop().attr({
        'aria-hidden': true,
        'data-is-active': false
      }).fadeOut(this.options.fadeOutDuration, function () {
        _this.isActive = false;
        _this.isClick = false;
      });
      /**
       * fires when the tooltip is hidden
       * @event Tooltip#hide
       */
      this.$element.trigger('hide.zf.tooltip');
    }

    /**
     * adds event listeners for the tooltip and its anchor
     * TODO combine some of the listeners like focus and mouseenter, etc.
     * @private
     */

  }, {
    key: '_events',
    value: function _events() {
      var _this = this;
      var $template = this.template;
      var isFocus = false;

      if (!this.options.disableHover) {

        this.$element.on('mouseenter.zf.tooltip', function (e) {
          if (!_this.isActive) {
            _this.timeout = setTimeout(function () {
              _this.show();
            }, _this.options.hoverDelay);
          }
        }).on('mouseleave.zf.tooltip', function (e) {
          clearTimeout(_this.timeout);
          if (!isFocus || _this.isClick && !_this.options.clickOpen) {
            _this.hide();
          }
        });
      }

      if (this.options.clickOpen) {
        this.$element.on('mousedown.zf.tooltip', function (e) {
          e.stopImmediatePropagation();
          if (_this.isClick) {
            //_this.hide();
            // _this.isClick = false;
          } else {
            _this.isClick = true;
            if ((_this.options.disableHover || !_this.$element.attr('tabindex')) && !_this.isActive) {
              _this.show();
            }
          }
        });
      } else {
        this.$element.on('mousedown.zf.tooltip', function (e) {
          e.stopImmediatePropagation();
          _this.isClick = true;
        });
      }

      if (!this.options.disableForTouch) {
        this.$element.on('tap.zf.tooltip touchend.zf.tooltip', function (e) {
          _this.isActive ? _this.hide() : _this.show();
        });
      }

      this.$element.on({
        // 'toggle.zf.trigger': this.toggle.bind(this),
        // 'close.zf.trigger': this.hide.bind(this)
        'close.zf.trigger': this.hide.bind(this)
      });

      this.$element.on('focus.zf.tooltip', function (e) {
        isFocus = true;
        if (_this.isClick) {
          // If we're not showing open on clicks, we need to pretend a click-launched focus isn't
          // a real focus, otherwise on hover and come back we get bad behavior
          if (!_this.options.clickOpen) {
            isFocus = false;
          }
          return false;
        } else {
          _this.show();
        }
      }).on('focusout.zf.tooltip', function (e) {
        isFocus = false;
        _this.isClick = false;
        _this.hide();
      }).on('resizeme.zf.trigger', function () {
        if (_this.isActive) {
          _this._setPosition();
        }
      });
    }

    /**
     * adds a toggle method, in addition to the static show() & hide() functions
     * @function
     */

  }, {
    key: 'toggle',
    value: function toggle() {
      if (this.isActive) {
        this.hide();
      } else {
        this.show();
      }
    }

    /**
     * Destroys an instance of tooltip, removes template element from the view.
     * @function
     */

  }, {
    key: '_destroy',
    value: function _destroy() {
      this.$element.attr('title', this.template.text()).off('.zf.trigger .zf.tooltip').removeClass('has-tip top right left').removeAttr('aria-describedby aria-haspopup data-disable-hover data-resize data-toggle data-tooltip data-yeti-box');

      this.template.remove();
    }
  }]);

  return Tooltip;
}(_foundation.Positionable);

Tooltip.defaults = {
  disableForTouch: false,
  /**
   * Time, in ms, before a tooltip should open on hover.
   * @option
   * @type {number}
   * @default 200
   */
  hoverDelay: 200,
  /**
   * Time, in ms, a tooltip should take to fade into view.
   * @option
   * @type {number}
   * @default 150
   */
  fadeInDuration: 150,
  /**
   * Time, in ms, a tooltip should take to fade out of view.
   * @option
   * @type {number}
   * @default 150
   */
  fadeOutDuration: 150,
  /**
   * Disables hover events from opening the tooltip if set to true
   * @option
   * @type {boolean}
   * @default false
   */
  disableHover: false,
  /**
   * Optional addtional classes to apply to the tooltip template on init.
   * @option
   * @type {string}
   * @default ''
   */
  templateClasses: '',
  /**
   * Non-optional class added to tooltip templates. Foundation default is 'tooltip'.
   * @option
   * @type {string}
   * @default 'tooltip'
   */
  tooltipClass: 'tooltip',
  /**
   * Class applied to the tooltip anchor element.
   * @option
   * @type {string}
   * @default 'has-tip'
   */
  triggerClass: 'has-tip',
  /**
   * Minimum breakpoint size at which to open the tooltip.
   * @option
   * @type {string}
   * @default 'small'
   */
  showOn: 'small',
  /**
   * Custom template to be used to generate markup for tooltip.
   * @option
   * @type {string}
   * @default ''
   */
  template: '',
  /**
   * Text displayed in the tooltip template on open.
   * @option
   * @type {string}
   * @default ''
   */
  tipText: '',
  touchCloseText: 'Tap to close.',
  /**
   * Allows the tooltip to remain open if triggered with a click or touch event.
   * @option
   * @type {boolean}
   * @default true
   */
  clickOpen: true,
  /**
   * DEPRECATED Additional positioning classes, set by the JS
   * @option
   * @type {string}
   * @default ''
   */
  positionClass: '',
  /**
   * Position of tooltip. Can be left, right, bottom, top, or auto.
   * @option
   * @type {string}
   * @default 'auto'
   */
  position: 'auto',
  /**
   * Alignment of tooltip relative to anchor. Can be left, right, bottom, top, center, or auto.
   * @option
   * @type {string}
   * @default 'auto'
   */
  alignment: 'auto',
  /**
   * Allow overlap of container/window. If false, tooltip will first try to
   * position as defined by data-position and data-alignment, but reposition if
   * it would cause an overflow.  @option
   * @type {boolean}
   * @default false
   */
  allowOverlap: false,
  /**
   * Allow overlap of only the bottom of the container. This is the most common
   * behavior for dropdowns, allowing the dropdown to extend the bottom of the
   * screen but not otherwise influence or break out of the container.
   * Less common for tooltips.
   * @option
   * @type {boolean}
   * @default false
   */
  allowBottomOverlap: false,
  /**
   * Distance, in pixels, the template should push away from the anchor on the Y axis.
   * @option
   * @type {number}
   * @default 0
   */
  vOffset: 0,
  /**
   * Distance, in pixels, the template should push away from the anchor on the X axis
   * @option
   * @type {number}
   * @default 0
   */
  hOffset: 0,
  /**
   * Distance, in pixels, the template spacing auto-adjust for a vertical tooltip
   * @option
   * @type {number}
   * @default 14
   */
  tooltipHeight: 14,
  /**
   * Distance, in pixels, the template spacing auto-adjust for a horizontal tooltip
   * @option
   * @type {number}
   * @default 12
   */
  tooltipWidth: 12,
  /**
  * Allow HTML in tooltip. Warning: If you are loading user-generated content into tooltips,
  * allowing HTML may open yourself up to XSS attacks.
  * @option
  * @type {boolean}
  * @default false
  */
  allowHtml: false
};

/**
 * TODO utilize resize event trigger
 */

exports.Tooltip = Tooltip;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Plugin = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _foundationUtil = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Abstract class for providing lifecycle hooks. Expect plugins to define AT LEAST
// {function} _setup (replaces previous constructor),
// {function} _destroy (replaces previous destroy)
var Plugin = function () {
  function Plugin(element, options) {
    _classCallCheck(this, Plugin);

    this._setup(element, options);
    var pluginName = getPluginName(this);
    this.uuid = (0, _foundationUtil.GetYoDigits)(6, pluginName);

    if (!this.$element.attr('data-' + pluginName)) {
      this.$element.attr('data-' + pluginName, this.uuid);
    }
    if (!this.$element.data('zfPlugin')) {
      this.$element.data('zfPlugin', this);
    }
    /**
     * Fires when the plugin has initialized.
     * @event Plugin#init
     */
    this.$element.trigger('init.zf.' + pluginName);
  }

  _createClass(Plugin, [{
    key: 'destroy',
    value: function destroy() {
      this._destroy();
      var pluginName = getPluginName(this);
      this.$element.removeAttr('data-' + pluginName).removeData('zfPlugin')
      /**
       * Fires when the plugin has been destroyed.
       * @event Plugin#destroyed
       */
      .trigger('destroyed.zf.' + pluginName);
      for (var prop in this) {
        this[prop] = null; //clean up script to prep for garbage collection.
      }
    }
  }]);

  return Plugin;
}();

// Convert PascalCase to kebab-case
// Thank you: http://stackoverflow.com/a/8955580


function hyphenate(str) {
  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

function getPluginName(obj) {
  if (typeof obj.constructor.name !== 'undefined') {
    return hyphenate(obj.constructor.name);
  } else {
    return hyphenate(obj.className);
  }
}

exports.Plugin = Plugin;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _foundationUtil = __webpack_require__(75);

var _foundationUtil2 = __webpack_require__(8);

var _foundation = __webpack_require__(76);

var _foundationUtil3 = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Dropdown module.
 * @module foundation.dropdown
 * @requires foundation.util.keyboard
 * @requires foundation.util.box
 * @requires foundation.util.triggers
 */
var Dropdown = function (_Positionable) {
  _inherits(Dropdown, _Positionable);

  function Dropdown() {
    _classCallCheck(this, Dropdown);

    return _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).apply(this, arguments));
  }

  _createClass(Dropdown, [{
    key: '_setup',

    /**
     * Creates a new instance of a dropdown.
     * @class
     * @param {jQuery} element - jQuery object to make into a dropdown.
     *        Object should be of the dropdown panel, rather than its anchor.
     * @param {Object} options - Overrides to the default plugin settings.
     */
    value: function _setup(element, options) {
      this.$element = element;
      this.options = _jquery2.default.extend({}, Dropdown.defaults, this.$element.data(), options);
      this.className = 'Dropdown'; // ie9 back compat

      // Triggers init is idempotent, just need to make sure it is initialized
      _foundationUtil3.Triggers.init(_jquery2.default);

      this._init();

      _foundationUtil.Keyboard.register('Dropdown', {
        'ENTER': 'open',
        'SPACE': 'open',
        'ESCAPE': 'close'
      });
    }

    /**
     * Initializes the plugin by setting/checking options and attributes, adding helper variables, and saving the anchor.
     * @function
     * @private
     */

  }, {
    key: '_init',
    value: function _init() {
      var $id = this.$element.attr('id');

      this.$anchor = (0, _jquery2.default)('[data-toggle="' + $id + '"]').length ? (0, _jquery2.default)('[data-toggle="' + $id + '"]') : (0, _jquery2.default)('[data-open="' + $id + '"]');
      this.$anchor.attr({
        'aria-controls': $id,
        'data-is-focus': false,
        'data-yeti-box': $id,
        'aria-haspopup': true,
        'aria-expanded': false

      });

      if (this.options.parentClass) {
        this.$parent = this.$element.parents('.' + this.options.parentClass);
      } else {
        this.$parent = null;
      }

      this.$element.attr({
        'aria-hidden': 'true',
        'data-yeti-box': $id,
        'data-resize': $id,
        'aria-labelledby': this.$anchor[0].id || (0, _foundationUtil2.GetYoDigits)(6, 'dd-anchor')
      });
      _get(Dropdown.prototype.__proto__ || Object.getPrototypeOf(Dropdown.prototype), '_init', this).call(this);
      this._events();
    }
  }, {
    key: '_getDefaultPosition',
    value: function _getDefaultPosition() {
      // handle legacy classnames
      var position = this.$element[0].className.match(/(top|left|right|bottom)/g);
      if (position) {
        return position[0];
      } else {
        return 'bottom';
      }
    }
  }, {
    key: '_getDefaultAlignment',
    value: function _getDefaultAlignment() {
      // handle legacy float approach
      var horizontalPosition = /float-(\S+)/.exec(this.$anchor[0].className);
      if (horizontalPosition) {
        return horizontalPosition[1];
      }

      return _get(Dropdown.prototype.__proto__ || Object.getPrototypeOf(Dropdown.prototype), '_getDefaultAlignment', this).call(this);
    }

    /**
     * Sets the position and orientation of the dropdown pane, checks for collisions if allow-overlap is not true.
     * Recursively calls itself if a collision is detected, with a new position class.
     * @function
     * @private
     */

  }, {
    key: '_setPosition',
    value: function _setPosition() {
      _get(Dropdown.prototype.__proto__ || Object.getPrototypeOf(Dropdown.prototype), '_setPosition', this).call(this, this.$anchor, this.$element, this.$parent);
    }

    /**
     * Adds event listeners to the element utilizing the triggers utility library.
     * @function
     * @private
     */

  }, {
    key: '_events',
    value: function _events() {
      var _this = this;
      this.$element.on({
        'open.zf.trigger': this.open.bind(this),
        'close.zf.trigger': this.close.bind(this),
        'toggle.zf.trigger': this.toggle.bind(this),
        'resizeme.zf.trigger': this._setPosition.bind(this)
      });

      if (this.options.hover) {
        this.$anchor.off('mouseenter.zf.dropdown mouseleave.zf.dropdown').on('mouseenter.zf.dropdown', function () {
          var bodyData = (0, _jquery2.default)('body').data();
          if (typeof bodyData.whatinput === 'undefined' || bodyData.whatinput === 'mouse') {
            clearTimeout(_this.timeout);
            _this.timeout = setTimeout(function () {
              _this.open();
              _this.$anchor.data('hover', true);
            }, _this.options.hoverDelay);
          }
        }).on('mouseleave.zf.dropdown', function () {
          clearTimeout(_this.timeout);
          _this.timeout = setTimeout(function () {
            _this.close();
            _this.$anchor.data('hover', false);
          }, _this.options.hoverDelay);
        });
        if (this.options.hoverPane) {
          this.$element.off('mouseenter.zf.dropdown mouseleave.zf.dropdown').on('mouseenter.zf.dropdown', function () {
            clearTimeout(_this.timeout);
          }).on('mouseleave.zf.dropdown', function () {
            clearTimeout(_this.timeout);
            _this.timeout = setTimeout(function () {
              _this.close();
              _this.$anchor.data('hover', false);
            }, _this.options.hoverDelay);
          });
        }
      }
      this.$anchor.add(this.$element).on('keydown.zf.dropdown', function (e) {

        var $target = (0, _jquery2.default)(this),
            visibleFocusableElements = _foundationUtil.Keyboard.findFocusable(_this.$element);

        _foundationUtil.Keyboard.handleKey(e, 'Dropdown', {
          open: function open() {
            if ($target.is(_this.$anchor)) {
              _this.open();
              _this.$element.attr('tabindex', -1).focus();
              e.preventDefault();
            }
          },
          close: function close() {
            _this.close();
            _this.$anchor.focus();
          }
        });
      });
    }

    /**
     * Adds an event handler to the body to close any dropdowns on a click.
     * @function
     * @private
     */

  }, {
    key: '_addBodyHandler',
    value: function _addBodyHandler() {
      var $body = (0, _jquery2.default)(document.body).not(this.$element),
          _this = this;
      $body.off('click.zf.dropdown').on('click.zf.dropdown', function (e) {
        if (_this.$anchor.is(e.target) || _this.$anchor.find(e.target).length) {
          return;
        }
        if (_this.$element.find(e.target).length) {
          return;
        }
        _this.close();
        $body.off('click.zf.dropdown');
      });
    }

    /**
     * Opens the dropdown pane, and fires a bubbling event to close other dropdowns.
     * @function
     * @fires Dropdown#closeme
     * @fires Dropdown#show
     */

  }, {
    key: 'open',
    value: function open() {
      // var _this = this;
      /**
       * Fires to close other open dropdowns, typically when dropdown is opening
       * @event Dropdown#closeme
       */
      this.$element.trigger('closeme.zf.dropdown', this.$element.attr('id'));
      this.$anchor.addClass('hover').attr({ 'aria-expanded': true });
      // this.$element/*.show()*/;

      this.$element.addClass('is-opening');
      this._setPosition();
      this.$element.removeClass('is-opening').addClass('is-open').attr({ 'aria-hidden': false });

      if (this.options.autoFocus) {
        var $focusable = _foundationUtil.Keyboard.findFocusable(this.$element);
        if ($focusable.length) {
          $focusable.eq(0).focus();
        }
      }

      if (this.options.closeOnClick) {
        this._addBodyHandler();
      }

      if (this.options.trapFocus) {
        _foundationUtil.Keyboard.trapFocus(this.$element);
      }

      /**
       * Fires once the dropdown is visible.
       * @event Dropdown#show
       */
      this.$element.trigger('show.zf.dropdown', [this.$element]);
    }

    /**
     * Closes the open dropdown pane.
     * @function
     * @fires Dropdown#hide
     */

  }, {
    key: 'close',
    value: function close() {
      if (!this.$element.hasClass('is-open')) {
        return false;
      }
      this.$element.removeClass('is-open').attr({ 'aria-hidden': true });

      this.$anchor.removeClass('hover').attr('aria-expanded', false);

      /**
       * Fires once the dropdown is no longer visible.
       * @event Dropdown#hide
       */
      this.$element.trigger('hide.zf.dropdown', [this.$element]);

      if (this.options.trapFocus) {
        _foundationUtil.Keyboard.releaseFocus(this.$element);
      }
    }

    /**
     * Toggles the dropdown pane's visibility.
     * @function
     */

  }, {
    key: 'toggle',
    value: function toggle() {
      if (this.$element.hasClass('is-open')) {
        if (this.$anchor.data('hover')) return;
        this.close();
      } else {
        this.open();
      }
    }

    /**
     * Destroys the dropdown.
     * @function
     */

  }, {
    key: '_destroy',
    value: function _destroy() {
      this.$element.off('.zf.trigger').hide();
      this.$anchor.off('.zf.dropdown');
      (0, _jquery2.default)(document.body).off('click.zf.dropdown');
    }
  }]);

  return Dropdown;
}(_foundation.Positionable);

Dropdown.defaults = {
  /**
   * Class that designates bounding container of Dropdown (default: window)
   * @option
   * @type {?string}
   * @default null
   */
  parentClass: null,
  /**
   * Amount of time to delay opening a submenu on hover event.
   * @option
   * @type {number}
   * @default 250
   */
  hoverDelay: 250,
  /**
   * Allow submenus to open on hover events
   * @option
   * @type {boolean}
   * @default false
   */
  hover: false,
  /**
   * Don't close dropdown when hovering over dropdown pane
   * @option
   * @type {boolean}
   * @default false
   */
  hoverPane: false,
  /**
   * Number of pixels between the dropdown pane and the triggering element on open.
   * @option
   * @type {number}
   * @default 0
   */
  vOffset: 0,
  /**
   * Number of pixels between the dropdown pane and the triggering element on open.
   * @option
   * @type {number}
   * @default 0
   */
  hOffset: 0,
  /**
   * DEPRECATED: Class applied to adjust open position.
   * @option
   * @type {string}
   * @default ''
   */
  positionClass: '',

  /**
   * Position of dropdown. Can be left, right, bottom, top, or auto.
   * @option
   * @type {string}
   * @default 'auto'
   */
  position: 'auto',
  /**
   * Alignment of dropdown relative to anchor. Can be left, right, bottom, top, center, or auto.
   * @option
   * @type {string}
   * @default 'auto'
   */
  alignment: 'auto',
  /**
   * Allow overlap of container/window. If false, dropdown will first try to position as defined by data-position and data-alignment, but reposition if it would cause an overflow.
   * @option
   * @type {boolean}
   * @default false
   */
  allowOverlap: false,
  /**
   * Allow overlap of only the bottom of the container. This is the most common
   * behavior for dropdowns, allowing the dropdown to extend the bottom of the
   * screen but not otherwise influence or break out of the container.
   * @option
   * @type {boolean}
   * @default true
   */
  allowBottomOverlap: true,
  /**
   * Allow the plugin to trap focus to the dropdown pane if opened with keyboard commands.
   * @option
   * @type {boolean}
   * @default false
   */
  trapFocus: false,
  /**
   * Allow the plugin to set focus to the first focusable element within the pane, regardless of method of opening.
   * @option
   * @type {boolean}
   * @default false
   */
  autoFocus: false,
  /**
   * Allows a click on the body to close the dropdown.
   * @option
   * @type {boolean}
   * @default false
   */
  closeOnClick: false
};

exports.Dropdown = Dropdown;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*


   Magic Zoom Plus v5.2.5 
   Copyright 2017 Magic Toolbox
   Buy a license: https://www.magictoolbox.com/magiczoomplus/
   License agreement: https://www.magictoolbox.com/license/


*/
eval(function (m, a, g, i, _c, k) {
   _c = function c(e) {
      return (e < a ? '' : _c(parseInt(e / a))) + ((e = e % a) > 35 ? String.fromCharCode(e + 29) : e.toString(36));
   };if (!''.replace(/^/, String)) {
      while (g--) {
         k[_c(g)] = i[g] || _c(g);
      }i = [function (e) {
         return k[e];
      }];_c = function _c() {
         return '\\w+';
      };g = 1;
   };while (g--) {
      if (i[g]) {
         m = m.replace(new RegExp('\\b' + _c(g) + '\\b', 'g'), i[g]);
      }
   }return m;
}('1k.a2=(17(){1b z,A;z=A=(17(){1b V={4I:"kh.3-b5-1-fG",ej:0,8y:{},$bG:17(Z){1a(Z.$62||(Z.$62=++P.ej))},9k:17(Z){1a(P.8y[Z]||(P.8y[Z]={}))},$F:17(){},$1l:17(){1a 1l},$1r:17(){1a 1r},dN:"fz-"+1p.5P(1p.6o()*1t cf().fe()),3v:17(Z){1a(2E!=Z)},bd:17(aa,Z){1a(2E!=aa)?aa:Z},aq:17(Z){1a!!(Z)},1O:17(Z){if(!P.3v(Z)){1a 1l}if(Z.$4B){1a Z.$4B}if(!!Z.5W){if(1==Z.5W){1a"6n"}if(3==Z.5W){1a"d7"}}if(Z.1I&&Z.f1){1a"ha"}if(Z.1I&&Z.9I){1a"26"}if((Z 5n 1k.6M||Z 5n 1k.ch)&&Z.5p===P.3N){1a"3T"}if(Z 5n 1k.65){1a"4f"}if(Z 5n 1k.ch){1a"17"}if(Z 5n 1k.5X){1a"1N"}if(P.1e.57){if(P.3v(Z.dl)){1a"1z"}}1j{if(Z===1k.1z||Z.5p==1k.1v||Z.5p==1k.ff||Z.5p==1k.cJ||Z.5p==1k.gX||Z.5p==1k.gZ){1a"1z"}}if(Z 5n 1k.cf){1a"dR"}if(Z 5n 1k.eg){1a"hb"}if(Z===1k){1a"1k"}if(Z===1n){1a"1n"}1a 80(Z)},2a:17(ae,ad){if(!(ae 5n 1k.65)){ae=[ae]}if(!ad){1a ae[0]}1T(1b ac=0,aa=ae.1I;ac<aa;ac++){if(!P.3v(ae)){8O}1T(1b ab in ad){if(!6M.2z.41.2c(ad,ab)){8O}3e{ae[ac][ab]=ad[ab]}3t(Z){}}}1a ae[0]},9m:17(ad,ac){if(!(ad 5n 1k.65)){ad=[ad]}1T(1b ab=0,Z=ad.1I;ab<Z;ab++){if(!P.3v(ad[ab])){8O}if(!ad[ab].2z){8O}1T(1b aa in(ac||{})){if(!ad[ab].2z[aa]){ad[ab].2z[aa]=ac[aa]}}}1a ad[0]},cI:17(ab,aa){if(!P.3v(ab)){1a ab}1T(1b Z in(aa||{})){if(!ab[Z]){ab[Z]=aa[Z]}}1a ab},$3e:17(){1T(1b aa=0,Z=26.1I;aa<Z;aa++){3e{1a 26[aa]()}3t(ab){}}1a 1h},$A:17(ab){if(!P.3v(ab)){1a P.$([])}if(ab.f0){1a P.$(ab.f0())}if(ab.f1){1b aa=ab.1I||0,Z=1t 65(aa);5K(aa--){Z[aa]=ab[aa]}1a P.$(Z)}1a P.$(65.2z.b8.2c(ab))},6y:17(){1a 1t cf().fe()},43:17(ad){1b ab;4H(P.1O(ad)){1C"7U":ab={};1T(1b ac in ad){ab[ac]=P.43(ad[ac])}1H;1C"4f":ab=[];1T(1b aa=0,Z=ad.1I;aa<Z;aa++){ab[aa]=P.43(ad[aa])}1H;1Q:1a ad}1a P.$(ab)},$:17(ab){1b Z=1r;if(!P.3v(ab)){1a 1h}if(ab.$bM){1a ab}4H(P.1O(ab)){1C"4f":ab=P.cI(ab,P.2a(P.65,{$bM:P.$F}));ab.3f=ab.fA;1a ab;1H;1C"1N":1b aa=1n.d2(ab);if(P.3v(aa)){1a P.$(aa)}1a 1h;1H;1C"1k":1C"1n":P.$bG(ab);ab=P.2a(ab,P.3A);1H;1C"6n":P.$bG(ab);ab=P.2a(ab,P.3V);1H;1C"1z":ab=P.2a(ab,P.1v);1H;1C"d7":1C"17":1C"4f":1C"dR":1Q:Z=1l;1H}if(Z){1a P.2a(ab,{$bM:P.$F})}1j{1a ab}},$1t:17(Z,ab,aa){1a P.$(P.fp.8E(Z)).8u(ab||{}).1y(aa||{})},6G:17(ac,ad,aa){1b Z,af,ab,ah=[],ag=-1;aa||(aa=P.dN);Z=P.$(aa)||P.$1t("2o",{id:aa,1u:"9N/6h"}).24((1n.fK||1n.3B),"1G");af=Z.fm||Z.eU;if("1N"!=P.1O(ad)){1T(1b ab in ad){ah.3g(ab+":"+ad[ab])}ad=ah.7K(";")}if(af.cV){ag=af.cV(ac+" {"+ad+"}",af.fY.1I)}1j{3e{ag=af.g9(ac,ad,af.gg.1I)}3t(ae){}}1a ag},ga:17(ac,Z){1b ab,aa;ab=P.$(ac);if("6n"!==P.1O(ab)){1a}aa=ab.fm||ab.eU;if(aa.ea){aa.ea(Z)}1j{if(aa.e5){aa.e5(Z)}}},g2:17(){1a"g5-fJ-fH-fC-gb".4u(/[gf]/g,17(ab){1b aa=1p.6o()*16|0,Z=ab=="x"?aa:(aa&3|8);1a Z.8M(16)}).7e()},6w:(17(){1b Z;1a 17(aa){if(!Z){Z=1n.8E("a")}Z.3D("74",aa);1a("!!"+Z.74).4u("!!","")}})(),gc:17(ab){1b ac=0,Z=ab.1I;1T(1b aa=0;aa<Z;++aa){ac=31*ac+ab.en(aa);ac%=g6}1a ac}};1b P=V;1b Q=V.$;if(!1k.ft){1k.ft=V;1k.$fz=V.$}P.65={$4B:"4f",4E:17(ac,ad){1b Z=13.1I;1T(1b aa=13.1I,ab=(ad<0)?1p.1W(0,aa+ad):ad||0;ab<aa;ab++){if(13[ab]===ac){1a ab}}1a-1},5O:17(Z,aa){1a 13.4E(Z,aa)!=-1},fA:17(Z,ac){1T(1b ab=0,aa=13.1I;ab<aa;ab++){if(ab in 13){Z.2c(ac,13[ab],ab,13)}}},2X:17(Z,ae){1b ad=[];1T(1b ac=0,aa=13.1I;ac<aa;ac++){if(ac in 13){1b ab=13[ac];if(Z.2c(ae,13[ac],ac,13)){ad.3g(ab)}}}1a ad},fZ:17(Z,ad){1b ac=[];1T(1b ab=0,aa=13.1I;ab<aa;ab++){if(ab in 13){ac[ab]=Z.2c(ad,13[ab],ab,13)}}1a ac}};P.9m(5X,{$4B:"1N",4P:17(){1a 13.4u(/^\\s+|\\s+$/g,"")},eq:17(Z,aa){1a(aa||1l)?(13.8M()===Z.8M()):(13.5l().8M()===Z.5l().8M())},5w:17(){1a 13.4u(/-\\D/g,17(Z){1a Z.a7(1).7e()})},97:17(){1a 13.4u(/[A-Z]/g,17(Z){1a("-"+Z.a7(0).5l())})},gj:17(Z){1a 5T(13,Z||10)},gm:17(){1a 2u(13)},cR:17(){1a!13.4u(/1r/i,"").4P()},4K:17(aa,Z){Z=Z||"";1a(Z+13+Z).4E(Z+aa+Z)>-1}});V.9m(ch,{$4B:"17",1F:17(){1b aa=P.$A(26),Z=13,ab=aa.6L();1a 17(){1a Z.6e(ab||1h,aa.5M(P.$A(26)))}},2L:17(){1b aa=P.$A(26),Z=13,ab=aa.6L();1a 17(ac){1a Z.6e(ab||1h,P.$([ac||(P.1e.2C?1k.1z:1h)]).5M(aa))}},2F:17(){1b aa=P.$A(26),Z=13,ab=aa.6L();1a 1k.4q(17(){1a Z.6e(Z,aa)},ab||0)},f3:17(){1b aa=P.$A(26),Z=13;1a 17(){1a Z.2F.6e(Z,aa)}},dD:17(){1b aa=P.$A(26),Z=13,ab=aa.6L();1a 1k.ep(17(){1a Z.6e(Z,aa)},ab||0)}});1b W={},O=2v.fL.5l(),N=O.3G(/(3S|6a|57|ba)\\/(\\d+\\.?\\d*)/i),S=O.3G(/(fS|aB)\\/(\\d+\\.?\\d*)/i)||O.3G(/(ec|5U|9D|ck|6Y|aB)\\/(\\d+\\.?\\d*)/i),U=O.3G(/4I\\/(\\d+\\.?\\d*)/i),J=1n.5a.2o;17 K(aa){1b Z=aa.a7(0).7e()+aa.b8(1);1a aa in J||("e9"+Z)in J||("e6"+Z)in J||("6C"+Z)in J||("O"+Z)in J}P.1e={2M:{g7:!!(1n.g1),gl:!!(1k.bU),bI:!!(1n.dC),4Z:!!(1n.fU||1n.fF||1n.9Y||1n.fr||1n.fV||1n.g0||1n.g3||1n.g4||1n.g8),cO:!!(1k.gn)&&!!(1k.gh)&&(1k.9P&&"fD"in 1t 9P),1Y:K("1Y"),2k:K("2k"),8Y:K("8Y"),dd:K("dd"),4V:1l,eK:1l,8k:1l,5t:1l,7z:(17(){1a 1n.fI.fN("b0://b3.b4.b6/fO/fP/fQ#hJ","1.1")})()},au:17(){1a"hI"in 1k||(1k.d8&&1n 5n d8)||(2v.hz>0)||(2v.hw>0)}(),2V:O.3G(/(6T|bb\\d+|iq).+|im|il\\/|ij|ii|ih|ig|ic|ib|ia|ip(eT|es|ad)|i9|i7|hU |i6|i5|i4|2V.+ck|i3|6Y m(i2|in)i|i1( hY)?|eW|p(hX|hW)\\/|hV|hT|hn|gT(4|6)0|hm|gQ|gP\\.(1e|3O)|gM|gJ|gG (ce|eW)|gC|gB/)?1r:1l,7I:(N&&N[1])?N[1].5l():(1k.6Y)?"ba":!!(1k.gA)?"57":(2E!==1n.gz||1h!=1k.gy)?"6a":(1h!==1k.gx||!2v.gu)?"3S":"gt",4I:(N&&N[2])?2u(N[2]):0,4v:(S&&S[1])?S[1].5l():"",75:(S&&S[2])?2u(S[2]):0,87:"",aW:"",4R:"",2C:0,4O:O.3G(/ip(?:ad|es|eT)/)?"9B":(O.3G(/(?:hf|6T)/)||2v.4O.3G(/he|a6|hd/i)||["hc"])[0].5l(),fy:1n.9u&&"e3"==1n.9u.5l(),eB:0,49:17(){1a(1n.9u&&"e3"==1n.9u.5l())?1n.3B:1n.5a},4V:1k.4V||1k.h9||1k.h5||1k.h2||1k.h1||2E,8W:1k.8W||1k.eN||1k.eN||1k.h0||1k.gV||1k.go||2E,2m:1l,7v:17(){if(P.1e.2m){1a}1b ac,ab;P.1e.2m=1r;P.3B=P.$(1n.3B);P.a6=P.$(1k);3e{1b aa=P.$1t("34").1y({1f:2K,1g:2K,7j:"6i",2h:"5R",1G:-gW}).24(1n.3B);P.1e.eB=aa.cW-aa.cY;aa.2U()}3t(Z){}3e{ac=P.$1t("34");ab=ac.2o;ab.eM="eL:29(aH://),29(aH://),gY 29(aH://)";P.1e.2M.eK=(/(29\\s*\\(.*?){3}/).3k(ab.eL);ab=1h;ac=1h}3t(Z){}if(!P.1e.7r){P.1e.7r=P.8Z("2k").97()}3e{ac=P.$1t("34");ac.2o.eM=P.8Z("2X").97()+":59(h3);";P.1e.2M.8k=!!ac.2o.1I&&(!P.1e.2C||P.1e.2C>9);ac=1h}3t(Z){}if(!P.1e.2M.8k){P.$(1n.5a).1B("6F-h4-3h")}3e{P.1e.2M.5t=(17(){1b ad=P.$1t("5t");1a!!(ad.eO&&ad.eO("2d"))})()}3t(Z){}if(2E===1k.h6&&2E!==1k.gU){W.2W="h7"}P.3A.33.2c(P.$(1n),"a5")}};(17(){1b ae=[],ad,ac,aa;17 Z(){1a!!(26.9I.bp)}4H(P.1e.7I){1C"57":if(!P.1e.4I){P.1e.4I=!!(1k.9P)?3:2}1H;1C"6a":P.1e.4I=(S&&S[2])?2u(S[2]):0;1H}P.1e[P.1e.7I]=1r;if(S&&"ec"===S[1]){P.1e.4v="5U"}if(!!1k.5U){P.1e.5U=1r}if(S&&"aB"===S[1]){P.1e.4v="6Y";P.1e.6Y=1r}if("9D"===P.1e.4v&&(U&&U[1])){P.1e.75=2u(U[1])}if("6T"==P.1e.4O&&P.1e.3S&&(U&&U[1])){P.1e.7T=1r}ad=({6a:["-e7-","e6","e7"],3S:["-3S-","e9","3S"],57:["-6C-","6C","6C"],ba:["-o-","O","o"]})[P.1e.7I]||["","",""];P.1e.87=ad[0];P.1e.aW=ad[1];P.1e.4R=ad[2];P.1e.2C=(!P.1e.57)?2E:(1n.eV)?1n.eV:17(){1b af=0;if(P.1e.fy){1a 5}4H(P.1e.4I){1C 2:af=6;1H;1C 3:af=7;1H}1a af}();ae.3g(P.1e.4O+"-3h");if(P.1e.2V){ae.3g("2V-3h")}if(P.1e.7T){ae.3g("6T-1e-3h")}if(P.1e.2C){P.1e.4v="ie";P.1e.75=P.1e.2C;ae.3g("ie"+P.1e.2C+"-3h");1T(ac=11;ac>P.1e.2C;ac--){ae.3g("hg-ie"+ac+"-3h")}}if(P.1e.3S&&P.1e.4I<hh){P.1e.2M.4Z=1l}if(P.1e.4V){P.1e.4V.2c(1k,17(){P.1e.2M.4V=1r})}if(P.1e.2M.7z){ae.3g("7z-3h")}1j{ae.3g("6F-7z-3h")}aa=(1n.5a.5Y||"").3G(/\\S+/g)||[];1n.5a.5Y=P.$(aa).5M(ae).7K(" ");3e{1n.5a.3D("3x-3h-fl",P.1e.4v);1n.5a.3D("3x-3h-fl-hi",P.1e.75)}3t(ab){}if(P.1e.2C&&P.1e.2C<9){1n.8E("5J");1n.8E("eZ")}})();(17(){P.1e.4Z={91:P.1e.2M.4Z,4T:17(){1a!!(1n.hj||1n[P.1e.4R+"hk"]||1n.4Z||1n.hl||1n[P.1e.4R+"h8"])},ci:17(Z,aa){aa||(aa={});if(13.91){P.$(1n).1D(13.bt,13.fs=17(ab){if(13.4T()){aa.c2&&aa.c2()}1j{P.$(1n).1P(13.bt,13.fs);aa.ca&&aa.ca()}}.2L(13));P.$(1n).1D(13.bu,13.6m=17(ab){aa.8h&&aa.8h();P.$(1n).1P(13.bu,13.6m)}.2L(13));(Z[P.1e.4R+"gS"]||Z[P.1e.4R+"gE"]||Z.gR||17(){}).2c(Z)}1j{if(aa.8h){aa.8h()}}},d6:(1n.9Y||1n.fr||1n[P.1e.4R+"gr"]||1n[P.1e.4R+"gs"]||17(){}).1F(1n),bt:1n.fi?"gv":(1n.9Y?"":P.1e.4R)+"gw",bu:1n.fi?"gq":(1n.9Y?"":P.1e.4R)+"gD",gF:P.1e.4R,gH:1h}})();1b Y=/\\S+/g,M=/^(3Q(fb|dY|dX|cy)gI)|((7F|7S)(fb|dY|dX|cy))$/,R={"gK":("2E"===80(J.cB))?"gL":"cB"},T={eJ:1r,eR:1r,2p:1r,e1:1r,1m:1r},L=(1k.cD)?17(ab,Z){1b aa=1k.cD(ab,1h);1a aa?aa.gN(Z)||aa[Z]:1h}:17(ac,aa){1b ab=ac.gO,Z=1h;Z=ab?ab[aa]:1h;if(1h==Z&&ac.2o&&ac.2o[aa]){Z=ac.2o[aa]}1a Z};17 X(ab){1b Z,aa;aa=(P.1e.3S&&"2X"==ab)?1l:(ab in J);if(!aa){Z=P.1e.aW+ab.a7(0).7e()+ab.b8(1);if(Z in J){1a Z}}1a ab}P.8Z=X;P.3V={cv:17(Z){1a!(Z||"").4K(" ")&&(13.5Y||"").4K(Z," ")},1B:17(ad){1b aa=(13.5Y||"").3G(Y)||[],ac=(ad||"").3G(Y)||[],Z=ac.1I,ab=0;1T(;ab<Z;ab++){if(!P.$(aa).5O(ac[ab])){aa.3g(ac[ab])}}13.5Y=aa.7K(" ");1a 13},1U:17(ae){1b aa=(13.5Y||"").3G(Y)||[],ad=(ae||"").3G(Y)||[],Z=ad.1I,ac=0,ab;1T(;ac<Z;ac++){if((ab=P.$(aa).4E(ad[ac]))>-1){aa.9y(ab,1)}}13.5Y=ae?aa.7K(" "):"";1a 13},hZ:17(Z){1a 13.cv(Z)?13.1U(Z):13.1B(Z)},3y:17(aa){1b ab=aa.5w(),Z=1h;aa=R[ab]||(R[ab]=X(ab));Z=L(13,aa);if("2B"===Z){Z=1h}if(1h!==Z){if("2p"==aa){1a P.3v(Z)?2u(Z):1}if(M.3k(aa)){Z=5T(Z,10)?Z:"63"}}1a Z},3J:17(aa,Z){1b ac=aa.5w();3e{if("2p"==aa){13.co(Z);1a 13}aa=R[ac]||(R[ac]=X(ac));13.2o[aa]=Z+(("6c"==P.1O(Z)&&!T[ac])?"2w":"")}3t(ab){}1a 13},1y:17(aa){1T(1b Z in aa){13.3J(Z,aa[Z])}1a 13},i0:17(){1b Z={};P.$A(26).3f(17(aa){Z[aa]=13.3y(aa)},13);1a Z},co:17(ab,Z){1b aa;Z=Z||1l;13.2o.2p=ab;ab=5T(2u(ab)*2K);if(Z){if(0===ab){if("3w"!=13.2o.4x){13.2o.4x="3w"}}1j{if("5G"!=13.2o.4x){13.2o.4x="5G"}}}if(P.1e.2C&&P.1e.2C<9){if(!9c(ab)){if(!~13.2o.2X.4E("bk")){13.2o.2X+=" cq:ct.cl.bk(9g="+ab+")"}1j{13.2o.2X=13.2o.2X.4u(/9g=\\d*/i,"9g="+ab)}}1j{13.2o.2X=13.2o.2X.4u(/cq:ct.cl.bk\\(9g=\\d*\\)/i,"").4P();if(""===13.2o.2X){13.2o.5H("2X")}}}1a 13},8u:17(Z){1T(1b aa in Z){if("3T"===aa){13.1B(""+Z[aa])}1j{13.3D(aa,""+Z[aa])}}1a 13},ir:17(){1b aa=0,Z=0;aa=13.3y("1Y-5o");Z=13.3y("1Y-bQ");aa=aa.4E("6C")>-1?2u(aa):aa.4E("s")>-1?2u(aa)*bs:0;Z=Z.4E("6C")>-1?2u(Z):Z.4E("s")>-1?2u(Z)*bs:0;1a aa+Z},4o:17(){1a 13.1y({6l:"2Y",4x:"3w"})},5z:17(){1a 13.1y({6l:"",4x:"5G"})},1E:17(){1a{1f:13.cW,1g:13.ik}},8A:17(aa){1b Z=13.1E();Z.1f-=(2u(13.3y("3Q-1M-1f")||0)+2u(13.3y("3Q-2J-1f")||0));Z.1g-=(2u(13.3y("3Q-1G-1f")||0)+2u(13.3y("3Q-2N-1f")||0));if(!aa){Z.1f-=(2u(13.3y("7F-1M")||0)+2u(13.3y("7F-2J")||0));Z.1g-=(2u(13.3y("7F-1G")||0)+2u(13.3y("7F-2N")||0))}1a Z},7p:17(){1a{1G:13.8q,1M:13.8n}},io:17(){1b Z=13,aa={1G:0,1M:0};do{aa.1M+=Z.8n||0;aa.1G+=Z.8q||0;Z=Z.4D}5K(Z);1a aa},88:17(){1b ad=13,aa=0,ac=0;if(P.3v(1n.5a.7w)){1b Z=13.7w(),ab=P.$(1n).7p(),ae=P.1e.49();1a{1G:Z.1G+ab.y-ae.i8,1M:Z.1M+ab.x-ae.hS}}do{aa+=ad.hD||0;ac+=ad.hR||0;ad=ad.hq}5K(ad&&!(/^(?:3B|bN)$/i).3k(ad.b9));1a{1G:ac,1M:aa}},7y:17(){1b aa=13.88();1b Z=13.1E();1a{1G:aa.1G,2N:aa.1G+Z.1g,1M:aa.1M,2J:aa.1M+Z.1f}},5A:17(aa){3e{13.hr=aa}3t(Z){13.hs=aa}1a 13},2U:17(){1a(13.4D)?13.4D.bf(13):13},5h:17(){P.$A(13.ht).3f(17(Z){if(3==Z.5W||8==Z.5W){1a}P.$(Z).5h()});13.2U();13.c1();if(13.$62){P.8y[13.$62]=1h;4W P.8y[13.$62]}1a 1h},3c:17(ab,aa){aa=aa||"2N";1b Z=13.4m;("1G"==aa&&Z)?13.hu(ab,Z):13.bZ(ab);1a 13},24:17(ab,aa){1b Z=P.$(ab).3c(13,aa);1a 13},ev:17(Z){13.3c(Z.4D.8N(13,Z));1a 13},9V:17(Z){if("6n"!==P.1O("1N"==P.1O(Z)?Z=1n.d2(Z):Z)){1a 1l}1a(13==Z)?1l:(13.5O&&!(P.1e.da))?(13.5O(Z)):(13.d3)?!!(13.d3(Z)&16):P.$A(13.8a(Z.b9)).5O(Z)}};P.3V.hv=P.3V.3y;P.3V.hx=P.3V.1y;if(!1k.3V){1k.3V=P.$F;if(P.1e.7I.3S){1k.1n.8E("hy")}1k.3V.2z=(P.1e.7I.3S)?1k["[[hA.2z]]"]:{}}P.9m(1k.3V,{$4B:"6n"});P.3A={1E:17(){if(P.1e.au||P.1e.hB||P.1e.da){1a{1f:1k.5y,1g:1k.5c}}1a{1f:P.1e.49().cY,1g:P.1e.49().hp}},7p:17(){1a{x:1k.hC||P.1e.49().8n,y:1k.hE||P.1e.49().8q}},hF:17(){1b Z=13.1E();1a{1f:1p.1W(P.1e.49().hG,Z.1f),1g:1p.1W(P.1e.49().hH,Z.1g)}}};P.2a(1n,{$4B:"1n"});P.2a(1k,{$4B:"1k"});P.2a([P.3V,P.3A],{2e:17(ac,aa){1b Z=P.9k(13.$62),ab=Z[ac];if(2E!==aa&&2E===ab){ab=Z[ac]=aa}1a(P.3v(ab)?ab:1h)},3b:17(ab,aa){1b Z=P.9k(13.$62);Z[ab]=aa;1a 13},38:17(aa){1b Z=P.9k(13.$62);4W Z[aa];1a 13}});if(!(1k.bc&&1k.bc.2z&&1k.bc.2z.bi)){P.2a([P.3V,P.3A],{bi:17(Z){1a P.$A(13.92("*")).2X(17(ab){3e{1a(1==ab.5W&&ab.5Y.4K(Z," "))}3t(aa){}})}})}P.2a([P.3V,P.3A],{9l:17(){1a 13.bi(26[0])},8a:17(){1a 13.92(26[0])}});if(P.1e.4Z.91&&!1n.di){P.3V.di=17(){P.1e.4Z.ci(13)}}P.1v={$4B:"1z",5Z:P.$1l,2g:17(){1a 13.5f().3X()},5f:17(){if(13.dj){13.dj()}1j{13.dl=1r}1a 13},3X:17(){if(13.dm){13.dm()}1j{13.hK=1l}1a 13},4j:17(){13.5Z=P.$1r;1a 13},7x:17(){1b aa,Z;aa=((/3z/i).3k(13.1u))?13.2I[0]:13;1a(!P.3v(aa))?{x:0,y:0}:{x:aa.2H,y:aa.2G}},5Q:17(){1b aa,Z;aa=((/3z/i).3k(13.1u))?13.2I[0]:13;1a(!P.3v(aa))?{x:0,y:0}:{x:aa.52||aa.2H+P.1e.49().8n,y:aa.4Y||aa.2G+P.1e.49().8q}},b7:17(){1b Z=13.4d||13.hL;5K(Z&&3==Z.5W){Z=Z.4D}1a Z},8m:17(){1b aa=1h;4H(13.1u){1C"7O":1C"hM":1C"hN":aa=13.9b||13.hO;1H;1C"8F":1C"c6":1C"f5":aa=13.9b||13.hP;1H;1Q:1a aa}3e{5K(aa&&3==aa.5W){aa=aa.4D}}3t(Z){aa=1h}1a aa},71:17(){if(!13.dn&&13.2t!==2E){1a(13.2t&1?1:(13.2t&2?3:(13.2t&4?2:0)))}1a 13.dn},hQ:17(){1a(13.2l&&("3z"===13.2l||13.2l===13.5m))||(/3z/i).3k(13.1u)},ho:17(){1a 13.2l?(("3z"===13.2l||13.5m===13.2l)&&13.9x):1===13.2I.1I&&(13.6g.1I?13.6g[0].3K==13.2I[0].3K:1r)}};P.aQ="fj";P.aV="gp";P.9R="";if(!1n.fj){P.aQ="fT";P.aV="fR";P.9R="8d"}P.1v.1x={1u:"",x:1h,y:1h,2R:1h,2t:1h,4d:1h,9b:1h,$4B:"1z.4l",5Z:P.$1l,5d:P.$([]),4a:17(Z){1b aa=Z;13.5d.3g(aa)},2g:17(){1a 13.5f().3X()},5f:17(){13.5d.3f(17(aa){3e{aa.5f()}3t(Z){}});1a 13},3X:17(){13.5d.3f(17(aa){3e{aa.3X()}3t(Z){}});1a 13},4j:17(){13.5Z=P.$1r;1a 13},7x:17(){1a{x:13.2H,y:13.2G}},5Q:17(){1a{x:13.x,y:13.y}},b7:17(){1a 13.4d},8m:17(){1a 13.9b},71:17(){1a 13.2t},d4:17(){1a 13.5d.1I>0?13.5d[0].b7():2E}};P.2a([P.3V,P.3A],{1D:17(ab,ad,ae,ah){1b ag,Z,ac,af,aa;if("1N"==P.1O(ab)){aa=ab.8Q(" ");if(aa.1I>1){ab=aa}}if(P.1O(ab)=="4f"){P.$(ab).3f(13.1D.2L(13,ad,ae,ah));1a 13}if(!ab||!ad||P.1O(ab)!="1N"||P.1O(ad)!="17"){1a 13}if(ab=="a5"&&P.1e.2m){ad.2c(13);1a 13}ab=W[ab]||ab;ae=5T(ae||50);if(!ad.$9F){ad.$9F=1p.5P(1p.6o()*P.6y())}ag=P.3A.2e.2c(13,"7Y",{});Z=ag[ab];if(!Z){ag[ab]=Z=P.$([]);ac=13;if(P.1v.1x[ab]){P.1v.1x[ab].1L.5S.2c(13,ah)}1j{Z.3n=17(ai){ai=P.2a(ai||1k.e,{$4B:"1z"});P.3A.33.2c(ac,ab,P.$(ai))};13[P.aQ](P.9R+ab,Z.3n,1l)}}af={1u:ab,fn:ad,aS:ae,de:ad.$9F};Z.3g(af);Z.fM(17(aj,ai){1a aj.aS-ai.aS});1a 13},1P:17(af){1b ad=P.3A.2e.2c(13,"7Y",{}),ab,Z,aa,ag,ae,ac;ae=26.1I>1?26[1]:-2K;if("1N"==P.1O(af)){ac=af.8Q(" ");if(ac.1I>1){af=ac}}if(P.1O(af)=="4f"){P.$(af).3f(13.1P.2L(13,ae));1a 13}af=W[af]||af;if(!af||P.1O(af)!="1N"||!ad||!ad[af]){1a 13}ab=ad[af]||[];1T(aa=0;aa<ab.1I;aa++){Z=ab[aa];if(-2K==ae||!!ae&&ae.$9F===Z.de){ag=ab.9y(aa--,1)}}if(0===ab.1I){if(P.1v.1x[af]){P.1v.1x[af].1L.2U.2c(13)}1j{13[P.aV](P.9R+af,ab.3n,1l)}4W ad[af]}1a 13},33:17(ad,af){1b ac=P.3A.2e.2c(13,"7Y",{}),ab,Z,aa;ad=W[ad]||ad;if(!ad||P.1O(ad)!="1N"||!ac||!ac[ad]){1a 13}3e{af=P.2a(af||{},{1u:ad})}3t(ae){}if(2E===af.2R){af.2R=P.6y()}ab=ac[ad]||[];1T(aa=0;aa<ab.1I&&!(af.5Z&&af.5Z());aa++){ab[aa].fn.2c(13,af)}},bL:17(aa,Z){1b ad=("a5"==aa)?1l:1r,ac=13,ab;aa=W[aa]||aa;if(!ad){P.3A.33.2c(13,aa);1a 13}if(ac===1n&&1n.9L&&!ac.aI){ac=1n.5a}if(1n.9L){ab=1n.9L(aa);ab.64(Z,1r,1r)}1j{ab=1n.fE();ab.9a=aa}if(1n.9L){ac.aI(ab)}1j{ac.fX("8d"+Z,ab)}1a ab},c1:17(){1b aa=P.3A.2e.2c(13,"7Y");if(!aa){1a 13}1T(1b Z in aa){P.3A.1P.2c(13,Z)}P.3A.38.2c(13,"7Y");1a 13}});(17(Z){if("8e"===1n.8g){1a Z.1e.7v.2F(1)}if(Z.1e.3S&&Z.1e.4I<fW){(17(){(Z.$(["2j","8e"]).5O(1n.8g))?Z.1e.7v():26.9I.2F(50)})()}1j{if(Z.1e.57&&Z.1e.2C<9&&1k==1G){(17(){(Z.$3e(17(){Z.1e.49().gk("1M");1a 1r}))?Z.1e.7v():26.9I.2F(50)})()}1j{Z.3A.1D.2c(Z.$(1n),"gi",Z.1e.7v);Z.3A.1D.2c(Z.$(1k),"67",Z.1e.7v)}}})(V);P.3N=17(){1b ad=1h,aa=P.$A(26);if("3T"==P.1O(aa[0])){ad=aa.6L()}1b Z=17(){1T(1b ag in 13){13[ag]=P.43(13[ag])}if(13.5p.$3H){13.$3H={};1b ai=13.5p.$3H;1T(1b ah in ai){1b af=ai[ah];4H(P.1O(af)){1C"17":13.$3H[ah]=P.3N.dz(13,af);1H;1C"7U":13.$3H[ah]=P.43(af);1H;1C"4f":13.$3H[ah]=P.43(af);1H}}}1b ae=(13.3L)?13.3L.6e(13,26):13;4W 13.bp;1a ae};if(!Z.2z.3L){Z.2z.3L=P.$F}if(ad){1b ac=17(){};ac.2z=ad.2z;Z.2z=1t ac;Z.$3H={};1T(1b ab in ad.2z){Z.$3H[ab]=ad.2z[ab]}}1j{Z.$3H=1h}Z.5p=P.3N;Z.2z.5p=Z;P.2a(Z.2z,aa[0]);P.2a(Z,{$4B:"3T"});1a Z};V.3N.dz=17(Z,aa){1a 17(){1b ac=13.bp;1b ab=aa.6e(Z,26);1a ab}};(17(ac){1b ab=ac.$;1b Z=5,aa=aU;ac.1v.1x.1R=1t ac.3N(ac.2a(ac.1v.1x,{1u:"1R",3L:17(af,ae){1b ad=ae.5Q();13.x=ad.x;13.y=ad.y;13.2H=ae.2H;13.2G=ae.2G;13.2R=ae.2R;13.2t=ae.71();13.4d=af;13.4a(ae)}}));ac.1v.1x.1R.1L={1w:{7m:aa,2t:1},5S:17(ad){13.3b("1z:1R:1w",ac.2a(ac.43(ac.1v.1x.1R.1L.1w),ad||{}));13.1D("6X",ac.1v.1x.1R.1L.3n,1);13.1D("6j",ac.1v.1x.1R.1L.3n,1);13.1D("2O",ac.1v.1x.1R.1L.bo,1);if(ac.1e.57&&ac.1e.2C<9){13.1D("9C",ac.1v.1x.1R.1L.3n,1)}},2U:17(){13.1P("6X",ac.1v.1x.1R.1L.3n);13.1P("6j",ac.1v.1x.1R.1L.3n);13.1P("2O",ac.1v.1x.1R.1L.bo);if(ac.1e.57&&ac.1e.2C<9){13.1P("9C",ac.1v.1x.1R.1L.3n)}},bo:17(ad){ad.3X()},3n:17(ag){1b af,ad,ae;ad=13.2e("1z:1R:1w");if(ag.1u!="9C"&&ag.71()!=ad.2t){1a}if(13.2e("1z:1R:bj")){13.38("1z:1R:bj");1a}if("6X"==ag.1u){af=1t ac.1v.1x.1R(13,ag);13.3b("1z:1R:9O",af)}1j{if("6j"==ag.1u){af=13.2e("1z:1R:9O");if(!af){1a}ae=ag.5Q();13.38("1z:1R:9O");af.4a(ag);if(ag.2R-af.2R<=ad.7m&&1p.8i(1p.4F(ae.x-af.x,2)+1p.4F(ae.y-af.y,2))<=Z){13.33("1R",af)}1n.33("6j",ag)}1j{if(ag.1u=="9C"){af=1t ac.1v.1x.1R(13,ag);13.33("1R",af)}}}}}})(V);(17(aa){1b Z=aa.$;aa.1v.1x.2T=1t aa.3N(aa.2a(aa.1v.1x,{1u:"2T",2n:"3M",6D:1l,3L:17(ae,ad,ac){1b ab=ad.5Q();13.x=ab.x;13.y=ab.y;13.2H=ad.2H;13.2G=ad.2G;13.2R=ad.2R;13.2t=ad.71();13.4d=ae;13.4a(ad);13.2n=ac}}));aa.1v.1x.2T.1L={5S:17(){1b ac=aa.1v.1x.2T.1L.cH.2L(13),ab=aa.1v.1x.2T.1L.9Q.2L(13);13.1D("6X",aa.1v.1x.2T.1L.aD,1);13.1D("6j",aa.1v.1x.2T.1L.9Q,1);1n.1D("6W",ac,1);1n.1D("6j",ab,1);13.3b("1z:2T:4N:1n:5u",ac);13.3b("1z:2T:4N:1n:7o",ab)},2U:17(){13.1P("6X",aa.1v.1x.2T.1L.aD);13.1P("6j",aa.1v.1x.2T.1L.9Q);Z(1n).1P("6W",13.2e("1z:2T:4N:1n:5u")||aa.$F);Z(1n).1P("6j",13.2e("1z:2T:4N:1n:7o")||aa.$F);13.38("1z:2T:4N:1n:5u");13.38("1z:2T:4N:1n:7o")},aD:17(ac){1b ab;if(1!=ac.71()){1a}ab=1t aa.1v.1x.2T(13,ac,"3M");13.3b("1z:2T:3M",ab)},9Q:17(ac){1b ab;ab=13.2e("1z:2T:3M");if(!ab){1a}ac.3X();ab=1t aa.1v.1x.2T(13,ac,"9z");13.38("1z:2T:3M");13.33("2T",ab)},cH:17(ac){1b ab;ab=13.2e("1z:2T:3M");if(!ab){1a}ac.3X();if(!ab.6D){ab.6D=1r;13.33("2T",ab)}ab=1t aa.1v.1x.2T(13,ac,"eP");13.33("2T",ab)}}})(V);(17(aa){1b Z=aa.$;aa.1v.1x.4b=1t aa.3N(aa.2a(aa.1v.1x,{1u:"4b",7C:1l,7h:1h,3L:17(ad,ac){1b ab=ac.5Q();13.x=ab.x;13.y=ab.y;13.2H=ac.2H;13.2G=ac.2G;13.2R=ac.2R;13.2t=ac.71();13.4d=ad;13.4a(ac)}}));aa.1v.1x.4b.1L={1w:{7m:7G},5S:17(ab){13.3b("1z:4b:1w",aa.2a(aa.43(aa.1v.1x.4b.1L.1w),ab||{}));13.1D("1R",aa.1v.1x.4b.1L.3n,1)},2U:17(){13.1P("1R",aa.1v.1x.4b.1L.3n)},3n:17(ad){1b ac,ab;ac=13.2e("1z:4b:1z");ab=13.2e("1z:4b:1w");if(!ac){ac=1t aa.1v.1x.4b(13,ad);ac.7h=4q(17(){ac.7C=1r;ad.5Z=aa.$1l;13.33("1R",ad);13.38("1z:4b:1z")}.1F(13),ab.7m+10);13.3b("1z:4b:1z",ac);ad.4j()}1j{3P(ac.7h);13.38("1z:4b:1z");if(!ac.7C){ac.4a(ad);ad.4j().2g();13.33("4b",ac)}1j{}}}}})(V);(17(af){1b ae=af.$;17 Z(ag){1a ag.2l?(("3z"===ag.2l||ag.5m===ag.2l)&&ag.9x):1===ag.2I.1I&&(ag.6g.1I?ag.6g[0].3K==ag.2I[0].3K:1r)}17 ab(ag){if(ag.2l){1a("3z"===ag.2l||ag.5m===ag.2l)?ag.9H:1h}1j{1a ag.2I[0].3K}}17 ac(ag){if(ag.2l){1a("3z"===ag.2l||ag.5m===ag.2l)?ag:1h}1j{1a ag.2I[0]}}af.1v.1x.21=1t af.3N(af.2a(af.1v.1x,{1u:"21",id:1h,3L:17(ah,ag){1b ai=ac(ag);13.id=ai.9H||ai.3K;13.x=ai.52;13.y=ai.4Y;13.52=ai.52;13.4Y=ai.4Y;13.2H=ai.2H;13.2G=ai.2G;13.2R=ag.2R;13.2t=0;13.4d=ah;13.4a(ag)}}));1b aa=10,ad=7G;af.1v.1x.21.1L={5S:17(ag){13.1D(["5g",1k.2v.3a?"6R":"7s"],af.1v.1x.21.1L.7f,1);13.1D(["6B",1k.2v.3a?"5r":"6A"],af.1v.1x.21.1L.6O,1);13.1D("2O",af.1v.1x.21.1L.ay,1)},2U:17(){13.1P(["5g",1k.2v.3a?"6R":"7s"],af.1v.1x.21.1L.7f);13.1P(["6B",1k.2v.3a?"5r":"6A"],af.1v.1x.21.1L.6O);13.1P("2O",af.1v.1x.21.1L.ay)},ay:17(ag){ag.3X()},7f:17(ag){if(!Z(ag)){13.38("1z:21:1z");1a}13.3b("1z:21:1z",1t af.1v.1x.21(13,ag));13.3b("1z:1R:bj",1r)},6O:17(aj){1b ah=af.6y(),ai=13.2e("1z:21:1z"),ag=13.2e("1z:21:1w");if(!ai||!Z(aj)){1a}13.38("1z:21:1z");if(ai.id==ab(aj)&&aj.2R-ai.2R<=ad&&1p.8i(1p.4F(ac(aj).52-ai.x,2)+1p.4F(ac(aj).4Y-ai.y,2))<=aa){13.38("1z:1R:9O");aj.2g();ai.4a(aj);13.33("21",ai)}}}})(V);P.1v.1x.3q=1t P.3N(P.2a(P.1v.1x,{1u:"3q",7C:1l,7h:1h,3L:17(aa,Z){13.x=Z.x;13.y=Z.y;13.2H=Z.2H;13.2G=Z.2G;13.2R=Z.2R;13.2t=0;13.4d=aa;13.4a(Z)}}));P.1v.1x.3q.1L={1w:{7m:aU},5S:17(Z){13.3b("1z:3q:1w",P.2a(P.43(P.1v.1x.3q.1L.1w),Z||{}));13.1D("21",P.1v.1x.3q.1L.3n,1)},2U:17(){13.1P("21",P.1v.1x.3q.1L.3n)},3n:17(ab){1b aa,Z;aa=13.2e("1z:3q:1z");Z=13.2e("1z:3q:1w");if(!aa){aa=1t P.1v.1x.3q(13,ab);aa.7h=4q(17(){aa.7C=1r;ab.5Z=P.$1l;13.33("21",ab)}.1F(13),Z.7m+10);13.3b("1z:3q:1z",aa);ab.4j()}1j{3P(aa.7h);13.38("1z:3q:1z");if(!aa.7C){aa.4a(ab);ab.4j().2g();13.33("3q",aa)}1j{}}}};(17(ae){1b ad=ae.$;17 Z(af){1a af.2l?(("3z"===af.2l||af.5m===af.2l)&&af.9x):1===af.2I.1I&&(af.6g.1I?af.6g[0].3K==af.2I[0].3K:1r)}17 ab(af){if(af.2l){1a("3z"===af.2l||af.5m===af.2l)?af.9H:1h}1j{1a af.2I[0].3K}}17 ac(af){if(af.2l){1a("3z"===af.2l||af.5m===af.2l)?af:1h}1j{1a af.2I[0]}}1b aa=10;ae.1v.1x.2q=1t ae.3N(ae.2a(ae.1v.1x,{1u:"2q",2n:"3M",id:1h,6D:1l,3L:17(ah,ag,af){1b ai=ac(ag);13.id=ai.9H||ai.3K;13.2H=ai.2H;13.2G=ai.2G;13.52=ai.52;13.4Y=ai.4Y;13.x=ai.52;13.y=ai.4Y;13.2R=ag.2R;13.2t=0;13.4d=ah;13.4a(ag);13.2n=af}}));ae.1v.1x.2q.1L={5S:17(){1b ag=ae.1v.1x.2q.1L.9o.1F(13),af=ae.1v.1x.2q.1L.6O.1F(13);13.1D(["5g",1k.2v.3a?"6R":"7s"],ae.1v.1x.2q.1L.7f,1);13.1D(["6B",1k.2v.3a?"5r":"6A"],ae.1v.1x.2q.1L.6O,1);13.1D(["7Q",1k.2v.3a?"5s":"6x"],ae.1v.1x.2q.1L.9o,1);13.3b("1z:2q:4N:1n:5u",ag);13.3b("1z:2q:4N:1n:7o",af);ad(1n).1D(1k.2v.3a?"5s":"6x",ag,1);ad(1n).1D(1k.2v.3a?"5r":"6A",af,1)},2U:17(){13.1P(["5g",1k.2v.3a?"6R":"7s"],ae.1v.1x.2q.1L.7f);13.1P(["6B",1k.2v.3a?"5r":"6A"],ae.1v.1x.2q.1L.6O);13.1P(["7Q",1k.2v.3a?"5s":"6x"],ae.1v.1x.2q.1L.9o);ad(1n).1P(1k.2v.3a?"5s":"6x",13.2e("1z:2q:4N:1n:5u")||ae.$F,1);ad(1n).1P(1k.2v.3a?"5r":"6A",13.2e("1z:2q:4N:1n:7o")||ae.$F,1);13.38("1z:2q:4N:1n:5u");13.38("1z:2q:4N:1n:7o")},7f:17(ag){1b af;if(!Z(ag)){1a}af=1t ae.1v.1x.2q(13,ag,"3M");13.3b("1z:2q:3M",af)},6O:17(ag){1b af;af=13.2e("1z:2q:3M");if(!af||!af.6D||af.id!=ab(ag)){1a}af=1t ae.1v.1x.2q(13,ag,"9z");13.38("1z:2q:3M");13.33("2q",af)},9o:17(ag){1b af;af=13.2e("1z:2q:3M");if(!af||!Z(ag)){1a}if(af.id!=ab(ag)){13.38("1z:2q:3M");1a}if(!af.6D&&1p.8i(1p.4F(ac(ag).52-af.x,2)+1p.4F(ac(ag).4Y-af.y,2))>aa){af.6D=1r;13.33("2q",af)}if(!af.6D){1a}af=1t ae.1v.1x.2q(13,ag,"eP");13.33("2q",af)}}})(V);P.1v.1x.3U=1t P.3N(P.2a(P.1v.1x,{1u:"3U",48:1,bw:1,fu:1,2n:"gd",3L:17(aa,Z){13.2R=Z.2R;13.2t=0;13.4d=aa;13.x=Z.4i[0].2H+(Z.4i[1].2H-Z.4i[0].2H)/2;13.y=Z.4i[0].2G+(Z.4i[1].2G-Z.4i[0].2G)/2;13.eI=1p.8i(1p.4F(Z.4i[0].2H-Z.4i[1].2H,2)+1p.4F(Z.4i[0].2G-Z.4i[1].2G,2));13.4a(Z)},3W:17(Z){1b aa;13.2n="ge";if(Z.2I[0].3K!=13.5d[0].4i[0].3K||Z.2I[1].3K!=13.5d[0].4i[1].3K){1a}aa=1p.8i(1p.4F(Z.2I[0].2H-Z.2I[1].2H,2)+1p.4F(Z.2I[0].2G-Z.2I[1].2G,2));13.bw=13.48;13.48=aa/13.eI;13.fu=13.48/13.bw;13.x=Z.2I[0].2H+(Z.2I[1].2H-Z.2I[0].2H)/2;13.y=Z.2I[0].2G+(Z.2I[1].2G-Z.2I[0].2G)/2;13.4a(Z)}}));P.1v.1x.3U.1L={5S:17(){13.1D("5g",P.1v.1x.3U.1L.aJ,1);13.1D("6B",P.1v.1x.3U.1L.az,1);13.1D("7Q",P.1v.1x.3U.1L.av,1)},2U:17(){13.1P("5g",P.1v.1x.3U.1L.aJ);13.1P("6B",P.1v.1x.3U.1L.az);13.1P("7Q",P.1v.1x.3U.1L.av)},aJ:17(aa){1b Z;if(aa.4i.1I!=2){1a}aa.3X();Z=1t P.1v.1x.3U(13,aa);13.3b("1z:3U:1z",Z)},az:17(aa){1b Z;Z=13.2e("1z:3U:1z");if(!Z){1a}aa.3X();13.38("1z:3U:1z")},av:17(aa){1b Z;Z=13.2e("1z:3U:1z");if(!Z){1a}aa.3X();Z.3W(aa);13.33("3U",Z)}};(17(ae){1b ac=ae.$;ae.1v.1x.4y=1t ae.3N(ae.2a(ae.1v.1x,{1u:"4y",3L:17(ak,aj,am,ag,af,al,ah){1b ai=aj.5Q();13.x=ai.x;13.y=ai.y;13.2R=aj.2R;13.4d=ak;13.it=am||0;13.bm=ag||0;13.8t=af||0;13.kW=al||0;13.la=ah||0;13.aZ=aj.aZ||0;13.bC=1l;13.4a(aj)}}));1b ad,aa;17 Z(){ad=1h}17 ab(af,ag){1a(af>50)||(1===ag&&!("a6"==ae.1e.4O&&af<1))||(0===af%12)||(0==af%4.ko)}ae.1v.1x.4y.1L={9a:"kk"in 1n||ae.1e.2C>8?"is":"ka",5S:17(){13.1D(ae.1v.1x.4y.1L.9a,ae.1v.1x.4y.1L.3n,1)},2U:17(){13.1P(ae.1v.1x.4y.1L.9a,ae.1v.1x.4y.1L.3n,1)},3n:17(ak){1b al=0,ai=0,ag=0,af=0,aj,ah;if(ak.ek){ag=ak.ek*-1}if(ak.em!==2E){ag=ak.em}if(ak.fq!==2E){ag=ak.fq}if(ak.fv!==2E){ai=ak.fv*-1}if(ak.8t){ag=-1*ak.8t}if(ak.bm){ai=ak.bm}if(0===ag&&0===ai){1a}al=0===ag?ai:ag;af=1p.1W(1p.3C(ag),1p.3C(ai));if(!ad||af<ad){ad=af}aj=al>0?"5P":"4p";al=1p[aj](al/ad);ai=1p[aj](ai/ad);ag=1p[aj](ag/ad);if(aa){3P(aa)}aa=4q(Z,7G);ah=1t ae.1v.1x.4y(13,ak,al,ai,ag,0,ad);ah.bC=ab(ad,ak.aZ||0);13.33("4y",ah)}}})(V);P.a6=P.$(1k);P.fp=P.$(1n);1a V})();(17(L){if(!L){5D"6S 6U 6V"}1b K=L.$;1b J=1k.kD||1k.kC||1h;z.aE=1t L.3N({2b:1h,2m:1l,1w:{9X:L.$F,6v:L.$F,aP:L.$F,6m:L.$F,7E:L.$F,f6:L.$F,9J:1l,f7:1r},1A:1h,8l:1h,bq:0,7H:{9X:17(M){if(M.4d&&(7G===M.4d.9h||f9===M.4d.9h)&&M.kB){13.1w.9X.1F(1h,(M.2j-(13.1w.f7?13.bq:0))/M.kA).2F(1);13.bq=M.2j}},6v:17(M){if(M){K(M).2g()}13.8j();if(13.2m){1a}13.2m=1r;13.8f();!13.1w.9J&&13.1w.9X.1F(1h,1).2F(1);13.1w.6v.1F(1h,13).2F(1);13.1w.7E.1F(1h,13).2F(1)},aP:17(M){if(M){K(M).2g()}13.8j();13.2m=1l;13.8f();13.1w.aP.1F(1h,13).2F(1);13.1w.7E.1F(1h,13).2F(1)},6m:17(M){if(M){K(M).2g()}13.8j();13.2m=1l;13.8f();13.1w.6m.1F(1h,13).2F(1);13.1w.7E.1F(1h,13).2F(1)}},9e:17(){K(["67","aN","f4"]).3f(17(M){13.2b.1D(M,13.7H["8d"+M].2L(13).f3(1))},13)},8j:17(){if(13.8l){3e{3P(13.8l)}3t(M){}13.8l=1h}K(["67","aN","f4"]).3f(17(N){13.2b.1P(N)},13)},8f:17(){13.1E();if(13.2b.2e("1t")){1b M=13.2b.4D;13.2b.2U().38("1t").1y({2h:"kz",1G:"2B"});M.5h()}},cP:17(N){1b O=1t 9P(),M;K(["aN","kx"]).3f(17(P){O["8d"+P]=K(17(Q){13.7H["8d"+P].2c(13,Q)}).1F(13)},13);O.6m=K(17(){13.1w.f6.1F(1h,13).2F(1);13.1w.9J=1l;13.9e();13.2b.1X=N}).1F(13);O.6v=K(17(){if(7G!==O.9h&&f9!==O.9h){13.7H.6m.2c(13);1a}M=O.kw;13.9e();if(J&&!L.1e.57&&!("9B"===L.1e.4O&&L.1e.4I<kv)){13.2b.3D("1X",J.kd(M))}1j{13.2b.1X=N}}).1F(13);O.8o("ku",N);O.ky="kt";O.kF()},3L:17(N,M){13.1w=L.2a(13.1w,M);13.2b=K(N)||L.$1t("2b",{},{"1W-1f":"2Y","1W-1g":"2Y"}).24(L.$1t("34").1B("3h-ax-2b").1y({2h:"5R",1G:-eA,1f:10,1g:10,7j:"3w"}).24(1n.3B)).3b("1t",1r);if(L.1e.2M.cO&&13.1w.9J&&"1N"==L.1O(N)){13.cP(N);1a}1b O=17(){if(13.cs()){13.7H.6v.2c(13)}1j{13.7H.6m.2c(13)}O=1h}.1F(13);13.9e();if("1N"==L.1O(N)){13.2b.1X=N}1j{if(L.1e.57&&5==L.1e.4I&&L.1e.2C<9){13.2b.cU=17(){if(/2j|8e/.3k(13.2b.8g)){13.2b.cU=1h;O&&O()}}.1F(13)}13.2b.1X=N.2s("1X")}13.2b&&13.2b.8e&&O&&(13.8l=O.2F(2K))},kH:17(){13.8j();13.8f();13.2m=1l;1a 13},cs:17(){1b M=13.2b;1a(M.8S)?(M.8S>0):(M.8g)?("8e"==M.8g):M.1f>0},1E:17(){1a 13.1A||(13.1A={1f:13.2b.8S||13.2b.1f,1g:13.2b.cE||13.2b.1g})}})})(z);(17(K){if(!K){5D"6S 6U 6V"}if(K.5N){1a}1b J=K.$;K.5N=1t K.3N({3L:17(M,L){1b N;13.el=K.$(M);13.1w=K.2a(13.1w,L);13.5I=1l;13.7u=13.aC;N=K.5N.8D[13.1w.1Y]||13.1w.1Y;if("17"===K.1O(N)){13.7u=N}1j{13.5x=13.7Z(N)||13.7Z("6z")}if("1N"==K.1O(13.1w.7g)){13.1w.7g="kI"===13.1w.7g?66:5T(13.1w.7g)||1}},1w:{dG:60,5o:8T,1Y:"6z",7g:1,56:"kJ",dA:K.$F,7i:K.$F,cj:K.$F,dV:K.$F,9K:1l,kK:1l},4r:1h,5x:1h,7u:1h,kL:17(L){13.1w.1Y=L;L=K.5N.8D[13.1w.1Y]||13.1w.1Y;if("17"===K.1O(L)){13.7u=L}1j{13.7u=13.aC;13.5x=13.7Z(L)||13.7Z("6z")}},4z:17(N){1b L=/\\%$/,M;13.4r=N||{};13.aR=0;13.2n=0;13.kM=0;13.8V={};13.7L="7L"===13.1w.56||"7L-4C"===13.1w.56;13.7D="7D"===13.1w.56||"7D-4C"===13.1w.56;1T(M in 13.4r){L.3k(13.4r[M][0])&&(13.8V[M]=1r);if("4C"===13.1w.56||"7L-4C"===13.1w.56||"7D-4C"===13.1w.56){13.4r[M].4C()}}13.aX=K.6y();13.dI=13.aX+13.1w.5o;13.1w.dA.2c();if(0===13.1w.5o){13.6H(1);13.1w.7i.2c()}1j{13.9G=13.dt.1F(13);if(!13.1w.9K&&K.1e.2M.4V){13.5I=K.1e.4V.2c(1k,13.9G)}1j{13.5I=13.9G.dD(1p.5V(bs/13.1w.dG))}}1a 13},aO:17(){if(13.5I){if(!13.1w.9K&&K.1e.2M.4V&&K.1e.8W){K.1e.8W.2c(1k,13.5I)}1j{d5(13.5I)}13.5I=1l}},2g:17(L){L=K.3v(L)?L:1l;13.aO();if(L){13.6H(1);13.1w.7i.2F(10)}1a 13},aY:17(N,M,L){N=2u(N);M=2u(M);1a(M-N)*L+N},dt:17(){1b M=K.6y(),L=(M-13.aX)/13.1w.5o,N=1p.5P(L);if(M>=13.dI&&N>=13.1w.7g){13.aO();13.6H(1);13.1w.7i.2F(10);1a 13}if(13.7L&&13.aR<N){1T(1b O in 13.4r){13.4r[O].4C()}}13.aR=N;if(!13.1w.9K&&K.1e.2M.4V){13.5I=K.1e.4V.2c(1k,13.9G)}13.6H((13.7D?N:0)+13.7u(L%1))},6H:17(L){1b M={},O=L;1T(1b N in 13.4r){if("2p"===N){M[N]=1p.5V(13.aY(13.4r[N][0],13.4r[N][1],L)*2K)/2K}1j{M[N]=13.aY(13.4r[N][0],13.4r[N][1],L);13.8V[N]&&(M[N]+="%")}}13.1w.cj(M,13.el);13.7M(M);13.1w.dV(M,13.el)},7M:17(L){1a 13.el.1y(L)},7Z:17(L){1b M,N=1h;if("1N"!==K.1O(L)){1a 1h}4H(L){1C"9r":N=J([0,0,1,1]);1H;1C"6z":N=J([0.25,0.1,0.25,1]);1H;1C"6z-in":N=J([0.42,0,1,1]);1H;1C"6z-dc":N=J([0,0,0.58,1]);1H;1C"6z-in-dc":N=J([0.42,0,0.58,1]);1H;1C"d1":N=J([0.47,0,0.kN,0.kE]);1H;1C"d0":N=J([0.39,0.kr,0.kg,1]);1H;1C"kq":N=J([0.k7,0.aL,0.55,0.95]);1H;1C"dJ":N=J([0.55,0.k8,0.68,0.53]);1H;1C"dU":N=J([0.25,0.46,0.45,0.94]);1H;1C"k9":N=J([0.kb,0.dE,0.kc,0.kP]);1H;1C"dT":N=J([0.55,0.ke,0.k6,0.19]);1H;1C"dS":N=J([0.kf,0.61,0.dp,1]);1H;1C"ki":N=J([0.kj,0.cb,0.dp,1]);1H;1C"kl":N=J([0.df,0.dE,0.dg,0.22]);1H;1C"km":N=J([0.db,0.84,0.44,1]);1H;1C"kn":N=J([0.77,0,0.ao,1]);1H;1C"kp":N=J([0.kO,0.aL,0.ks,0.kQ]);1H;1C"kZ":N=J([0.23,1,0.32,1]);1H;1C"l7":N=J([0.86,0,0.l8,1]);1H;1C"dq":N=J([0.95,0.aL,0.lc,0.ld]);1H;1C"dr":N=J([0.19,1,0.22,1]);1H;1C"kR":N=J([1,0,0,1]);1H;1C"l2":N=J([0.6,0.lf,0.98,0.kS]);1H;1C"kT":N=J([0.kU,0.82,0.db,1]);1H;1C"kY":N=J([0.l1,0.le,0.15,0.86]);1H;1C"dQ":N=J([0.6,-0.28,0.dk,0.cb]);1H;1C"dP":N=J([0.ao,0.bX,0.32,1.l9]);1H;1C"kX":N=J([0.68,-0.55,0.kV,1.55]);1H;1Q:L=L.4u(/\\s/g,"");if(L.3G(/^5q-5v\\((?:-?[0-9\\.]{0,}[0-9]{1,},){3}(?:-?[0-9\\.]{0,}[0-9]{1,})\\)$/)){N=L.4u(/^5q-5v\\s*\\(|\\)$/g,"").8Q(",");1T(M=N.1I-1;M>=0;M--){N[M]=2u(N[M])}}}1a J(N)},aC:17(X){1b L=0,W=0,T=0,Y=0,V=0,R=0,S=13.1w.5o;17 Q(Z){1a((L*Z+W)*Z+T)*Z}17 P(Z){1a((Y*Z+V)*Z+R)*Z}17 N(Z){1a(3*L*Z+2*W)*Z+T}17 U(Z){1a 1/(7G*Z)}17 M(Z,aa){1a P(O(Z,aa))}17 O(ag,ah){1b af,ae,ad,aa,Z,ac;17 ab(ai){if(ai>=0){1a ai}1j{1a 0-ai}}1T(ad=ag,ac=0;ac<8;ac++){aa=Q(ad)-ag;if(ab(aa)<ah){1a ad}Z=N(ad);if(ab(Z)<0.bE){1H}ad=ad-aa/Z}af=0;ae=1;ad=ag;if(ad<af){1a af}if(ad>ae){1a ae}5K(af<ae){aa=Q(ad);if(ab(aa-ag)<ah){1a ad}if(ag>aa){af=ad}1j{ae=ad}ad=(ae-af)*0.5+af}1a ad}T=3*13.5x[0];W=3*(13.5x[2]-13.5x[0])-T;L=1-T-W;R=3*13.5x[1];V=3*(13.5x[3]-13.5x[1])-R;Y=1-R-V;1a M(X,U(S))}});K.5N.8D={9r:"9r",l0:"d1",l3:"d0",l4:"dq",l5:"dr",lb:"dJ",l6:"dU",kG:"dT",k5:"dS",jh:"dQ",k3:"dP",dO:17(M,L){L=L||[];1a 1p.4F(2,10*--M)*1p.fa(20*M*1p.f8*(L[0]||1)/3)},iU:17(M,L){1a 1-K.5N.8D.dO(1-M,L)},dM:17(N){1T(1b M=0,L=1;1;M+=L,L/=2){if(N>=(7-4*M)/11){1a L*L-1p.4F((11-6*M-11*N)/4,2)}}},iV:17(L){1a 1-K.5N.8D.dM(1-L)},2Y:17(L){1a 0}}})(z);(17(K){if(!K){5D"6S 6U 6V"}if(K.9A){1a}1b J=K.$;K.9A=1t K.3N(K.5N,{3L:17(L,M){13.aG=L;13.1w=K.2a(13.1w,M);13.5I=1l;13.$3H.3L()},4z:17(P){1b L=/\\%$/,O,N,M=P.1I;13.aF=P;13.9q=1t 65(M);1T(N=0;N<M;N++){13.9q[N]={};1T(O in P[N]){L.3k(P[N][O][0])&&(13.9q[N][O]=1r);if("4C"===13.1w.56||"7L-4C"===13.1w.56||"7D-4C"===13.1w.56){13.aF[N][O].4C()}}}13.$3H.4z({});1a 13},6H:17(L){1T(1b M=0;M<13.aG.1I;M++){13.el=K.$(13.aG[M]);13.4r=13.aF[M];13.8V=13.9q[M];13.$3H.6H(L)}}})})(z);(17(K){if(!K){5D"6S 6U 6V";1a}if(K.aM){1a}1b J=K.$;K.aM=17(M,N){1b L=13.7q=K.$1t("34",1h,{2h:"5R","z-8x":dB}).1B("iW");K.$(M).1D("7O",17(){L.24(1n.3B)});K.$(M).1D("8F",17(){L.2U()});K.$(M).1D("6W",17(S){1b U=20,R=K.$(S).5Q(),Q=L.1E(),P=K.$(1k).1E(),T=K.$(1k).7p();17 O(X,V,W){1a(W<(X-V)/2)?W:((W>(X+V)/2)?(W-V):(X-V)/2)}L.1y({1M:T.x+O(P.1f,Q.1f+2*U,R.x-T.x)+U,1G:T.y+O(P.1g,Q.1g+2*U,R.y-T.y)+U})});13.9N(N)};K.aM.2z.9N=17(L){13.7q.4m&&13.7q.bf(13.7q.4m);13.7q.3c(1n.8R(L))}})(z);(17(K){if(!K){5D"6S 6U 6V";1a}if(K.iX){1a}1b J=K.$;K.9n=17(O,N,M,L){13.9i=1h;13.5i=K.$1t("bY",1h,{2h:"5R","z-8x":dB,4x:"3w",2p:0.8}).1B(L||"").24(M||1n.3B);13.du(O);13.5z(N)};K.9n.2z.5z=17(L){13.5i.5z();13.9i=13.4o.1F(13).2F(K.bd(L,iY))};K.9n.2z.4o=17(L){3P(13.9i);13.9i=1h;if(13.5i&&!13.be){13.be=1t z.5N(13.5i,{5o:K.bd(L,bA),7i:17(){13.5i.5h();4W 13.5i;13.be=1h}.1F(13)}).4z({2p:[13.5i.3y("2p"),0]})}};K.9n.2z.du=17(L){13.5i.4m&&13.7q.bf(13.5i.4m);13.5i.3c(1n.8R(L))}})(z);(17(K){if(!K){5D"6S 6U 6V"}if(K.7a){1a}1b N=K.$,J=1h,R={"3p":1,4f:2,6c:3,"17":4,1N:2K},L={"3p":17(U,T,S){if("3p"!=K.1O(T)){if(S||"1N"!=K.1O(T)){1a 1l}1j{if(!/^(1r|1l)$/.3k(T)){1a 1l}1j{T=T.cR()}}}if(U.41("2D")&&!N(U["2D"]).5O(T)){1a 1l}J=T;1a 1r},1N:17(U,T,S){if("1N"!==K.1O(T)){1a 1l}1j{if(U.41("2D")&&!N(U["2D"]).5O(T)){1a 1l}1j{J=""+T;1a 1r}}},6c:17(V,U,T){1b S=1l,X=/%$/,W=(K.1O(U)=="1N"&&X.3k(U));if(T&&!"6c"==80 U){1a 1l}U=2u(U);if(9c(U)){1a 1l}if(9c(V.7d)){V.7d=cm.iZ}if(9c(V.br)){V.br=cm.j0}if(V.41("2D")&&!N(V["2D"]).5O(U)){1a 1l}if(V.7d>U||U>V.br){1a 1l}J=W?(U+"%"):U;1a 1r},4f:17(V,T,S){if("1N"===K.1O(T)){3e{T=1k.j1.j2(T)}3t(U){1a 1l}}if(K.1O(T)==="4f"){J=T;1a 1r}1j{1a 1l}},"17":17(U,T,S){if(K.1O(T)==="17"){J=T;1a 1r}1j{1a 1l}}},M=17(X,W,T){1b V;V=X.41("3d")?X.3d:[X];if("4f"!=K.1O(V)){1a 1l}1T(1b U=0,S=V.1I-1;U<=S;U++){if(L[V[U].1u](V[U],W,T)){1a 1r}}1a 1l},P=17(X){1b V,U,W,S,T;if(X.41("3d")){S=X.3d.1I;1T(V=0;V<S;V++){1T(U=V+1;U<S;U++){if(R[X.3d[V]["1u"]]>R[X.3d[U].1u]){T=X.3d[V];X.3d[V]=X.3d[U];X.3d[U]=T}}}}1a X},Q=17(V){1b U;U=V.41("3d")?V.3d:[V];if("4f"!=K.1O(U)){1a 1l}1T(1b T=U.1I-1;T>=0;T--){if(!U[T].1u||!R.41(U[T].1u)){1a 1l}if(K.3v(U[T]["2D"])){if("4f"!==K.1O(U[T]["2D"])){1a 1l}1T(1b S=U[T]["2D"].1I-1;S>=0;S--){if(!L[U[T].1u]({1u:U[T].1u},U[T]["2D"][S],1r)){1a 1l}}}}if(V.41("1Q")&&!M(V,V["1Q"],1r)){1a 1l}1a 1r},O=17(S){13.4A={};13.1w={};13.cp(S)};K.2a(O.2z,{cp:17(U){1b T,S,V;1T(T in U){if(!U.41(T)){8O}S=(T+"").4P().5w();if(!13.4A.41(S)){13.4A[S]=P(U[T]);if(!Q(13.4A[S])){5D"iT j3 j5 j6 \'"+T+"\' j7 in "+U}13.1w[S]=2E}}},7M:17(T,S){T=(T+"").4P().5w();if(K.1O(S)=="1N"){S=S.4P()}if(13.4A.41(T)){J=S;if(M(13.4A[T],S)){13.1w[T]=J}J=1h}},eC:17(S){S=(S+"").4P().5w();if(13.4A.41(S)){1a K.3v(13.1w[S])?13.1w[S]:13.4A[S]["1Q"]}},7V:17(T){1T(1b S in T){13.7M(S,T[S])}},ey:17(){1b T=K.2a({},13.1w);1T(1b S in T){if(2E===T[S]&&2E!==13.4A[S]["1Q"]){T[S]=13.4A[S]["1Q"]}}1a T},9M:17(S){N(S.8Q(";")).3f(N(17(T){T=T.8Q(":");13.7M(T.6L().4P(),T.7K(":"))}).1F(13))},aq:17(S){S=(S+"").4P().5w();1a 13.4A.41(S)},j8:17(S){S=(S+"").4P().5w();1a 13.aq(S)&&K.3v(13.1w[S])},2U:17(S){S=(S+"").4P().5w();if(13.aq(S)){4W 13.1w[S];4W 13.4A[S]}}});K.7a=O}(z));(17(N){if(!N){5D"6S 6U 6V";1a}1b M=N.$;if(N.9E){1a}1b L="b0://b3.b4.b6/j9/7z",K="b0://b3.b4.b6/ja/jb";1b J=17(O){13.6J={};13.7A=M(O);13.5t=M(1n.ar(L,"7z"));13.5t.3D("1f",13.7A.8S||13.7A.1f);13.5t.3D("1g",13.7A.cE||13.7A.1g);13.1i=M(1n.ar(L,"1i"));13.1i.jc(K,"74",13.7A.2s("1X"));13.1i.3D("1f","2K%");13.1i.3D("1g","2K%");13.1i.24(13.5t)};J.2z.76=17(){1a 13.5t};J.2z.59=17(O){if(1p.5V(O)<1){1a}if(!13.6J.59){13.6J.59=M(1n.ar(L,"2X"));13.6J.59.3D("id","cA");13.6J.59.bZ(M(1n.ar(L,"jd")).8u({"in":"je",cz:O}));13.6J.59.24(13.5t);13.1i.3D("2X","29(#cA)")}1j{13.6J.59.4m.3D("cz",O)}1a 13};N.9E=J}(z));1b s=(17(L){1b K=L.$;1b J=17(N,M){13.3m={87:"3h",3F:"8r",2h:"2N",1A:{j4:"2w",1f:"2B",1g:"2B"},iR:["1g","1f"]};13.3H=N;13.4w=1h;13.78=1h;13.2S=1h;13.2P={};13.eb=[];13.6p=1h;13.b2=1h;13.5L=1h;13.3m=L.2a(13.3m,M);13.3l=13.3m.87+"-bz";13.83=13.3m.87+"-6N";13.dW()};J.2z={dW:17(){13.4w=L.$1t("34").1B(13.3l).1B(13.3l+"-"+13.3m.3F).1y({4x:"3w"});13.78=L.$1t("34").1B(13.3l+"-78").24(13.4w);13.4w.24(13.3H);K(["4L","4M"]).3f(17(M){13.2P[M]=L.$1t("2t").1B(13.3l+"-2t").1B(13.3l+"-2t-"+M).24(13.4w).1D("1R 21",(17(O,N){K(O).5d[0].2g().4j();K(O).5f();13.6i(N)}).2L(13,M))}.1F(13));13.2P.4L.1B(13.3l+"-2t-4X");13.2S=L.$1t("iF").1D("1R 21",17(M){M.2g()})},dL:17(N){1b M=L.$1t("iQ").1B(13.83).3c(N).24(13.2S);1t L.aE(N,{7E:13.9Z.1F(13)});13.eb.3g(M);1a M},f2:17(N){1b M=13.6p||13.2S.9l(13.83+"-6Z")[0];if(M){K(M).1U(13.83+"-6Z")}13.6p=K(N);if(!13.6p){1a}13.6p.1B(13.83+"-6Z");13.6i(13.6p)},bS:17(){if(13.78!==13.2S.4D){K(13.2S).24(13.78);13.fd();K(1k).1D("72",13.5L=13.9Z.1F(13));13.bS.1F(13).2F(1);1a}1b M=13.3H.1E();if(M.1g>0&&M.1g>M.1f){13.8s("4U")}1j{13.8s("8r")}13.9Z();13.4w.1y({4x:""})},2g:17(){if(13.5L){K(1k).1P("72",13.5L)}13.4w.5h()},6i:17(Z,P){1b R={x:0,y:0},ac="4U"==13.3m.3F?"1G":"1M",U="4U"==13.3m.3F?"1g":"1f",Q="4U"==13.3m.3F?"y":"x",Y=13.2S.4D.1E()[U],V=13.2S.4D.88(),O=13.2S.1E()[U],X,M,ab,S,N,W,T,aa=[];if(13.b2){13.b2.2g()}1j{13.2S.1y("1Y",L.1e.7r+5X.7c(32)+"a1")}if(2E===P){P=8T}X=13.2S.88();if("1N"==L.1O(Z)){R[Q]=("4M"==Z)?1p.1W(X[ac]-V[ac]-Y,Y-O):1p.2f(X[ac]-V[ac]+Y,0)}1j{if("6n"==L.1O(Z)){M=Z.1E();ab=Z.88();R[Q]=1p.2f(0,1p.1W(Y-O,X[ac]+Y/2-ab[ac]-M[U]/2))}1j{1a}}if(L.1e.6a&&"6T"==L.1e.4O||L.1e.2C&&L.1e.2C<10){if("1N"==L.1O(Z)&&R[Q]==X[ac]-V[ac]){X[ac]+=0===X[ac]-V[ac]?30:-30}R["7S-"+ac]=[((O<=Y)?0:(X[ac]-V[ac])),R[Q]];4W R.x;4W R.y;if(!13.b1){13.b1=1t L.9A([13.2S],{5o:bA})}aa.3g(R);13.b1.4z(aa);T=R["7S-"+ac][1]}1j{13.2S.1y({1Y:L.1e.7r+5X.7c(32)+P+"6C 6z",2k:"4k("+R.x+"2w, "+R.y+"2w, 0)"});T=R[Q]}if(T>=0){13.2P.4L.1B(13.3l+"-2t-4X")}1j{13.2P.4L.1U(13.3l+"-2t-4X")}if(T<=Y-O){13.2P.4M.1B(13.3l+"-2t-4X")}1j{13.2P.4M.1U(13.3l+"-2t-4X")}T=1h},fd:17(){1b O,N,P,W,V,Y,Q,U,T,X,ad,aa,ab,Z={x:0,y:0},M,S,R=aU,ac=17(ag){1b af,ae=0;1T(af=1.5;af<=90;af+=1.5){ae+=(ag*1p.fa(af/1p.f8/2))}(W<0)&&(ae*=(-1));1a ae};V=K(17(ae){Z={x:0,y:0};M="4U"==13.3m.3F?"1G":"1M";S="4U"==13.3m.3F?"1g":"1f";O="4U"==13.3m.3F?"y":"x";aa=13.2S.4D.1E()[S];ad=13.2S.1E()[S];P=aa-ad;if(P>=0){1a}if(ae.2n=="3M"){if(2E===ab){ab=0}13.2S.3J("1Y",L.1e.7r+5X.7c(32)+"fk");Y=ae[O];T=ae.y;U=ae.x;X=1l}1j{if("9z"==ae.2n){if(X){1a}Q=ac(1p.3C(W));ab+=Q;(ab<=P)&&(ab=P);(ab>=0)&&(ab=0);Z[O]=ab;13.2S.3J("1Y",L.1e.7r+5X.7c(32)+R+"6C  5q-5v(.0, .0, .0, 1)");13.2S.3J("2k","4k("+Z.x+"2w, "+Z.y+"2w, 63)");W=0}1j{if(X){1a}if("8r"==13.3m.3F&&1p.3C(ae.x-U)>1p.3C(ae.y-T)||"4U"==13.3m.3F&&1p.3C(ae.x-U)<1p.3C(ae.y-T)){ae.2g();W=ae[O]-Y;ab+=W;Z[O]=ab;13.2S.3J("2k","4k("+Z.x+"2w, "+Z.y+"2w, 63)");if(ab>=0){13.2P.4L.1B(13.3l+"-2t-4X")}1j{13.2P.4L.1U(13.3l+"-2t-4X")}if(ab<=P){13.2P.4M.1B(13.3l+"-2t-4X")}1j{13.2P.4M.1U(13.3l+"-2t-4X")}}1j{X=1r}}Y=ae[O]}}).1F(13);13.2S.1D("2q",V)},9Z:17(){1b P,O,M,N=13.3H.1E();if(N.1g>0&&N.1g>N.1f){13.8s("4U")}1j{13.8s("8r")}P="4U"==13.3m.3F?"1g":"1f";O=13.2S.1E()[P];M=13.4w.1E()[P];if(O<=M){13.4w.1B("6F-2P");13.2S.3J("1Y","").1E();13.2S.3J("2k","4k(0,0,0)");13.2P.4L.1B(13.3l+"-2t-4X");13.2P.4M.1U(13.3l+"-2t-4X")}1j{13.4w.1U("6F-2P")}if(13.6p){13.6i(13.6p,0)}},8s:17(M){if("4U"!==M&&"8r"!==M||M==13.3m.3F){1a}13.4w.1U(13.3l+"-"+13.3m.3F);13.3m.3F=M;13.4w.1B(13.3l+"-"+13.3m.3F);13.2S.3J("1Y","2Y").1E();13.2S.3J("2k","").3J("7S","")}};1a J})(z);1b i=A.$;if(80 6M.bh!=="17"){6M.bh=17(M){if(M==1h){5D 1t iv("iw ix 2E iy 1h 6f 7U")}M=6M(M);1T(1b J=1;J<26.1I;J++){1b L=26[J];if(L!=1h){1T(1b K in L){if(6M.2z.41.2c(L,K)){M[K]=L[K]}}}}1a M}}if(!A.1e.9U){A.1e.9U=A.8Z("2k").97()}1b p={4h:{1u:"1N","2D":["2O","7P"],"1Q":"7P"},4c:{3d:[{1u:"1N","2D":["1m","2y","4n","40"],"1Q":"1m"},{1u:"3p","2D":[1l]}],"1Q":"1m"},cu:{3d:[{1u:"1N","2D":["2B"]},{1u:"6c",7d:1}],"1Q":"2B"},e8:{3d:[{1u:"1N","2D":["2B"]},{1u:"6c",7d:1}],"1Q":"2B"},cc:{1u:"1N","1Q":"2J"},iz:{1u:"6c",7d:0,"1Q":15},8b:{3d:[{1u:"1N","2D":["2N","1G","40"],"1Q":"40"},{1u:"3p","2D":[1l]}],"1Q":"40"},2r:{3d:[{1u:"1N","2D":["1k","cG","40"]},{1u:"3p","2D":[1l]}],"1Q":"1k"},4G:{3d:[{1u:"1N","2D":["1m","2y","40"],"1Q":"1m"},{1u:"3p","2D":[1l]}],"1Q":"1m"},3E:{1u:"1N","2D":["2O","2Z"],"1Q":"2O"},3Y:{1u:"3p","1Q":1r},d9:{1u:"3p","1Q":1r},3o:{3d:[{1u:"1N","2D":["bv","2Z","40"]},{1u:"3p","2D":[1l]}],"1Q":"bv"},cN:{1u:"3p","1Q":1r},eY:{1u:"3p","1Q":1r},fg:{1u:"3p","1Q":1l},9t:{1u:"3p","1Q":1l},c4:{1u:"3p","1Q":1r},ew:{1u:"3p","1Q":1l},eo:{1u:"3p","1Q":1r},bT:{1u:"1N","2D":["2O","7P"],"1Q":"2O"},5C:{1u:"1N"},as:{1u:"3p","1Q":1l},c5:{1u:"1N","1Q":"iA 6f 1m"},ap:{1u:"1N","1Q":"fx 6f 1m"},93:{1u:"1N","1Q":"fx 6f 2r"},iB:{1u:"1N","1Q":"iC"},iD:{1u:"1N","1Q":"iu"},iE:{1u:"1N","1Q":"iG"}};1b m={4c:{3d:[{1u:"1N","2D":["1m","2y","40"],"1Q":"1m"},{1u:"3p","2D":[1l]}],"1Q":"1m"},3E:{1u:"1N","2D":["2O","2Z"],"1Q":"2O"},93:{1u:"1N","1Q":"iH 6f 2r"},c5:{1u:"1N","1Q":"iI 6f 1m"},ap:{1u:"1N","1Q":"iJ 21 6f 1m"}};1b o="a2";1b E="1q";1b b=20;1b B=["by","dZ","cC","cF","dv","cT"];1b D=8T;1b v;1b q={};1b G=i([]);1b I;1b f=1k.iK||1;1b H;1b y=1r;1b g=A.1e.2M.8Y?"4k(":"9T(";1b C=A.1e.2M.8Y?",0)":")";1b n=1h;1b r=(17(){1b K,N,M,L,J;1a J})();1b t=17(){1a"iL$iM"+"p".7e()+" iN$"+"eG.2.5".4u("v","")+" k4$"+"c".7e()+((1k.bn$bl&&A.1O(1k.bn$bl)==="1N")?" iO$"+1k.bn$bl.5l():"")};17 x(L){1b K,J;K="";1T(J=0;J<L.1I;J++){K+=5X.7c(14^L.en(J))}1a K}17 j(L){1b K=[],J=1h;(L&&(J=i(L)))&&(K=G.2X(17(M){1a M.3I===J}));1a K.1I?K[0]:1h}17 a(L){1b K=i(1k).1E();1b J=i(1k).7p();L=L||0;1a{1M:L,2J:K.1f-L,1G:L,2N:K.1g-L,x:J.x,y:J.y}}17 c(J){1a(J.2l&&(J.2l==="3z"||J.2l===J.5m))||(/3z/i).3k(J.1u)}17 h(J){1a J.2l?((J.2l==="3z"||J.5m===J.2l)&&J.9x):J.2I.1I===1&&(J.6g.1I?J.6g[0].3K===J.2I[0].3K:1r)}17 e(J){1a 6M.bh({},J,{1u:J.1u,52:J.52,4Y:J.4Y,ef:J.ef,ee:J.ee,2H:J.2H,2G:J.2G})}17 u(){1b L=A.$A(26);1b K=L.6L();1b J=q[K];if(J){1T(1b M=0;M<J.1I;M++){J[M].6e(1h,L)}}}17 F(){1b N=26[0],J,M,K=[];3e{do{M=N.b9;if(/^[A-aK-z]*$/.3k(M)){if(J=N.2s("id")){if(/^[A-aK-z][-A-aK-iP-jf]*/.3k(J)){M+="#"+J}}K.3g(M)}N=N.4D}5K(N&&N!==1n.5a);K=K.4C();A.6G(K.7K(" ")+"> .1q-5J > 2b",{1f:"2K% !2i;",1Y:"2Y",2k:"2Y"},"1q-bU-6h",1r)}3t(L){}}17 w(){1b K=1h,L=1h,J=17(){1k.iS(1n.3B.8n,1n.3B.8q);1k.aI(1t 1v("72"))};L=ep(17(){1b O=1k.3F===90||1k.3F===-90;1b N=1k.5c;1b M=(O?er.jg:er.jG)*0.85;if((K===1h||K===1l)&&((O&&N<M)||(!O&&N<M))){K=1r;J()}1j{if((K===1h||K===1r)&&((O&&N>M)||(!O&&N>M))){K=1l;J()}}},jI);1a L}17 d(){A.6G(".3h-3w-78, .3h-ax-2b",{6l:"eQ !2i","2f-1g":"0 !2i","2f-1f":"0 !2i","1W-1g":"2Y !2i","1W-1f":"2Y !2i",1f:"eS !2i",1g:"eS !2i",2h:"5R !2i",1G:"-c0 !2i",1M:"0 !2i",7j:"3w !2i","-3S-2k":"2Y !2i",2k:"2Y !2i","-3S-1Y":"2Y !2i",1Y:"2Y !2i"},"a4-a9-6h");A.6G(".3h-ax-2b 2b",{6l:"bP-eQ !2i",3Q:"0 !2i",7F:"0 !2i","2f-1g":"0 !2i","2f-1f":"0 !2i","1W-1g":"2Y !2i","1W-1f":"2Y !2i","-3S-2k":"2Y !2i",2k:"2Y !2i","-3S-1Y":"2Y !2i",1Y:"2Y !2i"},"a4-a9-6h");if(A.1e.7T){A.6G(".2V-3h .1q-2r .1q-2r-bg",{6l:"2Y !2i"},"a4-a9-6h")}if(A.1e.7T&&(A.1e.4v!=="5U"||A.1e.75===44)){A.6G(".2V-3h .1q-1m-1k.1q-2y, .2V-3h .1q-1m-1k.1q-2y:jJ",{"3Q-jK":"0 !2i"},"a4-a9-6h")}}1b l=17(M,N,K,L,J){13.1K={1X:1h,29:1h,6u:1,1d:1h,2n:0,1A:{1f:0,1g:0},2j:1l};13.1m={1X:1h,29:1h,6u:1,1d:1h,2n:0,1A:{1f:0,1g:0},2j:1l};if(A.1O(M)==="7U"){13.1K=M}1j{if(A.1O(M)==="1N"){13.1K.29=A.6w(M)}}if(A.1O(N)==="7U"){13.1m=N}1j{if(A.1O(N)==="1N"){13.1m.29=A.6w(N)}}13.3u=K;13.1w=L;13.4t=J;13.7N=1h;13.3O=1h;13.1d=1h};l.2z={an:17(L,K,J){1b M=L.8a("2b")[0];if(J){13.1K.1d=M||A.$1t("2b").24(L)}if(f>1){13.1K.29=L.2s("3x-1i-2x");if(13.1K.29){13.1K.6u=2}13.1m.29=L.2s("3x-1m-1i-2x");if(13.1m.29){13.1m.6u=2}}13.1K.1X=L.2s("3x-1i")||L.2s("jL")||(M?M.8c||M.2s("1X"):1h);if(13.1K.1X){13.1K.1X=A.6w(13.1K.1X)}13.1K.29=13.1K.29||13.1K.1X;if(13.1K.29){13.1K.29=A.6w(13.1K.29)}13.1m.1X=L.2s("3x-1m-1i")||L.2s("74");if(13.1m.1X){13.1m.1X=A.6w(13.1m.1X)}13.1m.29=13.1m.29||13.1m.1X;if(13.1m.29){13.1m.29=A.6w(13.1m.29)}13.3u=L.2s("3x-3u")||L.2s("8z")||K;13.3O=L.2s("3x-3O");13.4t=L;1a 13},aA:17(J){1b K=1h;if(26.1I>1&&A.1O(26[1])==="17"){K=26[1]}if(13[J].2n!==0){if(13[J].2j){13.6v(K)}1a}if(13[J].29&&13[J].1d&&!13[J].1d.2s("1X")&&!13[J].1d.2s("jM")){13[J].1d.3D("1X",13[J].29)}13[J].2n=1;1t A.aE(13[J].1d||13[J].29,{7E:i(17(L){13[J].2j=1r;13[J].2n=L.2m?2:-1;if(L.2m){13[J].1A=L.1E();if(!13[J].1d){13[J].1d=i(L.2b);13[J].1d.2s("2o");13[J].1d.5H("2o");13[J].1A.1f/=13[J].6u;13[J].1A.1g/=13[J].6u}1j{13[J].1d.1y({"1W-1f":13[J].1A.1f,"1W-1g":13[J].1A.1g});if(13[J].1d.8c&&13[J].1d.8c!==13[J].1d.1X){13[J].29=13[J].1d.8c}1j{if(A.6w(13[J].1d.2s("1X")||"")!==13[J].29){13[J].1d.3D("1X",13[J].29)}}}}13.6v(K)}).1F(13)})},9s:17(){13.aA("1K",26[0])},bB:17(){13.aA("1m",26[0])},67:17(){13.7N=1h;if(26.1I>0&&A.1O(26[0])==="17"){13.7N=26[0]}13.9s();13.bB()},6v:17(J){if(J){J.2c(1h,13)}if(13.7N&&13.1K.2j&&13.1m.2j){13.7N.2c(1h,13);13.7N=1h;1a}},2j:17(){1a(13.1K.2j&&13.1m.2j)},2m:17(){1a(13.1K.2n===2&&13.1m.2n===2)},7B:17(K){1b J=K==="1K"?"1m":"1K";if(!13[K].2j||(13[K].2j&&13[K].2n===2)){1a 13[K].29}1j{if(!13[J].2j||(13[J].2j&&13[J].2n===2)){1a 13[J].29}1j{1a 1h}}},76:17(K){1b J=K==="1K"?"1m":"1K";if(!13[K].2j||(13[K].2j&&13[K].2n===2)){1a 13[K].1d}1j{if(!13[J].2j||(13[J].2j&&13[J].2n===2)){1a 13[J].1d}1j{1a 1h}}},1E:17(K){1b J=K==="1K"?"1m":"1K";if(!13[K].2j||(13[K].2j&&13[K].2n===2)){1a 13[K].1A}1j{if(!13[J].2j||(13[J].2j&&13[J].2n===2)){1a 13[J].1A}1j{1a{1f:0,1g:0}}}},jN:17(K){1b J=K==="1K"?"1m":"1K";if(!13[K].2j||(13[K].2j&&13[K].2n===2)){1a 13[K].6u}1j{if(!13[J].2j||(13[J].2j&&13[J].2n===2)){1a 13[J].6u}1j{1a 1}}},73:17(J){13.1d=13.76(J)}};1b k=17(K,J){13.1w=1t A.7a(p);13.1o=i(17(){if(26.1I>1){1a 13.7M(26[0],26[1])}1j{1a 13.eC(26[0])}}).1F(13.1w);13.ez=1t A.7a(m);13.3R=[];13.1i=1h;13.79=1h;13.3I=i(K).1D("3M jO 2O",17(L){L.2g()});13.id=1h;13.1d=1h;13.8G=1h;13.6K=1h;13.9j=1h;13.6E=1h;13.7b={1f:0,1g:0};13.1A={1f:0,1g:0};13.1S={1f:0,1g:0};13.3i={1f:0,1g:0};13.1Z={1G:0,1M:0,2N:0,2J:0};13.2m=1l;13.1J=1l;13.5F=1h;13.aw=1h;13.5L=i(17(){if(13.1J){13.1i.1d.1y({"1W-1g":1p.2f(13.1i.1E("1m").1g,13.6I())});13.1i.1d.1y({"1W-1f":1p.2f(13.1i.1E("1m").1f,13.7J())})}13.7R(26[0])}).1F(13);13.c9=i(17(L){3P(13.aw);13.aw=i(13.5L).2F(10,L.1u==="6i")}).2L(13);if(t){I.3c(A.$1t("34",{},{6l:"2Y",4x:"3w"}).3c(1n.8R(t)));t=2E}13.1s=1h;13.1c=1h;13.3o=1h;13.bR=1h;13.6q=0;13.8v=1r;13.6k=1h;13.5E=1h;13.6N=1h;13.3j=1h;13.3Z=1h;13.3Y=1h;13.5k=1h;13.8P=1h;13.4S=1h;13.8C=1h;13.5b=1h;13.4g=1h;13.4Q=[];13.2P={};13.aT=0;13.bK=1h;13.4z(J)};k.2z={eu:17(J){13.1w.7V(1k[E+"7a"]||{});13.1w.9M(13.3I.2s("3x-1w")||"");if(!A.1e.au){13.1o("as",1l)}if(A.1e.2V||13.1o("as")){13.1w.7V(13.ez.ey());13.1w.7V(1k[E+"jP"]||{});13.1w.9M(13.3I.2s("3x-2V-1w")||"")}if(A.1O(J)==="1N"){13.1w.9M(J||"")}1j{13.1w.7V(J||{})}if(13.1o("5C")){13.1o("5C",13.1o("5C").4u(","," "))}if(13.1o("8b")===1l){13.1o("8b","40")}if(13.1o("3o")===1l){13.1o("3o","40")}4H(13.1o("3o")){1C"40":13.6q=0;1H;1C"2Z":13.6q=66;1H;1C"bv":1Q:13.6q=2;1H}if(13.1o("4c")==="40"){13.1o("4c",1l)}if(13.1o("2r")==="40"){13.1o("2r",1l)}if(13.1o("4G")==="40"){13.1o("4G",1l)}if(A.1e.2V&&13.1o("4c")==="1m"&&13.1o("cc")==="2A"){if(13.1o("2r")){13.1o("4c",1l)}1j{13.1o("4h","2O")}}},4z:17(M){1b K;1b J=13;1b L;if(13.aT<1){13.eu(M);if(y&&!13.1o("c4")){1a}13.6K=13.3I.dC("2b");13.9j=13.6K?13.6K.2s("1X"):1h;13.6E=i(13.3I).2s("8z");i(13.3I).5H("8z")}L=1t l().an(13.3I,13.6E,1r);if(!L.1K.29){if(++13.aT<=D){13.bK=4q(17(){J.4z()},2K)}1a}13.79=L;13.1i=13.79;F(13.3I);13.id=13.3I.2s("id")||"1q-"+1p.5P(1p.6o()*A.6y());13.3I.3D("id",13.id);13.1d=A.$1t("5J").1B("1q-5J");13.1d.ev(13.1i.1K.1d).1B(13.1o("5C"));if(13.1o("ew")!==1r){13.1d.1D("jQ",17(O){O.2g();1a 1l})}13.1d.1B("1q-"+13.1o("4h")+"-1m");if(!13.1o("2r")){13.1d.1B("1q-6F-2r")}13.1s={1d:A.$1t("34",{"3T":"1q-1s"},{1G:0}).24(13.1d),1i:A.$1t("2b",{1X:"3x:1i/eD;eE,et/eF="},{2h:"5R",1G:0,1M:0}),1f:0,1g:0,36:{x:0,y:0},5B:{x:0,y:0},1A:{1f:0,1g:0},3Q:{x:0,y:0},dx:0,dy:0,69:1l,4o:17(){if(A.1e.2M.2k){13.1d.1y({2k:"9T(-c0, -c0)"})}1j{13.1d.1y({1G:-eA})}}};13.1s.4o();13.1s.1d.3c(13.1s.1i);13.1c={1d:A.$1t("34",{"3T":"1q-1m-1k"},{1G:-eH}).1B(13.1o("5C")).24(I),1i:A.$1t("2b",{1X:"3x:1i/eD;eE,et/eF="},{2h:"5R"}),bW:0,1f:0,1g:0,5y:0,5c:0,1A:{1f:"2B",6P:"2w",1g:"2B",6Q:"2w"},1V:13.1o("4c"),2h:13.1o("cc"),7l:13.1o("4h"),4l:1l,2Q:1l,3r:1l,4T:1l,6t:i(17(){13.1c.4T=26[0]!==1l;13.1d[13.1c.4T?"1U":"1B"]("1q-6F-1m")}).1F(13),4o:i(17(){1b O=i(13.1d).2e("cr");13.1c.1d.1P("2W");13.1c.1d.1y({1G:-eH}).24(I);13.1c.1d.1U("1q-9d 1q-p-"+(13.1c.1V==="1m"?13.1c.2h:13.1c.1V));if(!13.1J&&O){O.2U()}13.1c.1i.2s("2o");13.1c.1i.5H("2o")}).1F(13),9w:i(17(O){13.1d[O===1l?"1B":"1U"]("1q-6F-1m");13.1d[O==="2y"?"1B":"1U"]("1q-2y-1m");13.1c.1d[O==="2y"?"1B":"1U"]("1q-2y");13.1c.1d[O==="4n"?"1B":"1U"]("1q-4n");if(O!=="1m"){13.1d.1U("1q-2A-1m");13.1c.1d.1U("1q-2A")}13.1c.1V=O;if(O===1l){13.1c.6t(1l)}}).1F(13)};13.1c.1d.3c(13.1c.1i);13.1c.9w(13.1o("4c"));13.1c.1i.5H("1f");13.1c.1i.5H("1g");if(80(r)!=="2E"){1b N=1p.5P(1p.6o()*A.6y());i(13.1d).3b("cr",A.$1t(((1p.5P(1p.6o()*bV)+1)%2)?"bY":"34").8u({id:"8p"+N}).1y({6l:"bP",7j:"3w",4x:"5G",e2:r[1],jH:r[2],eJ:r[3],jR:"jT-jU",2h:"5R",1G:8,1M:8,7S:"2B",1f:"2B",jV:"2J",eR:"jW",e1:e4}).5A(x(r[0])));if(i(i(13.1d).2e("cr")).8a("a")[0]){i(i(i(13.1d).2e("cr")).8a("a")[0]).1D("21 1R",17(O){O.5f();1k.8o(13.74)}).8u({id:"bO"+N})}A.6G("#"+13.id+" > 5J.1q-5J > #"+("8p"+N)+",#"+13.id+" > 5J.1q-5J > #"+("8p"+N)+" > #"+("bO"+N)+",bN 3B .1q-2r > #"+("8p"+N)+",bN 3B .1q-2r > #"+("8p"+N)+" > #"+("bO"+N),{6l:"bP !2i;",4x:"5G !2i;",e2:r[1]+" !2i;","jX-1A":r[2]+"2w !2i;","z-8x":"e4 !2i;"},"1q-bU-6h",1r)}if((K=(""+13.1o("cu")).3G(/^([0-9]+)?(2w|%)?$/))){13.1c.1A.6P=K[2]||"2w";13.1c.1A.1f=(2u(K[1])||"2B")}if((K=(""+13.1o("e8")).3G(/^([0-9]+)?(2w|%)?$/))){13.1c.1A.6Q=K[2]||"2w";13.1c.1A.1g=(2u(K[1])||"2B")}if(13.1c.1V==="2y"){13.1d.1B("1q-2y-1m");13.1c.1d.1B("1q-2y");if(13.1c.1A.1f==="2B"){13.1c.1A.6P="%";13.1c.1A.1f=70}if(13.1c.1A.1g==="2B"){13.1c.1A.6Q="%"}}1j{if(13.1o("1m-2h").3G(/^#/)){if(13.1c.4l=i(13.1o("1m-2h").4u(/^#/,""))){if(i(13.1c.4l).1E().1g>50){if(13.1c.1A.1f==="2B"){13.1c.1A.6P="%";13.1c.1A.1f=2K}if(13.1c.1A.1g==="2B"){13.1c.1A.6Q="%";13.1c.1A.1g=2K}}}1j{13.1o("1m-2h","2J")}}if(13.1c.1V==="4n"){if(13.1c.1A.1f==="2B"){13.1c.1A.6P="2w"}if(13.1c.1A.1g==="2B"){13.1c.1A.6Q="2w"}}if(13.1c.1V==="1m"){if(13.1c.1A.1f==="2B"||13.1o("1m-2h")==="2A"){13.1c.1A.6P="%";13.1c.1A.1f=2K}if(13.1c.1A.1g==="2B"||13.1o("1m-2h")==="2A"){13.1c.1A.6Q="%";13.1c.1A.1g=2K}}if(13.1o("1m-2h")==="2A"){13.1d.1B("1q-2A-1m")}}13.1c.2h=13.1c.4l?"4l":13.1o("1m-2h");13.1s.3Q.x=2u(13.1s.1d.3y("3Q-1M-1f")||"0");13.1s.3Q.y=2u(13.1s.1d.3y("3Q-1G-1f")||"0");13.1i.9s(17(){if(13.1i.1K.2n!==2){1a}13.1i.73("1K");13.1A=13.1i.1d.1E();13.fc();13.2m=1r;if(13.1o("9t")===1r){u("by",13.id);if(A.1e.2V){13.7R()}1j{13.6r()}}}.1F(13));if(13.1o("9t")!==1r||13.1o("4h")==="2Z"){13.1i.67(i(17(O){13.7n(O,1r)}).1F(13));13.5E=i(13.8J).1F(13).2F(8K)}13.ed()},2g:17(){3P(13.bK);13.cx();if(13.1c){13.1c.1d.5h()}if(13.4g){13.4g.2g();13.4g=1h}if(13.3j){13.3j.5h()}if(13.1J){i(A.1e.49()).1y({7j:""})}i(13.3R).3f(17(J){i(J.4t).1U("1q-6N-6Z").1U(13.1o("5C")||"1q-$jY-6h-3T-6f-2U$")},13);if(13.6K){13.3I.3c(13.6K);if(13.9j){13.6K.3D("1X",13.9j)}}if(13.6E){13.3I.3D("8z",13.6E)}if(13.1d){13.1d.5h()}},7n:17(K,L){1b J=13.1i;if(K.1m.2n!==2){13.1i=K;13.2m=1r;13.1c.6t(1l);1a}13.1i=K;13.1i.73(13.1J?"1m":"1K");13.1c.1i.1X=13.1i.7B("1m");13.1c.1d.1U("1q-4n");13.1c.1i.2s("2o");13.1c.1i.5H("2o");13.1c.1d.1E();4q(i(17(){1b N=13.1c.1i.1E(),M;13.3i=13.1i.1E("1m");if(N.1f*N.1g>1&&N.1f*N.1g<13.3i.1f*13.3i.1g){13.3i=N}13.1S=A.43(13.3i);if(13.1c.1V==="4n"){13.1c.1d.1B("1q-4n")}13.fo();13.1s.1i.1X=13.1i.1d.8c||13.1i.1d.1X;13.1c.6t(13.1c.1V&&!(13.1J&&13.1c.1V==="4n"));13.2m=1r;13.5F=1h;13.5L();13.1d.1B("1q-2m");13.bH();if(J!==13.1i){u("dZ",13.id,J.4t,13.1i.4t);if(13.9v){M=13.9v;13.9v=1h;13.3W(M.1i,M.ei)}}1j{if(!!L){u("by",13.id)}}if(13.64){13.1d.33(13.64.1u,13.64)}1j{if(13.1J&&13.1o("3E")==="2Z"){13.4J()}1j{if(!!L){13.6r()}}}}).1F(13),jZ)},ed:17(){1b K=13.id;1b J;1b L;L=1t eg("1m\\\\-id(\\\\s+)?:(\\\\s+)?"+K+"($|;)");if(A.1e.2M.bI){J=A.$A(1n.bJ(\'[3x-1m-id="\'+13.id+\'"]\'));J=i(J).5M(A.$A(1n.bJ(\'[bD*="1m-id"]\')).2X(17(M){1a L.3k(M.2s("bD")||"")}))}1j{J=A.$A(1n.92("A")).2X(17(M){1a K===M.2s("3x-1m-id")||L.3k(M.2s("bD")||"")})}i(J).3f(17(N){1b M,O;i(N).1D("2O",17(P){P.3X()});M=1t l().an(N,13.6E);if(13.1i.1m.1X.4K(M.1m.1X)&&13.1i.1K.1X.4K(M.1K.1X)){i(M.4t).1B("1q-6N-6Z");M=13.1i;M.4t=N}if(!M.3O&&13.1i.3O){M.3O=13.1i.3O}O=i(17(){13.3W(M)}).1F(13);i(N).1D("6X",17(P){if("eh"in P){P.eh()}},5);i(N).1D("21 "+(13.1o("bT")==="7P"?"7O 8F":"1R"),i(17(Q,P){if(13.6b){3P(13.6b)}13.6b=1l;if(Q.1u==="7O"){13.6b=i(O).2F(P)}1j{if(Q.1u==="21"||Q.1u==="1R"){O()}}}).2L(13,60)).1B(13.1o("5C")).1B("1q-6N");M.9s();if(13.1o("9t")!==1r){M.bB()}13.3R.3g(M)},13)},3W:17(J,K){if(!13.2m){13.9v={1i:J,ei:K};1a}if(!J||J===13.1i){1a 1l}13.4e(1h,1r);13.2m=1l;13.1d.1U("1q-2m");13.5E=i(13.8J).1F(13).2F(8K);J.67(i(17(R){1b L,S,Q,N,M,P,O=(A.1e.2C<10)?"1E":"7w";13.bH();R.73("1K");if(!R.1d){13.2m=1r;13.1d.1B("1q-2m");1a}13.a8(R);L=13.1i.1d[O]();if(13.1J){R.73("1m");Q=A.$1t("34").1B("1q-2r-bg");if(A.1e.2M.8k||A.1e.2C<10){Q.3c(A.$1t("2b",{1X:R.7B("1m")}).1y({2p:0}))}1j{Q.3c(1t A.9E(R.1d).59(b).76().1y({2p:0}))}i(Q).1y({"z-8x":-99}).24(13.3j)}if(13.1J&&13.1c.1V==="1m"&&13.1o("3E")==="2Z"){i(R.1d).1y({2p:0}).24(13.1d);S=L;M=[R.1d,13.1i.1d];P=[{2p:[0,1]},{2p:[1,0]}];i(R.1d).1y({"1W-1f":1p.2f(R.1E("1m").1f,13.7J()),"1W-1g":1p.2f(R.1E("1m").1g,13.6I())})}1j{13.1d.1y({1g:13.1d[O]().1g});13.1i.1d.1y({2h:"5R",1G:0,1M:0,2N:0,2J:0,1f:"2K%",1g:"2K%","1W-1f":"","1W-1g":""});i(R.1d).1y({"1W-1f":1p.2f(R.1E(13.1J?"1m":"1K").1f,13.1J?13.7J():66),"1W-1g":1p.2f(R.1E(13.1J?"1m":"1K").1g,13.1J?13.6I():66),2h:"k0",1G:0,1M:0,2p:0,2k:""}).24(13.1d);S=i(R.1d)[O]();if(!K){i(R.1d).1y({"2f-1f":L.1f,1g:L.1g,"1W-1f":L.1f,"1W-1g":""})}13.1d.1y({1g:"",7j:""}).1E();i(R.1d).1E();M=[R.1d,13.1i.1d];P=[A.2a({2p:[0,1]},K?{48:[0.6,1]}:{"2f-1f":[L.1f,S.1f],"1W-1f":[L.1f,S.1f],1g:[L.1g,S.1g]}),{2p:[1,0]}]}if(13.1J){if(13.3Z.4m&&Q.4m){N=i(13.3Z.4m).3y("2p");if(A.1e.6a){M=M.5M([Q.4m]);P=P.5M([{2p:[0.cg,N]}])}1j{M=M.5M([Q.4m,13.3Z.4m]);P=P.5M([{2p:[0.cg,N]},{2p:[N,0.cg]}])}}}1t A.9A(M,{5o:(K||13.1o("eo"))?K?8K:k1:0,1Y:K?"5q-5v(0.ao, 0.bX, 0.fw, 1)":(L.1f===S.1f)?"9r":"5q-5v(0.25, .1, .1, 1)",7i:i(17(){13.1i.1d.2U().2s("2o");13.1i.1d.5H("2o");i(R.1d).1y(13.1J?{1f:"2B",1g:"2B"}:{1f:"",1g:""}).1y({"2f-1f":"","2f-1g":"",2p:"","1W-1f":1p.2f(R.1E(13.1J?"1m":"1K").1f,13.1J?13.7J():66),"1W-1g":1p.2f(R.1E(13.1J?"1m":"1K").1g,13.1J?13.6I():66)});if(13.1J){13.3Z.2U();13.3Z=2E;13.3Z=Q.3J("z-8x",-2K);i(13.3Z.4m).1y({2p:""});if(13.3Y){if(R.3u){if(R.3O){13.3Y.5A("").3c(A.$1t("a",{74:R.3O}).1D("21 1R",13.a3.1F(13)).5A(R.3u))}1j{13.3Y.5A(R.3u).1B("1q-5z")}}1j{13.3Y.1U("1q-5z")}}}13.7n(R)}).1F(13),cj:i(17(T,U){if(2E!==T.48){U.3J("2k","48("+T.48+")")}})}).4z(P)}).1F(13))},a8:17(K){1b J=1l;i(13.3R).3f(17(L){i(L.4t).1U("1q-6N-6Z");if(L===K){J=1r}});if(J&&K.4t){i(K.4t).1B("1q-6N-6Z")}if(13.4g){13.4g.f2(K.dK)}},fo:17(J){if(13.1i.3u&&13.1o("8b")!=="40"&&13.1c.1V!=="2y"){if(!13.1c.3u){13.1c.3u=A.$1t("34",{"3T":"1q-3u"}).24(13.1c.1d.1B("3u-"+13.1o("8b")))}13.1c.3u.5A(13.1i.3u)}},6r:17(J,M,K){1b L;if(!13.1J){if(13.6q<=0){1a}if(K!==1r){13.6q--}}if(M===2E||M===1h){if(!13.1c.2Q&&!13.1c.3r){if(13.1o("4c")&&(13.1c.4T||!13.1i.2j())&&!(A.1e.2V&&13.1o("2r")&&13.1c.1V==="1m"&&13.1c.2h==="2A")){if(13.1c.7l==="7P"){M=13.1o("c5")}1j{if(13.1c.7l==="2O"){M=13.1o("ap")}}}1j{M=13.1o("2r")?13.1o("93"):""}}1j{M=13.1o("2r")?13.1o("93"):""}}if(!M){13.c3();1a}L=13.1d;if(!13.3o){13.3o=A.$1t("34",{"3T":"1q-3o"});13.bR=A.$1t("bY",{"3T":"1q-3o-k2"}).3c(1n.8R(M)).24(13.3o);i(13.3o).24(13.1d)}1j{i(13.bR).5A(M)}13.3o.1y({"1Y-bQ":""}).1U("1q-3o-3w");if(13.1J){L=13.4S}1j{if((13.1c.2Q||13.1c.3r)&&13.1c.1V!=="2y"&&13.1c.2h==="2A"){L=13.1c.1d}}if(J===1r){4q(i(17(){13.3o.1B("1q-3o-3w")}).1F(13),16)}13.3o.24(L)},c3:17(){if(13.3o){13.3o.1y({"1Y-bQ":"fk"}).1B("1q-3o-3w")}},8J:17(){if(!13.6k){13.6k=A.$1t("34",{"3T":"1q-jS"});13.1d.3c(13.6k);13.6k.1E()}13.6k.1B("eX")},bH:17(){3P(13.5E);13.5E=1h;if(13.6k){i(13.6k).1U("eX")}},7k:17(L,P){1b O=A.43(13.1c.1A),N=(!13.1J&&13.1c.4l)?i(13.1c.4l).1E():{1f:0,1g:0},K,J,M=13.1A,Q={x:0,y:0};P=P||13.1c.2h;13.7b=13.1i.1d.1E();13.1A=13.1i.1d.1E();13.1Z=13.1i.1d.7w();if(!N.1g){N=13.1A}if(13.1o("eY")===1l||13.1c.1V===1l||13.1c.1V==="4n"){L=1l}if(13.1c.1V==="4n"){if(O.1f==="2B"){O.1f=13.3i.1f}if(O.1g==="2B"){O.1g=13.3i.1g}}if(13.1J&&13.1c.1V==="2y"){O.1f=70;O.1g="2B"}if(13.1c.1V==="2y"&&O.1g==="2B"){13.1c.1f=2u(O.1f/2K)*1p.2f(N.1f,N.1g);13.1c.1g=13.1c.1f}1j{if(13.1c.1V==="1m"&&P==="2A"){13.1A=13.1d.1E();N=13.1A;13.1Z=13.1d.7w();13.1c.1f=N.1f;13.1c.1g=N.1g}1j{13.1c.1f=(O.6P==="%")?2u(O.1f/2K)*N.1f:5T(O.1f);13.1c.1g=(O.6Q==="%")?2u(O.1g/2K)*N.1g:5T(O.1g)}}if(13.1c.1V==="4n"){J=1p.2f(1p.2f(13.1c.1f/13.3i.1f,13.1c.1g/13.3i.1g),1);13.1c.1f=13.3i.1f*J;13.1c.1g=13.3i.1g*J}13.1c.1f=1p.4p(13.1c.1f);13.1c.1g=1p.4p(13.1c.1g);13.1c.bW=13.1c.1f/13.1c.1g;13.1c.1d.1y({1f:13.1c.1f,1g:13.1c.1g});if(L){N=13.1J?13.3j.1E():13.1c.1d.1E();if(!13.1J&&(13.7b.1f*13.7b.1g)/(13.3i.1f*13.3i.1g)>0.8){13.1S.1f=1.5*13.3i.1f;13.1S.1g=1.5*13.3i.1g}1j{13.1S=A.43(13.3i)}}if(13.1c.1V!==1l&&!13.1c.2Q&&!(13.1J&&13.1o("3E")==="2Z")){if((13.7b.1f*13.7b.1g)/(13.1S.1f*13.1S.1g)>0.8){13.1S=A.43(13.3i);13.1c.6t(1l)}1j{13.1c.6t(1r)}}13.1c.1i.1y({1f:13.1S.1f,1g:13.1S.1g});13.1S.8B=13.1S.1f;13.1S.9W=13.1S.1g;K=13.1c.1d.8A();13.1c.5y=1p.4p(K.1f);13.1c.5c=1p.4p(K.1g);13.1s.1f=1p.4p(13.1c.5y/(13.1S.1f/13.1A.1f));13.1s.1g=1p.4p(13.1c.5c/(13.1S.1g/13.1A.1g));13.1s.1d.1y({1f:13.1s.1f,1g:13.1s.1g});13.1s.1i.1y(13.1A);A.2a(13.1s,13.1s.1d.1E());if(13.1c.2Q){3P(13.51);13.51=1h;if(13.1s.69){13.1s.36.x*=(13.1A.1f/M.1f);13.1s.36.y*=(13.1A.1g/M.1g);Q.x=13.1s.5B.x;Q.y=13.1s.5B.y}1j{Q.x=13.1Z.1M+13.1s.1f/2+(13.1s.36.x*(13.1A.1f/M.1f));Q.y=13.1Z.1G+13.1s.1g/2+(13.1s.36.y*(13.1A.1g/M.1g))}13.8L(1h,Q)}},7R:17(N){1b Q;1b P;1b J;1b O;1b M;1b L;1b K=i(13.1d).2e("cr");J=a(5);M=13.1c.2h;O=13.1J?"2A":13.1c.4l?"4l":13.1o("1m-2h");L=13.1J&&13.1c.1V==="1m"?13.3j:1n.3B;if(13.1J){J.y=0;J.x=0}if(!N){13.7k(1r,O)}Q=13.1Z.1G;if(13.1c.1V!=="2y"){if(N){13.7k(1l);1a}4H(O){1C"2A":1C"4l":Q=0;P=0;1H;1C"1G":Q=13.1Z.1G-13.1c.1g-13.1o("1m-5e");if(J.1G>Q){Q=13.1Z.2N+13.1o("1m-5e");O="2N"}P=13.1Z.1M;1H;1C"2N":Q=13.1Z.2N+13.1o("1m-5e");if(J.2N<Q+13.1c.1g){Q=13.1Z.1G-13.1c.1g-13.1o("1m-5e");O="1G"}P=13.1Z.1M;1H;1C"1M":P=13.1Z.1M-13.1c.1f-13.1o("1m-5e");if(J.1M>P&&J.2J>=13.1Z.2J+13.1o("1m-5e")+13.1c.1f){P=13.1Z.2J+13.1o("1m-5e");O="2J"}1H;1C"2J":1Q:P=13.1Z.2J+13.1o("1m-5e");if(J.2J<P+13.1c.1f&&J.1M<=13.1Z.1M-13.1c.1f-13.1o("1m-5e")){P=13.1Z.1M-13.1c.1f-13.1o("1m-5e");O="1M"}1H}4H(13.1o("1m-2h")){1C"1G":1C"2N":if(J.1G>Q||J.2N<Q+13.1c.1g){O="2A"}1H;1C"1M":1C"2J":if(J.1M>P||J.2J<P+13.1c.1f){O="2A"}1H;1Q:}13.1c.2h=O;if(!13.1c.3r&&!13.1c.2Q){if(A.1e.2V&&!13.1J&&13.1c.1V==="1m"){if(13.1o("2r")){13.1c.6t(O!=="2A")}1j{if(13.1o("4h")!=="2O"){13.1c.7l=O==="2A"?"2O":13.1o("4h");13.9f();13.9p();13.89(13.1c.7l==="2O");13.8w(13.1c.7l==="2O"&&!13.1o("2r"))}}13.6r(1l,1h,1r)}1a}13.7k(1l);if(N){1a}if(O==="4l"){L=13.1c.4l;J.y=0;J.x=0}if(O==="2A"){if(13.1c.1V!=="4n"){13.1c.1d.1B("1q-2A");13.1d.1B("1q-2A-1m")}13.1s.4o();Q=13.1Z.1G+J.y;P=13.1Z.1M+J.x;if(!13.1J&&A.1e.2C&&A.1e.2C<11){Q=0;P=0;L=13.1d}}1j{Q+=J.y;P+=J.x;13.1d.1U("1q-2A-1m");13.1c.1d.1U("1q-2A")}13.1c.1d.1y({1G:Q,1M:P})}1j{13.7k(1l);L=13.1d}13.1c.1d[13.1J?"1B":"1U"]("1q-1J");if(!13.1J&&K){K.24(13.1c.1V==="1m"&&O==="2A"?13.1c.1d:13.1d,((1p.5P(1p.6o()*bV)+1)%2)?"1G":"2N")}13.1c.1d.24(L)},fh:17(P){1b L;1b J;1b N;1b M;1b O=1l;1b K=P.bC?5:3/54;if(!13.1c.2Q){1a}i(P).2g();K=(2K+K*1p.3C(P.8t))/2K;if(P.8t<0){K=1/K}if(13.1c.1V==="2y"){J=1p.1W(2K,1p.5V(13.1c.1f*K));J=1p.2f(J,13.1A.1f*0.9);N=J/13.1c.bW;13.1c.1f=1p.4p(J);13.1c.1g=1p.4p(N);13.1c.1d.1y({1f:13.1c.1f,1g:13.1c.1g});L=13.1c.1d.8A();13.1c.5y=1p.4p(L.1f);13.1c.5c=1p.4p(L.1g);O=1r}1j{if(!13.1J&&13.1c.1V==="1m"){J=1p.1W(13.1A.1f,1p.5V(13.1S.1f*K));J=1p.2f(J,13.1S.8B);N=J/(13.1S.8B/13.1S.9W);13.1S.1f=1p.4p(J);13.1S.1g=1p.4p(N)}1j{1a}}M=i(1k).7p();13.1s.1f=(13.1c.5y/(13.1S.1f/13.1A.1f));13.1s.1g=(13.1c.5c/(13.1S.1g/13.1A.1g));13.1s.1d.1y({1f:13.1s.1f,1g:13.1s.1g});A.2a(13.1s,13.1s.1d.1E());if(13.1c.2Q){3P(13.51);13.51=1h;if(O){13.51=1r}13.8L(1h,{x:P.x-M.x,y:P.y-M.y});if(O){13.51=1h}}},89:17(L){1b K;1b J=L?"3q 1R":"5g"+(1k.2v.3a?" 6R":1k.2v.9S?" 7s":"")+(1k.2v.3a?" 5s":1k.2v.9S?" 6x":" 6W");1b M=13.1d.2e("1q:5j:4J:fn",(!L)?i(17(N){if(c(N)&&!h(N)){1a}if(N&&N.2l==="3z"&&N.1u!=="6R"){1a}K=(A.1e.2C<9)?A.2a({},N):N;if(!13.5F){3P(13.5F);13.5F=4q(i(17(){13.4J(K)}).1F(13),jF)}}).2L(13):i(13.4J).2L(13));13.1d.3b("1q:5j:4J:1z",J).1D(J,M,10)},9f:17(){1b J=13.1d.2e("1q:5j:4J:1z");1b K=13.1d.2e("1q:5j:4J:fn");13.1d.1P(J,K);13.1d.38("1q:5j:4J:fn")},8w:17(K){1b J="6B";if(1k.2v.3a){J+=" 5r c6 5s"}1j{if(1k.2v.9S){J+=" 6A f5 6x"}1j{J+=" 8F 6W"}}if(K){if(13.1J||A.1e.2V){J="3q 1R"}1j{J+=" 3q 1R"}}1b L=13.1d.2e("1q:5j:4e:fn",i(17(N){if(c(N)&&!h(N)){1a}if(N&&N.1u==="5r"&&N.2l!=="3z"){1a}if(N&&(N.1u==="5s"||N.1u==="6x"||N.1u==="6W")){if(!13.2m||!13.1c.4T||!13.1c.2Q){1a}1b M=N.7x();if(M.x<13.1Z.1M||M.x>13.1Z.2J||M.y<13.1Z.1G||M.y>13.1Z.2N){13.4e(N);1a}}1j{if(13.1c.1d!==N.8m()&&!((13.1c.2h==="2A"||13.1c.1V==="2y")&&13.1c.1d.9V(N.8m()))&&!13.1d.9V(N.8m())){13.4e(N);1a}}}).2L(13));13.1d.3b("1q:5j:4e:1z",J).1D(J,L,20)},9p:17(){1b J=13.1d.2e("1q:5j:4e:1z");1b K=13.1d.2e("1q:5j:4e:fn");13.1d.1P(J,K);13.1d.38("1q:5j:4e:fn")},fc:17(){13.cS=13.5u.1F(13);13.1d.1D(["5g",1k.2v.3a?"6R":"7s"],i(17(J){if((A.1e.7T||A.1e.4O==="6T"&&A.1e.6a)&&13.1o("4c")&&13.1o("4h")!=="2O"&&J.1u==="5g"){J.3X();if(A.1e.6a){J.5f()}}if(!13.1c.2Q){1a}if(13.1c.2h==="2A"){13.1s.5B=J.7x()}}).2L(13),10);13.1d.1D(["6B",1k.2v.3a?"5r":"6A"],i(17(J){if(c(J)&&h(J)){13.1s.7t=1l}}).2L(13),10);13.1d.1D("7Q "+(A.1e.4O==="6T"?"":1k.2v.3a?"5s":1k.2v.9S?"6x":"6W"),i(13.8L).2L(13));if(13.1o("4c")){13.89(13.1o("4h")==="2O");13.8w(13.1o("4h")==="2O")}13.1d.1D("6X",17(J){J.5f()},10).1D("1R",i(17(J){13.1d.bL("ff","2O");if(13.1J){13.3j.33("1R",J)}}).1F(13),15);if(13.1o("2r")){13.1d.1D("21 1R",i(13.2r).2L(13),15)}1j{13.1d.1D("21 1R",i(13.a3).2L(13),15)}if(13.3R.1I>1){13.bF()}if(!A.1e.2V&&13.1o("fg")){13.1d.1D("4y",13.fh.2L(13))}i(1k).1D(A.1e.2V?"72":"72 6i",13.c9)},cx:17(){if(13.1d){13.1d.1P("4y")}i(1k).1P("72 6i",13.c9);i(13.3R).3f(17(J){i(J.4t).c1()})},4J:17(P){1b Q;1b O;1b M;1b N;1b J;1b K=0;1b L=0;if(!13.1i.2j()||!13.2m||!13.1c.4T||13.1c.2Q||13.1c.3r){if(!13.1i.2j()&&!13.64){if(P){13.64=e(P);P.4j()}13.1i.67(13.7n.1F(13));if(!13.5E){13.5E=i(13.8J).1F(13).2F(8K)}}1a}if(P&&P.1u==="5s"&&P.2l==="3z"){1a}if(!13.1o("4c")&&13.1o("2r")&&!13.1J){13.1c.2Q=1r;1a}13.1c.3r=1r;if(13.1J&&13.1c.1V==="1m"){N=13.1i.1d.7y();13.5k.1B("1q-1m-in");J=13.4S.7y();L=((N.1M+N.2J)/2-(J.1M+J.2J)/2);K=((N.1G+N.2N)/2-(J.1G+J.2N)/2)}13.1c.1i.1P("2W");13.1c.1d.1U("1q-9d").1P("2W");13.1c.1d.1B("1q-3r");13.1d.1B("1q-3r");13.7R();O=(13.1c.1V==="1m")?13.1c.2h:13.1c.1V;if(A.1e.2M.1Y&&!(13.1J&&13.1o("3E")==="2Z")){if(O==="2A"){M=13.1i.1d.1E();13.1c.1i.1y({2k:"4k(0,"+K+"2w, 0) 48("+M.1f/13.1S.1f+", "+M.1g/13.1S.1g+")"}).1E();13.1c.1i.1D("2W",i(17(){13.1c.1i.1P("2W");13.1c.1d.1U("1q-3r 1q-p-"+O);13.1c.3r=1l;13.1c.2Q=1r}).1F(13));13.1c.1d.1B("1q-p-"+O).1E();if(!A.1e.2V&&A.1e.5U&&(A.1e.4v==="5U"||A.1e.4v==="6Y")){13.1c.3r=1l;13.1c.2Q=1r}}1j{13.1c.1d.1D("2W",i(17(){13.1c.1d.1P("2W");13.1c.1d.1U("1q-3r 1q-p-"+O)}).1F(13));13.1c.1d.1y({1Y:"2Y"});13.1c.1d.1B("1q-p-"+O).1E();13.1c.1d.1y({1Y:""}).1E();13.1c.1d.1U("1q-p-"+O);13.1c.3r=1l;13.1c.2Q=1r}}1j{13.1c.1d.1U("1q-3r");13.1c.3r=1l;13.1c.2Q=1r}if(!13.1J){13.6r(1r)}if(P){P.2g().4j();Q=P.7x();if(13.1c.1V==="2y"&&(/21/i).3k(P.1u)){Q.y-=13.1c.1g/2+10}if(O==="2A"&&((/21/i).3k(P.1u)||c(P))){13.1s.36={x:0,y:0};Q.x=-(Q.x-13.1Z.1M-13.1A.1f/2)*(13.1S.1f/13.1A.1f);Q.y=-(Q.y-13.1Z.1G-13.1A.1g/2)*(13.1S.1g/13.1A.1g)}}1j{Q={x:13.1Z.1M+(13.1Z.2J-13.1Z.1M)/2,y:13.1Z.1G+(13.1Z.2N-13.1Z.1G)/2};if(A.1e.2V&&13.1J&&13.1o("3E")==="2Z"){13.1s.69=1r;13.1s.36={x:0,y:0};Q.x=-(Q.x-13.1Z.1M-13.1A.1f/2)*(13.1S.1f/13.1A.1f);Q.y=-(Q.y-13.1Z.1G-13.1A.1g/2)*(13.1S.1g/13.1A.1g)}}13.1d.1U("1q-3r").1B("1q-2Q");Q.x+=-L;Q.y+=-K;13.1s.5B={x:0,y:0};13.1s.dx=0;13.1s.dy=0;13.8L(P,Q,1r);u("cC",13.id)},4e:17(L,Q){1b O;1b M;1b J;1b K;1b N=0;1b P=0;1b R=13.1c.2Q;13.64=1h;if(!13.2m){1a}if(L&&L.1u==="c6"&&L.2l==="3z"){1a}3P(13.51);13.51=1h;3P(13.5F);13.5F=1h;13.1c.3r=1l;13.1c.2Q=1l;if(Q!==1r&&!13.1J){if(R){if(A.1e.2V&&!13.1J&&13.1c.1V==="1m"){13.7R()}1j{13.6r()}}}if(!13.1c.4T){1a}if(L){L.2g()}13.1c.1i.1P("2W");13.1c.1d.1U("1q-3r").1P("2W");if(13.1J){K=13.4S.7y();if(13.1o("3E")!=="2Z"){13.5k.1U("1q-1m-in")}13.1i.1d.1y({"1W-1g":13.6I()});J=13.1i.1d.7y();P=((J.1M+J.2J)/2-(K.1M+K.2J)/2);N=((J.1G+J.2N)/2-(K.1G+K.2N)/2)}O=(13.1c.1V==="1m")?13.1c.2h:13.1c.1V;if(A.1e.2M.1Y&&L&&!(13.1J&&13.1o("3E")==="2Z")){if(O==="2A"){13.1c.1i.1D("2W",i(17(){13.1c.1i.1P("2W");13.1d.1U("1q-2Q");4q(i(17(){13.1c.4o()}).1F(13),32)}).1F(13));M=13.1i.1d.1E();13.1c.1d.1B("1q-9d 1q-p-"+O).1E();13.1c.1i.1y({2k:"4k(0,"+N+"2w,0) 48("+M.1f/13.1S.8B+", "+M.1g/13.1S.9W+")"})}1j{13.1c.1d.1D("2W",i(17(){13.1c.4o();13.1d.1U("1q-2Q")}).1F(13));13.1c.1d.3y("2p");13.1c.1d.1B("1q-9d 1q-p-"+O);13.1d.1U("1q-2Q")}}1j{13.1c.4o();13.1d.1U("1q-2Q")}13.1s.dx=0;13.1s.dy=0;13.1s.5B={x:0,y:0};13.1s.4o();if(R){u("cF",13.id)}},8L:17(T,S,R){1b L=S;1b N;1b M;1b P=0;1b K;1b O=0;1b J;1b U;1b Q=1l;if(!13.1c.2Q&&!R){1a}if(T){i(T).3X().5f();if(c(T)&&!h(T)){1a}Q=(/21/i).3k(T.1u)||c(T);if(Q&&!13.1s.7t){13.1s.7t=Q}if(!L){L=T.7x()}}if(13.1c.1V==="4n"){1a}if(13.1c.1V==="1m"&&13.1c.2h==="2A"&&(T&&Q||!T&&13.1s.69)){13.1s.69=1r;N=13.1s.36.x+(L.x-13.1s.5B.x);M=13.1s.36.y+(L.y-13.1s.5B.y);13.1s.5B=L;P=1p.2f(0,13.1c.5y-13.1S.1f)/2;K=-P;O=1p.2f(0,13.1c.5c-13.1S.1g)/2;J=-O}1j{13.1s.69=1l;if(13.1c.1V==="2y"){L.y=1p.1W(13.1Z.1G,1p.2f(L.y,13.1Z.2N));L.x=1p.1W(13.1Z.1M,1p.2f(L.x,13.1Z.2J))}N=L.x-13.1Z.1M;M=L.y-13.1Z.1G;K=13.1A.1f-13.1s.1f;J=13.1A.1g-13.1s.1g;N-=13.1s.1f/2;M-=13.1s.1g/2}if(13.1c.1V!=="2y"){N=1p.1W(P,1p.2f(N,K));M=1p.1W(O,1p.2f(M,J))}13.1s.36.x=N;13.1s.36.y=M;if(13.1c.1V==="1m"&&13.1c.2h!=="2A"){if(A.1e.2M.2k){13.1s.1d.1y({2k:"9T("+13.1s.36.x+"2w,"+13.1s.36.y+"2w)"});13.1s.1i.1y({2k:"9T("+-(13.1s.36.x+13.1s.3Q.x)+"2w, "+-(13.1s.36.y+13.1s.3Q.y)+"2w)"})}1j{13.1s.1d.1y({1G:13.1s.36.y,1M:13.1s.36.x});13.1s.1i.1y({1G:-(13.1s.36.y+13.1s.3Q.y),1M:-(13.1s.36.x+13.1s.3Q.x)})}}if(13.1c.1V==="2y"){if(13.1s.7t&&!(T&&T.1u==="3q")){L.y-=13.1c.1g/2+10}13.1c.1d.1y({1G:L.y-13.1Z.1G-13.1c.1g/2,1M:L.x-13.1Z.1M-13.1c.1f/2})}if(!13.51){13.1s.dx=0;13.1s.dy=0;13.5u(1)}},5u:17(O){1b M;1b K;1b J;1b P;1b N;1b L;if(!jt(O)){if(13.1s.69){O=13.1s.7t?0.4:0.16}1j{O=13.1o("cN")?0.2:13.1s.7t?0.4:0.8}}M=((13.1s.36.x-13.1s.dx)*O);K=((13.1s.36.y-13.1s.dy)*O);13.1s.dx+=M;13.1s.dy+=K;if(!13.51||1p.3C(M)>0.bE||1p.3C(K)>0.bE){if(13.1s.69){J=13.1s.dx;P=13.1s.dy}1j{J=(13.1s.dx*(13.1S.1f/13.1A.1f)-1p.1W(0,13.1S.1f-13.1c.5y)/2);P=(13.1s.dy*(13.1S.1g/13.1A.1g)-1p.1W(0,13.1S.1g-13.1c.5c)/2);if(13.1c.1V==="2y"){J=1p.5V(J);P=1p.5V(P)}J=-J;P=-P}N=13.1S.1f/13.1S.8B;L=13.1S.1g/13.1S.9W;13.1c.1i.1y(A.1e.2M.2k?{2k:g+J+"2w,"+P+"2w"+C+" 48("+N+","+L+")"}:{1f:13.1S.1f,1g:13.1S.1g,1M:-(13.1s.dx*(13.1S.1f/13.1A.1f)+1p.2f(0,13.1S.1f-13.1c.5y)/2),1G:-(13.1s.dy*(13.1S.1g/13.1A.1g)+1p.2f(0,13.1S.1g-13.1c.5c)/2)})}if(13.1c.1V==="2y"){1a}13.51=4q(13.cS,16)},bF:17(){1b V;1b L;1b Q=30;1b N=jE;1b S;1b T="";1b K={};1b J;1b P;1b U=0;1b W={1Y:A.1e.9U+5X.7c(32)+"dF 5q-5v(.18,.35,.58,1)"};1b M;1b R;1b O=i(17(X){if(!13.2m||13.1c.2Q){1a}if(X.2n==="3M"){3P(13.5F);13.5F=1h;U=0;K={x:X.x,y:X.y,cX:X.2R};V=13.1A.1f;L=V/2;13.1i.1d.1P("2W");13.1i.1d.3J("1Y","");13.1i.1d.3J("2k","4k(0, 0, 0)");R=1h}1j{J=(X.x-K.x);P={x:0,y:0,z:0};if(R===1h){R=(1p.3C(X.x-K.x)<1p.3C(X.y-K.y))}if(R){1a}X.2g();if(X.2n==="9z"){U=0;M=1h;S=X.2R-K.cX;if(1p.3C(J)>L||(S<N&&1p.3C(J)>Q)){if((T=(J>0)?"dw":(J<=0)?"jj":"")){if(T==="dw"){M=13.8H();U+=V*10}1j{M=13.8I();U-=V*10}}}P.x=U;P.dH=-90*(P.x/V);13.1i.1d.1D("2W",i(17(Y){13.1i.1d.1P("2W");13.1i.1d.3J("1Y","");if(M){13.1i.1d.1y({2k:"4k("+P.x+"2w, 63, 63)"});13.3W(M,1r)}}).1F(13));13.1i.1d.1y(W);13.1i.1d.1y({"1Y-5o":P.x?"jk":"dF",2p:1-0.7*1p.3C(P.x/V),2k:"4k("+P.x+"2w, 63, 63)"});J=0;1a}P.x=J;P.z=-50*1p.3C(P.x/L);P.dH=-60*(P.x/L);13.1i.1d.1y({2p:1-0.7*1p.3C(P.x/L),2k:"4k("+P.x+"2w, 63, "+P.z+"2w)"})}}).1F(13);13.1d.1D("2q",O)},cM:17(){1b K,J;if(13.3R.1I){13.4Q=13.3R}1j{K=13.3I.2s("3x-a0");if(K){if(A.1e.2M.bI){J=A.$A(1n.bJ(\'.a2[3x-a0="\'+K+\'"], .8X[3x-a0="\'+K+\'"]\'))}1j{J=A.$A(1n.92("A")).2X(17(L){1a K===L.2s("3x-a0")})}i(J).3f(17(M){1b L,N;L=j(M);if(L&&L.3R.1I>0){1a}if(L){N=1t l(L.1i.1K.29,L.1i.1m.29,L.1i.3u,1h,L.1i.4t);N.3O=L.1i.3O}1j{N=1t l().an(M,L?L.6E:1h)}if(13.1i.1m.1X.4K(N.1m.29)&&13.1i.1K.1X.4K(N.1K.29)){N=13.1i}13.4Q.3g(N)},13);13.79=13.1i}}if(13.4Q.1I>1){13.5k.1B("cZ-bz");13.5b=A.$1t("34",{"3T":"1q-2r-jl"}).24(13.5k);13.4g=1t s(13.5b);i(13.4Q).3f(17(L){1b M=i(17(N){13.a8(L);13.3W(L)}).1F(13);L.dK=13.4g.dL(A.$1t("2b",{1X:L.7B("1K")}).1D("21 1R",17(N){N.2g()}).1D("21 "+(13.1o("bT")==="7P"?"7O 8F":"1R"),i(17(O,N){if(13.6b){3P(13.6b)}13.6b=1l;if(O.1u==="7O"){13.6b=i(M).2F(N)}1j{if(O.1u==="21"||O.1u==="1R"){M()}}}).2L(13,60)))},13);13.2P.4M.5z();13.2P.4L.5z()}1j{13.5k.1U("cZ-bz");13.2P.4M.4o();13.2P.4L.4o()}},ds:17(){1b J;if(13.4g){13.4g.2g();13.4g=1h}if(13.5b){13.5b.2U();13.5b=1h}if(13.4Q.1I>1&&!13.3R.1I){13.1d.1P("2q");13.1i.1d.2U().2s("2o");13.1i.1d.5H("2o");13.79.1d.24(13.1d);13.7n(13.79);5K(J=13.4Q.jm()){if(J!==13.79){if(J.1K.1d){J.1K.1d.5h();J.1K.1d=1h}if(J.1m.1d){J.1m.1d.5h();J.1m.1d=1h}J=1h}}}13.4Q=[]},6d:17(){if(!13.2m||!13.1J){1a}if(A.1e.4O==="9B"&&A.1e.4v==="9D"&&5T(A.1e.75)===7){d5(n);n=1h}i(1n).1P("cd",13.8U);13.4e(1h,1r);13.2m=1l;if(A.1e.4Z.91&&A.1e.4Z.4T()){A.1e.4Z.d6()}1j{if(A.1e.2M.1Y){13.1d.1P("2W").1y({1Y:""});13.1d.1D("2W",13.7W);if(A.1e.3S){4q(i(17(){13.7W()}).1F(13),jn)}13.3Z.1P("2W").1y({1Y:""});13.3Z.1y({1Y:"dh 0.6s 5q-5v(0.df, 0.jo, 0.dg, 0.jp) 0.a1"}).1E();13.1d.1y({1Y:"dh .3s 5q-5v(0.8T, 0, 0.dk, 0.cb) a1"}).1E();if(13.1c.1V!==1l&&13.1o("3E")==="2Z"&&13.1o("4G")!=="2y"){13.1i.1d.1y({"1W-1g":13.1i.1E("1m").1g});13.1i.1d.1y({"1W-1f":13.1i.1E("1m").1f})}13.3Z.1y({2p:0.4});13.1d.1y({2p:0.jq,2k:"48(0.4)"})}1j{13.7W()}}},2r:17(L){if(!13.1i.2j()||!13.2m||13.1J){if(!13.1i.2j()){if(L){13.64=e(L);L.4j();if(L.1u==="21"){L.5d[1].4j()}}13.1i.67(13.7n.1F(13));if(!13.5E){13.5E=i(13.8J).1F(13).2F(8K)}}1a}if(L){L.4j()}1b J=i(13.1d).2e("cr");1b K=1n.jr();13.c3();13.6q--;13.4e(1h,1r);13.9f();13.9p();13.2m=1l;if(!13.3j){13.3j=A.$1t("34").1B("1q-2r").1B(13.1o("5C")).1y({2p:0});13.5k=A.$1t("34").1B("1q-2r-cQ").24(13.3j);13.8C=A.$1t("34").1B("1q-2r-ji").24(13.5k);i(["4L","4M","6d"]).3f(17(N){1b M="1q-2t";13.2P[N]=A.$1t("2t",{8z:13.1o("9N-js-"+N)}).1B(M).1B(M+"-"+N);K.bZ(13.2P[N]);4H(N){1C"4L":13.2P[N].1D("21 1R",17(O){O.2g();13.3W(13.8H())}.2L(13));1H;1C"4M":13.2P[N].1D("21 1R",17(O){O.2g();13.3W(13.8I())}.2L(13));1H;1C"6d":13.2P[N].1D("21 1R",17(O){O.2g();13.6d()}.2L(13));1H;1Q:}},13);13.8C.3c(K);13.3j.1D("4y 5g 3q",i(17(M){i(M).2g()}));if(13.1o("d9")){13.3j.1D("21 1R",17(O){1b N=O.5Q();1b M=i(13.1o("4G")==="2y"?13.1c.1d:13.1c.1i).7y();if(13.1o("3E")!=="2Z"&&M.1G<=N.y&&N.y<=M.2N&&M.1M<=N.x&&N.x<=M.2J){O.4j();13.4e(O);1a}if(13.1o("3E")!=="2Z"&&13.1d.9V(O.d4())){1a}O.2g();13.6d()}.2L(13))}13.8U=i(17(N){1b M=1h;if(N.7X!==27&&N.7X!==37&&N.7X!==39){1a}i(N).2g();if(N.7X===27){13.6d()}1j{M=(N.7X===37)?13.8H():13.8I();if(M){13.3W(M)}}}).2L(13);13.81=i(17(){1b M;13.1d.1P("2W").1y({1Y:"",2k:"4k(0, 0, 0)"});if(13.1J){1a}13.1J=1r;13.3j.1U("1q-2r-ju").1y({2p:1});13.1c.9w(13.1o("4G"));13.1S=A.43(13.3i);13.5L();if(13.3Y&&13.1i.3u){if(13.1i.3O){13.3Y.3c(A.$1t("a",{74:13.1i.3O}).1D("21 1R",13.a3.1F(13)).5A(13.1i.3u))}1j{13.3Y.5A(13.1i.3u)}13.3Y.1B("1q-5z")}if(13.1o("3E")!=="2Z"){13.89(1r);13.8w(1r)}13.2m=1r;if(13.1o("3E")==="2Z"){if(13.1c.1V!==1l){13.1c.6t(1r)}if(A.1e.2V&&13.8v){13.8v=1l}13.4J()}if((A.1e.2V||13.1o("as"))&&13.1c.4T){if(13.8v||13.6q>0){13.6r(1r,13.1o("ap"))}13.8v=1l}13.8C.1U("1q-3w").1B("1q-at 1q-5G");if(13.5b){13.5b.1U("1q-3w").1B("1q-at 1q-5G")}if(13.4g){13.4g.bS();13.a8(13.1i)}if(J){J.24(13.3j,((1p.5P(1p.6o()*bV)+1)%2)?"1G":"2N")}if(13.4Q.1I&&!13.3R.1I){13.bF()}i(1n).1D("cd",13.8U);if(A.1e.4O==="9B"&&A.1e.4v==="9D"&&5T(A.1e.75)===7){n=w()}u("dv",13.id)}).1F(13);13.7W=i(17(){13.1d.1P("2W");if(!13.1J){1a}if(13.1J){i(1n).1P("cd",13.8U);13.4e(1h,1r)}13.ds();13.1J=1l;13.1c.9w(13.1o("4c"));13.1d.8N(13.1i.76("1K"),13.1i.1d);13.1i.73("1K");i(13.1i.1d).1y({1f:"",1g:"","1W-1f":1p.2f(13.1i.1E("1K").1f),"1W-1g":1p.2f(13.1i.1E("1K").1g)});13.1s.1i.1X=13.1i.7B("1K");13.1d.1y({2p:"",1Y:""});13.1d.1y({2k:"4k(0, 0, 0)"});i(13.3I).8N(13.1d,13.8G);13.7k(1r);if(13.3Y){13.3Y.2U();13.3Y=1h}13.9f();13.9p();if(13.1o("4h")==="2Z"){13.4J()}1j{if(13.1o("4c")!==1l){13.89(13.1o("4h")==="2O");13.8w(13.1o("4h")==="2O")}}13.6r();13.3Z.1P("2W");13.3j.2U();13.3Z.2U();13.3Z=1h;i(A.1e.49()).1U("1q-1J-cw-8o");13.2m=1r;if(A.1e.2C<10){13.5L()}1j{i(1k).bL("cJ","72")}u("cT",13.id)}).1F(13);13.8P=A.$1t("34",{"3T":"1q-1i-cQ"}).24(13.5k);13.4S=A.$1t("5J").24(13.8P);13.8G=13.1d.jv(1l)}13.cM();i(A.1e.49()).1B("1q-1J-cw-8o");i(1n.3B).1E();if(13.1o("2r")==="cG"){13.c8();A.1e.4Z.ci(13.3j,{c2:i(17(){13.81()}).1F(13),ca:13.7W,8h:i(17(){13.bx()}).1F(13)})}1j{4q(i(17(){13.c8();13.bx()}).1F(13),96)}},c8:17(){1b K;1b J;K=A.$1t("2b",{1X:13.1i.7B("1m")});13.3Z=A.$1t("34").1B("1q-2r-bg").3c((A.1e.2M.8k||A.1e.2C<10)?K:1t A.9E(K).59(b).76()).24(13.3j);if(13.1o("3E")==="2Z"&&13.1o("4G")!==1l){13.5k.1B("1q-2Z-1m"+(13.1o("4G")==="1m"?" 1q-1m-in":"")).1E()}J=i(13.1d)[(A.1e.2C<10)?"1E":"7w"]();i(13.8G).1y({1f:J.1f,1g:J.1g});13.1d.8N(13.1i.76("1m"),13.1i.1d);13.1i.73("1m");13.3j.24(1n.3B);13.7J=17(){1b L=13.8P;if(i(13.4S).1E().1f>50){L=13.4S}1a 17(){1a 13.1o("3E")==="2Z"&&13.1o("4G")!==1l&&13.1o("4G")!=="2y"?66:1p.5V(i(L).8A().1f)}}.2c(13);13.6I=17(){1b L=13.8P;if(i(13.4S).1E().1g>50){L=13.4S}1a 17(){1a 13.1o("3E")==="2Z"&&13.1o("4G")!==1l&&13.1o("4G")!=="2y"?66:1p.5V(i(L).8A().1g)}}.2c(13);13.8C.1U("1q-at 1q-5G").1B("1q-3w");if(13.5b){13.5b.1U("1q-at 1q-5G").1B("1q-3w")}13.1i.1d.1y({"1W-1g":1p.2f(13.1i.1E("1m").1g,13.6I())});13.1i.1d.1y({"1W-1f":1p.2f(13.1i.1E("1m").1f,13.7J())});13.4S.3c(i(13.3I).8N(13.8G,13.1d));if(13.1o("3Y")){13.3Y=A.$1t("eZ",{"3T":"1q-3u"}).24(13.4S)}},bx:17(){13.1d.1y({1Y:""});13.1d.1y({2k:"48(0.6)"}).1E();13.1d.1y({1Y:A.1e.9U+" 0.4s 5q-5v(0.ao, 0.bX, 0.fw, 1) a1"});if(A.1e.2M.1Y){13.1d.1D("2W",13.81);if(A.1e.5U&&(A.1e.4v==="5U"||A.1e.4v==="6Y")){4q(i(17(){13.81()}).1F(13),bA)}}1j{13.81.2F(16,13)}13.3j.1y({2p:1});13.1d.1y({2k:"48(1)"})},a3:17(){if(13.1i.3O){1k.8o(13.1i.3O,"jw")}},8I:17(){1b J=(13.1J?13.4Q:13.3R).2X(17(M){1a(M.1K.2n!==-1||M.1m.2n!==-1)});1b K=J.1I;1b L=i(J).4E(13.1i)+1;1a(K<=1)?1h:J[(L>=K)?0:L]},8H:17(){1b J=(13.1J?13.4Q:13.3R).2X(17(M){1a(M.1K.2n!==-1||M.1m.2n!==-1)});1b K=J.1I;1b L=i(J).4E(13.1i)-1;1a(K<=1)?1h:J[(L<0)?K-1:L]},e0:17(K,L){1b J=13.3R.2X(17(M){1a((M.1m.1X.4K(K)||M.1m.29.4K(K))&&(M.1K.1X.4K(L)||M.1K.29.4K(L)))})||[];1a J[0]||((L&&K&&A.1O(L)==="1N"&&A.1O(K)==="1N")?1t l(L,K):1h)},c7:17(K){1b J=13.3R.2X(17(L){1a(L.4t===K)})||[];1a J[0]},fB:17(J){1a 13.3R[J]}};v={4I:"eG.2.5 (jx)",4z:17(M,K){1b L=1h;1b J=[];A.$A((M?[i(M)]:A.$A(1n.9l("a2")).5M(A.$A(1n.9l("8X"))))).3f(i(17(N){if(i(N)){if(!j(N)){L=1t k(N,K);if(y&&!L.1o("c4")){L.2g();L=1h}1j{G.3g(L);J.3g(L)}}}}).1F(13));1a M?J[0]:J},2g:17(M){1b K,L,J;if(M){(L=j(M))&&(L=G.9y(G.4E(L),1))&&L[0].2g()&&(4W L[0]);1a}5K(K=G.1I){L=G.9y(K-1,1);L[0].2g();4W L[0]}},jy:17(J){13.2g(J);1a 13.4z(J)},3W:17(O,N,M,K){1b L=j(O);1b J;if(L){J=A.1O(N)==="6n"?L.c7(N):L.e0(N,M);if(J){L.3W(J)}}},jz:17(M,L){1b K=j(M);1b J;if(K){4H(A.1O(L)){1C"6n":J=K.c7(L);1H;1C"6c":J=K.fB(L);1H;1Q:}if(J){K.3W(J)}}},4L:17(K){1b J;(J=j(K))&&J.3W(J.8H())},4M:17(K){1b J;(J=j(K))&&J.3W(J.8I())},jA:17(K){1b J;(J=j(K))&&J.4J()},jB:17(K){1b J;(J=j(K))&&J.4e()},2r:17(K){1b J;(J=j(K))&&J.2r()},6d:17(K){1b J;(J=j(K))&&J.6d()},ex:17(J,K){if(!q[J]){q[J]=[]}if(A.1O(K)==="17"){q[J].3g(K)}},jC:17(J){1a!!j(J)}};i(1n).1D("a5",17(){1b K=1k[E+"7a"]||{};t=t();d();I=A.$1t("34",{"3T":"3h-3w-78"}).24(1n.3B);H=(A.1e.2V&&1k.cn&&1k.cn("(1W-cL-1f: cK), (1W-cL-1g: cK)").jD);if(A.1e.2V){A.2a(p,m)}1T(1b J=0;J<B.1I;J++){if(K[B[J]]&&A.$F!==K[B[J]]){v.ex(B[J],K[B[J]])}}v.4z();y=1l});1k.8X=1k.8X||{};1a v})();', 62, 1318, '|||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||this||||function|||return|var|zoomBox|node|browser|width|height|null|image|else|window|false|zoom|document|option|Math|mz|true|lens|new|type|Event|options|Custom|jSetCss|event|size|jAddClass|case|jAddEvent|jGetSize|jBind|top|break|length|expanded|small|handler|left|string|jTypeOf|jRemoveEvent|default|btnclick|zoomSize|for|jRemoveClass|mode|max|src|transition|boundaries||tap|||jAppendTo||arguments|||url|extend|img|call||jFetch|min|stop|position|important|loaded|transform|pointerType|ready|state|style|opacity|touchdrag|expand|getAttribute|button|parseFloat|navigator|px||magnifier|prototype|inner|auto|ieMode|enum|undefined|jDelay|clientY|clientX|changedTouches|right|100|jBindAsEvent|features|bottom|click|buttons|active|timeStamp|context|mousedrag|jRemove|mobile|transitionend|filter|none|always||||jCallEvent|div||pos||jDel||pointerEnabled|jStore|append|oneOf|try|jEach|push|magic|zoomSizeOrigin|expandBox|test|rootCSS|settings|handle|hint|boolean|dbltap|activating||catch|caption|defined|hidden|data|jGetCss|touch|Doc|body|abs|setAttribute|expandZoomOn|orientation|match|parent|placeholder|jSetCssProp|identifier|init|dragstart|Class|link|clearTimeout|border|additionalImages|webkit|class|touchpinch|Element|update|stopDefaults|expandCaption|expandBg|off|hasOwnProperty||detach|||||scale|getDoc|pushToEvents|dblbtnclick|zoomMode|target|deactivate|array|expandThumbs|zoomOn|touches|stopQueue|translate3d|custom|firstChild|preview|hide|ceil|setTimeout|styles||origin|replace|uaName|root|visibility|mousescroll|start|schema|J_TYPE|reverse|parentNode|indexOf|pow|expandZoomMode|switch|version|activate|has|prev|next|listeners|platform|jTrim|expandGallery|domPrefix|expandFigure|enabled|vertical|requestAnimationFrame|delete|disabled|pageY|fullScreen||moveTimer|pageX||||direction|trident||blur|documentElement|expandNav|innerHeight|events|distance|stopDistribution|touchstart|kill|messageBox|handlers|expandStage|toLowerCase|MSPOINTER_TYPE_TOUCH|instanceof|duration|constructor|cubic|pointerup|pointermove|canvas|move|bezier|jCamelize|cubicBezier|innerWidth|show|changeContent|spos|cssClass|throw|loadTimer|activateTimer|visible|removeAttribute|timer|figure|while|resizeCallback|concat|FX|contains|floor|jGetPageXY|absolute|add|parseInt|chrome|round|nodeType|String|className|isQueueStopped|||J_UUID|0px|initEvent|Array|Infinity|load||innertouch|gecko|updateTimer|number|close|apply|to|targetTouches|css|scroll|mouseup|loadingBox|display|onerror|element|random|selectedItem|hintRuns|showHint||enable|dppx|onload|getAbsoluteURL|MSPointerMove|now|ease|MSPointerUp|touchend|ms|dragged|originalTitle|no|addCSS|render|expandMaxHeight|filters|originalImg|shift|Object|thumb|onTouchEnd|wunits|hunits|pointerdown|MagicJS|android|not|found|mousemove|mousedown|opera|selected||getButton|resize|setCurNode|href|uaVersion|getNode||wrapper|primaryImage|Options|normalSize|fromCharCode|minimum|toUpperCase|onTouchStart|cycles|tm|onComplete|overflow|setSize|trigger|threshold|setupZoom|end|jGetScroll|tooltip|cssTransformProp|MSPointerDown|touchmovement|easeFn|onready|getBoundingClientRect|getClientXY|jGetRect|svg|originalImage|getURL|timedout|continuous|oncomplete|padding|200|_handlers|engine|expandMaxWidth|join|alternate|set|callback|mouseover|hover|touchmove|reflowZoom|margin|androidBrowser|object|fromJSON|onClose|keyCode|_EVENTS_|parseCubicBezier|typeof|onExpand||itemCSS||||cssPrefix|jGetPosition|registerActivateEvent|byTag|zoomCaption|currentSrc|on|complete|_cleanup|readyState|fallback|sqrt|_unbind|cssFilters|_timer|getRelated|scrollLeft|open|crMz|scrollTop|horizontal|setOrientation|deltaY|setProps|mobileZoomHint|registerDeactivateEvent|index|storage|title|getInnerSize|maxWidth|expandControls|Transition|createElement|mouseout|stubNode|getPrev|getNext|showLoading|400|animate|toString|replaceChild|continue|expandImageStage|split|createTextNode|naturalWidth|600|keyboardCallback|pStyles|cancelAnimationFrame|MagicZoomPlus|perspective|normalizeCSS||capable|getElementsByTagName|textExpandHint||||dashize|||eventType|relatedTarget|isNaN|deactivating|_bind|unregisterActivateEvent|Opacity|status|hideTimer|originalImgSrc|getStorage|byClass|implement|Message|onTouchMove|unregisterDeactivateEvent|pStyles_arr|linear|loadSmall|lazyZoom|compatMode|nextImage|setMode|isPrimary|splice|dragend|PFX|ios|dblclick|safari|SVGImage|J_EUID|loopBind|pointerId|callee|xhr|forceAnimation|createEvent|fromString|text|btnclickEvent|XMLHttpRequest|handleMouseUp|_event_prefix_|msPointerEnabled|translate|cssTransform|hasChild|maxHeight|onprogress|exitFullscreen|reflow|gallery|0s|MagicZoom|openLink|magiczoom|domready|win|charAt|setActiveThumb|reset||||||||||||||parseNode|175|textClickZoomHint|exists|createElementNS|forceTouch|fade|touchScreen|handleTouchMove|resizeTimer|temporary|onClick|handleTouchEnd|loadImg|opr|cubicBezierAtTime|handleMouseDown|ImageLoader|styles_arr|el_arr|https|dispatchEvent|handleTouchStart|Za|05|Tooltip|abort|stopAnimation|onabort|_event_add_|cycle|priority|startAttempts|300|_event_del_|cssDomPrefix|startTime|calc|deltaMode|http|selectorsMoveFX|scrollFX|www|w3||org|getTarget|slice|tagName|presto||HTMLElement|ifndef|hideFX|removeChild||assign|getElementsByClassName|ignore|Alpha|Pltm|deltaX|mgctlbx|onclick|caller|loadedBytes|maximum|1000|changeEventName|errorEventName|once|previousScale|expandToWindow|onZoomReady|thumbs|500|loadZoom|isMouse|rel|000001|swipe|uuid|hideLoading|query|querySelectorAll|startTimer|jRaiseEvent|J_EXT|html|mzCrA|inline|delay|hintMessage|run|selectorTrigger|runtime|101|aspectRatio|885|span|appendChild|10000px|jClearEvents|onEnter|hideHint|autostart|textHoverZoomHint|pointerout|imageByOrigin|prepareExpandedView|onResize|onExit|045|zoomPosition|keydown||Date|0001|Function|request|onBeforeRender|firefox|Microsoft|Number|matchMedia|jSetOpacity|parseSchema|progid||isReady|DXImageTransform|zoomWidth|jHasClass|view|unregisterEvents|Right|stdDeviation|filterBlur|styleFloat|onZoomIn|getComputedStyle|naturalHeight|onZoomOut|fullscreen|handleMouseMove|nativize|UIEvent|767px|device|setupExpandGallery|smoothing|xhr2|loadBlob|stage|jToBool|moveBind|onExpandClose|onreadystatechange|insertRule|offsetWidth|ts|clientWidth|with|easeOutSine|easeInSine|getElementById|compareDocumentPosition|getOriginalTarget|clearInterval|cancel|textnode|DocumentTouch|closeOnClickOutside|webkit419|165|out|animation|euid|895|685|all|requestFullScreen|stopPropagation|735|cancelBubble|preventDefault|which||355|easeInExpo|easeOutExpo|destroyExpandGallery|loop|setMessage|onExpandOpen|backward|||wrap|onStart|999|querySelector|interval|03|300ms|fps|deg|finishTime|easeInQuad|selector|addItem|bounceIn|stylesId|elasticIn|easeOutBack|easeInBack|date|easeOutCubic|easeInCubic|easeOutQuad|onAfterRender|setupContent|Left|Bottom|onUpdate|imageByURL|zIndex|color|backcompat|2147483647|removeRule|Moz|moz|zoomHeight|Webkit|deleteRule|items|crios|setupSelectors|screenY|screenX|RegExp|stopImmediatePropagation|onswipe|UUID|detail||wheelDelta|charCodeAt|transitionEffect|setInterval||screen|od|R0lGODlhAQABAAD|loadOptions|enclose|rightClick|registerCallback|getJSON|touchOptions|10000|scrollbarsWidth|get|gif|base64|ACwAAAAAAQABAAACADs|v5|100000|_initialDistance|fontWeight|multibackground|background|cssText|mozCancelAnimationFrame|getContext|dragmove|block|lineHeight|10px|hone|styleSheet|documentMode|phone|shown|upscale|figcaption|toArray|item|selectItem|jDefer|error|MSPointerOut|onxhrerror|progressiveLoad|PI|304|cos|Top|registerEvents|initDrag|getTime|MouseEvent|variableZoom|changeZoomLevel|msExitFullscreen|addEventListener|0ms|ua|sheet||setCaption|doc|wheelDeltaY|cancelFullScreen|onchange|magicJS|curScale|wheelDeltaX|320|Click|backCompat|mjs|forEach|imageByIndex|yxxx|withCredentials|createEventObject|msFullscreenEnabled|gac3ac3e|4xxx|implementation|xxxx|head|userAgent|sort|hasFeature|TR|SVG11|feature|detachEvent|edge|attachEvent|fullscreenEnabled|webkitexitFullscreen|420|fireEvent|cssRules|map|webkitCancelFullScreen|evaluate|generateUUID|mozCancelFullScreen|oCancelFullScreen|xxxxxxxx|4294967296|xpath|msCancelFullScreen|addRule|removeCSS|xxxxxxxxxxxx|getHashCode|pinchstart|pinchupdate|xy|rules|FormData|DOMContentLoaded|jToInt|doScroll|air|toFloat|ProgressEvent|webkitCancelRequestAnimationFrame|removeEventListener|MSFullscreenError|ExitFullscreen|CancelFullScreen|unknown|taintEnabled|MSFullscreenChange|fullscreenchange|WebKitPoint|mozInnerScreenY|getBoxObjectFor|ActiveXObject|xiino|xda|fullscreenerror|RequestFullScreen|prefix|windows|activeElement|Width|wap|float|cssFloat|vodafone|getPropertyValue|currentStyle|up|treo|requestFullscreen|RequestFullscreen|series|WebKitTransitionEvent|msCancelAnimationFrame|9999|KeyboardEvent|red|KeyEvent|oCancelAnimationFrame|msRequestAnimationFrame|oRequestAnimationFrame|2px|cssfilters|webkitRequestAnimationFrame|TransitionEvent|webkitTransitionEnd|FullScreen|mozRequestAnimationFrame|collection|regexp|other|linux|mac|webos|lt|536|ver|fullscreenElement|FullscreenElement|webkitIsFullScreen|symbian|psp|isPrimaryTouch|clientHeight|offsetParent|innerHTML|innerText|childNodes|insertBefore|jGetStyle|msMaxTouchPoints|jSetStyle|iframe|maxTouchPoints|DOMElement|presto925|pageXOffset|offsetLeft|pageYOffset|jGetFullSize|scrollWidth|scrollHeight|ontouchstart|Image|returnValue|srcElement|pointerover|MSPointerOver|fromElement|toElement|isTouchEvent|offsetTop|clientLeft|pocket|lge|plucker|re|ixi|os|jToggleClass|jGetStyles|palm|ob|netfront|mmp|midp|maemo|kindle|clientTop|iris|iemobile|hiptop|fennec||||elaine|compal|blazer|blackberry|offsetHeight|bada|avantgo||jGetFullScroll||meego|jGetTransitionDuration|wheel|delta|Next|TypeError|Cannot|convert|or|zoomDistance|Hover|textBtnClose|Close|textBtnNext|textBtnPrev|ul|Previous|Tap|Touch|Double|devicePixelRatio|mgctlbxN|MZ|mgctlbxV|mgctlbxP|z0|li|sides|scrollTo|Incorrect|elasticOut|bounceOut|MagicToolboxTooltip|MessageBox|5000|NEGATIVE_INFINITY|POSITIVE_INFINITY|JSON|parse|definition|units|of|the|parameter|isset|2000|1999|xlink|setAttributeNS|feGaussianBlur|SourceGraphic|9_|availWidth|backIn|controls|forward|100ms|thumbnails|pop|260|030|220|01|createDocumentFragment|btn|isFinite|opening|cloneNode|_self|Plus|refresh|switchTo|zoomIn|zoomOut|running|matches|201|120|availHeight|fontSize|250|before|radius|rev|srcset|getRatio|selectstart|MobileOptions|contextmenu|fontFamily|loading|sans|serif|textAlign|2em|font|dummy|256|relative|350|message|backOut|mgctlbxL|cubicOut|675|445|085|easeInOutQuad|mousewheel|455|515|createObjectURL|055|215|565|v3|easeInOutCubic|645|onwheel|easeInQuart|easeOutQuart|easeInOutQuart|000244140625|easeInQuint|easeInOutSine|575|855|blob|GET|537|response|progress|responseType|static|total|lengthComputable|webkitURL|URL|715|send|cubicIn|destroy|infinite|normal|roundCss|setTransition|curFrame|745|755|955|06|easeInOutExpo|335|easeOutCirc|075|265|deltaZ|easeInOutBack|easeInOutCirc|easeOutQuint|sineIn|785|easeInCirc|sineOut|expoIn|expoOut|quadOut|easeInOutQuint|07|275|deltaFactor|quadIn|795|035|135|04'.split('|'), 0, {}));

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*


   Magic Scroll v2.0.26
   Copyright 2016 Magic Toolbox
   Buy a license: https://www.magictoolbox.com/magicscroll/
   License agreement: https://www.magictoolbox.com/license/


*/
eval(function (m, a, g, i, _c, k) {
   _c = function c(e) {
      return (e < a ? '' : _c(parseInt(e / a))) + ((e %= a) > 35 ? String.fromCharCode(e + 29) : e.toString(36));
   };if (!''.replace(/^/, String)) {
      while (g--) {
         k[_c(g)] = i[g] || _c(g);
      }i = [function (e) {
         return k[e];
      }];_c = function _c() {
         return '\\w+';
      };g = 1;
   }while (g--) {
      if (i[g]) {
         m = m.replace(new RegExp('\\b' + _c(g) + '\\b', 'g'), i[g]);
      }
   }return m;
}('1l.4U=(17(){1a s,u;s=u=(17(){1a Q={5w:"iU.3-b5",dM:0,9f:{},$6I:17(U){18(U.$6Q||(U.$6Q=++K.dM))},be:17(U){18(K.9f[U]||(K.9f[U]={}))},$F:17(){},$1c:17(){18 1c},$1e:17(){18 1e},dD:"dS-"+1g.66(1g.7v()*1v cv().dP()),3e:17(U){18(2U!=U)},bx:17(V,U){18(2U!=V)?V:U},ax:17(U){18!!(U)},1P:17(U){if(!K.3e(U)){18 1c}if(U.$4V){18 U.$4V}if(!!U.5a){if(1==U.5a){18"7x"}if(3==U.5a){18"dJ"}}if(U.1r&&U.36){18"iT"}if(U.1r&&U.aT){18"3m"}if((U 4v 1l.dL||U 4v 1l.cx)&&U.4I===K.4h){18"2D"}if(U 4v 1l.6h){18"48"}if(U 4v 1l.cx){18"17"}if(U 4v 1l.e2){18"2c"}if(K.1f.5N){if(K.3e(U.eE)){18"1D"}}1b{if(U===1l.1D||U.4I==1l.1u||U.4I==1l.iV||U.4I==1l.iW||U.4I==1l.iX||U.4I==1l.iS){18"1D"}}if(U 4v 1l.cv){18"dE"}if(U 4v 1l.iR){18"iM"}if(U===1l){18"1l"}if(U===1k){18"1k"}18 bz(U)},1U:17(Z,Y){if(!(Z 4v 1l.6h)){Z=[Z]}if(!Y){18 Z[0]}1s(1a X=0,V=Z.1r;X<V;X++){if(!K.3e(Z)){5c}1s(1a W in Y){if(!dL.27.4r.2o(Y,W)){5c}3p{Z[X][W]=Y[W]}3y(U){}}}18 Z[0]},bh:17(Y,X){if(!(Y 4v 1l.6h)){Y=[Y]}1s(1a W=0,U=Y.1r;W<U;W++){if(!K.3e(Y[W])){5c}if(!Y[W].27){5c}1s(1a V in(X||{})){if(!Y[W].27[V]){Y[W].27[V]=X[V]}}}18 Y[0]},dK:17(W,V){if(!K.3e(W)){18 W}1s(1a U in(V||{})){if(!W[U]){W[U]=V[U]}}18 W},$3p:17(){1s(1a V=0,U=3m.1r;V<U;V++){3p{18 3m[V]()}3y(W){}}18 1i},$A:17(W){if(!K.3e(W)){18 K.$([])}if(W.dO){18 K.$(W.dO())}if(W.36){1a V=W.1r||0,U=1v 6h(V);4W(V--){U[V]=W[V]}18 K.$(U)}18 K.$(6h.27.ca.2o(W))},67:17(){18 1v cv().dP()},6p:17(Y){1a W;7L(K.1P(Y)){1R"7T":W={};1s(1a X in Y){W[X]=K.6p(Y[X])}1N;1R"48":W=[];1s(1a V=0,U=Y.1r;V<U;V++){W[V]=K.6p(Y[V])}1N;2H:18 Y}18 K.$(W)},$:17(W){1a U=1e;if(!K.3e(W)){18 1i}if(W.$cw){18 W}7L(K.1P(W)){1R"48":W=K.dK(W,K.1U(K.6h,{$cw:K.$F}));W.1z=W.e3;18 W;1N;1R"2c":1a V=1k.ec(W);if(K.3e(V)){18 K.$(V)}18 1i;1N;1R"1l":1R"1k":K.$6I(W);W=K.1U(W,K.4c);1N;1R"7x":K.$6I(W);W=K.1U(W,K.3E);1N;1R"1D":W=K.1U(W,K.1u);1N;1R"dJ":1R"17":1R"48":1R"dE":2H:U=1c;1N}if(U){18 K.1U(W,{$cw:K.$F})}1b{18 W}},$1v:17(U,W,V){18 K.$(K.bu.6n(U)).eb(W||{}).33(V||{})},c2:17(V,X,ab){1a Y,W,Z,aa=[],U=-1;ab||(ab=K.dD);Y=K.$(ab)||K.$1v("3l",{id:ab,1H:"a1/au"}).4b((1k.iQ||1k.43),"1L");W=Y.dF||Y.dG;if("2c"!=K.1P(X)){1s(1a Z in X){aa.2b(Z+":"+X[Z])}X=aa.8A(";")}if(W.dC){U=W.dC(V+" {"+X+"}",W.iP.1r)}1b{U=W.iY(V,X)}18 U},cA:17(X,U){1a W,V;W=K.$(X);if("7x"!==K.1P(W)){18}V=W.dF||W.dG;if(V.dI){V.dI(U)}1b{if(V.dH){V.dH(U)}}},iZ:17(){18"j8-j7-j9-ja-jb".5j(/[j6]/g,17(W){1a V=1g.7v()*16|0,U=W=="x"?V:(V&3|8);18 U.8I(16)}).7X()},j5:(17(){1a U;18 17(V){if(!U){U=1k.6n("a")}U.3f("bd",V);18("!!"+U.bd).5j("!!","")}})(),j1:17(W){1a X=0,U=W.1r;1s(1a V=0;V<U;++V){X=31*X+W.j0(V);X%=j2}18 X}};1a K=Q;1a L=Q.$;if(!1l.bN){1l.bN=Q;1l.$dS=Q.$}K.6h={$4V:"48",5J:17(X,Y){1a U=14.1r;1s(1a V=14.1r,W=(Y<0)?1g.6l(0,V+Y):Y||0;W<V;W++){if(14[W]===X){18 W}}18-1},3i:17(U,V){18 14.5J(U,V)!=-1},e3:17(U,X){1s(1a W=0,V=14.1r;W<V;W++){if(W in 14){U.2o(X,14[W],W,14)}}},4S:17(U,Z){1a Y=[];1s(1a X=0,V=14.1r;X<V;X++){if(X in 14){1a W=14[X];if(U.2o(Z,14[X],X,14)){Y.2b(W)}}}18 Y},fX:17(U,Y){1a X=[];1s(1a W=0,V=14.1r;W<V;W++){if(W in 14){X[W]=U.2o(Y,14[W],W,14)}}18 X}};K.bh(e2,{$4V:"2c",4e:17(){18 14.5j(/^\\s+|\\s+$/g,"")},eq:17(U,V){18(V||1c)?(14.8I()===U.8I()):(14.38().8I()===U.38().8I())},6f:17(){18 14.5j(/-\\D/g,17(U){18 U.an(1).7X()})},bl:17(){18 14.5j(/[A-Z]/g,17(U){18("-"+U.an(0).38())})},j4:17(U){18 1X(14,U||10)},iK:17(){18 3q(14)},dN:17(){18!14.5j(/1e/i,"").4e()},bg:17(V,U){U=U||"";18(U+14+U).5J(U+V+U)>-1}});Q.bh(cx,{$4V:"17",1d:17(){1a V=K.$A(3m),U=14,W=V.78();18 17(){18 U.5k(W||1i,V.c7(K.$A(3m)))}},6F:17(){1a V=K.$A(3m),U=14,W=V.78();18 17(X){18 U.5k(W||1i,K.$([X||(K.1f.1B?1l.1D:1i)]).c7(V))}},3v:17(){1a V=K.$A(3m),U=14,W=V.78();18 1l.5o(17(){18 U.5k(U,V)},W||0)},ee:17(){1a V=K.$A(3m),U=14;18 17(){18 U.3v.5k(U,V)}},ek:17(){1a V=K.$A(3m),U=14,W=V.78();18 1l.ir(17(){18 U.5k(U,V)},W||0)}});1a R={},J=3V.iq.38(),I=J.4B(/(5d|8E|5N|c6)\\/(\\d+\\.?\\d*)/i),N=J.4B(/(is|cG)\\/(\\d+\\.?\\d*)/i)||J.4B(/(dx|a6|dp|e6|91|cG)\\/(\\d+\\.?\\d*)/i),P=J.4B(/5w\\/(\\d+\\.?\\d*)/i),E=1k.6s.3l;17 F(V){1a U=V.an(0).7X()+V.ca(1);18 V in E||("e9"+U)in E||("eS"+U)in E||("ms"+U)in E||("O"+U)in E}K.1f={4J:{it:!!(1k.iu),io:!!(1l.im),ih:!!(1k.ig),7r:!!(1k.ii||1k.ij||1k.aR||1k.f4||1k.il||1k.ik||1k.iv||1k.iw||1k.iF),ez:!!(1l.iE)&&!!(1l.iG)&&(1l.b1&&"iH"in 1v b1),2M:F("2M"),8b:F("8b"),e5:F("e5"),2s:F("2s"),5Q:1c,dY:1c,cz:1c,4n:1c,a3:(17(){18 1k.iI.iD("iC://iy.ix.iz/iA/iB/jc#jd","1.1")})()},c4:17(){18"jP"in 1l||(1l.e7&&1k 4v e7)||(3V.jO>0)||(3V.jQ>0)}(),7E:J.4B(/(a2|bb\\d+|jR).+|jS|jN\\/|jM|jI|jH|jJ|jK|jL|jT|ip(dV|e0|ad)|jU|k3|k2 |k4|k5|k6|7E.+e6|k1|91 m(k0|in)i|jW( jV)?|e1|p(jX|jY)\\/|jZ|jG|jF|jn(4|6)0|jm|jo|jp\\.(1f|jq)|jl|jk|jf (ce|e1)|jg|jh/)?1e:1c,7w:(I&&I[1])?I[1].38():(1l.91)?"c6":!!(1l.jj)?"5N":(2U!==1k.ji||1i!=1l.jr)?"8E":(1i!==1l.js||!3V.jB)?"5d":"jA",5w:(I&&I[2])?3q(I[2]):0,8p:(N&&N[1])?N[1].38():"",ak:(N&&N[2])?3q(N[2]):0,eO:"",c1:"",5u:"",1B:0,8u:J.4B(/ip(?:ad|e0|dV)/)?"eu":(J.4B(/(?:jC|a2)/)||3V.8u.4B(/jD|b2|jE/i)||["jz"])[0].38(),eI:1k.aM&&"dU"==1k.aM.38(),dW:0,5G:17(){18(1k.aM&&"dU"==1k.aM.38())?1k.43:1k.6s},5Q:1l.5Q||1l.jy||1l.ju||1l.jt||1l.jv||2U,9Z:1l.9Z||1l.dB||1l.dB||1l.ic||1l.k7||1l.hS||2U,5E:1c,7V:17(){if(K.1f.5E){18}1a X,W;K.1f.5E=1e;K.43=K.$(1k.43);K.b2=K.$(1l);3p{1a V=K.$1v("2Y").33({1A:2G,1F:2G,6z:"2r",2F:"6N",1L:-gW}).4b(1k.43);K.1f.dW=V.ea-V.ep;V.2n()}3y(U){}3p{X=K.$1v("2Y");W=X.3l;W.dA="e8:aL(cu://),aL(cu://),gX aL(cu://)";K.1f.4J.dY=(/(aL\\s*\\(.*?){3}/).3D(W.e8);W=1i;X=1i}3y(U){}if(!K.1f.dl){K.1f.dl=K.bf("8b").bl()}3p{X=K.$1v("2Y");X.3l.dA=K.bf("4S").bl()+":gg(gU);";K.1f.4J.cz=!!X.3l.1r&&(!K.1f.1B||K.1f.1B>9);X=1i}3y(U){}if(!K.1f.4J.cz){K.$(1k.6s).2S("eW-gP-4s")}3p{K.1f.4J.4n=(17(){1a Y=K.$1v("4n");18!!(Y.9e&&Y.9e("2d"))})()}3y(U){}if(2U===1l.gO&&2U!==1l.gQ){R.79="gR"}K.4c.1q.2o(K.$(1k),"8J")}};(17(){1a Z=[],Y,X,V;17 U(){18!!(3m.aT.d5)}7L(K.1f.7w){1R"5N":if(!K.1f.5w){K.1f.5w=!!(1l.b1)?3:2}1N;1R"8E":K.1f.5w=(N&&N[2])?3q(N[2]):0;1N}K.1f[K.1f.7w]=1e;if(N&&"dx"===N[1]){K.1f.8p="a6"}if(!!1l.a6){K.1f.a6=1e}if(N&&"cG"===N[1]){K.1f.8p="91";K.1f.91=1e}if("dp"===K.1f.8p&&(P&&P[1])){K.1f.ak=3q(P[1])}if("a2"==K.1f.8u&&K.1f.5d&&(P&&P[1])){K.1f.eK=1e}Y=({8E:["-eV-","eS","eV"],5d:["-5d-","e9","5d"],5N:["-ms-","ms","ms"],c6:["-o-","O","o"]})[K.1f.7w]||["","",""];K.1f.eO=Y[0];K.1f.c1=Y[1];K.1f.5u=Y[2];K.1f.1B=(!K.1f.5N)?2U:(1k.eJ)?1k.eJ:17(){1a aa=0;if(K.1f.eI){18 5}7L(K.1f.5w){1R 2:aa=6;1N;1R 3:aa=7;1N}18 aa}();Z.2b(K.1f.8u+"-4s");if(K.1f.7E){Z.2b("7E-4s")}if(K.1f.eK){Z.2b("a2-1f-4s")}if(K.1f.1B){K.1f.8p="ie";K.1f.ak=K.1f.1B;Z.2b("ie"+K.1f.1B+"-4s");1s(X=11;X>K.1f.1B;X--){Z.2b("lt-ie"+X+"-4s")}}if(K.1f.5d&&K.1f.5w<h8){K.1f.4J.7r=1c}if(K.1f.5Q){K.1f.5Q.2o(1l,17(){K.1f.4J.5Q=1e})}if(K.1f.4J.a3){Z.2b("a3-4s")}1b{Z.2b("eW-a3-4s")}V=(1k.6s.6r||"").4B(/\\S+/g)||[];1k.6s.6r=K.$(V).c7(Z).8A(" ");3p{1k.6s.3f("2e-4s-f6",K.1f.8p);1k.6s.3f("2e-4s-f6-h7",K.1f.ak)}3y(W){}if(K.1f.1B&&K.1f.1B<9){1k.6n("4w");1k.6n("34")}})();(17(){K.1f.7r={ci:K.1f.4J.7r,f8:17(){18!!(1k.h3||1k[K.1f.5u+"h2"]||1k.7r||1k.h4||1k[K.1f.5u+"gN"])},eC:17(U,V){V||(V={});if(14.ci){K.$(1k).1I(14.c9,14.fa=17(W){if(14.f8()){V.f9&&V.f9()}1b{K.$(1k).1V(14.c9,14.fa);V.f5&&V.f5()}}.6F(14));K.$(1k).1I(14.cM,14.5x=17(W){V.ar&&V.ar();K.$(1k).1V(14.cM,14.5x)}.6F(14));(U[K.1f.5u+"gJ"]||U[K.1f.5u+"gv"]||U.gu||17(){}).2o(U)}1b{if(V.ar){V.ar()}}},gw:(1k.aR||1k.f4||1k[K.1f.5u+"gx"]||1k[K.1f.5u+"gt"]||17(){}).1d(1k),c9:1k.eY?"gz":(1k.aR?"":K.1f.5u)+"gr",cM:1k.eY?"gp":(1k.aR?"":K.1f.5u)+"gy",gM:K.1f.5u,gI:1i}})();1a T=/\\S+/g,H=/^(5Z(f0|f1|f3|f2)gA)|((5L|6c)(f0|f1|f3|f2))$/,M={"gG":("2U"===bz(E.eG))?"gC":"eG"},O={gD:1e,gE:1e,3u:1e,cT:1e,cW:1e},G=(1l.ej)?17(W,U){1a V=1l.ej(W,1i);18 V?V.gF(U)||V[U]:1i}:17(X,V){1a W=X.h5,U=1i;U=W?W[V]:1i;if(1i==U&&X.3l&&X.3l[V]){U=X.3l[V]}18 U};17 S(W){1a U,V;V=(K.1f.5d&&"4S"==W)?1c:(W in E);if(!V){U=K.1f.c1+W.an(0).7X()+W.ca(1);if(U in E){18 U}}18 W}K.bf=S;K.3E={8W:17(U){18!(U||"").bg(" ")&&(14.6r||"").bg(U," ")},2S:17(Y){1a V=(14.6r||"").4B(T)||[],X=(Y||"").4B(T)||[],U=X.1r,W=0;1s(;W<U;W++){if(!K.$(V).3i(X[W])){V.2b(X[W])}}14.6r=V.8A(" ");18 14},4R:17(Z){1a V=(14.6r||"").4B(T)||[],Y=(Z||"").4B(T)||[],U=Y.1r,X=0,W;1s(;X<U;X++){if((W=K.$(V).5J(Y[X]))>-1){V.cy(W,1)}}14.6r=Z?V.8A(" "):"";18 14},hf:17(U){18 14.8W(U)?14.4R(U):14.2S(U)},2k:17(V){1a W=V.6f(),U=1i;V=M[W]||(M[W]=S(W));U=G(14,V);if("21"===U){U=1i}if(1i!==U){if("3u"==V){18 K.3e(U)?3q(U):1}if(H.3D(V)){U=1X(U,10)?U:"d1"}}18 U},1M:17(V,U){1a X=V.6f();3p{if("3u"==V){14.3Z(U);18 14}V=M[X]||(M[X]=S(X));14.3l[V]=U+(("5h"==K.1P(U)&&!O[X])?"2J":"")}3y(W){}18 14},33:17(V){1s(1a U in V){14.1M(U,V[U])}18 14},hU:17(){1a U={};K.$A(3m).1z(17(V){U[V]=14.2k(V)},14);18 U},3Z:17(W,U){1a V;U=U||1c;14.3l.3u=W;W=1X(3q(W)*2G);if(U){if(0===W){if("64"!=14.3l.6e){14.3l.6e="64"}}1b{if("7a"!=14.3l.6e){14.3l.6e="7a"}}}if(K.1f.1B&&K.1f.1B<9){if(!6C(W)){if(!~14.3l.4S.5J("cb")){14.3l.4S+=" eo:en.eh.cb(aQ="+W+")"}1b{14.3l.4S=14.3l.4S.5j(/aQ=\\d*/i,"aQ="+W)}}1b{14.3l.4S=14.3l.4S.5j(/eo:en.eh.cb\\(aQ=\\d*\\)/i,"").4e();if(""===14.3l.4S){14.3l.3P("4S")}}}18 14},eb:17(U){1s(1a V in U){if("2D"===V){14.2S(""+U[V])}1b{14.3f(V,""+U[V])}}18 14},hK:17(){1a V=0,U=0;V=14.2k("2M-3R");U=14.2k("2M-bs");V=V.5J("ms")>-1?3q(V):V.5J("s")>-1?3q(V)*93:0;U=U.5J("ms")>-1?3q(U):U.5J("s")>-1?3q(U)*93:0;18 V+U},52:17(){18 14.33({4N:"3X",6e:"64"})},2K:17(){18 14.33({4N:"",6e:"7a"})},2p:17(){18{1A:14.ea,1F:14.6g}},hM:17(V){1a U=14.2p();U.1A-=(3q(14.2k("5Z-1O-1A")||0)+3q(14.2k("5Z-6q-1A")||0));U.1F-=(3q(14.2k("5Z-1L-1A")||0)+3q(14.2k("5Z-5m-1A")||0));if(!V){U.1A-=(3q(14.2k("5L-1O")||0)+3q(14.2k("5L-6q")||0));U.1F-=(3q(14.2k("5L-1L")||0)+3q(14.2k("5L-5m")||0))}18 U},aF:17(){18{1L:14.aY,1O:14.aX}},hN:17(){1a U=14,V={1L:0,1O:0};do{V.1O+=U.aX||0;V.1L+=U.aY||0;U=U.3j}4W(U);18 V},5z:17(){1a Y=14,V=0,X=0;if(K.3e(1k.6s.bH)){1a U=14.bH(),W=K.$(1k).aF(),Z=K.1f.5G();18{1L:U.1L+W.y-Z.hP,1O:U.1O+W.x-Z.hO}}do{V+=Y.fh||0;X+=Y.df||0;Y=Y.hX}4W(Y&&!(/^(?:43|hY)$/i).3D(Y.2x));18{1L:X,1O:V}},i7:17(){1a V=14.5z();1a U=14.2p();18{1L:V.1L,5m:V.1L+U.1F,1O:V.1O,6q:V.1O+U.1A}},i6:17(V){3p{14.g7=V}3y(U){14.i8=V}18 14},2n:17(){18(14.3j)?14.3j.8y(14):14},4Y:17(){K.$A(14.2h).1z(17(U){if(3==U.5a||8==U.5a){18}K.$(U).4Y()});14.2n();14.cF();if(14.$6Q){K.9f[14.$6Q]=1i;5g K.9f[14.$6Q]}18 1i},2m:17(W,V){V=V||"5m";1a U=14.3o;("1L"==V&&U)?14.7i(W,U):14.9l(W);18 14},4b:17(W,V){1a U=K.$(W).2m(14,V);18 14},ia:17(U){14.2m(U.3j.i5(14,U));18 14},i4:17(U){if("7x"!==K.1P("2c"==K.1P(U)?U=1k.ec(U):U)){18 1c}18(14==U)?1c:(14.3i&&!(K.1f.ef))?(14.3i(U)):(14.ed)?!!(14.ed(U)&16):K.$A(14.7H(U.2x)).3i(U)}};K.3E.i1=K.3E.2k;K.3E.i2=K.3E.33;if(!1l.3E){1l.3E=K.$F;if(K.1f.7w.5d){1l.1k.6n("i3")}1l.3E.27=(K.1f.7w.5d)?1l["[[hJ.27]]"]:{}}K.bh(1l.3E,{$4V:"7x"});K.4c={2p:17(){if(K.1f.c4||K.1f.hp||K.1f.ef){18{1A:1l.ho,1F:1l.hq}}18{1A:K.1f.5G().ep,1F:K.1f.5G().ht}},aF:17(){18{x:1l.hn||K.1f.5G().aX,y:1l.hm||K.1f.5G().aY}},k8:17(){1a U=14.2p();18{1A:1g.6l(K.1f.5G().hg,U.1A),1F:1g.6l(K.1f.5G().hi,U.1F)}}};K.1U(1k,{$4V:"1k"});K.1U(1l,{$4V:"1l"});K.1U([K.3E,K.4c],{2t:17(X,V){1a U=K.be(14.$6Q),W=U[X];if(2U!==V&&2U===W){W=U[X]=V}18(K.3e(W)?W:1i)},3w:17(W,V){1a U=K.be(14.$6Q);U[W]=V;18 14},3H:17(V){1a U=K.be(14.$6Q);5g U[V];18 14}});if(!(1l.cl&&1l.cl.27&&1l.cl.27.cm)){K.1U([K.3E,K.4c],{cm:17(U){18 K.$A(14.aZ("*")).4S(17(W){3p{18(1==W.5a&&W.6r.bg(U," "))}3y(V){}})}})}K.1U([K.3E,K.4c],{fS:17(){18 14.cm(3m[0])},7H:17(){18 14.aZ(3m[0])}});if(K.1f.7r.ci&&!1k.eA){K.3E.eA=17(){K.1f.7r.eC(14)}}K.1u={$4V:"1D",6Z:K.$1c,2a:17(){18 14.8g().4x()},8g:17(){if(14.eD){14.eD()}1b{14.eE=1e}18 14},4x:17(){if(14.bQ){14.bQ()}1b{14.fF=1c}18 14},7N:17(){14.6Z=K.$1e;18 14},es:17(){1a V,U;V=((/5F/i).3D(14.1H))?14.3k[0]:14;18(!K.3e(V))?{x:0,y:0}:{x:V.3c,y:V.3a}},6V:17(){1a V,U;V=((/5F/i).3D(14.1H))?14.3k[0]:14;18(!K.3e(V))?{x:0,y:0}:{x:V.6w||V.3c+K.1f.5G().aX,y:V.6A||V.3a+K.1f.5G().aY}},cf:17(){1a U=14.1Z||14.hF;4W(U&&3==U.5a){U=U.3j}18 U},as:17(){1a V=1i;7L(14.1H){1R"5e":1R"hG":1R"hH":V=14.aW||14.hC;1N;1R"6J":1R"hB":1R"hx":V=14.aW||14.hw;1N;2H:18 V}3p{4W(V&&3==V.5a){V=V.3j}}3y(U){V=1i}18 V},7e:17(){if(!14.ey&&14.3Q!==2U){18(14.3Q&1?1:(14.3Q&2?3:(14.3Q&4?2:0)))}18 14.ey},hy:17(){18(14.3h&&("5F"===14.3h||14.3h===14.6R))||(/5F/i).3D(14.1H)},hz:17(){18 14.3h?(("5F"===14.3h||14.6R===14.3h)&&14.d4):1===14.3k.1r&&(14.8w.1r?14.8w[0].4C==14.3k[0].4C:1e)}};K.aH="et";K.9y="hA";K.7t="";if(!1k.et){K.aH="kV";K.9y="mg";K.7t="3U"}K.1u.1w={1H:"",x:1i,y:1i,3b:1i,3Q:1i,1Z:1i,aW:1i,$4V:"1D.mh",6Z:K.$1c,6H:K.$([]),4D:17(U){1a V=U;14.6H.2b(V)},2a:17(){18 14.8g().4x()},8g:17(){14.6H.1z(17(V){3p{V.8g()}3y(U){}});18 14},4x:17(){14.6H.1z(17(V){3p{V.4x()}3y(U){}});18 14},7N:17(){14.6Z=K.$1e;18 14},es:17(){18{x:14.3c,y:14.3a}},6V:17(){18{x:14.x,y:14.y}},cf:17(){18 14.1Z},as:17(){18 14.aW},7e:17(){18 14.3Q},mf:17(){18 14.6H.1r>0?14.6H[0].cf():2U}};K.1U([K.3E,K.4c],{1I:17(W,Y,Z,ac){1a ab,U,X,aa,V;if("2c"==K.1P(W)){V=W.8l(" ");if(V.1r>1){W=V}}if(K.1P(W)=="48"){K.$(W).1z(14.1I.6F(14,Y,Z,ac));18 14}if(!W||!Y||K.1P(W)!="2c"||K.1P(Y)!="17"){18 14}if(W=="8J"&&K.1f.5E){Y.2o(14);18 14}W=R[W]||W;Z=1X(Z||50);if(!Y.$4p){Y.$4p=1g.66(1g.7v()*K.67())}ab=K.4c.2t.2o(14,"9p",{});U=ab[W];if(!U){ab[W]=U=K.$([]);X=14;if(K.1u.1w[W]){K.1u.1w[W].1Q.6G.2o(14,ac)}1b{U.3N=17(ad){ad=K.1U(ad||1l.e,{$4V:"1D"});K.4c.1q.2o(X,W,K.$(ad))};14[K.aH](K.7t+W,U.3N,1c)}}aa={1H:W,fn:Y,bY:Z,ew:Y.$4p};U.2b(aa);U.mb(17(ae,ad){18 ae.bY-ad.bY});18 14},1V:17(aa){1a Y=K.4c.2t.2o(14,"9p",{}),W,U,V,ab,Z,X;Z=3m.1r>1?3m[1]:-2G;if("2c"==K.1P(aa)){X=aa.8l(" ");if(X.1r>1){aa=X}}if(K.1P(aa)=="48"){K.$(aa).1z(14.1V.6F(14,Z));18 14}aa=R[aa]||aa;if(!aa||K.1P(aa)!="2c"||!Y||!Y[aa]){18 14}W=Y[aa]||[];1s(V=0;V<W.1r;V++){U=W[V];if(-2G==Z||!!Z&&Z.$4p===U.ew){ab=W.cy(V--,1)}}if(0===W.1r){if(K.1u.1w[aa]){K.1u.1w[aa].1Q.2n.2o(14)}1b{14[K.9y](K.7t+aa,W.3N,1c)}5g Y[aa]}18 14},1q:17(Y,aa){1a X=K.4c.2t.2o(14,"9p",{}),W,U,V;Y=R[Y]||Y;if(!Y||K.1P(Y)!="2c"||!X||!X[Y]){18 14}3p{aa=K.1U(aa||{},{1H:Y})}3y(Z){}if(2U===aa.3b){aa.3b=K.67()}W=X[Y]||[];1s(V=0;V<W.1r&&!(aa.6Z&&aa.6Z());V++){W[V].fn.2o(14,aa)}},md:17(V,U){1a Y=("8J"==V)?1c:1e,X=14,W;V=R[V]||V;if(!Y){K.4c.1q.2o(14,V);18 14}if(X===1k&&1k.aS&&!X.ex){X=1k.6s}if(1k.aS){W=1k.aS(V);W.mk(U,1e,1e)}1b{W=1k.mq();W.9Q=V}if(1k.aS){X.ex(W)}1b{X.mr("3U"+U,W)}18 W},cF:17(){1a V=K.4c.2t.2o(14,"9p");if(!V){18 14}1s(1a U in V){K.4c.1V.2o(14,U)}K.4c.3H.2o(14,"9p");18 14}});(17(U){if("5n"===1k.8Z){18 U.1f.7V.3v(1)}if(U.1f.5d&&U.1f.5w<mt){(17(){(U.$(["4K","5n"]).3i(1k.8Z))?U.1f.7V():3m.aT.3v(50)})()}1b{if(U.1f.5N&&U.1f.1B<9&&1l==1L){(17(){(U.$3p(17(){U.1f.5G().mp("1O");18 1e}))?U.1f.7V():3m.aT.3v(50)})()}1b{U.4c.1I.2o(U.$(1k),"gl",U.1f.7V);U.4c.1I.2o(U.$(1l),"2C",U.1f.7V)}}})(Q);K.4h=17(){1a Y=1i,V=K.$A(3m);if("2D"==K.1P(V[0])){Y=V.78()}1a U=17(){1s(1a ab in 14){14[ab]=K.6p(14[ab])}if(14.4I.$4i){14.$4i={};1a ad=14.4I.$4i;1s(1a ac in ad){1a aa=ad[ac];7L(K.1P(aa)){1R"17":14.$4i[ac]=K.4h.ev(14,aa);1N;1R"7T":14.$4i[ac]=K.6p(aa);1N;1R"48":14.$4i[ac]=K.6p(aa);1N}}}1a Z=(14.4g)?14.4g.5k(14,3m):14;5g 14.d5;18 Z};if(!U.27.4g){U.27.4g=K.$F}if(Y){1a X=17(){};X.27=Y.27;U.27=1v X;U.$4i={};1s(1a W in Y.27){U.$4i[W]=Y.27[W]}}1b{U.$4i=1i}U.4I=K.4h;U.27.4I=U;K.1U(U.27,V[0]);K.1U(U,{$4V:"2D"});18 U};Q.4h.ev=17(U,V){18 17(){1a X=14.d5;1a W=V.5k(U,3m);18 W}};(17(X){1a W=X.$;1a U=5,V=8D;X.1u.1w.2L=1v X.4h(X.1U(X.1u.1w,{1H:"2L",4g:17(aa,Z){1a Y=Z.6V();14.x=Y.x;14.y=Y.y;14.3c=Z.3c;14.3a=Z.3a;14.3b=Z.3b;14.3Q=Z.7e();14.1Z=aa;14.4D(Z)}}));X.1u.1w.2L.1Q={1t:{8j:V,3Q:1},6G:17(Y){14.3w("1D:2L:1t",X.1U(X.6p(X.1u.1w.2L.1Q.1t),Y||{}));14.1I("8f",X.1u.1w.2L.1Q.3N,1);14.1I("6D",X.1u.1w.2L.1Q.3N,1);14.1I("4f",X.1u.1w.2L.1Q.de,1);if(X.1f.5N&&X.1f.1B<9){14.1I("8S",X.1u.1w.2L.1Q.3N,1)}},2n:17(){14.1V("8f",X.1u.1w.2L.1Q.3N);14.1V("6D",X.1u.1w.2L.1Q.3N);14.1V("4f",X.1u.1w.2L.1Q.de);if(X.1f.5N&&X.1f.1B<9){14.1V("8S",X.1u.1w.2L.1Q.3N)}},de:17(Y){Y.4x()},3N:17(ab){1a aa,Y,Z;Y=14.2t("1D:2L:1t");if(ab.1H!="8S"&&ab.7e()!=Y.3Q){18}if(14.2t("1D:2L:da")){14.3H("1D:2L:da");18}if("8f"==ab.1H){aa=1v X.1u.1w.2L(14,ab);14.3w("1D:2L:b6",aa)}1b{if("6D"==ab.1H){aa=14.2t("1D:2L:b6");if(!aa){18}Z=ab.6V();14.3H("1D:2L:b6");aa.4D(ab);if(ab.3b-aa.3b<=Y.8j&&1g.8e(1g.4Q(Z.x-aa.x,2)+1g.4Q(Z.y-aa.y,2))<=U){14.1q("2L",aa)}1k.1q("6D",ab)}1b{if(ab.1H=="8S"){aa=1v X.1u.1w.2L(14,ab);14.1q("2L",aa)}}}}}})(Q);(17(V){1a U=V.$;V.1u.1w.2E=1v V.4h(V.1U(V.1u.1w,{1H:"2E",4T:"41",6P:1c,4g:17(Z,Y,X){1a W=Y.6V();14.x=W.x;14.y=W.y;14.3c=Y.3c;14.3a=Y.3a;14.3b=Y.3b;14.3Q=Y.7e();14.1Z=Z;14.4D(Y);14.4T=X}}));V.1u.1w.2E.1Q={6G:17(){1a X=V.1u.1w.2E.1Q.eg.6F(14),W=V.1u.1w.2E.1Q.b0.6F(14);14.1I("8f",V.1u.1w.2E.1Q.d3,1);14.1I("6D",V.1u.1w.2E.1Q.b0,1);1k.1I("az",X,1);1k.1I("6D",W,1);14.3w("1D:2E:5r:1k:7J",X);14.3w("1D:2E:5r:1k:5D",W)},2n:17(){14.1V("8f",V.1u.1w.2E.1Q.d3);14.1V("6D",V.1u.1w.2E.1Q.b0);U(1k).1V("az",14.2t("1D:2E:5r:1k:7J")||V.$F);U(1k).1V("6D",14.2t("1D:2E:5r:1k:5D")||V.$F);14.3H("1D:2E:5r:1k:7J");14.3H("1D:2E:5r:1k:5D")},d3:17(X){1a W;if(1!=X.7e()){18}W=1v V.1u.1w.2E(14,X,"41");14.3w("1D:2E:41",W)},b0:17(X){1a W;W=14.2t("1D:2E:41");if(!W){18}X.4x();W=1v V.1u.1w.2E(14,X,"9x");14.3H("1D:2E:41");14.1q("2E",W)},eg:17(X){1a W;W=14.2t("1D:2E:41");if(!W){18}X.4x();if(!W.6P){W.6P=1e;14.1q("2E",W)}W=1v V.1u.1w.2E(14,X,"dw");14.1q("2E",W)}}})(Q);(17(V){1a U=V.$;V.1u.1w.4F=1v V.4h(V.1U(V.1u.1w,{1H:"4F",80:1c,7W:1i,4g:17(Y,X){1a W=X.6V();14.x=W.x;14.y=W.y;14.3c=X.3c;14.3a=X.3a;14.3b=X.3b;14.3Q=X.7e();14.1Z=Y;14.4D(X)}}));V.1u.1w.4F.1Q={1t:{8j:5K},6G:17(W){14.3w("1D:4F:1t",V.1U(V.6p(V.1u.1w.4F.1Q.1t),W||{}));14.1I("2L",V.1u.1w.4F.1Q.3N,1)},2n:17(){14.1V("2L",V.1u.1w.4F.1Q.3N)},3N:17(Y){1a X,W;X=14.2t("1D:4F:1D");W=14.2t("1D:4F:1t");if(!X){X=1v V.1u.1w.4F(14,Y);X.7W=5o(17(){X.80=1e;Y.6Z=V.$1c;14.1q("2L",Y);14.3H("1D:4F:1D")}.1d(14),W.8j+10);14.3w("1D:4F:1D",X);Y.7N()}1b{3t(X.7W);14.3H("1D:4F:1D");if(!X.80){X.4D(Y);Y.7N().2a();14.1q("4F",X)}1b{}}}}})(Q);(17(aa){1a Z=aa.$;17 U(ab){18 ab.3h?(("5F"===ab.3h||ab.6R===ab.3h)&&ab.d4):1===ab.3k.1r&&(ab.8w.1r?ab.8w[0].4C==ab.3k[0].4C:1e)}17 W(ab){if(ab.3h){18("5F"===ab.3h||ab.6R===ab.3h)?ab.9I:1i}1b{18 ab.3k[0].4C}}17 X(ab){if(ab.3h){18("5F"===ab.3h||ab.6R===ab.3h)?ab:1i}1b{18 ab.3k[0]}}aa.1u.1w.3A=1v aa.4h(aa.1U(aa.1u.1w,{1H:"3A",id:1i,4g:17(ac,ab){1a ad=X(ab);14.id=ad.9I||ad.4C;14.x=ad.6w;14.y=ad.6A;14.6w=ad.6w;14.6A=ad.6A;14.3c=ad.3c;14.3a=ad.3a;14.3b=ab.3b;14.3Q=0;14.1Z=ac;14.4D(ab)}}));1a V=10,Y=5K;aa.1u.1w.3A.1Q={6G:17(ab){14.1I(["8m",1l.3V.4A?"9F":"9E"],aa.1u.1w.3A.1Q.7Y,1);14.1I(["8t",1l.3V.4A?"8x":"7P"],aa.1u.1w.3A.1Q.7m,1);14.1I("4f",aa.1u.1w.3A.1Q.cX,1)},2n:17(){14.1V(["8m",1l.3V.4A?"9F":"9E"],aa.1u.1w.3A.1Q.7Y);14.1V(["8t",1l.3V.4A?"8x":"7P"],aa.1u.1w.3A.1Q.7m);14.1V("4f",aa.1u.1w.3A.1Q.cX)},cX:17(ab){ab.4x()},7Y:17(ab){if(!U(ab)){14.3H("1D:3A:1D");18}14.3w("1D:3A:1D",1v aa.1u.1w.3A(14,ab));14.3w("1D:2L:da",1e)},7m:17(ae){1a ac=aa.67(),ad=14.2t("1D:3A:1D"),ab=14.2t("1D:3A:1t");if(!ad||!U(ae)){18}14.3H("1D:3A:1D");if(ad.id==W(ae)&&ae.3b-ad.3b<=Y&&1g.8e(1g.4Q(X(ae).6w-ad.x,2)+1g.4Q(X(ae).6A-ad.y,2))<=V){14.3H("1D:2L:b6");ae.2a();ad.4D(ae);14.1q("3A",ad)}}}})(Q);K.1u.1w.5b=1v K.4h(K.1U(K.1u.1w,{1H:"5b",80:1c,7W:1i,4g:17(V,U){14.x=U.x;14.y=U.y;14.3c=U.3c;14.3a=U.3a;14.3b=U.3b;14.3Q=0;14.1Z=V;14.4D(U)}}));K.1u.1w.5b.1Q={1t:{8j:8D},6G:17(U){14.3w("1D:5b:1t",K.1U(K.6p(K.1u.1w.5b.1Q.1t),U||{}));14.1I("3A",K.1u.1w.5b.1Q.3N,1)},2n:17(){14.1V("3A",K.1u.1w.5b.1Q.3N)},3N:17(W){1a V,U;V=14.2t("1D:5b:1D");U=14.2t("1D:5b:1t");if(!V){V=1v K.1u.1w.5b(14,W);V.7W=5o(17(){V.80=1e;W.6Z=K.$1c;14.1q("3A",W)}.1d(14),U.8j+10);14.3w("1D:5b:1D",V);W.7N()}1b{3t(V.7W);14.3H("1D:5b:1D");if(!V.80){V.4D(W);W.7N().2a();14.1q("5b",V)}1b{}}}};(17(Z){1a Y=Z.$;17 U(aa){18 aa.3h?(("5F"===aa.3h||aa.6R===aa.3h)&&aa.d4):1===aa.3k.1r&&(aa.8w.1r?aa.8w[0].4C==aa.3k[0].4C:1e)}17 W(aa){if(aa.3h){18("5F"===aa.3h||aa.6R===aa.3h)?aa.9I:1i}1b{18 aa.3k[0].4C}}17 X(aa){if(aa.3h){18("5F"===aa.3h||aa.6R===aa.3h)?aa:1i}1b{18 aa.3k[0]}}1a V=10;Z.1u.1w.2u=1v Z.4h(Z.1U(Z.1u.1w,{1H:"2u",4T:"41",id:1i,6P:1c,4g:17(ac,ab,aa){1a ad=X(ab);14.id=ad.9I||ad.4C;14.3c=ad.3c;14.3a=ad.3a;14.6w=ad.6w;14.6A=ad.6A;14.x=ad.6w;14.y=ad.6A;14.3b=ab.3b;14.3Q=0;14.1Z=ac;14.4D(ab);14.4T=aa}}));Z.1u.1w.2u.1Q={6G:17(){1a ab=Z.1u.1w.2u.1Q.9R.1d(14),aa=Z.1u.1w.2u.1Q.7m.1d(14);14.1I(["8m",1l.3V.4A?"9F":"9E"],Z.1u.1w.2u.1Q.7Y,1);14.1I(["8t",1l.3V.4A?"8x":"7P"],Z.1u.1w.2u.1Q.7m,1);14.1I(["9N",1l.3V.4A?"9S":"9O"],Z.1u.1w.2u.1Q.9R,1);14.3w("1D:2u:5r:1k:7J",ab);14.3w("1D:2u:5r:1k:5D",aa);Y(1k).1I(1l.3V.4A?"9S":"9O",ab,1);Y(1k).1I(1l.3V.4A?"8x":"7P",aa,1)},2n:17(){14.1V(["8m",1l.3V.4A?"9F":"9E"],Z.1u.1w.2u.1Q.7Y);14.1V(["8t",1l.3V.4A?"8x":"7P"],Z.1u.1w.2u.1Q.7m);14.1V(["9N",1l.3V.4A?"9S":"9O"],Z.1u.1w.2u.1Q.9R);Y(1k).1V(1l.3V.4A?"9S":"9O",14.2t("1D:2u:5r:1k:7J")||Z.$F,1);Y(1k).1V(1l.3V.4A?"8x":"7P",14.2t("1D:2u:5r:1k:5D")||Z.$F,1);14.3H("1D:2u:5r:1k:7J");14.3H("1D:2u:5r:1k:5D")},7Y:17(ab){1a aa;if(!U(ab)){18}aa=1v Z.1u.1w.2u(14,ab,"41");14.3w("1D:2u:41",aa)},7m:17(ab){1a aa;aa=14.2t("1D:2u:41");if(!aa||!aa.6P||aa.id!=W(ab)){18}aa=1v Z.1u.1w.2u(14,ab,"9x");14.3H("1D:2u:41");14.1q("2u",aa)},9R:17(ab){1a aa;aa=14.2t("1D:2u:41");if(!aa||!U(ab)){18}if(aa.id!=W(ab)){14.3H("1D:2u:41");18}if(!aa.6P&&1g.8e(1g.4Q(X(ab).6w-aa.x,2)+1g.4Q(X(ab).6A-aa.y,2))>V){aa.6P=1e;14.1q("2u",aa)}if(!aa.6P){18}aa=1v Z.1u.1w.2u(14,ab,"dw");14.1q("2u",aa)}}})(Q);K.1u.1w.4q=1v K.4h(K.1U(K.1u.1w,{1H:"4q",7F:1,bZ:1,e4:1,4T:"m2",4g:17(V,U){14.3b=U.3b;14.3Q=0;14.1Z=V;14.x=U.57[0].3c+(U.57[1].3c-U.57[0].3c)/2;14.y=U.57[0].3a+(U.57[1].3a-U.57[0].3a)/2;14.dm=1g.8e(1g.4Q(U.57[0].3c-U.57[1].3c,2)+1g.4Q(U.57[0].3a-U.57[1].3a,2));14.4D(U)},7g:17(U){1a V;14.4T="m3";if(U.3k[0].4C!=14.6H[0].57[0].4C||U.3k[1].4C!=14.6H[0].57[1].4C){18}V=1g.8e(1g.4Q(U.3k[0].3c-U.3k[1].3c,2)+1g.4Q(U.3k[0].3a-U.3k[1].3a,2));14.bZ=14.7F;14.7F=V/14.dm;14.e4=14.7F/14.bZ;14.x=U.3k[0].3c+(U.3k[1].3c-U.3k[0].3c)/2;14.y=U.3k[0].3a+(U.3k[1].3a-U.3k[0].3a)/2;14.4D(U)}}));K.1u.1w.4q.1Q={6G:17(){14.1I("8m",K.1u.1w.4q.1Q.bG,1);14.1I("8t",K.1u.1w.4q.1Q.bV,1);14.1I("9N",K.1u.1w.4q.1Q.bP,1)},2n:17(){14.1V("8m",K.1u.1w.4q.1Q.bG);14.1V("8t",K.1u.1w.4q.1Q.bV);14.1V("9N",K.1u.1w.4q.1Q.bP)},bG:17(V){1a U;if(V.57.1r!=2){18}V.4x();U=1v K.1u.1w.4q(14,V);14.3w("1D:4q:1D",U)},bV:17(V){1a U;U=14.2t("1D:4q:1D");if(!U){18}V.4x();14.3H("1D:4q:1D")},bP:17(V){1a U;U=14.2t("1D:4q:1D");if(!U){18}V.4x();U.7g(V);14.1q("4q",U)}};(17(Z){1a X=Z.$;Z.1u.1w.4z=1v Z.4h(Z.1U(Z.1u.1w,{1H:"4z",4g:17(af,ae,ah,ab,aa,ag,ac){1a ad=ae.6V();14.x=ad.x;14.y=ad.y;14.3b=ae.3b;14.1Z=af;14.my=ah||0;14.3L=ab||0;14.3K=aa||0;14.mx=ag||0;14.mB=ac||0;14.bv=ae.bv||0;14.4Z=1c;14.4D(ae)}}));1a Y,V;17 U(){Y=1i}17 W(aa,ab){18(aa>50)||(1===ab&&!("b2"==Z.1f.8u&&aa<1))||(0===aa%12)||(0==aa%4.mw)}Z.1u.1w.4z.1Q={9Q:"mA"in 1k||Z.1f.1B>8?"mC":"a7",6G:17(){14.1I(Z.1u.1w.4z.1Q.9Q,Z.1u.1w.4z.1Q.3N,1)},2n:17(){14.1V(Z.1u.1w.4z.1Q.9Q,Z.1u.1w.4z.1Q.3N,1)},3N:17(af){1a ag=0,ad=0,ab=0,aa=0,ae,ac;if(af.du){ab=af.du*-1}if(af.dq!==2U){ab=af.dq}if(af.dr!==2U){ab=af.dr}if(af.dT!==2U){ad=af.dT*-1}if(af.3K){ab=-1*af.3K}if(af.3L){ad=af.3L}if(0===ab&&0===ad){18}ag=0===ab?ad:ab;aa=1g.6l(1g.1E(ab),1g.1E(ad));if(!Y||aa<Y){Y=aa}ae=ag>0?"66":"9a";ag=1g[ae](ag/Y);ad=1g[ae](ad/Y);ab=1g[ae](ab/Y);if(V){3t(V)}V=5o(U,5K);ac=1v Z.1u.1w.4z(14,af,ag,ad,ab,0,Y);ac.4Z=W(Y,af.bv||0);14.1q("4z",ac)}}})(Q);K.b2=K.$(1l);K.bu=K.$(1k);18 Q})();(17(G){if(!G){6v"7z 7s 7n"}1a F=G.$;1a E=1l.kG||1l.kF||1i;s.fB=1v G.4h({2g:1i,5E:1c,1t:{b7:G.$F,6b:G.$F,9d:G.$F,5x:G.$F,8n:G.$F,er:G.$F,bc:1c,eZ:1e},1y:1i,9i:1i,bC:0,8v:{b7:17(H){if(H.1Z&&(5K===H.1Z.aV||eP===H.1Z.aV)&&H.kB){14.1t.b7.1d(1i,(H.4K-(14.1t.eZ?14.bC:0))/H.kC).3v(1);14.bC=H.4K}},6b:17(H){if(H){F(H).2a()}14.9k();if(14.5E){18}14.5E=1e;14.8z();!14.1t.bc&&14.1t.b7.1d(1i,1).3v(1);14.1t.6b.1d(1i,14).3v(1);14.1t.8n.1d(1i,14).3v(1)},9d:17(H){if(H){F(H).2a()}14.9k();14.5E=1c;14.8z();14.1t.9d.1d(1i,14).3v(1);14.1t.8n.1d(1i,14).3v(1)},5x:17(H){if(H){F(H).2a()}14.9k();14.5E=1c;14.8z();14.1t.5x.1d(1i,14).3v(1);14.1t.8n.1d(1i,14).3v(1)}},bo:17(){F(["2C","8H","7G"]).1z(17(H){14.2g.1I(H,14.8v["3U"+H].6F(14).ee(1))},14)},9k:17(){if(14.9i){3p{3t(14.9i)}3y(H){}14.9i=1i}F(["2C","8H","7G"]).1z(17(I){14.2g.1V(I)},14)},8z:17(){14.2p();if(14.2g.2t("1v")){1a H=14.2g.3j;14.2g.2n().3H("1v").33({2F:"kM",1L:"21"});H.4Y()}},eF:17(I){1a J=1v b1(),H;F(["8H","1K"]).1z(17(K){J["3U"+K]=F(17(L){14.8v["3U"+K].2o(14,L)}).1d(14)},14);J.5x=F(17(){14.1t.er.1d(1i,14).3v(1);14.1t.bc=1c;14.bo();14.2g.4l=I}).1d(14);J.6b=F(17(){if(5K!==J.aV&&eP!==J.aV){14.8v.5x.2o(14);18}H=J.kX;14.bo();if(E&&!G.1f.5N&&!("eu"===G.1f.8u&&G.1f.5w<kT)){14.2g.3f("4l",E.kS(H))}1b{14.2g.4l=I}}).1d(14);J.kO("kN",I);J.kP="kQ";J.kR()},4g:17(I,H){14.1t=G.1U(14.1t,H);14.2g=F(I)||G.$1v("2g",{},{"6l-1A":"3X","6l-1F":"3X"}).4b(G.$1v("2Y").2S("4s-kz-2g").33({2F:"6N",1L:-ky,1A:10,1F:10,6z:"64"}).4b(1k.43)).3w("1v",1e);if(G.1f.4J.ez&&14.1t.bc&&"2c"==G.1P(I)){14.eF(I);18}1a J=17(){if(14.em()){14.8v.6b.2o(14)}1b{14.8v.5x.2o(14)}J=1i}.1d(14);14.bo();if("2c"==G.1P(I)){14.2g.4l=I}1b{if(G.1f.5N&&5==G.1f.5w&&G.1f.1B<9){14.2g.eB=17(){if(/4K|5n/.3D(14.2g.8Z)){14.2g.eB=1i;J&&J()}}.1d(14)}14.2g.4l=I.3O("4l")}14.2g&&14.2g.5n&&J&&(14.9i=J.3v(2G))},fy:17(){14.9k();14.8z();14.5E=1c;18 14},em:17(){1a H=14.2g;18(H.bB)?(H.bB>0):(H.8Z)?("5n"==H.8Z):H.1A>0},2p:17(){18 14.1y||(14.1y={1A:14.2g.bB||14.2g.1A,1F:14.2g.k9||14.2g.1F})}})})(s);(17(F){if(!F){6v"7z 7s 7n"}if(F.4y){18}1a E=F.$;F.4y=1v F.4h({4g:17(H,G){1a I;14.el=F.$(H);14.1t=F.1U(14.1t,G);14.6E=1c;14.85=14.9T;I=F.4y.9w[14.1t.2M]||14.1t.2M;if("17"===F.1P(I)){14.85=I}1b{14.5W=14.9j(I)||14.9j("7I")}if("2c"==F.1P(14.1t.7O)){14.1t.7O="3z"===14.1t.7O?kb:1X(14.1t.7O)||1}},1t:{ei:60,3R:bS,2M:"7I",7O:1,1J:"kc",8R:F.$F,5X:F.$F,aU:F.$F,fb:F.$F,al:1c,kd:1c},56:1i,5W:1i,85:1i,kl:17(G){14.1t.2M=G;G=F.4y.9w[14.1t.2M]||14.1t.2M;if("17"===F.1P(G)){14.85=G}1b{14.85=14.9T;14.5W=14.9j(G)||14.9j("7I")}},2N:17(I){1a G=/\\%$/,H;14.56=I||{};14.bw=0;14.4T=0;14.km=0;14.aN={};14.81="81"===14.1t.1J||"81-4E"===14.1t.1J;14.2y="2y"===14.1t.1J||"2y-4E"===14.1t.1J;1s(H in 14.56){G.3D(14.56[H][0])&&(14.aN[H]=1e);if("4E"===14.1t.1J||"81-4E"===14.1t.1J||"2y-4E"===14.1t.1J){14.56[H].4E()}}14.bE=F.67();14.eH=14.bE+14.1t.3R;14.1t.8R.2o();if(0===14.1t.3R){14.7C(1);14.1t.5X.2o()}1b{14.at=14.1n.1d(14);if(!14.1t.al&&F.1f.4J.5Q){14.6E=F.1f.5Q.2o(1l,14.at)}1b{14.6E=14.at.ek(1g.5O(93/14.1t.ei))}}18 14},bt:17(){if(14.6E){if(!14.1t.al&&F.1f.4J.5Q&&F.1f.9Z){F.1f.9Z.2o(1l,14.6E)}1b{kx(14.6E)}14.6E=1c}},2a:17(G){G=F.3e(G)?G:1c;14.bt();if(G){14.7C(1);14.1t.5X.3v(10)}18 14},bM:17(I,H,G){I=3q(I);H=3q(H);18(H-I)*G+I},1n:17(){1a H=F.67(),G=(H-14.bE)/14.1t.3R,I=1g.66(G);if(H>=14.eH&&I>=14.1t.7O){14.bt();14.7C(1);14.1t.5X.3v(10);18 14}if(14.81&&14.bw<I){1s(1a J in 14.56){14.56[J].4E()}}14.bw=I;if(!14.1t.al&&F.1f.4J.5Q){14.6E=F.1f.5Q.2o(1l,14.at)}14.7C((14.2y?I:0)+14.85(G%1))},7C:17(G){1a H={},J=G;1s(1a I in 14.56){if("3u"===I){H[I]=1g.5O(14.bM(14.56[I][0],14.56[I][1],G)*2G)/2G}1b{H[I]=14.bM(14.56[I][0],14.56[I][1],G);14.aN[I]&&(H[I]+="%")}}14.1t.aU(H,14.el);14.2q(H);14.1t.fb(H,14.el)},2q:17(G){18 14.el.33(G)},9j:17(G){1a H,I=1i;if("2c"!==F.1P(G)){18 1i}7L(G){1R"97":I=E([0,0,1,1]);1N;1R"7I":I=E([0.25,0.1,0.25,1]);1N;1R"7I-in":I=E([0.42,0,1,1]);1N;1R"7I-ap":I=E([0,0,0.58,1]);1N;1R"7I-in-ap":I=E([0.42,0,0.58,1]);1N;1R"eU":I=E([0.47,0,0.lz,0.lA]);1N;1R"eT":I=E([0.39,0.lB,0.lx,1]);1N;1R"lw":I=E([0.lr,0.bF,0.55,0.95]);1N;1R"fc":I=E([0.55,0.lq,0.68,0.53]);1N;1R"dt":I=E([0.25,0.46,0.45,0.94]);1N;1R"ls":I=E([0.lu,0.eX,0.lv,0.lC]);1N;1R"ds":I=E([0.55,0.lD,0.lL,0.19]);1N;1R"dv":I=E([0.lM,0.61,0.f7,1]);1N;1R"lN":I=E([0.lO,0.eN,0.f7,1]);1N;1R"lJ":I=E([0.lF,0.eX,0.lG,0.22]);1N;1R"lH":I=E([0.eM,0.84,0.44,1]);1N;1R"lI":I=E([0.77,0,0.eL,1]);1N;1R"lp":I=E([0.lo,0.bF,0.l7,0.l8]);1N;1R"l9":I=E([0.23,1,0.32,1]);1N;1R"la":I=E([0.86,0,0.l6,1]);1N;1R"eQ":I=E([0.95,0.bF,0.l1,0.l0]);1N;1R"eR":I=E([0.19,1,0.22,1]);1N;1R"l2":I=E([1,0,0,1]);1N;1R"l3":I=E([0.6,0.l4,0.98,0.lb]);1N;1R"lc":I=E([0.lk,0.82,0.eM,1]);1N;1R"lm":I=E([0.ln,0.lj,0.15,0.86]);1N;1R"dz":I=E([0.6,-0.28,0.li,0.eN]);1N;1R"dn":I=E([0.eL,0.ld,0.32,1.lf]);1N;1R"lh":I=E([0.68,-0.55,0.hh,1.55]);1N;2H:G=G.5j(/\\s/g,"");if(G.4B(/^5V-5U\\((?:-?[0-9\\.]{0,}[0-9]{1,},){3}(?:-?[0-9\\.]{0,}[0-9]{1,})\\)$/)){I=G.5j(/^5V-5U\\s*\\(|\\)$/g,"").8l(",");1s(H=I.1r-1;H>=0;H--){I[H]=3q(I[H])}}}18 E(I)},9T:17(S){1a G=0,R=0,O=0,T=0,Q=0,M=0,N=14.1t.3R;17 L(U){18((G*U+R)*U+O)*U}17 K(U){18((T*U+Q)*U+M)*U}17 I(U){18(3*G*U+2*R)*U+O}17 P(U){18 1/(5K*U)}17 H(U,V){18 K(J(U,V))}17 J(ab,ac){1a aa,Z,Y,V,U,X;17 W(ad){if(ad>=0){18 ad}1b{18 0-ad}}1s(Y=ab,X=0;X<8;X++){V=L(Y)-ab;if(W(V)<ac){18 Y}U=I(Y);if(W(U)<0.kp){1N}Y=Y-V/U}aa=0;Z=1;Y=ab;if(Y<aa){18 aa}if(Y>Z){18 Z}4W(aa<Z){V=L(Y);if(W(V-ab)<ac){18 Y}if(ab>V){aa=Y}1b{Z=Y}Y=(Z-aa)*0.5+aa}18 Y}O=3*14.5W[0];R=3*(14.5W[2]-14.5W[0])-O;G=1-O-R;M=3*14.5W[1];Q=3*(14.5W[3]-14.5W[1])-M;T=1-M-Q;18 H(S,P(N))}});F.4y.9w={97:"97",kn:"eU",kk:"eT",kh:"eQ",kW:"eR",kE:"fc",lP:"dt",mu:"ds",m5:"dv",lZ:"dz",lV:"dn",dy:17(H,G){G=G||[];18 1g.4Q(2,10*--H)*1g.fE(20*H*1g.3F*(G[0]||1)/3)},m9:17(H,G){18 1-F.4y.9w.dy(1-H,G)},dZ:17(I){1s(1a H=0,G=1;1;H+=G,G/=2){if(I>=(7-4*H)/11){18 G*G-1g.4Q((11-6*H-11*I)/4,2)}}},mo:17(G){18 1-F.4y.9w.dZ(1-G)},3X:17(G){18 0}}})(s);(17(F){if(!F){6v"7z 7s 7n"}if(F.dX){18}1a E=F.$;F.dX=1v F.4h(F.4y,{4g:17(G,H){14.bX=G;14.1t=F.1U(14.1t,H);14.6E=1c;14.$4i.4g()},2N:17(K){1a G=/\\%$/,J,I,H=K.1r;14.bD=K;14.aG=1v 6h(H);1s(I=0;I<H;I++){14.aG[I]={};1s(J in K[I]){G.3D(K[I][J][0])&&(14.aG[I][J]=1e);if("4E"===14.1t.1J||"81-4E"===14.1t.1J||"2y-4E"===14.1t.1J){14.bD[I][J].4E()}}}14.$4i.2N({});18 14},7C:17(G){1s(1a H=0;H<14.bX.1r;H++){14.el=F.$(14.bX[H]);14.56=14.bD[H];14.aN=14.aG[H];14.$4i.7C(G)}}})})(s);(17(F){if(!F){6v"7z 7s 7n";18}if(F.bp){18}1a E=F.$;F.bp=17(H,I){1a G=14.8k=F.$1v("2Y",1i,{2F:"6N","z-1S":dR}).2S("gL");F.$(H).1I("5e",17(){G.4b(1k.43)});F.$(H).1I("6J",17(){G.2n()});F.$(H).1I("az",17(N){1a P=20,M=F.$(N).6V(),L=G.2p(),K=F.$(1l).2p(),O=F.$(1l).aF();17 J(S,Q,R){18(R<(S-Q)/2)?R:((R>(S+Q)/2)?(R-Q):(S-Q)/2)}G.33({1O:O.x+J(K.1A,L.1A+2*P,M.x-O.x)+P,1L:O.y+J(K.1F,L.1F+2*P,M.y-O.y)+P})});14.a1(I)};F.bp.27.a1=17(G){14.8k.3o&&14.8k.8y(14.8k.3o);14.8k.2m(1k.bn(G))}})(s);(17(F){if(!F){6v"7z 7s 7n";18}if(F.hd){18}1a E=F.$;F.aw=17(J,I,H,G){14.ay=1i;14.6j=F.$1v("a8",1i,{2F:"6N","z-1S":dR,6e:"64",3u:0.8}).2S(G||"").4b(H||1k.43);14.dQ(J);14.2K(I)};F.aw.27.2K=17(G){14.6j.2K();14.ay=14.52.1d(14).3v(F.bx(G,ha))};F.aw.27.52=17(G){3t(14.ay);14.ay=1i;if(14.6j&&!14.by){14.by=1v s.4y(14.6j,{3R:F.bx(G,8V),5X:17(){14.6j.4Y();5g 14.6j;14.by=1i}.1d(14)}).2N({3u:[14.6j.2k("3u"),0]})}};F.aw.27.dQ=17(G){14.6j.3o&&14.8k.8y(14.6j.3o);14.6j.2m(1k.bn(G))}})(s);(17(F){if(!F){6v"7z 7s 7n"}if(F.cd){18}1a I=F.$,E=1i,M={"5S":1,48:2,5h:3,"17":4,2c:2G},G={"5S":17(P,O,N){if("5S"!=F.1P(O)){if(N||"2c"!=F.1P(O)){18 1c}1b{if(!/^(1e|1c)$/.3D(O)){18 1c}1b{O=O.dN()}}}if(P.4r("3J")&&!I(P["3J"]).3i(O)){18 1c}E=O;18 1e},2c:17(P,O,N){if("2c"!==F.1P(O)){18 1c}1b{if(P.4r("3J")&&!I(P["3J"]).3i(O)){18 1c}1b{E=""+O;18 1e}}},5h:17(Q,P,O){1a N=1c,S=/%$/,R=(F.1P(P)=="2c"&&S.3D(P));if(O&&!"5h"==bz P){18 1c}P=3q(P);if(6C(P)){18 1c}if(6C(Q.7D)){Q.7D=bW.iN}if(6C(Q.cg)){Q.cg=bW.iL}if(Q.4r("3J")&&!I(Q["3J"]).3i(P)){18 1c}if(Q.7D>P||P>Q.cg){18 1c}E=R?(P+"%"):P;18 1e},48:17(Q,O,N){if("2c"===F.1P(O)){3p{O=1l.mi.iO(O)}3y(P){18 1c}}if(F.1P(O)==="48"){E=O;18 1e}1b{18 1c}},"17":17(P,O,N){if(F.1P(O)==="17"){E=O;18 1e}1b{18 1c}}},H=17(S,R,O){1a Q;Q=S.4r("3M")?S.3M:[S];if("48"!=F.1P(Q)){18 1c}1s(1a P=0,N=Q.1r-1;P<=N;P++){if(G[Q[P].1H](Q[P],R,O)){18 1e}}18 1c},K=17(S){1a Q,P,R,N,O;if(S.4r("3M")){N=S.3M.1r;1s(Q=0;Q<N;Q++){1s(P=Q+1;P<N;P++){if(M[S.3M[Q]["1H"]]>M[S.3M[P].1H]){O=S.3M[Q];S.3M[Q]=S.3M[P];S.3M[P]=O}}}}18 S},L=17(Q){1a P;P=Q.4r("3M")?Q.3M:[Q];if("48"!=F.1P(P)){18 1c}1s(1a O=P.1r-1;O>=0;O--){if(!P[O].1H||!M.4r(P[O].1H)){18 1c}if(F.3e(P[O]["3J"])){if("48"!==F.1P(P[O]["3J"])){18 1c}1s(1a N=P[O]["3J"].1r-1;N>=0;N--){if(!G[P[O].1H]({1H:P[O].1H},P[O]["3J"][N],1e)){18 1c}}}}if(Q.4r("2H")&&!H(Q,Q["2H"],1e)){18 1c}18 1e},J=17(N){14.5s={};14.1t={};14.gj(N)};F.1U(J.27,{gj:17(P){1a O,N,Q;1s(O in P){if(!P.4r(O)){5c}N=(O+"").4e().6f();if(!14.5s.4r(N)){14.5s[N]=K(P[O]);if(!L(14.5s[N])){6v"jw gV gY gZ \'"+O+"\' gT in "+P}14.1t[N]=2U}}},2q:17(O,N){O=(O+"").4e().6f();if(F.1P(N)=="2c"){N=N.4e()}if(14.5s.4r(O)){E=N;if(H(14.5s[O],N)){14.1t[O]=E}E=1i}},gf:17(N){N=(N+"").4e().6f();if(14.5s.4r(N)){18 F.3e(14.1t[N])?14.1t[N]:14.5s[N]["2H"]}},7d:17(O){1s(1a N in O){14.2q(N,O[N])}},gS:17(){1a O=F.1U({},14.1t);1s(1a N in O){if(2U===O[N]&&2U!==14.5s[N]["2H"]){O[N]=14.5s[N]["2H"]}}18 O},9q:17(N){I(N.8l(";")).1z(I(17(O){O=O.8l(":");14.2q(O.78().4e(),O.8A(":"))}).1d(14))},ax:17(N){N=(N+"").4e().6f();18 14.5s.4r(N)},h0:17(N){N=(N+"").4e().6f();18 14.ax(N)&&F.3e(14.1t[N])},2n:17(N){N=(N+"").4e().6f();if(14.ax(N)){5g 14.1t[N];5g 14.5s[N]}}});F.cd=J}(s));u.$9o=17(E){1a G=[],F;1s(F in E){if(!E.4r(F)||(F+"").h1(0,2)=="$J"){5c}G.2b(E[F])}18 u.$A(G)};u.9r={4f:2,8S:2,6D:2,8f:2,h9:2,a7:2,h6:2,5e:2,6J:2,az:2,gq:2,gK:2,8L:2,gB:2,hV:2,hW:2,gg:2,hQ:2,bj:2,hL:2,i9:2,2C:1,hZ:1,hI:2,5T:1,7J:1,gl:1,hl:1,7G:1,8H:1};u.hD={1k:1e,7x:1e,"2D":1e,7T:1e};u.75={2O:17(I,H,F){if(u.1P(I)=="48"){k(I).1z(14.2O.6F(14,H,F));18 14}if(!I||!H||u.1P(I)!="2c"||u.1P(H)!="17"){18 14}if(I=="8J"&&u.1f.5E){H.2o(14);18 14}F=1X(F||10);if(!H.$4p){H.$4p=1g.66(1g.7v()*u.67())}1a G=14.2t("9v",{});G[I]||(G[I]={});G[I][F]||(G[I][F]={});G[I]["5p"]||(G[I]["5p"]={});if(G[I][F][H.$4p]){18 14}if(G[I]["5p"][H.$4p]){14.go(I,H)}1a E=14,J=17(K){18 H.2o(E,k(K))};if(u.9r[I]&&!G[I]["17"]){if(u.9r[I]==2){J=17(K){K=u.1U(K||1l.e,{$4V:"1D"});18 H.2o(E,k(K))}}G[I]["17"]=17(K){E.1q(I,K)};14[u.aH](u.7t+I,G[I]["17"],1c)}G[I][F][H.$4p]=J;G[I]["5p"][H.$4p]=F;18 14},1q:17(F,H){3p{H=u.1U(H||{},{1H:F})}3y(G){}if(!F||u.1P(F)!="2c"){18 14}1a E=14.2t("9v",{});E[F]||(E[F]={});E[F]["5p"]||(E[F]["5p"]={});u.$9o(E[F]).1z(17(I){if(I!=E[F]["5p"]&&I!=E[F]["17"]){u.$9o(I).1z(17(J){J(14)},14)}},H);18 14},go:17(H,G){if(!H||!G||u.1P(H)!="2c"||u.1P(G)!="17"){18 14}if(!G.$4p){G.$4p=1g.66(1g.7v()*u.67())}1a F=14.2t("9v",{});F[H]||(F[H]={});F[H]["5p"]||(F[H]["5p"]={});4O=F[H]["5p"][G.$4p];F[H][4O]||(F[H][4O]={});if(4O>=0&&F[H][4O][G.$4p]){5g F[H][4O][G.$4p];5g F[H]["5p"][G.$4p];if(u.$9o(F[H][4O]).1r==0){5g F[H][4O];if(u.9r[H]&&u.$9o(F[H]).1r==0){1a E=14;14[u.9y](u.7t+H,F[H]["17"],1c)}}}18 14},fN:17(G){if(!G||u.1P(G)!="2c"){18 14}1a F=14.2t("9v",{});if(u.9r[G]){1a E=14;14[u.9y](u.7t+G,F[G]["17"],1c)}F[G]={};18 14},ma:17(G,F){1a E=14.2t("9v",{});1s(t in E){if(F&&t!=F){5c}1s(4O in E[t]){if(4O=="5p"||4O=="17"){5c}1s(f in E[t][4O]){k(G).2O(t,E[t][4O][f],4O)}}}18 14},m7:17(H,G){if(1!==H.5a){18 14}1a F=14.2t("6H");if(!F){18 14}1s(1a E in F){if(G&&E!=G){5c}1s(1a I in F[E]){k(H).2O(E,F[E][I])}}18 14},2t:u.3E.2t,3w:u.3E.3w};(17(E){if(!E){6v"7z 7s 7n";18}E.1U=17(M,L){if(!(M 4v 1l.6h)){M=[M]}if(!(L 4v 1l.6h)){L=[L]}1s(1a J=0,G=M.1r;J<G;J++){if(!E.3e(M[J])){5c}1s(1a I=0,K=L.1r;I<K;I++){if(!E.3e(L[I])){5c}1s(1a H in(L[I]||{})){3p{M[J][H]=L[I][H]}3y(F){}}}}18 M[0]};E.dg=17(H,G){17 F(){}F.27=G.27;H.$4i=G.27;H.27=1v F();H.27.4I=H};E.1U([E.3E,1l.bN.3E],{gn:E.3E.2p,2p:17(F,H){1a G,I={1A:0,1F:0};if(H){I=14.gn()}1b{G=14.bH();I.1A=G.1A;I.1F=G.1F}if(F){I.1A+=(1X(14.2k("6c-1O")||0)+1X(14.2k("6c-6q")||0));I.1F+=(1X(14.2k("6c-1L")||0)+((14.2k("4N")!="72")?1X(14.2k("6c-5m")||0):0))}18 I}})})(s);u.3W||(u.3W={});u.3W.g5=(17(){1a E=["8s","7U"],H;17 I(K,J){18 u.$1v("3Q",{1H:"3Q"},{4N:"8r-72"}).2S(H["2D"]).2S(H.1T).2S(H["2D"]+"-gi").2S(H["2D"]+"-gi-"+K).4b(J)}17 F(J,K){K.8g();14.1q(J)}1a G=17(K,J){u.$6I(14);14.1t={"2D":"",bi:"",bk:"",2F:"fv",1T:"ms-3n",kH:"3Q"};H=14.o=14.1t;u.1U(14.o,K);14.7U=I("7U",J);14.8s=I("8s",J);14.8s.1I("4f",17(L){L.2a()}).1I("2L 3A",F.1d(14,"1G"));14.7U.1I("4f",17(L){L.2a()}).1I("2L 3A",F.1d(14,"2B"))};G.27={7M:17(J){j(J&&[J]||E).1z(17(K){14[K].2S(H.bk)},14)},4m:17(J){j(J&&[J]||E).1z(17(K){14[K].4R(H.bk)},14)},52:17(J){j(J&&[J]||E).1z(17(K){14[K].2S(H.bi)},14)},2K:17(J){j(J&&[J]||E).1z(17(K){14[K].4R(H.bi)},14)},2n:17(J){j(J&&[J]||E).1z(17(K){14[K].4Y()},14)},g3:17(J){j(E).1z(17(K){14[K].4R("1Y-"+H.1T);14[K].2S("1Y-"+J)},14);14.o.1T="1Y-"+J}};u.1U(G.27,u.75);18 G})();u.3W||(u.3W={});u.3W.fJ=(17(){1a F="kL",E=17(I,H,G){u.$6I(14);14.7S={};14.o=14.7S;u.1U(14.o,I);14.2f=u.$([]);14.4M=G;14.5B={};14.a0=1c;14.1j=u.$1v("2Y",{"2D":"1Y-2f"});14.1j.4b(H)};E.27={2b:17(G){1a H=j(17(J){1a I=14.2f.1r;14.2f.2b({1S:I,4m:1c,2W:J,1o:u.$1v("2Y",{"2D":"1Y-gm 1Y-gm-"+I})});if(!I){14.5B=14.2f[I];14.92(14.2f[I]);14.2f[I].4m=1e}14.2f[I].1o.1I("4f",j(17(K){K.2a();if(14.2f[I].1S==14.5B.1S){18}14.a0=14.4M();!14.a0&&14.1q("2f-4f",{1J:14.gh(14.2f[I]),fK:14.2f[I].2W})}).1d(14));14.2f[I].1o.4b(14.1j)}).1d(14);14.bj();G.1z(j(17(I){H(I)}).1d(14))},c0:17(G,H){if(14.5B.1S==G[0]){18}14.92(14.gk(G,H))},2K:17(){14.1j.2S("2K")},7g:17(){if(14.5B.1o){14.bJ();14.92(14.2f[0])}},2n:17(){14.2f.1z(17(G){G.1o.4Y()});14.1j.4Y()},bJ:17(){14.5B.4m=1c;14.5B.1o.4R(F)},92:17(G){14.bJ();14.5B=G;G.4m=1e;G.1o.2S(F)},gh:17(G){1a H=14.5B.1S>G.1S?"2B":"1G";14.92(G);18 H},gk:17(G,J){1a K,I=14.2f.1r-1,H=14.5B;1s(1a K=I;K>=0;K--){if(14.2f[K].2W<=G[0]){H=14.2f[K];1N}}if(J){if(14.o.1h-1==G[G.1r-1]){H=14.2f[I]}}18 H},bj:17(){14.a0=1c;14.5B={};14.2f.1z(17(G){G.1o.4Y()});14.2f.1r=0}};u.1U(E.27,u.75);18 E})();u.3W||(u.3W={});u.3W.96=(17(){1a F=8D,E=17(G,H){14.9h="3X";14.1o=u.$1v("2Y",{"2D":"1Y-3x"});if(u.1f.1B&&u.1f.1B<10){14.1o.2m(u.$1v("2Y",{"2D":"1Y-3x-a1"}).2m(u.bu.bn("kq...")))}1b{if(H){14.1o.2m(u.$1v("2Y",{"2D":"1Y-3x-ge"}).2m(u.$1v("2Y",{"2D":"1Y-36-3x"},{"z-1S":lg})))}1b{14.1o.2m(u.$1v("2Y",{"2D":"1Y-3x-ge"}).2m(u.$1v("2Y",{"2D":"1Y-3x-2X 1Y-3x-le"})).2m(u.$1v("2Y",{"2D":"1Y-3x-2X 1Y-3x-ll"})).2m(u.$1v("2Y",{"2D":"1Y-3x-2X 1Y-3x-l5"})).2m(u.$1v("2Y",{"2D":"1Y-3x-2X 1Y-3x-lE"})).2m(u.$1v("2Y",{"2D":"1Y-3x-2X 1Y-3x-lK"})).2m(u.$1v("2Y",{"2D":"1Y-3x-2X 1Y-3x-ly"})).2m(u.$1v("2Y",{"2D":"1Y-3x-2X 1Y-3x-kZ"})).2m(u.$1v("2Y",{"2D":"1Y-3x-2X 1Y-3x-kY"})))}}14.1o.4b(G);14.1o.52()};E.27={2K:17(){if(14.9h==="2K"){18}if(14.1o){14.9h="2K";14.1o.3Z(1);14.1o.2K()}},52:17(G){if(14.9h==="52"){18}if(14.1o){14.9h="52";14.1o.3Z(0);14.1o.52()}},2n:17(){14.1o&&14.1o.4Y()}};18 E})();u.3W||(u.3W={});u.3W.kr=(17(){1a E=17(){1a L=[],G=8D,I=0,J=0,M=1c,K=14;u.$6I(14);17 H(){1a P;if(L.1r==0){K.1q("5n");18}if(!M&&L.1r>0){M=1e;P=L.78();1a O=j([]);O.2b(P.36);if(P.36.5t&&P.36.5t.1r>0){j(P.36.5t).1z(j(17(Q){O.2b(Q)}).1d(14))}O.1z(17(R,Q){J+=1;if(P.7a){if(Q){P.7a=1c}}N(R,!!Q,P.7a,P.4M,17(){M=1c;H()},P.8q)})}}17 F(P,R,O,Q){if(P.1K){P.1K.52(1e)}I++;if(I==J){J=I=0;O();Q()}}17 N(U,T,Q,R,P,O){1a V,W,S=j(U.2j);if(U.2C=="4K"){F(U,T,R,P);18}if(Q){if(u.1f.1B&&u.1f.1B<10){W=j(S).2p();V={3u:[0,1],1L:[W.1F/2,0],1O:[W.1A/2,0],1A:[0,W.1A],1F:[0,W.1F]};14.fA=1v u.4y(S,{3R:G,5X:j(17(Y,X){S.33({6z:"",2F:"",1L:"",1O:"",1A:"",1F:""});T&&(U.2C="4K");F(U,T,Y,X)}).1d(14,R,P),8R:j(17(){S.33({2F:"fC",6z:"64"})}).1d(14)});14.fA.2N(V)}1b{S.1M(g,"7F(0.2, 0.2)");S.1M("2M","3X");S.3Z(0);S.6g;S.3j.6g;S.1I("79",j(17(X){if(X.1Z==S){14.1V(X.1H);14.1M(g,"");14.1M("2M","")}}).1d(S));if(!T&&O){O(U)}S.1M("2M",g+" "+G+"ms 5V-5U(.5,.5,.69,1.9), 3u "+G+"ms 97");S.6g;S.3j.6g;S.1M(g,"7F(1.0, 1.0)");S.3Z(1);T&&(U.2C="4K");F(U,T,R,P)}}1b{S.3Z(1);if(T){U.2C="4K"}1b{O(U)}F(U,T,R,P)}}14.2b=17(Q,P,O,R){L.2b({36:Q,7a:P,4M:O,8q:R});H()}};u.1U(E.27,u.75);18 E})();(17(E){E.ch=17(L,G){1a F=0,K=14,J,H;17 O(P){18 17(Q){(G[P]||E.$F).2o(K,Q,Q.fz);F--;N()}}17 N(){1a P;if(!L.1r){}1b{if(F<(G.6S||3)){J=L.78();P=I(J.1o);if(P){H=1v E.fB(P,{6b:O("6b"),5x:O("5x"),9d:O("9d"),8n:O("8n")});H.fz=J}1b{(G.6b||E.$F).2o(K,{1y:j(J.1o).2p(),2g:P},J);F--;N()}F++}}}17 M(P){1a Q,R;Q=(P&&P 4v ko);if(Q){R=P.3O("2e-4l")||1i;if(R){P.3f("4l",R)}}18(Q&&P.3O("4l"))?P:1i}17 I(P){18 E.1P(J)=="2c"?P:(E.1P(P)=="7T"?M(P.2g):((P.2x=="A"||P.2x.38()=="4w")?M(j(P).7H("65")[0]||P.3o):(P.2x=="65"?M(P):1i)))}14.2b=17(P,Q){L[Q?"ks":"2b"](P);G.bs||N();18 14};14.8H=17(){H.fy();kt--};14.2C=N;G.bs||L.1r&&N()}})(s);1a m,j=u.$,C=j,k=j;1a o;1a p=17(){18"kw$kv ku$"+"fY.0.26".5j("v","")+" ka$"+"c".7X()+((1l.bA$bL&&"2c"==u.1P(1l.bA$bL))?" ke$"+1l.bA$bL.38():"")};17 c(){u.c2(".fW-fV-fT-fU",{4N:"72 !4u","8o-1F":"0 !4u","8o-1A":"0 !4u","6l-1F":"3X !4u","6l-1A":"3X !4u",1A:"fd !4u",1F:"fd !4u",2F:"6N !4u",1L:"-cc !4u",1O:"0 !4u",6z:"64 !4u","-5d-8b":"3X !4u",8b:"3X !4u","-5d-2M":"3X !4u",2M:"3X !4u"},"kf-bj-au")}u.4X={};m={1A:{3M:[{1H:"5h",7D:1},{1H:"2c","3J":["21"]}],"2H":"21"},1F:{3M:[{1H:"5h",7D:1},{1H:"2c","3J":["21"]}],"2H":"21"},1h:{3M:[{1H:"5h",7D:1},{1H:"48"},{1H:"2c","3J":["21","8a"]}],"2H":"21"},4P:{3M:[{1H:"5S"},{1H:"2c","3J":["21"]}],"2H":"21"},2i:{3M:[{1H:"5S"},{1H:"2c","3J":["fv","cj","bm"]}],"2H":"cj"},4t:{1H:"5h","2H":0},9t:{1H:"5h","2H":bS},1n:{3M:[{1H:"2c","3J":["3z","6o","bm"]},{1H:"5S","3J":[1c]}],"2H":"3z"},3S:{1H:"5S","2H":1c},1T:{1H:"2c","3J":["3n","3C"],"2H":"3n"},3I:{3M:[{1H:"5h",7D:0},{1H:"2c","3J":["21"]}],"2H":"21"},6U:{1H:"5S","2H":1e},2v:{1H:"2c","3J":["2r","2s","5H","6k-6i"],"2H":"2r"},ck:{1H:"5S","2H":1c},7Z:{1H:"2c","2H":"5V-5U(.8, 0, .5, 1)"},6B:{1H:"5S","2H":1c},aP:{1H:"5S","2H":1e},cn:{1H:"17","2H":u.$F},co:{1H:"17","2H":u.$F},cE:{1H:"17","2H":u.$F},fO:{1H:"17","2H":u.$F},cD:{1H:"17","2H":u.$F},a4:{1H:"17","2H":u.$F}};1k.6n("4w");1k.6n("34");1a n=17(E){18{1A:((1X(E.2k("6c-1O"))||0)+(1X(E.2k("6c-6q"))||0)),1F:((1X(E.2k("6c-1L"))||0)+(1X(E.2k("6c-5m"))||0))}},i=17(E){18{1A:((1X(E.2k("5L-1O"))||0)+(1X(E.2k("5L-6q"))||0)),1F:((1X(E.2k("5L-1L"))||0)+(1X(E.2k("5L-5m"))||0))}},r=17(E){18{1A:((1X(E.2k("5Z-1O-1A"))||0)+(1X(E.2k("5Z-6q-1A"))||0)),1F:((1X(E.2k("5Z-1L-1A"))||0)+(1X(E.2k("5Z-5m-1A"))||0))}},D=17(E){18{1A:j(E).2k("1A"),1F:j(E).2k("1F")}},v=u.1f.5u,g=u.bf("8b").bl(),b=17(F,G){1a E=1c,H=0;u.$6I(14);14.7S={4o:1e,6x:"5V-5U(.8, 0, .5, 1)",1p:"2r",2y:1c,1K:1c,6T:1c,1T:"3n",3R:8V,1n:1e,3S:1e,3I:"21",6U:1e,6B:1c};14.o=14.7S;u.1U(14.o,G);14.1j=j(F).1M("kj-ki","kg");14.1n={2Z:1c,2V:1c};14.9V();14.b3=j(17(K){1a J={},I=1e;if(37===K.bU||39===K.bU){J.1J=K.bU==39?"1G":"2B";if(!14.o.1n){if("1G"===J.1J){if(14.1n.2V){I=1c}}1b{if(14.1n.2Z){I=1c}}}I&&14.1q("gb",J)}}).1d(14);14.7A="2r";14.1h=j([]);14.4j=j([]);14.6L=j([]);14.5C=j([]);14.6W=j([]);14.1m=0;14.3s=0;14.2z=14.o.3I;14.1C=0;14.l=1i;14.5v=1i;14.2l=1i;14.2I=0;14.7h=0;14.24=0;14.1J="1G";14.4M=u.$F;14.3B=0;14.7b=1c;14.2T=1i;14.8F=0;14.8h=1i;14.d6=14.1m;14.6Y=1c;14.bI=1c;14.bR=1c;14.5Y=1c;14.9U=1i;14.3Y={};14.9B=0;14.8G={1J:"1G",6X:1c};14.9c=1i;14.6S=1v u.ch([],{6S:1,5x:j(17(J,K){1a I=14.1h[K.1S];I.2C="7G";if(I.1K){I.1K.2n();I.1K=1i}I.1o.2S("1Y-fw");14.9K(j(17(M,L){if(M.1S==I.1S){M.2m=1e;if(M.1K){M.1K.2n();M.1K=1i}M.1o.2C="7G";M.1o.2S("1Y-fw")}}).1d(14));H++;if(14.o.3S){if(14.b8()){if(14.o.4o||!14.3Y.51){14.1q("9z");14.1q("bq")}if(!14.2P){14.7p()}!14.3Y.51&&14.1q("5n")}}1b{if(H==14.l&&!14.o.3S){14.5Y=1e;!14.3Y.51&&14.1q("5n")}}14.bK()}).1d(14),6b:(17(L,M){1a K=[],J=14.1h[M.1S],I;if(!J){18}J.1o.2m(J.2j);3p{14.9W(J)}3y(L){}if(!14.bR){3p{14.9n(J)}3y(L){14.bR=1e}}14.bO(J,j(17(){1a N=1e;if(j(["2r","2s"]).3i(14.7A)){if(!14.3Y.51&&!14.o.3S){N=M.1S<14.3B}}14.bT(J,N,14.8q);J.2C="4K";H++;if(14.o.3S){14.dh(H)}1b{if(H==14.l){14.5Y=1e;!14.3Y.51&&14.1q("5n")}}14.bK()}).1d(14))}).1d(14)})};b.27={4I:b,8q:u.$F,9n:u.$F,9W:u.$F,dh:17(E){if(14.b8()){if(14.o.4o||!14.3Y.51){14.1q("9z");14.1q("bq")}if(!14.3Y.51){14.1q("5n")}}},bT:17(I,L,K){1a E,H,G,J=8V,F=I.2j;if(L){if(u.1f.1B&&u.1f.1B<10){E=j(F).2p();H={3u:[0,1],1L:[E.1F/2,0],1O:[E.1A/2,0],1A:[0,E.1A],1F:[0,E.1F]};G=1v u.4y(F,{3R:J,5X:j(17(N,M){F.33({6z:"",2F:"",1L:"",1O:"",1A:"",1F:""});if(I.1K){I.1K.2n();I.1K=1i}}).1d(14),8R:j(17(){F.33({2F:"fC",6z:"64"})}).1d(14)});G.2N(H)}1b{F.1M("2M","3X");F.3Z(0);F.6g;F.3j.6g;F.1I("79",j(17(M){if(M.1Z==F){14.1V(M.1H);14.1M(g,"");14.1M("2M","");if(I.1K){I.1K.2n();I.1K=1i}}}).1d(F));F.1M("2M",g+" "+J+"ms 5V-5U(.5,.5,.69,1.9), 3u "+J+"ms 97");F.6g;F.3j.6g;F.3Z(1);K&&K(I)}}1b{F.3Z(1);if(I.1K){I.1K.2n();I.1K=1i}}I.5t.1r>0&&j(I.5t).1z(j(17(M){if(M){j(M.2j).3Z(1);M.2C="4K";if(M.1K){M.1K.2n();M.1K=1i}}}).1d(14))},bK:17(){1a E=0;14.1h.1z(j(17(F){if(F.2C=="4K"||F.2C=="7G"){E++}if(14.l==E){14.5Y=1e;14.1q("9z")}}).1d(14))},b8:17(){1a E=0,F=0;if(14.5Y){18 1e}1s(;E<14.3B;E++){if(14.1h[14.3G(14.1m+E)].2C=="4K"||14.1h[14.3G(14.1m+E)].2C=="7G"){F+=1}}18 F==14.3B},7c:17(){18 14.1j.3j.2p()[14.1x.1y]},9V:17(){1a E={3n:{1y:"1A",1W:"1O",fD:"1F"},3C:{1y:"1F",1W:"1L",fD:"1A"}};14.1x=E[14.o.1T];if(14.o.3I==0){14.o.3I="21"}if(!14.o.1n||"6o"===14.o.1n){14.1n.2Z=1e}if(u.1f.1B&&u.1f.1B<10){14.1j.1M(14.1x.1W,0)}1b{14.1j.1M(g,"4H(0, 0, 0)")}},9s:17(){14.1j.6g},b4:17(){if(14.5Y||14.bI){18}14.bI=1e;14.1q("9g");14.1h.1z(j(17(E){if(E.2C=="7l"){if(E.1K){E.1K.2n();E.1K=1i}E.5t.1r>0&&j(E.5t).1z(17(F){if(F.1K){F.1K.2n();F.1K=1i}});14.6S.2b({1o:E.2j,1S:E.1S})}}).1d(14));14.5Y=1e},8i:17(F){1a G,I=14.1m,E=j([]),H,J;if(14.5Y){18}if(14.o.3S){F&&(I=(F=="1G")?14.3G(I+14.3B):14.3G(I-14.3B));J=j(17(K){if(K.2C=="7l"){if(14.o.4o){!F&&14.1q("9g")}1b{K.1K&&K.1K.2K()}K.2C="2C";14.6S.2b({1o:K.2j,1S:K.1S})}}).1d(14);1s(G=0;G<14.3B;G++){H=14.1h[14.3G(I+G)];J(H);if(!F){J(14.1h[14.3G(H.1S+14.3B)]);J(14.1h[14.3G(H.1S-14.3B)])}}}},di:17(J){1a K,F,H,G,E=0,I=14.9U.1r;if(J=="2B"){E=I-1;I=-1}if(!14.5Y){4W(E!=I){G=14.9U[E];K=G.5z();F=G.3O("2e-36");if(K[14.1x.1W]+14.1h[0].1y[14.1x.1y]>14.9B[14.1x.1W]&&K[14.1x.1W]<14.9B[14.1x.1W]+14.24){H=14.1h[F];if(H.2C=="7l"){H.2C="2C";H.1K&&H.1K.2K();j(H.5t).1z(j(17(L){L.1K&&L.1K.2K()}).1d(14));14.6S.2b({1o:H.2j,1S:H.1S})}}J=="1G"?E++:E--}}},83:17(I){1a F,E,H,G;if(14.3Y.8c){18}14.3Y.8c=1e;E=14.l=14.1h.1r;14.24=14.7c();H=j(14.1j.3j).5z();1s(F=0;F<14.l;F++){G=14.1h[F];G.1y=G.1o.2p(1e);14.2I+=G.1y[14.1x.1y]}14.40()},am:17(F){14.3Y.51=1e;14.9X();if(!u.1f.1B||u.1f.1B&&u.1f.1B>9){if(14.o.6U){14.7y()}}14.8d();if((!u.1f.1B||u.1f.1B&&u.1f.1B>9)&&"2r"===14.o.1p&&14.o.4P){14.7B()}if(j(["2r","2s"]).3i(14.7A)){1s(1a E=0;E<14.1h.1r;E++){if(E>=14.3B){14.1h[E].1K&&14.1h[E].1K.2K()}}}14.1m=0;14.3s=14.4j.1r;j(1l).1I("5T",14.40.1d(14));if(14.o.6B){j(1k).1I("8L",14.b3)}14.40();F&&F()},8d:17(){14.1h.1z(j(17(E){E.2j.fi=j(17(){14.1q("2K-14",{1S:E.1S})}).1d(14);E.2j.1I("4f",j(17(F){if(14.2P){F.2a()}}).1d(14))}).1d(14))},9X:17(G){1a E,F=0;if(14.7b){18}if(14.o.2y){14.2z=14.3B;18}1s(E=0;E<14.l;E++){F+=14.1h[E].1y[14.1x.1y];if(F>=14.24){if(14.2z=="21"||14.2z>=E){if(14.o.1p=="2s"&&F-14.1h[E].1y[14.1x.1y]+5<14.24||F==14.24){E+=1}14.2z=E;if(14.o.3I!="21"&&14.o.3I<14.2z){14.2z=14.o.3I}}1N}}!14.2z&&(14.2z=1)},cR:17(F){1a E=F.6t();4w=1k.6n("4w"),34=1k.6n("34");u.$A(F.3o.2h).1z(j(17(G){if(G.2x.38()=="34"){u.$A(G.2h).1z(j(17(H){j(34).2m(H.6t(1e))}).1d(14));u.$A(G.fI).1z(j(17(H){4w.3f(H,H.ao)}).1d(14));4w.2m(34)}1b{j(4w).2m(G.6t(1e))}}).1d(14));u.$A(F.3o.fI).1z(j(17(G){4w.3f(G,G.ao)}).1d(14));E.2m(4w);18 E},9K:17(E){if(14.4j.1r>0){j([14.4j,14.6L]).1z(j(17(F){F.1z(j(17(H,G){E(H,G)}).1d(14))}).1d(14))}},bO:17(F,G){if(14.4j.1r>0){1a E=j(17(){1a H;if(u.1f.1B&&u.1f.1B<9&&F.1o.3o.2x.38()=="4w"){H=14.cR(F.2j.6t(1e))}1b{H=F.2j.6t(1e)}H.2h&&u.$A(H.2h).1z(j(17(I){if(j(I).8W&&j(I).8W("4U-1K-lQ")){I.4Y()}}).1d(14));18 H}).1d(14);14.9K(j(17(I,H){if(I.1S==F.1S&&!I.2m){I.2j=E();14.1h[F.1S].5t.2b(I);I.2m=1e;I.1o.2m(I.2j)}}).1d(14))}G&&G()},cO:17(){1a E,F=0,I=0,K=0,H={1O:0,1L:0},J,G;if(14.7b){18}1s(E=0;E<14.l;E++){F+=14.1h[E].1y[14.1x.1y];K++;if(14.24<=F){1N}}if(14.l>1&&(K>14.3B||14.4j.1r==0)){I=14.4j.1r;1s(E=I;E<K;E++){J={1o:14.1h[14.l-1-E].1o.6t(),2C:"7l",2m:1c};j(J.1o).3f("2e-36",14.l-1-E);J.1S=14.1h[14.l-1-E].1S;if(14.o.3S&&14.o.1K){J.1K=1v u.3W.96(J.1o);J.1K.2K()}14.4j.2b(J);G={1o:14.1h[E].1o.6t(),2C:"7l",2m:1c};j(G.1o).3f("2e-36",E);G.1S=14.1h[E].1S;if(14.o.3S&&14.o.1K){G.1K=1v u.3W.96(G.1o);G.1K.2K()}14.6L.2b(G);j([G.1o,J.1o]).1z(j(17(L){L.1I("4f",j(17(M){if(14.2P){M.2a()}}).1d(14))}).1d(14));14.1j.2m(G.1o);14.1j.2m(J.1o,"1L");j([14.1h[14.l-1-E],14.1h[E]]).1z(j(17(L){if(L.2C=="4K"){14.bO(L,j(17(){1a M=1e;if(j(["2r","2s"]).3i(14.7A)){if(!14.3Y.51&&!14.o.3S){M=L.1S<14.3B}}14.bT(L,M);L.5t.1r>0&&j(L.5t).1z(17(N){if(N.1K){N.1K.2n();N.1K=1i}})}).1d(14))}}).1d(14))}if(I){14.3B+=K-I}1b{14.3B=K}}1b{14.3B=K}14.7h=14.1C=0;F=0;1s(E=0;E<14.4j.1r;E++){F+=14.1h[14.l-1-E].1y[14.1x.1y]}14.7h+=F;14.1C-=F;H[14.1x.1W]=14.1C;if(u.1f.1B&&u.1f.1B<10){14.1j.1M(14.1x.1W,H[14.1x.1W])}1b{14.9D()}},2b:17(E){14.l=14.1h.1r;E.1S=14.l;E.2C="7l";E.5t=[];if("8E"===u.1f.7w){E.2j.1I("41",17(F){F.bQ()})}if(14.o.1K&&14.o.3S){E.1K=1v u.3W.96(E.1o,1e);if(!14.o.4o){E.1K.2K()}}E.1o.3f("2e-36",E.1S);E.1o.1I("5e 6J",j(17(G){1a F=G.as();4W(F&&F!==E.1o){F=F.3j}if(F==E.1o){18}if("5e"===G.1H){14.1q("3U-36-ga",{aq:E.1S})}1b{14.1q("3U-36-ap",{aq:E.1S})}}).1d(14));14.1h.2b(E)},3G:17(E){E%=14.l;E<0&&(E=E+14.l);18 E},2W:17(F,G){1a E;if(F=="1G"||F=="2B"){14.1J=F}if(14.2P||14.6Y){18}14.2P=1e;if(u.1P(F)=="7T"){14.1J=F.1J;F.6X=1c;F.87=1c}1b{if(/1G|2B|^\\+|^\\-/.3D(F)){if(/^\\+|^\\-/.3D(F)){E=/^\\+/.3D(F)?"1G":"2B";F={6m:1g.1E(1X(F)),1J:E};F.6m>14.l&&(F.6m=14.l);F.1Z=14.3G(F.1J=="1G"?(14.1m+F.6m):(14.1m-F.6m))}1b{F={1J:F};F.1Z=14.3G(F.1J=="1G"?(14.1m+14.2z):(14.1m-14.2z))}F.6X=1c;F.87=1e}1b{if(u.1P(1X(F))=="5h"){F={1Z:14.3G(F),6X:1e,87:1c}}}}F.4M=G;if(!14.o.1n){if(14.1n.2Z||14.1n.2V){if(14.1n.2Z){if("2B"===F.1J){14.2P=1c;G(1i,1e);18}}1b{if("1G"===F.1J){14.2P=1c;G(1i,1e);18}}}}14["kU"+14.7A](F)},5M:17(H,F){1a G={1O:0,1L:0},I=1c,E=F||14.1C;if(H=="1G"){if(E+14.7h-14.2l+14.2I<0){14.1C=E+14.2I;G[14.1x.1W]=14.1C;I=1e}}1b{if(E+14.2l>0){14.1C=E-14.2I;G[14.1x.1W]=14.1C;I=1e}}if(I){if(u.1f.1B&&u.1f.1B<10){14.1j.1M(14.1x.1W,G[14.1x.1W]+"2J")}1b{14.1j.1M(g,"4H("+G.1O+"2J, "+G.1L+"2J, 0)");14.1j.1M("2M",g+" 9G "+14.o.6x);14.9s();if(14.o.1p=="2s"){14.8N=14.3s=14.6K();if(H=="1G"){14.3s+=14.2z}1b{14.3s-=14.2z}}}}18 I},6M:17(H,G){1a F,E=1e;if(!G){if(14.o.3I=="21"){14.2z="21";14.9X(H=="2B")}E=1c;G=14.2z}1b{14.o.4o=1c}1s(F=G;F>0;F--){14.1m=14.3G((H=="1G")?(14.1m+1):(14.1m-1));14.3s=(H=="1G")?(14.3s+1):(14.3s-1);14.2l+=14.1h[(H=="1G")?14.3G(14.1m-1):14.1m].1y[14.1x.1y]}if("3z"===14.o.1n){if(!14.o.2y){14.1q("3U-2N-1p",{4d:14.5l()})}}1b{if("2r"===14.o.1p&&14.1n.2V&&H=="2B"){if(E){14.1m-=(14.7k-1)}1b{14.1m-=(G-1)}if(14.1m<0){14.1m=0}}14.1q("4m");if(14.1n.2V&&H=="1G"){14.1n.2V=1c;14.1n.2Z=1e;14.1C=0;14.2l=0;14.1m=0;14.3s=0;14.1q("5f-3g");14.1q("3U-2N-1p",{4d:14.5l()})}1b{if(14.1n.2Z&&H=="2B"){14.1n.2Z=1c;14.1n.2V=1e;14.2l=0;14.1m=14.l-1;if(14.o.1p=="2r"){14.3s=14.l-14.7k;14.1C=(14.2I-14.24)*(-1)}1b{14.3s=14.l-14.l%14.7k;14.1C=(1g.9a(14.l/14.2z)-1)*14.24*(-1)}14.1q("1m-3g");14.1q("3U-2N-1p",{4d:14.5l(1e)})}1b{14.1n.2V=1c;14.1n.2Z=1c;if(H=="1G"){if(14.1C-14.2l<=14.24-14.2I||14.1C-14.2l+1<=14.24-14.2I){14.1q("1m-3g");if(14.o.1p=="2r"||14.o.1p=="2s"&&"3z"===14.o.1n){14.2l=14.1C-(14.24-14.2I)}1b{14.2l=14.24}14.1n.2V=1e;14.1m=14.l-1;14.1q("3U-2N-1p",{4d:14.5l(1e)})}1b{14.1q("3U-2N-1p",{4d:14.5l()})}}1b{if(14.1C+14.2l>=0||14.1C+14.2l===-1){14.1q("5f-3g");14.2l=1g.1E(14.1C);14.1n.2Z=1e;14.3s=0;14.1m=0;14.1q("3U-2N-1p",{4d:14.5l()})}1b{14.1q("3U-2N-1p",{4d:14.5l()})}}}}}},fH:17(I){1a E,G,F=0,H;if(!I.1J){F=1g.66(14.3B/2);if(14.3B%2==0){F-=1}F<0&&(F=0)}if("3z"===14.o.1n){I.1Z=14.3G(I.1Z-F)}if(14.1m!=I.1Z){14.o.4o=1c;H=j(17(M){1a K=14.1m,L=0,J;do{L++;!M?K++:K--;J=14.3G(K)}4W(J!=I.1Z);18 L}).1d(14);if(!I.1J){if("3z"===14.o.1n){I.1J=H()<=H(1e)?"1G":"2B"}1b{I.1J=I.1Z>14.1m?"1G":"2B"}}14.1q("4m");if("3z"===14.o.1n){4W(14.1m!=I.1Z){14.1m=14.3G(I.1J=="1G"?++14.1m:--14.1m);14.3s=I.1J=="1G"?++14.3s:--14.3s;14.2l+=14.1h[14.1m].1y[14.1x.1y]}}1b{14.1n.2V=1c;14.1n.2Z=1c;14.1m=I.1Z;G=0;1s(E=0;E<I.1Z-F;E++){G+=14.1h[E].1y[14.1x.1y]}14.3s=I.1Z;14.1C=0-14.7h-G;if(14.o.1p=="2r"&&14.1C<=0-(14.2I-14.24)||14.1C<=0-((14.2I+(14.l%14.2z)*14.1h[0].1y[14.1x.1y])-14.24)){if(14.o.1p=="2r"){14.1C=0-(14.2I-14.24)}14.1n.2V=1e;14.1q("1m-3g");14.1m=14.l-1}if(14.1C>=0){14.1C=0;14.1q("5f-3g");14.1n.2Z=1e;14.1m=0}}}1b{14.2P=1c;14.6Y=1c;14.1q("g9")}},fj:17(H){1a E=14.1C,F=1c,G;14.8N=14.3s;14.2l=0;if((!14.o.1n||"6o"===14.o.1n)&&14.o.1p=="2s"){if(14.1n.2V&&H.1J=="1G"||14.1n.2Z&&H.1J=="2B"){F=1e}}if(H.87){14.6M(H.1J,H.6m)}1b{14.fH(H)}if(F){H.1J=H.1J=="1G"?"2B":"1G"}if(0!==14.8F){G=14.1h[14.d6].1y[14.1x.1y]-14.8F;if(H.1J=="1G"){14.2l-=G}1b{14.2l+=G}14.8F=0}"3z"===14.o.1n&&14.5M(H.1J);if(H.1J=="1G"){14.1C-=14.2l}1b{14.1C+=14.2l}14.8G.1J=H.1J;14.8G.6X=H.6X;if(E!=14.1C){14.4M=H.4M;if(14.o.4o&&!14.5Y&&!14.b8()){14.1q("9g");14.8i();14.2O("bq",j(17(I){14.2P&&14.71(1i,I.1J,I.6X)}).1d(14,14.8G))}1b{if(!14.5Y){14.8i()}14.71(1i,H.1J,H.6X)}}1b{14.1q("g2")}},71:17(F,E,H){1a G={1O:0,1L:0};14.2P=1e;if(u.1f.1B&&u.1f.1B<10){G={};G[14.1x.1W]=[1X(14.1j.2k(14.1x.1W)),14.1C];14.fx=1v u.4y(14.1j,{2M:14.o.6x,3R:F||14.o.3R,5X:14.76.1d(14),8R:j(17(){14.fu=1c}).1d(14)}).2N(G)}1b{G[14.1x.1W]=14.1C;if(14.o.1p=="2s"&&!H){14.fG(E,G)}1b{14.1j.1V("79");14.1j.1I("79",j(17(I){if(I.1Z==14.1j){14.1j.1V(I.1H);if(H){14.3s=14.6K();14.d0()}14.76()}}).1d(14));14.1j.1M(g,"4H("+G.1O+"2J, "+G.1L+"2J, 0)");14.1j.1M("2M",g+" "+(F||14.o.3R)+"ms "+14.o.6x)}}},fG:17(K,J){1a I,F,H,G=14.1j.2h,E=G.1r,L=j(17(M){M%=14.5v;M<0&&(M=M+14.5v);18 M}).1d(14);14.5C.1r=0;14.6W.1r=0;1s(I=0;I<14.2z;I++){if("3z"===14.o.1n){F=L(14.8N+I)}1b{F=14.8N+I<E?14.8N+I:1i}F!=1i&&14.5C.2b(G[F]);if("3z"===14.o.1n){H=L(14.3s+I)}1b{H=14.3s+I<E?14.3s+I:1i}H!=1i&&14.6W.2b(G[H])}if(K=="2B"){14.5C.4E();14.6W.4E()}14.1j.3f("2e-"+K,"");14.5C.1z(j(17(N,M){N.1I(v+"8T 8O",j(17(O,P,Q){if(O==14.5C[P]){O.1V(v+"8T 8O").3f("2e-cQ","");if(P==14.5C.1r-1){14.5C.1z(j(17(S,R){S.3P("2e-2s-8U");S.3P("2e-9u")}).1d(14));14.6W.1z(j(17(S,R){if(R==14.6W.1r-1){S.1I(v+"8T 8O",j(17(T){if(T.1Z==S){S.1V(v+"8T 8O");14.6W.1z(j(17(U,V){U.3P("2e-2s-8U");U.3P("2e-9u")}).1d(14));14.5C.1z(j(17(U,V){U.3P("2e-cQ")}).1d(14));14.1j.3P("2e-"+K);14.9s();14.76()}}).1d(14))}S.3f("2e-cU","");S.1I(v+"8X 8M",j(17(T){if(T.1Z==14){14.1V(v+"8X 8M");S.3P("2e-cU")}}).1d(S));S.3f("2e-9u","kD");S.3f("2e-2s-8U",(R+1))}).1d(14));14.1j.1M(g,"4H("+J.1O+"2J, "+J.1L+"2J, 0)")}}}).1d(14,N,M))}).1d(14));14.5C.1z(j(17(N,M){N.3f("2e-dk","");N.1I(v+"8X 8M",j(17(O){if(O.1Z==14){N.1V(v+"8X 8M");14.3P("2e-dk")}}).1d(N));N.3f("2e-9u","kA");N.3f("2e-2s-8U",(M+1))}).1d(14))},5l:17(H){1a I=0,G=14.2z,E=[],F;if(H){if(14.o.1p=="2r"){I=14.l-14.2z}1b{I=14.l%14.2z?14.l-14.l%14.2z:14.l-14.2z}G=14.l}1s(;I<G;I++){if(!H){F=14.1m+I}1b{F=I}E.2b(14.3G(F))}18 E},76:17(){14.2P=1c;14.99=1c;14.4M&&14.4M(14.5l(14.1n.2V))},d0:17(){14.1j.1M("2M",g+" 9G")},9J:17(J){1a I={x:0,y:0},G=J.2k(g)||"",H=/3d/.3D(G)?(/kK\\(([^\\)]+)\\)/):(/kJ\\(([^\\)]+)\\)/),F=/3d/.3D(G)?12:4,E=/3d/.3D(G)?13:5;(J.2k(g)||"").5j(H,17(M,L){1a K=L.8l(",");I.x+=1X(K[F],10);I.y+=1X(K[E])});18 I},6K:17(){1a H;1a G;1a E;1a F=bW.kI;1a I=14.1j.3j.5z()[14.1x.1W];1s(H=0;H<14.5v;H++){G=14.1j.2h[H].5z()[14.1x.1W];if(F>1g.1E(I-G)){F=1g.1E(I-G);E=H}1b{1N}}18 E},7p:17(){if(14.4j.1r==0){18}1a F,E,G=j(17(I,J){1a K,H;if(14.1h[J].1o!=I&&14.1h[J].2C=="4K"){1s(H=0;H<14.5v;H++){if(14.1h[J].1o==14.1j.2h[H]){K=H;1N}}if(K<E){14.1j.7i(I,14.1j.2h[K]);if(E+1<=14.5v-1){14.1j.7i(14.1h[J].1o,14.1j.2h[E+1])}1b{14.1j.9l(14.1h[J].1o)}}1b{14.1j.7i(14.1h[J].1o,I);if(K+1<=14.5v-1){14.1j.7i(I,14.1j.2h[K+1])}1b{14.1j.9l(I)}}}}).1d(14);E=14.6K();1s(F=0;F<14.3B;F++){G(14.1j.2h[E],14.3G(14.1m+F));E++}},9A:17(M){1a K,I,J,P=0,F=0,O,L=14.1j.3j.5z()[14.1x.1W]+1,H=14.1j.5z()[14.1x.1W]-L,N=1g.1E(1g.1E(H)-1g.1E(14.1C)),G,E=j(17(Q){18 1X(14.1j.2h[Q].3O("2e-36"))}).1d(14);(N>0&&N<1)&&(N=0);if(M=="1G"){L+=N}1b{L-=N}1s(K=0;K<14.5v;K++){J=14.1j.2h[K].5z()[14.1x.1W];if(J==L){14.1m=E(K);18 0}O=1X(14.1j.2h[K].2p()[14.1x.1y]);if(J<L&&J+O>L){G=K;if(M=="1G"){G=K+1>14.5v-1?14.5v-1:K+1;K++}1s(I=0;I<K;I++){F+=14.1h[E(I)].1y[14.1x.1y]}P=1g.1E(1g.1E(14.1C)-F);14.1m=E(G);1N}}18 P},7y:17(){1a ae,K,ac,U,ad,J,F=(14.1x.1W=="1O")?"x":"y",L={x:0,y:0},S=14.o.1p=="2r",V,X=1e,O={x:0,y:0},H=1c,W=1c,M=1i,Q=0,Y=1i,R=1c,G=j(17(ah){1a ag,af=0;if(ah>14.24){ah=14.24}1s(ag=1.5;ag<=90;ag+=1.5){af+=(ah*1g.fE(ag/1g.3F/2))}18 14.24>af?af:14.24}).1d(14),I=j(17(ah){1a ai,af=0,ag,aj;4W(af>14.1C){af-=14.24}if(1g.1E(af-14.1C)>14.24/2){af+=14.24}aj=af;1s(ai=0;ai<14.5v;ai++){ag=1X(14.1j.2h[ai].3O("2e-36"));if(aj==0){14.1m=ag;1N}aj+=14.1h[ag].1y[14.1x.1y]}18 af}).1d(14),aa=j(17(af){W=1e;j(1k.43).2S("1Y-7Q");14.o.4o=1c;X=1e;3t(14.2T);if(14.o.1p=="2s"){14.dj()}14.8P&&14.8P();L={x:0,y:0};F=(14.1x.1W=="1O")?"x":"y";14.1q("5i-2N");14.1j.1V("79");14.1C=14.9J(14.1j)[F];L[F]=14.1C;14.1j.1M(g,"4H("+L.x+"2J, "+L.y+"2J, 0)");14.1j.1M("2M","3X");14.9s();14.o.1p=="2r"&&(S=1e);14.2P=1e}).1d(14),E=j(17(){if(14.o.1p=="2s"){14.1j.1M("2M","3X");14.3s=14.6K()}if(14.o.1p=="2s"){14.1m=1X(14.1j.2h[14.6K()].3O("2e-36"))}if("3z"===14.o.1n){14.7p()}14.2P=1c;14.6Y=1c;S=1c;X=1e;14.8i();14.1q("5i-5D",{4d:14.5l(14.1n.2V)})}).1d(14),T=j(17(ag){j(1k.43).4R("1Y-7Q");if(W){W=1c;1a af=14.1C;if(!X){ag.fF=1c;P();K=ag.3b-ae;if(14.o.1p=="2r"){if(K>5K){J=ad;S=1c}1b{J=G(1g.1E(O[F]-ag[F]))}ad=J;if("3z"===14.o.1n){14.2l=1g.1E(ad);14.5M(ac)}if("3z"===14.o.1n||14.1C<=0){if(1g.1E(14.1C)<ad){ad=1g.1E(14.1C)}14.1C-=ad}ac=="1G"?14.1C-=14.9A(ac):14.1C+=14.9A(ac);if(!14.o.1n||"6o"===14.o.1n){14.1q("4m");14.1n.2Z=1c;14.1n.2V=1c;if(14.1C>0){14.1C=0;14.1m=0;S=1e;14.1q("5f-3g");14.1n.2Z=1e}if(14.1C<14.24-14.2I){14.1C=14.24-14.2I;14.1m=14.l-1;S=1e;14.1q("1m-3g");14.1n.2V=1e}}V=S?bS:8D}1b{S=1e;14.2l=0;14.1C=I();"3z"===14.o.1n&&14.5M(ac);if(K<5K){14.2l=14.24;"3z"===14.o.1n&&14.5M(ac);if(ac=="1G"){14.1C-=14.24}1b{14.1C+=14.24}}if(!14.o.1n||"6o"===14.o.1n){14.1q("4m");14.1n.2Z=1c;14.1n.2V=1c;if(14.1C>=0){14.1C=0;14.1m=0;14.1n.2Z=1e;14.1q("5f-3g")}if(14.1C<=(1g.9a(14.l/14.2z)-1)*14.24*(-1)){14.1C=(1g.9a(14.l/14.2z)-1)*14.24*(-1);14.1m=14.l-1;14.1n.2V=1e;14.1q("1m-3g")}}V=8V}L[F]=14.1C;14.1j.1I("79",j(17(ah){if(ah.1Z==14.1j){E()}}).1d(14));if(af==14.1C){14.2P=1c;S=1c;X=1e}14.1j.1M("2M",g+" "+V+"ms 5V-5U(.22,.63,.49,.8)");14.1j.1M(g,"4H("+L.x+"2J, "+L.y+"2J, 0)")}1b{if(!u.1f.7E){E()}1b{14.2P=1c}}}}).1d(14),N=0,P=j(17(){3t(Y);Y=1i;R=1c;N=0}).1d(14),ab=j(17(){1a af=N*0.2;if(1g.1E(af)<0.mz){P();18}N-=af;14.1C-=af;L[F]=14.1C;14.1j.1M(g,"4H("+L.x+"2J, "+L.y+"2J, 0)");Y=5o(ab,16)}).1d(14),Z=j(17(ag){if(W){1a af=ag[F]-Q>0?"2B":"1G";X=1c;if("3z"===14.o.1n){14.2l=1g.1E(ad);14.5M(af)}if(u.1f.1B){N+=ad;if(!R){R=1e;ab()}}1b{14.1j.1M("2M",g+" 9G");if(14.o.1p=="2s"){}14.1C-=ad;L[F]=14.1C;14.1j.1M(g,"4H("+L.x+"2J, "+L.y+"2J, 0)")}14.di(af)}}).1d(14);14.9c=j(17(af){if(14.7b||14.o.1p=="2s"&&S){18}if("41"==af.4T){ae=af.3b;O.x=af.x;O.y=af.y;Q=af[F]}1b{ac=(ad>0)?"1G":"2B";ad=Q-af[F];14.8G.1J=ac;if("9x"==af.4T){if(H){H=1c;T(af)}}1b{if(14.o.1T=="3C"||1g.1E(af.x-O.x)>1g.1E(af.y-O.y)){af.4x();if(!H){if(14.o.1p=="2s"&&14.2P){18}H=1e;aa(af)}1b{Z(af)}}}}Q=af[F]}).1d(14);if(!u.1f.1B||u.1f.1B&&u.1f.1B>9){14.1j.3j.1I("2E 2u",14.9c)}},7B:17(){1a I,J,F=0,H={x:0,y:0},G=(14.1x.1W=="1O")?"x":"y",E=j(17(L){1a K=F*(L||0.2);I=K>0?"1G":"2B";F-=K;if(1g.1E(K)<0.9M){3t(14.2T);14.1m=1X(14.1j.2h[14.6K()].3O("2e-36"));14.7p();14.8F=14.cS();14.d6=14.1m;F=0;14.2l=0;14.2T=1i;14.6Y=1c;14.2P=1c;14.1q("5i-5D",{4d:14.5l(14.1n.2V)});18}14.2l=1g.1E(K);"3z"===14.o.1n&&14.5M(I);14.1C-=K;14.2l=0;14.di(I);if(!14.o.1n||"6o"===14.o.1n){if(14.1C>0){14.1C=0;F=0.9M;14.1q("5f-3g")}1b{if(14.1C<14.24-14.2I){14.1C=14.24-14.2I;F=0.9M;14.1q("1m-3g")}1b{14.1q("4m")}}}H[G]=14.1C;14.1j.1M(g,"4H("+H.x+"2J, "+H.y+"2J, 0)");14.2T=5o(E.1d(14,L),30)}).1d(14);if(u.1f.1B&&u.1f.1B<10||14.7b){18}14.8P=j(17(){if(14.6Y){3t(14.2T);F=0;14.2l=0;14.2T=1i;14.6Y=1c;14.2P=1c}}).1d(14);14.1j.1I("4z",j(17(K){1a L=(1g.1E(K.3K)<1g.1E(K.3L)?K.3L:K.3K*(!K.4Z?-1:-30));if(14.2P){18}if((1e===14.o.4P&&K.4Z)||"3C"===14.o.1T&&1g.1E(K.3K)>1g.1E(K.3L)||"3n"===14.o.1T&&1g.1E(K.3K)<1g.1E(K.3L)){K.2a();14.6Y=1e;if(0===F){14.1j.1M("2M",g+" 9G");H={x:0,y:0};G=(14.1x.1W=="1O")?"x":"y"}14.1q("5i-2N");F+=L;if(!14.2T){E(0.4)}}}).1d(14))},cS:17(){1a F,E,G=14.1C,H=j(["8h","1h","6L"]);14.8h=[];14.4j.1z(j(17(I){14.8h.2b(I)}).1d(14));14.8h.4E();1s(F=0;F<H.1r;F++){1s(E=0;E<14[H[F]].1r;E++){G+=14.1h[14[H[F]][E].1S].1y[14.1x.1y];if(G>0){14.1m=14[H[F]][E].1S;14.8h=1i;18 G}}}},5y:17(){1a E,F;if(!14.o.2y||14.99||!14.2P||14.o.1p=="2s"){18}14.99=1e;if(u.1f.1B&&u.1f.1B<10){14.fx&&(14.fx.1t.5X=u.$F);14.fx&&14.fx.2a();14.fx=1i;14.1C=1g.5O(1X(14.1j.2k(14.1x.1W)))}1b{14.1C=14.9J(14.1j)[(14.1x.1W=="1O")?"x":"y"]}E=14.9A(14.1J);F=14.o.3R/14.2l*E;if(14.1J=="1G"){14.1C-=E}1b{14.1C+=E}14.71(F)},2a:17(){14.fu=1e;14.2P=1c;14.8P&&14.8P();if(14.o.1p=="2s"){14.dj()}if(u.1f.1B&&u.1f.1B<10){14.fx&&14.fx.2a(1e);14.fx=1i}1b{14.d0()}},dj:17(){1a E={x:0,y:0};if(!u.1f.1B||u.1f.1B&&u.1f.1B>10){E[14.1x.1W]=14.1C;14.1j.3P("2e-1G");14.1j.3P("2e-2B");j([14.5C,14.6W]).1z(j(17(F,G){if(F.1r>0){F.1z(j(17(I,H){I.1V(v+"8X 8M "+v+"8T 8O");I.3P("2e-2s-8U");I.3P("2e-9u");if(!G){I.3P("2e-dk");I.3P("2e-cQ")}1b{I.3P("2e-cU")}}).1d(14))}}).1d(14));14.1j.1M(g,"4H("+E.1O+"2J, "+E.1L+"2J, 0)");14.2P=1c;14.9s()}},40:17(){1a F,G,E,H;14.2a();14.99=1c;14.9B=j(14.1j.3j).5z();14.24=14.7c();14.7k=0;14.2I=0;1s(F=0;F<14.l;F++){14.1h[F].1y=14.1h[F].1o.2p(1e);14.2I+=14.1h[F].1y[14.1x.1y];if(14.2I<=14.24){14.7k+=1}}if(u.1f.1B&&u.1f.1B<10){14.1m=0}1b{14.9D()}14.2l=0;14.2z=14.o.3I;if(14.2I<=14.24){14.7b=1e;14.1q("g6");14.1q("7M");14.7h=0;14.1C=0;if(u.1f.1B&&u.1f.1B<10){14.1j.1M(14.1x.1W,0)}1b{14.1j.1M(g,"4H(d1, d1, 0)")}14.9H()}1b{14.7b=1c;14.1q("g4");14.1q("4m");if(!14.o.1n||"6o"===14.o.1n){if(14.1n.2Z){14.1q("5f-3g")}if(14.1n.2V){14.1q("1m-3g")}}}if((14.2I>14.24)&&("3z"===14.o.1n||14.o.2y)){14.cO()}1b{14.3B=G=0;1s(F=0;F<14.l;F++){G+=14.1h[F].1y[14.1x.1y];14.3B++;if(14.24<=G){1N}}}14.5M("1G");14.1j.1V("79");14.3s=14.6K();14.5v=14.1j.2h.1r;14.9X();14.7p();14.9U=u.$A(14.1j.2h);14.o.3S?14.8i():14.b4()},9D:17(){1a G,I,H={1O:0,1L:0},F=14.1h[14.1m].1o.5z()[14.1x.1W],E=14.1j.3j.5z()[14.1x.1W];if(u.1f.1B&&u.1f.1B<10){}1b{if(!14.o.1n&&14.1n.2V){if("2r"===14.o.1p){H[14.1x.1W]=14.24-14.2I}1b{I=14.7k-14.l%14.7k;H[14.1x.1W]=14.24-(14.2I+14.1h[0].1y[14.1x.1y]*I)}}1b{G=14.9J(14.1j)["1O"===14.1x.1W?"x":"y"];H[14.1x.1W]=G-(F-E)}14.1C=H[14.1x.1W];14.1j.1M(g,"4H("+H.1O+"2J, "+H.1L+"2J, 0)")}},ft:17(F){1a L=0,K=1e,G=14.l-1,H=j(["6L","1h","4j"]),J=j(17(P,N){1a M,O=1i;1s(M=0;M<P.1r;M++){if(P[M].1S==N){O=P[M].1o;1N}}18 O}).1d(14),I=j(17(M){18(L==0)?M-1:(L-1)}).1d(14),E=j(17(P,N){1a O,M=P.1r;if(M>0){1s(O=0;O<M;O++){if(K){K=1c;L=M-1;14.1j.9l(P[L].1o)}1b{14.1j.7i(J(P,!L?G:I(M)),J(!L?14[H[N-1]]:P,L));L=!L?G:L-1}}}}).1d(14);H.1z(j(17(M,N){E(14[M],N);L=0}).1d(14));if(!F){14.1m=0}},9H:17(){14.4j.1z(17(E){E.1o.4Y()});14.4j=j([]);14.6L.1z(17(E){E.1o.4Y()});14.6L=j([])},7g:17(F){1a E={1O:0,1L:0};14.2a();if(F){14.1C=14.1m=0}if(u.1f.1B&&u.1f.1B<10){14.1j.33(E)}1b{if(F){14.1j.1M(g,"4H("+E.1O+"2J, "+E.1L+"2J, 0)")}1b{14.9D()}}14.2z=14.o.3I;if((!14.o.2y&&(!14.o.1n||"6o"===14.o.1n))&&14.4j.1r>0){14.7h=0;14.9H()}14.40();14.ft(!F);if(F){14.1j.3j.1V("2E 2u",14.9c);if(14.o.6U){14.1j.3j.1I("2E 2u",14.9c)}}14.2P=1c},fM:17(E){1s(1a F in E){14.o[F]=E[F]}14.9V()},7o:17(){14.2a();14.9H();j(1l).1V("5T");j(1k).1V("8L");14.1j.1V("2u 2E");14.1h.1z(j(17(E){E.1o.1V("5e 6J");5g E.2j.fi}).1d(14))}};u.1U(b.27,u.75);u.4X.cP=b;1a x=17(E,F){u.4X.cP.5k(14,3m);14.7S={5A:"21",7u:j([0.44,0.59,0.35,0.89]),9Y:m1,6x:"5V-5U(.8, 0, .5, 1)"};14.7A="5H";14.o=14.7S;u.1U(14.o,F);14.2l=70;14.6u=0;14.2w=0;14.2T=1i;14.9C=1g.4Q(10,8);14.2X=2*1g.3F;14.1m=0;14.m4=j([]);14.9L=1i;14.4G=1i;14.6a=1i;14.5A=0;14.l=0;14.db=1i};u.dg(x,u.4X.cP);u.1U(x.27,{4I:x,cO:u.$F,7p:u.$F,5l:u.$F,fj:u.$F,5y:u.$F,cL:u.$F,9K:u.$F,cR:u.$F,8i:u.$F,cS:u.$F,7u:u.1U({},u.4y.27),5M:17(){14.6u%=14.2X;14.2w=14.6u},83:17(G){1a F,E;if(14.3Y.8c){18}14.3Y.8c=1e;E=14.l=14.1h.1r;14.24=14.7c();if(u.1f.1B&&u.1f.1B<10&&14.1h[0].2j.1r&&14.1h[0].2j.9P.2x.38()=="34"){14.db=1X(14.1h[0].2j.9P.2k("m8-1y"))}14.7u.5W=14.o.7u;1s(F=0;F<14.l;F++){14.1h[F].1y=14.1h[F].1o.2p(1e,1e);14.2I+=14.1h[F].1y[14.1x.1y];14.1h[F].1o.1M("2F","6N");14.1h[F].2g=14.dc(14.1h[F])}if("3z"===14.o.1n){14.1q("4m")}14.1h.1z(j(17(H){if(H.34&&!H.7j){if(H.2j.2x.38()!="4w"){H.7j=1e}}}).1d(14));14.40();14.b4()},am:17(E){14.3Y.51=1e;14.8d();14.4G=14.2X/14.l;14.6a=(14.2X-14.4G)*(-1);14.2z=1;14.7y();14.o.4P&&14.7B();j(1l).1I("5T",14.40.1d(14));if(14.o.6B){j(1k).1I("8L",14.b3)}E&&E();14.40()},8d:17(){x.$4i.8d.5k(14);14.1h.1z(j(17(E){E.1o.1I("4f",j(17(F){14.1q("36-4f",{1S:E.1S})}).1d(14))}).1d(14))},8q:17(F){1a E=93;if(u.1f.1B&&u.1f.1B<10||!F.4n){18}F.4n.3Z(1);F.4n.1M("2M","3u "+E+"ms")},9n:17(G){1a E,F,H=j(17(I){if(I.4n||I.7j){E=I.2g.2p(1c,1e);F=I.2g.df+E.1F;if(I.4n){I.4n.33({1L:F,1O:I.2g.fh,1A:E.1A})}if(I.7j&&I.34){I.34.33({1L:F})}}}).1d(14);G?H(G):14.1h.1z(j(17(I){H(I)}).1d(14))},dc:17(G){1a E,F=G.2j;if(F.2x=="65"){E=F}1b{if(F.3o.2x=="65"){E=F.3o}1b{if(F.3o.2x=="cC"&&F.3o.3o.2x=="65"){E=F.3o.3o}1b{E=1i}}}if(E){j(E).1M("z-1S",2G)}18 E},9W:17(R){if(14.o.1T=="3C"){18}1a G=u.$1v("4n",{},{3u:0}),S=u.$1v("4n"),F,E,J,P,O,Q,T=1,M,N,K,H,L,I;if(u.1f.1B&&u.1f.1B<10){18}if(G.9e){F=G.9e("2d");E=S.9e("2d");if(!R.2g){18}O=j(R.2g).2p(1c,1e);Q=O.1F/2G*30;S.1A=O.1A;S.1F=O.1F;E.fg();E.7F(1,-1);E.m6(R.2g,0,O.1F*(-1),O.1A,O.1F);J=E.m0(0,0,O.1A,Q);E.fe();G.1A=O.1A;G.1F=Q;F.fg();N=J.2e;I=N.1r;H=I/4/O.1A;K=14.o.9Y;M=I/H;1s(L=3;L<I;L+=4){if(L>M){M+=(I/H);T++;K=1g.5O(14.o.9Y-14.o.9Y*14.7u.9T(1/(H/T)))}N[L]=K}F.mv(J,0,0);F.fe();R.4n=G;if((!R.2j.2h||R.2j.2h.1r<2)&&R.2j.2x.38()!=="a"){R.1o.9l(G)}1b{R.2j.7i(G,R.2j.2h[1])}G.2S("1Y-lT")}},cZ:17(F){1a G=0,E=14.2l/(14.l/2),H=2G-E;if(F>H){G=(F-H)/E}18 G},5q:17(L){1a I={1O:0,1L:0},G={1O:0,1L:0},S={1O:0,1L:0},M,R,Q=14.l,N=14.2l,E=14.2X/Q,P,H,F,K,J,O;I[14.1x.1W]=14.5A;u.3e(L)||(L=0);14.6u=L;1s(J=0;J<Q;J++){H=F=J*E+L;F%=14.2X;H%=14.2X;if(F!=0&&F!=1g.3F){if(1g.9a(1g.1E(F)/1g.3F)%2==0){if(1g.1E(F)%1g.3F!=0){H=1g.3F-(1g.1E(F)%1g.3F)}}1b{H=1g.1E(F)}}H=1g.1E(H*2G/1g.3F);if(14.1h[J].34){14.1h[J].34.3Z(14.cZ(2G-(H*N/2G)))}H=2G-1g.5O(H*N/2G);!14.9L&&(14.9L=14.1h[J].1y);M=1g.1E(F);if(M>1g.3F/2&&M<1g.3F+1g.3F/2){if(M>1g.3F){M=1g.3F/2-1g.1E(M-1g.3F)}1b{M=M-1g.3F/2}M=(1-1g.6d(M))*0.7}1b{M=1}if(u.1f.1B&&u.1f.1B<10){K={1A:14.d8("1A",H),1F:14.d8("1F",H)};14.1h[J].1o.33(K);14.1h[J].1o.33({1L:1g.6d(F)*I.1L+1X(14.8K.1F)/2-1X(K.1F)/2,1O:1g.6d(F)*I.1O+1X(14.8K.1A)/2-1X(K.1A)/2});if(14.1h[J].2j.1r&&14.1h[J].2j.9P.2x.38()=="34"){14.1h[J].2j.9P.3l.lS=14.ff(H/2G*H)}if(14.1h[J].7j){P=14.1h[J].2g.2p(1c,1e);14.1h[J].34.33({1L:14.1h[J].2g.df+P.1F})}}1b{S[14.1x.1W]=62/14.2X*F;14.o.1T=="3C"&&(S[14.1x.1W]*=(-1));O=1g.1E(F);R=1g.8e(1-1g.6d(O)*1g.6d(O));if(O>1g.3F/2&&O<1g.3F+1g.3F/2){O=14.5A*(R)+14.5A}1b{O=14.5A*(1-R)}O>0&&(O*=(-1));G[14.1x.1W]=(1g.6d(F)*I[14.1x.1W]+1X(14.8K[14.1x.1y])/2-14.1h[J].1y[14.1x.1y]/2);14.1h[J].1o.1M(g,"lR("+G.1O+"2J)lU("+G.1L+"2J)ba("+O+"2J)fr("+S.1L+"b9)fs("+S.1O+"b9)")}14.1h[J].1o.1M("z-1S",0+H);14.1h[J].1o.3Z(M)}},5O:17(E,F){1a G=1g.4Q(10,F||15);18 1g.5O(E*G)/G},6M:17(H){1a F,G,E=62/14.l;if(H.87){if(H.6m){if(H.1J=="1G"&&14.1m>H.1Z){F=14.l-14.1m;F+=H.1Z}1b{if(H.1J=="2B"&&14.1m<H.1Z){F=14.l-H.1Z;F+=14.1m}}!F&&(F=1g.1E(14.1m-H.1Z));14.1m=H.1Z}1b{F=14.2z;14.1m=14.3G(H.1J=="1G"?14.1m+F:14.1m-F)}}1b{G=(62-14.1m*E+H.1Z*E)%62;if(G>=0&&G<=d7){!H.1J&&(H.1J="1G")}1b{if(G>=d7&&G<=62){!H.1J&&(H.1J="2B")}}if(H.1J=="1G"){F=1g.5O(G/E)}1b{F=1g.5O((62-G)/E)}14.1m=H.1Z}18 u.1U(H,{4G:F*14.4G})},fk:17(F){1a E;F=14.6M(F);E=F.4G;if(!14.o.1n){14.1q("4m")}if(F.1J=="1G"){14.2w-=E;if(!14.o.1n){if(14.2w==14.6a){14.1q("1m-3g")}1b{if(14.2w<14.6a){14.1m=0;14.2w=0;14.1q("5f-3g")}}}}1b{14.2w+=E;if(!14.o.1n){if(14.2w==0){14.1q("5f-3g")}1b{if(14.2w>0){14.1m=14.l-1;14.2w=14.6a;14.1q("1m-3g")}}}}14.1q("3U-2N-1p",{4d:[14.1m]});14.4M=F.4M;14.71(14.2w)},d8:17(E,F){18 14.9L[E]/2G*F},ff:17(E){18 1g.5O(14.db/2G*E)+"2J"},71:17(E){14.fx=1v u.4y(14.1j,{3R:14.o.3R,2M:14.o.6x,aU:(17(F){14.5q(F.4G/14.9C)}).1d(14),5X:j(17(){14.76()}).1d(14)}).2N({4G:[14.9C*14.6u,14.9C*E]})},76:17(){14.5M();x.$4i.76.5k(14)},74:17(F){1a E=1g.1E(14.2w-14.6u)*(F||0.2);if(1g.1E(E)<0.9M){3t(14.2T);14.2T=1i;14.2P=1c;14.1q("5i-5D",{4d:[14.1m]});18}if(14.2w<14.6u){E*=(-1)}14.5q(14.6u+E);14.2T=5o(14.74.1d(14,F),30)},7R:17(){1a G,H=14.2w%14.2X,F=1X(1g.1E(14.2w/14.2X)),J,I,E=j(17(K){4W(F!=0){F--;if(H<=0){K-=14.2X}1b{K+=14.2X}}18 K}).1d(14);1s(G=0;G<14.l;G++){J=(G*14.2X)/14.l;I=((G+1)*14.2X)/14.l;if(H<=0){J*=(-1);I*=(-1)}1b{J=14.2X-J;I=14.2X-I}if(J!=H){if(J>H&&H>I){if(1g.1E(H-J)<=1g.1E(I-H)){14.2w=E(J);14.1m=G}1b{14.2w=E(I);14.1m=14.3G(G+1)}}}1b{14.1m=G}}},7B:17(){1a G,F,E=14.2X/62*15;14.1j.1I("4z",j(17(H){if(1e===14.o.4P||H.4Z||"3C"===14.o.1T&&1g.1E(H.3K)>1g.1E(H.3L)||"3n"===14.o.1T&&1g.1E(H.3K)<1g.1E(H.3L)){14.1q("5i-2N");14.fx&&14.fx.2a(1e);14.fx=1i;H.2a();if(u.1f.1B&&u.1f.1B<10){H.4Z=1e}F=1g.1E(H.3K)<1g.1E(H.3L)?H.3L:-1*H.3K;F=H.4Z?(F*E):(F*(8/lY));!H.4Z&&(F=F>0?1g.8o(14.4G/4,F):1g.6l(14.4G/4*(-1),F));14.2w-=F;3t(G);G=5o(j(17(){14.7R()}).1d(14),2G);if(!14.o.1n){if(14.2w>=0){14.1q("5f-3g");14.2w=0;14.1m=0}1b{if(14.2w<=14.6a){14.1q("1m-3g");14.2w=14.6a;14.1m=14.l-1}}}if(!14.2T){14.74(0.fq)}}}).1d(14))},7y:17(){1a J=(14.1x.1W=="1O")?"x":"y",L={x:0,y:0},K={x:0,y:0},I,F=1c,H="1G",E=1c,G=j(17(M){if("41"==M.4T){j(1k.43).2S("1Y-7Q");E=1e;L.x=K.x=M.x;L.y=K.y=M.y}1b{if(E){L.x=M.x;L.y=M.y;if("9x"==M.4T){j(1k.43).4R("1Y-7Q");E=1c;if(F){F=1c;14.7R()}}1b{if(14.o.1T=="3C"||1g.1E(M.x-K.x)>1g.1E(M.y-K.y)){M.4x();if(!F){F=1e;14.2P=1e;14.fx&&14.fx.2a();14.1q("5i-2N");3t(14.2T);14.2T=1i}H=K[J]<L[J]?"2B":"1G";I=1g.1E(K[J]-L[J])/14.5A;if(H=="1G"){14.2w-=I;if(!14.o.1n){if(14.2w<=14.6a){14.1q("1m-3g");14.2w=14.6a;14.1m=14.l-1}}}1b{14.2w+=I;if(!14.o.1n){if(14.2w>=0){14.1q("5f-3g");14.2w=0;14.1m=0}}}!14.2T&&14.74()}K.x=L.x;K.y=L.y}}}}).1d(14);14.1j.1I("2u 2E",G)},2a:17(){14.fx&&14.fx.2a(1e);14.fx=1i;3t(14.2T);14.2T=1i;14.2w&&14.5q(14.2w)},40:17(){1a F,G,E,H;14.2a();14.24=14.7c();14.8K=14.1j.3j.2p(1c,1e);14.2I=0;1s(F=0;F<14.l;F++){14.1h[F].1y=14.1h[F].1o.2p(1e,1e);14.2I+=14.1h[F].1y[14.1x.1y]}14.4G=1*14.2X/14.l;14.6a=(14.2X-14.4G)*(-1);G=14.2I/14.2X;14.5A=14.8K[14.1x.1y]/2;(14.5A<G)&&(14.5A=G);(u.1f.1B&&u.1f.1B<10)&&(14.5A-=(14.1h[0].1y[14.1x.1y]/2));14.6u=14.2w=0;14.5q();14.9n();E=14.1m;14.1m=0;H=14.6M({1Z:E});if("1G"===H.1J){14.2w-=H.4G}1b{14.2w+=H.4G}14.5q(14.2w)},7g:17(E){14.2a();14.1m=0;if(14.o.1T=="3C"){14.d9()}1b{14.1h.1z(j(17(F){if(!F.4n){14.9W(F)}}).1d(14))}14.1j.1V("2u 2E 4z");14.7y();14.o.4P&&14.7B();14.cL();14.9V();14.40();if(14.o.1T=="3n"){14.1h.1z(j(17(F){14.8q(F)}).1d(14))}14.2P=1c},d9:17(){14.1h.1z(j(17(E){if(E.4n){E.4n.2n();5g E.4n}}).1d(14))},7o:17(){x.$4i.7o.5k(14);14.1j.1V("4z");14.d9();14.1h.1z(j(17(E){E.1o.1V("4f")}).1d(14))}});u.1U(x.27,u.75);u.4X.d2=x;1a d=17(E,F){u.4X.d2.5k(14,3m);14.7A="lX";14.2A=1i;14.2l=1i;14.2Q=1i;14.4L=1i;14.4k=1i;14.cN=lW;14.2z=1;14.2T=1i;14.3T=1i;14.2R=1i;14.3r=1i;14.cY=0};u.dg(d,u.4X.d2);u.1U(d.27,{4I:d,5M:u.$F,fk:u.$F,cZ:u.$F,fp:17(){1a E,G,F;14.3r=14.2Q;if(14.o.1T=="3C"){F=14.2Q+14.2Q*0.8;14.3r/=2}1b{F=14.2Q*2}1s(E=0;E<14.l;E++){G=(E==1)?F:14.3r;14.1h[E].2F=!E?(14.2A-14.2Q):(14.1h[E-1].2F+G)}},cT:17(E){if(14.o.1T=="3n"){18 1g.5O(14.2I-1g.1E(14.2A-(E.2F+14.2Q)))}},83:17(G){1a F,E;if(14.8c){18}14.8c=1e;E=14.l=14.1h.1r;14.24=14.7c();14.7u.5W=14.o.7u;1s(F=0;F<14.l;F++){14.1h[F].1y=14.1h[F].1o.2p(1e,1e);14.2I+=14.1h[F].1y[14.1x.1y];14.1h[F].1o.1M("2F","6N");14.1h[F].2g=14.dc(14.1h[F]);14.1h[F].34&&j(14.1h[F].34).3Z(0)}14.o.1n=1c;14.1h.1z(j(17(H){if(H.34&&!H.7j){if(H.2j.2x.38()!="4w"){H.7j=1e}}}).1d(14));14.40();!14.o.3S&&14.b4()},am:17(E){14.3Y.51=1e;14.8d();14.2z=1;14.7y();14.o.4P&&14.7B();j(1l).1I("5T",14.40.1d(14));if(14.o.6B){j(1k).1I("8L",14.b3)}E&&E();14.40()},cW:17(M){1a K,F,L,J,G=1,E,H=M.2F+14.2Q,I=M.2F+14.2Q<=14.2A;J=I?(14.2A-H):(H-14.2A);J/=((I?(14.2A-14.3T):(14.2R-14.2A))/2G);F=(90/2G*J)*(1g.3F/d7);K=60*1g.6d(F);E=1-1*1g.6d(F);if(14.o.1T=="3n"){!I&&(K*=(-1))}1b{K*=(-1);I&&(G=1-0.7*1g.6d(F))}L=14.cN*1g.6d(F)*(-1);18{8C:K,ba:L,3u:G,cV:E}},fl:17(I,K){1a G,F=1c,J=1c,E=I.2F+14.2Q,L,H={8C:60,ba:14.cN*(-1),3u:1};L=E-K;if(E>=14.2R){if(E-K<14.2R){G=E-14.2R;J=1e;K-=G;if(K<=14.2Q){K=(14.2R-14.2A)/14.3r*K}1b{if(K<=14.2Q*2){K=(14.2R-14.3T)/(14.3r*2)*K}1b{K+=(14.2Q*2);J=1c}}I.2F-=G}F=1e;I.2F-=K}1b{if(E<=14.3T){if(14.o.1T=="3C"){K=(14.2R-14.2A)/14.3r*K}1b{if(E-K>14.3T){J=1e;G=14.3T-E;K+=G;if(K>=14.2Q*(-1)){K=(14.2R-14.2A)/14.3r*K}1b{if(K>=14.2Q*2*(-1)){K=(14.2R-14.3T)/(14.3r*2)*K}1b{K-=(14.2Q*2)}}I.2F+=G}}F=1e;I.2F-=K}1b{if(E>14.3T&&E<14.2R){K=(14.2R-14.2A)/14.3r*K;if(E-K>=14.2R){G=14.2R-E;K+=G;K=14.3r/((14.2R-14.2A)/K);I.2F+=G}1b{if(E-K<=14.3T){if(14.o.1T=="3n"){G=E-14.3T;K-=G;K=14.3r/((14.2R-14.2A)/K);I.2F-=G}}1b{J=1e}}I.2F-=K}}}if(14.o.1T=="3n"){I.2F>14.2A&&(H.8C*=(-1))}1b{H.8C=60*(-1);I.2F<14.2A&&(H.3u=0.3)}J&&(H=14.cW(I));F&&(H.cV=0);if(14.o.3S){if(14.24>L-14.2Q&&"7l"===I.2C){14.cY=I.1S;I.2C="2C";if(14.o.4o){14.1q("9g")}1b{I.1K&&I.1K.2K()}14.6S.2b({1o:I.2j,1S:I.1S})}}18 H},dh:17(E){if(14.cY===E-1){if(14.o.4o||!14.3Y.51){14.1q("9z")}if(!14.3Y.51){14.1q("5n")}}},5q:17(H){1a F,G,J,E,I=14.4L-H;H||(H=0);14.4L=H;1s(F=0;F<14.l;F++){J={1O:0,1L:0};E={1O:0,1L:0};G=14.fl(14.1h[F],I);J[14.1x.1W]=14.1h[F].2F;E[14.1x.1W]=G.8C;14.1h[F].1o.1M(g,"4H("+J.1O+"2J, "+J.1L+"2J, "+G.ba+"2J)fr("+E.1L+"b9)fs("+E.1O+"b9)");14.1h[F].34&&14.1h[F].34.3Z(G.cV);if(14.o.1T=="3n"){14.1h[F].1o.1M("z-1S",14.cT(14.1h[F]))}1b{14.1h[F].1o.3Z(G.3u)}}},6M:17(F){1a E=14.2z;if(F.87){F.6m&&(E=F.6m);if(F.1J=="1G"){14.1n.2Z=1c;if(14.1m+E>14.l-1){if(14.1m!=14.l-1){E=14.l-1-14.1m;14.1m+=E;14.1n.2V=1e}1b{14.1m=0;E=14.l-1;14.1n.2Z=1e;14.1n.2V=1c;F.1J="2B"}}1b{14.1m+=E;if(14.1m===14.l-1){14.1n.2V=1e}}}1b{14.1n.2V=1c;if(14.1m-E<0){if(14.1m!=0){E=14.1m;14.1m-=E;14.1n.2Z=1e}1b{14.1m=14.l-1;E=14.l-1;14.1n.2Z=1c;14.1n.2V=1e;F.1J="1G"}}1b{14.1m-=E;if(14.1m===0){14.1n.2Z=1e}}}}1b{!F.1J&&(F.1J=F.1Z>=14.1m?"1G":"2B");E=1g.1E(14.1m-F.1Z);14.1m=F.1Z}14.2l=14.3r*E;18 F.1J},mn:17(E){E.1J=14.6M(E);14.4M=E.4M;14.1q("3U-2N-1p",{4d:[14.1m]});14.71(E.1J=="1G"?14.4L-14.2l:14.4L+14.2l)},71:17(E){14.4k=E;14.fx=1v u.4y(14.1j,{3R:8V,2M:14.o.6x,aU:(17(F){14.5q(F.1W)}).1d(14),5X:j(17(){14.76()}).1d(14)}).2N({1W:[14.4L,E]})},74:17(F){1a E=1g.1E(14.4k-14.4L)*(F||0.2);if(1g.1E(E)<0.mm){3t(14.2T);14.2T=1i;14.2P=1c;14.1q("5i-5D",{4d:[14.1m]});18}if(14.4k<14.4L){E*=(-1)}14.5q(14.4L+E);14.2T=5o(14.74.1d(14,F),30)},dd:17(I,J){1a G,F=I.2F+14.2Q,E=I.2F,H=j(17(K){if(F>14.3T&&F<14.2R||K){J=(14.2R-14.2A)/14.3r*J;if(F-J>=14.2R){G=14.2R-F;J+=G;J=14.3r/((14.2R-14.2A)/J);E+=G}1b{if(F-J<=14.3T){if(14.o.1T=="3n"){G=F-14.3T;J-=G;J=14.3r/((14.2R-14.2A)/J);E-=G}}}E-=J}}).1d(14);if(F>=14.2R){if(F-J<14.2R){G=F-14.2R;J-=G;E-=G;H(1e)}1b{E-=J}}1b{if(F<=14.3T){if(14.o.1T=="3C"){J=(14.2R-14.2A)/14.3r*J}if(F-J>14.3T){G=14.3T-F;J+=G;E+=G;H(1e)}1b{E-=J}}1b{H()}}18 E},7R:17(){1a G,F,E,H=14.4L-14.4k;if(14.o.1T=="3C"){H*=2}1s(G=0;G<14.l;G++){F=!F?14.dd(14.1h[G],H):E;E=(G+1<14.l)?14.dd(14.1h[G+1],H):1i;if(F+14.2Q>14.3T||G==14.l-1){if(E&&E+14.2Q>=14.2R||!E){E=ml}if(14.2A-(F+14.2Q)<(E+14.2Q)-14.2A){14.1m=G}1b{14.1m=G+1}if(14.1m===0){14.1n.2Z=1e}1b{if(14.1m===14.l-1){14.1n.2V=1e}}14.4k=14.2A-14.1m*14.3r;1N}}},7B:17(){1a F,E;14.1j.1I("4z",j(17(G){if(1e===14.o.4P||G.4Z||"3C"===14.o.1T&&1g.1E(G.3K)>1g.1E(G.3L)||"3n"===14.o.1T&&1g.1E(G.3K)<1g.1E(G.3L)){14.1q("5i-2N");14.fx&&14.fx.2a();14.fx=1i;G.2a();E=1g.1E(G.3K)<1g.1E(G.3L)?G.3L:-1*G.3K;E=G.4Z?(E*14.3r):(E*(8/13));!G.4Z&&(E=E>0?1g.8o(14.3r/4,E):1g.6l(14.3r/4*(-1),E));14.4k-=E;3t(F);F=5o(j(17(){14.7R()}).1d(14),2G);if(14.4k>=14.2A){14.4k=14.2A;14.1m=0}1b{if(14.4k<=14.2A-((14.l-1)*14.3r)){14.4k=14.2A-((14.l-1)*14.3r);14.1m=14.l-1}}if(!14.2T){14.74(0.fq)}}}).1d(14))},7y:17(){1a H=(14.1x.1W=="1O")?"x":"y",J={x:0,y:0},I={x:0,y:0},F=1c,E=1c,G=j(17(K){if("41"==K.4T){j(1k.43).2S("1Y-7Q");E=1e;J.x=I.x=K.x;J.y=I.y=K.y;14.1n.2Z=1c;14.1n.2V=1c}1b{if(E){J.x=K.x;J.y=K.y;if("9x"==K.4T){j(1k.43).4R("1Y-7Q");E=1c;if(F){14.7R();F=1c}}1b{if(14.o.1T=="3C"||1g.1E(K.x-I.x)>1g.1E(K.y-I.y)){K.4x();if(!F){14.fx&&14.fx.2a();14.1q("5i-2N");3t(14.2T);14.2P=1e;14.2T=1i;F=1e}14.4k-=(I[H]-J[H]);!14.2T&&14.74()}1b{14.2P=1c}I.x=J.x;I.y=J.y}}}}).1d(14);14.1j.1I("2u 2E",G)},2a:17(){14.fx&&14.fx.2a(1e);14.fx=1i;3t(14.2T);14.2T=1i;14.4k&&14.5q(14.4k)},40:17(){1a F,E,H,G;14.2a();14.2l=0;14.24=14.7c();14.2I=0;1s(F=0;F<14.l;F++){14.1h[F].1y=14.1h[F].1o.2p(1e,1e);14.2I+=14.1h[F].1y[14.1x.1y]}14.2Q=14.1h[0].1y[14.1x.1y]/2;if(14.o.1T=="3n"){14.2A=14.24/2}1b{14.2A=14.2Q+(14.2Q/50*15)}14.4L=14.4k=14.2A;if(14.o.1T=="3n"){14.3T=14.2A-(14.2Q*2);14.2R=14.2A+(14.2Q*2)}1b{14.3T=0;14.2R=14.2A+14.2Q+14.2Q*0.8}14.fp();14.5q(14.4L);14.9n();E=14.1m;14.1m=0;H=14.6M({1Z:E});G=H=="1G"?14.4L-14.2l:14.4L+14.2l;14.4k=G;14.5q(G)},cL:17(){14.1h.1z(j(17(E){if(14.o.1T=="3n"){E.1o.3l.3u=""}1b{E.1o.1M("z-1S","")}}).1d(14))}});u.1U(d.27,u.75);u.4X.mj=d;1a A=17(H,R){1a L,J,F,N,Q,I,M,O,K=0,E,G,P="mc me 2r 1y.";14.1t=1v u.cd(m);14.o=14.1t.gf.1d(14.1t);14.2q=14.1t.2q.1d(14.1t);14.1t.7d(1l.aD||{});14.1t.7d((1l.aB||{})[H.3O("id")||""]||{});14.1t.9q(H.3O("2e-1t")||"");if(u.1f.7E){14.1t.7d(1l.aE||{});14.1t.7d((1l.aA||{})[H.3O("id")||""]||{});14.1t.9q(H.3O("2e-7E-1t")||"")}if("2c"==u.1P(R)){14.1t.9q(R||"")}1b{14.1t.7d(R||{})}if(!14.o("aP")){18 1c}14.jx=j(H).3w("2r",14);u.$6I(14);14.88=1c;if(u.1f.1B){u.$A(H.aZ("a")).1z(17(S){S.bd=S.bd});u.$A(H.aZ("2g")).1z(17(S){S.4l=S.4l})}14.fQ=j(H).3O("2D")||j(H).3O("6r");14.6y=[];14.29={4t:14.o("4t"),5y:1e,6T:1c,1K:1e,2y:1c,fZ:"2r",4o:1e,fo:"5V-5U(.8, 0, .5, 1)",7f:"21"};14.id=H.3O("id")||"4U-"+1g.66(1g.7v()*u.67());14.1j=H.3w("2r",14);14.4a=u.$1v("2Y",{"2D":"1Y-4a"},{4N:"8r-72"});14.73=u.$1v("2Y",{"2D":"1Y-1h-1j"});14.88=1c;1s(L=14.1j.2h.1r-1;L>=0;L--){F=14.1j.2h[L];if(F.5a===3||F.5a===8){14.1j.8y(F)}1b{14.6y.2b(F)}}if(14.6y.1r===0){18}I=17(T){1a S=17(W){1a V=T.2h[W],U=V.2x.38();if("br"===U||"hr"===U){18 S(++W)}1b{18 V}};18 S(0)};O=I(14.1j);if(O.2x=="cC"){O=j(O).7H("65")[0]||O.3o}if(O.2x=="A"){O=j(O).7H("65")[0]||O.3o}14.a9=1c;if(O.2x=="65"){14.a9=O;M=O.3O("2e-4l");if(M){M=(M+"").4e();if(""!=M){O.3f("4l",M)}}}14.a5=1i;E=j(17(S){14.a5=5o(j(17(){14.9b=j(I(14.1j)).2p();if(14.9b.1F==0){if(K<2G){K++;E(S)}}1b{3t(14.a5);S()}}).1d(14),2G)}).1d(14);E(j(17(){14.7q=j([]);N=u.$A(14.1j.2h);14.2Z=N[0];j(N[0]).1M("4N","3X");14.gd={1y:D(N[0]),5Z:r(N[0]),5L:i(N[0]),6c:n(N[0])};N[0].1M("4N","8r-72");14.1j.1M("4N","3X");14.c8=D(14.1j);14.1j.1M("4N","8r-72");14.5R=1i;14.cI();if(14.29.1K){14.1K=1v u.3W.96(14.1j)}14.cs();14.g1();G=j(17(){1a T,V=1e,S={};14.6O=u.$1v("2Y",1i,{2F:"6N",1O:"-cc",1L:"-cc"}).4b(1k.43);14.2K();1s(L=0,J=N.1r;L<J;L++){T=N[L].2x.38();if(V){if("br"===T||"hr"===T){5c}}1b{if("br"===T||"hr"===T){5c}}3p{if(p){o.2m(u.$1v("2Y",{},{4N:"3X",6e:"64"}).2m(1k.bn(p)));p=2U}}3y(U){}V=1c;j(N[L]).3Z(0).1M("4N","8r-72");14.2b(N[L],S);S={};if(L==J-1){14.83()}}}).1d(14);1v u.ch([{1o:N[0]}],{6S:1,5x:17(S){6v"fm: 4U: fm hE hv - "+S.2g.4l+". "+P},6b:(17(S,T){14.5R=(S.2g)?S.2g.2p():S.1y;if(T.1o.2x.38()=="4w"){u.$A(T.1o.2h).1z(j(17(V){if(V.2x&&V.2x.38()=="34"){1a U=n(j(V));14.8Y=V.2p();14.8Y.1A+=U.1A;14.8Y.1F+=U.1F;14.5R.1F+=14.8Y.1F}}).1d(14))}G()}).1d(14)})}).1d(14))};u.1U(A.27,{c5:1c,cI:17(){if("2s"==14.o("2v")&&(u.1f.1B||!u.1f.4J.2s)){14.2q("2v","2r")}if(u.1f.1B&&u.1f.1B<=9&&14.o("2v")=="6k-6i"){14.2q("2v","2r")}14.29.6T=1k.hu.hk.5J("#4s-6T-2v")!=-1;if(u.1P(14.o("1h"))==="48"){14.29.7f=14.o("1h");j(17(){1a G,I,F,H=14.29.7f,E=H.1r;1s(G=0;G<E;G++){1s(I=G+1;I<E;I++){if(H[G][0]<H[I][0]){F=H[G];H[G]=H[I];H[I]=F}}}14.29.7f=H}).1d(14)();14.2q("1h","21")}if(14.o("9t")===0){14.2q("9t",10)}if(14.o("4t")<0||14.o("3I")==0){14.29.2y=1e}if(j(["6k-6i","2s"]).3i(14.o("2v"))){14.29.2y=1c}if("bm"===14.o("1n")||"1c"===14.o("1n")){14.2q("1n",1c)}if(14.o("2v")=="5H"||14.29.2y){14.2q("1n","3z")}if(14.o("2v")=="6k-6i"){14.2q("1n",1c)}if("6o"===14.o("1n")&&"2s"===14.o("2v")){14.2q("1n",1c)}if(j(["6k-6i","5H"]).3i(14.o("2v"))||14.29.2y){14.2q("ck",1c)}if(j(["6k-6i","5H"]).3i(14.o("2v"))&&!14.29.2y){14.2q("3I",1)}if(j(["6k-6i","5H"]).3i(14.o("2v"))&&!j(["21","8a"]).3i(14.o("1h"))){14.2q("1h","21")}if(14.o("2v")=="2s"&&14.o("1h")=="21"){14.2q("1h","8a")}if(14.o("2v")=="2s"){14.2q("3I","21")}if(14.29.2y){14.2q("7Z","5V-5U(0, 0, 1, 1)")}1b{if(14.o("7Z")=="5V-5U(0, 0, 1, 1)"){14.2q("7Z",14.29.fo)}}if("5H"===14.o("2v")){14.2q("3S",1c)}if(j(["6k-6i","5H"]).3i(14.o("2v"))){14.29.7f="21"}14.hj=14.o("1A");14.hs=14.o("1F");if(14.29.2y){14.2q("4t",0)}if(j(["6k-6i","5H"]).3i(14.o("2v"))||14.29.2y){14.2q("2i",1c)}if("1c"===14.o("2i")||"bm"===14.o("2i")){14.2q("2i",1c)}if(14.o("2i")){14.1j.2S("4U-2i-"+14.o("2i"))}14.1j.2S("4U-"+14.o("1T"));14.1j.3f("2e-2v",14.o("2v"))},cs:17(){if(!14.o("ck")){if(14.2f){14.2f.2n();14.2f=1i}18}if(!14.2f){14.2f=1v u.3W.fJ({},14.1j,j(17(){18 14.5I}).1d(14));14.1j.2S("4U-2f");14.2f.2O("2f-4f",j(17(E){14.2W({1J:E.1J,1Z:E.fK})}).1d(14))}},cr:17(){1a F,E=j([]);if(!14.1p){18}1s(F=0;F<14.1p.l;F++){if(j(["2r","2s"]).3i(14.o("2v"))){if(F%14.1p.2z==0){E.2b(14.1p.1h[F].1S)}}1b{E.2b(14.1p.1h[F].1S)}}14.2f.2b(E)},cH:17(){1a E=i(14.1j);if(14.2i){14.2i.2n();14.2i=1i}14.4a.33({1L:"",1O:"",6q:"",5m:""});if(14.o("2i")){if(!14.2i){14.2i=1v u.3W.g5({1T:"1Y-"+14.o("1T"),"2D":"1Y-3Q",bi:"1Y-64",bk:"1Y-i0"},14.1j);14.1p.2O("7M",14.2i.7M.1d(14.2i,2U));14.1p.2O("4m",14.2i.4m.1d(14.2i,2U));14.1p.2O("g6",14.2i.52.1d(14.2i,2U));14.1p.2O("g4",14.2i.2K.1d(14.2i,2U));if(!14.o("1n")){14.1p.2O("2r",14.2i.4m.1d(14.2i,2U));14.1p.2O("1m-3g",14.2i.7M.1d(14.2i,"8s"));14.1p.2O("5f-3g",14.2i.7M.1d(14.2i,"7U"))}14.2i.2O("1G",(17(I){14.2W("1G")}).1d(14));14.2i.2O("2B",(17(I){14.2W("2B")}).1d(14))}1b{14.2i.g3(14.o("1T"))}if(14.o("2i")=="cj"){1a H=14.o("1T")=="3n"?j(["1O","6q"]):j(["1L","5m"]),F=14.o("1T")=="3n"?"1A":"1F",G=1X(14.2i.8s.2p()[F]);H.1z(j(17(I){14.4a.1M(I,G+(E[F]/2))}).1d(14))}}},9m:17(){if(14.o("1A")!="21"){14.1j.1M("1A",14.o("1A"))}if(14.o("1F")!="21"){14.1j.1M("1F",14.o("1F"))}18},g1:17(){1a E=j(["2r","2s"]).3i(14.o("2v"))?"1p":14.o("2v");14.1p=1v u.4X[("-"+E).6f()](14.73,{1T:14.o("1T"),3R:14.o("9t"),2y:14.29.2y,6x:14.o("7Z"),1n:14.o("1n"),3I:14.o("3I"),1p:14.o("2v"),3S:14.o("3S"),1K:14.29.1K,4o:14.29.4o,6T:14.29.6T,4P:14.o("4P"),6U:14.o("6U"),6B:14.o("6B")});if(14.o("1h")!="21"&&14.o("3I")=="21"){14.2q("3I",14.o("1h"))}14.1p.2O("g2",j(17(){14.5I=1c;14.21()}).1d(14))},2W:17(E,F){if(14.o("2v")=="2s"&&/^\\+|^\\-/.3D(E)){E=/^\\+/.3D(E)?"1G":"2B"}if(!14.5I&&!14.1p.7b){14.5I=1e;3t(14.7K);14.1p.2W(E,j(17(G,H){14.5I=1c;if(H){18}14.1q("cJ-2r");if(!14.29.2y||14.c5||14.5P){if(14.6O.2h.1r==0){14.6O.2n()}if(14.o("1n")){14.1p.7p()}14.o("a4")({id:14.id,1h:G});14.1p.hR=1c;F&&F()}1b{14.2W("1G",F)}}).1d(14))}},gc:17(J){1a F,I,G,E,H;if(J.2x.7X()=="A"){if((E=j(J).7H("65")[0])){if((H=j(J).7H("a8")[0])&&""!==H.g7.4e()){I=j(H.6t(1e)).2S("1Y-c3");I.3f("4s-cB","fP")}1b{if(((F=E.g8)&&3==F.5a&&""!==F.ao.4e())||(H&&(F=H.g8)&&3==F.5a&&""!==F.ao.4e())){I=u.$1v("a8",{"2D":"1Y-c3"}).2m(F.6t(1e))}}1s(G=J.2h.1r-1;G>=0;G--){if(E!==J.2h[G]){J.8y(J.2h[G])}}if(I){J.2m(I)}}}1b{if(J.2x.38()=="4w"){u.$A(J.2h).1z(j(17(K){if(K.2x&&K.2x.38()=="34"){F=K.3O("id")||"34-"+1g.66(1g.7v()*u.67());K.3f("id",F);j(K).2S("1Y-c3");I=K;14.hT=u.c2("#"+F+":ib",{"5L-1L":(14.8Y.1F+r(j(K))/2)/1X(14.9b.1A)*2G+"%"})}}).1d(14))}}18{1o:J,34:I}},aI:17(E){if(14.o("1h")!="21"){E.1o.1M(14.o("1T")=="3n"?"1A":"1F",2G/14.o("1h")+"%")}},aJ:17(F){1a G,E;if(14.o("1h")=="8a"){14.2q("1h",1g.66(14.4a.2p()[14.1p.1x.1y]/14.5R[14.1p.1x.1y]))}1b{if(14.o("1h")=="21"){if(!14.gd.1y[14.1p.1x.1y]){G=14.5R[14.1p.1x.1y]||14.9b[14.1p.1x.1y];E=14.73.2p();if("3C"===14.o("1T")){G=1g.8o(G,E[14.1p.1x.1y])}E=(G+n(F.2j)[14.1p.1x.1y]+r(F.2j)[14.1p.1x.1y]+i(F.2j)[14.1p.1x.1y]+i(F.1o)[14.1p.1x.1y])/14.73.2p()[14.1p.1x.1y]*2G;if(E>2G){E=2G}F.1o.1M(14.1p.1x.1y,E+"%")}}}},2b:17(F,E){F.2K();F={2j:F};if(E.1L){E.1L.1z(17(H){H.2n()})}if(E.5m){E.5m.1z(17(H){H.2n()})}F.gH=E;1a G=14.gc(F.2j);F.2j=G.1o;F.34=G.34;F.1o=u.$1v("2Y",{"2D":"1Y-36"});F.1o.4b(14.73);14.aJ(F);14.aI(F);F.2j.4b(14.6O);14.1p.2b(F)},2K:17(){if(14.ct){18}14.ct=1e;14.1j.2m(14.4a.2m(14.73)).2K().3f("id",14.id);14.1j.1M("4N","8r-72");if(14.o("2i")){14.cH();14.o("1n")&&14.2i.7M("7U");14.2i.52()}14.av();14.9m();if(14.a9){if("3n"===14.o("1T")&&14.1j.2p().1A<14.5R.1A){14.av(1e);14.9m()}}14.aK();j(1l).1I("5T",14.40.1d(14))},83:17(E){14.1p.2O("gb",j(17(F){14.2W(F.1J)}).1d(14));14.1p.2O("2K-14",j(17(F){14.2W(F.1S)}).1d(14));14.1p.2O("9g",j(17(){14.1K&&14.1K.2K()}).1d(14));14.1p.2O("9z",j(17(){14.1K&&14.1K.52()}).1d(14));14.1p.2O("5n",j(17(){14.1p.am(j(17(){14.1p.2O("g9",j(17(){14.5I=1c}).1d(14));14.1p.2O("36-4f",j(17(H){1a G=1e,F,I;if(14.o("2v")=="5H"){F=62/14.1p.l;I=(62-14.1p.1m*F+H.1S*F)%62;if(I>90&&I<gs){G=1c}}G&&14.2W(H.1S)}).1d(14));if(14.2f){14.2f.o.1h=14.1p.1h.1r;14.cr();14.2f.2K()}14.1p.2O("3U-36-ga",j(17(F){14.o("cn")({id:14.id,36:F.aq})}).1d(14));14.1p.2O("3U-36-ap",j(17(F){14.o("co")({id:14.id,36:F.aq})}).1d(14));14.1p.2O("3U-2N-1p",j(17(F){14.2f&&14.2f.c0(F.4d,!14.o("1n"));14.o("cD")({id:14.id,1h:F.4d})}).1d(14));14.1p.2O("5i-2N",j(17(){14.5I=1e;14.21()}).1d(14));14.1p.2O("5i-5D",j(17(F){14.2f&&14.2f.c0(F.4d,!14.o("1n"));14.5I=1c;14.o("a4")({id:14.id,1h:F.4d});if(14.6O.2h.1r==0){14.6O.2n()}14.21()}).1d(14));14.1j.1M("6z","7a");14.88=1e;14.o("cE").2o(14,14.id);j(1l).1I("5T",j(17(){14.5I=1c;if(14.29.2y){14.2W.1d(14,"1G").3v(5K)}1b{14.21()}}).1d(14));14.cq();if("3C"===14.o("1T")&&/%$/.3D(14.o("1F"))){14.2q("1F",14.1j.2p().1F);14.9m()}if(14.o("4t")!=0){14.21()}1b{14.5P=1e}if(14.29.2y){14.5P=1c;14.2W.1d(14,"1G").3v(5K)}14.88=1e}).1d(14))}).1d(14));14.1p.83()},cq:17(){14.2O("cJ-2r",j(17(){if(14.29.4t!=0){!14.29.2y&&14.21()}}).1d(14));if(!u.1f.c4&&(14.29.5y||14.29.2y)){14.4a.1I("5e 6J",j(17(F){F.2a();1a E=F.as();4W(E&&E!==14.4a){E=E.3j}if(E==14.4a){18}if(14.29.5y&&!14.5P){14.fR="5e"==F.1H;14.c5="5e"==F.1H;if(14.29.2y){if(F.1H=="5e"){14.cK()}1b{14.2W("1G")}}1b{14.21()}}}).1d(14))}if(!14.29.2y&&"2s"===14.o("2v")&&14.o("4P")){14.4a.1I("4z",j(17(E){1a F=-1*(1g.1E(E.3K)<1g.1E(E.3L)?E.3L:-1*E.3K);F=E.4Z?(F):(F*(8/54));if((1e===14.o("4P")&&E.4Z)||"3C"===14.o("1T")&&1g.1E(E.3K)>1g.1E(E.3L)||"3n"===14.o("1T")&&1g.1E(E.3K)<1g.1E(E.3L)){E.2a();if(1g.1E(F)<0.6){18}14.2W(F>0?"2B":"1G")}}).1d(14))}},av:17(M){1a L="1A",N="1F",I=14.o("1T")=="3C",E=14.1j.2p(),H={1A:0,1F:0},J=i(14.1j),Q=r(14.4a),U=n(14.4a),O=i(14.4a),P=n(14.2Z),K=u.$1v("2Y",{"2D":"1Y-36"}).4b(14.4a.3o),R,S,G,T,F=i(K);K.2n();if(14.1j.2k("g0-he")=="5Z-g0"){H=r(14.1j)}if(I){L=N;N="1A"}if(14.o(L)=="21"&&!1X(14.c8[L])){if(I){if(!6C(14.o("1h"))){14.2q(L,E[L]*14.o("1h"))}1b{14.2q(L,E[L])}}1b{14.2q(L,"2G%")}}if(14.o(N)=="21"&&!1X(14.c8[N])||M){G=H[N]+J[N]+Q[N]+P[N]+F[N];if(I){R=1g.8o(14.5R[N],E[N])}1b{R=14.5R[N];if(14.a9){S=14.5R[N]/14.5R[L];if(14.5R[L]>E[L]){R=E[L]*S}}}T=(R+n(j(14.6y[0]))[N]+i(14.6y[0])[N]+r(14.6y[0])[N])||14.9b[N]||E[N];T+=G;T+="";14.2q(N,T)}},aK:17(){1a H,G,F,J,I=1e,E=14.o("1h");if(14.29.7f!="21"&&j(["2r","2s"]).3i(14.o("2v"))){J=14.29.7f;F=J.1r;G=14.29.fZ=="2r"?14.1j.2p()[14.o("1T")=="3C"?"1F":"1A"]:j(1l).2p()[14.o("1T")=="3C"?"1F":"1A"];1s(H=F-1;H>=0;H--){if(G<=J[H][0]&&!6C(J[H][1])){14.2q("1h",J[H][1]);I=1c;1N}1b{if(0===H){if(j(["5H","6k-6i"]).3i(14.o("2v"))){14.2q("1h",1)}1b{if("2s"===14.o("2v")){14.2q("1h","8a")}1b{14.2q("1h","8a")}}}}}if(E===14.o("1h")){18}u.$A(14.73.2h).1z(j(17(L,K){14.aJ({1o:L,2j:L.3o});14.aI({1o:L})}).1d(14));if(14.1p.1h.1r>0){14.1p.7g()}}},40:17(){14.aK()},5T:17(){if(14.88){14.40();14.1p.40()}},cK:17(){14.1p.5y()},2a:17(){14.1j.3w("hc-1h-3u",1c);14.1p&&14.1p.2a();14.5I=1c;3t(14.7K);14.7K=1c},hb:17(E){18 E==14.o("2v")},cp:17(F,E){if(!j(["cn","co","cE","cD","a4"]).3i(F)){18}14.2q(F,E)},7o:17(){1a E,F,G;14.2a();3t(14.a5);14.4a.1V("5e 6J");14.4a.1V("a7");14.1p&&14.1p.7o();if(14.7q){1s(E=0;E<14.7q.1r;E++){u.cA("fL-au",14.7q[E])}}14.1j.4R("4U-2f");j(14.6y).1z(j(17(H){if(H.3j){j(H).2n()}G=H;if(G.2x=="cC"){G=G.3o}if(G.2x=="A"){G=G.3o}if(G.2x=="65"){F=G.3O("2e-4l");if(F){F=(F+"").4e();if(""!=F){G.3P("4l")}}}if(H.2h.1r>0&&H.2x.38()=="a"){u.$A(H.2h).1z(j(17(I){if(I.2x&&I.2x.38()=="a8"){if("fP"===I.3O("4s-cB")){I.3P("4s-cB");H.2m(I)}1b{H.2m(I.2h[0]);I.2n()}}}).1d(14))}H.33({6e:"",3u:"1"})}).1d(14));14.6O&&14.6O.2n();u.$A(14.1j.2h).1z(17(H){j(H).4Y()});j(14.1j).3P("2e-2v");j(14.1j).cF().4R().2S(14.fQ);14.1j.33({1A:"",1F:"",6e:"",4N:"",6z:""});14.1j.3H("2r");1s(E=14.6y.1r-1;E>=0;E--){j(14.6y[E]).33({3u:""}).4b(14.1j)}14.o("fO").2o(14,14.id);18 1i},8Q:17(E){if(1i===E||2U===E){E=14.o("4t")}1b{E||(E=93);E=1X(E);if(6C(E)){E=14.o("4t")}}if(!14.5P){18}if(!14.7K){14.5P=1c;14.1p.99=1c;14.29.4t=E;14.2W("1G")}},5y:17(){if(14.5P){18}14.5P=1e;if(14.29.2y){14.cK()}1b{14.2a()}14.21()},8B:17(E){1a H,G={1F:"",1A:""},F=14.o("2v");14.2a();14.1j.4R("4U-2i-"+14.o("2i"));14.1j.4R("4U-"+14.o("1T"));14.4a.1V("5e 6J a7");14.fN("cJ-2r");14.1K=1i;14.1j.4R("4U-2f");if("2c"==u.1P(E)){14.1t.9q(E||"")}1b{14.1t.7d(E||{})}if(F!=14.o("2v")){18 1c}14.29.4t=14.o("4t");14.cI();14.1p.1h.1z(j(17(I){I.1o.33(G)}).1d(14));14.1p.4j.1z(j(17(I){j(I).1o.33(G)}).1d(14));14.1p.6L.1z(j(17(I){j(I).1o.33(G)}).1d(14));14.cH();1s(H=0;H<14.7q.1r;H++){14.7q[H]&&u.cA("fL-au",14.7q[H])}14.1p.fM({1T:14.o("1T"),3R:14.o("9t"),2y:14.29.2y,6x:14.o("7Z"),1n:14.o("1n"),3I:14.o("3I"),1p:14.o("2v"),3S:14.o("3S"),1K:14.29.1K,4o:14.29.4o,6T:14.29.6T,4P:14.o("4P"),6U:14.o("6U"),6B:14.o("6B")});14.av();14.9m();14.aK();u.$A(14.73.2h).1z(j(17(J,I){14.aJ({1o:J,2j:J.3o});14.aI({1o:J})}).1d(14));14.1p.7g(1e);14.cs();if(14.2f){14.cr();14.2f.2K()}if(14.o("4t")==0){14.5y()}1b{14.5P=1c}14.o("2i")&&14.2i.2K();14.cq();if(14.29.2y){14.2W.1d(14,"1G").3v(5K);14.5P=1c}1b{14.21()}18 1e},21:17(){1a E="1G";3t(14.7K);14.7K=1c;if(14.5I||14.5P||14.fR){18}if(14.29.4t!=0){14.7K=5o(j(17(){14.2W(E)}).1d(14),1g.1E(14.29.4t))}}});u.1U(A.27,u.75);u.4X.aO=A;1a B=17(F){1a E=h(F);if(!E){18}18{cp:E.cp.1d(E),5y:E.5y.1d(E),8Q:j(17(G){14.8Q(G)}).1d(E),1G:j(17(G){G=!G?"1G":a(G,"+");14.2W(G)}).1d(E),2B:j(17(G){G=!G?"2B":a(G,"-");14.2W(G)}).1d(E),2W:j(17(G){if(!G||6C(1g.1E(1X(G)))){G="1G"}14.2W(G)}).1d(E),8B:j(17(G){if(!G||u.1P(G)!="7T"){G={}}14.8B(G)}).1d(E)}},h=17(F){1a E=1i;if(u.1P(F)=="2c"&&j(F)||u.1P(F)=="7x"){E=j(F).2t("2r")}1b{if(u.1P(F)=="17"&&(F 4v u.4X.aO)||F&&F.ct){E=F}}18 E},e=17(G,H,F){1a E=h(G);if(E){18 E[F](H)}1b{H=G;G=y}j(G).1z(17(I){I[F](H)})},a=17(F,E){if(u.1P(F)==="2c"){F=1X(F);if(6C(F)){F=F}}if(u.1P(F)==="5h"){F=E+F}18 F},w=17(F){1a E=u.$A((F||1k).fS("4U")).fX(17(G){18 q.2N(G)});l=1e;18 E},l=1c,z=17(E){18 y=j(y).4S(17(F){18 F.7o()})},y=[],q={5w:"fY.0.26",2N:17(F){1a E=1i;if(3m.1r){F=j(F);if(F&&j(F).8W("4U")){if(E=j(F).2t("2r")){18 E}1b{E=1v u.4X.aO(F,l?{aP:1e}:{});if(!E.o("aP")){E=1i;18 1c}1b{y.2b(E);18 E}}}1b{18 1c}}1b{18 w()}},2a:17(E){if(3m.1r){E=(E 4v u.4X.aO)?E:(j(E)&&j(E).2t("2r")||1i);if(!E){18}y.cy(j(y).5J(E),1);E.7o()}1b{z();18}},je:17(E){if(E){q.2a(E);18 q.2N(E.id||E)}1b{z();18 w()}},iJ:17(G){1a F,E=1c;if(G){F=h(G);if(F){E=F.88}}18 E},j3:17(E){18 B(E)},8B:17(E,F){18 e(E,F,"8B")},5T:17(E){if(E){e(E,1i,"5T")}1b{j(y).1z(17(F){q.5T(F)})}},2W:17(E,F){if(2U!=E&&1i!=E){e(E,F,"2W")}},5y:17(E){e(E,1i,"5y")},8Q:17(E,F){e(E,F,"8Q")},1G:17(E,F){1a G;F=!F?"1G":a(F,"+");if(!E){E=F}1b{if(!h(E)){E=a(E,"+")}}e(E,F,"2W")},2B:17(E,F){1a G;F=!F?"2B":a(F,"-");if(!E){E=F}1b{if(!h(E)){E=a(E,"-")}}e(E,F,"2W")}};j(1k).1I("8J",17(){p=p();o=u.$1v("2Y",{"2D":"fW-fV-fT-fU"}).4b(1k.43);u.3e(1l.aD)||(1l.aD={});u.3e(1l.aE)||(1l.aE={});u.3e(1l.aB)||(1l.aB={});u.3e(1l.aA)||(1l.aA={});1a E=1l.aA.aC||1l.aB.aC||1l.aE.aC||1l.aD.aC||u.$F;E();q.2N.3v(10)});18 q})();', 62, 1403, '||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||this|||function|return||var|else|false|jBind|true|browser|Math|items|null|container|document|window|last|loop|node|effect|jCallEvent|length|for|options|Event|new|Custom|p_|size|jEach|width|ieMode|containerPosition|event|abs|height|forward|type|jAddEvent|direction|progress|top|jSetCssProp|break|left|jTypeOf|handler|case|index|orientation|extend|jRemoveEvent|pos|parseInt|mcs|target||auto|||containerWidth|||prototype||_insideOptions|stop|push|string||data|bullets|img|childNodes|arrows|content|jGetCss|distance|append|jRemove|call|jGetSize|set|scroll|animation|jFetch|touchdrag|mode|nextAngle|tagName|continuous|itemStep|center|backward|load|class|mousedrag|position|100|default|allSize|px|show|btnclick|transition|start|bindEvent|move_|moiety|lastSide|jAddClass|moveTimer|undefined|lastItem|jump|circle|div|firstItem||||jSetCss|figcaption||item||toLowerCase||clientY|timeStamp|clientX||defined|setAttribute|frame|pointerType|contains|parentNode|changedTouches|style|arguments|horizontal|firstChild|try|parseFloat|stepDistance|globalIndex|clearTimeout|opacity|jDelay|jStore|loader|catch|infinite|tap|fullViewedItems|vertical|test|Element|PI|_getItemIndex|jDel|step|enum|deltaY|deltaX|oneOf|handle|getAttribute|removeAttribute|button|duration|lazyLoad|firstSide|on|navigator|Modules|none|doneFlag|jSetOpacity|onResize|dragstart||body|||||array||wrapper|jAppendTo|Doc|arr|jTrim|click|init|Class|parent|itemsFirstClones|nextPosition|src|enable|canvas|stopDownload|J_EUID|touchpinch|hasOwnProperty|magic|autoplay|important|instanceof|figure|stopDefaults|FX|mousescroll|pointerEnabled|match|identifier|pushToEvents|reverse|dblbtnclick|angle|translate3d|constructor|features|loaded|lastPosition|callback|display|order|scrollOnWheel|pow|jRemoveClass|filter|state|MagicScroll|J_TYPE|while|Scroll|kill|isMouse||two|hide||||styles|touches|||nodeType|dbltap|continue|webkit|mouseover|first|delete|number|drag|replace|apply|getVisibleIndexes|bottom|complete|setTimeout|orders|renderCarousel|listeners|schema|clone|domPrefix|globalLength|version|onerror|pause|jGetPosition|radius|activeBullet|exitItems|end|ready|touch|getDoc|carousel|hold_|indexOf|200|padding|_shiftContainer|trident|round|pause_|requestAnimationFrame|sizeFirstImg|boolean|resize|bezier|cubic|cubicBezier|onComplete|loadAll|border|||360||hidden|IMG|floor|now|||endItem|onload|margin|sin|visibility|jCamelize|offsetHeight|Array|flow|messageBox|cover|max|goTo|createElement|rewind|detach|right|className|documentElement|cloneNode|lastAngle|throw|pageX|timingFunction|originalNodes|overflow|pageY|keyboard|isNaN|mouseup|timer|jBindAsEvent|add|events|uuid|mouseout|_getGlobalIndex|itemsLastClones|_calcDistance|absolute|hashBox|dragged|J_UUID|MSPOINTER_TYPE_TOUCH|queue|debug|draggable|jGetPageXY|enterItems|disableEffect|wheel_|isQueueStopped||_move|block|itemsContainer|_move2|customEvents|_onComplete||shift|transitionend|visible|stopScroll|_sWidth|fromJSON|getButton|itemSettings|update|correctPosition|insertBefore|captionA|itemsVisible|notLoaded|onTouchEnd|found|dispose|changeClones|cachedCSS|fullScreen|not|_event_prefix_|gradientBezier|random|engine|element|_initDragOnScroll|MagicJS|name|_initOnWheel|render|minimum|mobile|scale|error|byTag|ease|move|auto_|switch|disable|stopQueue|cycles|MSPointerUp|dragging|searchIndex|_options|object|prev|onready|tm|toUpperCase|onTouchStart|easing|timedout|alternate||done||easeFn||defaultMove|scrollReady||fit|transform|one|itemEvent|sqrt|mousedown|stopDistribution|tempArray|preloadItem|threshold|tooltip|split|touchstart|oncomplete|min|uaName|showReflection|inline|next|touchend|platform|_handlers|targetTouches|pointerup|removeChild|_cleanup|join|updateOptions|rotate|300|gecko|wheelDiff|moveSettings|abort|toString|domready|containerSize|keydown|animationstart|previous|animationend|stopWhell|play|onStart|dblclick|AnimationEnd|nth|500|jHasClass|AnimationStart|sizefigcaption|readyState||opera|activate|1000|||Progress|linear||continuousPause|ceil|firstItemSize|onDrag|onabort|getContext|storage|showProgress|flag|_timer|parseCubicBezier|_unbind|appendChild|setContainerSize|setCanvasPosition|AA|_EVENTS_|fromString|nativeEvents|_render|speed|action|_events|Transition|dragend|_event_del_|hideProgress|correctItemPosition|wrapperPosition|fxk|correctContainerPosition|MSPointerDown|pointerdown|0ms|_removeClones|pointerId|getMatrixPosition|performedOnClones|originSize|00001|touchmove|MSPointerMove|lastChild|eventType|onTouchMove|pointermove|cubicBezierAtTime|allNodes|_setProperties|setReflection|setItemStep|startAlpha|cancelAnimationFrame|ban|text|android|svg|onMoveEnd|coreTimeout|chrome|mousewheel|span|tagImg|||||||||||uaVersion|forceAnimation|done2|charAt|nodeValue|out|itemIndex|fallback|getRelated|loopBind|css|checkSizes_|Message|exists|hideTimer|mousemove|MagicScrollMobileExtraOptions|MagicScrollExtraOptions|beforeInit|MagicScrollOptions|MagicScrollMobileOptions|jGetScroll|pStyles_arr|_event_add_|setPercent|checkWholeItems|countTheNumberOfItems|url|compatMode|pStyles|Full|autostart|Opacity|exitFullscreen|createEvent|callee|onBeforeRender|status|relatedTarget|scrollLeft|scrollTop|getElementsByTagName|handleMouseUp|XMLHttpRequest|win|keyboardCallback|preloadAll||btnclickEvent|onprogress|checkLoadingVisibleItems|deg|translateZ||xhr|href|getStorage|normalizeCSS|has|implement|classHidden|reset|classDisabled|dashize|off|createTextNode|_bind|Tooltip|groupLoad||delay|stopAnimation|doc|deltaMode|cycle|ifndef|hideFX|typeof|mgctlbx|naturalWidth|loadedBytes|styles_arr|startTime|05|handleTouchStart|getBoundingClientRect|preloadAllFlag|deactivate|checkLoadedItems|Pltm|calc|magicJS|addCloneContent|handleTouchMove|preventDefault|disableReflection|600|showItem|keyCode|handleTouchEnd|Number|el_arr|priority|previousScale|setActiveBullet|cssDomPrefix|addCSS|caption|touchScreen|hovered|presto|concat|containerCssSize|changeEventName|slice|Alpha|10000px|Options||getTarget|maximum|QImageLoader|capable|outside|pagination|HTMLElement|getElementsByClassName|onItemHover|onItemOut|registerCallback|setEvent|setBullets|initBullets|indoc|https|Date|J_EXT|Function|splice|cssFilters|removeCSS|user|FIGURE|onMoveStart|onReady|jClearEvents|opr|setupArrows|setupOptions|after|pauseContinuous|resetZIndex|errorEventName|depth|_prepareClones|Effect|exited|cloneFigure|_getWheelDiff|zIndex|entering|captionOpasity|zoom|onClick|lastItemLoad|showCaption|_cleansingStyles|0px|Carousel|handleMouseDown|isPrimary|caller|prevIndex|180|setItemSide|removeCanvas|ignore|originFontSize|getImg|checkPosition|onclick|offsetTop|inherit|onLazyLoad|freeTouchPreload|stopEffect|exiting|cssTransformProp|_initialDistance|easeOutBack||safari|wheelDelta|wheelDeltaY|easeInCubic|easeOutQuad|detail|easeOutCubic|dragmove|crios|elasticIn|easeInBack|cssText|mozCancelAnimationFrame|insertRule|stylesId|date|sheet|styleSheet|removeRule|deleteRule|textnode|nativize|Object|UUID|jToBool|toArray|getTime|setMessage|999|mjs|wheelDeltaX|backcompat|hone|scrollbarsWidth|PFX|multibackground|bounceIn|od|phone|String|forEach|curScale|perspective|firefox|DocumentTouch|background|Webkit|offsetWidth|setProps|getElementById|compareDocumentPosition|jDefer|webkit419|handleMouseMove|Microsoft|fps|getComputedStyle|interval||isReady|DXImageTransform|progid|clientWidth||onxhrerror|getClientXY|addEventListener|ios|wrap|euid|dispatchEvent|which|xhr2|requestFullScreen|onreadystatechange|request|stopPropagation|cancelBubble|loadBlob|styleFloat|finishTime|backCompat|documentMode|androidBrowser|175|165|045|cssPrefix|304|easeInExpo|easeOutExpo|Moz|easeOutSine|easeInSine|moz|no|03|msExitFullscreen|progressiveLoad|Top|Bottom|Right|Left|cancelFullScreen|onExit|ua|355|enabled|onEnter|onchange|onAfterRender|easeInQuad|10px|restore|setFontSize|save|offsetLeft|showThis|_scroll|_carousel|calcItemPosition|Error||timingFunctionDefault|setItemsPosition|08|rotateX|rotateY|rightQueue|stop_|inside|noimg||destroy|origItem|itemFX|ImageLoader|relative|otherSize|cos|returnValue|_moveEffect|jumpToNumber|attributes|Bullets|jumpIndex|magicscroll|setNewOptions|destroyEvent|onStop|yes|originalClasses|pauseHover_|byClass|hdn|holder|tmp|msc|map|v2|maxSize|box|initEffect_|hold|setOrientation|showArrows|ArrowsPair|hideArrows|innerHTML|nextSibling|disableHold|hover|key_down|parseTag|itemCss|circles|get|blur|getDirection|arrow|parseSchema|getBulletIndex|DOMContentLoaded|bullet|jGetSize_|unbindEvent|MSFullscreenError|selectstart|fullscreenchange|270|CancelFullScreen|requestFullscreen|RequestFullScreen|cancel|ExitFullscreen|fullscreenerror|MSFullscreenChange|Width|keypress|cssFloat|fontWeight|lineHeight|getPropertyValue|float|additionalTags|activeElement|RequestFullscreen|selectend|MagicToolboxTooltip|prefix|FullScreen|TransitionEvent|cssfilters|WebKitTransitionEvent|webkitTransitionEnd|getJSON|parameter|2px|definition|9999|red|of|the|isset|substring|FullscreenElement|fullscreenElement|webkitIsFullScreen|currentStyle|DOMMouseScroll|ver|536|contextmenu|5000|checkEffect|swap|MessageBox|sizing|jToggleClass|scrollWidth|265|scrollHeight|originwidth|hash|readystatechange|pageYOffset|pageXOffset|innerWidth|presto925|innerHeight||originheight|clientHeight|location|image|toElement|MSPointerOut|isTouchEvent|isPrimaryTouch|removeEventListener|pointerout|fromElement|customEventsAllowed|loading|srcElement|pointerover|MSPointerOver|beforeunload|DOMElement|jGetTransitionDuration|select|getInnerSize|jGetFullScroll|clientLeft|clientTop|change|continuousMove|webkitCancelRequestAnimationFrame|cssId|jGetStyles|keyup|focus|offsetParent|html|unload|disabled|jGetStyle|jSetStyle|iframe|hasChild|replaceChild|changeContent|jGetRect|innerText|submit|enclose|before|oCancelAnimationFrame||||querySelector|query|fullscreenEnabled|msFullscreenEnabled|webkitCancelFullScreen|webkitexitFullscreen|runtime||air||userAgent|setInterval|edge|xpath|evaluate|mozCancelFullScreen|oCancelFullScreen|w3|www|org|TR|SVG11|http|hasFeature|ProgressEvent|msCancelFullScreen|FormData|withCredentials|implementation|running|toFloat|POSITIVE_INFINITY|regexp|NEGATIVE_INFINITY|parse|cssRules|head|RegExp|KeyEvent|collection|v3|MouseEvent|UIEvent|KeyboardEvent|addRule|generateUUID|charCodeAt|getHashCode|4294967296|getInstance|jToInt|getAbsoluteURL|xy|xxxx|xxxxxxxx|4xxx|yxxx|xxxxxxxxxxxx|feature|Image|refresh|windows|xda|xiino|getBoxObjectFor|ActiveXObject|wap|vodafone|symbian|series|treo|up|link|mozInnerScreenY|WebKitPoint|oRequestAnimationFrame|webkitRequestAnimationFrame|msRequestAnimationFrame|Incorrect|original|mozRequestAnimationFrame|other|unknown|taintEnabled|webos|mac|linux|psp|pocket|compal|blazer|elaine|fennec|hiptop|blackberry|bada|maxTouchPoints|ontouchstart|msMaxTouchPoints|meego|avantgo|iemobile|iris|os|palm|ixi|re|plucker|ob|netfront|lge|kindle|maemo|midp|mmp|msCancelAnimationFrame|jGetFullSize|naturalHeight|mgctlbxL|Infinity|normal|roundCss|mgctlbxP|magicsroll|nowrap|expoIn|space|white|sineOut|setTransition|curFrame|sineIn|HTMLImageElement|000001|Loading|ShowItems|unshift|count|mgctlbxV|MSC|mgctlbxN|clearInterval|10000|temporary|exit|lengthComputable|total|enter|quadIn|webkitURL|URL|form|MAX_VALUE|matrix|matrix3d|active|static|GET|open|responseType|blob|send|createObjectURL|537|_|attachEvent|expoOut|response|circle_08|circle_07|035|795|easeInOutExpo|easeInCirc|04|circle_03|07|855|06|easeOutQuint|easeInOutQuint|335|easeOutCirc|885|circle_01|275|100000|easeInOutBack|735|135|075|circle_02|easeInOutCirc|785|755|easeInQuint|085|445|easeInOutQuad||455|515|easeInOutSine|565|circle_06|745|715|575|955|055|circle_04|895|685|easeOutQuart|easeInOutQuart|easeInQuart|circle_05|675|215|easeInOutCubic|645|quadOut|bar|translateX|fontSize|reflection|translateY|backOut|350|coverFlow|864|backIn|getImageData|255|pinchstart|pinchupdate|getVisibleItems|cubicOut|drawImage|jCopyEvents|font|elasticOut|cloneEvents|sort|Cannot|jRaiseEvent|calculate|getOriginalTarget|detachEvent|custom|JSON|CoverFlow|initEvent|100000000|01|_coverFlow|bounceOut|doScroll|createEventObject|fireEvent||420|cubicIn|putImageData|000244140625|deltaZ|delta|0001|onwheel|deltaFactor|wheel'.split('|'), 0, {}));

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ==================================================
// fancyBox v3.0.47
//
// Licensed GPLv3 for open source use
// or fancyBox Commercial License for commercial use
//
// http://fancyapps.com/fancybox/
// Copyright 2017 fancyApps
//
// ==================================================
!function (t, e, n, o) {
  "use strict";
  function s(t) {
    var e = t.currentTarget,
        o = t.data ? t.data.options : {},
        s = t.data ? t.data.items : [],
        i = "",
        a = 0;t.preventDefault(), t.stopPropagation(), n(e).attr("data-fancybox") && (i = n(e).data("fancybox")), i ? (s = s.length ? s.filter('[data-fancybox="' + i + '"]') : n("[data-fancybox=" + i + "]"), a = s.index(e)) : s = [e], n.fancybox.open(s, o, a);
  }if (!n) return o;var i = { speed: 330, loop: !0, opacity: "auto", margin: [44, 0], gutter: 30, infobar: !0, buttons: !0, slideShow: !0, fullScreen: !0, thumbs: !0, closeBtn: !0, smallBtn: "auto", image: { preload: "auto", protect: !1 }, ajax: { settings: { data: { fancybox: !0 } } }, iframe: { tpl: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen allowtransparency="true" src=""></iframe>', preload: !0, scrolling: "no", css: {} }, baseClass: "", slideClass: "", baseTpl: '<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-controls"><div class="fancybox-infobar"><button data-fancybox-previous class="fancybox-button fancybox-button--left" title="Previous"></button><div class="fancybox-infobar__body"><span class="js-fancybox-index"></span>&nbsp;/&nbsp;<span class="js-fancybox-count"></span></div><button data-fancybox-next class="fancybox-button fancybox-button--right" title="Next"></button></div><div class="fancybox-buttons"><button data-fancybox-close class="fancybox-button fancybox-button--close" title="Close (Esc)"></button></div></div><div class="fancybox-slider-wrap"><div class="fancybox-slider"></div></div><div class="fancybox-caption-wrap"><div class="fancybox-caption"></div></div></div>', spinnerTpl: '<div class="fancybox-loading"></div>', errorTpl: '<div class="fancybox-error"><p>The requested content cannot be loaded. <br /> Please try again later.<p></div>', closeTpl: '<button data-fancybox-close class="fancybox-close-small"></button>', parentEl: "body", touch: !0, keyboard: !0, focus: !0, closeClickOutside: !0, beforeLoad: n.noop, afterLoad: n.noop, beforeMove: n.noop, afterMove: n.noop, onComplete: n.noop, onInit: n.noop, beforeClose: n.noop, afterClose: n.noop, onActivate: n.noop, onDeactivate: n.noop },
      a = n(t),
      r = n(e),
      c = 0,
      l = function l(t) {
    return t && t.hasOwnProperty && t instanceof n;
  },
      u = function () {
    return t.requestAnimationFrame || t.webkitRequestAnimationFrame || t.mozRequestAnimationFrame || function (e) {
      t.setTimeout(e, 1e3 / 60);
    };
  }(),
      d = function d(o) {
    var s;return "function" == typeof n && o instanceof n && (o = o[0]), s = o.getBoundingClientRect(), s.bottom > 0 && s.right > 0 && s.left < (t.innerWidth || e.documentElement.clientWidth) && s.top < (t.innerHeight || e.documentElement.clientHeight);
  },
      p = function p(t, o, s) {
    var a = this;a.opts = n.extend(!0, { index: s }, i, o || {}), a.id = a.opts.id || ++c, a.group = [], a.currIndex = parseInt(a.opts.index, 10) || 0, a.prevIndex = null, a.prevPos = null, a.currPos = 0, a.firstRun = null, a.createGroup(t), a.group.length && (a.$lastFocus = n(e.activeElement).blur(), a.slides = {}, a.init(t));
  };n.extend(p.prototype, { init: function init() {
      var t,
          e,
          o = this,
          s = !1;o.scrollTop = r.scrollTop(), o.scrollLeft = r.scrollLeft(), n.fancybox.getInstance() || (t = n("body").width(), n("html").addClass("fancybox-enabled"), n.fancybox.isTouch ? (n.each(o.group, function (t, e) {
        if ("image" !== e.type && "iframe" !== e.type) return s = !0, !1;
      }), s && n("body").css({ position: "fixed", width: t, top: o.scrollTop * -1 })) : (t = n("body").width() - t, t > 1 && n('<style id="fancybox-noscroll" type="text/css">').html(".compensate-for-scrollbar, .fancybox-enabled body { margin-right: " + t + "px; }").appendTo("head"))), e = n(o.opts.baseTpl).attr("id", "fancybox-container-" + o.id).data("FancyBox", o).addClass(o.opts.baseClass).hide().prependTo(o.opts.parentEl), o.$refs = { container: e, bg: e.find(".fancybox-bg"), controls: e.find(".fancybox-controls"), buttons: e.find(".fancybox-buttons"), slider_wrap: e.find(".fancybox-slider-wrap"), slider: e.find(".fancybox-slider"), caption: e.find(".fancybox-caption") }, o.trigger("onInit"), o.activate(), o.current || o.jumpTo(o.currIndex);
    }, createGroup: function createGroup(t) {
      var e = this,
          s = n.makeArray(t);n.each(s, function (t, s) {
        var i,
            a,
            r,
            c,
            l = {},
            u = {},
            d = [];n.isPlainObject(s) ? (l = s, u = s.opts || {}) : "object" === n.type(s) && n(s).length ? (i = n(s), d = i.data(), u = "options" in d ? d.options : {}, u = "object" === n.type(u) ? u : {}, l.type = "type" in d ? d.type : u.type, l.src = "src" in d ? d.src : u.src || i.attr("href"), u.width = "width" in d ? d.width : u.width, u.height = "height" in d ? d.height : u.height, u.thumb = "thumb" in d ? d.thumb : u.thumb, u.selector = "selector" in d ? d.selector : u.selector, "srcset" in d && (u.image = { srcset: d.srcset }), u.$orig = i) : l = { type: "html", content: s + "" }, l.opts = n.extend(!0, {}, e.opts, u), a = l.type, r = l.src || "", a || (l.content ? a = "html" : r.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i) ? a = "image" : r.match(/\.(pdf)((\?|#).*)?$/i) ? a = "pdf" : "#" === r.charAt(0) && (a = "inline"), l.type = a), l.index = e.group.length, l.opts.$orig && !l.opts.$orig.length && delete l.opts.$orig, !l.opts.$thumb && l.opts.$orig && (l.opts.$thumb = l.opts.$orig.find("img:first")), l.opts.$thumb && !l.opts.$thumb.length && delete l.opts.$thumb, "function" === n.type(l.opts.caption) ? l.opts.caption = l.opts.caption.apply(s, [e, l]) : "caption" in d ? l.opts.caption = d.caption : u.$orig && (l.opts.caption = i.attr("title")), l.opts.caption = l.opts.caption === o ? "" : l.opts.caption + "", "ajax" === a && (c = r.split(/\s+/, 2), c.length > 1 && (l.src = c.shift(), l.opts.selector = c.shift())), "auto" == l.opts.smallBtn && (n.inArray(a, ["html", "inline", "ajax"]) > -1 ? (l.opts.buttons = !1, l.opts.smallBtn = !0) : l.opts.smallBtn = !1), "pdf" === a && (l.type = "iframe", l.opts.closeBtn = !0, l.opts.smallBtn = !1, l.opts.iframe.preload = !1), l.opts.modal && n.extend(!0, l.opts, { infobar: 0, buttons: 0, keyboard: 0, slideShow: 0, fullScreen: 0, closeClickOutside: 0 }), e.group.push(l);
      });
    }, addEvents: function addEvents() {
      var e = this;e.removeEvents(), e.$refs.container.on("click.fb-close", "[data-fancybox-close]", function (t) {
        t.stopPropagation(), t.preventDefault(), e.close(t);
      }).on("click.fb-previous", "[data-fancybox-previous]", function (t) {
        t.stopPropagation(), t.preventDefault(), e.previous();
      }).on("click.fb-next", "[data-fancybox-next]", function (t) {
        t.stopPropagation(), t.preventDefault(), e.next();
      }), n(t).on("orientationchange.fb resize.fb", function (t) {
        u(function () {
          t && t.originalEvent && "resize" === t.originalEvent.type ? e.update() : (e.$refs.slider_wrap.hide(), u(function () {
            e.$refs.slider_wrap.show(), e.update();
          }));
        });
      }), r.on("focusin.fb", function (t) {
        var o = n.fancybox ? n.fancybox.getInstance() : null;!o || n(t.target).hasClass("fancybox-container") || n.contains(o.$refs.container[0], t.target) || (t.stopPropagation(), o.focus(), a.scrollTop(e.scrollTop).scrollLeft(e.scrollLeft));
      }), r.on("keydown.fb", function (t) {
        var o = e.current,
            s = t.keyCode || t.which;if (o && o.opts.keyboard && !n(t.target).is("input") && !n(t.target).is("textarea")) {
          if (8 === s || 27 === s) return t.preventDefault(), void e.close(t);switch (s) {case 37:case 38:
              t.preventDefault(), e.previous();break;case 39:case 40:
              t.preventDefault(), e.next();break;case 80:case 32:
              t.preventDefault(), e.SlideShow && (t.preventDefault(), e.SlideShow.toggle());break;case 70:
              e.FullScreen && (t.preventDefault(), e.FullScreen.toggle());break;case 71:
              e.Thumbs && (t.preventDefault(), e.Thumbs.toggle());}
        }
      });
    }, removeEvents: function removeEvents() {
      a.off("scroll.fb resize.fb orientationchange.fb"), r.off("keydown.fb focusin.fb click.fb-close"), this.$refs.container.off("click.fb-close click.fb-previous click.fb-next");
    }, previous: function previous(t) {
      this.jumpTo(this.currIndex - 1, t);
    }, next: function next(t) {
      this.jumpTo(this.currIndex + 1, t);
    }, jumpTo: function jumpTo(t, e) {
      var n,
          s,
          i,
          a,
          r = this;if (n = r.firstRun = null === r.firstRun, s = i = t = parseInt(t, 10), a = !!r.current && r.current.opts.loop, !r.isAnimating && (s != r.currIndex || n)) {
        if (r.group.length > 1 && a) s %= r.group.length, s = s < 0 ? r.group.length + s : s, 2 == r.group.length ? i = t - r.currIndex + r.currPos : (i = s - r.currIndex + r.currPos, Math.abs(r.currPos - (i + r.group.length)) < Math.abs(r.currPos - i) ? i += r.group.length : Math.abs(r.currPos - (i - r.group.length)) < Math.abs(r.currPos - i) && (i -= r.group.length));else if (!r.group[s]) return void r.update(!1, !1, e);r.current && (r.current.$slide.removeClass("fancybox-slide--current fancybox-slide--complete"), r.updateSlide(r.current, !0)), r.prevIndex = r.currIndex, r.prevPos = r.currPos, r.currIndex = s, r.currPos = i, r.current = r.createSlide(i), r.group.length > 1 && ((r.opts.loop || i - 1 >= 0) && r.createSlide(i - 1), (r.opts.loop || i + 1 < r.group.length) && r.createSlide(i + 1)), r.current.isMoved = !1, r.current.isComplete = !1, e = parseInt(e === o ? 1.5 * r.current.opts.speed : e, 10), r.trigger("beforeMove"), r.updateControls(), n && (r.current.$slide.addClass("fancybox-slide--current"), r.$refs.container.show(), u(function () {
          r.$refs.bg.css("transition-duration", r.current.opts.speed + "ms"), r.$refs.container.addClass("fancybox-container--ready");
        })), r.update(!0, !1, n ? 0 : e, function () {
          r.afterMove();
        }), r.loadSlide(r.current), n && r.current.$ghost || r.preload();
      }
    }, createSlide: function createSlide(t) {
      var e,
          o,
          s,
          i = this;if (o = t % i.group.length, o = o < 0 ? i.group.length + o : o, !i.slides[t] && i.group[o]) {
        if (i.opts.loop && i.group.length > 2) for (var a in i.slides) {
          if (i.slides[a].index === o) return s = i.slides[a], s.pos = t, i.slides[t] = s, delete i.slides[a], i.updateSlide(s), s;
        }e = n('<div class="fancybox-slide"></div>').appendTo(i.$refs.slider), i.slides[t] = n.extend(!0, {}, i.group[o], { pos: t, $slide: e, isMoved: !1, isLoaded: !1 });
      }return i.slides[t];
    }, zoomInOut: function zoomInOut(t, e, o) {
      var s,
          i,
          a,
          r = this,
          c = r.current,
          l = c.$placeholder,
          u = c.opts.opacity,
          p = c.opts.$thumb,
          h = p ? p.offset() : 0,
          f = c.$slide.offset();return !!(l && c.isMoved && h && d(p)) && !("In" === t && !r.firstRun) && (n.fancybox.stop(l), r.isAnimating = !0, s = { top: h.top - f.top + parseFloat(p.css("border-top-width") || 0), left: h.left - f.left + parseFloat(p.css("border-left-width") || 0), width: p.width(), height: p.height(), scaleX: 1, scaleY: 1 }, "auto" == u && (u = Math.abs(c.width / c.height - s.width / s.height) > .1), "In" === t ? (i = s, a = r.getFitPos(c), a.scaleX = a.width / i.width, a.scaleY = a.height / i.height, u && (i.opacity = .1, a.opacity = 1)) : (i = n.fancybox.getTranslate(l), a = s, c.$ghost && (c.$ghost.show(), c.$image && c.$image.remove()), i.scaleX = i.width / a.width, i.scaleY = i.height / a.height, i.width = a.width, i.height = a.height, u && (a.opacity = 0)), r.updateCursor(a.width, a.height), delete a.width, delete a.height, n.fancybox.setTranslate(l, i), l.show(), r.trigger("beforeZoom" + t), l.css("transition", "all " + e + "ms"), n.fancybox.setTranslate(l, a), setTimeout(function () {
        var e;l.css("transition", "none"), e = n.fancybox.getTranslate(l), e.scaleX = 1, e.scaleY = 1, n.fancybox.setTranslate(l, e), r.trigger("afterZoom" + t), o.apply(r), r.isAnimating = !1;
      }, e), !0);
    }, canPan: function canPan() {
      var t = this,
          e = t.current,
          n = e.$placeholder,
          o = !1;return n && (o = t.getFitPos(e), o = Math.abs(n.width() - o.width) > 1 || Math.abs(n.height() - o.height) > 1), o;
    }, isScaledDown: function isScaledDown() {
      var t = this,
          e = t.current,
          o = e.$placeholder,
          s = !1;return o && (s = n.fancybox.getTranslate(o), s = s.width < e.width || s.height < e.height), s;
    }, scaleToActual: function scaleToActual(t, e, s) {
      var i,
          a,
          r,
          c,
          l,
          u = this,
          d = u.current,
          p = d.$placeholder,
          h = parseInt(d.$slide.width(), 10),
          f = parseInt(d.$slide.height(), 10),
          g = d.width,
          b = d.height;p && (u.isAnimating = !0, t = t === o ? .5 * h : t, e = e === o ? .5 * f : e, i = n.fancybox.getTranslate(p), c = g / i.width, l = b / i.height, a = .5 * h - .5 * g, r = .5 * f - .5 * b, g > h && (a = i.left * c - (t * c - t), a > 0 && (a = 0), a < h - g && (a = h - g)), b > f && (r = i.top * l - (e * l - e), r > 0 && (r = 0), r < f - b && (r = f - b)), u.updateCursor(g, b), n.fancybox.animate(p, null, { top: r, left: a, scaleX: c, scaleY: l }, s || d.opts.speed, function () {
        u.isAnimating = !1;
      }));
    }, scaleToFit: function scaleToFit(t) {
      var e,
          o = this,
          s = o.current,
          i = s.$placeholder;i && (o.isAnimating = !0, e = o.getFitPos(s), o.updateCursor(e.width, e.height), n.fancybox.animate(i, null, { top: e.top, left: e.left, scaleX: e.width / i.width(), scaleY: e.height / i.height() }, t || s.opts.speed, function () {
        o.isAnimating = !1;
      }));
    }, getFitPos: function getFitPos(t) {
      var e,
          o,
          s,
          i,
          r,
          c,
          l,
          u = t.$placeholder || t.$content,
          d = t.width,
          p = t.height,
          h = t.opts.margin;return !(!u || !u.length || !d && !p) && ("number" === n.type(h) && (h = [h, h]), 2 == h.length && (h = [h[0], h[1], h[0], h[1]]), a.width() < 800 && (h = [0, 0, 0, 0]), e = parseInt(t.$slide.width(), 10) - (h[1] + h[3]), o = parseInt(t.$slide.height(), 10) - (h[0] + h[2]), s = Math.min(1, e / d, o / p), c = Math.floor(s * d), l = Math.floor(s * p), i = Math.floor(.5 * (o - l)) + h[0], r = Math.floor(.5 * (e - c)) + h[3], { top: i, left: r, width: c, height: l });
    }, update: function update(t, e, o, s) {
      var i,
          a = this;a.isAnimating !== !0 && a.current && (i = a.current.pos * Math.floor(a.current.$slide.width()) * -1 - a.current.pos * a.current.opts.gutter, o = parseInt(o, 10) || 0, n.fancybox.stop(a.$refs.slider), t === !1 ? a.updateSlide(a.current, e) : n.each(a.slides, function (t, n) {
        a.updateSlide(n, e);
      }), o ? n.fancybox.animate(a.$refs.slider, null, { top: 0, left: i }, o, function () {
        a.current.isMoved = !0, "function" === n.type(s) && s.apply(a);
      }) : (n.fancybox.setTranslate(a.$refs.slider, { top: 0, left: i }), a.current.isMoved = !0, "function" === n.type(s) && s.apply(a)));
    }, updateSlide: function updateSlide(t, e) {
      var o,
          s = this,
          i = t.$placeholder;t = t || s.current, t && !s.isClosing && (o = t.pos * Math.floor(t.$slide.width()) + t.pos * t.opts.gutter, o !== t.leftPos && (n.fancybox.setTranslate(t.$slide, { top: 0, left: o }), t.leftPos = o), e !== !1 && i && (n.fancybox.setTranslate(i, s.getFitPos(t)), t.pos === s.currPos && s.updateCursor()), t.$slide.trigger("refresh"), s.trigger("onUpdate", t));
    }, updateCursor: function updateCursor(t, e) {
      var n,
          s = this,
          i = s.$refs.container.removeClass("fancybox-controls--canzoomIn fancybox-controls--canzoomOut fancybox-controls--canGrab");!s.isClosing && s.opts.touch && (n = t !== o && e !== o ? t < s.current.width && e < s.current.height : s.isScaledDown(), n ? i.addClass("fancybox-controls--canzoomIn") : s.group.length < 2 ? i.addClass("fancybox-controls--canzoomOut") : i.addClass("fancybox-controls--canGrab"));
    }, loadSlide: function loadSlide(t) {
      var e,
          o,
          s,
          i = this;if (t && !t.isLoaded && !t.isLoading) {
        switch (t.isLoading = !0, i.trigger("beforeLoad", t), e = t.type, o = t.$slide, o.off("refresh").trigger("onReset").addClass("fancybox-slide--" + (e || "unknown")).addClass(t.opts.slideClass), e) {case "image":
            i.setImage(t);break;case "iframe":
            i.setIframe(t);break;case "html":
            i.setContent(t, t.content);break;case "inline":
            n(t.src).length ? i.setContent(t, n(t.src)) : i.setError(t);break;case "ajax":
            i.showLoading(t), s = n.ajax(n.extend({}, t.opts.ajax.settings, { url: t.src, success: function success(e, n) {
                "success" === n && i.setContent(t, e);
              }, error: function error(e, n) {
                e && "abort" !== n && i.setError(t);
              } })), o.one("onReset", function () {
              s.abort();
            });break;default:
            i.setError(t);}return !0;
      }
    }, setImage: function setImage(e) {
      var o,
          s,
          i,
          a,
          r = this,
          c = e.opts.image.srcset;if (e.isLoaded && !e.hasError) return void r.afterLoad(e);if (c) {
        i = t.devicePixelRatio || 1, a = t.innerWidth * i, s = c.split(",").map(function (t) {
          var e = {};return t.trim().split(/\s+/).forEach(function (t, n) {
            var o = parseInt(t.substring(0, t.length - 1), 10);return 0 === n ? e.url = t : void (o && (e.value = o, e.postfix = t[t.length - 1]));
          }), e;
        }), s.sort(function (t, e) {
          return t.value - e.value;
        });for (var l = 0; l < s.length; l++) {
          var u = s[l];if ("w" === u.postfix && u.value >= a || "x" === u.postfix && u.value >= i) {
            o = u;break;
          }
        }!o && s.length && (o = s[s.length - 1]), o && (e.src = o.url, e.width && e.height && "w" == o.postfix && (e.height = e.width / e.height * o.value, e.width = o.value));
      }e.$placeholder = n('<div class="fancybox-placeholder"></div>').hide().appendTo(e.$slide), e.opts.preload !== !1 && e.opts.width && e.opts.height && (e.opts.thumb || e.opts.$thumb) ? (e.width = e.opts.width, e.height = e.opts.height, e.$ghost = n("<img />").one("load error", function () {
        r.isClosing || (n("<img/>")[0].src = e.src, r.revealImage(e, function () {
          r.setBigImage(e), r.firstRun && e.index === r.currIndex && r.preload();
        }));
      }).addClass("fancybox-image").appendTo(e.$placeholder).attr("src", e.opts.thumb || e.opts.$thumb.attr("src"))) : r.setBigImage(e);
    }, setBigImage: function setBigImage(t) {
      var e = this,
          o = n("<img />");t.$image = o.one("error", function () {
        e.setError(t);
      }).one("load", function () {
        clearTimeout(t.timouts), t.timouts = null, e.isClosing || (t.width = this.naturalWidth, t.height = this.naturalHeight, t.opts.image.srcset && o.attr("sizes", "100vw").attr("srcset", t.opts.image.srcset), e.afterLoad(t), t.$ghost && (t.timouts = setTimeout(function () {
          t.$ghost.hide();
        }, 350)));
      }).addClass("fancybox-image").attr("src", t.src).appendTo(t.$placeholder), o[0].complete ? o.trigger("load") : o[0].error ? o.trigger("error") : t.timouts = setTimeout(function () {
        o[0].complete || t.hasError || e.showLoading(t);
      }, 150), t.opts.image.protect && n('<div class="fancybox-spaceball"></div>').appendTo(t.$placeholder).on("contextmenu.fb", function (t) {
        return 2 == t.button && t.preventDefault(), !0;
      });
    }, revealImage: function revealImage(t, e) {
      var o = this;return e = e || n.noop, "image" !== t.type || t.hasError || t.isRevealed === !0 ? void e.apply(o) : (t.isRevealed = !0, void (t.pos === o.currPos && o.zoomInOut("In", t.opts.speed, e) || (t.$ghost && !t.isLoaded && o.updateSlide(t, !0), t.pos === o.currPos ? n.fancybox.animate(t.$placeholder, { opacity: 0 }, { opacity: 1 }, 300, e) : t.$placeholder.show(), e.apply(o))));
    }, setIframe: function setIframe(t) {
      var e,
          s = this,
          i = t.opts.iframe,
          a = t.$slide;t.$content = n('<div class="fancybox-content"></div>').css(i.css).appendTo(a), e = n(i.tpl.replace(/\{rnd\}/g, new Date().getTime())).attr("scrolling", n.fancybox.isTouch ? "auto" : i.scrolling).appendTo(t.$content), i.preload ? (t.$content.addClass("fancybox-tmp"), s.showLoading(t), e.on("load.fb error.fb", function (e) {
        this.isReady = 1, t.$slide.trigger("refresh"), s.afterLoad(t);
      }), a.on("refresh.fb", function () {
        var n,
            s,
            a,
            r,
            c,
            l = t.$content;if (1 === e[0].isReady) {
          try {
            n = e.contents(), s = n.find("body");
          } catch (t) {}s && s.length && (i.css.width === o || i.css.height === o) && (a = e[0].contentWindow.document.documentElement.scrollWidth, r = Math.ceil(s.outerWidth(!0) + (l.width() - a)), c = Math.ceil(s.outerHeight(!0)), l.css({ width: i.css.width === o ? r + (l.outerWidth() - l.innerWidth()) : i.css.width, height: i.css.height === o ? c + (l.outerHeight() - l.innerHeight()) : i.css.height })), l.removeClass("fancybox-tmp");
        }
      })) : this.afterLoad(t), e.attr("src", t.src), t.opts.smallBtn && t.$content.prepend(t.opts.closeTpl), a.one("onReset", function () {
        try {
          n(this).find("iframe").hide().attr("src", "//about:blank");
        } catch (t) {}n(this).empty(), t.isLoaded = !1;
      });
    }, setContent: function setContent(t, e) {
      var o = this;o.isClosing || (o.hideLoading(t), t.$slide.empty(), l(e) && e.parent().length ? (e.data("placeholder") && e.parents(".fancybox-slide").trigger("onReset"), e.data({ placeholder: n("<div></div>").hide().insertAfter(e) }).css("display", "inline-block")) : ("string" === n.type(e) && (e = n("<div>").append(e).contents(), 3 === e[0].nodeType && (e = n("<div>").html(e))), t.opts.selector && (e = n("<div>").html(e).find(t.opts.selector))), t.$slide.one("onReset", function () {
        var o = l(e) ? e.data("placeholder") : 0;o && (e.hide().replaceAll(o), e.data("placeholder", null)), t.hasError || (n(this).empty(), t.isLoaded = !1);
      }), t.$content = n(e).appendTo(t.$slide), t.opts.smallBtn === !0 && t.$content.find(".fancybox-close-small").remove().end().eq(0).append(t.opts.closeTpl), this.afterLoad(t));
    }, setError: function setError(t) {
      t.hasError = !0, this.setContent(t, t.opts.errorTpl);
    }, showLoading: function showLoading(t) {
      var e = this;t = t || e.current, t && !t.$spinner && (t.$spinner = n(e.opts.spinnerTpl).appendTo(t.$slide));
    }, hideLoading: function hideLoading(t) {
      var e = this;t = t || e.current, t && t.$spinner && (t.$spinner.remove(), delete t.$spinner);
    }, afterMove: function afterMove() {
      var t = this,
          e = t.current,
          o = {};e && (e.$slide.siblings().trigger("onReset"), n.each(t.slides, function (e, n) {
        n.pos >= t.currPos - 1 && n.pos <= t.currPos + 1 ? o[n.pos] = n : n && n.$slide.remove();
      }), t.slides = o, t.trigger("afterMove"), e.isLoaded && t.complete());
    }, afterLoad: function afterLoad(t) {
      var e = this;e.isClosing || (t.isLoading = !1, t.isLoaded = !0, e.trigger("afterLoad", t), e.hideLoading(t), t.$ghost || e.updateSlide(t, !0), t.index === e.currIndex && t.isMoved ? e.complete() : t.$ghost || e.revealImage(t));
    }, complete: function complete() {
      var t = this,
          e = t.current;t.revealImage(e, function () {
        e.isComplete = !0, e.$slide.addClass("fancybox-slide--complete"), t.updateCursor(), t.trigger("onComplete"), e.opts.focus && "image" !== e.type && "iframe" !== e.type && t.focus();
      });
    }, preload: function preload() {
      var t,
          e,
          n = this;n.group.length < 2 || (t = n.slides[n.currPos + 1], e = n.slides[n.currPos - 1], t && "image" === t.type && n.loadSlide(t), e && "image" === e.type && n.loadSlide(e));
    }, focus: function focus() {
      var t,
          e = this.current;t = e && e.isComplete ? e.$slide.find('button,:input,[tabindex],a:not(".disabled")').filter(":visible:first") : null, t && t.length || (t = this.$refs.container), t.focus(), this.$refs.slider_wrap.scrollLeft(0), e && e.$slide.scrollTop(0);
    }, activate: function activate() {
      var t = this;n(".fancybox-container").each(function () {
        var e = n(this).data("FancyBox");e && e.uid !== t.uid && !e.isClosing && e.trigger("onDeactivate");
      }), t.current && (t.$refs.container.index() > 0 && t.$refs.container.prependTo(e.body), t.updateControls()), t.trigger("onActivate"), t.addEvents();
    }, close: function close(t) {
      var e = this,
          o = e.current,
          s = o.opts.speed,
          i = n.proxy(function () {
        e.cleanUp(t);
      }, this);return !e.isAnimating && !e.isClosing && (e.trigger("beforeClose", t) === !1 ? (n.fancybox.stop(e.$refs.slider), void u(function () {
        e.update(!0, !0, 150);
      })) : (e.isClosing = !0, o.timouts && clearTimeout(o.timouts), t !== !0 && n.fancybox.stop(e.$refs.slider), e.$refs.container.removeClass("fancybox-container--active").addClass("fancybox-container--closing"), o.$slide.removeClass("fancybox-slide--complete").siblings().remove(), o.isMoved || o.$slide.css("overflow", "visible"), e.removeEvents(), e.hideLoading(o), e.hideControls(), e.updateCursor(), e.$refs.bg.css("transition-duration", s + "ms"), this.$refs.container.removeClass("fancybox-container--ready"), void (t === !0 ? setTimeout(i, s) : e.zoomInOut("Out", s, i) || n.fancybox.animate(e.$refs.container, null, { opacity: 0 }, s, "easeInSine", i))));
    }, cleanUp: function cleanUp(t) {
      var e,
          o = this;o.$refs.slider.children().trigger("onReset"), o.$refs.container.empty().remove(), o.trigger("afterClose", t), o.current = null, e = n.fancybox.getInstance(), e ? e.activate() : (n("html").removeClass("fancybox-enabled"), n("body").removeAttr("style"), a.scrollTop(o.scrollTop).scrollLeft(o.scrollLeft), n("#fancybox-noscroll").remove()), o.$lastFocus && o.$lastFocus.focus();
    }, trigger: function trigger(t, o) {
      var s,
          i = Array.prototype.slice.call(arguments, 1),
          a = this,
          r = o && o.opts ? o : a.current;return r ? i.unshift(r) : r = a, i.unshift(a), n.isFunction(r.opts[t]) && (s = r.opts[t].apply(r, i)), s === !1 ? s : void ("afterClose" === t ? n(e).trigger(t + ".fb", i) : a.$refs.container.trigger(t + ".fb", i));
    }, toggleControls: function toggleControls(t) {
      this.isHiddenControls ? this.updateControls(t) : this.hideControls();
    }, hideControls: function hideControls() {
      this.isHiddenControls = !0, this.$refs.container.removeClass("fancybox-show-controls"), this.$refs.container.removeClass("fancybox-show-caption");
    }, updateControls: function updateControls(t) {
      var e = this,
          o = e.$refs.container,
          s = e.$refs.caption,
          i = e.current,
          a = i.index,
          r = i.opts,
          c = r.caption;this.isHiddenControls && t !== !0 || (this.isHiddenControls = !1, o.addClass("fancybox-show-controls").toggleClass("fancybox-show-infobar", !!r.infobar && e.group.length > 1).toggleClass("fancybox-show-buttons", !!r.buttons).toggleClass("fancybox-is-modal", !!r.modal), n(".fancybox-button--left", o).toggleClass("fancybox-button--disabled", !r.loop && a <= 0), n(".fancybox-button--right", o).toggleClass("fancybox-button--disabled", !r.loop && a >= e.group.length - 1), n(".fancybox-button--play", o).toggle(!!(r.slideShow && e.group.length > 1)), n(".fancybox-button--close", o).toggle(!!r.closeBtn), n(".js-fancybox-count", o).html(e.group.length), n(".js-fancybox-index", o).html(a + 1), i.$slide.trigger("refresh"), s && s.empty(), c && c.length ? (s.html(c), this.$refs.container.addClass("fancybox-show-caption "), e.$caption = s) : this.$refs.container.removeClass("fancybox-show-caption"));
    } }), n.fancybox = { version: "3.0.47", defaults: i, getInstance: function getInstance(t) {
      var e = n('.fancybox-container:not(".fancybox-container--closing"):first').data("FancyBox"),
          o = Array.prototype.slice.call(arguments, 1);return e instanceof p && ("string" === n.type(t) ? e[t].apply(e, o) : "function" === n.type(t) && t.apply(e, o), e);
    }, open: function open(t, e, n) {
      return new p(t, e, n);
    }, close: function close(t) {
      var e = this.getInstance();e && (e.close(), t === !0 && this.close());
    }, isTouch: e.createTouch !== o && /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent), use3d: function () {
      var n = e.createElement("div");return t.getComputedStyle(n).getPropertyValue("transform") && !(e.documentMode && e.documentMode <= 11);
    }(), getTranslate: function getTranslate(t) {
      var e, n;return !(!t || !t.length) && (e = t.get(0).getBoundingClientRect(), n = t.eq(0).css("transform"), n && n.indexOf("matrix") !== -1 ? (n = n.split("(")[1], n = n.split(")")[0], n = n.split(",")) : n = [], n.length ? (n = n.length > 10 ? [n[13], n[12], n[0], n[5]] : [n[5], n[4], n[0], n[3]], n = n.map(parseFloat)) : n = [0, 0, 1, 1], { top: n[0], left: n[1], scaleX: n[2], scaleY: n[3], opacity: parseFloat(t.css("opacity")), width: e.width, height: e.height });
    }, setTranslate: function setTranslate(t, e) {
      var n = "",
          s = {};if (t && e) return e.left === o && e.top === o || (n = (e.left === o ? t.position().top : e.left) + "px, " + (e.top === o ? t.position().top : e.top) + "px", n = this.use3d ? "translate3d(" + n + ", 0px)" : "translate(" + n + ")"), e.scaleX !== o && e.scaleY !== o && (n = (n.length ? n + " " : "") + "scale(" + e.scaleX + ", " + e.scaleY + ")"), n.length && (s.transform = n), e.opacity !== o && (s.opacity = e.opacity), e.width !== o && (s.width = e.width), e.height !== o && (s.height = e.height), t.css(s);
    }, easing: { easeOutCubic: function easeOutCubic(t, e, n, o) {
        return n * ((t = t / o - 1) * t * t + 1) + e;
      }, easeInCubic: function easeInCubic(t, e, n, o) {
        return n * (t /= o) * t * t + e;
      }, easeOutSine: function easeOutSine(t, e, n, o) {
        return n * Math.sin(t / o * (Math.PI / 2)) + e;
      }, easeInSine: function easeInSine(t, e, n, o) {
        return -n * Math.cos(t / o * (Math.PI / 2)) + n + e;
      } }, stop: function stop(t) {
      t.removeData("animateID");
    }, animate: function animate(t, e, s, i, a, r) {
      var c,
          l,
          d,
          p = this,
          h = null,
          f = 0,
          g = function g() {
        s.scaleX !== o && s.scaleY !== o && e && e.width !== o && e.height !== o && (s.width = e.width * s.scaleX, s.height = e.height * s.scaleY, s.scaleX = 1, s.scaleY = 1), p.setTranslate(t, s), r();
      },
          b = function b(n) {
        if (c = [], l = 0, t.length && t.data("animateID") === d) {
          if (n = n || Date.now(), h && (l = n - h), h = n, f += l, f >= i) return void g();for (var r in s) {
            s.hasOwnProperty(r) && e[r] !== o && (e[r] == s[r] ? c[r] = s[r] : c[r] = p.easing[a](f, e[r], s[r] - e[r], i));
          }p.setTranslate(t, c), u(b);
        }
      };p.animateID = d = p.animateID === o ? 1 : p.animateID + 1, t.data("animateID", d), r === o && "function" == n.type(a) && (r = a, a = o), a || (a = "easeOutCubic"), r = r || n.noop, e ? this.setTranslate(t, e) : e = this.getTranslate(t), i ? (t.show(), u(b)) : g();
    } }, n.fn.fancybox = function (t) {
    return this.off("click.fb-start").on("click.fb-start", { items: this, options: t || {} }, s), this;
  }, n(e).on("click.fb-start", "[data-fancybox]", s);
}(window, document, window.jQuery), function (t) {
  "use strict";
  var e = function e(_e, n, o) {
    if (_e) return o = o || "", "object" === t.type(o) && (o = t.param(o, !0)), t.each(n, function (t, n) {
      _e = _e.replace("$" + t, n || "");
    }), o.length && (_e += (_e.indexOf("?") > 0 ? "&" : "?") + o), _e;
  },
      n = { youtube: { matcher: /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i, params: { autoplay: 1, autohide: 1, fs: 1, rel: 0, hd: 1, wmode: "transparent", enablejsapi: 1, html5: 1 }, paramPlace: 8, type: "iframe", url: "//www.youtube.com/embed/$4", thumb: "//img.youtube.com/vi/$4/hqdefault.jpg" }, vimeo: { matcher: /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/, params: { autoplay: 1, hd: 1, show_title: 1, show_byline: 1, show_portrait: 0, fullscreen: 1, api: 1 }, paramPlace: 3, type: "iframe", url: "//player.vimeo.com/video/$2" }, metacafe: { matcher: /metacafe.com\/watch\/(\d+)\/(.*)?/, type: "iframe", url: "//www.metacafe.com/embed/$1/?ap=1" }, dailymotion: { matcher: /dailymotion.com\/video\/(.*)\/?(.*)/, params: { additionalInfos: 0, autoStart: 1 }, type: "iframe", url: "//www.dailymotion.com/embed/video/$1" }, vine: { matcher: /vine.co\/v\/([a-zA-Z0-9\?\=\-]+)/, type: "iframe", url: "//vine.co/v/$1/embed/simple" }, instagram: { matcher: /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i, type: "image", url: "//$1/p/$2/media/?size=l" }, google_maps: { matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i, type: "iframe", url: function url(t) {
        return "//maps.google." + t[2] + "/?ll=" + (t[9] ? t[9] + "&z=" + Math.floor(t[10]) + (t[12] ? t[12].replace(/^\//, "&") : "") : t[12]) + "&output=" + (t[12] && t[12].indexOf("layer=c") > 0 ? "svembed" : "embed");
      } } };t(document).on("onInit.fb", function (o, s) {
    t.each(s.group, function (o, s) {
      var i,
          a,
          r,
          c,
          l,
          u,
          d = s.src || "",
          p = !1;s.type || (t.each(n, function (n, o) {
        if (a = d.match(o.matcher), l = {}, u = n, a) {
          if (p = o.type, o.paramPlace && a[o.paramPlace]) {
            c = a[o.paramPlace], "?" == c[0] && (c = c.substring(1)), c = c.split("&");for (var h = 0; h < c.length; ++h) {
              var f = c[h].split("=", 2);2 == f.length && (l[f[0]] = decodeURIComponent(f[1].replace(/\+/g, " ")));
            }
          }return r = t.extend(!0, {}, o.params, s.opts[n], l), d = "function" === t.type(o.url) ? o.url.call(this, a, r, s) : e(o.url, a, r), i = "function" === t.type(o.thumb) ? o.thumb.call(this, a, r, s) : e(o.thumb, a), "vimeo" === u && (d = d.replace("&%23", "#")), !1;
        }
      }), p ? (s.src = d, s.type = p, s.opts.thumb || s.opts.$thumb && s.opts.$thumb.length || (s.opts.thumb = i), "iframe" === p && (t.extend(!0, s.opts, { iframe: { preload: !1, scrolling: "no" }, smallBtn: !1, closeBtn: !0, fullScreen: !1, slideShow: !1 }), s.opts.slideClass += " fancybox-slide--video")) : s.type = "iframe");
    });
  });
}(window.jQuery), function (t, e, n) {
  "use strict";
  var o = function () {
    return t.requestAnimationFrame || t.webkitRequestAnimationFrame || t.mozRequestAnimationFrame || function (e) {
      t.setTimeout(e, 1e3 / 60);
    };
  }(),
      s = function s(e) {
    var n = [];e = e.originalEvent || e || t.e, e = e.touches && e.touches.length ? e.touches : e.changedTouches && e.changedTouches.length ? e.changedTouches : [e];for (var o in e) {
      e[o].pageX ? n.push({ x: e[o].pageX, y: e[o].pageY }) : e[o].clientX && n.push({ x: e[o].clientX, y: e[o].clientY });
    }return n;
  },
      i = function i(t, e, n) {
    return e && t ? "x" === n ? t.x - e.x : "y" === n ? t.y - e.y : Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2)) : 0;
  },
      a = function a(t) {
    return t.is("a") || t.is("button") || t.is("input") || t.is("select") || t.is("textarea") || n.isFunction(t.get(0).onclick);
  },
      r = function r(e) {
    var n = t.getComputedStyle(e)["overflow-y"],
        o = t.getComputedStyle(e)["overflow-x"],
        s = ("scroll" === n || "auto" === n) && e.scrollHeight > e.clientHeight,
        i = ("scroll" === o || "auto" === o) && e.scrollWidth > e.clientWidth;return s || i;
  },
      c = function c(t) {
    for (var e = !1;;) {
      if (e = r(t.get(0))) break;if (t = t.parent(), !t.length || t.hasClass("fancybox-slider") || t.is("body")) break;
    }return e;
  },
      l = function l(t) {
    var e = this;e.instance = t, e.$wrap = t.$refs.slider_wrap, e.$slider = t.$refs.slider, e.$container = t.$refs.container, e.destroy(), e.$wrap.on("touchstart.fb mousedown.fb", n.proxy(e, "ontouchstart"));
  };l.prototype.destroy = function () {
    this.$wrap.off("touchstart.fb mousedown.fb touchmove.fb mousemove.fb touchend.fb touchcancel.fb mouseup.fb mouseleave.fb");
  }, l.prototype.ontouchstart = function (e) {
    var o = this,
        r = n(e.target),
        l = o.instance,
        u = l.current,
        d = u.$content || u.$placeholder;return o.startPoints = s(e), o.$target = r, o.$content = d, o.canvasWidth = Math.round(u.$slide[0].clientWidth), o.canvasHeight = Math.round(u.$slide[0].clientHeight), o.startEvent = e, e.originalEvent.clientX > o.canvasWidth + u.$slide.offset().left || (a(r) || a(r.parent()) || c(r) ? void 0 : u.opts.touch ? void (e.originalEvent && 2 == e.originalEvent.button || (e.stopPropagation(), e.preventDefault(), !u || o.instance.isAnimating || o.instance.isClosing || !o.startPoints || o.startPoints.length > 1 && !u.isMoved || (o.$wrap.off("touchmove.fb mousemove.fb", n.proxy(o, "ontouchmove")), o.$wrap.off("touchend.fb touchcancel.fb mouseup.fb mouseleave.fb", n.proxy(o, "ontouchend")), o.$wrap.on("touchend.fb touchcancel.fb mouseup.fb mouseleave.fb", n.proxy(o, "ontouchend")), o.$wrap.on("touchmove.fb mousemove.fb", n.proxy(o, "ontouchmove")), o.startTime = new Date().getTime(), o.distanceX = o.distanceY = o.distance = 0, o.canTap = !1, o.isPanning = !1, o.isSwiping = !1, o.isZooming = !1, o.sliderStartPos = n.fancybox.getTranslate(o.$slider), o.contentStartPos = n.fancybox.getTranslate(o.$content), o.contentLastPos = null, 1 !== o.startPoints.length || o.isZooming || (o.canTap = u.isMoved, "image" === u.type && (o.contentStartPos.width > o.canvasWidth + 1 || o.contentStartPos.height > o.canvasHeight + 1) ? (n.fancybox.stop(o.$content), o.isPanning = !0) : (n.fancybox.stop(o.$slider), o.isSwiping = !0), o.$container.addClass("fancybox-controls--isGrabbing")), 2 === o.startPoints.length && u.isMoved && !u.hasError && "image" === u.type && (u.isLoaded || u.$ghost) && (o.isZooming = !0, o.isSwiping = !1, o.isPanning = !1, n.fancybox.stop(o.$content), o.centerPointStartX = .5 * (o.startPoints[0].x + o.startPoints[1].x) - n(t).scrollLeft(), o.centerPointStartY = .5 * (o.startPoints[0].y + o.startPoints[1].y) - n(t).scrollTop(), o.percentageOfImageAtPinchPointX = (o.centerPointStartX - o.contentStartPos.left) / o.contentStartPos.width, o.percentageOfImageAtPinchPointY = (o.centerPointStartY - o.contentStartPos.top) / o.contentStartPos.height, o.startDistanceBetweenFingers = i(o.startPoints[0], o.startPoints[1]))))) : (o.endPoints = o.startPoints, o.ontap()));
  }, l.prototype.ontouchmove = function (t) {
    var e = this;t.preventDefault(), e.newPoints = s(t), e.newPoints && e.newPoints.length && (e.distanceX = i(e.newPoints[0], e.startPoints[0], "x"), e.distanceY = i(e.newPoints[0], e.startPoints[0], "y"), e.distance = i(e.newPoints[0], e.startPoints[0]), e.distance > 0 && (e.isSwiping ? e.onSwipe() : e.isPanning ? e.onPan() : e.isZooming && e.onZoom()));
  }, l.prototype.onSwipe = function () {
    var e,
        s = this,
        i = s.isSwiping,
        a = s.sliderStartPos.left;i === !0 ? Math.abs(s.distance) > 10 && (s.instance.group.length < 2 ? s.isSwiping = "y" : !s.instance.current.isMoved || s.instance.opts.touch.vertical === !1 || "auto" === s.instance.opts.touch.vertical && n(t).width() > 800 ? s.isSwiping = "x" : (e = Math.abs(180 * Math.atan2(s.distanceY, s.distanceX) / Math.PI), s.isSwiping = e > 45 && e < 135 ? "y" : "x"), s.canTap = !1, s.instance.current.isMoved = !1, s.startPoints = s.newPoints) : ("x" == i && (!s.instance.current.opts.loop && 0 === s.instance.current.index && s.distanceX > 0 ? a += Math.pow(s.distanceX, .8) : !s.instance.current.opts.loop && s.instance.current.index === s.instance.group.length - 1 && s.distanceX < 0 ? a -= Math.pow(-s.distanceX, .8) : a += s.distanceX), s.sliderLastPos = { top: "x" == i ? 0 : s.sliderStartPos.top + s.distanceY, left: a }, o(function () {
      n.fancybox.setTranslate(s.$slider, s.sliderLastPos);
    }));
  }, l.prototype.onPan = function () {
    var t,
        e,
        s,
        i = this;i.canTap = !1, t = i.contentStartPos.width > i.canvasWidth ? i.contentStartPos.left + i.distanceX : i.contentStartPos.left, e = i.contentStartPos.top + i.distanceY, s = i.limitMovement(t, e, i.contentStartPos.width, i.contentStartPos.height), s.scaleX = i.contentStartPos.scaleX, s.scaleY = i.contentStartPos.scaleY, i.contentLastPos = s, o(function () {
      n.fancybox.setTranslate(i.$content, i.contentLastPos);
    });
  }, l.prototype.limitMovement = function (t, e, n, o) {
    var s,
        i,
        a,
        r,
        c = this,
        l = c.canvasWidth,
        u = c.canvasHeight,
        d = c.contentStartPos.left,
        p = c.contentStartPos.top,
        h = c.distanceX,
        f = c.distanceY;return s = Math.max(0, .5 * l - .5 * n), i = Math.max(0, .5 * u - .5 * o), a = Math.min(l - n, .5 * l - .5 * n), r = Math.min(u - o, .5 * u - .5 * o), n > l && (h > 0 && t > s && (t = s - 1 + Math.pow(-s + d + h, .8) || 0), h < 0 && t < a && (t = a + 1 - Math.pow(a - d - h, .8) || 0)), o > u && (f > 0 && e > i && (e = i - 1 + Math.pow(-i + p + f, .8) || 0), f < 0 && e < r && (e = r + 1 - Math.pow(r - p - f, .8) || 0)), { top: e, left: t };
  }, l.prototype.limitPosition = function (t, e, n, o) {
    var s = this,
        i = s.canvasWidth,
        a = s.canvasHeight;return n > i ? (t = t > 0 ? 0 : t, t = t < i - n ? i - n : t) : t = Math.max(0, i / 2 - n / 2), o > a ? (e = e > 0 ? 0 : e, e = e < a - o ? a - o : e) : e = Math.max(0, a / 2 - o / 2), { top: e, left: t };
  }, l.prototype.onZoom = function () {
    var e = this,
        s = e.contentStartPos.width,
        a = e.contentStartPos.height,
        r = e.contentStartPos.left,
        c = e.contentStartPos.top,
        l = i(e.newPoints[0], e.newPoints[1]),
        u = l / e.startDistanceBetweenFingers,
        d = Math.floor(s * u),
        p = Math.floor(a * u),
        h = (s - d) * e.percentageOfImageAtPinchPointX,
        f = (a - p) * e.percentageOfImageAtPinchPointY,
        g = (e.newPoints[0].x + e.newPoints[1].x) / 2 - n(t).scrollLeft(),
        b = (e.newPoints[0].y + e.newPoints[1].y) / 2 - n(t).scrollTop(),
        m = g - e.centerPointStartX,
        y = b - e.centerPointStartY,
        v = r + (h + m),
        x = c + (f + y),
        w = { top: x, left: v, scaleX: e.contentStartPos.scaleX * u, scaleY: e.contentStartPos.scaleY * u };e.canTap = !1, e.newWidth = d, e.newHeight = p, e.contentLastPos = w, o(function () {
      n.fancybox.setTranslate(e.$content, e.contentLastPos);
    });
  }, l.prototype.ontouchend = function (t) {
    var e = this,
        o = e.instance.current,
        i = Math.max(new Date().getTime() - e.startTime, 1),
        a = e.isSwiping,
        r = e.isPanning,
        c = e.isZooming;return e.endPoints = s(t), e.$container.removeClass("fancybox-controls--isGrabbing"), e.$wrap.off("touchmove.fb mousemove.fb", n.proxy(this, "ontouchmove")), e.$wrap.off("touchend.fb touchcancel.fb mouseup.fb mouseleave.fb", n.proxy(this, "ontouchend")), e.isSwiping = !1, e.isPanning = !1, e.isZooming = !1, e.canTap ? e.ontap() : (e.velocityX = e.distanceX / i * .5, e.velocityY = e.distanceY / i * .5, e.speed = o.opts.speed || 330, e.speedX = Math.max(.75 * e.speed, Math.min(1.5 * e.speed, 1 / Math.abs(e.velocityX) * e.speed)), e.speedY = Math.max(.75 * e.speed, Math.min(1.5 * e.speed, 1 / Math.abs(e.velocityY) * e.speed)), void (r ? e.endPanning() : c ? e.endZooming() : e.endSwiping(a)));
  }, l.prototype.endSwiping = function (t) {
    var e = this;"y" == t && Math.abs(e.distanceY) > 50 ? (n.fancybox.animate(e.$slider, null, { top: e.sliderStartPos.top + e.distanceY + 150 * e.velocityY, left: e.sliderStartPos.left, opacity: 0 }, e.speedY), e.instance.close(!0)) : "x" == t && e.distanceX > 50 ? e.instance.previous(e.speedX) : "x" == t && e.distanceX < -50 ? e.instance.next(e.speedX) : e.instance.update(!1, !0, 150);
  }, l.prototype.endPanning = function () {
    var t,
        e,
        o,
        s = this;s.contentLastPos && (t = s.contentLastPos.left + s.velocityX * s.speed * 2, e = s.contentLastPos.top + s.velocityY * s.speed * 2, o = s.limitPosition(t, e, s.contentStartPos.width, s.contentStartPos.height), o.width = s.contentStartPos.width, o.height = s.contentStartPos.height, n.fancybox.animate(s.$content, null, o, s.speed, "easeOutSine"));
  }, l.prototype.endZooming = function () {
    var t,
        e,
        o,
        s,
        i = this,
        a = i.instance.current,
        r = i.newWidth,
        c = i.newHeight;i.contentLastPos && (t = i.contentLastPos.left, e = i.contentLastPos.top, s = { top: e, left: t, width: r, height: c, scaleX: 1, scaleY: 1 }, n.fancybox.setTranslate(i.$content, s), r < i.canvasWidth && c < i.canvasHeight ? i.instance.scaleToFit(150) : r > a.width || c > a.height ? i.instance.scaleToActual(i.centerPointStartX, i.centerPointStartY, 150) : (o = i.limitPosition(t, e, r, c), n.fancybox.animate(i.$content, null, o, i.speed, "easeOutSine")));
  }, l.prototype.ontap = function () {
    var t = this,
        e = t.instance,
        o = e.current,
        s = t.endPoints[0].x,
        i = t.endPoints[0].y;if (s -= t.$wrap.offset().left, i -= t.$wrap.offset().top, e.SlideShow && e.SlideShow.isActive && e.SlideShow.stop(), !n.fancybox.isTouch) return o.opts.closeClickOutside && t.$target.is(".fancybox-slide") ? void e.close(t.startEvent) : void ("image" == o.type && o.isMoved && (e.canPan() ? e.scaleToFit() : e.isScaledDown() ? e.scaleToActual(s, i) : e.group.length < 2 && e.close(t.startEvent)));if (t.tapped) {
      if (clearTimeout(t.tapped), t.tapped = null, Math.abs(s - t.x) > 50 || Math.abs(i - t.y) > 50 || !o.isMoved) return this;"image" == o.type && (o.isLoaded || o.$ghost) && (e.canPan() ? e.scaleToFit() : e.isScaledDown() && e.scaleToActual(s, i));
    } else t.x = s, t.y = i, t.tapped = setTimeout(function () {
      t.tapped = null, e.toggleControls(!0);
    }, 300);return this;
  }, n(e).on("onActivate.fb", function (t, e) {
    e && !e.Guestures && (e.Guestures = new l(e));
  }), n(e).on("beforeClose.fb", function (t, e) {
    e && e.Guestures && e.Guestures.destroy();
  });
}(window, document, window.jQuery), function (t, e) {
  "use strict";
  var n = function n(t) {
    this.instance = t, this.init();
  };e.extend(n.prototype, { timer: null, isActive: !1, $button: null, speed: 3e3, init: function init() {
      var t = this;t.$button = e('<button data-fancybox-play class="fancybox-button fancybox-button--play" title="Slideshow (P)"></button>').appendTo(t.instance.$refs.buttons), t.instance.$refs.container.on("click", "[data-fancybox-play]", function () {
        t.toggle();
      });
    }, set: function set() {
      var t = this;t.instance && t.instance.current && (t.instance.current.opts.loop || t.instance.currIndex < t.instance.group.length - 1) ? t.timer = setTimeout(function () {
        t.instance.next();
      }, t.instance.current.opts.slideShow.speed || t.speed) : t.stop();
    }, clear: function clear() {
      var t = this;clearTimeout(t.timer), t.timer = null;
    }, start: function start() {
      var t = this;t.stop(), t.instance && t.instance.current && (t.instance.current.opts.loop || t.instance.currIndex < t.instance.group.length - 1) && (t.instance.$refs.container.on({ "beforeLoad.fb.player": e.proxy(t, "clear"), "onComplete.fb.player": e.proxy(t, "set") }), t.isActive = !0, t.instance.current.isComplete && t.set(), t.instance.$refs.container.trigger("onPlayStart"), t.$button.addClass("fancybox-button--pause"));
    }, stop: function stop() {
      var t = this;t.clear(), t.instance.$refs.container.trigger("onPlayEnd").off(".player"), t.$button.removeClass("fancybox-button--pause"), t.isActive = !1;
    }, toggle: function toggle() {
      var t = this;t.isActive ? t.stop() : t.start();
    } }), e(t).on("onInit.fb", function (t, e) {
    e && e.group.length > 1 && e.opts.slideShow && !e.SlideShow && (e.SlideShow = new n(e));
  }), e(t).on("beforeClose.fb onDeactivate.fb", function (t, e) {
    e && e.SlideShow && e.SlideShow.stop();
  });
}(document, window.jQuery), function (t, e) {
  "use strict";
  var n = function () {
    var e,
        n,
        o,
        s = [["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"], ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"], ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"], ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"], ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"]],
        i = {};for (n = 0; n < s.length; n++) {
      if (e = s[n], e && e[1] in t) {
        for (o = 0; o < e.length; o++) {
          i[s[0][o]] = e[o];
        }return i;
      }
    }return !1;
  }();if (n) {
    var o = { request: function request(e) {
        e = e || t.documentElement, e[n.requestFullscreen](e.ALLOW_KEYBOARD_INPUT);
      }, exit: function exit() {
        t[n.exitFullscreen]();
      }, toggle: function toggle(t) {
        this.isFullscreen() ? this.exit() : this.request(t);
      }, isFullscreen: function isFullscreen() {
        return Boolean(t[n.fullscreenElement]);
      }, enabled: function enabled() {
        return Boolean(t[n.fullscreenEnabled]);
      } };e(t).on({ "onInit.fb": function onInitFb(t, n) {
        var s;n && n.opts.fullScreen && !n.FullScreen && (s = n.$refs.container, n.$refs.button_fs = e('<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fullscreen" title="Full screen (F)"></button>').appendTo(n.$refs.buttons), s.on("click.fb-fullscreen", "[data-fancybox-fullscreen]", function (t) {
          t.stopPropagation(), t.preventDefault(), o.toggle(s[0]);
        }), n.opts.fullScreen.requestOnStart === !0 && o.request(s[0]));
      }, "beforeMove.fb": function beforeMoveFb(t, e) {
        e && e.$refs.button_fs && e.$refs.button_fs.toggle(!!e.current.opts.fullScreen);
      }, "beforeClose.fb": function beforeCloseFb() {
        o.exit();
      } }), e(t).on(n.fullscreenchange, function () {
      var t = e.fancybox.getInstance(),
          n = t ? t.current.$placeholder : null;n && (n.css("transition", "none"), t.isAnimating = !1, t.update(!0, !0, 0));
    });
  }
}(document, window.jQuery), function (t, e) {
  "use strict";
  var n = function n(t) {
    this.instance = t, this.init();
  };e.extend(n.prototype, { $button: null, $grid: null, $list: null, isVisible: !1, init: function init() {
      var t = this;t.$button = e('<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="Thumbnails (G)"></button>').appendTo(this.instance.$refs.buttons).on("touchend click", function (e) {
        e.stopPropagation(), e.preventDefault(), t.toggle();
      });
    }, create: function create() {
      var t,
          n,
          o = this.instance;this.$grid = e('<div class="fancybox-thumbs"></div>').appendTo(o.$refs.container), t = "<ul>", e.each(o.group, function (e, o) {
        n = o.opts.thumb || (o.opts.$thumb ? o.opts.$thumb.attr("src") : null), n || "image" !== o.type || (n = o.src), n && n.length && (t += '<li data-index="' + e + '"  tabindex="0" class="fancybox-thumbs-loading"><img data-src="' + n + '" /></li>');
      }), t += "</ul>", this.$list = e(t).appendTo(this.$grid).on("click touchstart", "li", function () {
        o.jumpTo(e(this).data("index"));
      }), this.$list.find("img").hide().one("load", function () {
        var t,
            n,
            o,
            s,
            i = e(this).parent().removeClass("fancybox-thumbs-loading"),
            a = i.outerWidth(),
            r = i.outerHeight();t = this.naturalWidth || this.width, n = this.naturalHeight || this.height, o = t / a, s = n / r, o >= 1 && s >= 1 && (o > s ? (t /= s, n = r) : (t = a, n /= o)), e(this).css({ width: Math.floor(t), height: Math.floor(n), "margin-top": Math.min(0, Math.floor(.3 * r - .3 * n)), "margin-left": Math.min(0, Math.floor(.5 * a - .5 * t)) }).show();
      }).each(function () {
        this.src = e(this).data("src");
      });
    }, focus: function focus() {
      this.instance.current && this.$list.children().removeClass("fancybox-thumbs-active").filter('[data-index="' + this.instance.current.index + '"]').addClass("fancybox-thumbs-active").focus();
    }, close: function close() {
      this.$grid.hide();
    }, update: function update() {
      this.instance.$refs.container.toggleClass("fancybox-container--thumbs", this.isVisible), this.isVisible ? (this.$grid || this.create(), this.$grid.show(), this.focus()) : this.$grid && this.$grid.hide(), this.instance.update();
    }, hide: function hide() {
      this.isVisible = !1, this.update();
    }, show: function show() {
      this.isVisible = !0, this.update();
    }, toggle: function toggle() {
      this.isVisible ? this.hide() : this.show();
    } }), e(t).on("onInit.fb", function (t, e) {
    var o = e.group[0],
        s = e.group[1];e.opts.thumbs && !e.Thumbs && e.group.length > 1 && ("image" == o.type || o.opts.thumb || o.opts.$thumb) && ("image" == s.type || s.opts.thumb || s.opts.$thumb) && (e.Thumbs = new n(e));
  }), e(t).on("beforeMove.fb", function (t, e, n) {
    var o = e && e.Thumbs;o && (n.modal ? (o.$button.hide(), o.hide()) : (e.opts.thumbs.showOnStart === !0 && e.firstRun && o.show(), o.$button.show(), o.isVisible && o.focus()));
  }), e(t).on("beforeClose.fb", function (t, e) {
    e && e.Thumbs && (e.Thumbs.isVisible && e.opts.thumbs.hideOnClosing !== !1 && e.Thumbs.close(), e.Thumbs = null);
  });
}(document, window.jQuery), function (t, e, n) {
  "use strict";
  function o() {
    var t = e.location.hash.substr(1),
        n = t.split("-"),
        o = n.length > 1 && /^\+?\d+$/.test(n[n.length - 1]) ? parseInt(n.pop(-1), 10) || 1 : 1,
        s = n.join("-");return o < 1 && (o = 1), { hash: t, index: o, gallery: s };
  }function s(t) {
    var e;"" !== t.gallery && (e = n("[data-fancybox='" + n.escapeSelector(t.gallery) + "']").eq(t.index - 1), e.length ? e.trigger("click") : n("#" + n.escapeSelector(t.gallery)).trigger("click"));
  }function i(t) {
    var e;return !!t && (e = t.current ? t.current.opts : t.opts, e.$orig ? e.$orig.data("fancybox") : e.hash || "");
  }n.escapeSelector || (n.escapeSelector = function (t) {
    var e = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g,
        n = function n(t, e) {
      return e ? "\0" === t ? "�" : t.slice(0, -1) + "\\" + t.charCodeAt(t.length - 1).toString(16) + " " : "\\" + t;
    };return (t + "").replace(e, n);
  });var a = null;n(function () {
    setTimeout(function () {
      n.fancybox.defaults.hash !== !1 && (n(e).on("hashchange.fb", function () {
        var t = o();n.fancybox.getInstance() ? a && a !== t.gallery + "-" + t.index && (a = null, n.fancybox.close()) : "" !== t.gallery && s(t);
      }), n(t).on({ "onInit.fb": function onInitFb(t, e) {
          var n = o(),
              s = i(e);s && n.gallery && s == n.gallery && (e.currIndex = n.index - 1);
        }, "beforeMove.fb": function beforeMoveFb(n, o, s) {
          var r = i(o);r && "" !== r && (e.location.hash.indexOf(r) < 0 && (o.opts.origHash = e.location.hash), a = r + (o.group.length > 1 ? "-" + (s.index + 1) : ""), "pushState" in history ? history.pushState("", t.title, e.location.pathname + e.location.search + "#" + a) : e.location.hash = a);
        }, "beforeClose.fb": function beforeCloseFb(n, o, s) {
          var r = i(o),
              c = o && o.opts.origHash ? o.opts.origHash : "";r && "" !== r && ("pushState" in history ? history.pushState("", t.title, e.location.pathname + e.location.search + c) : e.location.hash = c), a = null;
        } }), s(o()));
    }, 50);
  });
}(document, window, window.jQuery);

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (window.Element && !Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var matches = (this.document || this.ownerDocument).querySelectorAll(s);
    var i = '';
    var el = this;
    do {
      i = matches.length;
      while (--i >= 0 && matches.item(i) !== el) {};
    } while (i < 0 && (el = el.parentElement));
    return el;
  };
}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {

  if (typeof window.CustomEvent === "function") return false;

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _arguments = arguments;
/**
 * Object.assign
 * Does not support Symbols
 */
if (typeof Object.assign !== 'function') {
  Object.assign = function (target) {
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    var targetObject = Object(target);

    var _loop = function _loop(index) {
      var source = _arguments[index];
      if (source != null) {
        Object.keys(_arguments[index]).forEach(function (key) {
          targetObject[key] = source[key];
        });
      }
    };

    for (var index = 1; index < _arguments.length; index += 1) {
      _loop(index);
    }

    return targetObject;
  };
}

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * activate element by trigger change
 * example: used for reload button on wishlist
 */
var activateOnchangeTriggers = [].slice.call(document.querySelectorAll('[data-activate-onchange-trigger]'));

// add event listener
if (activateOnchangeTriggers !== null && activateOnchangeTriggers.length > 0) {
  activateOnchangeTriggers.forEach(function (trigger) {
    trigger.addEventListener('change', function () {
      var receiverID = trigger.dataset.activateOnchangeTrigger;
      var receiver = document.querySelector('[data-activate-onchange-receiver="' + receiverID + '"]');

      // activate receiver
      receiver.disabled = false;
    });
  });
}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toggler;
/**
 * @param {HTMLElement} scope context in which to operate
 * @return {void}
 */
function toggler() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  var triggers = [].slice.call(scope.querySelectorAll('[data-toggle]'));

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var targetIds = trigger.dataset.toggle.split(' ');

      // loop trough the IDs
      targetIds.forEach(function (targetId) {
        var target = document.getElementById(targetId);

        // toggle targets specified class
        if (target !== null && 'toggler' in target.dataset) {
          target.classList.toggle(target.dataset.toggler);
        }
      });
    });
  });
}

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initToggleButtons;
/**
 * @param  {HTMLElement} element button
 * @return {void}
 */
function toggleButton(element) {
  // Check to see if the button is pressed
  var pressed = element.getAttribute('aria-pressed') === 'true';
  // Change aria-pressed to the opposite state
  element.setAttribute('aria-pressed', !pressed);
}

/**
 * @param  {Event} event click event
 * @return {void}
 */
function handleBtnClick(event) {
  toggleButton(event.target);
}

/**
 * @param  {Event} event key press event
 * @return {void}
 */
function handleBtnKeyPress(event) {
  // Check to see if space or enter were pressed
  if (event.key === ' ' || event.key === 'Enter') {
    // Prevent the default action to stop scrolling when space is pressed
    event.preventDefault();
    toggleButton(event.target);
  }
}

/**
 * @param  {HTMLElement} element label
 * @return {void}
 */
function toggleLabel(element) {
  var label = element;
  var alternativeText = label.dataset.text;
  var currentText = label.innerHTML;

  // replace text
  label.innerHTML = alternativeText;

  // replace data
  label.dataset.text = currentText;
}

/**
 * @param  {HTMLElement} scope = document
 * @return {void}
 */
function initToggleButtons() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  var buttons = [].slice.call(scope.querySelectorAll('[aria-pressed]'));

  buttons.forEach(function (button) {
    // on click
    button.addEventListener('click', function (event) {
      var labelWithAlternativeText = button.querySelector('[data-text]');

      // toggle button
      handleBtnClick(event);

      // change label if alternative label is provided
      if (labelWithAlternativeText) {
        toggleLabel(labelWithAlternativeText);
      }
    });

    // on key press
    button.addEventListener('keyPress', function (event) {
      handleBtnKeyPress(event);
    });
  });
}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = clickRelay;
/**
 * @param {HTMLElement} scope context in which to operate
 * @return {void}
 */
function clickRelay() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  var triggers = [].slice.call(scope.querySelectorAll('[data-relay]'));

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.stopPropagation();
      event.preventDefault();

      var target = scope.getElementById(trigger.dataset.relay);

      // trigger click
      target.click();
    });
  });
}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var btnClass = 'btn';
var activeClass = 'is--active';

// Meta Navigation
var metaNavigation = document.getElementById('metaNavigation');

if (metaNavigation !== null) {
  metaNavigation.addEventListener('click', function (event) {
    var target = event.target;

    if (!target.classList.contains('shownav')) {
      document.body.classList.remove('open-off-canvas');
      document.querySelector('.main-navigation').classList.remove('is--open');
      document.querySelector('.btn.shownav').classList.remove('is--active');
    }

    if (target.nodeName === 'BUTTON' && target.classList.contains(btnClass)) {
      target.classList.toggle(activeClass);
    }
  });
}

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! nouislider - 10.1.0 - 2017-07-28 17:11:18 */

(function (factory) {

    if ( true ) {

        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    } else if ( typeof exports === 'object' ) {

        // Node/CommonJS
        module.exports = factory();

    } else {

        // Browser globals
        window.noUiSlider = factory();
    }

}(function( ){

	'use strict';

	var VERSION = '10.1.0';


	function isValidFormatter ( entry ) {
		return typeof entry === 'object' && typeof entry.to === 'function' && typeof entry.from === 'function';
	}

	function removeElement ( el ) {
		el.parentElement.removeChild(el);
	}

	// Bindable version
	function preventDefault ( e ) {
		e.preventDefault();
	}

	// Removes duplicates from an array.
	function unique ( array ) {
		return array.filter(function(a){
			return !this[a] ? this[a] = true : false;
		}, {});
	}

	// Round a value to the closest 'to'.
	function closest ( value, to ) {
		return Math.round(value / to) * to;
	}

	// Current position of an element relative to the document.
	function offset ( elem, orientation ) {

		var rect = elem.getBoundingClientRect();
		var doc = elem.ownerDocument;
		var docElem = doc.documentElement;
		var pageOffset = getPageOffset(doc);

		// getBoundingClientRect contains left scroll in Chrome on Android.
		// I haven't found a feature detection that proves this. Worst case
		// scenario on mis-match: the 'tap' feature on horizontal sliders breaks.
		if ( /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) ) {
			pageOffset.x = 0;
		}

		return orientation ? (rect.top + pageOffset.y - docElem.clientTop) : (rect.left + pageOffset.x - docElem.clientLeft);
	}

	// Checks whether a value is numerical.
	function isNumeric ( a ) {
		return typeof a === 'number' && !isNaN( a ) && isFinite( a );
	}

	// Sets a class and removes it after [duration] ms.
	function addClassFor ( element, className, duration ) {
		if (duration > 0) {
		addClass(element, className);
			setTimeout(function(){
				removeClass(element, className);
			}, duration);
		}
	}

	// Limits a value to 0 - 100
	function limit ( a ) {
		return Math.max(Math.min(a, 100), 0);
	}

	// Wraps a variable as an array, if it isn't one yet.
	// Note that an input array is returned by reference!
	function asArray ( a ) {
		return Array.isArray(a) ? a : [a];
	}

	// Counts decimals
	function countDecimals ( numStr ) {
		numStr = String(numStr);
		var pieces = numStr.split(".");
		return pieces.length > 1 ? pieces[1].length : 0;
	}

	// http://youmightnotneedjquery.com/#add_class
	function addClass ( el, className ) {
		if ( el.classList ) {
			el.classList.add(className);
		} else {
			el.className += ' ' + className;
		}
	}

	// http://youmightnotneedjquery.com/#remove_class
	function removeClass ( el, className ) {
		if ( el.classList ) {
			el.classList.remove(className);
		} else {
			el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
		}
	}

	// https://plainjs.com/javascript/attributes/adding-removing-and-testing-for-classes-9/
	function hasClass ( el, className ) {
		return el.classList ? el.classList.contains(className) : new RegExp('\\b' + className + '\\b').test(el.className);
	}

	// https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY#Notes
	function getPageOffset ( doc ) {

		var supportPageOffset = window.pageXOffset !== undefined;
		var isCSS1Compat = ((doc.compatMode || "") === "CSS1Compat");
		var x = supportPageOffset ? window.pageXOffset : isCSS1Compat ? doc.documentElement.scrollLeft : doc.body.scrollLeft;
		var y = supportPageOffset ? window.pageYOffset : isCSS1Compat ? doc.documentElement.scrollTop : doc.body.scrollTop;

		return {
			x: x,
			y: y
		};
	}

	// we provide a function to compute constants instead
	// of accessing window.* as soon as the module needs it
	// so that we do not compute anything if not needed
	function getActions ( ) {

		// Determine the events to bind. IE11 implements pointerEvents without
		// a prefix, which breaks compatibility with the IE10 implementation.
		return window.navigator.pointerEnabled ? {
			start: 'pointerdown',
			move: 'pointermove',
			end: 'pointerup'
		} : window.navigator.msPointerEnabled ? {
			start: 'MSPointerDown',
			move: 'MSPointerMove',
			end: 'MSPointerUp'
		} : {
			start: 'mousedown touchstart',
			move: 'mousemove touchmove',
			end: 'mouseup touchend'
		};
	}

	// https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
	// Issue #785
	function getSupportsPassive ( ) {

		var supportsPassive = false;

		try {

			var opts = Object.defineProperty({}, 'passive', {
				get: function() {
					supportsPassive = true;
				}
			});

			window.addEventListener('test', null, opts);

		} catch (e) {}

		return supportsPassive;
	}

	function getSupportsTouchActionNone ( ) {
		return window.CSS && CSS.supports && CSS.supports('touch-action', 'none');
	}


// Value calculation

	// Determine the size of a sub-range in relation to a full range.
	function subRangeRatio ( pa, pb ) {
		return (100 / (pb - pa));
	}

	// (percentage) How many percent is this value of this range?
	function fromPercentage ( range, value ) {
		return (value * 100) / ( range[1] - range[0] );
	}

	// (percentage) Where is this value on this range?
	function toPercentage ( range, value ) {
		return fromPercentage( range, range[0] < 0 ?
			value + Math.abs(range[0]) :
				value - range[0] );
	}

	// (value) How much is this percentage on this range?
	function isPercentage ( range, value ) {
		return ((value * ( range[1] - range[0] )) / 100) + range[0];
	}


// Range conversion

	function getJ ( value, arr ) {

		var j = 1;

		while ( value >= arr[j] ){
			j += 1;
		}

		return j;
	}

	// (percentage) Input a value, find where, on a scale of 0-100, it applies.
	function toStepping ( xVal, xPct, value ) {

		if ( value >= xVal.slice(-1)[0] ){
			return 100;
		}

		var j = getJ( value, xVal ), va, vb, pa, pb;

		va = xVal[j-1];
		vb = xVal[j];
		pa = xPct[j-1];
		pb = xPct[j];

		return pa + (toPercentage([va, vb], value) / subRangeRatio (pa, pb));
	}

	// (value) Input a percentage, find where it is on the specified range.
	function fromStepping ( xVal, xPct, value ) {

		// There is no range group that fits 100
		if ( value >= 100 ){
			return xVal.slice(-1)[0];
		}

		var j = getJ( value, xPct ), va, vb, pa, pb;

		va = xVal[j-1];
		vb = xVal[j];
		pa = xPct[j-1];
		pb = xPct[j];

		return isPercentage([va, vb], (value - pa) * subRangeRatio (pa, pb));
	}

	// (percentage) Get the step that applies at a certain value.
	function getStep ( xPct, xSteps, snap, value ) {

		if ( value === 100 ) {
			return value;
		}

		var j = getJ( value, xPct ), a, b;

		// If 'snap' is set, steps are used as fixed points on the slider.
		if ( snap ) {

			a = xPct[j-1];
			b = xPct[j];

			// Find the closest position, a or b.
			if ((value - a) > ((b-a)/2)){
				return b;
			}

			return a;
		}

		if ( !xSteps[j-1] ){
			return value;
		}

		return xPct[j-1] + closest(
			value - xPct[j-1],
			xSteps[j-1]
		);
	}


// Entry parsing

	function handleEntryPoint ( index, value, that ) {

		var percentage;

		// Wrap numerical input in an array.
		if ( typeof value === "number" ) {
			value = [value];
		}

		// Reject any invalid input, by testing whether value is an array.
		if ( Object.prototype.toString.call( value ) !== '[object Array]' ){
			throw new Error("noUiSlider (" + VERSION + "): 'range' contains invalid value.");
		}

		// Covert min/max syntax to 0 and 100.
		if ( index === 'min' ) {
			percentage = 0;
		} else if ( index === 'max' ) {
			percentage = 100;
		} else {
			percentage = parseFloat( index );
		}

		// Check for correct input.
		if ( !isNumeric( percentage ) || !isNumeric( value[0] ) ) {
			throw new Error("noUiSlider (" + VERSION + "): 'range' value isn't numeric.");
		}

		// Store values.
		that.xPct.push( percentage );
		that.xVal.push( value[0] );

		// NaN will evaluate to false too, but to keep
		// logging clear, set step explicitly. Make sure
		// not to override the 'step' setting with false.
		if ( !percentage ) {
			if ( !isNaN( value[1] ) ) {
				that.xSteps[0] = value[1];
			}
		} else {
			that.xSteps.push( isNaN(value[1]) ? false : value[1] );
		}

		that.xHighestCompleteStep.push(0);
	}

	function handleStepPoint ( i, n, that ) {

		// Ignore 'false' stepping.
		if ( !n ) {
			return true;
		}

		// Factor to range ratio
		that.xSteps[i] = fromPercentage([
			 that.xVal[i]
			,that.xVal[i+1]
		], n) / subRangeRatio (
			that.xPct[i],
			that.xPct[i+1] );

		var totalSteps = (that.xVal[i+1] - that.xVal[i]) / that.xNumSteps[i];
		var highestStep = Math.ceil(Number(totalSteps.toFixed(3)) - 1);
		var step = that.xVal[i] + (that.xNumSteps[i] * highestStep);

		that.xHighestCompleteStep[i] = step;
	}


// Interface

	function Spectrum ( entry, snap, singleStep ) {

		this.xPct = [];
		this.xVal = [];
		this.xSteps = [ singleStep || false ];
		this.xNumSteps = [ false ];
		this.xHighestCompleteStep = [];

		this.snap = snap;

		var index, ordered = [ /* [0, 'min'], [1, '50%'], [2, 'max'] */ ];

		// Map the object keys to an array.
		for ( index in entry ) {
			if ( entry.hasOwnProperty(index) ) {
				ordered.push([entry[index], index]);
			}
		}

		// Sort all entries by value (numeric sort).
		if ( ordered.length && typeof ordered[0][0] === "object" ) {
			ordered.sort(function(a, b) { return a[0][0] - b[0][0]; });
		} else {
			ordered.sort(function(a, b) { return a[0] - b[0]; });
		}


		// Convert all entries to subranges.
		for ( index = 0; index < ordered.length; index++ ) {
			handleEntryPoint(ordered[index][1], ordered[index][0], this);
		}

		// Store the actual step values.
		// xSteps is sorted in the same order as xPct and xVal.
		this.xNumSteps = this.xSteps.slice(0);

		// Convert all numeric steps to the percentage of the subrange they represent.
		for ( index = 0; index < this.xNumSteps.length; index++ ) {
			handleStepPoint(index, this.xNumSteps[index], this);
		}
	}

	Spectrum.prototype.getMargin = function ( value ) {

		var step = this.xNumSteps[0];

		if ( step && ((value / step) % 1) !== 0 ) {
			throw new Error("noUiSlider (" + VERSION + "): 'limit', 'margin' and 'padding' must be divisible by step.");
		}

		return this.xPct.length === 2 ? fromPercentage(this.xVal, value) : false;
	};

	Spectrum.prototype.toStepping = function ( value ) {

		value = toStepping( this.xVal, this.xPct, value );

		return value;
	};

	Spectrum.prototype.fromStepping = function ( value ) {

		return fromStepping( this.xVal, this.xPct, value );
	};

	Spectrum.prototype.getStep = function ( value ) {

		value = getStep(this.xPct, this.xSteps, this.snap, value );

		return value;
	};

	Spectrum.prototype.getNearbySteps = function ( value ) {

		var j = getJ(value, this.xPct);

		return {
			stepBefore: { startValue: this.xVal[j-2], step: this.xNumSteps[j-2], highestStep: this.xHighestCompleteStep[j-2] },
			thisStep: { startValue: this.xVal[j-1], step: this.xNumSteps[j-1], highestStep: this.xHighestCompleteStep[j-1] },
			stepAfter: { startValue: this.xVal[j-0], step: this.xNumSteps[j-0], highestStep: this.xHighestCompleteStep[j-0] }
		};
	};

	Spectrum.prototype.countStepDecimals = function () {
		var stepDecimals = this.xNumSteps.map(countDecimals);
		return Math.max.apply(null, stepDecimals);
 	};

	// Outside testing
	Spectrum.prototype.convert = function ( value ) {
		return this.getStep(this.toStepping(value));
	};

/*	Every input option is tested and parsed. This'll prevent
	endless validation in internal methods. These tests are
	structured with an item for every option available. An
	option can be marked as required by setting the 'r' flag.
	The testing function is provided with three arguments:
		- The provided value for the option;
		- A reference to the options object;
		- The name for the option;

	The testing function returns false when an error is detected,
	or true when everything is OK. It can also modify the option
	object, to make sure all values can be correctly looped elsewhere. */

	var defaultFormatter = { 'to': function( value ){
		return value !== undefined && value.toFixed(2);
	}, 'from': Number };

	function validateFormat ( entry ) {

		// Any object with a to and from method is supported.
		if ( isValidFormatter(entry) ) {
			return true;
		}

		throw new Error("noUiSlider (" + VERSION + "): 'format' requires 'to' and 'from' methods.");
	}

	function testStep ( parsed, entry ) {

		if ( !isNumeric( entry ) ) {
			throw new Error("noUiSlider (" + VERSION + "): 'step' is not numeric.");
		}

		// The step option can still be used to set stepping
		// for linear sliders. Overwritten if set in 'range'.
		parsed.singleStep = entry;
	}

	function testRange ( parsed, entry ) {

		// Filter incorrect input.
		if ( typeof entry !== 'object' || Array.isArray(entry) ) {
			throw new Error("noUiSlider (" + VERSION + "): 'range' is not an object.");
		}

		// Catch missing start or end.
		if ( entry.min === undefined || entry.max === undefined ) {
			throw new Error("noUiSlider (" + VERSION + "): Missing 'min' or 'max' in 'range'.");
		}

		// Catch equal start or end.
		if ( entry.min === entry.max ) {
			throw new Error("noUiSlider (" + VERSION + "): 'range' 'min' and 'max' cannot be equal.");
		}

		parsed.spectrum = new Spectrum(entry, parsed.snap, parsed.singleStep);
	}

	function testStart ( parsed, entry ) {

		entry = asArray(entry);

		// Validate input. Values aren't tested, as the public .val method
		// will always provide a valid location.
		if ( !Array.isArray( entry ) || !entry.length ) {
			throw new Error("noUiSlider (" + VERSION + "): 'start' option is incorrect.");
		}

		// Store the number of handles.
		parsed.handles = entry.length;

		// When the slider is initialized, the .val method will
		// be called with the start options.
		parsed.start = entry;
	}

	function testSnap ( parsed, entry ) {

		// Enforce 100% stepping within subranges.
		parsed.snap = entry;

		if ( typeof entry !== 'boolean' ){
			throw new Error("noUiSlider (" + VERSION + "): 'snap' option must be a boolean.");
		}
	}

	function testAnimate ( parsed, entry ) {

		// Enforce 100% stepping within subranges.
		parsed.animate = entry;

		if ( typeof entry !== 'boolean' ){
			throw new Error("noUiSlider (" + VERSION + "): 'animate' option must be a boolean.");
		}
	}

	function testAnimationDuration ( parsed, entry ) {

		parsed.animationDuration = entry;

		if ( typeof entry !== 'number' ){
			throw new Error("noUiSlider (" + VERSION + "): 'animationDuration' option must be a number.");
		}
	}

	function testConnect ( parsed, entry ) {

		var connect = [false];
		var i;

		// Map legacy options
		if ( entry === 'lower' ) {
			entry = [true, false];
		}

		else if ( entry === 'upper' ) {
			entry = [false, true];
		}

		// Handle boolean options
		if ( entry === true || entry === false ) {

			for ( i = 1; i < parsed.handles; i++ ) {
				connect.push(entry);
			}

			connect.push(false);
		}

		// Reject invalid input
		else if ( !Array.isArray( entry ) || !entry.length || entry.length !== parsed.handles + 1 ) {
			throw new Error("noUiSlider (" + VERSION + "): 'connect' option doesn't match handle count.");
		}

		else {
			connect = entry;
		}

		parsed.connect = connect;
	}

	function testOrientation ( parsed, entry ) {

		// Set orientation to an a numerical value for easy
		// array selection.
		switch ( entry ){
		  case 'horizontal':
			parsed.ort = 0;
			break;
		  case 'vertical':
			parsed.ort = 1;
			break;
		  default:
			throw new Error("noUiSlider (" + VERSION + "): 'orientation' option is invalid.");
		}
	}

	function testMargin ( parsed, entry ) {

		if ( !isNumeric(entry) ){
			throw new Error("noUiSlider (" + VERSION + "): 'margin' option must be numeric.");
		}

		// Issue #582
		if ( entry === 0 ) {
			return;
		}

		parsed.margin = parsed.spectrum.getMargin(entry);

		if ( !parsed.margin ) {
			throw new Error("noUiSlider (" + VERSION + "): 'margin' option is only supported on linear sliders.");
		}
	}

	function testLimit ( parsed, entry ) {

		if ( !isNumeric(entry) ){
			throw new Error("noUiSlider (" + VERSION + "): 'limit' option must be numeric.");
		}

		parsed.limit = parsed.spectrum.getMargin(entry);

		if ( !parsed.limit || parsed.handles < 2 ) {
			throw new Error("noUiSlider (" + VERSION + "): 'limit' option is only supported on linear sliders with 2 or more handles.");
		}
	}

	function testPadding ( parsed, entry ) {

		if ( !isNumeric(entry) ){
			throw new Error("noUiSlider (" + VERSION + "): 'padding' option must be numeric.");
		}

		if ( entry === 0 ) {
			return;
		}

		parsed.padding = parsed.spectrum.getMargin(entry);

		if ( !parsed.padding ) {
			throw new Error("noUiSlider (" + VERSION + "): 'padding' option is only supported on linear sliders.");
		}

		if ( parsed.padding < 0 ) {
			throw new Error("noUiSlider (" + VERSION + "): 'padding' option must be a positive number.");
		}

		if ( parsed.padding >= 50 ) {
			throw new Error("noUiSlider (" + VERSION + "): 'padding' option must be less than half the range.");
		}
	}

	function testDirection ( parsed, entry ) {

		// Set direction as a numerical value for easy parsing.
		// Invert connection for RTL sliders, so that the proper
		// handles get the connect/background classes.
		switch ( entry ) {
		  case 'ltr':
			parsed.dir = 0;
			break;
		  case 'rtl':
			parsed.dir = 1;
			break;
		  default:
			throw new Error("noUiSlider (" + VERSION + "): 'direction' option was not recognized.");
		}
	}

	function testBehaviour ( parsed, entry ) {

		// Make sure the input is a string.
		if ( typeof entry !== 'string' ) {
			throw new Error("noUiSlider (" + VERSION + "): 'behaviour' must be a string containing options.");
		}

		// Check if the string contains any keywords.
		// None are required.
		var tap = entry.indexOf('tap') >= 0;
		var drag = entry.indexOf('drag') >= 0;
		var fixed = entry.indexOf('fixed') >= 0;
		var snap = entry.indexOf('snap') >= 0;
		var hover = entry.indexOf('hover') >= 0;

		if ( fixed ) {

			if ( parsed.handles !== 2 ) {
				throw new Error("noUiSlider (" + VERSION + "): 'fixed' behaviour must be used with 2 handles");
			}

			// Use margin to enforce fixed state
			testMargin(parsed, parsed.start[1] - parsed.start[0]);
		}

		parsed.events = {
			tap: tap || snap,
			drag: drag,
			fixed: fixed,
			snap: snap,
			hover: hover
		};
	}

	function testMultitouch ( parsed, entry ) {
		parsed.multitouch = entry;

		if ( typeof entry !== 'boolean' ){
			throw new Error("noUiSlider (" + VERSION + "): 'multitouch' option must be a boolean.");
		}
	}

	function testTooltips ( parsed, entry ) {

		if ( entry === false ) {
			return;
		}

		else if ( entry === true ) {

			parsed.tooltips = [];

			for ( var i = 0; i < parsed.handles; i++ ) {
				parsed.tooltips.push(true);
			}
		}

		else {

			parsed.tooltips = asArray(entry);

			if ( parsed.tooltips.length !== parsed.handles ) {
				throw new Error("noUiSlider (" + VERSION + "): must pass a formatter for all handles.");
			}

			parsed.tooltips.forEach(function(formatter){
				if ( typeof formatter !== 'boolean' && (typeof formatter !== 'object' || typeof formatter.to !== 'function') ) {
					throw new Error("noUiSlider (" + VERSION + "): 'tooltips' must be passed a formatter or 'false'.");
				}
			});
		}
	}

	function testAriaFormat ( parsed, entry ) {
		parsed.ariaFormat = entry;
		validateFormat(entry);
	}

	function testFormat ( parsed, entry ) {
		parsed.format = entry;
		validateFormat(entry);
	}

	function testCssPrefix ( parsed, entry ) {

		if ( entry !== undefined && typeof entry !== 'string' && entry !== false ) {
			throw new Error("noUiSlider (" + VERSION + "): 'cssPrefix' must be a string or `false`.");
		}

		parsed.cssPrefix = entry;
	}

	function testCssClasses ( parsed, entry ) {

		if ( entry !== undefined && typeof entry !== 'object' ) {
			throw new Error("noUiSlider (" + VERSION + "): 'cssClasses' must be an object.");
		}

		if ( typeof parsed.cssPrefix === 'string' ) {
			parsed.cssClasses = {};

			for ( var key in entry ) {
				if ( !entry.hasOwnProperty(key) ) { continue; }

				parsed.cssClasses[key] = parsed.cssPrefix + entry[key];
			}
		} else {
			parsed.cssClasses = entry;
		}
	}

	function testUseRaf ( parsed, entry ) {
		if ( entry === true || entry === false ) {
			parsed.useRequestAnimationFrame = entry;
		} else {
			throw new Error("noUiSlider (" + VERSION + "): 'useRequestAnimationFrame' option should be true (default) or false.");
		}
	}

	// Test all developer settings and parse to assumption-safe values.
	function testOptions ( options ) {

		// To prove a fix for #537, freeze options here.
		// If the object is modified, an error will be thrown.
		// Object.freeze(options);

		var parsed = {
			margin: 0,
			limit: 0,
			padding: 0,
			animate: true,
			animationDuration: 300,
			ariaFormat: defaultFormatter,
			format: defaultFormatter
		};

		// Tests are executed in the order they are presented here.
		var tests = {
			'step': { r: false, t: testStep },
			'start': { r: true, t: testStart },
			'connect': { r: true, t: testConnect },
			'direction': { r: true, t: testDirection },
			'snap': { r: false, t: testSnap },
			'animate': { r: false, t: testAnimate },
			'animationDuration': { r: false, t: testAnimationDuration },
			'range': { r: true, t: testRange },
			'orientation': { r: false, t: testOrientation },
			'margin': { r: false, t: testMargin },
			'limit': { r: false, t: testLimit },
			'padding': { r: false, t: testPadding },
			'behaviour': { r: true, t: testBehaviour },
			'multitouch': { r: true, t: testMultitouch },
			'ariaFormat': { r: false, t: testAriaFormat },
			'format': { r: false, t: testFormat },
			'tooltips': { r: false, t: testTooltips },
			'cssPrefix': { r: false, t: testCssPrefix },
			'cssClasses': { r: false, t: testCssClasses },
			'useRequestAnimationFrame': { r: false, t: testUseRaf }
		};

		var defaults = {
			'connect': false,
			'direction': 'ltr',
			'behaviour': 'tap',
			'multitouch': false,
			'orientation': 'horizontal',
			'cssPrefix' : 'noUi-',
			'cssClasses': {
				target: 'target',
				base: 'base',
				origin: 'origin',
				handle: 'handle',
				handleLower: 'handle-lower',
				handleUpper: 'handle-upper',
				horizontal: 'horizontal',
				vertical: 'vertical',
				background: 'background',
				connect: 'connect',
				ltr: 'ltr',
				rtl: 'rtl',
				draggable: 'draggable',
				drag: 'state-drag',
				tap: 'state-tap',
				active: 'active',
				tooltip: 'tooltip',
				pips: 'pips',
				pipsHorizontal: 'pips-horizontal',
				pipsVertical: 'pips-vertical',
				marker: 'marker',
				markerHorizontal: 'marker-horizontal',
				markerVertical: 'marker-vertical',
				markerNormal: 'marker-normal',
				markerLarge: 'marker-large',
				markerSub: 'marker-sub',
				value: 'value',
				valueHorizontal: 'value-horizontal',
				valueVertical: 'value-vertical',
				valueNormal: 'value-normal',
				valueLarge: 'value-large',
				valueSub: 'value-sub'
			},
			'useRequestAnimationFrame': true
		};

		// AriaFormat defaults to regular format, if any.
		if ( options.format && !options.ariaFormat ) {
			options.ariaFormat = options.format;
		}

		// Run all options through a testing mechanism to ensure correct
		// input. It should be noted that options might get modified to
		// be handled properly. E.g. wrapping integers in arrays.
		Object.keys(tests).forEach(function( name ){

			// If the option isn't set, but it is required, throw an error.
			if ( options[name] === undefined && defaults[name] === undefined ) {

				if ( tests[name].r ) {
					throw new Error("noUiSlider (" + VERSION + "): '" + name + "' is required.");
				}

				return true;
			}

			tests[name].t( parsed, options[name] === undefined ? defaults[name] : options[name] );
		});

		// Forward pips options
		parsed.pips = options.pips;

		var styles = [['left', 'top'], ['right', 'bottom']];

		// Pre-define the styles.
		parsed.style = styles[parsed.dir][parsed.ort];
		parsed.styleOposite = styles[parsed.dir?0:1][parsed.ort];

		return parsed;
	}


function closure ( target, options, originalOptions ){

	var actions = getActions();
	var supportsTouchActionNone = getSupportsTouchActionNone();
	var supportsPassive = supportsTouchActionNone && getSupportsPassive();

	// All variables local to 'closure' are prefixed with 'scope_'
	var scope_Target = target;
	var scope_Locations = [];
	var scope_Base;
	var scope_Handles;
	var scope_HandleNumbers = [];
	var scope_ActiveHandlesCount = 0;
	var scope_Connects;
	var scope_Spectrum = options.spectrum;
	var scope_Values = [];
	var scope_Events = {};
	var scope_Self;
	var scope_Pips;
	var scope_Document = target.ownerDocument;
	var scope_DocumentElement = scope_Document.documentElement;
	var scope_Body = scope_Document.body;


	// Creates a node, adds it to target, returns the new node.
	function addNodeTo ( target, className ) {

		var div = scope_Document.createElement('div');

		if ( className ) {
			addClass(div, className);
		}

		target.appendChild(div);

		return div;
	}

	// Append a origin to the base
	function addOrigin ( base, handleNumber ) {

		var origin = addNodeTo(base, options.cssClasses.origin);
		var handle = addNodeTo(origin, options.cssClasses.handle);

		handle.setAttribute('data-handle', handleNumber);

		// https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex
		// 0 = focusable and reachable
		handle.setAttribute('tabindex', '0');
		handle.setAttribute('role', 'slider');
		handle.setAttribute('aria-orientation', options.ort ? 'vertical' : 'horizontal');

		if ( handleNumber === 0 ) {
			addClass(handle, options.cssClasses.handleLower);
		}

		else if ( handleNumber === options.handles - 1 ) {
			addClass(handle, options.cssClasses.handleUpper);
		}

		return origin;
	}

	// Insert nodes for connect elements
	function addConnect ( base, add ) {

		if ( !add ) {
			return false;
		}

		return addNodeTo(base, options.cssClasses.connect);
	}

	// Add handles to the slider base.
	function addElements ( connectOptions, base ) {

		scope_Handles = [];
		scope_Connects = [];

		scope_Connects.push(addConnect(base, connectOptions[0]));

		// [::::O====O====O====]
		// connectOptions = [0, 1, 1, 1]

		for ( var i = 0; i < options.handles; i++ ) {
			// Keep a list of all added handles.
			scope_Handles.push(addOrigin(base, i));
			scope_HandleNumbers[i] = i;
			scope_Connects.push(addConnect(base, connectOptions[i + 1]));
		}
	}

	// Initialize a single slider.
	function addSlider ( target ) {

		// Apply classes and data to the target.
		addClass(target, options.cssClasses.target);

		if ( options.dir === 0 ) {
			addClass(target, options.cssClasses.ltr);
		} else {
			addClass(target, options.cssClasses.rtl);
		}

		if ( options.ort === 0 ) {
			addClass(target, options.cssClasses.horizontal);
		} else {
			addClass(target, options.cssClasses.vertical);
		}

		scope_Base = addNodeTo(target, options.cssClasses.base);
	}


	function addTooltip ( handle, handleNumber ) {

		if ( !options.tooltips[handleNumber] ) {
			return false;
		}

		return addNodeTo(handle.firstChild, options.cssClasses.tooltip);
	}

	// The tooltips option is a shorthand for using the 'update' event.
	function tooltips ( ) {

		// Tooltips are added with options.tooltips in original order.
		var tips = scope_Handles.map(addTooltip);

		bindEvent('update', function(values, handleNumber, unencoded) {

			if ( !tips[handleNumber] ) {
				return;
			}

			var formattedValue = values[handleNumber];

			if ( options.tooltips[handleNumber] !== true ) {
				formattedValue = options.tooltips[handleNumber].to(unencoded[handleNumber]);
			}

			tips[handleNumber].innerHTML = formattedValue;
		});
	}


	function aria ( ) {

		bindEvent('update', function ( values, handleNumber, unencoded, tap, positions ) {

			// Update Aria Values for all handles, as a change in one changes min and max values for the next.
			scope_HandleNumbers.forEach(function( handleNumber ){

				var handle = scope_Handles[handleNumber];

				var min = checkHandlePosition(scope_Locations, handleNumber, 0, true, true, true);
				var max = checkHandlePosition(scope_Locations, handleNumber, 100, true, true, true);

				var now = positions[handleNumber];
				var text = options.ariaFormat.to(unencoded[handleNumber]);

				handle.children[0].setAttribute('aria-valuemin', min.toFixed(1));
				handle.children[0].setAttribute('aria-valuemax', max.toFixed(1));
				handle.children[0].setAttribute('aria-valuenow', now.toFixed(1));
				handle.children[0].setAttribute('aria-valuetext', text);
			});
		});
	}


	function getGroup ( mode, values, stepped ) {

		// Use the range.
		if ( mode === 'range' || mode === 'steps' ) {
			return scope_Spectrum.xVal;
		}

		if ( mode === 'count' ) {

			if ( !values ) {
				throw new Error("noUiSlider (" + VERSION + "): 'values' required for mode 'count'.");
			}

			// Divide 0 - 100 in 'count' parts.
			var spread = ( 100 / (values - 1) );
			var v;
			var i = 0;

			values = [];

			// List these parts and have them handled as 'positions'.
			while ( (v = i++ * spread) <= 100 ) {
				values.push(v);
			}

			mode = 'positions';
		}

		if ( mode === 'positions' ) {

			// Map all percentages to on-range values.
			return values.map(function( value ){
				return scope_Spectrum.fromStepping( stepped ? scope_Spectrum.getStep( value ) : value );
			});
		}

		if ( mode === 'values' ) {

			// If the value must be stepped, it needs to be converted to a percentage first.
			if ( stepped ) {

				return values.map(function( value ){

					// Convert to percentage, apply step, return to value.
					return scope_Spectrum.fromStepping( scope_Spectrum.getStep( scope_Spectrum.toStepping( value ) ) );
				});

			}

			// Otherwise, we can simply use the values.
			return values;
		}
	}

	function generateSpread ( density, mode, group ) {

		function safeIncrement(value, increment) {
			// Avoid floating point variance by dropping the smallest decimal places.
			return (value + increment).toFixed(7) / 1;
		}

		var indexes = {};
		var firstInRange = scope_Spectrum.xVal[0];
		var lastInRange = scope_Spectrum.xVal[scope_Spectrum.xVal.length-1];
		var ignoreFirst = false;
		var ignoreLast = false;
		var prevPct = 0;

		// Create a copy of the group, sort it and filter away all duplicates.
		group = unique(group.slice().sort(function(a, b){ return a - b; }));

		// Make sure the range starts with the first element.
		if ( group[0] !== firstInRange ) {
			group.unshift(firstInRange);
			ignoreFirst = true;
		}

		// Likewise for the last one.
		if ( group[group.length - 1] !== lastInRange ) {
			group.push(lastInRange);
			ignoreLast = true;
		}

		group.forEach(function ( current, index ) {

			// Get the current step and the lower + upper positions.
			var step;
			var i;
			var q;
			var low = current;
			var high = group[index+1];
			var newPct;
			var pctDifference;
			var pctPos;
			var type;
			var steps;
			var realSteps;
			var stepsize;

			// When using 'steps' mode, use the provided steps.
			// Otherwise, we'll step on to the next subrange.
			if ( mode === 'steps' ) {
				step = scope_Spectrum.xNumSteps[ index ];
			}

			// Default to a 'full' step.
			if ( !step ) {
				step = high-low;
			}

			// Low can be 0, so test for false. If high is undefined,
			// we are at the last subrange. Index 0 is already handled.
			if ( low === false || high === undefined ) {
				return;
			}

			// Make sure step isn't 0, which would cause an infinite loop (#654)
			step = Math.max(step, 0.0000001);

			// Find all steps in the subrange.
			for ( i = low; i <= high; i = safeIncrement(i, step) ) {

				// Get the percentage value for the current step,
				// calculate the size for the subrange.
				newPct = scope_Spectrum.toStepping( i );
				pctDifference = newPct - prevPct;

				steps = pctDifference / density;
				realSteps = Math.round(steps);

				// This ratio represents the ammount of percentage-space a point indicates.
				// For a density 1 the points/percentage = 1. For density 2, that percentage needs to be re-devided.
				// Round the percentage offset to an even number, then divide by two
				// to spread the offset on both sides of the range.
				stepsize = pctDifference/realSteps;

				// Divide all points evenly, adding the correct number to this subrange.
				// Run up to <= so that 100% gets a point, event if ignoreLast is set.
				for ( q = 1; q <= realSteps; q += 1 ) {

					// The ratio between the rounded value and the actual size might be ~1% off.
					// Correct the percentage offset by the number of points
					// per subrange. density = 1 will result in 100 points on the
					// full range, 2 for 50, 4 for 25, etc.
					pctPos = prevPct + ( q * stepsize );
					indexes[pctPos.toFixed(5)] = ['x', 0];
				}

				// Determine the point type.
				type = (group.indexOf(i) > -1) ? 1 : ( mode === 'steps' ? 2 : 0 );

				// Enforce the 'ignoreFirst' option by overwriting the type for 0.
				if ( !index && ignoreFirst ) {
					type = 0;
				}

				if ( !(i === high && ignoreLast)) {
					// Mark the 'type' of this point. 0 = plain, 1 = real value, 2 = step value.
					indexes[newPct.toFixed(5)] = [i, type];
				}

				// Update the percentage count.
				prevPct = newPct;
			}
		});

		return indexes;
	}

	function addMarking ( spread, filterFunc, formatter ) {

		var element = scope_Document.createElement('div');

		var valueSizeClasses = [
			options.cssClasses.valueNormal,
			options.cssClasses.valueLarge,
			options.cssClasses.valueSub
		];
		var markerSizeClasses = [
			options.cssClasses.markerNormal,
			options.cssClasses.markerLarge,
			options.cssClasses.markerSub
		];
		var valueOrientationClasses = [
			options.cssClasses.valueHorizontal,
			options.cssClasses.valueVertical
		];
		var markerOrientationClasses = [
			options.cssClasses.markerHorizontal,
			options.cssClasses.markerVertical
		];

		addClass(element, options.cssClasses.pips);
		addClass(element, options.ort === 0 ? options.cssClasses.pipsHorizontal : options.cssClasses.pipsVertical);

		function getClasses( type, source ){
			var a = source === options.cssClasses.value;
			var orientationClasses = a ? valueOrientationClasses : markerOrientationClasses;
			var sizeClasses = a ? valueSizeClasses : markerSizeClasses;

			return source + ' ' + orientationClasses[options.ort] + ' ' + sizeClasses[type];
		}

		function addSpread ( offset, values ){

			// Apply the filter function, if it is set.
			values[1] = (values[1] && filterFunc) ? filterFunc(values[0], values[1]) : values[1];

			// Add a marker for every point
			var node = addNodeTo(element, false);
				node.className = getClasses(values[1], options.cssClasses.marker);
				node.style[options.style] = offset + '%';

			// Values are only appended for points marked '1' or '2'.
			if ( values[1] ) {
				node = addNodeTo(element, false);
				node.className = getClasses(values[1], options.cssClasses.value);
				node.style[options.style] = offset + '%';
				node.innerText = formatter.to(values[0]);
			}
		}

		// Append all points.
		Object.keys(spread).forEach(function(a){
			addSpread(a, spread[a]);
		});

		return element;
	}

	function removePips ( ) {
		if ( scope_Pips ) {
			removeElement(scope_Pips);
			scope_Pips = null;
		}
	}

	function pips ( grid ) {

		// Fix #669
		removePips();

		var mode = grid.mode;
		var density = grid.density || 1;
		var filter = grid.filter || false;
		var values = grid.values || false;
		var stepped = grid.stepped || false;
		var group = getGroup( mode, values, stepped );
		var spread = generateSpread( density, mode, group );
		var format = grid.format || {
			to: Math.round
		};

		scope_Pips = scope_Target.appendChild(addMarking(
			spread,
			filter,
			format
		));

		return scope_Pips;
	}


	// Shorthand for base dimensions.
	function baseSize ( ) {
		var rect = scope_Base.getBoundingClientRect(), alt = 'offset' + ['Width', 'Height'][options.ort];
		return options.ort === 0 ? (rect.width||scope_Base[alt]) : (rect.height||scope_Base[alt]);
	}

	// Handler for attaching events trough a proxy.
	function attachEvent ( events, element, callback, data ) {

		// This function can be used to 'filter' events to the slider.
		// element is a node, not a nodeList

		var method = function ( e ){

			if ( scope_Target.hasAttribute('disabled') ) {
				return false;
			}

			// Stop if an active 'tap' transition is taking place.
			if ( hasClass(scope_Target, options.cssClasses.tap) ) {
				return false;
			}

			e = fixEvent(e, data.pageOffset, data.target || element);

			// Handle reject of multitouch
			if ( !e ) {
				return false;
			}

			// Ignore right or middle clicks on start #454
			if ( events === actions.start && e.buttons !== undefined && e.buttons > 1 ) {
				return false;
			}

			// Ignore right or middle clicks on start #454
			if ( data.hover && e.buttons ) {
				return false;
			}

			// 'supportsPassive' is only true if a browser also supports touch-action: none in CSS.
			// iOS safari does not, so it doesn't get to benefit from passive scrolling. iOS does support
			// touch-action: manipulation, but that allows panning, which breaks
			// sliders after zooming/on non-responsive pages.
			// See: https://bugs.webkit.org/show_bug.cgi?id=133112
			if ( !supportsPassive ) {
				e.preventDefault();
			}

			e.calcPoint = e.points[ options.ort ];

			// Call the event handler with the event [ and additional data ].
			callback ( e, data );
		};

		var methods = [];

		// Bind a closure on the target for every event type.
		events.split(' ').forEach(function( eventName ){
			element.addEventListener(eventName, method, supportsPassive ? { passive: true } : false);
			methods.push([eventName, method]);
		});

		return methods;
	}

	// Provide a clean event with standardized offset values.
	function fixEvent ( e, pageOffset, target ) {

		// Filter the event to register the type, which can be
		// touch, mouse or pointer. Offset changes need to be
		// made on an event specific basis.
		var touch = e.type.indexOf('touch') === 0;
		var mouse = e.type.indexOf('mouse') === 0;
		var pointer = e.type.indexOf('pointer') === 0;

		var x;
		var y;

		// IE10 implemented pointer events with a prefix;
		if ( e.type.indexOf('MSPointer') === 0 ) {
			pointer = true;
		}


		// In the event that multitouch is activated, the only thing one handle should be concerned
		// about is the touches that originated on top of it.
		if ( touch && options.multitouch ) {
			// Returns true if a touch originated on the target.
			var isTouchOnTarget = function (touch) {
				return touch.target === target || target.contains(touch.target);
			};
			// In the case of touchstart events, we need to make sure there is still no more than one
			// touch on the target so we look amongst all touches.
			if (e.type === 'touchstart') {
				var targetTouches = Array.prototype.filter.call(e.touches, isTouchOnTarget);
				// Do not support more than one touch per handle.
				if ( targetTouches.length > 1 ) {
					return false;
				}
				x = targetTouches[0].pageX;
				y = targetTouches[0].pageY;
			} else {
			// In the other cases, find on changedTouches is enough.
				var targetTouch = Array.prototype.find.call(e.changedTouches, isTouchOnTarget);
				// Cancel if the target touch has not moved.
				if ( !targetTouch ) {
					return false;
				}
				x = targetTouch.pageX;
				y = targetTouch.pageY;
			}
		} else if ( touch ) {
			// Fix bug when user touches with two or more fingers on mobile devices.
			// It's useful when you have two or more sliders on one page,
			// that can be touched simultaneously.
			// #649, #663, #668
			if ( e.touches.length > 1 ) {
				return false;
			}

			// noUiSlider supports one movement at a time,
			// so we can select the first 'changedTouch'.
			x = e.changedTouches[0].pageX;
			y = e.changedTouches[0].pageY;
		}

		pageOffset = pageOffset || getPageOffset(scope_Document);

		if ( mouse || pointer ) {
			x = e.clientX + pageOffset.x;
			y = e.clientY + pageOffset.y;
		}

		e.pageOffset = pageOffset;
		e.points = [x, y];
		e.cursor = mouse || pointer; // Fix #435

		return e;
	}

	// Translate a coordinate in the document to a percentage on the slider
	function calcPointToPercentage ( calcPoint ) {
		var location = calcPoint - offset(scope_Base, options.ort);
		var proposal = ( location * 100 ) / baseSize();
		return options.dir ? 100 - proposal : proposal;
	}

	// Find handle closest to a certain percentage on the slider
	function getClosestHandle ( proposal ) {

		var closest = 100;
		var handleNumber = false;

		scope_Handles.forEach(function(handle, index){

			// Disabled handles are ignored
			if ( handle.hasAttribute('disabled') ) {
				return;
			}

			var pos = Math.abs(scope_Locations[index] - proposal);

			if ( pos < closest ) {
				handleNumber = index;
				closest = pos;
			}
		});

		return handleNumber;
	}

	// Moves handle(s) by a percentage
	// (bool, % to move, [% where handle started, ...], [index in scope_Handles, ...])
	function moveHandles ( upward, proposal, locations, handleNumbers ) {

		var proposals = locations.slice();

		var b = [!upward, upward];
		var f = [upward, !upward];

		// Copy handleNumbers so we don't change the dataset
		handleNumbers = handleNumbers.slice();

		// Check to see which handle is 'leading'.
		// If that one can't move the second can't either.
		if ( upward ) {
			handleNumbers.reverse();
		}

		// Step 1: get the maximum percentage that any of the handles can move
		if ( handleNumbers.length > 1 ) {

			handleNumbers.forEach(function(handleNumber, o) {

				var to = checkHandlePosition(proposals, handleNumber, proposals[handleNumber] + proposal, b[o], f[o], false);

				// Stop if one of the handles can't move.
				if ( to === false ) {
					proposal = 0;
				} else {
					proposal = to - proposals[handleNumber];
					proposals[handleNumber] = to;
				}
			});
		}

		// If using one handle, check backward AND forward
		else {
			b = f = [true];
		}

		var state = false;

		// Step 2: Try to set the handles with the found percentage
		handleNumbers.forEach(function(handleNumber, o) {
			state = setHandle(handleNumber, locations[handleNumber] + proposal, b[o], f[o]) || state;
		});

		// Step 3: If a handle moved, fire events
		if ( state ) {
			handleNumbers.forEach(function(handleNumber){
				fireEvent('update', handleNumber);
				fireEvent('slide', handleNumber);
			});
		}
	}

	// External event handling
	function fireEvent ( eventName, handleNumber, tap ) {

		Object.keys(scope_Events).forEach(function( targetEvent ) {

			var eventType = targetEvent.split('.')[0];

			if ( eventName === eventType ) {
				scope_Events[targetEvent].forEach(function( callback ) {

					callback.call(
						// Use the slider public API as the scope ('this')
						scope_Self,
						// Return values as array, so arg_1[arg_2] is always valid.
						scope_Values.map(options.format.to),
						// Handle index, 0 or 1
						handleNumber,
						// Unformatted slider values
						scope_Values.slice(),
						// Event is fired by tap, true or false
						tap || false,
						// Left offset of the handle, in relation to the slider
						scope_Locations.slice()
					);
				});
			}
		});
	}


	// Fire 'end' when a mouse or pen leaves the document.
	function documentLeave ( event, data ) {
		if ( event.type === "mouseout" && event.target.nodeName === "HTML" && event.relatedTarget === null ){
			eventEnd (event, data);
		}
	}

	// Handle movement on document for handle and range drag.
	function eventMove ( event, data ) {

		// Fix #498
		// Check value of .buttons in 'start' to work around a bug in IE10 mobile (data.buttonsProperty).
		// https://connect.microsoft.com/IE/feedback/details/927005/mobile-ie10-windows-phone-buttons-property-of-pointermove-event-always-zero
		// IE9 has .buttons and .which zero on mousemove.
		// Firefox breaks the spec MDN defines.
		if ( navigator.appVersion.indexOf("MSIE 9") === -1 && event.buttons === 0 && data.buttonsProperty !== 0 ) {
			return eventEnd(event, data);
		}

		// Check if we are moving up or down
		var movement = (options.dir ? -1 : 1) * (event.calcPoint - data.startCalcPoint);

		// Convert the movement into a percentage of the slider width/height
		var proposal = (movement * 100) / data.baseSize;

		moveHandles(movement > 0, proposal, data.locations, data.handleNumbers);
	}

	// Unbind move events on document, call callbacks.
	function eventEnd ( event, data ) {

		// The handle is no longer active, so remove the class.
		if ( data.handle ) {
			removeClass(data.handle, options.cssClasses.active);
			scope_ActiveHandlesCount -= 1;
		}

		// Unbind the move and end events, which are added on 'start'.
		data.listeners.forEach(function( c ) {
			scope_DocumentElement.removeEventListener(c[0], c[1]);
		});

		if ( scope_ActiveHandlesCount === 0 ) {
			// Remove dragging class.
			removeClass(scope_Target, options.cssClasses.drag);
			setZindex();

			// Remove cursor styles and text-selection events bound to the body.
			if ( event.cursor ) {
				scope_Body.style.cursor = '';
				scope_Body.removeEventListener('selectstart', preventDefault);
			}
		}

		data.handleNumbers.forEach(function(handleNumber){
			fireEvent('change', handleNumber);
			fireEvent('set', handleNumber);
			fireEvent('end', handleNumber);
		});
	}

	// Bind move events on document.
	function eventStart ( event, data ) {

		var handle;
		if ( data.handleNumbers.length === 1 ) {

			var handleOrigin = scope_Handles[data.handleNumbers[0]];

			// Ignore 'disabled' handles
			if ( handleOrigin.hasAttribute('disabled') ) {
				return false;
			}

			handle = handleOrigin.children[0];
			scope_ActiveHandlesCount += 1;

			// Mark the handle as 'active' so it can be styled.
			addClass(handle, options.cssClasses.active);
		}

		// A drag should never propagate up to the 'tap' event.
		event.stopPropagation();

		// Record the event listeners.
		var listeners = [];

		// Attach the move and end events.
		var moveEvent = attachEvent(actions.move, scope_DocumentElement, eventMove, {
			// The event target has changed so we need to propagate the original one so that we keep
			// relying on it to extract target touches.
			target: event.target,
			handle: handle,
			listeners: listeners,
			startCalcPoint: event.calcPoint,
			baseSize: baseSize(),
			pageOffset: event.pageOffset,
			handleNumbers: data.handleNumbers,
			buttonsProperty: event.buttons,
			locations: scope_Locations.slice()
		});

		var endEvent = attachEvent(actions.end, scope_DocumentElement, eventEnd, {
			target: event.target,
			handle: handle,
			listeners: listeners,
			handleNumbers: data.handleNumbers
		});

		var outEvent = attachEvent("mouseout", scope_DocumentElement, documentLeave, {
			target: event.target,
			handle: handle,
			listeners: listeners,
			handleNumbers: data.handleNumbers
		});

		// We want to make sure we pushed the listeners in the listener list rather than creating
		// a new one as it has already been passed to the event handlers.
		listeners.push.apply(listeners, moveEvent.concat(endEvent, outEvent));

		// Text selection isn't an issue on touch devices,
		// so adding cursor styles can be skipped.
		if ( event.cursor ) {

			// Prevent the 'I' cursor and extend the range-drag cursor.
			scope_Body.style.cursor = getComputedStyle(event.target).cursor;

			// Mark the target with a dragging state.
			if ( scope_Handles.length > 1 ) {
				addClass(scope_Target, options.cssClasses.drag);
			}

			// Prevent text selection when dragging the handles.
			// In noUiSlider <= 9.2.0, this was handled by calling preventDefault on mouse/touch start/move,
			// which is scroll blocking. The selectstart event is supported by FireFox starting from version 52,
			// meaning the only holdout is iOS Safari. This doesn't matter: text selection isn't triggered there.
			// The 'cursor' flag is false.
			// See: http://caniuse.com/#search=selectstart
			scope_Body.addEventListener('selectstart', preventDefault, false);
		}

		data.handleNumbers.forEach(function(handleNumber){
			fireEvent('start', handleNumber);
		});
	}

	// Move closest handle to tapped location.
	function eventTap ( event ) {

		// The tap event shouldn't propagate up
		event.stopPropagation();

		var proposal = calcPointToPercentage(event.calcPoint);
		var handleNumber = getClosestHandle(proposal);

		// Tackle the case that all handles are 'disabled'.
		if ( handleNumber === false ) {
			return false;
		}

		// Flag the slider as it is now in a transitional state.
		// Transition takes a configurable amount of ms (default 300). Re-enable the slider after that.
		if ( !options.events.snap ) {
			addClassFor(scope_Target, options.cssClasses.tap, options.animationDuration);
		}

		setHandle(handleNumber, proposal, true, true);

		setZindex();

		fireEvent('slide', handleNumber, true);
		fireEvent('update', handleNumber, true);
		fireEvent('change', handleNumber, true);
		fireEvent('set', handleNumber, true);

		if ( options.events.snap ) {
			eventStart(event, { handleNumbers: [handleNumber] });
		}
	}

	// Fires a 'hover' event for a hovered mouse/pen position.
	function eventHover ( event ) {

		var proposal = calcPointToPercentage(event.calcPoint);

		var to = scope_Spectrum.getStep(proposal);
		var value = scope_Spectrum.fromStepping(to);

		Object.keys(scope_Events).forEach(function( targetEvent ) {
			if ( 'hover' === targetEvent.split('.')[0] ) {
				scope_Events[targetEvent].forEach(function( callback ) {
					callback.call( scope_Self, value );
				});
			}
		});
	}

	// Attach events to several slider parts.
	function bindSliderEvents ( behaviour ) {

		// Attach the standard drag event to the handles.
		if ( !behaviour.fixed ) {

			scope_Handles.forEach(function( handle, index ){

				// These events are only bound to the visual handle
				// element, not the 'real' origin element.
				attachEvent ( actions.start, handle.children[0], eventStart, {
					handleNumbers: [index]
				});
			});
		}

		// Attach the tap event to the slider base.
		if ( behaviour.tap ) {
			attachEvent (actions.start, scope_Base, eventTap, {});
		}

		// Fire hover events
		if ( behaviour.hover ) {
			attachEvent (actions.move, scope_Base, eventHover, { hover: true });
		}

		// Make the range draggable.
		if ( behaviour.drag ){

			scope_Connects.forEach(function( connect, index ){

				if ( connect === false || index === 0 || index === scope_Connects.length - 1 ) {
					return;
				}

				var handleBefore = scope_Handles[index - 1];
				var handleAfter = scope_Handles[index];
				var eventHolders = [connect];

				addClass(connect, options.cssClasses.draggable);

				// When the range is fixed, the entire range can
				// be dragged by the handles. The handle in the first
				// origin will propagate the start event upward,
				// but it needs to be bound manually on the other.
				if ( behaviour.fixed ) {
					eventHolders.push(handleBefore.children[0]);
					eventHolders.push(handleAfter.children[0]);
				}

				eventHolders.forEach(function( eventHolder ) {
					attachEvent ( actions.start, eventHolder, eventStart, {
						handles: [handleBefore, handleAfter],
						handleNumbers: [index - 1, index]
					});
				});
			});
		}
	}


	// Split out the handle positioning logic so the Move event can use it, too
	function checkHandlePosition ( reference, handleNumber, to, lookBackward, lookForward, getValue ) {

		// For sliders with multiple handles, limit movement to the other handle.
		// Apply the margin option by adding it to the handle positions.
		if ( scope_Handles.length > 1 ) {

			if ( lookBackward && handleNumber > 0 ) {
				to = Math.max(to, reference[handleNumber - 1] + options.margin);
			}

			if ( lookForward && handleNumber < scope_Handles.length - 1 ) {
				to = Math.min(to, reference[handleNumber + 1] - options.margin);
			}
		}

		// The limit option has the opposite effect, limiting handles to a
		// maximum distance from another. Limit must be > 0, as otherwise
		// handles would be unmoveable.
		if ( scope_Handles.length > 1 && options.limit ) {

			if ( lookBackward && handleNumber > 0 ) {
				to = Math.min(to, reference[handleNumber - 1] + options.limit);
			}

			if ( lookForward && handleNumber < scope_Handles.length - 1 ) {
				to = Math.max(to, reference[handleNumber + 1] - options.limit);
			}
		}

		// The padding option keeps the handles a certain distance from the
		// edges of the slider. Padding must be > 0.
		if ( options.padding ) {

			if ( handleNumber === 0 ) {
				to = Math.max(to, options.padding);
			}

			if ( handleNumber === scope_Handles.length - 1 ) {
				to = Math.min(to, 100 - options.padding);
			}
		}

		to = scope_Spectrum.getStep(to);

		// Limit percentage to the 0 - 100 range
		to = limit(to);

		// Return false if handle can't move
		if ( to === reference[handleNumber] && !getValue ) {
			return false;
		}

		return to;
	}

	function toPct ( pct ) {
		return pct + '%';
	}

	// Updates scope_Locations and scope_Values, updates visual state
	function updateHandlePosition ( handleNumber, to ) {

		// Update locations.
		scope_Locations[handleNumber] = to;

		// Convert the value to the slider stepping/range.
		scope_Values[handleNumber] = scope_Spectrum.fromStepping(to);

		// Called synchronously or on the next animationFrame
		var stateUpdate = function() {
			scope_Handles[handleNumber].style[options.style] = toPct(to);
			updateConnect(handleNumber);
			updateConnect(handleNumber + 1);
		};

		// Set the handle to the new position.
		// Use requestAnimationFrame for efficient painting.
		// No significant effect in Chrome, Edge sees dramatic performace improvements.
		// Option to disable is useful for unit tests, and single-step debugging.
		if ( window.requestAnimationFrame && options.useRequestAnimationFrame ) {
			window.requestAnimationFrame(stateUpdate);
		} else {
			stateUpdate();
		}
	}

	function setZindex ( ) {

		scope_HandleNumbers.forEach(function(handleNumber){
			// Handles before the slider middle are stacked later = higher,
			// Handles after the middle later is lower
			// [[7] [8] .......... | .......... [5] [4]
			var dir = (scope_Locations[handleNumber] > 50 ? -1 : 1);
			var zIndex = 3 + (scope_Handles.length + (dir * handleNumber));
			scope_Handles[handleNumber].childNodes[0].style.zIndex = zIndex;
		});
	}

	// Test suggested values and apply margin, step.
	function setHandle ( handleNumber, to, lookBackward, lookForward ) {

		to = checkHandlePosition(scope_Locations, handleNumber, to, lookBackward, lookForward, false);

		if ( to === false ) {
			return false;
		}

		updateHandlePosition(handleNumber, to);

		return true;
	}

	// Updates style attribute for connect nodes
	function updateConnect ( index ) {

		// Skip connects set to false
		if ( !scope_Connects[index] ) {
			return;
		}

		var l = 0;
		var h = 100;

		if ( index !== 0 ) {
			l = scope_Locations[index - 1];
		}

		if ( index !== scope_Connects.length - 1 ) {
			h = scope_Locations[index];
		}

		scope_Connects[index].style[options.style] = toPct(l);
		scope_Connects[index].style[options.styleOposite] = toPct(100 - h);
	}

	// ...
	function setValue ( to, handleNumber ) {

		// Setting with null indicates an 'ignore'.
		// Inputting 'false' is invalid.
		if ( to === null || to === false ) {
			return;
		}

		// If a formatted number was passed, attemt to decode it.
		if ( typeof to === 'number' ) {
			to = String(to);
		}

		to = options.format.from(to);

		// Request an update for all links if the value was invalid.
		// Do so too if setting the handle fails.
		if ( to !== false && !isNaN(to) ) {
			setHandle(handleNumber, scope_Spectrum.toStepping(to), false, false);
		}
	}

	// Set the slider value.
	function valueSet ( input, fireSetEvent ) {

		var values = asArray(input);
		var isInit = scope_Locations[0] === undefined;

		// Event fires by default
		fireSetEvent = (fireSetEvent === undefined ? true : !!fireSetEvent);

		values.forEach(setValue);

		// Animation is optional.
		// Make sure the initial values were set before using animated placement.
		if ( options.animate && !isInit ) {
			addClassFor(scope_Target, options.cssClasses.tap, options.animationDuration);
		}

		// Now that all base values are set, apply constraints
		scope_HandleNumbers.forEach(function(handleNumber){
			setHandle(handleNumber, scope_Locations[handleNumber], true, false);
		});

		setZindex();

		scope_HandleNumbers.forEach(function(handleNumber){

			fireEvent('update', handleNumber);

			// Fire the event only for handles that received a new value, as per #579
			if ( values[handleNumber] !== null && fireSetEvent ) {
				fireEvent('set', handleNumber);
			}
		});
	}

	// Reset slider to initial values
	function valueReset ( fireSetEvent ) {
		valueSet(options.start, fireSetEvent);
	}

	// Get the slider value.
	function valueGet ( ) {

		var values = scope_Values.map(options.format.to);

		// If only one handle is used, return a single value.
		if ( values.length === 1 ){
			return values[0];
		}

		return values;
	}

	// Removes classes from the root and empties it.
	function destroy ( ) {

		for ( var key in options.cssClasses ) {
			if ( !options.cssClasses.hasOwnProperty(key) ) { continue; }
			removeClass(scope_Target, options.cssClasses[key]);
		}

		while (scope_Target.firstChild) {
			scope_Target.removeChild(scope_Target.firstChild);
		}

		delete scope_Target.noUiSlider;
	}

	// Get the current step size for the slider.
	function getCurrentStep ( ) {

		// Check all locations, map them to their stepping point.
		// Get the step point, then find it in the input list.
		return scope_Locations.map(function( location, index ){

			var nearbySteps = scope_Spectrum.getNearbySteps( location );
			var value = scope_Values[index];
			var increment = nearbySteps.thisStep.step;
			var decrement = null;

			// If the next value in this step moves into the next step,
			// the increment is the start of the next step - the current value
			if ( increment !== false ) {
				if ( value + increment > nearbySteps.stepAfter.startValue ) {
					increment = nearbySteps.stepAfter.startValue - value;
				}
			}


			// If the value is beyond the starting point
			if ( value > nearbySteps.thisStep.startValue ) {
				decrement = nearbySteps.thisStep.step;
			}

			else if ( nearbySteps.stepBefore.step === false ) {
				decrement = false;
			}

			// If a handle is at the start of a step, it always steps back into the previous step first
			else {
				decrement = value - nearbySteps.stepBefore.highestStep;
			}


			// Now, if at the slider edges, there is not in/decrement
			if ( location === 100 ) {
				increment = null;
			}

			else if ( location === 0 ) {
				decrement = null;
			}

			// As per #391, the comparison for the decrement step can have some rounding issues.
			var stepDecimals = scope_Spectrum.countStepDecimals();

			// Round per #391
			if ( increment !== null && increment !== false ) {
				increment = Number(increment.toFixed(stepDecimals));
			}

			if ( decrement !== null && decrement !== false ) {
				decrement = Number(decrement.toFixed(stepDecimals));
			}

			return [decrement, increment];
		});
	}

	// Attach an event to this slider, possibly including a namespace
	function bindEvent ( namespacedEvent, callback ) {
		scope_Events[namespacedEvent] = scope_Events[namespacedEvent] || [];
		scope_Events[namespacedEvent].push(callback);

		// If the event bound is 'update,' fire it immediately for all handles.
		if ( namespacedEvent.split('.')[0] === 'update' ) {
			scope_Handles.forEach(function(a, index){
				fireEvent('update', index);
			});
		}
	}

	// Undo attachment of event
	function removeEvent ( namespacedEvent ) {

		var event = namespacedEvent && namespacedEvent.split('.')[0];
		var namespace = event && namespacedEvent.substring(event.length);

		Object.keys(scope_Events).forEach(function( bind ){

			var tEvent = bind.split('.')[0],
				tNamespace = bind.substring(tEvent.length);

			if ( (!event || event === tEvent) && (!namespace || namespace === tNamespace) ) {
				delete scope_Events[bind];
			}
		});
	}

	// Updateable: margin, limit, padding, step, range, animate, snap
	function updateOptions ( optionsToUpdate, fireSetEvent ) {

		// Spectrum is created using the range, snap, direction and step options.
		// 'snap' and 'step' can be updated.
		// If 'snap' and 'step' are not passed, they should remain unchanged.
		var v = valueGet();

		var updateAble = ['margin', 'limit', 'padding', 'range', 'animate', 'snap', 'step', 'format'];

		// Only change options that we're actually passed to update.
		updateAble.forEach(function(name){
			if ( optionsToUpdate[name] !== undefined ) {
				originalOptions[name] = optionsToUpdate[name];
			}
		});

		var newOptions = testOptions(originalOptions);

		// Load new options into the slider state
		updateAble.forEach(function(name){
			if ( optionsToUpdate[name] !== undefined ) {
				options[name] = newOptions[name];
			}
		});

		scope_Spectrum = newOptions.spectrum;

		// Limit, margin and padding depend on the spectrum but are stored outside of it. (#677)
		options.margin = newOptions.margin;
		options.limit = newOptions.limit;
		options.padding = newOptions.padding;

		// Update pips, removes existing.
		if ( options.pips ) {
			pips(options.pips);
		}

		// Invalidate the current positioning so valueSet forces an update.
		scope_Locations = [];
		valueSet(optionsToUpdate.start || v, fireSetEvent);
	}

	// Throw an error if the slider was already initialized.
	if ( scope_Target.noUiSlider ) {
		throw new Error("noUiSlider (" + VERSION + "): Slider was already initialized.");
	}

	// Create the base element, initialise HTML and set classes.
	// Add handles and connect elements.
	addSlider(scope_Target);
	addElements(options.connect, scope_Base);

	scope_Self = {
		destroy: destroy,
		steps: getCurrentStep,
		on: bindEvent,
		off: removeEvent,
		get: valueGet,
		set: valueSet,
		reset: valueReset,
		// Exposed for unit testing, don't use this in your application.
		__moveHandles: function(a, b, c) { moveHandles(a, b, scope_Locations, c); },
		options: originalOptions, // Issue #600, #678
		updateOptions: updateOptions,
		target: scope_Target, // Issue #597
		removePips: removePips,
		pips: pips // Issue #594
	};

	// Attach user events.
	bindSliderEvents(options.events);

	// Use the public value method to set the start values.
	valueSet(options.start);

	if ( options.pips ) {
		pips(options.pips);
	}

	if ( options.tooltips ) {
		tooltips();
	}

	aria();

	return scope_Self;

}


	// Run the standard initializer
	function initialize ( target, originalOptions ) {

		if ( !target || !target.nodeName ) {
			throw new Error("noUiSlider (" + VERSION + "): create requires a single element, got: " + target);
		}

		// Test the options and create the slider environment;
		var options = testOptions( originalOptions, target );
		var api = closure( target, options, originalOptions );

		target.noUiSlider = api;

		return api;
	}

	// Use an object instead of a function for future expansibility;
	return {
		version: VERSION,
		create: initialize
	};

}));

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var header = document.querySelector('[data-header]'); /* eslint-disable */


if (header !== null) {
  window.addEventListener('scroll', function () {
    if (window.pageYOffset > 450) {
      header.classList.add('is--minimal');
    } else {
      header.classList.remove('is--minimal');
    }
  });
}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var input = document.getElementById('js-search');
var suggest = document.getElementById('js-result-list');

if ((input && suggest) !== null) {
  var method = input.closest('form').dataset.autoSuggestMethod;
  var xhr = new XMLHttpRequest();

  var delay = function () {
    var timer = 0;
    return function (callback, ms) {
      clearTimeout(timer);
      timer = setTimeout(callback, ms);
    };
  }();

  if (input) {
    input.addEventListener('keyup', function () {
      delay(function () {
        if (input.value.length > 2) {
          var action = input.closest('form').dataset.autoSuggestAction;

          // fix relative path
          if (action.indexOf('/') !== 0) {
            action = '/' + action;
          }

          action = action + '&term=' + input.value;
          xhr.open(method, action, true);
          xhr.onload = function () {
            if (xhr.response.trim().substr(0, 3) === '<li') {
              suggest.innerHTML = xhr.response;
              suggest.classList.add('is--active');
            } else {
              suggest.classList.remove('is--active');
            }
          };
          xhr.send();
        } else {
          suggest.classList.remove('is--active');
        }
      }, 400);
    });
  }
}

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _flickity = __webpack_require__(150);

var _flickity2 = _interopRequireDefault(_flickity);

var _twt = __webpack_require__(13);

var TWTmediaQuery = _interopRequireWildcard(_twt);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blnIsTouchDevice = !!('ontouchstart' in window) || !!navigator.msMaxTouchPoints;
var FlickityDefaults = {
  cellSelector: '.slide',
  cellAlign: 'left',
  contain: true,
  draggable: blnIsTouchDevice,
  dragThreshold: 10,
  groupCells: true
};

/**
 * @param  {JQuery} element jQuery object
 * @param  {Object} options option parameters
 * @return {void}
 */
function initFlickity(element, options) {
  var config = Object.assign(FlickityDefaults, options);
  var flkty = new _flickity2.default(element, config);
  var customEvent = document.createEvent('Event');

  flkty.slider.style.display = 'flex';

  flkty.cells.forEach(function (cell) {
    cell.element.style.position = ''; // eslint-disable-line no-param-reassign
    cell.element.style.left = ''; // eslint-disable-line no-param-reassign
  });

  // init custom event
  customEvent.initEvent('resize', false, true);

  // dispatch custom event
  window.dispatchEvent(customEvent);

  return flkty;
}

window.onload = function () {
  var teaserSlider = [].slice.call(document.querySelectorAll('.slider--teaser'));

  if (teaserSlider !== null) {
    var sliderInstances = [];

    teaserSlider.forEach(function (slider) {
      initFlickity(slider);

      sliderInstances.push(slider);
    });
  }

  if (document.querySelectorAll('.slider--image') !== null) {
    var sliderNodes = document.querySelectorAll('.slider--image');
    var _sliderInstances = [];

    for (var i = 0; i < sliderNodes.length; i += 1) {
      var element = sliderNodes[i];
      _sliderInstances.push(initFlickity(element, {
        cellAlign: 'center'
      }));
    }
  }

  if (document.querySelectorAll('.slider--mobile') !== null) {
    var _sliderNodes = document.querySelectorAll('.slider--mobile');
    var strCurrentSize = TWTmediaQuery.getCurrentSize();
    var _sliderInstances2 = [];

    if (strCurrentSize === 'xs' || strCurrentSize === 's') {
      for (var _i = 0; _i < _sliderNodes.length; _i += 1) {
        var _element = _sliderNodes[_i];
        _sliderInstances2.push(initFlickity(_element));
      }
    }

    window.addEventListener('changed.twt.mediaQuery', function (event) {
      var newSize = event.detail.newSize;

      if (newSize !== 'xs' && newSize !== 's') {
        for (var _i2 = 0; _i2 < _sliderInstances2.length; _i2 += 1) {
          var _element2 = _sliderInstances2[_i2];
          _element2.flickity('destroy');
        }
        _sliderInstances2 = [];
      } else if (newSize === 'xs' || newSize === 's') {
        for (var _i3 = 0; _i3 < _sliderNodes.length; _i3 += 1) {
          var _element3 = _sliderNodes[_i3];
          _sliderInstances2.push(initFlickity(_element3));
        }
      }
    });
  }
};

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Flickity v2.0.8
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * http://flickity.metafizzy.co
 * Copyright 2016 Metafizzy
 */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(12),
      __webpack_require__(155),
      __webpack_require__(157),
      __webpack_require__(158),
      __webpack_require__(159),
      __webpack_require__(160),
      __webpack_require__(161)
    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      require('./flickity'),
      require('./drag'),
      require('./prev-next-button'),
      require('./page-dots'),
      require('./player'),
      require('./add-remove-cell'),
      require('./lazyload')
    );
  }

})( window, function factory( Flickity ) {
  /*jshint strict: false*/
  return Flickity;
});


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  /*global define: false, module: false */
  'use strict';
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.matchesSelector = factory();
  }

}( window, function factory() {
  'use strict';

  var matchesMethod = ( function() {
    var ElemProto = window.Element.prototype;
    // check for the standard method name first
    if ( ElemProto.matches ) {
      return 'matches';
    }
    // check un-prefixed
    if ( ElemProto.matchesSelector ) {
      return 'matchesSelector';
    }
    // check vendor prefixes
    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];

    for ( var i=0; i < prefixes.length; i++ ) {
      var prefix = prefixes[i];
      var method = prefix + 'MatchesSelector';
      if ( ElemProto[ method ] ) {
        return method;
      }
    }
  })();

  return function matchesSelector( elem, selector ) {
    return elem[ matchesMethod ]( selector );
  };

}));


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Flickity.Cell
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(79)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( getSize ) {
      return factory( window, getSize );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('get-size')
    );
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Cell = factory(
      window,
      window.getSize
    );
  }

}( window, function factory( window, getSize ) {

'use strict';

function Cell( elem, parent ) {
  this.element = elem;
  this.parent = parent;

  this.create();
}

var proto = Cell.prototype;

proto.create = function() {
  this.element.style.position = 'absolute';
  this.x = 0;
  this.shift = 0;
};

proto.destroy = function() {
  // reset style
  this.element.style.position = '';
  var side = this.parent.originSide;
  this.element.style[ side ] = '';
};

proto.getSize = function() {
  this.size = getSize( this.element );
};

proto.setPosition = function( x ) {
  this.x = x;
  this.updateTarget();
  this.renderPosition( x );
};

// setDefaultTarget v1 method, backwards compatibility, remove in v3
proto.updateTarget = proto.setDefaultTarget = function() {
  var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
  this.target = this.x + this.size[ marginProperty ] +
    this.size.width * this.parent.cellAlign;
};

proto.renderPosition = function( x ) {
  // render position of cell with in slider
  var side = this.parent.originSide;
  this.element.style[ side ] = this.parent.getPositionValue( x );
};

/**
 * @param {Integer} factor - 0, 1, or -1
**/
proto.wrapShift = function( shift ) {
  this.shift = shift;
  this.renderPosition( this.x + this.parent.slideableWidth * shift );
};

proto.remove = function() {
  this.element.parentNode.removeChild( this.element );
};

return Cell;

}));


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;// slide
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Slide = factory();
  }

}( window, function factory() {
'use strict';

function Slide( parent ) {
  this.parent = parent;
  this.isOriginLeft = parent.originSide == 'left';
  this.cells = [];
  this.outerWidth = 0;
  this.height = 0;
}

var proto = Slide.prototype;

proto.addCell = function( cell ) {
  this.cells.push( cell );
  this.outerWidth += cell.size.outerWidth;
  this.height = Math.max( cell.size.outerHeight, this.height );
  // first cell stuff
  if ( this.cells.length == 1 ) {
    this.x = cell.x; // x comes from first cell
    var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
    this.firstMargin = cell.size[ beginMargin ];
  }
};

proto.updateTarget = function() {
  var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
  var lastCell = this.getLastCell();
  var lastMargin = lastCell ? lastCell.size[ endMargin ] : 0;
  var slideWidth = this.outerWidth - ( this.firstMargin + lastMargin );
  this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
};

proto.getLastCell = function() {
  return this.cells[ this.cells.length - 1 ];
};

proto.select = function() {
  this.changeSelectedClass('add');
};

proto.unselect = function() {
  this.changeSelectedClass('remove');
};

proto.changeSelectedClass = function( method ) {
  this.cells.forEach( function( cell ) {
    cell.element.classList[ method ]('is-selected');
  });
};

proto.getCellElements = function() {
  return this.cells.map( function( cell ) {
    return cell.element;
  });
};

return Slide;

}));


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// animate
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(9)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( utils ) {
      return factory( window, utils );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('fizzy-ui-utils')
    );
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.animatePrototype = factory(
      window,
      window.fizzyUIUtils
    );
  }

}( window, function factory( window, utils ) {

'use strict';

// -------------------------- requestAnimationFrame -------------------------- //

// get rAF, prefixed, if present
var requestAnimationFrame = window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame;

// fallback to setTimeout
var lastTime = 0;
if ( !requestAnimationFrame )  {
  requestAnimationFrame = function( callback ) {
    var currTime = new Date().getTime();
    var timeToCall = Math.max( 0, 16 - ( currTime - lastTime ) );
    var id = setTimeout( callback, timeToCall );
    lastTime = currTime + timeToCall;
    return id;
  };
}

// -------------------------- animate -------------------------- //

var proto = {};

proto.startAnimation = function() {
  if ( this.isAnimating ) {
    return;
  }

  this.isAnimating = true;
  this.restingFrames = 0;
  this.animate();
};

proto.animate = function() {
  this.applyDragForce();
  this.applySelectedAttraction();

  var previousX = this.x;

  this.integratePhysics();
  this.positionSlider();
  this.settle( previousX );
  // animate next frame
  if ( this.isAnimating ) {
    var _this = this;
    requestAnimationFrame( function animateFrame() {
      _this.animate();
    });
  }
};


var transformProperty = ( function () {
  var style = document.documentElement.style;
  if ( typeof style.transform == 'string' ) {
    return 'transform';
  }
  return 'WebkitTransform';
})();

proto.positionSlider = function() {
  var x = this.x;
  // wrap position around
  if ( this.options.wrapAround && this.cells.length > 1 ) {
    x = utils.modulo( x, this.slideableWidth );
    x = x - this.slideableWidth;
    this.shiftWrapCells( x );
  }

  x = x + this.cursorPosition;
  // reverse if right-to-left and using transform
  x = this.options.rightToLeft && transformProperty ? -x : x;
  var value = this.getPositionValue( x );
  // use 3D tranforms for hardware acceleration on iOS
  // but use 2D when settled, for better font-rendering
  this.slider.style[ transformProperty ] = this.isAnimating ?
    'translate3d(' + value + ',0,0)' : 'translateX(' + value + ')';

  // scroll event
  var firstSlide = this.slides[0];
  if ( firstSlide ) {
    var positionX = -this.x - firstSlide.target;
    var progress = positionX / this.slidesWidth;
    this.dispatchEvent( 'scroll', null, [ progress, positionX ] );
  }
};

proto.positionSliderAtSelected = function() {
  if ( !this.cells.length ) {
    return;
  }
  this.x = -this.selectedSlide.target;
  this.positionSlider();
};

proto.getPositionValue = function( position ) {
  if ( this.options.percentPosition ) {
    // percent position, round to 2 digits, like 12.34%
    return ( Math.round( ( position / this.size.innerWidth ) * 10000 ) * 0.01 )+ '%';
  } else {
    // pixel positioning
    return Math.round( position ) + 'px';
  }
};

proto.settle = function( previousX ) {
  // keep track of frames where x hasn't moved
  if ( !this.isPointerDown && Math.round( this.x * 100 ) == Math.round( previousX * 100 ) ) {
    this.restingFrames++;
  }
  // stop animating if resting for 3 or more frames
  if ( this.restingFrames > 2 ) {
    this.isAnimating = false;
    delete this.isFreeScrolling;
    // render position with translateX when settled
    this.positionSlider();
    this.dispatchEvent('settle');
  }
};

proto.shiftWrapCells = function( x ) {
  // shift before cells
  var beforeGap = this.cursorPosition + x;
  this._shiftCells( this.beforeShiftCells, beforeGap, -1 );
  // shift after cells
  var afterGap = this.size.innerWidth - ( x + this.slideableWidth + this.cursorPosition );
  this._shiftCells( this.afterShiftCells, afterGap, 1 );
};

proto._shiftCells = function( cells, gap, shift ) {
  for ( var i=0; i < cells.length; i++ ) {
    var cell = cells[i];
    var cellShift = gap > 0 ? shift : 0;
    cell.wrapShift( cellShift );
    gap -= cell.size.outerWidth;
  }
};

proto._unshiftCells = function( cells ) {
  if ( !cells || !cells.length ) {
    return;
  }
  for ( var i=0; i < cells.length; i++ ) {
    cells[i].wrapShift( 0 );
  }
};

// -------------------------- physics -------------------------- //

proto.integratePhysics = function() {
  this.x += this.velocity;
  this.velocity *= this.getFrictionFactor();
};

proto.applyForce = function( force ) {
  this.velocity += force;
};

proto.getFrictionFactor = function() {
  return 1 - this.options[ this.isFreeScrolling ? 'freeScrollFriction' : 'friction' ];
};

proto.getRestingPosition = function() {
  // my thanks to Steven Wittens, who simplified this math greatly
  return this.x + this.velocity / ( 1 - this.getFrictionFactor() );
};

proto.applyDragForce = function() {
  if ( !this.isPointerDown ) {
    return;
  }
  // change the position to drag position by applying force
  var dragVelocity = this.dragX - this.x;
  var dragForce = dragVelocity - this.velocity;
  this.applyForce( dragForce );
};

proto.applySelectedAttraction = function() {
  // do not attract if pointer down or no cells
  if ( this.isPointerDown || this.isFreeScrolling || !this.cells.length ) {
    return;
  }
  var distance = this.selectedSlide.target * -1 - this.x;
  var force = distance * this.options.selectedAttraction;
  this.applyForce( force );
};

return proto;

}));


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// drag
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(12),
      __webpack_require__(156),
      __webpack_require__(9)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, Unidragger, utils ) {
      return factory( window, Flickity, Unidragger, utils );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('./flickity'),
      require('unidragger'),
      require('fizzy-ui-utils')
    );
  } else {
    // browser global
    window.Flickity = factory(
      window,
      window.Flickity,
      window.Unidragger,
      window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, Unidragger, utils ) {

'use strict';

// ----- defaults ----- //

utils.extend( Flickity.defaults, {
  draggable: true,
  dragThreshold: 3,
});

// ----- create ----- //

Flickity.createMethods.push('_createDrag');

// -------------------------- drag prototype -------------------------- //

var proto = Flickity.prototype;
utils.extend( proto, Unidragger.prototype );

// --------------------------  -------------------------- //

var isTouch = 'createTouch' in document;
var isTouchmoveScrollCanceled = false;

proto._createDrag = function() {
  this.on( 'activate', this.bindDrag );
  this.on( 'uiChange', this._uiChangeDrag );
  this.on( 'childUIPointerDown', this._childUIPointerDownDrag );
  this.on( 'deactivate', this.unbindDrag );
  // HACK - add seemingly innocuous handler to fix iOS 10 scroll behavior
  // #457, RubaXa/Sortable#973
  if ( isTouch && !isTouchmoveScrollCanceled ) {
    window.addEventListener( 'touchmove', function() {});
    isTouchmoveScrollCanceled = true;
  }
};

proto.bindDrag = function() {
  if ( !this.options.draggable || this.isDragBound ) {
    return;
  }
  this.element.classList.add('is-draggable');
  this.handles = [ this.viewport ];
  this.bindHandles();
  this.isDragBound = true;
};

proto.unbindDrag = function() {
  if ( !this.isDragBound ) {
    return;
  }
  this.element.classList.remove('is-draggable');
  this.unbindHandles();
  delete this.isDragBound;
};

proto._uiChangeDrag = function() {
  delete this.isFreeScrolling;
};

proto._childUIPointerDownDrag = function( event ) {
  event.preventDefault();
  this.pointerDownFocus( event );
};

// -------------------------- pointer events -------------------------- //

// nodes that have text fields
var cursorNodes = {
  TEXTAREA: true,
  INPUT: true,
  OPTION: true,
};

// input types that do not have text fields
var clickTypes = {
  radio: true,
  checkbox: true,
  button: true,
  submit: true,
  image: true,
  file: true,
};

proto.pointerDown = function( event, pointer ) {
  // dismiss inputs with text fields. #403, #404
  var isCursorInput = cursorNodes[ event.target.nodeName ] &&
    !clickTypes[ event.target.type ];
  if ( isCursorInput ) {
    // reset pointerDown logic
    this.isPointerDown = false;
    delete this.pointerIdentifier;
    return;
  }

  this._dragPointerDown( event, pointer );

  // kludge to blur focused inputs in dragger
  var focused = document.activeElement;
  if ( focused && focused.blur && focused != this.element &&
    // do not blur body for IE9 & 10, #117
    focused != document.body ) {
    focused.blur();
  }
  this.pointerDownFocus( event );
  // stop if it was moving
  this.dragX = this.x;
  this.viewport.classList.add('is-pointer-down');
  // bind move and end events
  this._bindPostStartEvents( event );
  // track scrolling
  this.pointerDownScroll = getScrollPosition();
  window.addEventListener( 'scroll', this );

  this.dispatchEvent( 'pointerDown', event, [ pointer ] );
};

proto.pointerDownFocus = function( event ) {
  // focus element, if not touch, and its not an input or select
  var canPointerDown = getCanPointerDown( event );
  if ( !this.options.accessibility || canPointerDown ) {
    return;
  }
  var prevScrollY = window.pageYOffset;
  this.element.focus();
  // hack to fix scroll jump after focus, #76
  if ( window.pageYOffset != prevScrollY ) {
    window.scrollTo( window.pageXOffset, prevScrollY );
  }
};

var touchStartEvents = {
  touchstart: true,
  pointerdown: true,
};

var focusNodes = {
  INPUT: true,
  SELECT: true,
};

function getCanPointerDown( event ) {
  var isTouchStart = touchStartEvents[ event.type ];
  var isFocusNode = focusNodes[ event.target.nodeName ];
  return isTouchStart || isFocusNode;
}

proto.canPreventDefaultOnPointerDown = function( event ) {
  // prevent default, unless touchstart or input
  var canPointerDown = getCanPointerDown( event );
  return !canPointerDown;
};

// ----- move ----- //

proto.hasDragStarted = function( moveVector ) {
  return Math.abs( moveVector.x ) > this.options.dragThreshold;
};

// ----- up ----- //

proto.pointerUp = function( event, pointer ) {
  delete this.isTouchScrolling;
  this.viewport.classList.remove('is-pointer-down');
  this.dispatchEvent( 'pointerUp', event, [ pointer ] );
  this._dragPointerUp( event, pointer );
};

proto.pointerDone = function() {
  window.removeEventListener( 'scroll', this );
  delete this.pointerDownScroll;
};

// -------------------------- dragging -------------------------- //

proto.dragStart = function( event, pointer ) {
  this.dragStartPosition = this.x;
  this.startAnimation();
  window.removeEventListener( 'scroll', this );
  this.dispatchEvent( 'dragStart', event, [ pointer ] );
};

proto.pointerMove = function( event, pointer ) {
  var moveVector = this._dragPointerMove( event, pointer );
  this.dispatchEvent( 'pointerMove', event, [ pointer, moveVector ] );
  this._dragMove( event, pointer, moveVector );
};

proto.dragMove = function( event, pointer, moveVector ) {
  event.preventDefault();

  this.previousDragX = this.dragX;
  // reverse if right-to-left
  var direction = this.options.rightToLeft ? -1 : 1;
  var dragX = this.dragStartPosition + moveVector.x * direction;

  if ( !this.options.wrapAround && this.slides.length ) {
    // slow drag
    var originBound = Math.max( -this.slides[0].target, this.dragStartPosition );
    dragX = dragX > originBound ? ( dragX + originBound ) * 0.5 : dragX;
    var endBound = Math.min( -this.getLastSlide().target, this.dragStartPosition );
    dragX = dragX < endBound ? ( dragX + endBound ) * 0.5 : dragX;
  }

  this.dragX = dragX;

  this.dragMoveTime = new Date();
  this.dispatchEvent( 'dragMove', event, [ pointer, moveVector ] );
};

proto.dragEnd = function( event, pointer ) {
  if ( this.options.freeScroll ) {
    this.isFreeScrolling = true;
  }
  // set selectedIndex based on where flick will end up
  var index = this.dragEndRestingSelect();

  if ( this.options.freeScroll && !this.options.wrapAround ) {
    // if free-scroll & not wrap around
    // do not free-scroll if going outside of bounding slides
    // so bounding slides can attract slider, and keep it in bounds
    var restingX = this.getRestingPosition();
    this.isFreeScrolling = -restingX > this.slides[0].target &&
      -restingX < this.getLastSlide().target;
  } else if ( !this.options.freeScroll && index == this.selectedIndex ) {
    // boost selection if selected index has not changed
    index += this.dragEndBoostSelect();
  }
  delete this.previousDragX;
  // apply selection
  // TODO refactor this, selecting here feels weird
  // HACK, set flag so dragging stays in correct direction
  this.isDragSelect = this.options.wrapAround;
  this.select( index );
  delete this.isDragSelect;
  this.dispatchEvent( 'dragEnd', event, [ pointer ] );
};

proto.dragEndRestingSelect = function() {
  var restingX = this.getRestingPosition();
  // how far away from selected slide
  var distance = Math.abs( this.getSlideDistance( -restingX, this.selectedIndex ) );
  // get closet resting going up and going down
  var positiveResting = this._getClosestResting( restingX, distance, 1 );
  var negativeResting = this._getClosestResting( restingX, distance, -1 );
  // use closer resting for wrap-around
  var index = positiveResting.distance < negativeResting.distance ?
    positiveResting.index : negativeResting.index;
  return index;
};

/**
 * given resting X and distance to selected cell
 * get the distance and index of the closest cell
 * @param {Number} restingX - estimated post-flick resting position
 * @param {Number} distance - distance to selected cell
 * @param {Integer} increment - +1 or -1, going up or down
 * @returns {Object} - { distance: {Number}, index: {Integer} }
 */
proto._getClosestResting = function( restingX, distance, increment ) {
  var index = this.selectedIndex;
  var minDistance = Infinity;
  var condition = this.options.contain && !this.options.wrapAround ?
    // if contain, keep going if distance is equal to minDistance
    function( d, md ) { return d <= md; } : function( d, md ) { return d < md; };
  while ( condition( distance, minDistance ) ) {
    // measure distance to next cell
    index += increment;
    minDistance = distance;
    distance = this.getSlideDistance( -restingX, index );
    if ( distance === null ) {
      break;
    }
    distance = Math.abs( distance );
  }
  return {
    distance: minDistance,
    // selected was previous index
    index: index - increment
  };
};

/**
 * measure distance between x and a slide target
 * @param {Number} x
 * @param {Integer} index - slide index
 */
proto.getSlideDistance = function( x, index ) {
  var len = this.slides.length;
  // wrap around if at least 2 slides
  var isWrapAround = this.options.wrapAround && len > 1;
  var slideIndex = isWrapAround ? utils.modulo( index, len ) : index;
  var slide = this.slides[ slideIndex ];
  if ( !slide ) {
    return null;
  }
  // add distance for wrap-around slides
  var wrap = isWrapAround ? this.slideableWidth * Math.floor( index / len ) : 0;
  return x - ( slide.target + wrap );
};

proto.dragEndBoostSelect = function() {
  // do not boost if no previousDragX or dragMoveTime
  if ( this.previousDragX === undefined || !this.dragMoveTime ||
    // or if drag was held for 100 ms
    new Date() - this.dragMoveTime > 100 ) {
    return 0;
  }

  var distance = this.getSlideDistance( -this.dragX, this.selectedIndex );
  var delta = this.previousDragX - this.dragX;
  if ( distance > 0 && delta > 0 ) {
    // boost to next if moving towards the right, and positive velocity
    return 1;
  } else if ( distance < 0 && delta < 0 ) {
    // boost to previous if moving towards the left, and negative velocity
    return -1;
  }
  return 0;
};

// ----- staticClick ----- //

proto.staticClick = function( event, pointer ) {
  // get clickedCell, if cell was clicked
  var clickedCell = this.getParentCell( event.target );
  var cellElem = clickedCell && clickedCell.element;
  var cellIndex = clickedCell && this.cells.indexOf( clickedCell );
  this.dispatchEvent( 'staticClick', event, [ pointer, cellElem, cellIndex ] );
};

// ----- scroll ----- //

proto.onscroll = function() {
  var scroll = getScrollPosition();
  var scrollMoveX = this.pointerDownScroll.x - scroll.x;
  var scrollMoveY = this.pointerDownScroll.y - scroll.y;
  // cancel click/tap if scroll is too much
  if ( Math.abs( scrollMoveX ) > 3 || Math.abs( scrollMoveY ) > 3 ) {
    this._pointerDone();
  }
};

// ----- utils ----- //

function getScrollPosition() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
}

// -----  ----- //

return Flickity;

}));


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Unidragger v2.2.2
 * Draggable base class
 * MIT license
 */

/*jshint browser: true, unused: true, undef: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(80)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Unipointer ) {
      return factory( window, Unipointer );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('unipointer')
    );
  } else {
    // browser global
    window.Unidragger = factory(
      window,
      window.Unipointer
    );
  }

}( window, function factory( window, Unipointer ) {

'use strict';

// -------------------------- Unidragger -------------------------- //

function Unidragger() {}

// inherit Unipointer & EvEmitter
var proto = Unidragger.prototype = Object.create( Unipointer.prototype );

// ----- bind start ----- //

proto.bindHandles = function() {
  this._bindHandles( true );
};

proto.unbindHandles = function() {
  this._bindHandles( false );
};

/**
 * works as unbinder, as you can .bindHandles( false ) to unbind
 * @param {Boolean} isBind - will unbind if falsey
 */
proto._bindHandles = function( isBind ) {
  // munge isBind, default to true
  isBind = isBind === undefined ? true : !!isBind;
  // bind each handle
  var bindMethod = isBind ? 'addEventListener' : 'removeEventListener';
  for ( var i=0; i < this.handles.length; i++ ) {
    var handle = this.handles[i];
    this._bindStartEvent( handle, isBind );
    handle[ bindMethod ]( 'click', this );
    // touch-action: none to override browser touch gestures
    // metafizzy/flickity#540
    if ( window.PointerEvent ) {
      handle.style.touchAction = isBind ? 'none' : '';
    }
  }
};

// ----- start event ----- //

/**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerDown = function( event, pointer ) {
  // dismiss range sliders
  if ( event.target.nodeName == 'INPUT' && event.target.type == 'range' ) {
    // reset pointerDown logic
    this.isPointerDown = false;
    delete this.pointerIdentifier;
    return;
  }

  this._dragPointerDown( event, pointer );
  // kludge to blur focused inputs in dragger
  var focused = document.activeElement;
  if ( focused && focused.blur ) {
    focused.blur();
  }
  // bind move and end events
  this._bindPostStartEvents( event );
  this.emitEvent( 'pointerDown', [ event, pointer ] );
};

// base pointer down logic
proto._dragPointerDown = function( event, pointer ) {
  // track to see when dragging starts
  this.pointerDownPoint = Unipointer.getPointerPoint( pointer );

  var canPreventDefault = this.canPreventDefaultOnPointerDown( event, pointer );
  if ( canPreventDefault ) {
    event.preventDefault();
  }
};

// overwriteable method so Flickity can prevent for scrolling
proto.canPreventDefaultOnPointerDown = function( event ) {
  // prevent default, unless touchstart or <select>
  return event.target.nodeName != 'SELECT';
};

// ----- move event ----- //

/**
 * drag move
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerMove = function( event, pointer ) {
  var moveVector = this._dragPointerMove( event, pointer );
  this.emitEvent( 'pointerMove', [ event, pointer, moveVector ] );
  this._dragMove( event, pointer, moveVector );
};

// base pointer move logic
proto._dragPointerMove = function( event, pointer ) {
  var movePoint = Unipointer.getPointerPoint( pointer );
  var moveVector = {
    x: movePoint.x - this.pointerDownPoint.x,
    y: movePoint.y - this.pointerDownPoint.y
  };
  // start drag if pointer has moved far enough to start drag
  if ( !this.isDragging && this.hasDragStarted( moveVector ) ) {
    this._dragStart( event, pointer );
  }
  return moveVector;
};

// condition if pointer has moved far enough to start drag
proto.hasDragStarted = function( moveVector ) {
  return Math.abs( moveVector.x ) > 3 || Math.abs( moveVector.y ) > 3;
};


// ----- end event ----- //

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerUp = function( event, pointer ) {
  this.emitEvent( 'pointerUp', [ event, pointer ] );
  this._dragPointerUp( event, pointer );
};

proto._dragPointerUp = function( event, pointer ) {
  if ( this.isDragging ) {
    this._dragEnd( event, pointer );
  } else {
    // pointer didn't move enough for drag to start
    this._staticClick( event, pointer );
  }
};

// -------------------------- drag -------------------------- //

// dragStart
proto._dragStart = function( event, pointer ) {
  this.isDragging = true;
  this.dragStartPoint = Unipointer.getPointerPoint( pointer );
  // prevent clicks
  this.isPreventingClicks = true;

  this.dragStart( event, pointer );
};

proto.dragStart = function( event, pointer ) {
  this.emitEvent( 'dragStart', [ event, pointer ] );
};

// dragMove
proto._dragMove = function( event, pointer, moveVector ) {
  // do not drag if not dragging yet
  if ( !this.isDragging ) {
    return;
  }

  this.dragMove( event, pointer, moveVector );
};

proto.dragMove = function( event, pointer, moveVector ) {
  event.preventDefault();
  this.emitEvent( 'dragMove', [ event, pointer, moveVector ] );
};

// dragEnd
proto._dragEnd = function( event, pointer ) {
  // set flags
  this.isDragging = false;
  // re-enable clicking async
  setTimeout( function() {
    delete this.isPreventingClicks;
  }.bind( this ) );

  this.dragEnd( event, pointer );
};

proto.dragEnd = function( event, pointer ) {
  this.emitEvent( 'dragEnd', [ event, pointer ] );
};

// ----- onclick ----- //

// handle all clicks and prevent clicks when dragging
proto.onclick = function( event ) {
  if ( this.isPreventingClicks ) {
    event.preventDefault();
  }
};

// ----- staticClick ----- //

// triggered after pointer down & up with no/tiny movement
proto._staticClick = function( event, pointer ) {
  // ignore emulated mouse up clicks
  if ( this.isIgnoringMouseUp && event.type == 'mouseup' ) {
    return;
  }

  // allow click in <input>s and <textarea>s
  var nodeName = event.target.nodeName;
  if ( nodeName == 'INPUT' || nodeName == 'TEXTAREA' ) {
    event.target.focus();
  }
  this.staticClick( event, pointer );

  // set flag for emulated clicks 300ms after touchend
  if ( event.type != 'mouseup' ) {
    this.isIgnoringMouseUp = true;
    // reset flag after 300ms
    setTimeout( function() {
      delete this.isIgnoringMouseUp;
    }.bind( this ), 400 );
  }
};

proto.staticClick = function( event, pointer ) {
  this.emitEvent( 'staticClick', [ event, pointer ] );
};

// ----- utils ----- //

Unidragger.getPointerPoint = Unipointer.getPointerPoint;

// -----  ----- //

return Unidragger;

}));


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// prev/next buttons
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(12),
      __webpack_require__(81),
      __webpack_require__(9)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, TapListener, utils ) {
      return factory( window, Flickity, TapListener, utils );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('./flickity'),
      require('tap-listener'),
      require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
      window,
      window.Flickity,
      window.TapListener,
      window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, TapListener, utils ) {
'use strict';

var svgURI = 'http://www.w3.org/2000/svg';

// -------------------------- PrevNextButton -------------------------- //

function PrevNextButton( direction, parent ) {
  this.direction = direction;
  this.parent = parent;
  this._create();
}

PrevNextButton.prototype = new TapListener();

PrevNextButton.prototype._create = function() {
  // properties
  this.isEnabled = true;
  this.isPrevious = this.direction == -1;
  var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
  this.isLeft = this.direction == leftDirection;

  var element = this.element = document.createElement('button');
  element.className = 'flickity-prev-next-button';
  element.className += this.isPrevious ? ' previous' : ' next';
  // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
  element.setAttribute( 'type', 'button' );
  // init as disabled
  this.disable();

  element.setAttribute( 'aria-label', this.isPrevious ? 'previous' : 'next' );

  // create arrow
  var svg = this.createSVG();
  element.appendChild( svg );
  // events
  this.on( 'tap', this.onTap );
  this.parent.on( 'select', this.update.bind( this ) );
  this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
};

PrevNextButton.prototype.activate = function() {
  this.bindTap( this.element );
  // click events from keyboard
  this.element.addEventListener( 'click', this );
  // add to DOM
  this.parent.element.appendChild( this.element );
};

PrevNextButton.prototype.deactivate = function() {
  // remove from DOM
  this.parent.element.removeChild( this.element );
  // do regular TapListener destroy
  TapListener.prototype.destroy.call( this );
  // click events from keyboard
  this.element.removeEventListener( 'click', this );
};

PrevNextButton.prototype.createSVG = function() {
  var svg = document.createElementNS( svgURI, 'svg');
  svg.setAttribute( 'viewBox', '0 0 100 100' );
  var path = document.createElementNS( svgURI, 'path');
  var pathMovements = getArrowMovements( this.parent.options.arrowShape );
  path.setAttribute( 'd', pathMovements );
  path.setAttribute( 'class', 'arrow' );
  // rotate arrow
  if ( !this.isLeft ) {
    path.setAttribute( 'transform', 'translate(100, 100) rotate(180) ' );
  }
  svg.appendChild( path );
  return svg;
};

// get SVG path movmement
function getArrowMovements( shape ) {
  // use shape as movement if string
  if ( typeof shape == 'string' ) {
    return shape;
  }
  // create movement string
  return 'M ' + shape.x0 + ',50' +
    ' L ' + shape.x1 + ',' + ( shape.y1 + 50 ) +
    ' L ' + shape.x2 + ',' + ( shape.y2 + 50 ) +
    ' L ' + shape.x3 + ',50 ' +
    ' L ' + shape.x2 + ',' + ( 50 - shape.y2 ) +
    ' L ' + shape.x1 + ',' + ( 50 - shape.y1 ) +
    ' Z';
}

PrevNextButton.prototype.onTap = function() {
  if ( !this.isEnabled ) {
    return;
  }
  this.parent.uiChange();
  var method = this.isPrevious ? 'previous' : 'next';
  this.parent[ method ]();
};

PrevNextButton.prototype.handleEvent = utils.handleEvent;

PrevNextButton.prototype.onclick = function() {
  // only allow clicks from keyboard
  var focused = document.activeElement;
  if ( focused && focused == this.element ) {
    this.onTap();
  }
};

// -----  ----- //

PrevNextButton.prototype.enable = function() {
  if ( this.isEnabled ) {
    return;
  }
  this.element.disabled = false;
  this.isEnabled = true;
};

PrevNextButton.prototype.disable = function() {
  if ( !this.isEnabled ) {
    return;
  }
  this.element.disabled = true;
  this.isEnabled = false;
};

PrevNextButton.prototype.update = function() {
  // index of first or last slide, if previous or next
  var slides = this.parent.slides;
  // enable is wrapAround and at least 2 slides
  if ( this.parent.options.wrapAround && slides.length > 1 ) {
    this.enable();
    return;
  }
  var lastIndex = slides.length ? slides.length - 1 : 0;
  var boundIndex = this.isPrevious ? 0 : lastIndex;
  var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
  this[ method ]();
};

PrevNextButton.prototype.destroy = function() {
  this.deactivate();
};

// -------------------------- Flickity prototype -------------------------- //

utils.extend( Flickity.defaults, {
  prevNextButtons: true,
  arrowShape: {
    x0: 10,
    x1: 60, y1: 50,
    x2: 70, y2: 40,
    x3: 30
  }
});

Flickity.createMethods.push('_createPrevNextButtons');
var proto = Flickity.prototype;

proto._createPrevNextButtons = function() {
  if ( !this.options.prevNextButtons ) {
    return;
  }

  this.prevButton = new PrevNextButton( -1, this );
  this.nextButton = new PrevNextButton( 1, this );

  this.on( 'activate', this.activatePrevNextButtons );
};

proto.activatePrevNextButtons = function() {
  this.prevButton.activate();
  this.nextButton.activate();
  this.on( 'deactivate', this.deactivatePrevNextButtons );
};

proto.deactivatePrevNextButtons = function() {
  this.prevButton.deactivate();
  this.nextButton.deactivate();
  this.off( 'deactivate', this.deactivatePrevNextButtons );
};

// --------------------------  -------------------------- //

Flickity.PrevNextButton = PrevNextButton;

return Flickity;

}));


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// page dots
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(12),
      __webpack_require__(81),
      __webpack_require__(9)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, TapListener, utils ) {
      return factory( window, Flickity, TapListener, utils );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('./flickity'),
      require('tap-listener'),
      require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
      window,
      window.Flickity,
      window.TapListener,
      window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, TapListener, utils ) {

// -------------------------- PageDots -------------------------- //

'use strict';

function PageDots( parent ) {
  this.parent = parent;
  this._create();
}

PageDots.prototype = new TapListener();

PageDots.prototype._create = function() {
  // create holder element
  this.holder = document.createElement('ol');
  this.holder.className = 'flickity-page-dots';
  // create dots, array of elements
  this.dots = [];
  // events
  this.on( 'tap', this.onTap );
  this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
};

PageDots.prototype.activate = function() {
  this.setDots();
  this.bindTap( this.holder );
  // add to DOM
  this.parent.element.appendChild( this.holder );
};

PageDots.prototype.deactivate = function() {
  // remove from DOM
  this.parent.element.removeChild( this.holder );
  TapListener.prototype.destroy.call( this );
};

PageDots.prototype.setDots = function() {
  // get difference between number of slides and number of dots
  var delta = this.parent.slides.length - this.dots.length;
  if ( delta > 0 ) {
    this.addDots( delta );
  } else if ( delta < 0 ) {
    this.removeDots( -delta );
  }
};

PageDots.prototype.addDots = function( count ) {
  var fragment = document.createDocumentFragment();
  var newDots = [];
  while ( count ) {
    var dot = document.createElement('li');
    dot.className = 'dot';
    fragment.appendChild( dot );
    newDots.push( dot );
    count--;
  }
  this.holder.appendChild( fragment );
  this.dots = this.dots.concat( newDots );
};

PageDots.prototype.removeDots = function( count ) {
  // remove from this.dots collection
  var removeDots = this.dots.splice( this.dots.length - count, count );
  // remove from DOM
  removeDots.forEach( function( dot ) {
    this.holder.removeChild( dot );
  }, this );
};

PageDots.prototype.updateSelected = function() {
  // remove selected class on previous
  if ( this.selectedDot ) {
    this.selectedDot.className = 'dot';
  }
  // don't proceed if no dots
  if ( !this.dots.length ) {
    return;
  }
  this.selectedDot = this.dots[ this.parent.selectedIndex ];
  this.selectedDot.className = 'dot is-selected';
};

PageDots.prototype.onTap = function( event ) {
  var target = event.target;
  // only care about dot clicks
  if ( target.nodeName != 'LI' ) {
    return;
  }

  this.parent.uiChange();
  var index = this.dots.indexOf( target );
  this.parent.select( index );
};

PageDots.prototype.destroy = function() {
  this.deactivate();
};

Flickity.PageDots = PageDots;

// -------------------------- Flickity -------------------------- //

utils.extend( Flickity.defaults, {
  pageDots: true
});

Flickity.createMethods.push('_createPageDots');

var proto = Flickity.prototype;

proto._createPageDots = function() {
  if ( !this.options.pageDots ) {
    return;
  }
  this.pageDots = new PageDots( this );
  // events
  this.on( 'activate', this.activatePageDots );
  this.on( 'select', this.updateSelectedPageDots );
  this.on( 'cellChange', this.updatePageDots );
  this.on( 'resize', this.updatePageDots );
  this.on( 'deactivate', this.deactivatePageDots );
};

proto.activatePageDots = function() {
  this.pageDots.activate();
};

proto.updateSelectedPageDots = function() {
  this.pageDots.updateSelected();
};

proto.updatePageDots = function() {
  this.pageDots.setDots();
};

proto.deactivatePageDots = function() {
  this.pageDots.deactivate();
};

// -----  ----- //

Flickity.PageDots = PageDots;

return Flickity;

}));


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// player & autoPlay
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(43),
      __webpack_require__(9),
      __webpack_require__(12)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter, utils, Flickity ) {
      return factory( EvEmitter, utils, Flickity );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      require('ev-emitter'),
      require('fizzy-ui-utils'),
      require('./flickity')
    );
  } else {
    // browser global
    factory(
      window.EvEmitter,
      window.fizzyUIUtils,
      window.Flickity
    );
  }

}( window, function factory( EvEmitter, utils, Flickity ) {

'use strict';

// -------------------------- Page Visibility -------------------------- //
// https://developer.mozilla.org/en-US/docs/Web/Guide/User_experience/Using_the_Page_Visibility_API

var hiddenProperty, visibilityEvent;
if ( 'hidden' in document ) {
  hiddenProperty = 'hidden';
  visibilityEvent = 'visibilitychange';
} else if ( 'webkitHidden' in document ) {
  hiddenProperty = 'webkitHidden';
  visibilityEvent = 'webkitvisibilitychange';
}

// -------------------------- Player -------------------------- //

function Player( parent ) {
  this.parent = parent;
  this.state = 'stopped';
  // visibility change event handler
  if ( visibilityEvent ) {
    this.onVisibilityChange = function() {
      this.visibilityChange();
    }.bind( this );
    this.onVisibilityPlay = function() {
      this.visibilityPlay();
    }.bind( this );
  }
}

Player.prototype = Object.create( EvEmitter.prototype );

// start play
Player.prototype.play = function() {
  if ( this.state == 'playing' ) {
    return;
  }
  // do not play if page is hidden, start playing when page is visible
  var isPageHidden = document[ hiddenProperty ];
  if ( visibilityEvent && isPageHidden ) {
    document.addEventListener( visibilityEvent, this.onVisibilityPlay );
    return;
  }

  this.state = 'playing';
  // listen to visibility change
  if ( visibilityEvent ) {
    document.addEventListener( visibilityEvent, this.onVisibilityChange );
  }
  // start ticking
  this.tick();
};

Player.prototype.tick = function() {
  // do not tick if not playing
  if ( this.state != 'playing' ) {
    return;
  }

  var time = this.parent.options.autoPlay;
  // default to 3 seconds
  time = typeof time == 'number' ? time : 3000;
  var _this = this;
  // HACK: reset ticks if stopped and started within interval
  this.clear();
  this.timeout = setTimeout( function() {
    _this.parent.next( true );
    _this.tick();
  }, time );
};

Player.prototype.stop = function() {
  this.state = 'stopped';
  this.clear();
  // remove visibility change event
  if ( visibilityEvent ) {
    document.removeEventListener( visibilityEvent, this.onVisibilityChange );
  }
};

Player.prototype.clear = function() {
  clearTimeout( this.timeout );
};

Player.prototype.pause = function() {
  if ( this.state == 'playing' ) {
    this.state = 'paused';
    this.clear();
  }
};

Player.prototype.unpause = function() {
  // re-start play if paused
  if ( this.state == 'paused' ) {
    this.play();
  }
};

// pause if page visibility is hidden, unpause if visible
Player.prototype.visibilityChange = function() {
  var isPageHidden = document[ hiddenProperty ];
  this[ isPageHidden ? 'pause' : 'unpause' ]();
};

Player.prototype.visibilityPlay = function() {
  this.play();
  document.removeEventListener( visibilityEvent, this.onVisibilityPlay );
};

// -------------------------- Flickity -------------------------- //

utils.extend( Flickity.defaults, {
  pauseAutoPlayOnHover: true
});

Flickity.createMethods.push('_createPlayer');
var proto = Flickity.prototype;

proto._createPlayer = function() {
  this.player = new Player( this );

  this.on( 'activate', this.activatePlayer );
  this.on( 'uiChange', this.stopPlayer );
  this.on( 'pointerDown', this.stopPlayer );
  this.on( 'deactivate', this.deactivatePlayer );
};

proto.activatePlayer = function() {
  if ( !this.options.autoPlay ) {
    return;
  }
  this.player.play();
  this.element.addEventListener( 'mouseenter', this );
};

// Player API, don't hate the ... thanks I know where the door is

proto.playPlayer = function() {
  this.player.play();
};

proto.stopPlayer = function() {
  this.player.stop();
};

proto.pausePlayer = function() {
  this.player.pause();
};

proto.unpausePlayer = function() {
  this.player.unpause();
};

proto.deactivatePlayer = function() {
  this.player.stop();
  this.element.removeEventListener( 'mouseenter', this );
};

// ----- mouseenter/leave ----- //

// pause auto-play on hover
proto.onmouseenter = function() {
  if ( !this.options.pauseAutoPlayOnHover ) {
    return;
  }
  this.player.pause();
  this.element.addEventListener( 'mouseleave', this );
};

// resume auto-play on hover off
proto.onmouseleave = function() {
  this.player.unpause();
  this.element.removeEventListener( 'mouseleave', this );
};

// -----  ----- //

Flickity.Player = Player;

return Flickity;

}));


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// add, remove cell
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(12),
      __webpack_require__(9)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, utils ) {
      return factory( window, Flickity, utils );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('./flickity'),
      require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
      window,
      window.Flickity,
      window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, utils ) {

'use strict';

// append cells to a document fragment
function getCellsFragment( cells ) {
  var fragment = document.createDocumentFragment();
  cells.forEach( function( cell ) {
    fragment.appendChild( cell.element );
  });
  return fragment;
}

// -------------------------- add/remove cell prototype -------------------------- //

var proto = Flickity.prototype;

/**
 * Insert, prepend, or append cells
 * @param {Element, Array, NodeList} elems
 * @param {Integer} index
 */
proto.insert = function( elems, index ) {
  var cells = this._makeCells( elems );
  if ( !cells || !cells.length ) {
    return;
  }
  var len = this.cells.length;
  // default to append
  index = index === undefined ? len : index;
  // add cells with document fragment
  var fragment = getCellsFragment( cells );
  // append to slider
  var isAppend = index == len;
  if ( isAppend ) {
    this.slider.appendChild( fragment );
  } else {
    var insertCellElement = this.cells[ index ].element;
    this.slider.insertBefore( fragment, insertCellElement );
  }
  // add to this.cells
  if ( index === 0 ) {
    // prepend, add to start
    this.cells = cells.concat( this.cells );
  } else if ( isAppend ) {
    // append, add to end
    this.cells = this.cells.concat( cells );
  } else {
    // insert in this.cells
    var endCells = this.cells.splice( index, len - index );
    this.cells = this.cells.concat( cells ).concat( endCells );
  }

  this._sizeCells( cells );

  var selectedIndexDelta = index > this.selectedIndex ? 0 : cells.length;
  this._cellAddedRemoved( index, selectedIndexDelta );
};

proto.append = function( elems ) {
  this.insert( elems, this.cells.length );
};

proto.prepend = function( elems ) {
  this.insert( elems, 0 );
};

/**
 * Remove cells
 * @param {Element, Array, NodeList} elems
 */
proto.remove = function( elems ) {
  var cells = this.getCells( elems );
  var selectedIndexDelta = 0;
  var len = cells.length;
  var i, cell;
  // calculate selectedIndexDelta, easier if done in seperate loop
  for ( i=0; i < len; i++ ) {
    cell = cells[i];
    var wasBefore = this.cells.indexOf( cell ) < this.selectedIndex;
    selectedIndexDelta -= wasBefore ? 1 : 0;
  }

  for ( i=0; i < len; i++ ) {
    cell = cells[i];
    cell.remove();
    // remove item from collection
    utils.removeFrom( this.cells, cell );
  }

  if ( cells.length ) {
    // update stuff
    this._cellAddedRemoved( 0, selectedIndexDelta );
  }
};

// updates when cells are added or removed
proto._cellAddedRemoved = function( changedCellIndex, selectedIndexDelta ) {
  // TODO this math isn't perfect with grouped slides
  selectedIndexDelta = selectedIndexDelta || 0;
  this.selectedIndex += selectedIndexDelta;
  this.selectedIndex = Math.max( 0, Math.min( this.slides.length - 1, this.selectedIndex ) );

  this.cellChange( changedCellIndex, true );
  // backwards compatibility
  this.emitEvent( 'cellAddedRemoved', [ changedCellIndex, selectedIndexDelta ] );
};

/**
 * logic to be run after a cell's size changes
 * @param {Element} elem - cell's element
 */
proto.cellSizeChange = function( elem ) {
  var cell = this.getCell( elem );
  if ( !cell ) {
    return;
  }
  cell.getSize();

  var index = this.cells.indexOf( cell );
  this.cellChange( index );
};

/**
 * logic any time a cell is changed: added, removed, or size changed
 * @param {Integer} changedCellIndex - index of the changed cell, optional
 */
proto.cellChange = function( changedCellIndex, isPositioningSlider ) {
  var prevSlideableWidth = this.slideableWidth;
  this._positionCells( changedCellIndex );
  this._getWrapShiftCells();
  this.setGallerySize();
  this.emitEvent( 'cellChange', [ changedCellIndex ] );
  // position slider
  if ( this.options.freeScroll ) {
    // shift x by change in slideableWidth
    // TODO fix position shifts when prepending w/ freeScroll
    var deltaX = prevSlideableWidth - this.slideableWidth;
    this.x += deltaX * this.cellAlign;
    this.positionSlider();
  } else {
    // do not position slider after lazy load
    if ( isPositioningSlider ) {
      this.positionSliderAtSelected();
    }
    this.select( this.selectedIndex );
  }
};

// -----  ----- //

return Flickity;

}));


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// lazyload
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(12),
      __webpack_require__(9)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, utils ) {
      return factory( window, Flickity, utils );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('./flickity'),
      require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
      window,
      window.Flickity,
      window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, utils ) {
'use strict';

Flickity.createMethods.push('_createLazyload');
var proto = Flickity.prototype;

proto._createLazyload = function() {
  this.on( 'select', this.lazyLoad );
};

proto.lazyLoad = function() {
  var lazyLoad = this.options.lazyLoad;
  if ( !lazyLoad ) {
    return;
  }
  // get adjacent cells, use lazyLoad option for adjacent count
  var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
  var cellElems = this.getAdjacentCellElements( adjCount );
  // get lazy images in those cells
  var lazyImages = [];
  cellElems.forEach( function( cellElem ) {
    var lazyCellImages = getCellLazyImages( cellElem );
    lazyImages = lazyImages.concat( lazyCellImages );
  });
  // load lazy images
  lazyImages.forEach( function( img ) {
    new LazyLoader( img, this );
  }, this );
};

function getCellLazyImages( cellElem ) {
  // check if cell element is lazy image
  if ( cellElem.nodeName == 'IMG' &&
    cellElem.getAttribute('data-flickity-lazyload') ) {
    return [ cellElem ];
  }
  // select lazy images in cell
  var imgs = cellElem.querySelectorAll('img[data-flickity-lazyload]');
  return utils.makeArray( imgs );
}

// -------------------------- LazyLoader -------------------------- //

/**
 * class to handle loading images
 */
function LazyLoader( img, flickity ) {
  this.img = img;
  this.flickity = flickity;
  this.load();
}

LazyLoader.prototype.handleEvent = utils.handleEvent;

LazyLoader.prototype.load = function() {
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  // load image
  this.img.src = this.img.getAttribute('data-flickity-lazyload');
  // remove attr
  this.img.removeAttribute('data-flickity-lazyload');
};

LazyLoader.prototype.onload = function( event ) {
  this.complete( event, 'flickity-lazyloaded' );
};

LazyLoader.prototype.onerror = function( event ) {
  this.complete( event, 'flickity-lazyerror' );
};

LazyLoader.prototype.complete = function( event, className ) {
  // unbind events
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );

  var cell = this.flickity.getParentCell( this.img );
  var cellElem = cell && cell.element;
  this.flickity.cellSizeChange( cellElem );

  this.img.classList.add( className );
  this.flickity.dispatchEvent( 'lazyLoad', event, cellElem );
};

// -----  ----- //

Flickity.LazyLoader = LazyLoader;

return Flickity;

}));


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)('.teaser--video .teaser__video, .teaser--video.teaser--video--only-play').on('click', function (event) {
    var $el = (0, _jquery2.default)(event.delegateTarget);
    event.stopPropagation();
    event.preventDefault();

    _jquery2.default.fancybox.open({
      src: $el.data('video-url'),
      type: 'iframe'
    });
  });
  (0, _jquery2.default)('a.fancybox-media').fancybox();
});

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var options = {
  openClass: 'is--open',
  hiddenClass: 'is--hidden'
};

/**
 * @param  {HTMLElement} breadcrumb the breadcrumb to get the entries from
 * @return {Array} entries
 */
function getBreadcrumbEntries(breadcrumb) {
  return [].slice.call(breadcrumb.querySelectorAll('li'));
}

/**
 * @param  {HTMLElement} breadcrumb the breadcrumb to expand
 * @return {void}
 */
function expandBreadcrumb(breadcrumb) {
  var entries = getBreadcrumbEntries(breadcrumb);
  var closeButton = breadcrumb.querySelector('[data-close]');
  var expandElement = breadcrumb.querySelector('[data-expand]');

  // add open class
  breadcrumb.classList.add(options.openClass);

  // show hidden entries
  entries.forEach(function (entry) {
    entry.classList.remove(options.hiddenClass);
  });

  // remove element to expand breadcrumb
  breadcrumb.querySelector('ul').removeChild(expandElement);

  // show close button and add event listener
  closeButton.classList.remove(options.hiddenClass);
}

/**
 * @param  {HTMLElement} breadcrumb the breadcrumb to create the element for
 * @return {HTMLElement} element for hidden entries
 */
function createElementForHiddenEntries(breadcrumb) {
  var entries = getBreadcrumbEntries(breadcrumb);
  var element = entries[0].cloneNode(false);
  var icon = breadcrumb.dataset.icon;

  // add classes and attributes
  element.classList.add('is--placeholder');
  element.dataset.expand = true;

  // add content
  element.innerHTML = '<span class="nav__item__trigger"><svg class="icon"><use xlink:href="' + icon + '"></use></svg><span>&hellip;</span></span>';

  // event listener
  element.addEventListener('click', function () {
    expandBreadcrumb(breadcrumb);
  });

  // return
  return element;
}

/**
 * @param  {HTMLElement} breadcrumb the breadcrumb to collapse
 * @return {void}
 */
function collapseBreadcrumb(breadcrumb) {
  var threshold = breadcrumb.dataset.threshold || 3;
  var entries = getBreadcrumbEntries(breadcrumb);
  var numberOfEntries = entries.length;
  var expandElement = createElementForHiddenEntries(breadcrumb);
  var closeButton = breadcrumb.querySelector('[data-close]');

  if (numberOfEntries > threshold) {
    var entriesToHide = entries.slice(1, numberOfEntries - 1);

    // remove open class
    breadcrumb.classList.remove(options.openClass);

    // add class to hide entries
    entriesToHide.forEach(function (entry) {
      entry.classList.add(options.hiddenClass);
    });

    // insert element to expand breadcrumb before last entry
    breadcrumb.querySelector('ul').insertBefore(expandElement, entries[entries.length - 1]);

    // hide close button
    closeButton.classList.add(options.hiddenClass);
  }
}

/**
 * start the magic
 *
 * @return {void}
 */
function init() {
  var breadcrumb = document.querySelector('[data-breadcrumb]');

  if (breadcrumb !== null) {
    var closeButton = breadcrumb.querySelector('[data-close]');

    // set initial state
    collapseBreadcrumb(breadcrumb);

    // event listener
    closeButton.addEventListener('click', function () {
      collapseBreadcrumb(breadcrumb);
    });
  }
}

init();

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function ($, window, document, undefined) {
  var defaults = {
    enabledClass: 'accordion--enabled',
    activeClass: 'is--active'
  };

  var Accordion = function Accordion(element, options) {
    this.el = element;
    this.options = options;
    this.$el = $(this.el);

    this.options = $.extend({}, defaults, options);
    this.options = $.extend({}, this.options, this.$el.data());

    this.$elTitles = this.$el.find('.accordion__title');
    this.$elContents = this.$el.find('.accordion__content');

    this.$el.addClass(this.options.enabledClass);

    this.init();
  };

  $.extend(Accordion.prototype, {
    init: function init() {
      this.prepareMarkup();
    },
    prepareMarkup: function prepareMarkup() {
      this.$elTitles.on('click.Accordion', $.proxy(this.onClick, this));
    },
    onClick: function onClick(event) {
      var $el = $(event.delegateTarget);
      var $elCurrentTitle = this.$elTitles.filter('.' + this.options.activeClass);
      var $elCurrentContent = this.$elContents.filter('.' + this.options.activeClass);

      if ($el !== $elCurrentTitle) {
        $el.addClass(this.options.activeClass);
        $el.next().stop().slideDown();
        $el.next().addClass(this.options.activeClass);
      }
      $elCurrentTitle.removeClass(this.options.activeClass);
      $elCurrentContent.stop().slideUp();
      $elCurrentContent.removeClass(this.options.activeClass);
      $.fn.matchHeight._update();
    },
    onSlideUp: function onSlideUp($elTitle, $elContent) {},
    onSlideDown: function onSlideDown($elTitle, $elContent) {}
  });

  function jqAccordion(options) {
    return this.each(function () {
      var returnValue = null;
      if (!$.data(this, 'Accordion')) {
        returnValue = $.data(this, 'Accordion', new Accordion(this, options));
      } else {
        returnValue = $.data(this, 'Accordion');
      }
      return returnValue;
    });
  }

  $.fn.Accordion = jqAccordion;

  $('.accordion').Accordion();
})(_jquery2.default, window, document); /* eslint-disable */

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(document).ready(function () {
  // browser window scroll (in pixels) after which the "back to top" link is shown
  var offset = 300;

  // duration of the top scrolling animation (in ms)
  var scrollTopDuration = 700;

  // grab the "back to top" link
  var $backToTop = (0, _jquery2.default)('.to-top-link');

  // smooth scroll to top
  $backToTop.on('click', function (event) {
    event.preventDefault();

    (0, _jquery2.default)('body,html').animate({
      scrollTop: 0
    }, scrollTopDuration);
  });

  (0, _jquery2.default)(window).on('scroll', function () {
    $backToTop.toggleClass('is--sticky', (0, _jquery2.default)(window).scrollTop() > offset);
  });
});

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function ($, window, document, undefined) {
  var defaults = {};

  var Limiter = function Limiter(element, options) {
    this._el = element;
    this.$el = $(this._el);
    this.$el.addClass('limiter--enabled');
    this.$elChildren = this.$el.children();
    this.state = 'closed';

    this._options = options;
    this.options = $.extend({}, defaults, this._options);
    this.options = $.extend({}, this.options, this.$el.data());

    this.init();
  };

  $.extend(Limiter.prototype, {
    init: function init() {
      this.bindEvents();
    },
    calculateRows: function calculateRows() {
      var intLastOffset = this.$elChildren.first().offset().top;
      var intCurrentRow = 0;
      var arrRows = [];
      this.$elChildren.show();
      this.$elChildren.each(function () {
        var $el = $(this);
        var intCurrentOffset = $el.offset().top;

        if (intCurrentOffset === intLastOffset) {
          if (!$.isArray(arrRows[intCurrentRow])) {
            arrRows[intCurrentRow] = [];
          }
          arrRows[intCurrentRow].push($el);
        } else {
          intLastOffset = intCurrentOffset;
          ++intCurrentRow;
          arrRows.push([$el]);
        }
      });
      this.arrRows = arrRows;
    },
    hideRows: function hideRows() {
      this.$elChildren.hide();
      var arrVisibleRows = this.arrRows.slice(0, this.options.limitRows);
      for (var row in arrVisibleRows) {
        for (var child in arrVisibleRows[row]) {
          $(arrVisibleRows[row][child]).show();
        }
      }
      this.state = 'closed';
    },
    bindEvents: function bindEvents() {
      $(window).on('resize.Limiter', $.proxy(this.onResize, this)).trigger('resize.Limiter');
      this.$el.next('.btn').on('click.Limiter', $.proxy(this.toggleRows, this));
    },
    onResize: function onResize() {
      this.calculateRows();
      if (this.state === 'closed') this.hideRows();
      this.$el.next('.btn').toggle(this.arrRows.length > this.options.limitRows);
    },
    showRows: function showRows() {
      this.$elChildren.show();
      this.state = 'opened';
    },
    toggleRows: function toggleRows(event) {
      var $el = $(event.delegateTarget);
      event.preventDefault();
      if (this.state === 'opened') {
        this.hideRows();
        $el.find('.btn__text').text(this.options.buttonTextOpen);
        $('html, body').animate({
          'scrollTop': this.$el.offset().top - $('.page-header').height() - 25
        }, 500);
      } else if (this.state === 'closed') {
        this.showRows();
        $el.find('.btn__text').text(this.options.buttonTextClose);
      }
      $el.toggleClass('is--toggled');
    }
  });

  $.fn.Limiter = function (options) {
    return this.each(function () {
      var returnValue = null;
      if (!$.data(this, 'Limiter')) {
        returnValue = $.data(this, 'Limiter', new Limiter(this, options));
      } else {
        returnValue = $.data(this, 'Limiter');
      }
      return returnValue;
    });
  };

  $('[data-limit-rows]').Limiter();
})(_jquery2.default, window, document); /* eslint-disable */

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function ($, window, document, undefined) {
  var defaults = {};

  var Collapsable = function Collapsable(element, options) {
    this._el = element;
    this.$el = $(this._el);
    this.$el.addClass('collapsable--enabled');
    this.$elContent = this.$el.find('.collapsable__content');
    this.$elTrigger = this.$el.children('.btn');
    this.state = 'opened';

    this._options = options;
    this.options = $.extend({}, defaults, this._options);
    this.options = $.extend({}, this.options, this.$el.data());

    this.init();
  };

  $.extend(Collapsable.prototype, {
    init: function init() {
      this.bindEvents();
    },
    bindEvents: function bindEvents() {
      this.$elTrigger.on('click.Collapsable', $.proxy(this.toggleContent, this));
    },
    toggleContent: function toggleContent(event) {
      event.preventDefault();
      this.$el.toggleClass('is--collapsed');
      if (this.state === 'opened') {
        this.$elContent.slideUp();
        this.$elTrigger.find('.btn__text').text(this.options.buttonTextOpen);
        this.state = 'closed';

        $('html, body').animate({
          'scrollTop': this.$el.offset().top - $('.page-header').height() - 20
        }, 500);
      } else if (this.state === 'closed') {
        this.$elContent.slideDown();
        this.$elTrigger.find('.btn__text').text(this.options.buttonTextClose);
        this.state = 'opened';
      }
    }
  });

  $.fn.Collapsable = function (options) {
    return this.each(function () {
      var returnValue = null;
      if (!$.data(this, 'Collapsable')) {
        returnValue = $.data(this, 'Collapsable', new Collapsable(this, options));
      } else {
        returnValue = $.data(this, 'Collapsable');
      }
      return returnValue;
    });
  };

  $('.collapsable').Collapsable();
})(_jquery2.default, window, document); /* eslint-disable */

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function ($, window, document, undefined) {
  var blnIsTouchDevice = !!('ontouchstart' in window) || !!navigator.msMaxTouchPoints;

  $(document).ready(function () {
    if (blnIsTouchDevice) {
      $('.site-settings-item').on('click.SiteSetting', function () {
        $(this).siblings('.is--open').removeClass('is--open');
        $(this).toggleClass('is--open');

        // close several other flyouts
        // $('.page-header .search').removeClass('is--open');
        // $('.page-header .meta-main-navigation .btn').removeClass('is--active');
        // $('.main-navigation').removeClass('is--open');
        // $('body').removeClass('open-off-canvas');
      });
    }
  });
})(_jquery2.default, window, document); /* eslint-disable */

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function ($, window, document) {
  $(document).ready(function () {
    $('.frm__fld--amount.has--refresh-button').each(function (index, item) {
      var $elParent = $(item);
      var $elInputField = $elParent.find('input');

      $elInputField.data('lastValue', $elInputField.val());
      $elInputField.on('input change keyup', function (event) {
        var $this = $(event.currentTarget);

        if ($this.data('lastValue') !== $this.val()) {
          $elParent.find('.btn').removeClass('is--disabled');
        } else {
          $elParent.find('.btn').addClass('is--disabled');
        }
      });
    });
  });
})(_jquery2.default, window, document);

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _twt = __webpack_require__(13);

var TWTmediaQuery = _interopRequireWildcard(_twt);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var removeMoreButton = (0, _jquery2.default)('.btn.more.show-for-large');
var current = 'only screen and (min-width: 64em)';

window.addEventListener('resize', function () {
  var newSize = TWTmediaQuery.getCurrentSize();

  if (newSize > current) {
    current = newSize;
    removeMoreButton.remove();
  }
});

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var printButtons = [].slice.call(document.querySelectorAll('[data-print]'));

if (printButtons !== null) {
  printButtons.forEach(function (button) {
    // set event listener
    button.addEventListener('click', function () {
      window.print();
    });
  });
}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(document).ready(function () {
  var emailFromSender = (0, _jquery2.default)('.emailFromSender_input');
  var emailFromSenderChk = (0, _jquery2.default)('.emailFromSender_check');
  // input field for emailFromSender should not be visible
  (0, _jquery2.default)(emailFromSender).closest('.frm__row').hide();

  // if user checks 'yes, i want a copy of this form to my mail-address...'
  (0, _jquery2.default)(emailFromSenderChk).on('click', function () {
    (0, _jquery2.default)(emailFromSenderChk).delay(100).queue(function () {
      if ((0, _jquery2.default)(emailFromSenderChk).closest('.frm__row').find('.emailFromSender_check').is(':checked')) {
        // ... then, copy value of input.email in our hidden field
        (0, _jquery2.default)(emailFromSender).val((0, _jquery2.default)('.email').val());
      } else {
        // if user un-check the box, a default-value for cms has to be there
        (0, _jquery2.default)(emailFromSender).val('no-reply@example.com');
      }
      (0, _jquery2.default)(emailFromSenderChk).dequeue();
    });
  });
});

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var submitButtons = [].slice.call(document.querySelectorAll('[data-submit]'));

if (submitButtons !== null) {
  submitButtons.forEach(function (button) {
    // set event listener
    button.addEventListener('click', function () {
      button.closest('form').submit();
    });
  });
}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $body = (0, _jquery2.default)('body');
var $cookienote = (0, _jquery2.default)('.cookienote');

/**
 * @param  {String} cname cookie name
 * @return {String} cookie name or empty string
 */
function getCookie(cname) {
  var name = cname + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i += 1) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

/**
 * @param  {String} cname cookie name
 * @param  {String} cvalue cookie value
 * @param  {Number} exdays days until cookie expires
 * @return {void}
 */
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';expires=' + expires + ';path=/';
  return true;
}

if (getCookie('obo_cookienote_confirm') !== '1') {
  $body.addClass('show-cookienote');
}

(0, _jquery2.default)('.cookienote-confirm').on('click', function () {
  if (setCookie('obo_cookienote_confirm', 1, 365)) {
    $cookienote.fadeOut();
    $body.removeClass('show-cookienote');
  }
});

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line func-names
(0, _jquery2.default)('.zoom-gallery .selectors a').on('touchstart click', function (event) {
  var iframe = (0, _jquery2.default)('.active iframe[src*="youtube"], .active iframe[src*="vimeo"]');

  if (iframe.length) {
    iframe.attr('src', iframe.attr('src'));
  }

  (0, _jquery2.default)('.zoom-gallery .zoom-gallery-slide').removeClass('active');
  (0, _jquery2.default)('.zoom-gallery .selectors a').removeClass('active');
  (0, _jquery2.default)('.zoom-gallery .zoom-gallery-slide[data-slide-id="' + (0, _jquery2.default)(this).attr('data-slide-id') + '"]').addClass('active');
  (0, _jquery2.default)(this).addClass('active');
  event.preventDefault();
});
(0, _jquery2.default)('.zoom-gallery').on('click', '.mcs-item', function setActiveThumb() {
  MagicZoom.switchTo('zoom-v', Number((0, _jquery2.default)(this).attr('data-item')));
  (0, _jquery2.default)('.mcs-item').removeClass('active');
  (0, _jquery2.default)(this).addClass('active');
});

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
  var $downloadSelect = (0, _jquery2.default)('.js-download-select');

  $downloadSelect.each(function (index, element) {
    var $select = (0, _jquery2.default)(element);
    var $parentForm = $select.closest('form');
    var $downloadButton = $parentForm.find('a');
    var $titleLink = $parentForm.parent().find('a.js-link-download');
    // const $fileTitleSpan = $titleLink.find('span.js-filename');
    var $fileSizeSpan = $titleLink.find('span.js-filesize');

    $select.on('change', function () {
      var $selectedElement = $select.find(':selected');
      var $downloadUrl = $selectedElement.data('downloadurl');
      // const $fileTitle = $selectedElement.data('filename');
      var $fileSize = $selectedElement.data('filesize');
      $downloadButton.attr('href', $downloadUrl);
      $titleLink.attr('href', $downloadUrl);
      // $fileTitleSpan.text($fileTitle);
      $fileSizeSpan.text($fileSize);
    });
  });
});

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i)) {
  document.querySelector('html').classList.add('is--ios');
}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var triggers = [].slice.call(document.querySelectorAll('[data-trigger-fieldset]'));

triggers.forEach(function (trigger) {
  var name = trigger.name;
  var items = [].slice.call(document.getElementsByName(name));
  var target = document.querySelector('[data-fieldset="' + trigger.dataset.triggerFieldset + '"]');

  items.forEach(function (item) {
    item.addEventListener('change', function () {
      if (item === trigger) {
        target.classList.remove('hide');
      } else {
        target.classList.add('hide');
      }
    });
  });
});

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * off canvas module
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @module twt.off-canvas
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _pubSub = __webpack_require__(14);

var _pubSub2 = _interopRequireDefault(_pubSub);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class OffCanvas
 * @export
 */
var OffCanvas = function () {
  /**
   * Creates a new instance of an off canvas element.
   * @param {HTMLElement} element - HTMLElement to make into an off canvas.
   * @param {Object} options - Overrides for the default settings.
   */
  function OffCanvas(element, options) {
    _classCallCheck(this, OffCanvas);

    this.element = element;
    this.options = Object.assign(OffCanvas.defaults, options);
    this.intScrollTop = null;
    this.onTransitionEnd = this.onTransitionEnd.bind(this);

    // initialize
    this.init();
  }

  /**
   * @return {void}
   */


  _createClass(OffCanvas, [{
    key: 'init',
    value: function init() {
      var _this = this;

      var id = this.element.id;

      // triggers
      this.triggers = [].slice.call(document.querySelectorAll('[data-open="' + id + '"], [data-close="' + id + '"], [data-toggle="' + id + '"]'));

      for (var i = 0; i < this.triggers.length; i += 1) {
        this.triggers[i].setAttribute('aria-controls', id);
        this.triggers[i].setAttribute('aria-expanded', false);
      }

      // keys
      this.keys = {
        27: this.close.bind(this)
      };

      // register event listener
      this.registerEventListener();

      _pubSub2.default.subscribe('close.modules', function () {
        _this.close();
      });
    }

    /**
     * @return {void}
     */

  }, {
    key: 'open',
    value: function open() {
      var event = document.createEvent('Event');
      event.initEvent('opened.twt.OffCanvas', true, false);

      // add class
      this.element.classList.add(this.options.openClass);

      // set trigger attribute
      this.triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', true);
      });

      // add class on body to indicate an open off-canvas
      this.intScrollTop = document.body.scrollTop || document.documentElement.scrollTop;

      document.querySelector('.page-header .search').classList.remove('is--open');
      document.querySelector('.page-header .meta-search .btn').classList.remove('is--active');

      // dispatch event
      this.element.dispatchEvent(event);
      _pubSub2.default.publish('opened.offCanvas');
    }

    /**
     * @return {void}
     */

  }, {
    key: 'close',
    value: function close() {
      var _this2 = this;

      // remove class
      this.element.classList.remove(this.options.openClass);

      // set trigger attribute
      this.triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', false);
        trigger.classList.remove(_this2.options.activeClass);
      });

      // remove class on body to indicate an open off-canvas
      document.body.classList.remove(this.options.openOffCanvasClass);
      document.querySelector('.main-navigation').addEventListener('transitionend', this.onTransitionEnd);

      _pubSub2.default.publish('closed.offCanvas');
    }

    /**
     * @return {void}
     */

  }, {
    key: 'onTransitionEnd',
    value: function onTransitionEnd() {
      var _this3 = this;

      // document.body.classList.remove('has--fixed-content');
      document.body.removeAttribute('style');
      document.body.scrollTop = this.intScrollTop;
      document.documentElement.scrollTop = this.intScrollTop;
      document.querySelector('.page-header').style.transform = 'none';
      setTimeout(function () {
        document.querySelector('.page-header').removeAttribute('style');
        document.querySelector('.main-navigation').removeEventListener('transitionend', _this3.onTransitionEnd);
      }, 50);
    }

    /**
     * @return {void}
     */

  }, {
    key: 'toggle',
    value: function toggle() {
      if (this.element.classList.contains(this.options.openClass)) {
        this.close();
      } else {
        this.open();
      }
    }

    /**
     * @return {void}
     */

  }, {
    key: 'registerEventListener',
    value: function registerEventListener() {
      var _this4 = this;

      // triggers
      for (var i = 0; i < this.triggers.length; i += 1) {
        this.triggers[i].addEventListener('click', function (event) {
          if (event.target.hasAttribute('data-toggle')) {
            _this4.toggle();
          } else if (event.target.hasAttribute('data-close')) {
            _this4.close();
          } else {
            _this4.open();
          }
        });
      }

      // keys
      document.addEventListener('keydown', function (event) {
        var key = event.keyCode;

        if (key in _this4.keys) {
          _this4.keys[key]();
        }
      });
    }
  }]);

  return OffCanvas;
}();

exports.default = OffCanvas;


OffCanvas.defaults = {
  openClass: 'is--open',
  activeClass: 'is--active',
  openOffCanvasClass: 'open-off-canvas'
};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * drilldown module
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @module twt.drilldown
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @requires twt.media-query
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _twt = __webpack_require__(13);

var TWTmediaQuery = _interopRequireWildcard(_twt);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Drilldown menu
 *
 * @export
 * @class Drilldown
 */
var Drilldown = function () {
  /**
   * Creates a new instance of a drilldown menu.
   * @param {HTMLElement} element - HTMLElement to make into an drilldown menu.
   * @param {Object} options - Overrides for the default settings.
   */
  function Drilldown(element, options) {
    _classCallCheck(this, Drilldown);

    this.element = element;
    this.options = Object.assign(Drilldown.defaults, options);
    this.level = 0;
    this.clickstream = [];
    this.menu = null;

    // set level
    this.element.dataset.level = this.level;

    // initialize
    this.init();
  }

  /**
   * @return {void}
   */


  _createClass(Drilldown, [{
    key: 'init',
    value: function init() {
      var _this = this;

      var currentSize = TWTmediaQuery.getCurrentSize();
      if (currentSize === 'm' || currentSize === 's' || currentSize === 'xs') {
        this.sublevels = this.element.querySelectorAll('[data-sublevel]');

        this.registerEventListener();
        this.size = currentSize;
      }

      window.addEventListener('changed.twt.mediaQuery', function () {
        _this.handleMediaQuery(event);
      });
    }

    /**
     * @param  {Event} event click event
     * @return {void}
     */

  }, {
    key: 'navigate',
    value: function navigate(event) {
      var currentSize = TWTmediaQuery.getCurrentSize();

      if (currentSize === 'm' || currentSize === 's' || currentSize === 'xs') {
        var customEvent = document.createEvent('Event');
        var listItem = event.target.closest('li');

        // set previous sublevel
        if (this.sublevel !== undefined) this.previousSublevel = this.sublevel;

        // set sublevel
        if (listItem !== null) {
          this.sublevel = listItem.querySelector('[data-sublevel]');
        }

        // If it was a menu item
        if (event.target && event.target.dataset.forward !== undefined) {
          if (event.preventDefault) {
            event.preventDefault();
          } else {
            event.returnValue = false; // eslint-disable-line no-param-reassign
          }
          event.stopImmediatePropagation();

          // initialize custom event
          customEvent.initEvent('forward.twt.drilldown', false, true);

          // dispatch event
          this.element.dispatchEvent(customEvent);
        } else if (event.target && event.target.dataset.back !== undefined) {
          // initialize custom event
          customEvent.initEvent('back.twt.drilldown', false, true);

          // dispatch event
          this.element.dispatchEvent(customEvent);
        }
      }
    }

    /**
     * @param  {Event} event changed.twt.mediaQuery
     * @return {void}
     */

  }, {
    key: 'handleMediaQuery',
    value: function handleMediaQuery(event) {
      var newSize = event.detail.newSize;
      if (newSize !== 'm' && newSize !== 's' && newSize !== 'xs') {
        this.destroy();
      } else {
        this.init();
      }

      this.currentSize = newSize;
    }

    /**
     * @return {void}
     */

  }, {
    key: 'registerEventListener',
    value: function registerEventListener() {
      var _this2 = this;

      this.element.addEventListener('click', function (event) {
        _this2.navigate(event);
      });

      this.element.addEventListener('forward.twt.drilldown', function () {
        _this2.forward();
      });

      this.element.addEventListener('back.twt.drilldown', function () {
        _this2.back();
      });
    }

    /**
     * @return {void}
     */

  }, {
    key: 'deregisterEventListener',
    value: function deregisterEventListener() {
      this.element.removeEventListener('forward.twt.drilldown', function () {});
      this.element.removeEventListener('back.twt.drilldown', function () {});
      window.removeEventListener('changed.twt.mediaQuery', function () {});
    }

    /**
     * @return {void}
     */

  }, {
    key: 'forward',
    value: function forward() {
      // set level
      this.level += 1;
      this.element.setAttribute('data-level', this.level);
      // reset active menu
      if (this.menu !== null) this.menu.classList.remove(this.options.activeClass);
      this.menu = this.sublevel.querySelector('.menu');

      // show sublevel
      this.sublevel.classList.add(this.options.activeClass);
      this.menu.classList.add(this.options.activeClass);

      // add to clickstream
      this.clickstream.push(this.sublevel);
    }

    /**
     * @return {void}
     */

  }, {
    key: 'back',
    value: function back() {
      // set level
      this.level -= 1;
      this.element.setAttribute('data-level', this.level);

      // reset active menu
      this.menu.classList.remove(this.options.activeClass);
      this.menu = this.sublevel.querySelector('.menu');
      if (this.menu !== null) this.menu.classList.add(this.options.activeClass);

      // hide sublevel
      this.clickstream[this.clickstream.length - 1].classList.remove(this.options.activeClass);

      // remove last entry
      this.clickstream.pop();
    }

    /**
     * @return {void}
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      this.deregisterEventListener();
    }
  }]);

  return Drilldown;
}();

exports.default = Drilldown;


Drilldown.defaults = {
  activeClass: 'is--active',
  visibleClass: 'is--shown'
};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * menu module
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @module TWTmenu
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @requires TWTmediaQuery
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _twt = __webpack_require__(13);

var TWTmediaQuery = _interopRequireWildcard(_twt);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @param  {HTMLElement} element the element in which to search for the first child
 * @return {HTMLElement} the first child
 */
function getFirstChild(element) {
  var firstChild = element.firstChild;

  // skip TextNodes
  while (firstChild != null && firstChild.nodeType === 3) {
    firstChild = firstChild.nextSibling;
  }

  return firstChild;
}

/**
 * @param  {HTMLElement} element the element to unwrap
 * @return {void}
 */
function unwrapElement(element) {
  // get the element's parent node
  var parent = element.parentNode;

  // move all children out of the element
  while (getFirstChild(element)) {
    var firstChild = getFirstChild(element);
    if (firstChild.classList.contains('menu-overflow-inner')) {
      unwrapElement(firstChild);
    } else {
      parent.insertBefore(firstChild, element);
    }
  }

  // remove the empty element
  parent.removeChild(element);
}

/**
 * @class Menu
 * @export
 */

var Menu = function () {
  /**
   * Creates a new instance of a menu.
   * @param {HTMLElement} element HTMLElement to make into a menu.
   * @param {Object} options Overrides for the default settings.
   */
  function Menu(element, options) {
    _classCallCheck(this, Menu);

    this.element = element;
    this.options = Object.assign(Menu.defaults, options);
    this.currentSize = TWTmediaQuery.getCurrentSize();

    // initialize
    this.init();
  }

  /**
   * @param  {Event} event the click event
   * @return {void}
   */


  _createClass(Menu, [{
    key: 'manageFlyout',
    value: function manageFlyout(event) {
      var sublevel = event.target.closest('[data-sublevel]');
      var level = parseInt(sublevel.dataset.sublevel, 10) || null;
      var flyout = event.target.parentNode.querySelector('[data-sublevel="' + (level + 1) + '"]');
      var menu = event.target;

      if (sublevel === null || flyout === null) return false;

      menu.classList.toggle(this.options.activeClass);

      if (this.currentSize === 'xs' && this.currentSize === 's') {
        return false;
      }

      // closest parent level 1
      if (level === 1 && event.target.nodeName === 'A' && flyout !== null) {
        if (event.preventDefault) {
          event.preventDefault();
        } else {
          event.returnValue = false; // eslint-disable-line no-param-reassign
        }

        // reset current active
        if (this.activeFlyout !== undefined && this.activeFlyout !== flyout) {
          this.activeFlyout.classList.remove(this.options.activeClass);
          this.activeMenu.classList.remove(this.options.activeClass);
        }

        // toogle class
        flyout.classList.toggle(this.options.activeClass);

        // set current flyout
        this.activeFlyout = flyout;
        this.activeMenu = menu;
      }

      this.manageFlyoutHeight();

      return false;
    }

    /**
     * @return {void}
     */

  }, {
    key: 'manageFlyoutHeight',
    value: function manageFlyoutHeight() {
      var flyouts = [].slice.call(this.element.querySelectorAll('[data-sublevel]'));
      var flyoutsHeight = flyouts.reduce(function (height, flyout) {
        return height + flyout.offsetHeight;
      }, 0);
      var spacing = 30;

      var overflowWrapper = document.getElementById(this.options.overflowWrapperID);

      // reset content
      if (overflowWrapper !== null) {
        unwrapElement(overflowWrapper);
      }

      // make content scrollable
      if (this.activeFlyout !== undefined && flyoutsHeight > 0) {
        var flyoutTopPosition = flyouts.filter(function (flyout) {
          return flyout.offsetHeight > 0 && flyout.dataset.sublevel === '1';
        })[0].getBoundingClientRect().top;
        var diff = flyoutTopPosition + flyoutsHeight - window.innerHeight;
        if (diff > 0) {
          var newContent = '<div id="' + this.options.overflowWrapperID + '" class="menu-overflow-wrapper row"><div class="menu-overflow-inner column">' + this.activeFlyout.innerHTML + '</div></div>';

          // replace content
          this.activeFlyout.innerHTML = newContent;

          // set content height and add class
          var content = document.getElementById(this.options.overflowWrapperID);
          content.style.height = content.offsetHeight - diff - spacing + 'px';
          content.classList.add('is--overflow');
        }
      }
    }

    /**
     * @return {void}
     */

  }, {
    key: 'registerEventlistener',
    value: function registerEventlistener() {
      var _this = this;

      // viewport
      window.addEventListener('changed.twt.mediaQuery', function (event) {
        _this.currentSize = event.detail.newSize;
      });
    }

    /**
     * @return {void}
     */

  }, {
    key: 'init',
    value: function init() {
      this.registerEventlistener();
    }
  }]);

  return Menu;
}();

exports.default = Menu;


Menu.defaults = {
  activeClass: 'is--active',
  overflowWrapperID: 'menuOverflowWrapper'
};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _twt = __webpack_require__(13);

var TWTmediaQuery = _interopRequireWildcard(_twt);

var _pubSub = __webpack_require__(14);

var _pubSub2 = _interopRequireDefault(_pubSub);

var _filter = __webpack_require__(24);

var _pagination = __webpack_require__(23);

var _pagination2 = _interopRequireDefault(_pagination);

var _articleListOrder = __webpack_require__(25);

var _articleListOrder2 = _interopRequireDefault(_articleListOrder);

var _spinner = __webpack_require__(21);

var _spinner2 = _interopRequireDefault(_spinner);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class Tabs
 * @export
 */
var Tabs = function () {
  /**
   * Creates a new instance of Tabs.
   * @param {HTMLElement} element - HTMLElement to make into a Tabnavigation.
   * @param {Object} options - Overrides for the default settings.
   */
  function Tabs(element, options) {
    _classCallCheck(this, Tabs);

    this.element = element;
    this.id = element.id;
    this.options = Object.assign(Tabs.defaults, options);

    this.element.classList.add('tabs--enabled');
    this.init();
  }

  /**
   * @return {void}
   */


  _createClass(Tabs, [{
    key: 'init',
    value: function init() {
      var _this = this;

      this.currentSize = TWTmediaQuery.getCurrentSize();
      this.intCurrentIndex = 0;
      this.arrTabs = this.element.querySelectorAll('.tabs__name');
      this.arrContents = this.element.querySelectorAll('.tabs__content');
      this.elTabNavigation = null;
      this.preventHashchange = false;

      this.prepareMarkup();

      if (location.hash !== '' && document.getElementById(location.hash.substr(2))) {
        this.switchTabById(location.hash);
      }

      window.addEventListener('hashchange', function () {
        if (_this.preventHashchange === false) {
          if (location.hash !== '' && document.getElementById(location.hash.substr(2))) {
            _this.switchTabById(location.hash);
            window.scrollTo(0, 0);
          }
        }
        _this.preventHashchange = false;
      });

      window.addEventListener('changed.twt.mediaQuery', function (event) {
        var newSize = event.detail.newSize;

        if (_this.element.classList.contains('is--mobile-fallback')) {
          if (newSize !== 'xs' && newSize !== 's') {
            var elCurrentName = _this.element.querySelector('.tabs__name.is--active');
            var elCurrentTab = _this.element.previousElementSibling.querySelector('.is--active');
            var elCurrentContent = _this.element.querySelector('.tabs__content.is--active');
            if (elCurrentName !== null) elCurrentName.classList.remove(_this.options.activeClass);
            if (elCurrentTab !== null) elCurrentTab.classList.remove(_this.options.activeClass);
            if (elCurrentContent !== null) {
              elCurrentContent.classList.remove(_this.options.activeClass);
            }

            _this.intCurrentIndex = 0;
            _this.arrContents[0].classList.add(_this.options.activeClass);
            _this.elTabNavigation.childNodes[0].classList.add(_this.options.activeClass);
            _this.$elTabsClose.classList.remove(_this.options.activeClass);
          } else if (newSize === 'xs' || newSize === 's') {
            var _elCurrentContent = _this.element.querySelector('.tabs__content.' + _this.options.activeClass);
            var _elCurrentTab = _this.element.previousElementSibling.querySelector('.is--active');

            if (_elCurrentContent !== null) {
              _elCurrentContent.classList.remove(_this.options.activeClass);
            }

            if (_elCurrentTab !== null) _elCurrentTab.classList.remove(_this.options.activeClass);
            _this.intCurrentIndex = null;
          }
        }
      });
    }

    /**
     * @return {void}
     */

  }, {
    key: 'prepareMarkup',
    value: function prepareMarkup() {
      var _this2 = this;

      var $elTabsClose = null;
      if (this.element.classList.contains('is--mobile-fallback')) {
        $elTabsClose = document.createElement('div');
        $elTabsClose.classList.add('tabs-close');
        var $elTabsCloseButton = document.createElement('span');
        $elTabsCloseButton.classList.add('btn', 'is--secondary', 'is--icon-left');
        $elTabsCloseButton.innerHTML = '<svg class="icon"><use xlink:href="' + this.element.dataset.iconsPath + '#doublearrowcircle"></use></svg><span class="btn__text">' + this.element.dataset.back + '</span>';
        $elTabsCloseButton.addEventListener('click', function (event) {
          var elCurrentContent = _this2.arrContents[_this2.intCurrentIndex];
          elCurrentContent.classList.remove(_this2.options.activeClass);
          var elCurrentTab = _this2.elTabNavigation.childNodes[_this2.intCurrentIndex];
          elCurrentTab.classList.remove(_this2.options.activeClass);
          _this2.intCurrentIndex = null;

          event.target.closest('.tabs-close').classList.remove(_this2.options.activeClass);

          _pubSub2.default.publish('closed.twt.tabs');

          return false;
        });
        $elTabsClose.appendChild($elTabsCloseButton);
        this.element.parentNode.insertBefore($elTabsClose, this.element.previousSibling);
        this.$elTabsClose = $elTabsClose;
      }

      var $elTabsNavigation = document.createElement('nav');
      $elTabsNavigation.classList.add('nav', 'nav--tabs');
      if (this.element.classList.contains('is--mobile-fallback')) $elTabsNavigation.classList.add('is--mobile-fallback');

      var $elTabs = document.createElement('ul');
      $elTabs.classList.add('tabs-navigation');

      for (var index = 0, len = this.arrTabs.length; index < len; index += 1) {
        var element = this.arrTabs[index];
        var strName = element.textContent;
        var $elListItem = document.createElement('li');
        var $elTab = document.createElement('a');

        $elListItem.classList.add('tab');
        $elTab.textContent = strName;
        $elTab.href = '#!' + this.id + '-' + index;

        $elTab.addEventListener('click', function (event) {
          _this2.switchTabById(event.target.hash);
          _this2.preventHashchange = true;
          return false;
        });

        if (this.element.classList.contains('is--mobile-fallback')) {
          if (index === 0 && this.currentSize !== 'xs' && this.currentSize !== 's') $elListItem.classList.add(this.options.activeClass);
        } else if (index === 0) {
          $elListItem.classList.add(this.options.activeClass);
        }

        $elListItem.appendChild($elTab);
        $elTabs.appendChild($elListItem);
        $elTabsNavigation.appendChild($elTabs);

        if (this.element.classList.contains('is--mobile-fallback')) {
          element.addEventListener('click', function (event) {
            if ($elTabsClose !== null) $elTabsClose.classList.add(_this2.options.activeClass);
            _this2.switchTabBySibling(event.target.closest('.tabs__name'));
            return false;
          });
        }
      }

      for (var _index = 0, _len = this.arrContents.length; _index < _len; _index += 1) {
        var el = this.arrContents[_index];
        el.id = this.id + '-' + _index;

        if (this.element.classList.contains('is--mobile-fallback')) {
          if (_index === 0 && this.currentSize !== 'xs' && this.currentSize !== 's') el.classList.add(this.options.activeClass);
        } else if (_index === 0) {
          el.classList.add(this.options.activeClass);
        }
      }

      this.element.parentNode.insertBefore($elTabsNavigation, this.element);
      this.elTabNavigation = $elTabs;
    }

    /**
     * @param  {String} id selector
     * @return {void}
     */

  }, {
    key: 'switchTabById',
    value: function switchTabById(id) {
      var _this3 = this;

      var elCurrentContent = this.arrContents[this.intCurrentIndex];
      elCurrentContent.classList.remove(this.options.activeClass);
      var elCurrentTab = this.elTabNavigation.childNodes[this.intCurrentIndex];
      elCurrentTab.classList.remove(this.options.activeClass);

      var _loop = function _loop(index, len) {
        var element = _this3.arrContents[index];
        if (element.id === id.substr(2)) {
          element.classList.add(_this3.options.activeClass);
          _this3.intCurrentIndex = index;
          if ((0, _jquery2.default)(element).is('[data-link]')) {
            var token = _spinner2.default.create();

            _jquery2.default.get((0, _jquery2.default)(element).attr('data-link'), function (data) {
              if (data.length > 0) {
                var container = (0, _jquery2.default)(element).find('.load-more-content');
                (0, _jquery2.default)(element).find('.load-more-content').first().html(data);
                (0, _jquery2.default)(element).removeAttr('data-link');

                (0, _filter.initFilterTags)(document.querySelector('.delete-option'));
                (0, _pagination2.default)(container);
                (0, _articleListOrder2.default)(container);

                _pubSub2.default.publish('reloaded.content', {
                  scope: container[0]
                });
              }

              // stop spinning
              _spinner2.default.destroy(token);
            });
          }
        }
      };

      for (var index = 0, len = this.arrContents.length; index < len; index += 1) {
        _loop(index, len);
      }

      this.elTabNavigation.childNodes[this.intCurrentIndex].classList.add(this.options.activeClass);

      // update matchheight
      _jquery2.default.fn.matchHeight._update(); // eslint-disable-line no-underscore-dangle
    }

    /**
     * @param  {HTMLElement} element tab node
     * @return {void}
     */

  }, {
    key: 'switchTabBySibling',
    value: function switchTabBySibling(element) {
      if (this.intCurrentIndex !== null) {
        var elCurrentContent = this.arrContents[this.intCurrentIndex];
        elCurrentContent.classList.remove(this.options.activeClass);
        var elCurrentTab = this.elTabNavigation.childNodes[this.intCurrentIndex];
        elCurrentTab.classList.remove(this.options.activeClass);
      }

      for (var index = 0, len = this.arrContents.length; index < len; index += 1) {
        var el = this.arrContents[index];
        if (el.id === element.nextElementSibling.id) {
          el.classList.add(this.options.activeClass);
          this.intCurrentIndex = index;

          if ((0, _jquery2.default)(element).is('[data-link]')) {
            (function () {
              var token = _spinner2.default.create();

              _jquery2.default.get((0, _jquery2.default)(element).attr('data-link'), function (data) {
                if (data.length > 0) {
                  var container = (0, _jquery2.default)(element).find('.load-more-content');
                  (0, _jquery2.default)(element).find('.load-more-content').first().html(data);
                  (0, _jquery2.default)(element).removeAttr('data-link');

                  (0, _filter.initFilterTags)(document.querySelector('.delete-option'));
                  (0, _pagination2.default)(container);
                  (0, _articleListOrder2.default)(container);

                  _pubSub2.default.publish('reloaded.content', {
                    scope: container[0]
                  });
                }

                // stop spinning
                _spinner2.default.destroy(token);
              });
            })();
          }
        }
      }

      element.classList.add(this.options.activeClass);
      this.elTabNavigation.childNodes[this.intCurrentIndex].classList.add(this.options.activeClass);

      // update matchheight
      _jquery2.default.fn.matchHeight._update(); // eslint-disable-line no-underscore-dangle
    }
  }]);

  return Tabs;
}();

exports.default = Tabs;


Tabs.defaults = {
  activeClass: 'is--active'
};

(0, _jquery2.default)('.is--mobile-fallback dt').on('click', function () {
  document.body.classList.add('has-tab-overlay');
});

_pubSub2.default.subscribe('closed.twt.tabs', function () {
  document.body.classList.remove('has-tab-overlay');
});

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pubSub = __webpack_require__(14);

var _pubSub2 = _interopRequireDefault(_pubSub);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var className = 'overlay'; /**
                            * overlay module.
                            * @module overlay
                            */

var hasActiveOverlayClass = 'has-active-overlay';
var pageHeader = document.querySelector('.page-header');
var overlayNode = document.createElement('div');

// set class and add data-attribute
overlayNode.classList.add(className);
overlayNode.dataset.overlay = true;

// add overlay to DOM
document.body.appendChild(overlayNode);

// group overlay functions
var overlay = {
  show: function show() {
    var intScrollTop = document.body.scrollTop || document.documentElement.scrollTop;

    // add class
    document.body.classList.add(hasActiveOverlayClass);

    // set body position
    document.body.style.transform = 'translateY(-' + intScrollTop + 'px) translateZ(0)';

    // set header position
    pageHeader.style.transform = 'translateY(' + intScrollTop + 'px) translateZ(0)';
    pageHeader.style.transition = 'none';
  },
  hide: function hide() {
    // remove class
    document.body.classList.remove(hasActiveOverlayClass);

    // reset body styles
    document.body.style.transform = '';

    // set header styles
    pageHeader.style.transform = '';
    pageHeader.style.transition = '';
  }
};

// hide on click
document.querySelector('[data-overlay]').addEventListener('click', function () {
  _pubSub2.default.publish('close.modules');
});

exports.default = overlay;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _notice = __webpack_require__(83);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(document).ready(function () {
  var wishlistNotice = new _notice.Notice();
  var wishlistNoticeManager = function wishlistNoticeManager(method, args) {
    return (0, _notice.noticeManager)(wishlistNotice, method, args);
  };

  /**
   * JS logic for article wishlist
   *
   * @param  {Node} scope the scope in which to search for articles to reload
   * @return {void}
   */
  function updateItemAmount() {
    var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

    // change article count on wishlist
    (0, _jquery2.default)(scope).find('.js-changeamount-noticelist').on('click', function (event) {
      var element = event.target;
      var wishlistForm = element.closest('form');
      var countInput = wishlistForm.querySelector('input[name=am]');
      var xhr = new XMLHttpRequest();
      var formData = new FormData(wishlistForm);

      xhr.open(wishlistForm.method, wishlistForm.action, true);
      xhr.onload = function () {
        if (xhr.status === 200) {
          var response = JSON.parse(xhr.response);

          if (response.return === -1) {
            // show error message
            wishlistNoticeManager('setMessage', [response.message]);
            wishlistNoticeManager('setType', ['error']);
            wishlistNoticeManager('render');
            wishlistNoticeManager('displayNoticeAtElementPosition', [countInput]);

            // Amount could not be changed.
            // Reset to previous value (we only do this in the noticelist)
            countInput.value = response.amount;
          } else if (response.return === 1) {
            element.classList.add('is--disabled');
            if (response.amount <= 0) {
              // article removed from list
              location.reload();
            } else {
              if (response.total) {
                (0, _jquery2.default)(wishlistForm).parent().parent().parent().find('.linesum').html(response.total);
              }

              // show success message
              wishlistNoticeManager('setMessage', [response.message]);
              wishlistNoticeManager('setType', ['success']);
              wishlistNoticeManager('render');
              wishlistNoticeManager('displayNoticeAtElementPosition', [countInput]);
            }
          }
        }
      };
      xhr.send(formData);
    });
  }

  (0, _jquery2.default)(document).find('.js-wishlistform').submit(function (e) {
    e.preventDefault();
  });

  updateItemAmount();
});

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _notice = __webpack_require__(83);

var _wishlistActions = __webpack_require__(84);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(document).ready(function () {
  var wishlistNotice = new _notice.Notice();
  var wishlistNoticeManager = function wishlistNoticeManager(method, args) {
    return (0, _notice.noticeManager)(wishlistNotice, method, args);
  };

  /**
   * add articles to wishlist from details page
   *
   * @param  {Node} scope the scope in which to search for articles to reload
   * @return {void}
   */
  function addArticleToWishlist() {
    var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

    (0, _jquery2.default)(scope).find('.js-addtowishlist').on('click', function (event) {
      var element = (0, _jquery2.default)(event.target);
      var countInput = element.parents('tr:first').find('form.js-wishlistform').find('input[name=am]')[0];
      var wishlistForm = element.parent().parent().parent().find('form')[0];
      var formData = new FormData(wishlistForm);
      var xhr = new XMLHttpRequest();

      // set the backend function to call (determined by the data-attribute on the cliecked item)
      wishlistForm.querySelector('input[name="fnc"]').value = element.attr('data-fnc');

      xhr.open(wishlistForm.method, wishlistForm.action, true);
      xhr.onload = function () {
        if (xhr.status === 200) {
          var response = JSON.parse(xhr.response);

          if (response.return === -1) {
            // show message, but leave the value in the form as it is.
            wishlistNoticeManager('setMessage', [response.message]);
            wishlistNoticeManager('setType', ['error']);
          } else if (response.return === 1) {
            // update badge
            (0, _wishlistActions.updateWishlistBadge)();

            // green
            wishlistNoticeManager('setMessage', [response.message]);
            wishlistNoticeManager('setType', ['success']);
          }

          if (document.body.classList.contains('has-tab-overlay')) {
            wishlistNoticeManager('render', ['.tabs__content.is--active']);
            wishlistNoticeManager('displayNoticeAtElementPosition', [countInput, '.tabs__content.is--active']);
          } else {
            wishlistNoticeManager('render');
            wishlistNoticeManager('displayNoticeAtElementPosition', [countInput]);
          }
        }
      };
      xhr.send(formData);

      return false;
    });
  }

  addArticleToWishlist();
});

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(187);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
  (0, _jquery2.default)('[data-datepicker]').fdatepicker({
    format: 'dd.mm.yyyy'
  });
});

/***/ }),
/* 187 */
/***/ (function(module, exports) {

/* =========================================================
 * foundation-datepicker.js
 * Copyright 2015 Peter Beno, najlepsiwebdesigner@gmail.com, @benopeter
 * project website http://foundation-datepicker.peterbeno.com
 * ========================================================= */
! function($) {

    function UTCDate() {
        return new Date(Date.UTC.apply(Date, arguments));
    }

    function UTCToday() {
        var today = new Date();
        return UTCDate(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate());
    }

    var Datepicker = function(element, options) {
        var that = this;

        this.element = $(element);
        this.autoShow = (options.autoShow == undefined ? true : options.autoShow);
        this.appendTo = options.appendTo || 'body';
        this.closeButton = options.closeButton;
        this.language = options.language || this.element.data('date-language') || "en";
        this.language = this.language in dates ? this.language : this.language.split('-')[0]; //Check if "de-DE" style date is available, if not language should fallback to 2 letter code eg "de"
        this.language = this.language in dates ? this.language : "en";
        this.isRTL = dates[this.language].rtl || false;
        this.format = DPGlobal.parseFormat(options.format || this.element.data('date-format') || dates[this.language].format || 'mm/dd/yyyy');
        this.formatText = options.format || this.element.data('date-format') || dates[this.language].format || 'mm/dd/yyyy';
        this.isInline = false;
        this.isInput = this.element.is('input');
        this.component = this.element.is('.date') ? this.element.find('.prefix, .postfix') : false;
        this.hasInput = this.component && this.element.find('input').length;
        this.disableDblClickSelection = options.disableDblClickSelection;
        this.onRender = options.onRender || function() {};
        if (this.component && this.component.length === 0) {
            this.component = false;
        }
        this.linkField = options.linkField || this.element.data('link-field') || false;
        this.linkFormat = DPGlobal.parseFormat(options.linkFormat || this.element.data('link-format') || 'yyyy-mm-dd hh:ii:ss');
        this.minuteStep = options.minuteStep || this.element.data('minute-step') || 5;
        this.pickerPosition = options.pickerPosition || this.element.data('picker-position') || 'bottom-right';
        this.initialDate = options.initialDate || null;
        this.faCSSprefix = options.faCSSprefix || 'fa';
        this.leftArrow = options.leftArrow || '<i class="' + this.faCSSprefix + ' ' + this.faCSSprefix + '-chevron-left fi-arrow-left"/>';
        this.rightArrow = options.rightArrow || '<i class="' + this.faCSSprefix + ' ' + this.faCSSprefix + '-chevron-right fi-arrow-right"/>';
        this.closeIcon = options.closeIcon || '<i class="' + this.faCSSprefix + ' ' + this.faCSSprefix + '-remove ' + this.faCSSprefix + '-times fi-x"></i>';

        

        this.minView = 0;
        if ('minView' in options) {
            this.minView = options.minView;
        } else if ('minView' in this.element.data()) {
            this.minView = this.element.data('min-view');
        }
        this.minView = DPGlobal.convertViewMode(this.minView);

        this.maxView = DPGlobal.modes.length - 1;
        if ('maxView' in options) {
            this.maxView = options.maxView;
        } else if ('maxView' in this.element.data()) {
            this.maxView = this.element.data('max-view');
        }
        this.maxView = DPGlobal.convertViewMode(this.maxView);

        this.startViewMode = 'month';
        if ('startView' in options) {
            this.startViewMode = options.startView;
        } else if ('startView' in this.element.data()) {
            this.startViewMode = this.element.data('start-view');
        }
        this.startViewMode = DPGlobal.convertViewMode(this.startViewMode);
        this.viewMode = this.startViewMode;

        if (!('minView' in options) && !('maxView' in options) && !(this.element.data('min-view')) && !(this.element.data('max-view'))) {
            this.pickTime = false;
            if ('pickTime' in options) {
                this.pickTime = options.pickTime;
            }
            if (this.pickTime == true) {
                this.minView = 0;
                this.maxView = 4;
            } else {
                this.minView = 2;
                this.maxView = 4;
            }
        }

        this.forceParse = true;
        if ('forceParse' in options) {
            this.forceParse = options.forceParse;
        } else if ('dateForceParse' in this.element.data()) {
            this.forceParse = this.element.data('date-force-parse');
        }


        this.picker = $(DPGlobal.template(this.leftArrow, this.rightArrow, this.closeIcon))
            .appendTo(this.isInline ? this.element : this.appendTo)
            .on({
                click: $.proxy(this.click, this),
                mousedown: $.proxy(this.mousedown, this)
            });
        if (this.closeButton) {
            this.picker.find('a.datepicker-close').show();
        } else {
            this.picker.find('a.datepicker-close').hide();
        }

        if (this.isInline) {
            this.picker.addClass('datepicker-inline');
        } else {
            this.picker.addClass('datepicker-dropdown dropdown-menu');
        }
        if (this.isRTL) {
            this.picker.addClass('datepicker-rtl');

            this.picker.find('.date-switch').each(function(){
              $(this).parent().prepend($(this).siblings('.next'));
              $(this).parent().append($(this).siblings('.prev'));
            })
            this.picker.find('.prev, .next').toggleClass('prev next');

        }
        $(document).on('mousedown', function(e) {
            if (that.isInput && e.target === that.element[0]) {
                return;
            }

            // Clicked outside the datepicker, hide it
            if ($(e.target).closest('.datepicker.datepicker-inline, .datepicker.datepicker-dropdown').length === 0) {
                that.hide();
            }
        });

        this.autoclose = true;
        if ('autoclose' in options) {
            this.autoclose = options.autoclose;
        } else if ('dateAutoclose' in this.element.data()) {
            this.autoclose = this.element.data('date-autoclose');
        }

        this.keyboardNavigation = true;
        if ('keyboardNavigation' in options) {
            this.keyboardNavigation = options.keyboardNavigation;
        } else if ('dateKeyboardNavigation' in this.element.data()) {
            this.keyboardNavigation = this.element.data('date-keyboard-navigation');
        }

        this.todayBtn = (options.todayBtn || this.element.data('date-today-btn') || false);
        this.todayHighlight = (options.todayHighlight || this.element.data('date-today-highlight') || false);

        this.calendarWeeks = false;
        if ('calendarWeeks' in options) {
            this.calendarWeeks = options.calendarWeeks;
        } else if ('dateCalendarWeeks' in this.element.data()) {
            this.calendarWeeks = this.element.data('date-calendar-weeks');
        }
        if (this.calendarWeeks)
            this.picker.find('tfoot th.today')
            .attr('colspan', function(i, val) {
                return parseInt(val) + 1;
            });

        this.weekStart = ((options.weekStart || this.element.data('date-weekstart') || dates[this.language].weekStart || 0) % 7);
        this.weekEnd = ((this.weekStart + 6) % 7);
        this.startDate = -Infinity;
        this.endDate = Infinity;
        this.daysOfWeekDisabled = [];
        this.datesDisabled = [];
        this.setStartDate(options.startDate || this.element.data('date-startdate'));
        this.setEndDate(options.endDate || this.element.data('date-enddate'));
        this.setDaysOfWeekDisabled(options.daysOfWeekDisabled || this.element.data('date-days-of-week-disabled'));
        this.setDatesDisabled(options.datesDisabled || this.element.data('dates-disabled'));

        this.fillDow();
        this.fillMonths();
        this.update();

        this.showMode();

        if (this.isInline) {
            this.show();
        }

        this._attachEvents();
    };

    Datepicker.prototype = {
        constructor: Datepicker,

        _events: [],
        _attachEvents: function() {
            this._detachEvents();
            if (this.isInput) { // single input
                if (!this.keyboardNavigation) {
                    this._events = [
                        [this.element, {
                            focus: (this.autoShow) ? $.proxy(this.show, this) : function() {}
                        }]
                    ];
                } else {
                    this._events = [
                        [this.element, {
                            focus: (this.autoShow) ? $.proxy(this.show, this) : function() {},
                            keyup: $.proxy(this.update, this),
                            keydown: $.proxy(this.keydown, this),
                            click: (this.element.attr('readonly')) ? $.proxy(this.show, this) : function() {}
                        }]
                    ];
                } 
            }
            else if (this.component && this.hasInput) { // component: input + button
                this._events = [
                    // For components that are not readonly, allow keyboard nav
                    [this.element.find('input'), {
                        focus: (this.autoShow) ? $.proxy(this.show, this) : function() {},
                        keyup: $.proxy(this.update, this),
                        keydown: $.proxy(this.keydown, this)
                    }],
                    [this.component, {
                        click: $.proxy(this.show, this)
                    }]
                ];
            } else if (this.element.is('div')) { // inline datepicker
                this.isInline = true;
            } else {
                this._events = [
                    [this.element, {
                        click: $.proxy(this.show, this)
                    }]
                ];
            }

            if (this.disableDblClickSelection) {
                this._events[this._events.length] = [
                    this.element, {
                        dblclick: function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            $(this).blur()
                        }
                    }
                ];
            }

            for (var i = 0, el, ev; i < this._events.length; i++) {
                el = this._events[i][0];
                ev = this._events[i][1];
                el.on(ev);
            }
        },
        _detachEvents: function() {
            for (var i = 0, el, ev; i < this._events.length; i++) {
                el = this._events[i][0];
                ev = this._events[i][1];
                el.off(ev);
            }
            this._events = [];
        },

        show: function(e) {
            this.picker.show();
            this.height = this.component ? this.component.outerHeight() : this.element.outerHeight();
            this.update();
            this.place();
            $(window).on('resize', $.proxy(this.place, this));
            if (e) {
                e.stopPropagation();
                e.preventDefault();
            }
            this.element.trigger({
                type: 'show',
                date: this.date
            });
        },

        hide: function(e) {
            if (this.isInline) return;
            if (!this.picker.is(':visible')) return;
            this.picker.hide();
            $(window).off('resize', this.place);
            this.viewMode = this.startViewMode;
            this.showMode();
            if (!this.isInput) {
                $(document).off('mousedown', this.hide);
            }

            if (
                this.forceParse &&
                (
                    this.isInput && this.element.val() ||
                    this.hasInput && this.element.find('input').val()
                )
            )
                this.setValue();
            this.element.trigger({
                type: 'hide',
                date: this.date
            });
        },

        remove: function() {
            this._detachEvents();
            this.picker.remove();
            delete this.element.data().datepicker;
        },

        getDate: function() {
            var d = this.getUTCDate();
            return new Date(d.getTime() + (d.getTimezoneOffset() * 60000));
        },

        getUTCDate: function() {
            return this.date;
        },

        setDate: function(d) {
            this.setUTCDate(new Date(d.getTime() - (d.getTimezoneOffset() * 60000)));
        },

        setUTCDate: function(d) {
            this.date = d;
            this.setValue();
        },

        setValue: function() {
            var formatted = this.getFormattedDate();
            if (!this.isInput) {
                if (this.component) {
                    this.element.find('input').val(formatted);
                }
                this.element.data('date', formatted);
            } else {
                this.element.val(formatted);
            }
        },

        getFormattedDate: function(format) {
            if (format === undefined)
                format = this.format;
            return DPGlobal.formatDate(this.date, format, this.language);
        },

        setStartDate: function(startDate) {
            this.startDate = startDate || -Infinity;
            if (this.startDate !== -Infinity) {
                this.startDate = DPGlobal.parseDate(this.startDate, this.format, this.language);
            }
            this.update();
            this.updateNavArrows();
        },

        setEndDate: function(endDate) {
            this.endDate = endDate || Infinity;
            if (this.endDate !== Infinity) {
                this.endDate = DPGlobal.parseDate(this.endDate, this.format, this.language);
            }
            this.update();
            this.updateNavArrows();
        },

        setDaysOfWeekDisabled: function(daysOfWeekDisabled) {
            this.daysOfWeekDisabled = daysOfWeekDisabled || [];
            if (!$.isArray(this.daysOfWeekDisabled)) {
                this.daysOfWeekDisabled = this.daysOfWeekDisabled.split(/,\s*/);
            }
            this.daysOfWeekDisabled = $.map(this.daysOfWeekDisabled, function(d) {
                return parseInt(d, 10);
            });
            this.update();
            this.updateNavArrows();
        },

        setDatesDisabled: function(datesDisabled) {
            this.datesDisabled = datesDisabled || [];
            if (!$.isArray(this.datesDisabled)) {
                this.datesDisabled = this.datesDisabled.split(/,\s*/);
            }
            this.datesDisabled = $.map(this.datesDisabled, function(d) {
                return DPGlobal.parseDate(d, this.format, this.language).valueOf();
            });
            this.update();
            this.updateNavArrows();
        },

        place: function() {
            if (this.isInline) return;
            var zIndex = parseInt(this.element.parents().filter(function() {
                return $(this).css('z-index') != 'auto';
            }).first().css('z-index')) + 10;
            var textbox = this.component ? this.component : this.element;
            var offset = textbox.offset();
            var height = textbox.outerHeight() + parseInt(textbox.css('margin-top'));
            var width = textbox.outerWidth() + parseInt(textbox.css('margin-left'));
            var fullOffsetTop = offset.top + height;
            var offsetLeft = offset.left;
            this.picker.removeClass('datepicker-top datepicker-bottom');
            // if the datepicker is going to be below the window, show it on top of the input
            if ((fullOffsetTop + this.picker.outerHeight()) >= $(window).scrollTop() + $(window).height()) {
                fullOffsetTop = offset.top - this.picker.outerHeight();
                this.picker.addClass('datepicker-top');
            }
            else {
                this.picker.addClass('datepicker-bottom');
            }

            // if the datepicker is going to go past the right side of the window, we want
            // to set the right position so the datepicker lines up with the textbox
            if (offset.left + this.picker.width() >= $(window).width()) {
                offsetLeft = (offset.left + width) - this.picker.width();
            }
            this.picker.css({
                top: fullOffsetTop,
                left: offsetLeft,
                zIndex: zIndex
            });
        },

        update: function() {
            var date, fromArgs = false;
            var currentVal = this.isInput ? this.element.val() : this.element.data('date') || this.element.find('input').val();
            if (arguments && arguments.length && (typeof arguments[0] === 'string' || arguments[0] instanceof Date)) {
                date = arguments[0];
                fromArgs = true;
            } 
            else if (!currentVal && this.initialDate != null) { // If value is not set, set it to the initialDate 
                date = this.initialDate
            }
            else {
                date = this.isInput ? this.element.val() : this.element.data('date') || this.element.find('input').val();
            }
    
            if (date && date.length > this.formatText.length) {
                    $(this.picker).addClass('is-invalid')
                    $(this.element).addClass('is-invalid-input')
                    return;
            } else {
                $(this.picker).removeClass('is-invalid')
                $(this.element).removeClass('is-invalid-input')
                  
            }
        
            this.date = DPGlobal.parseDate(date, this.format, this.language);  

            if (fromArgs || this.initialDate != null) this.setValue();

            if (this.date < this.startDate) {
                this.viewDate = new Date(this.startDate.valueOf());
            } else if (this.date > this.endDate) {
                this.viewDate = new Date(this.endDate.valueOf());
            } else {
                this.viewDate = new Date(this.date.valueOf());
            }
            this.fill();
        },

        fillDow: function() {
            var dowCnt = this.weekStart,
                html = '<tr>';
            if (this.calendarWeeks) {
                var cell = '<th class="cw">&nbsp;</th>';
                html += cell;
                this.picker.find('.datepicker-days thead tr:first-child').prepend(cell);
            }
            while (dowCnt < this.weekStart + 7) {
                html += '<th class="dow">' + dates[this.language].daysMin[(dowCnt++) % 7] + '</th>';
            }
            html += '</tr>';
            this.picker.find('.datepicker-days thead').append(html);
        },

        fillMonths: function() {
            var html = '',
                i = 0;
            while (i < 12) {
                html += '<span class="month">' + dates[this.language].monthsShort[i++] + '</span>';
            }
            this.picker.find('.datepicker-months td').html(html);
        },

        fill: function() {
            if (this.date == null || this.viewDate == null) {
                return;
            }

            var d = new Date(this.viewDate.valueOf()),
                year = d.getUTCFullYear(),
                month = d.getUTCMonth(),
                dayMonth = d.getUTCDate(),
                hours = d.getUTCHours(),
                minutes = d.getUTCMinutes(),
                startYear = this.startDate !== -Infinity ? this.startDate.getUTCFullYear() : -Infinity,
                startMonth = this.startDate !== -Infinity ? this.startDate.getUTCMonth() : -Infinity,
                endYear = this.endDate !== Infinity ? this.endDate.getUTCFullYear() : Infinity,
                endMonth = this.endDate !== Infinity ? this.endDate.getUTCMonth() : Infinity,
                currentDate = this.date && UTCDate(this.date.getUTCFullYear(), this.date.getUTCMonth(), this.date.getUTCDate()).valueOf(),
                today = new Date(),
                titleFormat = dates[this.language].titleFormat || dates['en'].titleFormat;
            // this.picker.find('.datepicker-days thead th.date-switch')
            // 			.text(DPGlobal.formatDate(new UTCDate(year, month), titleFormat, this.language));

            this.picker.find('.datepicker-days thead th:eq(1)')
                .text(dates[this.language].months[month] + ' ' + year);
            this.picker.find('.datepicker-hours thead th:eq(1)')
                .text(dayMonth + ' ' + dates[this.language].months[month] + ' ' + year);
            this.picker.find('.datepicker-minutes thead th:eq(1)')
                .text(dayMonth + ' ' + dates[this.language].months[month] + ' ' + year);


            this.picker.find('tfoot th.today')
                .text(dates[this.language].today)
                .toggle(this.todayBtn !== false);
            this.updateNavArrows();
            this.fillMonths();
            var prevMonth = UTCDate(year, month - 1, 28, 0, 0, 0, 0),
                day = DPGlobal.getDaysInMonth(prevMonth.getUTCFullYear(), prevMonth.getUTCMonth());
            prevMonth.setUTCDate(day);
            prevMonth.setUTCDate(day - (prevMonth.getUTCDay() - this.weekStart + 7) % 7);
            var nextMonth = new Date(prevMonth.valueOf());
            nextMonth.setUTCDate(nextMonth.getUTCDate() + 42);
            nextMonth = nextMonth.valueOf();
            var html = [];
            var clsName;
            while (prevMonth.valueOf() < nextMonth) {
                if (prevMonth.getUTCDay() == this.weekStart) {
                    html.push('<tr>');
                    if (this.calendarWeeks) {
                        // adapted from https://github.com/timrwood/moment/blob/master/moment.js#L128
                        var a = new Date(prevMonth.getUTCFullYear(), prevMonth.getUTCMonth(), prevMonth.getUTCDate() - prevMonth.getDay() + 10 - (this.weekStart && this.weekStart % 7 < 5 && 7)),
                            b = new Date(a.getFullYear(), 0, 4),
                            calWeek = ~~((a - b) / 864e5 / 7 + 1.5);
                        html.push('<td class="cw">' + calWeek + '</td>');
                    }
                }
                clsName = ' ' + this.onRender(prevMonth) + ' ';
                if (prevMonth.getUTCFullYear() < year || (prevMonth.getUTCFullYear() == year && prevMonth.getUTCMonth() < month)) {
                    clsName += ' old';
                } else if (prevMonth.getUTCFullYear() > year || (prevMonth.getUTCFullYear() == year && prevMonth.getUTCMonth() > month)) {
                    clsName += ' new';
                }
                // Compare internal UTC date with local today, not UTC today
                if (this.todayHighlight &&
                    prevMonth.getUTCFullYear() == today.getFullYear() &&
                    prevMonth.getUTCMonth() == today.getMonth() &&
                    prevMonth.getUTCDate() == today.getDate()) {
                    clsName += ' today';
                }
                if (currentDate && prevMonth.valueOf() == currentDate) {
                    clsName += ' active';
                }
                if (prevMonth.valueOf() < this.startDate || prevMonth.valueOf() > this.endDate ||
                    $.inArray(prevMonth.getUTCDay(), this.daysOfWeekDisabled) !== -1 ||
                    $.inArray(prevMonth.valueOf(), this.datesDisabled) !== -1) {
                    clsName += ' disabled';
                }
                html.push('<td class="day' + clsName + '">' + prevMonth.getUTCDate() + '</td>');
                if (prevMonth.getUTCDay() == this.weekEnd) {
                    html.push('</tr>');
                }
                prevMonth.setUTCDate(prevMonth.getUTCDate() + 1);
            }
            this.picker.find('.datepicker-days tbody').empty().append(html.join(''));

            html = [];
            for (var i = 0; i < 24; i++) {
                var actual = UTCDate(year, month, dayMonth, i);
                clsName = '';
                // We want the previous hour for the startDate
                if ((actual.valueOf() + 3600000) < this.startDate || actual.valueOf() > this.endDate) {
                    clsName += ' disabled';
                } else if (hours == i) {
                    clsName += ' active';
                }
                html.push('<span class="hour' + clsName + '">' + i + ':00</span>');
            }
            this.picker.find('.datepicker-hours td').html(html.join(''));

            html = [];
            for (var i = 0; i < 60; i += this.minuteStep) {
                var actual = UTCDate(year, month, dayMonth, hours, i);
                clsName = '';
                if (actual.valueOf() < this.startDate || actual.valueOf() > this.endDate) {
                    clsName += ' disabled';
                } else if (Math.floor(minutes / this.minuteStep) == Math.floor(i / this.minuteStep)) {
                    clsName += ' active';
                }
                html.push('<span class="minute' + clsName + '">' + hours + ':' + (i < 10 ? '0' + i : i) + '</span>');
            }
            this.picker.find('.datepicker-minutes td').html(html.join(''));


            var currentYear = this.date && this.date.getUTCFullYear();
            var months = this.picker.find('.datepicker-months')
                .find('th:eq(1)')
                .text(year)
                .end()
                .find('span').removeClass('active');
            if (currentYear && currentYear == year) {
                months.eq(this.date.getUTCMonth()).addClass('active');
            }
            if (year < startYear || year > endYear) {
                months.addClass('disabled');
            }
            if (year == startYear) {
                months.slice(0, startMonth).addClass('disabled');
            }
            if (year == endYear) {
                months.slice(endMonth + 1).addClass('disabled');
            }

            html = '';
            year = parseInt(year / 10, 10) * 10;
            var yearCont = this.picker.find('.datepicker-years')
                .find('th:eq(1)')
                .text(year + '-' + (year + 9))
                .end()
                .find('td');
            year -= 1;
            for (var i = -1; i < 11; i++) {
                html += '<span class="year' + (i == -1 || i == 10 ? ' old' : '') + (currentYear == year ? ' active' : '') + (year < startYear || year > endYear ? ' disabled' : '') + '">' + year + '</span>';
                year += 1;
            }
            yearCont.html(html);
        },

        updateNavArrows: function() {
            var d = new Date(this.viewDate),
                year = d.getUTCFullYear(),
                month = d.getUTCMonth(),
                day = d.getUTCDate(),
                hour = d.getUTCHours();
            switch (this.viewMode) {
                case 0:
                    if (this.startDate !== -Infinity && year <= this.startDate.getUTCFullYear() && month <= this.startDate.getUTCMonth() && day <= this.startDate.getUTCDate() && hour <= this.startDate.getUTCHours()) {
                        this.picker.find('.prev').css({
                            visibility: 'hidden'
                        });
                    } else {
                        this.picker.find('.prev').css({
                            visibility: 'visible'
                        });
                    }
                    if (this.endDate !== Infinity && year >= this.endDate.getUTCFullYear() && month >= this.endDate.getUTCMonth() && day >= this.endDate.getUTCDate() && hour >= this.endDate.getUTCHours()) {
                        this.picker.find('.next').css({
                            visibility: 'hidden'
                        });
                    } else {
                        this.picker.find('.next').css({
                            visibility: 'visible'
                        });
                    }
                    break;
                case 1:
                    if (this.startDate !== -Infinity && year <= this.startDate.getUTCFullYear() && month <= this.startDate.getUTCMonth() && day <= this.startDate.getUTCDate()) {
                        this.picker.find('.prev').css({
                            visibility: 'hidden'
                        });
                    } else {
                        this.picker.find('.prev').css({
                            visibility: 'visible'
                        });
                    }
                    if (this.endDate !== Infinity && year >= this.endDate.getUTCFullYear() && month >= this.endDate.getUTCMonth() && day >= this.endDate.getUTCDate()) {
                        this.picker.find('.next').css({
                            visibility: 'hidden'
                        });
                    } else {
                        this.picker.find('.next').css({
                            visibility: 'visible'
                        });
                    }
                    break;
                case 2:
                    if (this.startDate !== -Infinity && year <= this.startDate.getUTCFullYear() && month <= this.startDate.getUTCMonth()) {
                        this.picker.find('.prev').css({
                            visibility: 'hidden'
                        });
                    } else {
                        this.picker.find('.prev').css({
                            visibility: 'visible'
                        });
                    }
                    if (this.endDate !== Infinity && year >= this.endDate.getUTCFullYear() && month >= this.endDate.getUTCMonth()) {
                        this.picker.find('.next').css({
                            visibility: 'hidden'
                        });
                    } else {
                        this.picker.find('.next').css({
                            visibility: 'visible'
                        });
                    }
                    break;
                case 3:
                case 4:
                    if (this.startDate !== -Infinity && year <= this.startDate.getUTCFullYear()) {
                        this.picker.find('.prev').css({
                            visibility: 'hidden'
                        });
                    } else {
                        this.picker.find('.prev').css({
                            visibility: 'visible'
                        });
                    }
                    if (this.endDate !== Infinity && year >= this.endDate.getUTCFullYear()) {
                        this.picker.find('.next').css({
                            visibility: 'hidden'
                        });
                    } else {
                        this.picker.find('.next').css({
                            visibility: 'visible'
                        });
                    }
                    break;
            }
        },

        click: function(e) {
            e.stopPropagation();
            e.preventDefault();

            if ($(e.target).hasClass('datepicker-close') || $(e.target).parent().hasClass('datepicker-close')) {
                this.hide();
            }

            var target = $(e.target).closest('span, td, th');
            if (target.length == 1) {
                if (target.is('.disabled')) {
                    this.element.trigger({
                        type: 'outOfRange',
                        date: this.viewDate,
                        startDate: this.startDate,
                        endDate: this.endDate
                    });
                    return;
                }

                switch (target[0].nodeName.toLowerCase()) {
                    case 'th':
                        switch (target[0].className) {
                            case 'date-switch':
                                this.showMode(1);
                                break;
                            case 'prev':
                            case 'next':
                                var dir = DPGlobal.modes[this.viewMode].navStep * (target[0].className == 'prev' ? -1 : 1);
                                switch (this.viewMode) {
                                    case 0:
                                        this.viewDate = this.moveHour(this.viewDate, dir);
                                        break;
                                    case 1:
                                        this.viewDate = this.moveDate(this.viewDate, dir);
                                        break;
                                    case 2:
                                        this.viewDate = this.moveMonth(this.viewDate, dir);
                                        break;
                                    case 3:
                                    case 4:
                                        this.viewDate = this.moveYear(this.viewDate, dir);
                                        break;
                                }
                                this.fill();
                                break;
                            case 'today':
                                var date = new Date();
                                date = UTCDate(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());

                                this.viewMode = this.startViewMode;
                                this.showMode(0);
                                this._setDate(date);
                                break;
                        }
                        break;
                    case 'span':
                        if (!target.is('.disabled')) {
                            if (target.is('.month')) {
                              if (this.minView === 3) {
                                var month = target.parent().find('span').index(target) || 0;
                                var year = this.viewDate.getUTCFullYear(),
                                    day = 1,
                                    hours = this.viewDate.getUTCHours(),
                                    minutes = this.viewDate.getUTCMinutes(),
                                    seconds = this.viewDate.getUTCSeconds();
                                this._setDate(UTCDate(year, month, day, hours, minutes, seconds, 0));
                              } else {
                                this.viewDate.setUTCDate(1);
                                var month = target.parent().find('span').index(target);
                                this.viewDate.setUTCMonth(month);
                                this.element.trigger({
                                    type: 'changeMonth',
                                    date: this.viewDate
                                });
                              }
                            } else if (target.is('.year')) {
                              if (this.minView === 4) {
                                var year = parseInt(target.text(), 10) || 0;
                                var month = 0,
                                    day = 1,
                                    hours = this.viewDate.getUTCHours(),
                                    minutes = this.viewDate.getUTCMinutes(),
                                    seconds = this.viewDate.getUTCSeconds();
                                this._setDate(UTCDate(year, month, day, hours, minutes, seconds, 0));
                              } else {
                                this.viewDate.setUTCDate(1);
                                var year = parseInt(target.text(), 10) || 0;
                                this.viewDate.setUTCFullYear(year);
                                this.element.trigger({
                                    type: 'changeYear',
                                    date: this.viewDate
                                });
                              }
                            } else if (target.is('.hour')) {
                                var hours = parseInt(target.text(), 10) || 0;
                                var year = this.viewDate.getUTCFullYear(),
                                    month = this.viewDate.getUTCMonth(),
                                    day = this.viewDate.getUTCDate(),
                                    minutes = this.viewDate.getUTCMinutes(),
                                    seconds = this.viewDate.getUTCSeconds();
                                this._setDate(UTCDate(year, month, day, hours, minutes, seconds, 0));
                            } else if (target.is('.minute')) {
                                var minutes = parseInt(target.text().substr(target.text().indexOf(':') + 1), 10) || 0;
                                var year = this.viewDate.getUTCFullYear(),
                                    month = this.viewDate.getUTCMonth(),
                                    day = this.viewDate.getUTCDate(),
                                    hours = this.viewDate.getUTCHours(),
                                    seconds = this.viewDate.getUTCSeconds();
                                this._setDate(UTCDate(year, month, day, hours, minutes, seconds, 0));
                            }



                            if (this.viewMode != 0) {



                                var oldViewMode = this.viewMode;
                                this.showMode(-1);
                                this.fill();
                                if (oldViewMode == this.viewMode && this.autoclose) {
                                    this.hide();
                                }
                            } else {
                                this.fill();
                                if (this.autoclose) {
                                    this.hide();
                                }
                            }
                        }
                        break;
                    case 'td':



                        if (target.is('.day') && !target.is('.disabled')) {
                            var day = parseInt(target.text(), 10) || 1;
                            var year = this.viewDate.getUTCFullYear(),
                                month = this.viewDate.getUTCMonth(),
                                hours = this.viewDate.getUTCHours(),
                                minutes = this.viewDate.getUTCMinutes(),
                                seconds = this.viewDate.getUTCSeconds();
                            if (target.is('.old')) {
                                if (month === 0) {
                                    month = 11;
                                    year -= 1;
                                } else {
                                    month -= 1;
                                }
                            } else if (target.is('.new')) {
                                if (month == 11) {
                                    month = 0;
                                    year += 1;
                                } else {
                                    month += 1;
                                }
                            }
                            this._setDate(UTCDate(year, month, day, hours, minutes, seconds, 0));
                        }



                        var oldViewMode = this.viewMode;


                        this.showMode(-1);


                        this.fill();
                        if (oldViewMode == this.viewMode && this.autoclose) {
                            this.hide();
                        }
                        break;
                }
            }
        },

        _setDate: function(date, which) {

            if (!which || which == 'date')
                this.date = date;
            if (!which || which == 'view')
                this.viewDate = date;
            this.fill();
            this.setValue();
            this.element.trigger({
                type: 'changeDate',
                date: this.date
            });
            var element;
            if (this.isInput) {
                element = this.element;
            } else if (this.component) {
                element = this.element.find('input');
            }
            if (element) {
                element.change();
                if (this.autoclose && (!which || which == 'date')) {
                    // this.hide();
                }
            }
        },

        moveHour: function(date, dir) {
            if (!dir) return date;
            var new_date = new Date(date.valueOf());
            dir = dir > 0 ? 1 : -1;
            new_date.setUTCHours(new_date.getUTCHours() + dir);
            return new_date;
        },

        moveDate: function(date, dir) {
            if (!dir) return date;
            var new_date = new Date(date.valueOf());
            dir = dir > 0 ? 1 : -1;
            new_date.setUTCDate(new_date.getUTCDate() + dir);
            return new_date;
        },

        moveMonth: function(date, dir) {
            if (!dir) return date;
            var new_date = new Date(date.valueOf()),
                day = new_date.getUTCDate(),
                month = new_date.getUTCMonth(),
                mag = Math.abs(dir),
                new_month, test;
            dir = dir > 0 ? 1 : -1;
            if (mag == 1) {
                test = dir == -1
                    // If going back one month, make sure month is not current month
                    // (eg, Mar 31 -> Feb 31 == Feb 28, not Mar 02)
                    ? function() {
                        return new_date.getUTCMonth() == month;
                    }
                    // If going forward one month, make sure month is as expected
                    // (eg, Jan 31 -> Feb 31 == Feb 28, not Mar 02)
                    : function() {
                        return new_date.getUTCMonth() != new_month;
                    };
                new_month = month + dir;
                new_date.setUTCMonth(new_month);
                // Dec -> Jan (12) or Jan -> Dec (-1) -- limit expected date to 0-11
                if (new_month < 0 || new_month > 11)
                    new_month = (new_month + 12) % 12;
            } else {
                // For magnitudes >1, move one month at a time...
                for (var i = 0; i < mag; i++)
                // ...which might decrease the day (eg, Jan 31 to Feb 28, etc)...
                    new_date = this.moveMonth(new_date, dir);
                // ...then reset the day, keeping it in the new month
                new_month = new_date.getUTCMonth();
                new_date.setUTCDate(day);
                test = function() {
                    return new_month != new_date.getUTCMonth();
                };
            }
            // Common date-resetting loop -- if date is beyond end of month, make it
            // end of month
            while (test()) {
                new_date.setUTCDate(--day);
                new_date.setUTCMonth(new_month);
            }
            return new_date;
        },

        moveYear: function(date, dir) {
            return this.moveMonth(date, dir * 12);
        },

        dateWithinRange: function(date) {
            return date >= this.startDate && date <= this.endDate;
        },

        keydown: function(e) {
            if (!this.keyboardNavigation) {
                return true;
            }
            if (this.picker.is(':not(:visible)')) {
                if (e.keyCode == 27) // allow escape to hide and re-show picker
                    this.show();
                return;
            }
            var dateChanged = false,
                dir, day, month,
                newDate, newViewDate;
            switch (e.keyCode) {
                case 27: // escape
                    this.hide();
                    e.preventDefault();
                    break;
                case 37: // left
                case 39: // right
                    if (!this.keyboardNavigation) break;
                    dir = e.keyCode == 37 ? -1 : 1;
                    if (e.ctrlKey) {
                        newDate = this.moveYear(this.date, dir);
                        newViewDate = this.moveYear(this.viewDate, dir);
                    } else if (e.shiftKey) {
                        newDate = this.moveMonth(this.date, dir);
                        newViewDate = this.moveMonth(this.viewDate, dir);
                    } else {
                        newDate = new Date(this.date.valueOf());
                        newDate.setUTCDate(this.date.getUTCDate() + dir);
                        newViewDate = new Date(this.viewDate.valueOf());
                        newViewDate.setUTCDate(this.viewDate.getUTCDate() + dir);
                    }
                    if (this.dateWithinRange(newDate)) {
                        this.date = newDate;
                        this.viewDate = newViewDate;
                        this.setValue();
                        this.update();
                        e.preventDefault();
                        dateChanged = true;
                    }
                    break;
                case 38: // up
                case 40: // down
                    if (!this.keyboardNavigation) break;
                    dir = e.keyCode == 38 ? -1 : 1;
                    if (e.ctrlKey) {
                        newDate = this.moveYear(this.date, dir);
                        newViewDate = this.moveYear(this.viewDate, dir);
                    } else if (e.shiftKey) {
                        newDate = this.moveMonth(this.date, dir);
                        newViewDate = this.moveMonth(this.viewDate, dir);
                    } else {
                        newDate = new Date(this.date.valueOf());
                        newDate.setUTCDate(this.date.getUTCDate() + dir * 7);
                        newViewDate = new Date(this.viewDate.valueOf());
                        newViewDate.setUTCDate(this.viewDate.getUTCDate() + dir * 7);
                    }
                    if (this.dateWithinRange(newDate)) {
                        this.date = newDate;
                        this.viewDate = newViewDate;
                        this.setValue();
                        this.update();
                        e.preventDefault();
                        dateChanged = true;
                    }
                    break;
                case 13: // enter
                    this.hide();
                    e.preventDefault();
                    break;
                case 9: // tab
                    this.hide();
                    break;
            }
            if (dateChanged) {
                this.element.trigger({
                    type: 'changeDate',
                    date: this.date
                });
                var element;
                if (this.isInput) {
                    element = this.element;
                } else if (this.component) {
                    element = this.element.find('input');
                }
                if (element) {
                    element.change();
                }
            }
        },

        showMode: function(dir) {

            if (dir) {
                var newViewMode = Math.max(0, Math.min(DPGlobal.modes.length - 1, this.viewMode + dir));
                if (newViewMode >= this.minView && newViewMode <= this.maxView) {
                    this.viewMode = newViewMode;
                }
            }
            /*
            	vitalets: fixing bug of very special conditions:
            	jquery 1.7.1 + webkit + show inline datepicker in bootstrap popover.
            	Method show() does not set display css correctly and datepicker is not shown.
            	Changed to .css('display', 'block') solve the problem.
            	See https://github.com/vitalets/x-editable/issues/37

            	In jquery 1.7.2+ everything works fine.
            */
            //this.picker.find('>div').hide().filter('.datepicker-'+DPGlobal.modes[this.viewMode].clsName).show();
            this.picker.find('>div').hide().filter('.datepicker-' + DPGlobal.modes[this.viewMode].clsName).css('display', 'block');
            this.updateNavArrows();
        },
		
		changeViewDate: function(date) {
			this.date = date;
			this.viewDate = date;
			this.fill();
		},
		
        reset: function(e) {
            this._setDate(null, 'date');
        }
    };

    $.fn.fdatepicker = function(option) {
        var args = Array.apply(null, arguments);
        args.shift();
        return this.each(function() {
            var $this = $(this),
                data = $this.data('datepicker'),
                options = typeof option == 'object' && option;
            if (!data) {
                $this.data('datepicker', (data = new Datepicker(this, $.extend({}, $.fn.fdatepicker.defaults, options))));
            }
            if (typeof option == 'string' && typeof data[option] == 'function') {
                data[option].apply(data, args);
            }
        });
    };

    $.fn.fdatepicker.defaults = {
        onRender: function(date) {
            return '';
        }
    };
    $.fn.fdatepicker.Constructor = Datepicker;
    var dates = $.fn.fdatepicker.dates = {
        'en': {
            days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
            daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
            daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
            months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            today: "Today",
            titleFormat: "MM yyyy"
        }
    };

    var DPGlobal = {
        modes: [{
            clsName: 'minutes',
            navFnc: 'Hours',
            navStep: 1
        }, {
            clsName: 'hours',
            navFnc: 'Date',
            navStep: 1
        }, {
            clsName: 'days',
            navFnc: 'Month',
            navStep: 1
        }, {
            clsName: 'months',
            navFnc: 'FullYear',
            navStep: 1
        }, {
            clsName: 'years',
            navFnc: 'FullYear',
            navStep: 10
        }],
        isLeapYear: function(year) {
            return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0));
        },
        getDaysInMonth: function(year, month) {
            return [31, (DPGlobal.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
        },
        validParts: /hh?|ii?|ss?|dd?|mm?|MM?|yy(?:yy)?/g,
        nonpunctuation: /[^ -\/:-@\[\u3400-\u9fff-`{-~\t\n\r]+/g,
        parseFormat: function(format) {
            // IE treats \0 as a string end in inputs (truncating the value),
            // so it's a bad format delimiter, anyway
            var separators = format.replace(this.validParts, '\0').split('\0'),
                parts = format.match(this.validParts);
            if (!separators || !separators.length || !parts || parts.length === 0) {
                throw new Error("Invalid date format.");
            }
            this.formatText = format;
            return {
                separators: separators,
                parts: parts
            };
        },
        parseDate: function(date, format, language) {
            if (date instanceof Date) return new Date(date.valueOf() - date.getTimezoneOffset() * 60000);
            if (/^\d{4}\-\d{1,2}\-\d{1,2}$/.test(date)) {
                format = this.parseFormat('yyyy-mm-dd');
            }
            if (/^\d{4}\-\d{1,2}\-\d{1,2}[T ]\d{1,2}\:\d{1,2}$/.test(date)) {
                format = this.parseFormat('yyyy-mm-dd hh:ii');
            }
            if (/^\d{4}\-\d{1,2}\-\d{1,2}[T ]\d{1,2}\:\d{1,2}\:\d{1,2}[Z]{0,1}$/.test(date)) {
                format = this.parseFormat('yyyy-mm-dd hh:ii:ss');
            }
            if (/^[-+]\d+[dmwy]([\s,]+[-+]\d+[dmwy])*$/.test(date)) {
                var part_re = /([-+]\d+)([dmwy])/,
                    parts = date.match(/([-+]\d+)([dmwy])/g),
                    part, dir;
                date = new Date();
                for (var i = 0; i < parts.length; i++) {
                    part = part_re.exec(parts[i]);
                    dir = parseInt(part[1]);
                    switch (part[2]) {
                        case 'd':
                            date.setUTCDate(date.getUTCDate() + dir);
                            break;
                        case 'm':
                            date = Datetimepicker.prototype.moveMonth.call(Datetimepicker.prototype, date, dir);
                            break;
                        case 'w':
                            date.setUTCDate(date.getUTCDate() + dir * 7);
                            break;
                        case 'y':
                            date = Datetimepicker.prototype.moveYear.call(Datetimepicker.prototype, date, dir);
                            break;
                    }
                }
                return UTCDate(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
            }
            var parts = date && date.match(this.nonpunctuation) || [],
                date = new Date(),
                parsed = {},
                setters_order = ['hh', 'h', 'ii', 'i', 'ss', 's', 'yyyy', 'yy', 'M', 'MM', 'm', 'mm', 'd', 'dd'],
                setters_map = {
                    hh: function(d, v) {
                        return d.setUTCHours(v);
                    },
                    h: function(d, v) {
                        return d.setUTCHours(v);
                    },
                    ii: function(d, v) {
                        return d.setUTCMinutes(v);
                    },
                    i: function(d, v) {
                        return d.setUTCMinutes(v);
                    },
                    ss: function(d, v) {
                        return d.setUTCSeconds(v);
                    },
                    s: function(d, v) {
                        return d.setUTCSeconds(v);
                    },
                    yyyy: function(d, v) {
                        return d.setUTCFullYear(v);
                    },
                    yy: function(d, v) {
                        return d.setUTCFullYear(2000 + v);
                    },
                    m: function(d, v) {
                        v -= 1;
                        while (v < 0) v += 12;
                        v %= 12;
                        d.setUTCMonth(v);
                        while (d.getUTCMonth() != v)
                            d.setUTCDate(d.getUTCDate() - 1);
                        return d;
                    },
                    d: function(d, v) {
                        return d.setUTCDate(v);
                    }
                },
                val, filtered, part;
            setters_map['M'] = setters_map['MM'] = setters_map['mm'] = setters_map['m'];
            setters_map['dd'] = setters_map['d'];
            date = UTCDate(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0); //date.getHours(), date.getMinutes(), date.getSeconds());
            if (parts.length == format.parts.length) {
                for (var i = 0, cnt = format.parts.length; i < cnt; i++) {
                    val = parseInt(parts[i], 10);
                    part = format.parts[i];
                    if (isNaN(val)) {
                        switch (part) {
                            case 'MM':
                                filtered = $(dates[language].months).filter(function() {
                                    var m = this.slice(0, parts[i].length),
                                        p = parts[i].slice(0, m.length);
                                    return m == p;
                                });
                                val = $.inArray(filtered[0], dates[language].months) + 1;
                                break;
                            case 'M':
                                filtered = $(dates[language].monthsShort).filter(function() {
                                    var m = this.slice(0, parts[i].length),
                                        p = parts[i].slice(0, m.length);
                                    return m == p;
                                });
                                val = $.inArray(filtered[0], dates[language].monthsShort) + 1;
                                break;
                        }
                    }
                    parsed[part] = val;
                }
                for (var i = 0, s; i < setters_order.length; i++) {
                    s = setters_order[i];
                    if (s in parsed && !isNaN(parsed[s]))
                        setters_map[s](date, parsed[s])
                }
            }
            return date;
        },
        formatDate: function(date, format, language) {
            if (date == null) {
                return '';
            }
            var val = {
                h: date.getUTCHours(),
                i: date.getUTCMinutes(),
                s: date.getUTCSeconds(),
                d: date.getUTCDate(),
                m: date.getUTCMonth() + 1,
                M: dates[language].monthsShort[date.getUTCMonth()],
                MM: dates[language].months[date.getUTCMonth()],
                yy: date.getUTCFullYear().toString().substring(2),
                yyyy: date.getUTCFullYear()
            };
            val.hh = (val.h < 10 ? '0' : '') + val.h;
            val.ii = (val.i < 10 ? '0' : '') + val.i;
            val.ss = (val.s < 10 ? '0' : '') + val.s;
            val.dd = (val.d < 10 ? '0' : '') + val.d;
            val.mm = (val.m < 10 ? '0' : '') + val.m;
            var date = [],
                seps = $.extend([], format.separators);
            for (var i = 0, cnt = format.parts.length; i < cnt; i++) {
                if (seps.length)
                    date.push(seps.shift())
                date.push(val[format.parts[i]]);
            }
            return date.join('');
        },
        convertViewMode: function(viewMode) {
            switch (viewMode) {
                case 4:
                case 'decade':
                    viewMode = 4;
                    break;
                case 3:
                case 'year':
                    viewMode = 3;
                    break;
                case 2:
                case 'month':
                    viewMode = 2;
                    break;
                case 1:
                case 'day':
                    viewMode = 1;
                    break;
                case 0:
                case 'hour':
                    viewMode = 0;
                    break;
            }

            return viewMode;
        },
        headTemplate: function(leftArrow, rightArrow) {return('<thead>' +
            '<tr>' +
            '<th class="prev">' + leftArrow + '</th>' +
            '<th colspan="5" class="date-switch"></th>' +
            '<th class="next">' + rightArrow + '</th>' +
            '</tr>' +
            '</thead>')},
        contTemplate: '<tbody><tr><td colspan="7"></td></tr></tbody>',
        footTemplate: '<tfoot><tr><th colspan="7" class="today"></th></tr></tfoot>'
    };
    DPGlobal.template = function(leftArrow, rightArrow, closeIcon) {return( '<div class="datepicker">' +
        '<div class="datepicker-minutes">' +
        '<table class=" table-condensed">' +
        DPGlobal.headTemplate(leftArrow, rightArrow) +
        DPGlobal.contTemplate +
        DPGlobal.footTemplate +
        '</table>' +
        '</div>' +
        '<div class="datepicker-hours">' +
        '<table class=" table-condensed">' +
        DPGlobal.headTemplate(leftArrow, rightArrow) +
        DPGlobal.contTemplate +
        DPGlobal.footTemplate +
        '</table>' +
        '</div>' +
        '<div class="datepicker-days">' +
        '<table class=" table-condensed">' +
        DPGlobal.headTemplate(leftArrow, rightArrow) +
        '<tbody></tbody>' +
        DPGlobal.footTemplate +
        '</table>' +
        '</div>' +
        '<div class="datepicker-months">' +
        '<table class="table-condensed">' +
        DPGlobal.headTemplate(leftArrow, rightArrow) +
        DPGlobal.contTemplate +
        DPGlobal.footTemplate +
        '</table>' +
        '</div>' +
        '<div class="datepicker-years">' +
        '<table class="table-condensed">' +
        DPGlobal.headTemplate(leftArrow, rightArrow) +
        DPGlobal.contTemplate +
        DPGlobal.footTemplate +
        '</table>' +
        '</div>' +
        '<a class="button datepicker-close tiny alert right" style="width:auto;">' + closeIcon + '</a>' +
        '</div>')};

    $.fn.fdatepicker.DPGlobal = DPGlobal;

}(window.jQuery);


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
/**
 * @param  {HTMLElement} element Element with text to meassure
 * @return {void}
 */
function getTextLength(element) {
  return element.innerText.trim().length;
}

/**
 * @param  {HTMLElement} element Element to truncate
 * @param  {Number} threshold where to cut the text
 * @param  {String} method the method to determine where to cut of the text
 * @return {void}
 */
function truncate(element, threshold) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'precise';

  var container = element;
  var text = element.innerHTML;

  if (method === 'precise') {
    var visibleString = text.substring(0, threshold) + '&hellip;';
    var hiddenString = '<span class="hide is-truncated">' + text.substring(threshold, element.length) + '</span>';

    container.innerHTML = visibleString + hiddenString;
  }

  if (container.id === undefined) {
    window.console.warn('Please provide an ID on the container to toggle truncated text.');
  }
}

/**
 * @param  {Number} iterator the childs index
 * @param  {Array} children the array from which to hide specific elements
 * @return {void}
 */
function hideFollowingChildren(iterator, children) {
  for (var index = iterator + 1; index < children.length; index += 1) {
    children[index].classList.add('hide');
  }
}

/**
 * @param  {HTMLElement} container the container in which to truncate the text
 * @return {void}
 */
function checkTruncation(container) {
  var children = [].slice.call(container.children);
  var characterThreshold = container.dataset.truncateText;
  var toggler = document.querySelector('[data-truncate-toggle="' + container.id + '"]');

  // has children?
  if (children.length > 0) {
    var childIterator = 0;
    var totalCharacterCount = 0;

    while (totalCharacterCount < characterThreshold) {
      var child = children[childIterator];
      var characterCount = getTextLength(child);

      // add current count to running counter
      totalCharacterCount += characterCount;

      // check if the current child adds more characters than the threshold allows
      if (totalCharacterCount + characterCount >= characterThreshold) {
        truncate(child, characterCount - (totalCharacterCount - characterThreshold));
        hideFollowingChildren(childIterator, children);

        return false;
      }

      if (childIterator === children.length - 1) {
        // remove toggle
        if (toggler) toggler.parentNode.removeChild(toggler);

        return false;
      }

      // bump up the interator
      childIterator += 1;
    }
  } else {
    var _characterCount = getTextLength(container);
    if (_characterCount > characterThreshold) {
      truncate(container, characterThreshold);
    } else if (toggler) {
      // remove toggle
      toggler.parentNode.removeChild(toggler);
    }
  }

  return true;
}

/**
 * @param  {HTMLElement} container the container in which to revert the checkTruncation
 * @return {void}
 */
function revertcheckTruncation(container) {
  var hiddenElements = [].slice.call(container.querySelectorAll('.hide'));
  var truncatedString = container.querySelector('.is-truncated');

  // show all hidden elements
  hiddenElements.forEach(function (element) {
    element.classList.remove('hide');
  });

  // remove hellip
  truncatedString.parentNode.innerText = truncatedString.parentNode.innerText.replace('…', '');
}

/**
 * init
 *
 * @param  {HTMLElement} scope = document
 * @return {void}
 */
function init() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  var containers = [].slice.call(scope.querySelectorAll('[data-truncate-text]'));
  var togglers = [].slice.call(scope.querySelectorAll('[data-truncate-toggle]'));

  // check for checkTruncation
  containers.forEach(function (container) {
    checkTruncation(container);
  });

  // toggler
  togglers.forEach(function (toggler) {
    toggler.addEventListener('click', function () {
      var id = toggler.dataset.truncateToggle;
      var container = document.getElementById(id);

      if (toggler.getAttribute('aria-pressed') === 'true') {
        revertcheckTruncation(container);
      } else {
        checkTruncation(container);
      }
    });
  });
}

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchTeaserHeights = matchTeaserHeights;
exports.matchSliderHeights = matchSliderHeights;

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @return {void}
 */
function matchTeaserHeights() {
  var $elTeaserGroups = (0, _jquery2.default)('[data-mh-group="teaser"]');
  $elTeaserGroups.each(function (index, element) {
    var $el = (0, _jquery2.default)(element);

    $el.find('.teaser__picture').matchHeight();
    $el.find('.teaser__tags').matchHeight();
    $el.find('.teaser__header').matchHeight();
    $el.find('.teaser__excerpt').matchHeight();
    $el.find('.teaser__content-wrapper').matchHeight();
    $el.find('.teaser').matchHeight();
  });
}

/**
 * @return {void}
 */
function matchSliderHeights() {
  var sliderEntries = (0, _jquery2.default)('.slider');

  setTimeout(function () {
    var flickitySlider = (0, _jquery2.default)('.flickity-slider');

    flickitySlider.each(function (index, element) {
      var $el = (0, _jquery2.default)(element);

      $el.find('.teaser__picture').matchHeight();
      $el.find('.teaser__tags').matchHeight();
      $el.find('.teaser__header').matchHeight();
      $el.find('.teaser__excerpt').matchHeight();
      $el.find('.teaser__content-wrapper').matchHeight();
      $el.find('.teaser').matchHeight();
    });
  }, 2000);

  /**
   * @param  {JQuery} slider Slider
   * @return {void}
   */
  function setArrowPostion(slider) {
    var sliderTeaser = (0, _jquery2.default)(slider).find('.teaser__picture');
    var sliderArrow = (0, _jquery2.default)(slider).find('.flickity-prev-next-button');
    var sliderTeaserHeight = sliderTeaser.height();
    var positionTop = sliderTeaserHeight / 2;

    sliderArrow.css('top', positionTop);
  }

  /**
   * @return {void}
   */
  function setArrowPostionForAllSliders() {
    sliderEntries.each(function (i, slider) {
      setArrowPostion(slider);
    });
  }

  setArrowPostionForAllSliders();
  _jquery2.default.fn.matchHeight._afterUpdate = function () {
    // eslint-disable-line no-underscore-dangle
    setArrowPostionForAllSliders();
  };
}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.bundle.js